// BDD
import { badgeDisplayName } from "./utils/badgeLabel";
import React, { useState, useEffect, useRef, useMemo, Fragment, useCallback } from "react";
import { isTestNavLocked } from "./utils/testNavLock";
import { attachSmokeVisibilityPause, stopSmokeMedia } from "./utils/smokeVisibility";
import { View, Text, TextInput, ScrollView, Image, Platform, StyleSheet, useColorScheme, TouchableOpacity, Modal, FlatList, Switch, ActivityIndicator, useWindowDimensions } from "react-native";
import { Button, IconButton, Card } from "react-native-paper";
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { Animated, Easing, LayoutAnimation } from "react-native"; // BDD 10/13/2025

import axios from "axios";
import Hls from "hls.js";  // Γ£à Import HLS.js
import { ReactSketchCanvas } from "react-sketch-canvas"; // For Web & Windows
import WakeWordListener from "./WakeWordListener";  // Γ£à Import Wake Word Listener
// import ReactMarkdown from "react-markdown";  // Γ£à Import React Markdown Renderer
// import remarkGfm from "remark-gfm"; // Γ£à Enables GitHub Flavored Markdown (tables, lists, bold)
import "./MarkdownStyles.css";
import "./global-font-scale.css";
import "./responsive-layout.css";
import "./styles/theme.css";
import "./styles/home-animations.css";
import { useTheme } from "./contexts/ThemeContext";
import StudentHomeScreen from "./screens/StudentHomeScreen";
import TeacherHomeScreen from "./screens/TeacherHomeScreen";
import MessageStudentModal from "./components/home/teacher/MessageStudentModal";
import StudentAnalyticsPage from "./screens/StudentAnalyticsPage";
import StudentEngagementPage from "./screens/StudentEngagementPage";
import StudentTestsPage from "./screens/StudentTestsPage";
import StudentTestTakingPage from "./screens/StudentTestTakingPage";
import APExamPrepScreen from "./screens/APExamPrepScreen";
import JourneyPanel from "./components/JourneyPanel";
import JourneyTableOfContents from "./components/JourneyTableOfContents";
import JourneyAssetCompanion from "./components/JourneyAssetCompanion";
import JourneySwanMediaShell from "./components/journeys/present/JourneySwanMediaShell";
import { isThreeJsPwo, isKnownThreeJsPwoScene, buildThreeJsPwoUrl, DOODLE_ROBOT_PWO_ID, FOOD_DELIVERY_ROBOT_PWO_ID } from "./components/journeys/threeJsPwoProvider";
import { buildWonderLabsMediaTeachingInstructions, getWonderLabsScienceGuardrail, isMediaHint } from "./components/journeys/wonderLabsMediaTeaching";
import { placeWonderLabsCaptionCues } from "./components/journeys/wonderLabsCaptionCues";
import JourneyPresentMode from "./components/journeys/present/JourneyPresentMode";
import WonderLabsMissionHome, { WONDERLABS_MISSIONS, getWonderLabsJourneyId } from "./components/journeys/present/WonderLabsMissionHome";
import WonderLabsMissionWelcome from "./components/journeys/present/WonderLabsMissionWelcome";
import { isWonderLabsLearningBeatsEnabled } from "./components/journeys/wonderLabsLearningBeats";
import { WONDERLABS_FLOW } from "./components/journeys/wonderLabsWholeJourneys";
import { copyActivityCursors, hasAdvancedPastCheckpoint, planStepMove } from
  "./components/journeys/wonderLabsReviewNavigation";
import { getWonderLabsEntryRoute } from "./components/journeys/present/wonderLabsEntryRoute";

// Feature flag: the AP Exam Prep tab is hidden until real content is ready.
// Flip to true to re-enable the nav tab and its screen.
const SHOW_AP_EXAM_PREP = false;
import { OnboardingScreen } from "./screens/onboarding";
import { OnboardingProvider, useOnboarding } from "./contexts/OnboardingContext";
import { WalkthroughProvider, useWalkthrough } from "./contexts/WalkthroughContext";
import { CopilotProvider } from "react-native-copilot";
import { StudentNavButtons, TeacherNavButtons, TeacherHamburgerMenuItems } from "./components/HeaderNavigation";
import HeaderIconButton from "./components/header/HeaderIconButton";
import HeaderProfileMenu from "./components/header/HeaderProfileMenu";
import HeaderHelpMenu from "./components/header/HeaderHelpMenu";
import { buildProgramItems, shouldShowProgramsMenu } from "./components/header/programsMenu";
import useJourneyMap from "./components/home/hooks/useJourneyMap";
import LearningSubTabs from "./components/header/LearningSubTabs";
import { HEADER } from "./components/header/headerTheme";
import WalkthroughController from "./components/WalkthroughController";
import WalkthroughTooltip from "./components/WalkthroughTooltip";
// Walkthrough steps - currently only home screen steps are used
import { rem } from "./utils/fontScaling";
import { formatPwoName } from "./utils/formatSupSub"; // AIT-183 - <sup>/<sub> in PWO names
import { streamNdjson } from "./utils/streamingFetch"; // ZA 04/09/2026 - streaming AI responses
import { makeContinueChatHandler } from "./utils/continueChat";
import withHomeModule from "./utils/withHomeModule";
import {
  captureAutoOpenReturn,
  resolveCloseDestination,
  shouldDeferChallengeReveal,
  planChallengeReveal,
} from "./utils/closeFlow"; // AIT-246 / AIT-274
import Markdown from 'markdown-to-jsx';
import { InlineMath, BlockMath } from 'react-katex';
// import 'katex/dist/katex.css';  // Γ£à Import KaTeX CSS
import katex from 'katex';
import 'katex/dist/katex.min.css';
import he from 'he'; // Recommended library for HTML entity decoding
import { useRoute, useNavigation } from '@react-navigation/native';
import { useAuth } from "./AuthContext";
import html2canvas from "html2canvas";  // Install with: npm install html2canvas
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Pressable, TouchableWithoutFeedback, Alert } from "react-native";
import TestResultsSection from "./TestResultsSection";
import { formatLocalDate, formatLocalDateShort, formatLocalWeekShort } from "./Utils";
import { useTranslation } from "./i18n/useTranslation";
import { CURRICULA, getBoardLabel } from "./constants/boards";
const languageID = 1; // TODO: Move to config in the future
// const languageIDquiz = 3; // BDD CAUTION NOTE Experiment 
import { flushSync } from 'react-dom';
import { Picker } from '@react-native-picker/picker';
import { Linking } from 'react-native';
import { NotificationProvider, useNotification } from "./NotificationContext";
import MarkdownRenderer from "./components/MarkdownRenderer";
import SuggestionRail, { SUGGESTION_RAIL_WIDTH, getResponsiveRailWidth } from "./components/SuggestionRail";
import ChatPanel from "./components/ChatPanel";
import LeftSidebar from "./components/LeftSidebar";
import FolderNavigation from "./components/FolderNavigation";
import DavinciChallengeIntro from "./components/DavinciChallengeIntro"; // BDD 2026-06-16 Da Vinci 3-Day Challenge intro/lockdown
import TopicCardRedesigned from "./components/TopicCardRedesigned";
import ChapterLearningWorkspace from "./chapterLearning/ChapterLearningWorkspace";
import { resolveChapterLearningPath } from "./chapterLearning/chapterLearningPathRegistry";

// Lesson in a Box 2026-08-13
import LessonPlanWorkspace, {
  COVER_INDEX as LESSON_COVER_INDEX,
} from "./components/lessonPlans/LessonPlanWorkspace";
import {
  shouldPersistLessonRun,
  loadLessonRunProgress,
} from "./components/lessonPlans/lessonRunPersistence";
import LessonPlanLauncher, {
} from "./components/lessonPlans/LessonPlanLauncher";
// Same cap the Class Insights page uses, so the two lesson screens frame their
// content identically instead of one stretching to the monitor.
const LESSON_INDEX_MAX_WIDTH = 1240;
import LessonAssetCompanion from "./components/lessonPlans/LessonAssetCompanion";
// An asset's authored summary, shown where the Saras rail normally is. Takes a
// label and a string and nothing else — it cannot ask, which is the point.
import LessonSummarySurface from "./components/lessonPlans/LessonSummarySurface";
// Present mode 2026-08-27 — the full-screen presenting surface for a class
// with no devices. Owns its own layout; the app only hides chrome around it.
import LessonPresentMode from "./components/lessonPlans/present/LessonPresentMode";
import { LESSON_PRESENT_MODE_ENABLED, resolveLessonPresentHandler } from "./utils/featureFlags";
import LessonWizard from "./components/lessonPlans/authoring/LessonWizard";
import LessonInsightsPanel from "./components/lessonPlans/LessonInsightsPanel";
// S4 — collapsible Saras AI rail for the lesson workspace only. Wraps
// SuggestionRail; the other SuggestionRail call sites in this file are
// untouched by it. See LessonSarasPanel.js for why it owns its own width.
import LessonSarasPanel from "./components/lessonPlans/LessonSarasPanel";
import {
  buildResponsePayload,
  recordAiResult,
} from "./components/lessonPlans/lessonPlanRules";
import {
  apiForkLessonPlan,
  apiGetLessonClassInsights,
  apiGetLessonPlanProgress,
  apiGetLessonPlanRuntime,
  apiGetLessonPlanState,
  apiListLessonPlans,
  apiRecordLessonResponses,
  apiSaveLessonPlanState,
} from "./lessonPlans";

import { SUMMER_CAMP_DAYS } from "./components/home/launcherCatalog";

const STEM_MISSION_PHASE_LABELS = [
  "PRELUDE",
  "WONDER",
  "EXPLORE",
  "UNDERSTAND",
  "APPLY",
  "TEST & IMPROVE",
  "EXPLAIN",
  "REFLECT",
  "GROW",
];

const STEM_MISSION_SLUGS = new Set([
  "flood-rescue-bridge",
  "electric-spiral-mission",
  "conductive-dough-mission",
  "wind-powered-car-mission",
  "robot-artist-mission",
  "robot-artist-explorers-mission",
]);
import { SectionHeader, EmptyState, getMainContentColors } from "./components/MainContentArea";
import { getLessonColors } from "./components/lessonPlans/lessonPlanTheme";

// Saras Learning Loop 2026-08-24 - the Discovery Journey story layer. A loop
// IS a lesson_plan, so opening one routes through the lesson runtime above;
// these components render the chain and the cross-loop mastery map only.
import DiscoveryJourneyLauncher from "./components/discoveryJourneys/DiscoveryJourneyLauncher";
import DiscoveryJourneyMap from "./components/discoveryJourneys/DiscoveryJourneyMap";
import JourneyMasteryMap from "./components/discoveryJourneys/JourneyMasteryMap";
import {
  apiGetDiscoveryJourneyRuntime,
  apiGetJourneyMasteryMap,
} from "./discoveryJourneys";
import {
  apiEvaluateLessonAnswer,
  apiGetLessonMastery,
  apiRecordExplorationEvents,
} from "./lessonPlans";
import CollectionProgressBar from "./components/CollectionProgressBar";

import { RewardProvider, useReward } from "./RewardContext";
// # BDD 01/21/2026 - add_subscription_notifications_and_support
import SupportCenterModal from "./components/SupportCenterModal";
import KnowledgeCenterModal from "./components/KnowledgeCenterModal";
// # BDD 01/21/2026 - add_subscription_notifications_and_support
import NotificationsModal from "./components/NotificationsModal";
// BDD 02/22/2026 HomeWorkHelpV2-A
import HomeworkHelpPanel from "./components/HomeworkHelpPanel";
import PwoHealthcheckPanel from "./components/PwoHealthcheckPanel";
import KtPopup from "./components/KtPopup";
import KtMasteryDashboard from "./components/KtMasteryDashboard";
// KT constants — no cooldown, questions fire on every event
// frontend/app/AITutorApp.js
import { WEBGL_BASE_URL, FASTAPI_BASE_URL, ENVIRONMENT, PDF_BASE_URL } from "./config";
// BDD 02/22/2026 HomeworkHelpV2-A
const HOMEWORK_API_BASE_URL = FASTAPI_BASE_URL; // BDD 02/22/2026 HomeWorkHelpV2-A

import Logo from '../assets/Saras-3D_Logo_WBO.png';
// collections API helpers
import {
  apiListAvailableCollections,
  apiGetCollectionResolved,
  apiSelectActiveCollection,
} from "./collections";
import { useFeatureFlags } from "./features";
// AskDock removed — chat input now lives in the right AI panel (SuggestionRail)
const DOCK_MAX_WIDTH = 800;
import { CLUB_DOCK_HEIGHT, ASK_DOCK_HEIGHT, DOCK_HEIGHT, DOCK_HEIGHT_TABLET, DOCK_HEIGHT_MOBILE, LEGACY_BAR_HEIGHT, DOCK_MINIMIZED_HEIGHT, TABLET_BREAKPOINT } from "./constants";
import VersionBadge from "./VersionBadge.js"  // BDD 01/12/2026 - Version 
// BDD 10/8/2025
import { findFlowOrLegacyForQuestion, getDemoPreset, getTriviaForTopic } from "./demoPreset";
import { dumpActiveCollectionForPreset } from "./debugDump";
// BDD 10/12/2025
import { listDemoVideos } from "./demoPreset";
// BDD 10/13/2025
import ConfettiOverlay from "./ConfettiOverlay"; // path: frontend/app/ConfettiOverlay.js
// BDD 01/03/2026 schooladmin-teacher-engagement
import { canUseTeacherTools, canUseAdminTools } from "./roles";

const DAVINCI_SCANNER_ROLES = new Set([
  "davinci_kiosk",
  "moderator",
  "partneradmin",
  "admin",
  "institute_admin",
  "schooladmin",
  "superadmin",
]);

const canUseDavinciScanner = (user) =>
  !!user?.is_internal_admin || DAVINCI_SCANNER_ROLES.has((user?.role || "").toLowerCase());

// BDD 10/15/2025
// BDD 10/15/2025 — TEMP: silence RN-Web native-driver warning
if (Platform.OS === "web") {
  const _warn = console.warn?.bind(console) || (() => { });
  console.warn = (...args) => {
    const msg = String(args?.[0] ?? "");
    if (msg.includes("useNativeDriver") || msg.includes("RCTAnimation")) return;
    _warn(...args);
  };
}
// BDD 10/23/2025
import { buildCollectionTree } from "./collectionTree";
import QuestionDisplay from "./QuestionDisplay"; // BDD 10/27/2025
// Embedded teacher tools screens
import CreateTestQuestionsPageNew2 from "./CreateTestQuestionsPageNew2";
import TeacherTestsPage from "./screens/TeacherTestsPage";
import CollectionBuilderScreen from "./CollectionBuilderScreen";
import ManageStudentsScreen from "./ManageStudentsScreen";

// BDD 10/15/2025
const storage = {
  async get(key) {
    try {
      if (Platform.OS === "web") {
        const raw = window.localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
      }
      if (AsyncStorageOptional) {
        const raw = await AsyncStorageOptional.getItem(key);
        return raw ? JSON.parse(raw) : null;
      }
    } catch { }
    return null;
  },
  async set(key, val) {
    try {
      const raw = JSON.stringify(val);
      if (Platform.OS === "web") return window.localStorage.setItem(key, raw);
      if (AsyncStorageOptional) return AsyncStorageOptional.setItem(key, raw);
    } catch { }
  }
};

const API_URL_ASK = `${FASTAPI_BASE_URL}/ask_ai`;
const API_URL_ASK_STREAM = `${FASTAPI_BASE_URL}/ask_ai_stream`;  // ZA 04/09/2026 - streaming endpoint
const API_URL_FAST_ASK = `${FASTAPI_BASE_URL}/ask_fast`;  // NEW BDD 10/14/2025
const LAST_TOPIC_KEY = "last_viewed_topic";

const API_URL_MASTER_PLAYLIST = `${FASTAPI_BASE_URL}/master_playlist`;
const API_URL_VIDEOMETA = `${FASTAPI_BASE_URL}/video_metadata`;
const API_URL_SECURE_M3U8 = `${FASTAPI_BASE_URL}/secure_m3u8`;
const API_URL_CURRICULUM = `${FASTAPI_BASE_URL}/curriculum`;
const API_URL_CONTENT = `${FASTAPI_BASE_URL}/content`;
const debugPromptMode = new URLSearchParams(window.location.search).get("debugPromptMode") === "true";


// BDD 11/18/2025 - try 4 - Redesigned 01/06/2026
const TeacherDashboard = ({ setActiveModule, isDarkMode = false }) => {
  const [classes, setClasses] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState(null);

  const [summary, setSummary] = useState(null);
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { t } = useTranslation();
  const auth = useAuth();
  const { user } = auth || {};
  const teacherEmail = user?.email || null;

  // const [weeks, setWeeks] = useState(4);
  // const [allTime, setAllTime] = useState(false); // "from beginning to now" // BDD 02/17/2026

  // const [observerMode, setObserverMode] = useState(false);
  // const [observerSchoolName, setObserverSchoolName] = useState(user?.school || null);
  // // BDD 02/17/2026
  // const [observerSchoolId, setObserverSchoolId] = useState(user?.school_id ?? null); // ok if undefined
  // const [observerUnassigned, setObserverUnassigned] = useState(false); // "No school assigned" group

  // const observerSchoolLabel = observerUnassigned
  //   ? t("Unassigned (No School)")
  //   : (observerSchoolName || "");
  // const [schools, setSchools] = useState([]);
  // const [showStudentLB, setShowStudentLB] = useState(true);
  // const [showTeacherLB, setShowTeacherLB] = useState(true);
  // const [teacherLeaders, setTeacherLeaders] = useState([]);

  // // --- Data fetchers ---
  // const fetchTeacherClasses = async () => {
  //   try {
  //     // const params = observerMode
  //     //   ? { observer_all: 1, school_name: observerSchoolName }
  //     //   : { teacher_email: teacherEmail };
  //     // BDD 02/17/2026
  //     const params = observerMode
  //       ? {
  //           observer_all: 1,
  //           ...(observerUnassigned ? { unassigned: 1 } : { school_name: observerSchoolName }),
  //           ...(observerSchoolId ? { school_id: observerSchoolId } : {}),
  //         }
  //       : { teacher_email: teacherEmail };
  //     const response = await axios.get(`${FASTAPI_BASE_URL}/classes/teacher/classes`, { params });
  //     setClasses(response.data?.classes || []);
  //   } catch (err) {
  //     console.error("Error fetching teacher classes:", err);
  //     setError(t("Error loading classes"));
  //   }
  // };

  // const fetchEngagement = async () => {
  //   setLoading(true);
  //   setError(null);
  //   try {
  //     // const params = observerMode
  //     //   ? { observer_all: 1, school_name: observerSchoolName, class_id: selectedClassId, weeks }
  //     //   : { teacher_email: teacherEmail, class_id: selectedClassId, weeks };
  //     // BDD 02/17/2026
  //     const params = observerMode
  //       ? {
  //           observer_all: 1,
  //           class_id: selectedClassId,
  //           weeks,
  //           ...(allTime ? { all_time: 1 } : {}),
  //           ...(observerUnassigned ? { unassigned: 1 } : { school_name: observerSchoolName }),
  //           ...(observerSchoolId ? { school_id: observerSchoolId } : {}),
  //         }
  //       : {
  //           teacher_email: teacherEmail,
  //           class_id: selectedClassId,
  //           weeks,
  //           ...(allTime ? { all_time: 1 } : {}),
  //         };
  //     const response = await axios.get(`${FASTAPI_BASE_URL}/classes/teacher/class-engagement-summary`, { params });
  //     const data = response.data || {};
  //     setSummary(data.summary || null);
  //     setStudents(data.students || []);
  //   } catch (err) {
  //     console.error("Error fetching engagement summary:", err);
  //     setError(t("Error loading engagement summary"));
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   if (!teacherEmail) return;
  //   fetchTeacherClasses();
  // }, [teacherEmail, observerMode, observerSchoolName]);

  // useEffect(() => {
  //   if (!teacherEmail) return;
  //   fetchEngagement();
  // }, [teacherEmail, selectedClassId, weeks, observerMode, observerSchoolName]);

  // const fetchSchools = async () => {
  //   try {
  //     const res = await axios.get(`${FASTAPI_BASE_URL}/classes/schools`, { params: { observer_all: 1 } });
  //     const list = res.data?.schools || [];
  //     setSchools(list);
  //     if (!observerSchoolName && list.length) setObserverSchoolName(list[0].name);
  //   } catch (e) { console.error("fetchSchools error", e); }
  // };

  // useEffect(() => {
  //   if (observerMode && user?.can_view_all_classes) fetchSchools();
  // }, [observerMode, user?.can_view_all_classes]);

  // const fetchTeacherLeaderboard = async () => {
  //   if (!(user?.can_use_admin_tools ?? canUseAdminTools(user?.role))) {
  //     setTeacherLeaders([]);
  //     return;
  //   }
  //   try {
  //     // const params = {
  //     //   school_name: observerMode && observerSchoolName ? observerSchoolName : (user?.school || ""),
  //     //   weeks,
  //     // };
  //     // BDD 02/17/2026
  //     const params = {
  //       weeks,
  //       ...(allTime ? { all_time: 1 } : {}),

  //       // Observer selection takes precedence
  //       ...(observerMode
  //         ? {
  //             ...(observerUnassigned ? { unassigned: 1 } : { school_name: observerSchoolName }),
  //             ...(observerSchoolId ? { school_id: observerSchoolId } : {}),
  //           }
  //         : {
  //             // Normal mode: keep existing behavior, but also pass school_id if available
  //             school_name: user?.school || "",
  //             ...(user?.school_id ? { school_id: user.school_id } : {}),
  //           }),
  //     };

  //     const res = await axios.get(`${FASTAPI_BASE_URL}/classes/school/teacher-engagement-leaderboard`, { params });
  //     setTeacherLeaders(res.data?.teachers || []);
  //   } catch (e) {
  //     console.error("fetchTeacherLeaderboard error", e);
  //     setTeacherLeaders([]);
  //   }
  // };

  // // BDD 02/17/2026
  // useEffect(() => {
  //   fetchTeacherLeaderboard();
  // }, [weeks, allTime, observerMode, observerSchoolName, observerSchoolId, observerUnassigned, user?.role, user?.school, user?.school_id]);

  // // BDD 02/17/2026
  // useEffect(() => {
  //   // When switching schools (or to Unassigned), clear the selected class to avoid stale class_id.
  //   setSelectedClassId(null);
  // }, [observerMode, observerSchoolName, observerUnassigned]);


  // BDD 02/17/2026 - try2
  const [showStudentLB, setShowStudentLB] = useState(true);
  const [showTeacherLB, setShowTeacherLB] = useState(true);

  // --- State (keep your existing ones; add the missing if not present) ---
const [observerMode, setObserverMode] = useState(false);
  // BDD 02/17/2026 - try2

// You already have these (based on your pasted render)
const [observerSchoolName, setObserverSchoolName] = useState(user?.school || null);
const [observerSchoolId, setObserverSchoolId] = useState(null);
const [observerUnassigned, setObserverUnassigned] = useState(false);
  // BDD 02/17/2026 - try2

const [schools, setSchools] = useState([]);
const [teacherLeaders, setTeacherLeaders] = useState([]);
  // BDD 02/17/2026 - try2

const [weeks, setWeeks] = useState(4);
const [allTime, setAllTime] = useState(false);
  // BDD 02/17/2026 - try2

// label used in UI
const observerSchoolLabel = React.useMemo(() => {
  if (observerUnassigned) return t("Unassigned (No School)");
  return (observerSchoolName || user?.school || "");
}, [observerUnassigned, observerSchoolName, user?.school, t]);
  // BDD 02/17/2026 - try2

// --- Helpers to build params (school_id first; fallback to school_name; or unassigned) ---
const buildObserverSchoolParams = () => {
  if (observerUnassigned) return { observer_all: 1, unassigned: 1 };

  // Prefer school_id (best)
  if (observerSchoolId) return { observer_all: 1, school_id: observerSchoolId };

  // Fallback to name only if id is missing
  if (observerSchoolName) return { observer_all: 1, school_name: observerSchoolName };

  // Last fallback: user school_id/name (if observer has none selected yet)
  if (user?.school_id) return { observer_all: 1, school_id: user.school_id };
  if (user?.school) return { observer_all: 1, school_name: user.school };

  return { observer_all: 1 };
};
  // BDD 02/17/2026 - try2

// --- Data fetchers ---
const fetchSchools = async () => {
  try {
    const res = await axios.get(`${FASTAPI_BASE_URL}/classes/schools`, { params: { observer_all: 1 } });

    // If backend now returns UNASSIGNED, avoid duplicate because UI also adds it.
    const raw = res.data?.schools || [];
    const list = raw.filter(s => String(s?.code || "").toUpperCase() !== "UNASSIGNED");

    setSchools(list);

    // Default selection ONLY if nothing is selected yet
    if (!observerUnassigned && !observerSchoolId && !observerSchoolName && list.length) {
      setObserverSchoolName(list[0].name);
      setObserverSchoolId(list[0].id ?? null);
    }
  } catch (e) {
    console.error("fetchSchools error", e);
  }
};
  // BDD 02/17/2026 - try2

useEffect(() => {
  if (observerMode && user?.can_view_all_classes) fetchSchools();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [observerMode, user?.can_view_all_classes]);
  // BDD 02/17/2026 - try2

const fetchTeacherClasses = async () => {
  try {
    // If observer is viewing unassigned, there are no school classes to list.
    if (observerMode && observerUnassigned) {
      setClasses([]);
      return;
    }

    const params = observerMode
      ? buildObserverSchoolParams()
      : { teacher_email: teacherEmail };

    const response = await axios.get(`${FASTAPI_BASE_URL}/classes/teacher/classes`, { params });
    setClasses(response.data?.classes || []);
  } catch (err) {
    console.error("Error fetching teacher classes:", err);
    setError(t("Error loading classes"));
  }
};
  // BDD 02/17/2026 - try2

const fetchEngagement = async () => {
  setLoading(true);
  setError(null);
  try {
    let params;

    if (observerMode) {
      params = {
        ...buildObserverSchoolParams(),
        // class_id makes no sense for unassigned; keep it null
        ...(observerUnassigned ? {} : (selectedClassId != null ? { class_id: selectedClassId } : {})),
        weeks,
        all_time: allTime ? 1 : 0,
      };
    } else {
      params = {
        teacher_email: teacherEmail,
        ...(selectedClassId != null ? { class_id: selectedClassId } : {}),
        weeks,
        all_time: allTime ? 1 : 0,
      };
    }

    const response = await axios.get(`${FASTAPI_BASE_URL}/classes/teacher/class-engagement-summary`, { params });
    const data = response.data || {};
    setSummary(data.summary || null);
    setStudents(data.students || []);
  } catch (err) {
    console.error("Error fetching engagement summary:", err);
    setError(t("Error loading engagement summary"));
  } finally {
    setLoading(false);
  }
};
  // BDD 02/17/2026 - try2

const fetchTeacherLeaderboard = async () => {
  if (!(user?.can_use_admin_tools ?? canUseAdminTools(user?.role))) {
    setTeacherLeaders([]);
    return;
  }
  try {
    let params;

    if (observerMode) {
      params = {
        ...buildObserverSchoolParams(),
        weeks,
        all_time: allTime ? 1 : 0,
      };
    } else {
      // non-observer: prefer school_id if your token/user object includes it, else fallback to school string
      params = {
        ...(user?.school_id ? { school_id: user.school_id } : {}),
        ...(!user?.school_id && user?.school ? { school_name: user.school } : {}),
        weeks,
        all_time: allTime ? 1 : 0,
      };
    }

    const res = await axios.get(`${FASTAPI_BASE_URL}/classes/school/teacher-engagement-leaderboard`, { params });
    setTeacherLeaders(res.data?.teachers || []);
  } catch (e) {
    console.error("fetchTeacherLeaderboard error", e);
    setTeacherLeaders([]);
  }
};
  // BDD 02/17/2026 - try2

// --- Effects (IMPORTANT: include observerSchoolId/unassigned/allTime dependencies) ---
useEffect(() => {
  if (!teacherEmail) return;
  fetchTeacherClasses();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [teacherEmail, observerMode, observerSchoolName, observerSchoolId, observerUnassigned]);
  // BDD 02/17/2026 - try2

useEffect(() => {
  if (!teacherEmail) return;
  fetchEngagement();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [teacherEmail, selectedClassId, weeks, allTime, observerMode, observerSchoolName, observerSchoolId, observerUnassigned]);
  // BDD 02/17/2026 - try2

useEffect(() => {
  fetchTeacherLeaderboard();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [weeks, allTime, observerMode, observerSchoolName, observerSchoolId, observerUnassigned, user?.role, user?.school, user?.school_id]);

  const formatMinutes = (m) => (m == null ? "0" : m.toFixed(1));
  const handleSelectStudent = (student) => setSelectedStudent(student);
  const handleBackFromStudent = () => setSelectedStudent(null);

  // --- Styles ---
  const dk = isDarkMode;
  const ds = {
    container: { flex: 1, backgroundColor: dk ? "#0f172a" : "#f8fafc" },
    content: { padding: 24, paddingBottom: 40 },
    header: { marginBottom: 24 },
    title: { fontSize: rem(28) + 'rem', fontWeight: "700", color: dk ? "#f1f5f9" : "#0f172a", letterSpacing: -0.5 },
    subtitle: { fontSize: rem(14) + 'rem', color: dk ? "#94a3b8" : "#64748b", marginTop: 4, lineHeight: 20 },

    // Filter section
    filterSection: { marginBottom: 20 },
    filterLabel: { fontSize: rem(12) + 'rem', fontWeight: "600", color: dk ? "#94a3b8" : "#475569", marginBottom: 8, textTransform: "uppercase", letterSpacing: 0.5 },
    chipRow: { flexDirection: "row", flexWrap: "wrap", gap: 8 },
    chip: { paddingVertical: 8, paddingHorizontal: 14, borderRadius: 20, backgroundColor: dk ? "#334155" : "#e2e8f0" },
    chipActive: { backgroundColor: "#0ea5e9" },
    chipText: { fontSize: rem(13) + 'rem', fontWeight: "600", color: dk ? "#94a3b8" : "#475569" },
    chipTextActive: { color: "#ffffff" },

    // Time window
    timeChip: { paddingVertical: 6, paddingHorizontal: 12, borderRadius: 16, backgroundColor: dk ? "#1e293b" : "#f1f5f9", borderWidth: 1, borderColor: dk ? "rgba(148,163,184,0.2)" : "#e2e8f0" },
    timeChipActive: { backgroundColor: "#10b981", borderColor: "#10b981" },
    timeChipText: { fontSize: rem(12) + 'rem', fontWeight: "600", color: dk ? "#94a3b8" : "#64748b" },
    timeChipTextActive: { color: "#ffffff" },

    // Summary card - compact horizontal layout
    summaryCard: {
      backgroundColor: dk ? "#1e293b" : "#ffffff",
      borderRadius: 12,
      padding: 14,
      marginBottom: 12,
      shadowColor: "#000",
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: dk ? 0.3 : 0.03,
      shadowRadius: 4,
      elevation: 1,
      borderWidth: 1,
      borderColor: dk ? "rgba(148,163,184,0.15)" : "#e2e8f0",
    },
    summaryTitle: { fontSize: rem(13) + 'rem', fontWeight: "600", color: dk ? "#94a3b8" : "#64748b", marginBottom: 10, textTransform: "uppercase", letterSpacing: 0.5 },
    statsGrid: { flexDirection: "row", flexWrap: "wrap", justifyContent: "space-between" },
    statItem: {
      alignItems: "center",
      paddingVertical: 8,
      paddingHorizontal: 10,
      minWidth: 80,
    },
    statValue: { fontSize: rem(20) + 'rem', fontWeight: "700", color: dk ? "#f1f5f9" : "#0f172a" },
    statLabel: { fontSize: rem(10) + 'rem', color: "#94a3b8", marginTop: 2, textAlign: "center" },

    // Leaderboard section
    leaderboardCard: {
      backgroundColor: dk ? "#1e293b" : "#ffffff",
      borderRadius: 16,
      marginBottom: 16,
      shadowColor: "#000",
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: dk ? 0.3 : 0.04,
      shadowRadius: 8,
      elevation: 2,
      borderWidth: 1,
      borderColor: dk ? "rgba(148,163,184,0.15)" : "#e2e8f0",
      overflow: "hidden",
    },
    leaderboardHeader: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: 16,
      backgroundColor: dk ? "#0f172a" : "#f8fafc",
      borderBottomWidth: 1,
      borderBottomColor: dk ? "rgba(148,163,184,0.15)" : "#e2e8f0",
    },
    leaderboardTitle: { fontSize: rem(15) + 'rem', fontWeight: "700", color: dk ? "#f1f5f9" : "#0f172a" },
    chevron: { fontSize: rem(14) + 'rem', color: "#94a3b8" },

    // Student row
    studentRow: {
      flexDirection: "row",
      alignItems: "center",
      padding: 14,
      borderBottomWidth: 1,
      borderBottomColor: dk ? "rgba(148,163,184,0.1)" : "#f1f5f9",
    },
    rankBadge: {
      width: 32,
      height: 32,
      borderRadius: 16,
      backgroundColor: dk ? "#334155" : "#f1f5f9",
      justifyContent: "center",
      alignItems: "center",
      marginRight: 12,
    },
    rankBadgeTop: { backgroundColor: dk ? "rgba(251,191,36,0.2)" : "#fef3c7" },
    rankText: { fontSize: rem(12) + 'rem', fontWeight: "700", color: dk ? "#94a3b8" : "#64748b" },
    rankTextTop: { color: dk ? "#fbbf24" : "#d97706" },
    studentInfo: { flex: 1 },
    studentName: { fontSize: rem(14) + 'rem', fontWeight: "600", color: dk ? "#f1f5f9" : "#0f172a" },
    studentEmail: { fontSize: rem(12) + 'rem', color: "#94a3b8", marginTop: 1 },
    studentStats: { flexDirection: "row", marginTop: 6, gap: 12 },
    miniStat: { flexDirection: "row", alignItems: "center", gap: 4 },
    miniStatText: { fontSize: rem(11) + 'rem', color: dk ? "#94a3b8" : "#64748b" },
    scoreContainer: { alignItems: "flex-end" },
    scoreValue: { fontSize: rem(18) + 'rem', fontWeight: "700", color: dk ? "#38bdf8" : "#0ea5e9" },
    scoreLabel: { fontSize: rem(10) + 'rem', color: "#94a3b8", textTransform: "uppercase" },

    // Observer mode
    observerCard: {
      backgroundColor: dk ? "rgba(245,158,11,0.15)" : "#fffbeb",
      borderRadius: 12,
      padding: 14,
      marginBottom: 16,
      borderWidth: 1,
      borderColor: dk ? "rgba(251,191,36,0.3)" : "#fde68a",
      flexDirection: "row",
      alignItems: "center",
    },
    observerText: { fontSize: rem(13) + 'rem', color: dk ? "#fbbf24" : "#92400e", marginLeft: 10, flex: 1 },
    schoolSelect: { padding: 8, borderRadius: 8, border: dk ? "1px solid rgba(148,163,184,0.2)" : "1px solid #e2e8f0", backgroundColor: dk ? "#1e293b" : "#ffffff", color: dk ? "#f1f5f9" : undefined, fontSize: rem(13) + 'rem', minWidth: 200 },

    // Empty state
    emptyState: { padding: 24, alignItems: "center" },
    emptyText: { fontSize: rem(14) + 'rem', color: "#94a3b8", textAlign: "center" },

    // Error
    errorBanner: { backgroundColor: dk ? "rgba(239,68,68,0.15)" : "#fef2f2", borderRadius: 8, padding: 12, marginBottom: 16, borderWidth: 1, borderColor: dk ? "rgba(248,113,113,0.3)" : "#fecaca" },
    errorText: { color: dk ? "#f87171" : "#dc2626", fontSize: rem(13) + 'rem' },
  };

  // --- Early return ---
  if (!teacherEmail) {
    return (
      <View style={[ds.container, { justifyContent: "center", alignItems: "center", padding: 40 }]}>
        <MaterialCommunityIcons name="account-lock" size={48} color="#94a3b8" />
        <Text style={{ fontSize: rem(18) + 'rem', fontWeight: "600", color: dk ? "#f1f5f9" : "#0f172a", marginTop: 16 }}>
          {t("Teacher Dashboard")}
        </Text>
        <Text style={{ fontSize: rem(14) + 'rem', color: dk ? "#94a3b8" : "#64748b", marginTop: 8, textAlign: "center" }}>
          {t("Teacher login required to view this dashboard.")}
        </Text>
      </View>
    );
  }

  // --- Main render ---
  return (
    <ScrollView style={ds.container} contentContainerStyle={ds.content} keyboardShouldPersistTaps="handled">
      {/* Header */}
      <View style={ds.header}>
        <Text style={ds.title}>{t("Teacher Dashboard")}</Text>
        <Text style={ds.subtitle}>
          {t("Monitor student engagement across PWOs, videos, AI questions, quizzes, and tests")}
        </Text>
      </View>

      {/* Observer Mode Toggle */}
      {user?.can_view_all_classes && (
        <View style={ds.observerCard}>
          <Switch
            value={observerMode}
            onValueChange={(v) => {
              setObserverMode(v);
              setSelectedClassId(null);
              // BDD 02/17/2026 - try2
              // fetchTeacherClasses(); 
              // fetchEngagement();
              // fetchTeacherLeaderboard();
            }}
            trackColor={{ false: dk ? "#334155" : "#e2e8f0", true: "#fbbf24" }}
            thumbColor={observerMode ? "#f59e0b" : (dk ? "#94a3b8" : "#ffffff")}
          />
          <Text style={ds.observerText}>
            {t("Observer Mode")} {observerSchoolLabel ? `• ${observerSchoolLabel}` : ""}
          </Text>
        </View>
      )}

      {observerMode && user?.can_view_all_classes && (
        <View style={{ marginBottom: 16 }}>
          <Text style={ds.filterLabel}>{t("Select School")}</Text>
          <select
            value={observerUnassigned ? "__UNASSIGNED__" : (observerSchoolName || "")}
            onChange={(e) => {
              const v = e.target.value;

              if (v === "__UNASSIGNED__") {
                setObserverUnassigned(true);
                setObserverSchoolName(null);
                setObserverSchoolId(null);
                setSelectedClassId(null);
                return;
              }

              setObserverUnassigned(false);
              setObserverSchoolName(v);

              // Best-effort: derive school_id from the fetched list (if present)
              const match = (schools || []).find(s => (s?.name || "").toLowerCase() === (v || "").toLowerCase());
              setObserverSchoolId(match?.id ?? null);
            }}
            style={ds.schoolSelect}
          >
            <option value="__UNASSIGNED__">{t("Unassigned (No School)")}</option>
            {(schools || []).map((s) => (
              <option key={s.code || s.id || s.name} value={s.name}>{s.name}</option>
            ))}
          </select>
        </View>
      )}

      {/* Class Filter */}
      <View style={ds.filterSection}>
        <Text style={ds.filterLabel}>{t("Filter by Class")}</Text>
        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
          <View style={ds.chipRow}>
            <TouchableOpacity
              onPress={() => setSelectedClassId(null)}
              style={[ds.chip, selectedClassId === null && ds.chipActive]}
            >
              <Text style={[ds.chipText, selectedClassId === null && ds.chipTextActive]}>
                {t("All Classes")}
              </Text>
            </TouchableOpacity>
            {classes.map((cls) => (
              <TouchableOpacity
                key={cls.id}
                onPress={() => setSelectedClassId(cls.id)}
                style={[ds.chip, selectedClassId === cls.id && ds.chipActive]}
              >
                <Text style={[ds.chipText, selectedClassId === cls.id && ds.chipTextActive]}>
                  {cls.name}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
        </ScrollView>
      </View>

      {/* Time Window */}
      <View style={ds.filterSection}>
        <Text style={ds.filterLabel}>{t("Time Window")}</Text>
        <View style={ds.chipRow}>
          {[1, 4, 8, 12, 26, 52].map((w) => (
            <TouchableOpacity
              key={w}
              onPress={() => { setAllTime(false); setWeeks(w); }}
              style={[ds.timeChip, (!allTime && weeks === w) && ds.timeChipActive]}
            >
              <Text style={[ds.timeChipText, (!allTime && weeks === w) && ds.timeChipTextActive]}>
                {w === 1 ? t("1 week") : `${w} ${t("weeks")}`}
              </Text>
            </TouchableOpacity>
          ))}

          <TouchableOpacity
            onPress={() => setAllTime(true)}
            style={[ds.timeChip, allTime && ds.timeChipActive]}
          >
            <Text style={[ds.timeChipText, allTime && ds.timeChipTextActive]}>
              {t("All time")}
            </Text>
          </TouchableOpacity>
        </View>
      </View>

      {error && (
        <View style={ds.errorBanner}>
          <Text style={ds.errorText}>{error}</Text>
        </View>
      )}

      {selectedStudent ? (
        <StudentDetailsCard student={selectedStudent} onBack={handleBackFromStudent} formatMinutes={formatMinutes} isDarkMode={isDarkMode} />
      ) : (
        <>
          {/* Summary Stats - Compact */}
          {summary && (
            <View style={ds.summaryCard}>
              <Text style={ds.summaryTitle}>{t("Class Summary")}</Text>
              <View style={ds.statsGrid}>
                <View style={ds.statItem}>
                  <Text style={ds.statValue}>{summary.total_students}</Text>
                  <Text style={ds.statLabel}>{t("Students")}</Text>
                </View>
                <View style={ds.statItem}>
                  <Text style={[ds.statValue, { color: "#10b981" }]}>{summary.active_students}</Text>
                  <Text style={ds.statLabel}>{t("Active")}</Text>
                </View>
                <View style={ds.statItem}>
                  <Text style={[ds.statValue, { color: "#8b5cf6" }]}>{formatMinutes(summary.avg_time_active_minutes)}</Text>
                  <Text style={ds.statLabel}>{t("Avg Min")}</Text>
                </View>
                <View style={ds.statItem}>
                  <Text style={[ds.statValue, { color: "#f59e0b" }]}>{summary.avg_ai_questions}</Text>
                  <Text style={ds.statLabel}>{t("AI Qs")}</Text>
                </View>
                <View style={ds.statItem}>
                  <Text style={[ds.statValue, { color: "#ec4899" }]}>{summary.avg_pwo_launches}</Text>
                  <Text style={ds.statLabel}>{t("PWOs")}</Text>
                </View>
                <View style={ds.statItem}>
                  <Text style={[ds.statValue, { color: "#06b6d4" }]}>{summary.avg_video_plays}</Text>
                  <Text style={ds.statLabel}>{t("Videos")}</Text>
                </View>
              </View>
            </View>
          )}

          {/* Student Leaderboard */}
          <View style={ds.leaderboardCard}>
            <TouchableOpacity onPress={() => setShowStudentLB(v => !v)} style={ds.leaderboardHeader}>
              <Text style={ds.leaderboardTitle}>{t("Student Engagement Leaderboard")}</Text>
              <Text style={ds.chevron}>{showStudentLB ? "▼" : "▶"}</Text>
            </TouchableOpacity>
            {showStudentLB && (
              loading ? (
                <View style={ds.emptyState}>
                  <ActivityIndicator color="#0ea5e9" />
                  <Text style={[ds.emptyText, { marginTop: 8 }]}>{t("Loading...")}</Text>
                </View>
              ) : students.length === 0 ? (
                <View style={ds.emptyState}>
                  <MaterialCommunityIcons name="account-search" size={32} color="#cbd5e1" />
                  <Text style={ds.emptyText}>{t("No students found")}</Text>
                </View>
              ) : (
                <View style={{ maxHeight: 400 }}>
                  <ScrollView nestedScrollEnabled>
                    {students.map((s, i) => (
                      <TouchableOpacity key={s.email || i} onPress={() => handleSelectStudent(s)} style={ds.studentRow}>
                        <View style={[ds.rankBadge, i < 3 && ds.rankBadgeTop]}>
                          <Text style={[ds.rankText, i < 3 && ds.rankTextTop]}>{i + 1}</Text>
                        </View>
                        <View style={ds.studentInfo}>
                          <Text style={ds.studentName}>{s.name}</Text>
                          <Text style={ds.studentEmail}>{s.email}</Text>
                          <View style={ds.studentStats}>
                            <View style={ds.miniStat}>
                              <Text style={ds.miniStatText}>⏱ {formatMinutes(s.time_active_minutes)}m</Text>
                            </View>
                            <View style={ds.miniStat}>
                              <Text style={ds.miniStatText}>🧪 {s.pwo_launches}</Text>
                            </View>
                            <View style={ds.miniStat}>
                              <Text style={ds.miniStatText}>🎬 {s.video_plays}</Text>
                            </View>
                            <View style={ds.miniStat}>
                              <Text style={ds.miniStatText}>💬 {s.ai_questions}</Text>
                            </View>
                          </View>
                        </View>
                        <View style={ds.scoreContainer}>
                          <Text style={ds.scoreValue}>{s.engagement_score}</Text>
                          <Text style={ds.scoreLabel}>{t("Score")}</Text>
                        </View>
                      </TouchableOpacity>
                    ))}
                  </ScrollView>
                </View>
              )
            )}
          </View>

          {/* Teacher Leaderboard (Admin only) */}
          {(user?.can_use_admin_tools ?? canUseAdminTools(user?.role)) && (
            <View style={ds.leaderboardCard}>
              <TouchableOpacity onPress={() => setShowTeacherLB(v => !v)} style={ds.leaderboardHeader}>
                <Text style={ds.leaderboardTitle}>
                  {t("Teacher Engagement Leaderboard")}
                    {observerMode && observerSchoolLabel ? ` • ${observerSchoolLabel}` : ""}
                </Text>
                <Text style={ds.chevron}>{showTeacherLB ? "▼" : "▶"}</Text>
              </TouchableOpacity>
              {showTeacherLB && (
                teacherLeaders.length === 0 ? (
                  <View style={ds.emptyState}>
                    <Text style={ds.emptyText}>{t("No teacher data available")}</Text>
                  </View>
                ) : (
                  <View>
                    {teacherLeaders.map((tr, i) => (
                      <View key={tr.email || i} style={ds.studentRow}>
                        <View style={[ds.rankBadge, i < 3 && ds.rankBadgeTop]}>
                          <Text style={[ds.rankText, i < 3 && ds.rankTextTop]}>{i + 1}</Text>
                        </View>
                        <View style={ds.studentInfo}>
                          <Text style={ds.studentName}>{tr.name || tr.email}</Text>
                          <Text style={ds.studentEmail}>{tr.email}</Text>
                          <View style={ds.studentStats}>
                            <View style={ds.miniStat}>
                              <Text style={ds.miniStatText}>⏱ {tr.time_active_minutes}m</Text>
                            </View>
                            <View style={ds.miniStat}>
                              <Text style={ds.miniStatText}>🧪 {tr.pwo_launches}</Text>
                            </View>
                            <View style={ds.miniStat}>
                              <Text style={ds.miniStatText}>🎬 {tr.video_plays}</Text>
                            </View>
                          </View>
                        </View>
                        <View style={ds.scoreContainer}>
                          <Text style={ds.scoreValue}>{tr.engagement_score}</Text>
                          <Text style={ds.scoreLabel}>{t("Score")}</Text>
                        </View>
                      </View>
                    ))}
                  </View>
                )
              )}
            </View>
          )}
        </>
      )}

      {/* Knowledge Tracing — Mastery Dashboard Link */}
      <TouchableOpacity
        style={{
          backgroundColor: dk ? "#1e293b" : "#ffffff",
          borderRadius: 16,
          padding: 20,
          marginHorizontal: 20,
          marginTop: 16,
          marginBottom: 24,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          ...(Platform.OS === "web"
            ? { boxShadow: dk ? "0 4px 12px rgba(0,0,0,0.3)" : "0 4px 12px rgba(0,0,0,0.06)" }
            : { shadowColor: "#000", shadowOffset: { width: 0, height: 4 }, shadowOpacity: dk ? 0.3 : 0.06, shadowRadius: 12, elevation: 3 }),
        }}
        onPress={() => setActiveModule("knowledgeMastery")}
        activeOpacity={0.7}
      >
        <View style={{ flexDirection: "row", alignItems: "center", flex: 1 }}>
          <View style={{
            width: 44, height: 44, borderRadius: 12, alignItems: "center", justifyContent: "center",
            ...(Platform.OS === "web"
              ? { background: "linear-gradient(135deg, #818cf8 0%, #6366f1 100%)" }
              : { backgroundColor: "#818cf8" }),
          }}>
            <MaterialCommunityIcons name="brain" size={22} color="#ffffff" />
          </View>
          <View style={{ marginLeft: 14, flex: 1 }}>
            <Text style={{ fontSize: 16, fontWeight: "700", color: dk ? "#f1f5f9" : "#0f172a" }}>
              {t("Knowledge Tracing")}
            </Text>
            <Text style={{ fontSize: 13, color: dk ? "#94a3b8" : "#64748b", marginTop: 2 }}>
              {t("View student mastery heatmap across topics")}
            </Text>
          </View>
        </View>
        <MaterialCommunityIcons name="chevron-right" size={22} color={dk ? "#64748b" : "#94a3b8"} />
      </TouchableOpacity>
    </ScrollView>
  );
};

// Student Details Card Component
const StudentDetailsCard = ({ student, onBack, formatMinutes, isDarkMode = false }) => {
  const { t } = useTranslation();
  const dk = isDarkMode;

  const ds = {
    card: {
      backgroundColor: dk ? "#1e293b" : "#ffffff",
      borderRadius: 16,
      padding: 24,
      shadowColor: "#000",
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: dk ? 0.3 : 0.06,
      shadowRadius: 12,
      elevation: 3,
      borderWidth: 1,
      borderColor: dk ? "rgba(148,163,184,0.15)" : "#e2e8f0",
    },
    backBtn: {
      flexDirection: "row",
      alignItems: "center",
      marginBottom: 20,
      paddingVertical: 8,
    },
    backText: { color: dk ? "#38bdf8" : "#0ea5e9", fontSize: rem(14) + 'rem', fontWeight: "600", marginLeft: 4 },
    name: { fontSize: rem(24) + 'rem', fontWeight: "700", color: dk ? "#f1f5f9" : "#0f172a" },
    email: { fontSize: rem(14) + 'rem', color: dk ? "#94a3b8" : "#64748b", marginTop: 4, marginBottom: 20 },
    statsGrid: { flexDirection: "row", flexWrap: "wrap", gap: 12 },
    statBox: {
      width: "47%",
      backgroundColor: dk ? "#0f172a" : "#f8fafc",
      borderRadius: 12,
      padding: 16,
      borderWidth: 1,
      borderColor: dk ? "rgba(148,163,184,0.15)" : "#e2e8f0",
    },
    statValue: { fontSize: rem(28) + 'rem', fontWeight: "700", color: dk ? "#f1f5f9" : "#0f172a" },
    statLabel: { fontSize: rem(12) + 'rem', color: dk ? "#94a3b8" : "#64748b", marginTop: 4 },
    lastActive: {
      marginTop: 16,
      paddingTop: 16,
      borderTopWidth: 1,
      borderTopColor: dk ? "rgba(148,163,184,0.15)" : "#e2e8f0",
      flexDirection: "row",
      alignItems: "center",
    },
    lastActiveText: { fontSize: rem(13) + 'rem', color: dk ? "#94a3b8" : "#64748b", marginLeft: 8 },
  };

  return (
    <View style={ds.card}>
      <TouchableOpacity onPress={onBack} style={ds.backBtn}>
        <MaterialCommunityIcons name="arrow-left" size={20} color="#0ea5e9" />
        <Text style={ds.backText}>{t("Back to leaderboard")}</Text>
      </TouchableOpacity>

      <Text style={ds.name}>{student.name}</Text>
      <Text style={ds.email}>{student.email}</Text>

      <View style={ds.statsGrid}>
        <View style={ds.statBox}>
          <Text style={[ds.statValue, { color: "#0ea5e9" }]}>{student.engagement_score}</Text>
          <Text style={ds.statLabel}>{t("Engagement Score")}</Text>
        </View>
        <View style={ds.statBox}>
          <Text style={[ds.statValue, { color: "#8b5cf6" }]}>{formatMinutes(student.time_active_minutes)}</Text>
          <Text style={ds.statLabel}>{t("Minutes Active")}</Text>
        </View>
        <View style={ds.statBox}>
          <Text style={[ds.statValue, { color: "#ec4899" }]}>{student.pwo_launches}</Text>
          <Text style={ds.statLabel}>{t("PWOs Opened")}</Text>
        </View>
        <View style={ds.statBox}>
          <Text style={[ds.statValue, { color: "#06b6d4" }]}>{student.video_plays}</Text>
          <Text style={ds.statLabel}>{t("Videos Watched")}</Text>
        </View>
        <View style={ds.statBox}>
          <Text style={[ds.statValue, { color: "#f59e0b" }]}>{student.ai_questions}</Text>
          <Text style={ds.statLabel}>{t("AI Questions")}</Text>
        </View>
        <View style={ds.statBox}>
          <Text style={[ds.statValue, { color: "#10b981" }]}>{student.quiz_attempts}</Text>
          <Text style={ds.statLabel}>{t("Topic Quiz Attempts")}</Text>
        </View>
      </View>

      <View style={ds.lastActive}>
        <MaterialCommunityIcons name="calendar-clock" size={18} color="#94a3b8" />
        <Text style={ds.lastActiveText}>
          {t("Last active")}: {student.last_active ? formatLocalDate(student.last_active) : t("N/A")}
        </Text>
      </View>
    </View>
  );
};

// BDD 10/4/2025
// --- visibility (private | org | public)
export async function apiUpdateVisibility({ collection_id, visibility_scope, acting_teacher_email }) {
  // PATCH /api/collections/{id}?acting_teacher_email=...
  const url = `${API_COLLECTIONS}/${collection_id}?acting_teacher_email=${encodeURIComponent(acting_teacher_email)}`;
  const res = await axios.patch(url, { visibility_scope });
  return res.data; // updated CollectionOut
}

// BDD 8/17/2025 - related to IQH3D and Leia and Android APK
// --- Android APK / WebView detection + runtime info ---
function isAndroidApkWebView() {
  if (typeof window === "undefined") return false;
  const ua = navigator.userAgent || "";
  const hasBridge = !!(window.AndroidBridge && (
    typeof window.AndroidBridge.getRuntimeInfo === "function" ||
    typeof window.AndroidBridge.launchPWO === "function"
  ));
  // We tagged the UA in MainActivity: "... AITutorApp/Android"
  return hasBridge || ua.includes("AITutorApp/Android");
}

function getAndroidRuntimeInfoSafe() {
  try {
    if (window.AndroidBridge && typeof window.AndroidBridge.getRuntimeInfo === "function") {
      const s = window.AndroidBridge.getRuntimeInfo();
      const rt = JSON.parse(s);
      // console.log("RuntimeInfo:", rt);
      return rt; // { platform, manufacturer, brand, model, isTouch }
    }
  } catch (_) { }
  return null;
}
// BDD 8/25/2025
// // until you wire a real UI toggle, return undefined so we don't override arg2
// function getPreferredCameraMode() {
//   return undefined; // later: "2D" or "3D"
// }
// Map manufacturer/brand/model → the Unity-facing device_manufacturer string
function mapRuntimeToUnityManufacturer(rt) {
  if (!rt) return undefined;
  const m = (rt.manufacturer || "").toUpperCase();
  const b = (rt.brand || "").toUpperCase();
  const mod = (rt.model || "").toUpperCase();

  // Leia
  if (m.includes("LEIA") || b.includes("LEIA")) return "Leia Inc";

  // Old IQH3D (KTE)
  if (m.includes("KTE") || b.includes("KTE")) return "KTE";

  // New IQH3D (Alldocube Skyy X / T1201 etc.)
  if (m.includes("ALLDOCUBE") || b.includes("ALLDOCUBE") || mod.includes("SKYY") || mod.includes("T1201")) {
    return "ALLDOCUBE";
  }
  // BDD 8/17/2025 -- for new IQH3D tablet this is what I got: 
  // MANUFACTURER=Alldocube BRAND=Alldocube MODEL=T1201
  // Otherwise, don't touch whatever the server sent
  return undefined;
}

//==============

// Ensures payload is a JSON string and merges extras (deviceType, camera_mode, etc.)
function coercePayloadWithExtras(payload, extras = {}) {
  try {
    const base = typeof payload === "string" ? JSON.parse(payload) : (payload || {});
    const merged = { ...base, ...extras };
    return JSON.stringify(merged);
  } catch {
    // if payload is some opaque string, just ignore extras
    return typeof payload === "string" ? payload : JSON.stringify(extras);
  }
}



// --- Collection id helpers -----------------------------------------------
function isCollectionTopicKey(k) {
  return typeof k === "string" && k.startsWith("col-");
}

// Extract { collectionId, itemIdx } from "col-<collection_id>-t-<item_index>"
function parseCollectionTopicKey(k) {
  const m = /^col-(\d+)-t-(\d+)$/.exec(String(k || ""));
  if (!m) return null;
  return { collectionId: Number(m[1]), itemIdx: Number(m[2]) };
}

// BDD 12/08/2025
// BDD 11/21/2025 – slightly larger tiles + fonts for teachers & students
const TopicCard = React.memo(function TopicCard({
  item,
  imgUrl,        // final URL string computed by parent
  swanSrc,       // local require(...) placeholder
  isDarkMode,
  t,
  onStart,
  onOpenPwo,
  onOpenVideo,
  onOpenQuiz,
}) {
  const cardBg = isDarkMode ? "rgba(22,24,29,0.9)" : "#fff";
  const border = isDarkMode ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.08)";
  const text = isDarkMode ? "#fff" : "#111";
  const sub = isDarkMode ? "#cfd6e4" : "#5f6b7a";

  const hasNet = !!imgUrl;
  const [netReady, setNetReady] = React.useState(false);
  React.useEffect(() => { setNetReady(false); }, [imgUrl]);

  // helper for absolute fill
  const fill = { position: "absolute", left: 0, top: 0, width: "100%", height: "100%" };

  // 🔹 Single label resolver for the card title
  const topicLabel = (
    item?.topicDisplayName ||
    item?.topicName ||
    item?.display_name ||   // in case someone passes the raw topic object
    item?.name ||
    ""
  ).trim();

  // Optional: one-shot debug to see what TopicCard gets
  // console.log("[TopicCard] label =", topicLabel, "raw item=", item);

  return (
    <View
      style={{
        width: "100%",
        minHeight: 280,
        borderRadius: 18,
        overflow: "hidden",
        backgroundColor: cardBg,
        borderWidth: 1,
        borderColor: border,
        marginRight: 14,
        marginBottom: 14,
        shadowColor: "#000",
        shadowOpacity: 0.06,
        shadowOffset: { width: 0, height: 8 },
        shadowRadius: 12,
      }}
    >
      {/* Cover image */}
      <View
        style={{
          height: 130,
          backgroundColor: isDarkMode ? "#1c1f26" : "#f3f5f8",
        }}
      >
        {/* Swan is always there underneath — no flicker */}
        <Image source={swanSrc} style={fill} resizeMode="cover" />

        {/* Network image sits on top, invisible until fully ready */}
        {hasNet && (
          <Image
            source={{ uri: imgUrl }}
            style={[fill, { opacity: netReady ? 1 : 0 }]}
            resizeMode="cover"
            onError={() => setNetReady(false)} // stay on Swan if it fails
            onLoad={(e) => {
              const w = e?.nativeEvent?.source?.width ?? 1;
              const h = e?.nativeEvent?.source?.height ?? 1;
              setNetReady(w > 0 && h > 0);
            }}
          />
        )}
      </View>

      {/* Body */}
      <View style={{ padding: 14 }}>
        {/* Topic title */}
        <Text
          style={{ color: text, fontWeight: "700", fontSize: rem(16) + 'rem' }}
          numberOfLines={2}
        >
          {topicLabel}
        </Text>

        {/* Buttons row */}
        <View
          style={{
            flexDirection: "row",
            marginTop: 14,
            justifyContent: "space-between",
          }}
        >
          {/* Summary */}
          <View style={{ alignItems: "center", flex: 1 }}>
            <TouchableOpacity
              onPress={() => onStart(item)}
              style={{ padding: 8, borderRadius: 10 }}
              hitSlop={{ top: 6, bottom: 6, left: 6, right: 6 }}
              accessibilityLabel={t("Overview")}
            >
              <Text style={{ fontSize: rem(18) + 'rem', marginRight: 2 }}>{"❓"}</Text>
            </TouchableOpacity>
            <Text
              style={{
                color: sub,
                fontSize: rem(13) + 'rem',
                marginTop: 2,
                textAlign: "center",
              }}
            >
              {t("Summary")}
            </Text>
          </View>

          {/* PWO */}
          <View style={{ alignItems: "center", flex: 1 }}>
            <TouchableOpacity
              onPress={() => onOpenPwo(item)}
              style={{ padding: 8, borderRadius: 10 }}
              hitSlop={{ top: 6, bottom: 6, left: 6, right: 6 }}
              accessibilityLabel={t("Open PWO")}
            >
              <Text style={{ fontSize: rem(18) + 'rem', marginRight: 2 }}>{"🎮"}</Text>
            </TouchableOpacity>
            <Text
              style={{
                color: sub,
                fontSize: rem(13) + 'rem',
                marginTop: 2,
                textAlign: "center",
              }}
            >
              {item.pwoCount ?? 0}
            </Text>
          </View>

          {/* Video */}
          <View style={{ alignItems: "center", flex: 1 }}>
            <TouchableOpacity
              onPress={() => onOpenVideo(item)}
              style={{ padding: 8, borderRadius: 10 }}
              hitSlop={{ top: 6, bottom: 6, left: 6, right: 6 }}
              accessibilityLabel={t("Open Video")}
            >
              <Text style={{ fontSize: rem(18) + 'rem', marginRight: 2 }}>{"🎬"}</Text>
            </TouchableOpacity>
            <Text
              style={{
                color: sub,
                fontSize: rem(13) + 'rem',
                marginTop: 2,
                textAlign: "center",
              }}
            >
              {item.videoCount ?? 0}
            </Text>
          </View>

          {/* Quiz */}
          <View style={{ alignItems: "center", flex: 1 }}>
            <TouchableOpacity
              onPress={() => onOpenQuiz(item)}
              style={{ padding: 8, borderRadius: 10 }}
              hitSlop={{ top: 6, bottom: 6, left: 6, right: 6 }}
              accessibilityLabel={t("Open Quiz")}
            >
              <Text style={{ fontSize: rem(18) + 'rem', marginRight: 2 }}>{"📝"}</Text>
            </TouchableOpacity>
            <Text
              style={{
                color: sub,
                fontSize: rem(13) + 'rem',
                marginTop: 2,
                textAlign: "center",
              }}
            >
              {item.quizCount ?? 0}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
}, (prev, next) => {
  // 🔁 Re-render if the visual label changes
  const prevLabel = (
    prev.item?.topicDisplayName ||
    prev.item?.topicName ||
    prev.item?.display_name ||
    prev.item?.name ||
    ""
  ).trim();
  const nextLabel = (
    next.item?.topicDisplayName ||
    next.item?.topicName ||
    next.item?.display_name ||
    next.item?.name ||
    ""
  ).trim();

  return (
    prev.isDarkMode === next.isDarkMode &&
    prev.imgUrl === next.imgUrl &&
    prev.item.topicId === next.item.topicId &&
    prev.item.topicImagePath === next.item.topicImagePath &&
    prev.item.pwoCount === next.item.pwoCount &&
    prev.item.videoCount === next.item.videoCount &&
    prev.item.quizCount === next.item.quizCount &&
    prevLabel === nextLabel
  );
});


// BDD 11/16/2025
// const SUGGESTION_RAIL_WIDTH = 320; // BDD need to adjust
// function SuggestionRail({
//   t,
//   isDarkMode,
//   sparksMapped,
//   suggestedQuestions,
//   suggestedQuestionsHeader,
//   onAsk,
// }) {
//   const hasSparks = Array.isArray(sparksMapped) && sparksMapped.length > 0;
//   const hasSuggestions =
//     Array.isArray(suggestedQuestions) && suggestedQuestions.length > 0;

//   if (!hasSparks && !hasSuggestions) return null;

//   return (
//     <View
//       style={{
//         width: SUGGESTION_RAIL_WIDTH,
//         paddingVertical: 10,
//         paddingLeft: 8,
//         borderLeftWidth: StyleSheet.hairlineWidth,
//         borderLeftColor: isDarkMode ? "#374151" : "#e5e7eb",
//         backgroundColor: isDarkMode ? "#020617" : "#f9fafb",
//       }}
//     >
//       <ScrollView
//         contentContainerStyle={{
//           paddingBottom: 90, // keep clear of AskDock visually
//           paddingRight: 8,
//         }}
//         showsVerticalScrollIndicator={true}
//       >
//         {hasSparks && (
//           <View style={{ marginBottom: hasSuggestions ? 18 : 0 }}>
//             <Text
//               style={{
//                 fontSize: 12,
//                 fontWeight: "700",
//                 marginBottom: 6,
//                 color: isDarkMode ? "#e5e7eb" : "#111827",
//               }}
//             >
//               ✨ {t("Curiosity Sparks")}
//             </Text>

//             <View
//               style={{
//                 flexDirection: "row",
//                 flexWrap: "wrap",
//                 gap: 6,
//               }}
//             >
//               {sparksMapped.map((item, idx) => {
//                 const label =
//                   typeof item === "string"
//                     ? item
//                     : item.label || item.text || "";

//                 if (!label) return null;

//                 return (
//                   <TouchableOpacity
//                     key={idx}
//                     onPress={() => onAsk(label)}
//                     style={{
//                       backgroundColor: isDarkMode ? "#020617" : "#eef2ff",
//                       borderRadius: 999,
//                       paddingVertical: 5,
//                       paddingHorizontal: 10,
//                       borderWidth: 1,
//                       borderColor: isDarkMode ? "#334155" : "#cbd5e1",
//                       marginBottom: 4,
//                     }}
//                   >
//                     <Text
//                       style={{
//                         fontSize: 11,
//                         color: isDarkMode ? "#e5e7eb" : "#111827",
//                         flexShrink: 1,
//                       }}
//                     >
//                       {label}
//                     </Text>
//                   </TouchableOpacity>
//                 );
//               })}
//             </View>
//           </View>
//         )}

//         {hasSuggestions && (
//           <View>
//             <Text
//               style={{
//                 fontSize: 12,
//                 fontWeight: "700",
//                 marginBottom: 6,
//                 color: isDarkMode ? "#e5e7eb" : "#111827",
//               }}
//             >
//               {`🤖 ${
//                 Array.isArray(suggestedQuestionsHeader) &&
//                 suggestedQuestionsHeader.length > 0
//                   ? suggestedQuestionsHeader[0]
//                   : t("Deepen your understanding:")
//               }`}
//             </Text>

//             <View
//               style={{
//                 flexDirection: "row",
//                 flexWrap: "wrap",
//                 gap: 6,
//               }}
//             >
//               {suggestedQuestions.map((question, index) => (
//                 <TouchableOpacity
//                   key={index}
//                   onPress={() => onAsk(question)}
//                   style={{
//                     backgroundColor: isDarkMode ? "#020617" : "#f1f5f9",
//                     borderRadius: 999,
//                     paddingVertical: 5,
//                     paddingHorizontal: 10,
//                     borderWidth: 1,
//                     borderColor: isDarkMode ? "#4b5563" : "#cbd5e1",
//                     marginBottom: 4,
//                   }}
//                 >
//                   <Text
//                     style={{
//                       fontSize: 11,
//                       color: isDarkMode ? "#e5e7eb" : "#111827",
//                       flexShrink: 1,
//                     }}
//                   >
//                     {question}
//                   </Text>
//                 </TouchableOpacity>
//               ))}
//             </View>
//           </View>
//         )}
//       </ScrollView>
//     </View>
//   );
// }

// BDD 11/16/2025 - try 2
// const SUGGESTION_RAIL_WIDTH = 320; // BDD need to adjust

// function SuggestionRail({
//   t,
//   isDarkMode,
//   sparksMapped,
//   suggestedQuestions,
//   suggestedQuestionsHeader,
//   onAsk,
// }) {
//   const hasSparks =
//     Array.isArray(sparksMapped) && sparksMapped.length > 0;
//   const hasSuggestions =
//     Array.isArray(suggestedQuestions) && suggestedQuestions.length > 0;

//   if (!hasSparks && !hasSuggestions) return null;

//   return (
//     <View
//       style={{
//         width: SUGGESTION_RAIL_WIDTH,
//         paddingVertical: 10,
//         paddingLeft: 8,
//         borderLeftWidth: StyleSheet.hairlineWidth,
//         borderLeftColor: isDarkMode ? "#374151" : "#e5e7eb",
//         backgroundColor: isDarkMode ? "#020617" : "#f9fafb",
//       }}
//     >
//       <ScrollView
//         contentContainerStyle={{
//           paddingBottom: 90, // keep clear of AskDock visually
//           paddingRight: 8,
//         }}
//         showsVerticalScrollIndicator={true}
//       >
//         {hasSparks && (
//           <View style={{ marginBottom: hasSuggestions ? 18 : 0 }}>
//             <Text
//               style={{
//                 fontSize: 12,
//                 fontWeight: "700",
//                 marginBottom: 6,
//                 color: isDarkMode ? "#e5e7eb" : "#111827",
//               }}
//             >
//               ✨ {t("Curiosity Sparks")}
//             </Text>

//             {/* ⬇️ STACK CHIPS VERTICALLY, FULL WIDTH */}
//             <View
//               style={{
//                 flexDirection: "column",
//               }}
//             >
//               {sparksMapped.map((item, idx) => {
//                 const label =
//                   typeof item === "string"
//                     ? item
//                     : item.label || item.text || "";

//                 if (!label) return null;

//                 return (
//                   <TouchableOpacity
//                     key={idx}
//                     onPress={() => onAsk(label)}
//                     style={{
//                       backgroundColor: isDarkMode ? "#020617" : "#eef2ff",
//                       borderRadius: 999,
//                       paddingVertical: 5,
//                       paddingHorizontal: 10,
//                       borderWidth: 1,
//                       borderColor: isDarkMode ? "#334155" : "#cbd5e1",
//                       marginBottom: 4,
//                       alignSelf: "stretch", // 👈 take full rail width
//                     }}
//                   >
//                     <Text
//                       style={{
//                         fontSize: 12,
//                         color: isDarkMode ? "#e5e7eb" : "#111827",
//                         flexShrink: 1,
//                       }}
//                     >
//                       {label}
//                     </Text>
//                   </TouchableOpacity>
//                 );
//               })}
//             </View>
//           </View>
//         )}

//         {hasSuggestions && (
//           <View>
//             <Text
//               style={{
//                 fontSize: 12,
//                 fontWeight: "700",
//                 marginBottom: 6,
//                 color: isDarkMode ? "#e5e7eb" : "#111827",
//               }}
//             >
//               {`🤖 ${
//                 Array.isArray(suggestedQuestionsHeader) &&
//                 suggestedQuestionsHeader.length > 0
//                   ? suggestedQuestionsHeader[0]
//                   : t("Deepen your understanding:")
//               }`}
//             </Text>

//             {/* ⬇️ STACK FOLLOW-UP QUESTIONS VERTICALLY, FULL WIDTH */}
//             <View
//               style={{
//                 flexDirection: "column",
//               }}
//             >
//               {suggestedQuestions.map((question, index) => (
//                 <TouchableOpacity
//                   key={index}
//                   onPress={() => onAsk(question)}
//                   style={{
//                     backgroundColor: isDarkMode ? "#020617" : "#f1f5f9",
//                     borderRadius: 999,
//                     paddingVertical: 5,
//                     paddingHorizontal: 10,
//                     borderWidth: 1,
//                     borderColor: isDarkMode ? "#4b5563" : "#cbd5e1",
//                     marginBottom: 4,
//                     alignSelf: "stretch", // 👈 take full rail width
//                   }}
//                 >
//                   <Text
//                     style={{
//                       fontSize: 12,
//                       color: isDarkMode ? "#e5e7eb" : "#111827",
//                       flexShrink: 1,
//                     }}
//                   >
//                     {question}
//                   </Text>
//                 </TouchableOpacity>
//               ))}
//             </View>
//           </View>
//         )}
//       </ScrollView>
//     </View>
//   );
// }

// // BDD 11/21/2025 - try 2
// const SUGGESTION_RAIL_WIDTH = 320; // BDD need to adjust
// function SuggestionRail({
//   t,
//   isDarkMode,
//   sparksMapped,
//   suggestedQuestions,
//   suggestedQuestionsHeader,
//   onAsk,
//   viewMode = "collections", // 👈 NEW: tell us if we're in collections vs curriculum
// }) {
//   // ✨ Curiosity Sparks ONLY in collections view
//   const hasSparks =
//     viewMode === "collections" &&
//     Array.isArray(sparksMapped) &&
//     sparksMapped.length > 0;

//     // 🤖 AI follow-ups are allowed everywhere
//   const hasSuggestions =
//     Array.isArray(suggestedQuestions) && suggestedQuestions.length > 0;

//   if (!hasSparks && !hasSuggestions) return null;

//   return (
//     <View
//       style={{
//         flex: 1, // ⬅️ make rail fill the right strip height so ScrollView can actually scroll
//         width: SUGGESTION_RAIL_WIDTH,
//         paddingVertical: 10,
//         paddingLeft: 8,
//         borderLeftWidth: StyleSheet.hairlineWidth,
//         borderLeftColor: isDarkMode ? "#374151" : "#e5e7eb",
//         backgroundColor: isDarkMode ? "#020617" : "#f9fafb",
//       }}
//     >
//       <ScrollView
//         style={{ flex: 1 }} // ⬅️ let the scrollview take remaining height
//         contentContainerStyle={{
//           paddingBottom: 90, // keep clear of AskDock visually
//           paddingRight: 8,
//         }}
//         showsVerticalScrollIndicator={true}
//       >
//         {/* ✨ Curiosity Sparks → collections only */}

//         {hasSparks && (
//           <View style={{ marginBottom: hasSuggestions ? 18 : 0 }}>
//             <Text
//               style={{
//                 fontSize: 14, // ⬆️ bigger header font
//                 fontWeight: "700",
//                 marginBottom: 6,
//                 color: isDarkMode ? "#e5e7eb" : "#111827",
//               }}
//             >
//               ✨ {t("Curiosity Sparks")}
//             </Text>

//             {/* ⬇️ STACK CHIPS VERTICALLY, FULL WIDTH */}
//             <View
//               style={{
//                 flexDirection: "column",
//               }}
//             >
//               {sparksMapped.map((item, idx) => {
//                 const label =
//                   typeof item === "string"
//                     ? item
//                     : item.label || item.text || "";

//                 if (!label) return null;

//                 return (
//                   <TouchableOpacity
//                     key={idx}
//                     onPress={() => onAsk(label)}
//                     style={{
//                       backgroundColor: isDarkMode ? "#020617" : "#eef2ff",
//                       borderRadius: 999,
//                       paddingVertical: 8,   // ⬆️ more padding
//                       paddingHorizontal: 12,
//                       borderWidth: 1,
//                       borderColor: isDarkMode ? "#334155" : "#cbd5e1",
//                       marginBottom: 6,
//                       alignSelf: "stretch", // 👈 take full rail width
//                     }}
//                   >
//                     <Text
//                       style={{
//                         fontSize: 15, // ⬆️ larger text
//                         lineHeight: 20,
//                         color: isDarkMode ? "#e5e7eb" : "#111827",
//                         flexShrink: 1,
//                       }}
//                     >
//                       {label}
//                     </Text>
//                   </TouchableOpacity>
//                 );
//               })}
//             </View>
//           </View>
//         )}

//         {hasSuggestions && (
//           <View>
//             <Text
//               style={{
//                 fontSize: 14, // ⬆️ larger header font
//                 fontWeight: "700",
//                 marginBottom: 6,
//                 color: isDarkMode ? "#e5e7eb" : "#111827",
//               }}
//             >
//               {`🤖 ${
//                 Array.isArray(suggestedQuestionsHeader) &&
//                 suggestedQuestionsHeader.length > 0
//                   ? suggestedQuestionsHeader[0]
//                   : t("Deepen your understanding:")
//               }`}
//             </Text>

//             {/* ⬇️ STACK FOLLOW-UP QUESTIONS VERTICALLY, FULL WIDTH */}
//             <View
//               style={{
//                 flexDirection: "column",
//               }}
//             >
//               {suggestedQuestions.map((question, index) => (
//                 <TouchableOpacity
//                   key={index}
//                   onPress={() => onAsk(question)}
//                   style={{
//                     backgroundColor: isDarkMode ? "#020617" : "#f1f5f9",
//                     borderRadius: 999,
//                     paddingVertical: 8,   // ⬆️ more padding
//                     paddingHorizontal: 12,
//                     borderWidth: 1,
//                     borderColor: isDarkMode ? "#4b5563" : "#cbd5e1",
//                     marginBottom: 6,
//                     alignSelf: "stretch", // 👈 take full rail width
//                   }}
//                 >
//                   <Text
//                     style={{
//                       fontSize: 15, // ⬆️ larger text
//                       lineHeight: 20,
//                       color: isDarkMode ? "#e5e7eb" : "#111827",
//                       flexShrink: 1,
//                     }}
//                   >
//                     {question}
//                   </Text>
//                 </TouchableOpacity>
//               ))}
//             </View>
//           </View>
//         )}
//       </ScrollView>
//     </View>
//   );
// }



const AITutorApp = () => {
  //   const colorScheme = useColorScheme();
  //   const isDarkMode = colorScheme === "dark";
  const flags = useFeatureFlags();
  // BDD 10/3/2025 - placeholder image for topics
  const SARAS_3D_SWAN_SRC = require("../assets/Saras-3D_Logo_WBO.png");

  const { isDark: isDarkMode, toggleTheme } = useTheme(); // Theme from context

  const [history, setHistory] = useState([]);
  const [answer, setAnswer] = useState("");
  const [documents, setDocuments] = useState([]);
  const [videos, setVideos] = useState([]);
  const [pwos, setPwos] = useState([]);
  const [showBanner, setShowBanner] = useState(false);  // State for showing the banner for pwo

  const [loading, setLoading] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [showQuiz, setShowQuiz] = useState(false);
  const [showPwo, setShowPwo] = useState(false);
  // Optional WonderLabs local Three.js provider. Uses the ordinary PWO Ask AI
  // context and Swan rail, but never boots the legacy Unity iframe.
  const [threePwoActive, setThreePwoActive] = useState(false);
  const [threePwoUrl, setThreePwoUrl] = useState("");
  const threePwoFrameRef = useRef(null);
  // Tracks whether the PWO panel is visually open (iframe may stay mounted in bg).
  // Used to hide PWO-specific questions when the PWO is closed.
  const [isPwoOpen, setIsPwoOpen] = useState(false);
  const lastPwoSuggestionsContextRef = useRef(null);

  // Schools list for ManageStudentsScreen (shared with TeacherDashboard)
  const [schools, setSchools] = useState([]);
  const fetchSchools = async () => {
    try {
      const res = await axios.get(`${FASTAPI_BASE_URL}/classes/schools`, { params: { observer_all: 1 } });
      const raw = res.data?.schools || [];
      setSchools(raw.filter(s => String(s?.code || "").toUpperCase() !== "UNASSIGNED"));
    } catch (e) {
      console.error("fetchSchools error", e);
    }
  };

  const [videoReady, setVideoReady] = useState(false);  // Track when video is ready to play

  const videoRef = useRef(null);  // Γ£à Video ref for attaching HLS.js
  const pwoRef = useRef(null);
  const whiteboardRef = useRef(null);
  // ZA 04/09/2026 - AbortController for in-flight streaming AI request
  const streamAbortControllerRef = useRef(null);
  // ZA 04/09/2026 - sequential audio queue for streaming TTS chunks
  const ttsQueueRef = useRef([]);
  const ttsAudioRef = useRef(null);
  const ttsPlayingRef = useRef(false);

  const hadStreamAudioChunksRef = useRef(false); // BDD 04/12/2026 - avoid double autoplay after streamed chunk audio
  const suppressNextAudioAutoplayRef = useRef(false); // BDD 04/12/2026 - keep final Audio for replay, but don't auto-play it after chunk audio

  const pendingHistoryIndexRef = useRef(null); // BDD 04/12/2026 - stable row target for streamed refs patching
  const currentAskRequestIdRef = useRef(null); // BDD 04/12/2026 - prevent stale refs from patching a newer ask
 
  // BDD 04/14/2026 - stale async side-job protection
  const suggestedQuestionsAbortRef = useRef(null);
  const fetchReferencesAbortRef = useRef(null);
  
  // ── Lesson in a Box (2026-08-13) ─────────────────────────────────────────
  // Overlay state, deliberately not a new activeModule: a lesson is launched
  // from a topic tile deep inside the learning module, and closing it must
  // return the user exactly where they were.
  const [lessonPlanRuntime, setLessonPlanRuntime] = useState(null);
  const [showLessonPlan, setShowLessonPlan] = useState(false);
  const [lessonPlanLoading, setLessonPlanLoading] = useState(false);
  const [lessonPlanStepIndex, setLessonPlanStepIndex] = useState(LESSON_COVER_INDEX);
  // Present mode 2026-08-27 — teacher projects the lesson to a class with no
  // devices. Deliberately not its own step index: the workspace's index above
  // stays the single source of truth, so exiting lands on the same step.
  const [lessonPresentMode, setLessonPresentMode] = useState(false);
  const [lessonPlanSessionState, setLessonPlanSessionState] = useState({});
  const [lessonPlanLaunchingBlockId, setLessonPlanLaunchingBlockId] = useState(null);
  // The block whose asset currently fills the stage, highlighted in the companion.
  const [lessonPlanActiveBlockId, setLessonPlanActiveBlockId] = useState(null);
  // The asset summary currently on screen: `{ label, text }`, the author's own
  // words, or null. Deliberately NOT a turn in `history` — a fabricated
  // exchange in the rail's conversation would sit directly above the rail's
  // input box, and the next thing typed there would reach a model that has
  // never seen those words. See LessonSummarySurface.
  const [lessonPlanSummary, setLessonPlanSummary] = useState(null);
  const [lessonPlanList, setLessonPlanList] = useState([]);
  const [lessonPlanListLoading, setLessonPlanListLoading] = useState(false);
  const [lessonPlanListError, setLessonPlanListError] = useState(null);
  // { [lesson_plan_id]: { step_index, completed, ... } } for the page badges.
  const [lessonPlanProgress, setLessonPlanProgress] = useState({});
  // Authoring: null when closed, "new" when creating, or a lesson id when editing.
  const [lessonWizardTarget, setLessonWizardTarget] = useState(null);
  // "Make my copy": the id of the lesson currently being forked, or null. Its
  // own row alone shows "Copying…" — see LessonResultRow.js.
  const [forkingLessonId, setForkingLessonId] = useState(null);
  // Teacher Insights for the open lesson.
  const [lessonInsights, setLessonInsights] = useState(null);
  const [lessonInsightsOpen, setLessonInsightsOpen] = useState(false);
  const [lessonInsightsLoading, setLessonInsightsLoading] = useState(false);
  const [lessonInsightsError, setLessonInsightsError] = useState(null);
  // The student's own bands for this lesson's concepts, for the Grow phase.
  const [lessonPlanMastery, setLessonPlanMastery] = useState([]);
  // Exploration-as-Assessment events accumulate here and ride out on the
  // existing debounced save. Buffered rather than posted per event: a scene
  // switch should cost nothing, and a lesson must not stutter to record how
  // it is being used.
  const lessonExplorationBufferRef = useRef([]);

  // ── Saras Discovery Journey (2026-08-24) ────────────────────────────────
  const [discoveryJourney, setDiscoveryJourney] = useState(null);
  const [discoveryJourneyLoading, setDiscoveryJourneyLoading] = useState(false);
  const [discoveryJourneyError, setDiscoveryJourneyError] = useState(null);
  const [discoveryJourneyMastery, setDiscoveryJourneyMastery] = useState([]);
  // Set while a lesson is open *as a loop of* a journey, so closing the lesson
  // returns to the map rather than to the lesson index.
  const discoveryJourneyLoopRef = useRef(false);

  const lessonPlanHydratedRef = useRef(false);
  // Set synchronously when a lesson launches a PWO/video/quiz, so the
  // navigate-away watcher below can tell an intentional module switch from the
  // user clicking something in the top bar.
  //
  // Nothing sets it true any more, and it is left deliberately. Its last writer
  // was the cover page's toolkit quiz chip, the last thing a lesson opened by
  // leaving the module; every asset now plays inline, so there is no excursion
  // to remember. That makes the true-branches of resolveModuleAfterClose and of
  // the navigate-away watcher unreachable, but they are module-close paths on a
  // demo-critical screen and are cheaper to leave standing than to prove safe.
  // Removing this ref means removing those branches with it — one decision, not
  // a cleanup to do in passing.
  const lessonPlanAssetLaunchRef = useRef(false);
  // handlePWOClick/handleVideoClick navigate to their own module by default.
  // A lesson renders the stage inline instead, so it overrides the target.
  const assetLaunchModuleRef = useRef(null);  // video only; PWO plays inline
  const lessonPlanSaveTimeoutRef = useRef(null);
  const lessonPlanLastSavedRef = useRef(null);

  const [journeyRuntime, setJourneyRuntime] = useState(null);
  const [showJourney, setShowJourney] = useState(false);
  // Internal WonderLabs preview: the ordinary home and teacher-led Journey
  // stay available. Only tiles launched from this page use direct Swan entry.
  const [showRegularHomeWithSwanFlag, setShowRegularHomeWithSwanFlag] = useState(false);
  const wonderLabsDirectLaunchRef = useRef(false);
  const wonderLabsExitInFlightRef = useRef(false);
  // Step 0 is a view, never a Journey phase or a separate progress record.
  const [wonderLabsWelcomeOpen, setWonderLabsWelcomeOpen] = useState(false);
  const [wonderLabsWelcomeSlug, setWonderLabsWelcomeSlug] = useState(null);
  const [wonderLabsStarting, setWonderLabsStarting] = useState(false);
  // Teacher-only classroom presentation. Navigation is intentionally separate
  // from journeyStepIndex so presenting cannot advance the saved last/visited
  // step. Content state still belongs to whoever is loaded: the teacher's own
  // Journey is editable; a selected student's Journey remains read-only.
  const [journeyPresentMode, setJourneyPresentMode] = useState(false);
  const [journeyPresentStepIndex, setJourneyPresentStepIndex] = useState(0);
  // Same Journey, different facilitation. Teacher-led remains the default.
  const [journeyMode, setJourneyMode] = useState("teacher_led");
  const [journeyLoading, setJourneyLoading] = useState(false);
  const [journeyAiContext, setJourneyAiContext] = useState(null);
  const [journeyConversationStarted, setJourneyConversationStarted] =
    useState(false);
  // Same Swan read-aloud preference in the Journey and its media viewer.
  const [journeySwanReadAloudEnabled, setJourneySwanReadAloudEnabled] =
    useState(true);
  const journeySwanReadAloudRef = useRef(true);
  // R2: opening an asset temporarily unmounts JourneyPresentMode. Preserve the
  // learner's Swan guide AND conversation preference in the parent Journey
  // session, not in the replaceable media workspace.
  const [journeySwanPanelPreference, setJourneySwanPanelPreference] = useState({
    collapsed: true, conversationOpen: false,
  });
  // A child resuming a WonderLabs video takes audio focus away from Swan.
  // Suppress all late audio chunks for that same ask (not just the queue that
  // existed at the moment Play was pressed). Reset only on the next question.
  const journeyVideoInterruptedSpeechRef = useRef(false);
  const [journeyVideoPlaying, setJourneyVideoPlaying] = useState(false);
  // BDD 07/29/2026 - Journey workspace navigation.
  // Only a display cursor: retained while a Journey video/PWO takes over.
  // Reset on starting a different Journey; it is not stored in student answers.
  const wonderLabsActivityCursorRef = useRef({});
  // Review is only a viewing position; Continue Adventure retains this step
  // and the last persisted Activity/Part until the child progresses past it.
  const wonderLabsCheckpointStepRef = useRef(0);
  const wonderLabsReviewingRef = useRef(false);
  const [journeyStepIndex, setJourneyStepIndex] = useState(0);
  const [journeyVisitedThroughIndex, setJourneyVisitedThroughIndex] =
    useState(0);
  const [journeyActiveAsset, setJourneyActiveAsset] =
    useState(null);
  const [journeyMediaLaunchPending, setJourneyMediaLaunchPending] = useState(false);
  const journeyMediaLaunchRef = useRef(false);

  const [journeyRightTab, setJourneyRightTab] =
    useState("journey");

  const DEFAULT_JOURNEY_SESSION_STATE = {
    selectedArtworkId: null,
    observations: ["", "", ""],
    differentArtworkId: null,
    differenceReason: "",
    theory: "",
    steps: {},
  };

  const [journeySessionState, setJourneySessionState] =
    useState(() => ({ ...DEFAULT_JOURNEY_SESSION_STATE }));
  const [journeyPreviewStudent, setJourneyPreviewStudent] =
    useState(null);
  const [selectedJourneyStudentEmail, setSelectedJourneyStudentEmail] =
    useState("");
  const journeyStateHydratedRef = useRef(false);
  const journeySaveTimeoutRef = useRef(null);
  const lastSavedJourneyStateRef = useRef("");
  // R2.1 only: serialize WonderLabs R2 writes. The existing endpoint replaces
  // the entire state_json object, so overlapping PUTs could otherwise finish
  // out of order and silently roll back more recent evidence/navigation.
  // Ordinary Saras Journeys and the R1 fallback retain their existing path.
  const wonderLabsR2SaveTailRef = useRef(Promise.resolve());
  const wonderLabsR2SaveEpochRef = useRef(0);
  const queueWonderLabsR2Save = (journeyId, studentId, payload, stepId) => {
    const epoch = wonderLabsR2SaveEpochRef.current;
    const serialized = JSON.stringify(payload);
    const request = wonderLabsR2SaveTailRef.current.catch(() => {}).then(async () => {
      if (epoch !== wonderLabsR2SaveEpochRef.current) return;
      if (serialized === lastSavedJourneyStateRef.current) return;
      await axios.put(
        `${FASTAPI_BASE_URL}/student/${encodeURIComponent(studentId)}/journeys/${journeyId}/state`,
        { state_json: payload, last_active_step_id: stepId || null },
        authToken ? { headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        } } : undefined
      );
      if (epoch === wonderLabsR2SaveEpochRef.current) {
        lastSavedJourneyStateRef.current = serialized;
      }
    });
    // A rejected write must not permanently poison later retries, but the
    // individual caller still receives the rejection (especially on exit).
    wonderLabsR2SaveTailRef.current = request.catch(() => {});
    return request;
  };
  // This is display navigation, not experimental evidence or a new phase.
  // Persist it within the pre-existing per-journey session state.
  const recordWonderLabsR2ActivityCursor = useCallback((cursor, details = {}) => {
    if (!cursor || typeof cursor !== "object") return;
    if (wonderLabsDirectLaunchRef.current && details.intent === "review") {
      wonderLabsReviewingRef.current = true;
    }
    if (wonderLabsDirectLaunchRef.current && wonderLabsReviewingRef.current &&
        details.intent === "next") {
      const savedCursors = journeySessionState?.wonderlabs_activity_cursors;
      if (hasAdvancedPastCheckpoint({
        viewIndex: journeyStepIndex,
        checkpointIndex: wonderLabsCheckpointStepRef.current,
        stepId: details.stepId,
        savedCursors,
        viewCursors: cursor,
        activities: WONDERLABS_FLOW[details.stepId],
      })) {
        wonderLabsReviewingRef.current = false;
        wonderLabsCheckpointStepRef.current = Math.max(
          wonderLabsCheckpointStepRef.current, journeyStepIndex);
      }
    }
    // During review only the in-memory cursor changes. Evidence still saves,
    // but the server's saved resume cursor remains exactly where it was.
    if (wonderLabsDirectLaunchRef.current && wonderLabsReviewingRef.current) return;
    setJourneySessionState((previous) => {
      const nextCursor = copyActivityCursors(cursor);
      if (JSON.stringify(previous?.wonderlabs_activity_cursors) === JSON.stringify(nextCursor)) return previous;
      return { ...previous, wonderlabs_activity_cursors: nextCursor };
    });
  }, [journeySessionState?.wonderlabs_activity_cursors, journeyStepIndex]);
  const resumeJourneyPromptedForUserRef = useRef("");
  const resumeJourneyCheckInFlightRef = useRef(false);

  const hasMeaningfulJourneyState = useCallback((stateJson) => {
    if (!stateJson || typeof stateJson !== "object") return false;
    if (stateJson?.session_state?.wonderlabs_started === true) return true;

    const stepIndex = Number(stateJson?.step_index);
    const visitedThroughIndex = Number(stateJson?.visited_through_index);
    const sessionState = stateJson?.session_state;

    if (Number.isFinite(stepIndex) && stepIndex > 0) return true;
    if (Number.isFinite(visitedThroughIndex) && visitedThroughIndex > 0) return true;

    if (!sessionState || typeof sessionState !== "object") return false;

    const observations = Array.isArray(sessionState?.observations)
      ? sessionState.observations.some((value) => String(value || "").trim())
      : false;

    const hasStepEntries =
      sessionState?.steps &&
      typeof sessionState.steps === "object" &&
      Object.keys(sessionState.steps).length > 0;

    return Boolean(
      sessionState?.selectedArtworkId ||
      observations ||
      sessionState?.differentArtworkId ||
      String(sessionState?.differenceReason || "").trim() ||
      String(sessionState?.theory || "").trim() ||
      hasStepEntries
    );
  }, []);

  const [ttsStreamSpeaking, setTtsStreamSpeaking] = useState(false);

  const playNextTtsChunk = useCallback(() => {
    if (ttsPlayingRef.current) return;
    const next = ttsQueueRef.current.shift();
    if (!next) {
      setTtsStreamSpeaking(false);
      return;
    }
    setTtsStreamSpeaking(true);
    if (!ttsAudioRef.current) {
      ttsAudioRef.current = new Audio();
    }
    ttsPlayingRef.current = true;
    ttsAudioRef.current.src = next;
    ttsAudioRef.current.onended = () => {
      ttsPlayingRef.current = false;
      playNextTtsChunk();
    };
    ttsAudioRef.current.onerror = (err) => {
      console.warn("[tts-stream] audio playback error:", err);
      ttsPlayingRef.current = false;
      playNextTtsChunk();
    };
    ttsAudioRef.current.play().catch((err) => {
      console.warn("[tts-stream] audio play() rejected:", err);
      ttsPlayingRef.current = false;
      playNextTtsChunk();
    });
  }, []);

  const enqueueTtsChunk = useCallback((url) => {
    if (!url) return;
    ttsQueueRef.current.push(url);
    if (!ttsPlayingRef.current) {
      playNextTtsChunk();
    }
  }, [playNextTtsChunk]);

  const stopTtsStream = useCallback(() => {
    ttsQueueRef.current = [];
    if (ttsAudioRef.current) {
      try {
        ttsAudioRef.current.pause();
        ttsAudioRef.current.src = "";
      } catch {}
    }
    ttsPlayingRef.current = false;
    setTtsStreamSpeaking(false);
  }, []);

  useEffect(() => {
    journeySwanReadAloudRef.current = journeySwanReadAloudEnabled;
    if (!journeySwanReadAloudEnabled) stopTtsStream();
  }, [journeySwanReadAloudEnabled, stopTtsStream]);
  const updateJourneySwanReadAloud = useCallback((next) => {
    setJourneySwanReadAloudEnabled((previous) => {
      const resolved = typeof next === "function" ? next(previous) : Boolean(next);
      journeySwanReadAloudRef.current = resolved;
      if (!resolved) stopTtsStream();
      return resolved;
    });
  }, [stopTtsStream]);

  // Abort any in-flight stream on unmount to prevent state updates on unmounted component
  useEffect(() => {
    return () => {
      if (streamAbortControllerRef.current) {
        try { streamAbortControllerRef.current.abort(); } catch {}
        streamAbortControllerRef.current = null;
      }
      stopTtsStream();
    };
  }, [stopTtsStream]);

  const [videoDuration, setVideoDuration] = useState(null);
  // BDD 10/01/2026 - SBS 3D projector mode: browser-native <video> controls
  // cannot be targeted reliably while Pointer Lock owns the mouse, so SBS mode
  // exposes a small DOM control bar backed by these mirror states. Normal 2D is unchanged.
  const [sbs3dVideoPlaying, setSbs3dVideoPlaying] = useState(false);
  const [sbs3dVideoTime, setSbs3dVideoTime] = useState(0);
  const [sbs3dVideoDuration, setSbs3dVideoDuration] = useState(0);
  const [secureVideoUrl, setSecureVideoUrl] = useState("");
  // 🆕 Track which language we last used to fetch the collection 
  // BDD 12/09/2025 Localization For Collections
  const lastLangKeyForCollectionRef = useRef(null);

  // Initialize activeModule: use sessionStorage if available (page refresh), otherwise 'home' (fresh login)
  const [activeModule, setActiveModule] = useState(() => {
    // An explicit /wonderlabs link must win over a previous Saras tab saved
    // in this browser session, otherwise the Journey can open off-screen.
    if (typeof window !== 'undefined' &&
        getWonderLabsEntryRoute(window.location.pathname).isWonderLabs) return 'home';
    if (typeof window !== 'undefined' && window.sessionStorage) {
      const saved = sessionStorage.getItem('activeModule');
      // Only restore certain modules on refresh, not transient ones
      const restorableModules = ['home', 'learning', 'teacherDashboard', 'testQuestions'];
      if (saved && restorableModules.includes(saved)) {
        return saved;
      }
    }
    return 'home';
  }); // "home", "question", "video", "pwo", "whiteboard", "uploaded", "quiz", "teacherDashboard", "learning"

  // Teacher dashboard view toggle: "teacher" (default) or "student" (preview student home)
  const [teacherDashboardView, setTeacherDashboardView] = useState(() => {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      const saved = sessionStorage.getItem('teacherDashboardView');
      if (saved === 'teacher' || saved === 'student') return saved;
    }
    return 'teacher';
  });

  const [currentVideoId, setCurrentVideoId] = useState(null);
  const [currentVideoTagID, setCurrentVideoTagID] = useState(null);
  const [wonderLabsCaptionTracks, setWonderLabsCaptionTracks] = useState([]);
  const [currentPwoId, setCurrentPwoId] = useState(null);
  const [currentPwoScene, setCurrentPwoScene] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedResponse, setUploadedResponse] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [isNewDialog, setIsNewDialog] = useState(false);  // Tracks new chat state
  const [includeReference, setIncludeReference] = useState(true);
  const [loadingDots, setLoadingDots] = useState(0);

  const [isMuted, setIsMuted] = useState(true); // BDD 8/30/2025 - change default to speed AI response
  const [isDockMinimized, setIsDockMinimized] = useState(false); // Tablet dock collapse state

  // Onboarding state
  const { isCompleted: onboardingCompleted, isLoading: onboardingLoading } = useOnboarding();
  const { triggerWalkthrough } = useWalkthrough();
  const [showOnboarding, setShowOnboarding] = useState(false);

  // Check if onboarding should be shown
  useEffect(() => {
    if (Platform.OS === "web" && typeof window !== "undefined" &&
        getWonderLabsEntryRoute(window.location.pathname).isWonderLabs) {
      setShowOnboarding(false);
    } else if (!onboardingLoading && !onboardingCompleted) {
      setShowOnboarding(true);
    } else {
      setShowOnboarding(false);
    }
  }, [onboardingLoading, onboardingCompleted]);

  // Handle onboarding completion and start walkthrough
  const fetchStudentProfileRef = useRef(null);
  const handleOnboardingComplete = useCallback(() => {
    setShowOnboarding(false);
    // AIT-213: refresh profileData so the profile modal shows what was just saved.
    try { fetchStudentProfileRef.current?.(); } catch (e) { console.warn("[onboarding] profile refresh failed", e); }
    // Trigger walkthrough tour after a short delay
    setTimeout(() => {
      triggerWalkthrough();
    }, 300);
  }, [triggerWalkthrough]);

  const [question, setQuestion] = useState("");
  const [inputValue, setInputValue] = useState(""); // Local state for input box
  const [isVoiceInput, setIsVoiceInput] = useState(false);  // Tracks voice input

  // Add these state variables to your component
  // BDD 10/3/2025 - by doing activeSidebarTab defaut as collections, we are going to trigger collections view if the curriculumview is not set to 1
  // Secondary navigation for learning mode - controls which sub-page is shown
  // Values: "chat" | "analytics" | "engagement" | "tests" | "homework" | "modules"
  const [learningSubModule, setLearningSubModule] = useState(() => {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      const saved = sessionStorage.getItem('learningSubModule');
      const validSubs = ['chat', 'analytics', 'engagement', 'tests', 'homework', 'modules'];
      if (saved && validSubs.includes(saved)) {
        return saved;
      }
    }
    return "modules";
  });

  const [activeSidebarTab, setActiveSidebarTab] = useState(() => {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      const saved = sessionStorage.getItem('learningSubModule');
      if (saved === 'chat') return 'history';
    }
    return 'collections';
  }); // 'history' or 'collections'

  // Emphasize question bar when navigating from homescreen Ask AI button
  const [emphasizeQuestionBar, setEmphasizeQuestionBar] = useState(false);

  // Handler for secondary nav tab changes - syncs sidebar tab for chat/modules modes
  const handleLearningSubModuleChange = useCallback((subModule) => {
    setLearningSubModule(subModule);
    // Sync sidebar tab for modes that use the sidebar
    if (subModule === "chat") {
      setActiveSidebarTab("history");
    } else if (subModule === "modules") {
      setActiveSidebarTab("collections");
    }
  }, []);
  // const [profileFetched, setProfileFetched] = useState(false);            // NEW
  const initialSidebarSetRef = useRef(false);                             // NEW

  // States for learning path expansion
  const [expandedGrades, setExpandedGrades] = useState({});
  const [expandedSubjects, setExpandedSubjects] = useState({});
  const [expandedChapters, setExpandedChapters] = useState({});
  const [expandedTopics, setExpandedTopics] = useState({});
  // Track expansion state for Videos and PWOs separately inside topics
  const [expandedVideos, setExpandedVideos] = useState({});
  const [expandedPWOs, setExpandedPWOs] = useState({});

  // State to trigger refresh for the pre-signed urls
  const [imageExpiredTrigger, setImageExpiredTrigger] = useState(0);

  const [curriculum, setCurriculum] = useState([]);
  const [quizData, setQuiz] = useState({}); // Store fetched quiz data
  // State for storing user answers
  const [userAnswers, setUserAnswers] = useState({});
  const [answerFeedback, setAnswerFeedback] = useState({});
  const [showHints, setShowHints] = useState({});
  const [showSolutions, setShowSolutions] = useState({});

  const [assessments, setAssessments] = useState([]);
  const [engagementLogs, setEngagementLogs] = useState([]);
  const [engagementViewType, setEngagementViewType] = useState("daily"); // "daily" or "weekly"
  const [engagementHasMore, setEngagementHasMore] = useState(false);
  const [quizResponses, setQuizResponses] = useState({}); // Stores correct/wrong/unattempted answers
  const [totalQuestions, setTotalQuestions] = useState(10); // Adjust dynamically if needed
  const [attemptedQuestions, setAttemptedQuestions] = useState([]);;
  const [assessmentId, setAssessmentId] = useState(null);
  const [activeVideo, setActiveVideo] = useState(null);
  const [activePWO, setActivePWO] = useState(null);
  const [activeTopic, setActiveTopic] = useState(null);
  const pwoIframeRef = useRef(null);
  const [availableTests, setAvailableTests] = useState([]);
  const [upcomingTests, setUpcomingTests] = useState([]);
  const [myTestResults, setMyTestResults] = useState([]);

  // Summer Camp check-ins launched from the Home journey cards return Home
  // after a successful submission. All ordinary test launches keep the
  // existing return-to-Tests behavior.
  const testReturnTargetRef = useRef("tests");

  // BDD 08/30/2026 - Rev 1: a Video/PWO opened from completed exam review
  // should return to that same review when the asset closes. This preserves the
  // loaded test/result + AI conversation; exact review scroll position can be
  // added separately later without coupling it to asset routing.
  const examReviewAssetReturnRef = useRef(false);

  // const [activeTest, setActiveTest] = useState(null); // from startStudentTest



  const [aiNudge, setAiNudge] = useState("");
  const [adaptiveRecommendation, setAdaptiveRecommendation] = useState("");

  // Home screen state
  const [lastViewedTopic, setLastViewedTopic] = useState(null);
  const [learningResumeState, setLearningResumeState] = useState(null);
  const [curiosityResumeState, setCuriosityResumeState] = useState(null);
  const [streakDays, setStreakDays] = useState(0);
  const [weeklyActivity, setWeeklyActivity] = useState([]);

  // Teacher home screen state
  const [teacherHomeClassId, setTeacherHomeClassId] = useState(null);
  const [teacherHomeWeeks, setTeacherHomeWeeks] = useState(4);
  const [teacherHomeSummary, setTeacherHomeSummary] = useState(null);
  const [teacherHomeStudents, setTeacherHomeStudents] = useState([]);
  const [teacherHomeClasses, setTeacherHomeClasses] = useState([]);
  const [teacherHomeLoading, setTeacherHomeLoading] = useState(false);

  const [leaderboard, setLeaderboard] = useState([]);
  const [badges, setBadges] = useState([]);
  const [activeTest, setActiveTest] = useState(null);
  const [testQuestions, setTestQuestions] = useState([]);
  const [studentAnswers, setStudentAnswers] = useState({});
  const [testReadyToStart, setTestReadyToStart] = useState(false); // to show details and button
  const [activeSuggestedQuestion, setActiveSuggestedQuestion] = useState(null);
  const [tabSwitchCount, setTabSwitchCount] = useState(0);
  const tabSwitchDetectionEnabledRef = useRef(true);
  const tabSwitchFeatureEnabledRef = useRef(false); // 🔕 OFF by default

  const [clickCount, setClickCount] = useState(0);
  const [quizAttempts, setQuizAttempts] = useState(0);
  const clickCountRef = useRef(0);
  const quizAttemptsRef = useRef(0);
  // BDD 11/18/2025
  // NEW: richer engagement refs
  const timeActiveSecondsRef = useRef(0);   // accumulated active seconds
  const pwoLaunchesRef = useRef(0);         // number of PWOs opened
  const videoPlaysRef = useRef(0);          // number of videos played
  const aiQuestionsRef = useRef(0);         // number of AI questions asked
  const lastAiRewardTimeRef = useRef(0);

  // Inside your AITutorApp component (or header component)
  const navigation = useNavigation();
  // 1. Add states to track sidebar visibility and width
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [sidebarWidth, setSidebarWidth] = useState("20%"); // Left sidebar 20% (redesign: 20/40/40 split)
  const [isResizing, setIsResizing] = useState(false);
  // Right sidebar (SuggestionRail) draggable width
  const [rightSidebarWidth, setRightSidebarWidth] = useState(null); // null = use responsive default
  const [isResizingRight, setIsResizingRight] = useState(false);
  const resizeStartRightRef = useRef({ x: 0, wPx: 0 });

  // BDD 02/03/2026 student-practice-test-phase1
  const [myPracticeTests, setMyPracticeTests] = useState([]);
  // BDD 02/03/2026 student-practice-test-phase1
  const [practiceSubjectId, setPracticeSubjectId] = useState(null);
  const [practiceSubjectName, setPracticeSubjectName] = useState("");
  const [practiceTotal, setPracticeTotal] = useState(10);
  const [practiceMix, setPracticeMix] = useState("balanced");
  // BDD 02/03/2026 student-practice-test-phase1 - try4
  const [practiceSubjectKey, setPracticeSubjectKey] = useState("");
  const [practiceChapters, setPracticeChapters] = useState([]);
  const [practiceChapterMode, setPracticeChapterMode] = useState("all"); // "all" | "custom"
  const [practiceSelectedChapterIds, setPracticeSelectedChapterIds] = useState([]);
  const [practiceTitle, setPracticeTitle] = useState("");

  // BDD 02/12/2026 - debug/openpwo
  // Close-module re-entrancy guard + tiny debounce
  const closeInProgressRef = useRef(false);
  const lastCloseTimestampRef = useRef(0);
  const pwoBootSrcTimeoutId = useRef(null);

  // ========== PAGE ZOOM CONTROLS ==========
  const MIN_ZOOM = 0.5;
  const MAX_ZOOM = 2.0;
  const ZOOM_STEP = 0.1;
  const DEFAULT_ZOOM = 1.0;
  const ZOOM_STORAGE_KEY = "app_zoom_level";
  const [zoomLevel, setZoomLevel] = useState(DEFAULT_ZOOM);

  // BDD 02/16/2026 - test/healthCheckpwo
  const isHealthcheckEnabled = React.useMemo(() => {
    const fromFlags = !!(flags && (flags.healthcheck || flags.healthCheck));

    let fromUrl = false;
    if (Platform.OS === "web" && typeof window !== "undefined") {
      try {
        const qs = new URLSearchParams(window.location.search);
        const v =
          qs.get("healthCheck") ??
          qs.get("healthcheck") ??
          qs.get("ff_healthcheck") ??
          qs.get("ff_healthCheck");

        fromUrl = v === "1" || v === "true" || v === "yes";
      } catch {
        fromUrl = false;
      }
    }

    return fromFlags || fromUrl;
  }, [flags]);


  // Load saved zoom level on mount, or auto-detect for high-res (4K) screens
  useEffect(() => {
    if (typeof window === "undefined") return;

    // Auto-detect high-res screens on first visit or if user never manually changed zoom
    const savedZoom = localStorage?.getItem(ZOOM_STORAGE_KEY);
    const hasUserSetZoom = localStorage?.getItem("app_zoom_user_set") === "true";

    if (hasUserSetZoom && savedZoom) {
      // User explicitly set a zoom level — respect it
      const parsed = parseFloat(savedZoom);
      if (!isNaN(parsed) && parsed >= MIN_ZOOM && parsed <= MAX_ZOOM) {
        setZoomLevel(parsed);
        document.body.style.zoom = parsed;
      }
    } else {
      // Auto-detect: use CSS viewport width (already accounts for OS DPI scaling)
      const cssWidth = window.innerWidth || window.screen?.width || 0;
      console.log(`🔍 Auto-zoom detection: innerWidth=${window.innerWidth}, screen.width=${window.screen?.width}, devicePixelRatio=${window.devicePixelRatio}`);
      let autoZoom = null;
      if (cssWidth >= 3200) {
        // Very large CSS viewport — likely 4K with no/low OS scaling
        autoZoom = 1.5;
      } else if (cssWidth >= 2400) {
        // Large CSS viewport — likely 4K with moderate OS scaling
        autoZoom = 1.3;
      }
      if (autoZoom) {
        console.log(`🔍 Auto-zoom: applying ${autoZoom}x for viewport width ${cssWidth}px`);
        setZoomLevel(autoZoom);
        document.body.style.zoom = autoZoom;
        localStorage?.setItem(ZOOM_STORAGE_KEY, autoZoom.toString());
      } else if (savedZoom) {
        // Normal screen with previously saved zoom
        const parsed = parseFloat(savedZoom);
        if (!isNaN(parsed) && parsed >= MIN_ZOOM && parsed <= MAX_ZOOM) {
          setZoomLevel(parsed);
          document.body.style.zoom = parsed;
        }
      }
    }
  }, []);

  // Load last viewed topic from localStorage on mount
  useEffect(() => {
    if (typeof window !== "undefined" && window.localStorage) {
      try {
        const savedTopic = localStorage.getItem(LAST_TOPIC_KEY);
        if (savedTopic) {
          setLastViewedTopic(JSON.parse(savedTopic));
        }
      } catch (e) {
        console.error("Error loading last viewed topic:", e);
      }
    }
  }, []);

  // BDD 02/11/2026 - Let me know if I am running localhost or dev in frontend (nothing for prod)
  const host =
    (typeof window !== "undefined" && window.location?.hostname) ? window.location.hostname : "";
  // BDD 02/11/2026 - Let me know if I am running localhost or dev in frontend (nothing for prod)
  const debugBuildLabel =
    host.includes("localhost") ? "LOCAL" :
    host.includes("dev.") ? "DEV" :
    null; // ✅ PROD -> show nothing

  // Function to save last viewed topic
  const saveLastViewedTopic = useCallback((topic, chapterName, thumbnailUrl) => {
    if (!topic) return;
    const topicData = {
      title: topic.topicDisplayName || topic.topicName || topic.display_name || topic.name || "",
      chapterName: chapterName || "",
      progress: topic.progress || 0,
      thumbnailUrl: thumbnailUrl || "",
      topicId: topic.topicId || topic.id || "",
    };
    setLastViewedTopic(topicData);
    if (typeof window !== "undefined" && window.localStorage) {
      try {
        localStorage.setItem(LAST_TOPIC_KEY, JSON.stringify(topicData));
      } catch (e) {
        console.error("Error saving last viewed topic:", e);
      }
    }
  }, []);

  // Helper to force PWO iframe repaint after body zoom changes
  const forcePwoRepaint = () => {
    if (!pwoIframeRef.current) return;
    const iframe = pwoIframeRef.current;
    setTimeout(() => {
      if (!iframe) return;

      // Try multiple approaches to wake up Unity:

      // 1. Focus the iframe
      try {
        iframe.focus();
      } catch (e) { /* ignore */ }

      // 2. Dispatch resize event to main window (may propagate)
      try {
        window.dispatchEvent(new Event('resize'));
      } catch (e) { /* ignore */ }

      // 3. Nudge the iframe dimensions slightly to force reflow
      const origWidth = iframe.style.width;
      iframe.style.width = (PWO_NATIVE_WIDTH + 1) + 'px';
      requestAnimationFrame(() => {
        iframe.style.width = origWidth;
      });

      // 4. Try postMessage to Unity (common patterns)
      try {
        iframe.contentWindow?.postMessage({ type: "FOCUS" }, "*");
        iframe.contentWindow?.postMessage({ type: "WAKE" }, "*");
        iframe.contentWindow?.postMessage({ unity: "focus" }, "*");
      } catch (e) { /* cross-origin may block */ }
    }, 100);
  };

  const applyZoom = (level) => {
    if (typeof document !== "undefined") {
      document.body.style.zoom = level;
    }
    if (typeof window !== "undefined" && window.localStorage) {
      localStorage.setItem(ZOOM_STORAGE_KEY, level.toString());
    }
    // Force PWO iframe to repaint after body zoom change
    forcePwoRepaint();
  };

  const handleZoomIn = () => {
    const newZoom = Math.min(MAX_ZOOM, zoomLevel + ZOOM_STEP);
    const roundedZoom = Math.round(newZoom * 10) / 10;
    setZoomLevel(roundedZoom);
    applyZoom(roundedZoom);
    localStorage?.setItem("app_zoom_user_set", "true");
    // Refocus iframe to prevent Unity from pausing - do it immediately and after a frame
    pwoIframeRef.current?.focus();
    requestAnimationFrame(() => pwoIframeRef.current?.focus());
  };

  const handleZoomOut = () => {
    localStorage?.setItem("app_zoom_user_set", "true");
    const newZoom = Math.max(MIN_ZOOM, zoomLevel - ZOOM_STEP);
    const roundedZoom = Math.round(newZoom * 10) / 10;
    setZoomLevel(roundedZoom);
    applyZoom(roundedZoom);
    // Refocus iframe to prevent Unity from pausing - do it immediately and after a frame
    pwoIframeRef.current?.focus();
    requestAnimationFrame(() => pwoIframeRef.current?.focus());
  };

  const handleZoomReset = () => {
    setZoomLevel(DEFAULT_ZOOM);
    applyZoom(DEFAULT_ZOOM);
    // Refocus iframe to prevent Unity from pausing - do it immediately and after a frame
    pwoIframeRef.current?.focus();
    requestAnimationFrame(() => pwoIframeRef.current?.focus());
  };
  // ========== END PAGE ZOOM CONTROLS ==========

  const [devPrompt, setDevPrompt] = useState(""); // BDD 6/18/2025 DEBUG MODE
  const [devInstructions, setDevInstructions] = useState("");
  // const debugPromptMode = false; // BDD 6/18/2025 DEBUG MODE

  // Sidebar visibility is managed by UI interactions. (debug logs removed)

  const [profileModalVisible, setProfileModalVisible] = useState(false);

  // ===== Da Vinci 3-Day Challenge (science_center === "da_vinci" only) =====
  // challengeState: latest GET /davinci/challenge/state payload (or null).
  // challengeModal: when set, drives the day-complete / all-done overlay.
  const [challengeState, setChallengeState] = useState(null);
  const [challengeModal, setChallengeModal] = useState(null);
  // Lockdown intro ("Start 3-Day Challenge") — shown until the student starts.
  const [challengeIntroDismissed, setChallengeIntroDismissed] = useState(false);
  // AIT-275: explicit Close on the trail hub (in-memory; resets on reload).
  const [challengeHubClosed, setChallengeHubClosed] = useState(false);
  // Guards: avoid duplicate auto-routes and rapid double sync calls.
  const challengeAutoRoutedRef = useRef(false);
  const challengeSyncInFlightRef = useRef(false);
  const challengeSyncCooldownRef = useRef(0);
  // Tracks which user identity we've already bootstrapped state for, so the
  // mount fetch runs once per user (fetchWithAuth identity churn won't refetch).
  const challengeBootstrappedForRef = useRef(null);
  // Hold the latest handleCollectionClick so challenge callbacks (declared
  // before it) can route without a temporal-dead-zone reference.
  const handleCollectionClickRef = useRef(null);

  const [profileData, setProfileData] = useState({
    grade: "",
    age: "",
    passion: "",
    favorite_stem_subject: "",
    extracurricular_activity: "",
    preferred_learning_style: "",
  });
  // Inside your component...
  const webglReadyHandlerRef = useRef(null);
  const pwofallbackTimeoutId = useRef(null);
  const pwoInitTimeoutId = useRef(null);        // 3-second init setTimeout
  const pwoClickCancelledRef = useRef(false);   // cancellation guard for handlePWOClick
  const [isWebGLReady, setIsWebGLReady] = useState(false);
  const isWebGLReadyRef = useRef(false);
  // BDD for tile image based layout 6/16/2025
  const [pwoTopicMap, setPwoTopicMap] = useState({});
  const [videoTopicMap, setVideoTopicMap] = useState({});
  const [imageUrlMap, setImageUrlMap] = useState({});
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [quizCountMap, setQuizCountMap] = useState({}); // BDD 10/17/2025 - so that I can show quiz count in the new topicflat tile based layout
  const [quizInfoModal, setQuizInfoModal] = useState({ visible: false, item: null, loading: true, count: 0, bestCorrect: null, bestTotal: null, attempts: [] });
  // BDD 10/17/2025
  // ==== DEV LOGGING (no behavior changes) ====
  // flip this to false to silence logs
  const DEBUG_TILE_CONTENT = true;
  // BDD 10/17/2025
  // topicId -> { video: number, pwo: number, details?: { videos:[], pwos:[] } }
  const [chapterCounts, setChapterCounts] = React.useState({});
  // BDD TEMP CAUTION 10/17/2025 ==== TEMP: hide discovery widgets until wired up ====
  // const SHOW_DISCOVERY = false;
  const SHOW_DISCOVERY = !flags.club_mode; // BDD 11/16/2025

  const unauthorizedHandlerRef = useRef(null);
  const lastContextType = useRef(null);
  const [micError, setMicError] = useState(null);
  // AIT-249: quizMode now includes "quizReview" — a read-only review of a
  // just-submitted practice quiz (renders like pastTestView from in-memory
  // userAnswers + computed feedback, no extra fetch).
  const [quizMode, setQuizMode] = useState("quiz"); // "quiz" | "test" | "pastTestView" | "quizReview"
  // AIT-249: built at submit time for the deferred-feedback review screen.
  // Shape: { total, correct, wrong, unattempted, score, totalScore,
  //          perQuestion: { [qid]: { status, userAnswer, correctAnswer, solution, explanation } } }
  const [reviewSummary, setReviewSummary] = useState(null);
  const [quizNav, setQuizNav] = useState(null); // nav state from QuestionDisplay for fixed footer
  const [testTimeLeft, setTestTimeLeft] = useState(null); // In seconds
  const [testTimerActive, setTestTimerActive] = useState(false);

  // const [autoFetchReferences, setAutoFetchReferences] = useState(true); // BDD 11/12/2025 - handeled differently // BDD 11/7/2025
  // Always auto-fetch references after an answer (internal behavior)
  const autoFetchReferences = true;

  // const [restrictToRAGOnly, setRestrictToRAGOnly] = useState(false); // BDD 11/12/2025 - handeled differently // BDD 9/5/2025
  const [curriculumView, setCurriculumView] = useState(false); // BDD 9/14/2025
  const [autoPlayVideo, setAutoPlayVideo] = useState(false);
  const [autoOpenPWO, setAutoOpenPWO] = useState(false);
  const [autoSpeakAnswer, setAutoSpeakAnswer] = useState(true);
  const [autoWalkthroughMode, setAutoWalkthroughMode] = useState(false);
  const [walkthroughStep, setWalkthroughStep] = useState(null); // "pwo", "video", "quiz"
  const [walkthroughReferences, setWalkthroughReferences] = useState(null);
  // AIT-246: screen that was showing when an auto PWO/video opened from an AI
  // answer, so closing it returns there instead of a blank module.
  const autoOpenReturnRef = useRef(null);
  // AIT-246: always-current nav state for async callbacks (runAutoWalkthrough) that
  // would otherwise capture a stale closure. Assigned on every render, below the state.
  const navStateRef = useRef({});

  const auth = useAuth();
  const { updateSecondaryLang, selectedSecondaryLang, contentDb } = useAuth();  // ✅ Get token inside the component
  const { showNotification } = useNotification();
  const { showReward } = useReward();
  // # BDD 01/21/2026 - add_subscription_notifications_and_support
  const [supportModalVisible, setSupportModalVisible] = useState(false);
  const [knowledgeModalVisible, setKnowledgeModalVisible] = useState(false);
  // # BDD 01/21/2026 - add_subscription_notifications_and_support
  const [notificationsModalVisible, setNotificationsModalVisible] = useState(false);

  // Knowledge Tracing popup state
  const [ktPopupQuestion, setKtPopupQuestion] = useState(null);
  const [ktPopupVisible, setKtPopupVisible] = useState(false);
  const ktPopupVisibleRef = useRef(false);

  // KT popup preference (persisted in AsyncStorage)
  const [ktPopupDisabled, setKtPopupDisabled] = useState(false);
  const ktPopupDisabledRef = useRef(false);
  const ktPopupDisabledLoadedRef = useRef(false);
  const ktAutoDisableNotifiedRef = useRef(false);

  // Keep refs in sync with state for use in async callbacks (avoids stale closures)
  useEffect(() => { ktPopupVisibleRef.current = ktPopupVisible; }, [ktPopupVisible]);
  useEffect(() => { ktPopupDisabledRef.current = ktPopupDisabled; }, [ktPopupDisabled]);

  if (!auth) {
    console.error("⚠️ AuthContext is missing! Ensure AuthProvider wraps the app.");
    return <Text>⚠️ {t("Error: Authentication context is missing!")}</Text>;
  }

  const { authToken, user, logout, fetchWithAuth, } = auth; // BDD 10/3/2025 added fetchWithAuth
  const schoolName = (user?.school || "").trim().toLowerCase();
  const schoolKey = schoolName.replace(/[^a-z0-9]/g, "");
  const isDefaultSarasSchool = schoolKey === "saras3d";
  const hasSchool = !!user?.school_id;
  const hasPartner = !!user?.has_partner;
  const isRetailUser =
    !hasPartner &&
    !user?.is_institute_managed &&
    (!hasSchool || isDefaultSarasSchool) &&
    !user?.parent_email;
  const [dismissExpiryNotice, setDismissExpiryNotice] = useState(false);
  const expiryDaysLeft = useMemo(() => {
    if (!user?.access_end_date) return null;
    try {
      const end = new Date(String(user.access_end_date).slice(0, 10));
      if (Number.isNaN(end.getTime())) return null;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);
      return Math.ceil((end - today) / (1000 * 60 * 60 * 24));
    } catch {
      return null;
    }
  }, [user?.access_end_date]);
  const shouldShowExpiryNotice =
    isRetailUser &&
    !dismissExpiryNotice &&
    Number.isFinite(expiryDaysLeft) &&
    expiryDaysLeft >= 0 &&
    expiryDaysLeft <= 7;

  // WP7: restricted users are gated by the navigator in App.js (only UpgradePlan & co. are registered).
  // BDD 10/5/2025
  const { width, height } = useWindowDimensions();

  // BDD 10/01/2026 - SBS 3D projector mode (Phase 1C)
  // Single source of truth is frontend/app/features.js.
  // Enable for testing with ?ff_sbs3d=1; normal 2D behavior remains the default.
  const sbs3dProjectorMode = Platform.OS === "web" && flags?.sbs3d === true;
  // Phase 2B: Edge kiosk owns the full-screen window. AITutor keeps the same
  // SBS compositor, but must not layer the browser Fullscreen API on top.
  const sbs3dKioskMode =
    sbs3dProjectorMode && flags?.sbs3d_kiosk === true;

  const SBS3D_FILTER_ID = "saras-sbs3d-duplicate";
  const SBS3D_ROOT_ID = "saras-sbs3d-root";
  const [sbs3dSetupStarted, setSbs3dSetupStarted] = useState(false);
  const [sbs3dSetupComplete, setSbs3dSetupComplete] = useState(false);
  const [sbs3dPointerLocked, setSbs3dPointerLocked] = useState(false);
  const [sbs3dPwoCoverVisible, setSbs3dPwoCoverVisible] = useState(false);
  const [sbs3dPwoRecoveryVisible, setSbs3dPwoRecoveryVisible] = useState(false);
  const sbs3dCursorElRef = useRef(null);
  const sbs3dCursorPosRef = useRef({ x: 960, y: 540 });
  const sbs3dSavedDomStylesRef = useRef(null);
  const sbs3dPwoRevealTimerRef = useRef(null);

  const sbs3dPwoTakeover = sbs3dProjectorMode && showPwo;
  const sbs3dPwoHandoffMs = useMemo(() => {
    const configured = Number(flags?.sbs3d_pwo_handoff_ms ?? 2500);
    if (!Number.isFinite(configured)) return 2500;
    return Math.max(0, Math.min(10000, configured));
  }, [flags?.sbs3d_pwo_handoff_ms]);

  const beginSbs3dPwoCover = useCallback(() => {
    if (!sbs3dProjectorMode) return;
    if (sbs3dPwoRevealTimerRef.current) {
      clearTimeout(sbs3dPwoRevealTimerRef.current);
      sbs3dPwoRevealTimerRef.current = null;
    }
    console.log("[SBS3D] PWO safety cover ON");
    setSbs3dPwoCoverVisible(true);
  }, [sbs3dProjectorMode]);

  const scheduleSbs3dPwoReveal = useCallback(() => {
    if (!sbs3dProjectorMode) return;
    if (sbs3dPwoRevealTimerRef.current) {
      clearTimeout(sbs3dPwoRevealTimerRef.current);
    }
    console.log(`[SBS3D] PWO args sent; revealing Unity in ${sbs3dPwoHandoffMs} ms`);
    sbs3dPwoRevealTimerRef.current = setTimeout(() => {
      sbs3dPwoRevealTimerRef.current = null;
      console.log("[SBS3D] PWO safety cover OFF; revealing Unity");
      setSbs3dPwoCoverVisible(false);
    }, sbs3dPwoHandoffMs);
  }, [sbs3dProjectorMode, sbs3dPwoHandoffMs]);

  useEffect(() => {
    return () => {
      if (sbs3dPwoRevealTimerRef.current) {
        clearTimeout(sbs3dPwoRevealTimerRef.current);
        sbs3dPwoRevealTimerRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (!sbs3dProjectorMode || showPwo) return;
    if (sbs3dPwoRevealTimerRef.current) {
      clearTimeout(sbs3dPwoRevealTimerRef.current);
      sbs3dPwoRevealTimerRef.current = null;
    }
    setSbs3dPwoCoverVisible(false);
  }, [sbs3dProjectorMode, showPwo]);

  // Keep the logical cursor centered if the viewport changes before pointer-lock starts.
  useEffect(() => {
    if (!sbs3dProjectorMode || sbs3dPointerLocked) return;
    sbs3dCursorPosRef.current = {
      x: Math.max(0, width / 2),
      y: Math.max(0, height / 2),
    };
  }, [sbs3dProjectorMode, sbs3dPointerLocked, width, height]);

  // Save/restore DOM styles once for the whole SBS session.
  useEffect(() => {
    if (!sbs3dProjectorMode || Platform.OS !== "web" || typeof document === "undefined") return;

    const body = document.body;
    const html = document.documentElement;
    const root = document.getElementById(SBS3D_ROOT_ID);
    if (!body || !html || !root) return;

    sbs3dSavedDomStylesRef.current = {
      body: {
        transform: body.style.transform,
        transformOrigin: body.style.transformOrigin,
        width: body.style.width,
        height: body.style.height,
        filter: body.style.filter,
        WebkitFilter: body.style.WebkitFilter,
        overflow: body.style.overflow,
        cursor: body.style.cursor,
        background: body.style.background,
      },
      html: {
        overflow: html.style.overflow,
        background: html.style.background,
      },
      root: {
        transform: root.style.transform,
        transformOrigin: root.style.transformOrigin,
        width: root.style.width,
        height: root.style.height,
        filter: root.style.filter,
        WebkitFilter: root.style.WebkitFilter,
        overflow: root.style.overflow,
      },
    };

    return () => {
      const saved = sbs3dSavedDomStylesRef.current;
      if (!saved) return;
      Object.assign(body.style, saved.body);
      Object.assign(html.style, saved.html);
      Object.assign(root.style, saved.root);
    };
  }, [sbs3dProjectorMode]);

  // Normal AITutor in projector mode is rendered once, then duplicated by an
  // SVG reference filter. Phase 1A applied the filter to <body>; that allowed
  // visual overflow (especially the software cursor) to perturb the document's
  // horizontal raster/scroll extent. Keep the document itself fixed and apply
  // the SBS compositor only to the stable AITutor root. During PWO takeover the
  // root filter is removed because Unity supplies the complete packed SBS frame.
  useEffect(() => {
    if (!sbs3dProjectorMode || Platform.OS !== "web" || typeof document === "undefined") return;

    const body = document.body;
    const html = document.documentElement;
    const root = document.getElementById(SBS3D_ROOT_ID);
    if (!body || !html || !root) return;

    html.style.overflow = "hidden";
    html.style.background = "#000";
    body.style.width = "100vw";
    body.style.height = "100vh";
    body.style.background = "#000";
    body.style.overflow = "hidden";
    body.style.transform = "none";
    body.style.transformOrigin = "0 0";
    body.style.filter = "none";
    body.style.WebkitFilter = "none";

    root.style.width = "100vw";
    root.style.height = "100vh";
    root.style.transformOrigin = "0 0";

    if (sbs3dPwoTakeover) {
      root.style.transform = "none";
      root.style.filter = "none";
      root.style.WebkitFilter = "none";
      root.style.overflow = "hidden";
      // Unity normally owns the visible blue-ball cursor. If browser fullscreen
      // is escaped, expose the real system cursor so the recovery controls can
      // be clicked reliably instead of trying to align two cursor systems.
      body.style.cursor =
        !sbs3dKioskMode && sbs3dPwoRecoveryVisible ? "auto" : "none";
      return;
    }

    root.style.transform = "scaleX(0.5)";
    root.style.filter = `url(#${SBS3D_FILTER_ID})`;
    root.style.WebkitFilter = `url(#${SBS3D_FILTER_ID})`;
    root.style.overflow = "visible";
    body.style.cursor =
      sbs3dSetupComplete && sbs3dPointerLocked ? "none" : "auto";
  }, [
    sbs3dProjectorMode,
    sbs3dPwoTakeover,
    sbs3dSetupComplete,
    sbs3dPointerLocked,
    sbs3dPwoRecoveryVisible,
    sbs3dKioskMode,
  ]);

  const requestSbs3dFullscreen = useCallback(() => {
    if (sbs3dKioskMode) {
      // Edge --kiosk already owns the display. Calling requestFullscreen()
      // here would reintroduce browser-owned Esc/fullscreen UI that Phase 2B
      // deliberately removes.
      return null;
    }
    if (Platform.OS !== "web" || typeof document === "undefined") return null;
    const el = document.documentElement;
    try {
      if (!document.fullscreenElement && el?.requestFullscreen) {
        return el.requestFullscreen({ navigationUI: "hide" });
      }
    } catch {}
    return null;
  }, [sbs3dKioskMode]);

  const requestSbs3dPointerLock = useCallback(() => {
    if (Platform.OS !== "web" || typeof document === "undefined") return;
    const el = document.documentElement;
    try {
      if (document.pointerLockElement !== el && el?.requestPointerLock) {
        const result = el.requestPointerLock();
        if (result?.catch) result.catch(() => {});
      }
    } catch {}
  }, []);

  const releaseSbs3dPointer = useCallback(() => {
    if (Platform.OS !== "web" || typeof document === "undefined") return;
    try {
      if (document.pointerLockElement && document.exitPointerLock) {
        document.exitPointerLock();
      } else if (sbs3dKioskMode) {
      }
    } catch {}
  }, [sbs3dKioskMode]);

  const beginSbs3dSetup = useCallback(() => {
    requestSbs3dFullscreen();
    setSbs3dSetupStarted(true);
  }, [requestSbs3dFullscreen]);

  const continueSbs3dSetup = useCallback(() => {
    // A real click/Enter key gives the browser the user activation needed.
    requestSbs3dPointerLock();
    requestSbs3dFullscreen();
    setSbs3dSetupComplete(true);
  }, [requestSbs3dFullscreen, requestSbs3dPointerLock]);

  const resumeSbs3dPointer = useCallback(() => {
    requestSbs3dPointerLock();
    requestSbs3dFullscreen();
  }, [requestSbs3dFullscreen, requestSbs3dPointerLock]);

  const resumeSbs3dPwo = useCallback(() => {
    const focusUnity = () => {
      setSbs3dPwoRecoveryVisible(false);
      setTimeout(() => {
        try {
          pwoIframeRef.current?.focus?.();
        } catch {}
      }, 80);
    };

    if (sbs3dKioskMode) {
      focusUnity();
      return;
    }

    const result = requestSbs3dFullscreen();
    if (result?.then) {
      result.then(focusUnity).catch(() => {
        setSbs3dPwoRecoveryVisible(true);
      });
    } else {
      focusUnity();
    }
  }, [requestSbs3dFullscreen, sbs3dKioskMode]);

  // When Unity takes over, release browser pointer-lock so the existing Unity
  // blue-ball / interaction system owns mouse movement. On close, AITutor shows
  // a small SBS-safe "resume" overlay so pointer-lock can be reacquired by a
  // fresh user gesture.
  useEffect(() => {
    if (!sbs3dProjectorMode || Platform.OS !== "web" || typeof document === "undefined") return;
    if (!sbs3dPwoTakeover) return;
    try {
      if (document.pointerLockElement && document.exitPointerLock) {
        document.exitPointerLock();
      }
    } catch {}
  }, [sbs3dProjectorMode, sbs3dPwoTakeover]);

  // PWO uses Unity's own cursor/input while fullscreen is intact. Esc always
  // exits browser fullscreen, so detect that transition and place browser-owned
  // SBS-safe recovery controls above Unity. This is deliberately independent of
  // Pointer Lock; Unity does not use AITutor's relative-motion cursor.
  useEffect(() => {
    if (!sbs3dProjectorMode || Platform.OS !== "web" || typeof document === "undefined") return;
    if (sbs3dKioskMode) {
      // Kiosk fullscreen is owned by Edge, not document.fullscreenElement.
      // Treating fullscreenElement===null as a loss would be a false positive.
      setSbs3dPwoRecoveryVisible(false);
      return;
    }

    const syncPwoFullscreenState = () => {
      if (!sbs3dPwoTakeover) {
        setSbs3dPwoRecoveryVisible(false);
        return;
      }

      const fullscreenActive = !!document.fullscreenElement;
      if (!fullscreenActive) {
        console.log("[SBS3D] PWO fullscreen lost; showing recovery controls");
        setSbs3dPwoRecoveryVisible(true);
      } else {
        setSbs3dPwoRecoveryVisible(false);
      }
    };

    document.addEventListener("fullscreenchange", syncPwoFullscreenState);
    syncPwoFullscreenState();

    return () => {
      document.removeEventListener("fullscreenchange", syncPwoFullscreenState);
    };
  }, [sbs3dProjectorMode, sbs3dPwoTakeover, sbs3dKioskMode]);

  // Virtual cursor + click routing for the single authoritative AITutor DOM.
  useEffect(() => {
    if (!sbs3dProjectorMode || Platform.OS !== "web" || typeof document === "undefined") return;

    const html = document.documentElement;
    const updateLockState = () => {
      const locked = document.pointerLockElement === html;
      setSbs3dPointerLocked(locked);
      if (locked) {
          }
    };

    const moveCursor = (event) => {
      if (
        !sbs3dSetupComplete ||
        sbs3dPwoTakeover ||
        document.pointerLockElement !== html
      ) return;

      const pos = sbs3dCursorPosRef.current;
      // The rendered AITutor image is compressed 2:1 horizontally, so use 2x
      // horizontal mouse movement to keep perceived pointer speed natural.
      // Keep the cursor's full logical glyph inside the source eye. This also
      // prevents transformed visual overflow from ever widening the SBS source.
      pos.x = Math.max(0, Math.min(Math.max(0, width - 40), pos.x + (event.movementX || 0) * 2));
      pos.y = Math.max(0, Math.min(Math.max(0, height - 50), pos.y + (event.movementY || 0)));

      const cursor = sbs3dCursorElRef.current;
      if (cursor) {
        cursor.style.transform = `translate(${pos.x}px, ${pos.y}px)`;
      }
    };

    const getVirtualTarget = () => {
      const pos = sbs3dCursorPosRef.current;
      // The authoritative DOM occupies the physical left half after scaleX(.5).
      return document.elementFromPoint(pos.x * 0.5, pos.y);
    };

    const routeClick = (event) => {
      if (
        !sbs3dSetupComplete ||
        sbs3dPwoTakeover ||
        document.pointerLockElement !== html
      ) return;

      event.preventDefault();
      event.stopPropagation();

      let target = getVirtualTarget();
      if (!target) return;

      // Native <video controls> live in browser shadow UI, so elementFromPoint
      // cannot target play/seek sub-controls while Pointer Lock is active. SBS
      // mode therefore routes clicks on our explicit seek surface directly.
      const seekSurface = target.closest?.('[data-sbs3d-video-seek="1"]');
      if (seekSurface && videoRef.current) {
        const rect = seekSurface.getBoundingClientRect();
        const physicalX = sbs3dCursorPosRef.current.x * 0.5;
        const ratio = rect.width > 0
          ? Math.max(0, Math.min(1, (physicalX - rect.left) / rect.width))
          : 0;
        const duration = Number(videoRef.current.duration || sbs3dVideoDuration || 0);
        if (Number.isFinite(duration) && duration > 0) {
          videoRef.current.currentTime = duration * ratio;
          setSbs3dVideoTime(videoRef.current.currentTime || duration * ratio);
        }
        return;
      }

      // Clicking the video picture itself is a convenient SBS play/pause target.
      if (target.tagName === "VIDEO" && videoRef.current) {
        try {
          if (videoRef.current.paused) {
            const result = videoRef.current.play();
            if (result?.catch) result.catch(() => {});
          } else {
            videoRef.current.pause();
          }
        } catch {}
        return;
      }

      const actionable =
        target.closest?.(
          'button, a, input, textarea, select, [role="button"], [role="link"], [tabindex]'
        ) || target;

      try {
        if (typeof actionable.focus === "function") {
          actionable.focus({ preventScroll: true });
        }
      } catch {
        try { actionable.focus?.(); } catch {}
      }

      try {
        if (typeof actionable.click === "function") {
          actionable.click();
        } else {
          actionable.dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window,
            })
          );
        }
      } catch (error) {
        console.warn("[SBS3D] virtual click routing failed", error);
      }
    };

    const routeWheel = (event) => {
      if (
        !sbs3dSetupComplete ||
        sbs3dPwoTakeover ||
        document.pointerLockElement !== html
      ) return;

      const target = getVirtualTarget();
      if (!target) return;

      let node = target;
      while (node && node !== document.body && node !== document.documentElement) {
        try {
          const style = window.getComputedStyle(node);
          const canScrollY =
            /(auto|scroll)/.test(style.overflowY || "") &&
            node.scrollHeight > node.clientHeight;
          const canScrollX =
            /(auto|scroll)/.test(style.overflowX || "") &&
            node.scrollWidth > node.clientWidth;

          if (canScrollY || canScrollX) {
            event.preventDefault();
            if (canScrollY) node.scrollTop += event.deltaY;
            if (canScrollX) node.scrollLeft += event.deltaX || (event.shiftKey ? event.deltaY : 0);
            return;
          }
        } catch {}
        node = node.parentElement;
      }
    };

    document.addEventListener("pointerlockchange", updateLockState);
    document.addEventListener("mousemove", moveCursor, true);
    document.addEventListener("mousedown", routeClick, true);
    document.addEventListener("wheel", routeWheel, { capture: true, passive: false });
    updateLockState();

    return () => {
      document.removeEventListener("pointerlockchange", updateLockState);
      document.removeEventListener("mousemove", moveCursor, true);
      document.removeEventListener("mousedown", routeClick, true);
      document.removeEventListener("wheel", routeWheel, true);
    };
  }, [
    sbs3dProjectorMode,
    sbs3dSetupComplete,
    sbs3dPwoTakeover,
    sbs3dVideoDuration,
    width,
    height,
  ]);

  // Mirror the real <video> element into SBS-safe UI state. Native browser video
  // controls are disabled only in SBS mode; normal AITutor video behavior is untouched.
  useEffect(() => {
    if (!sbs3dProjectorMode || !showVideo || Platform.OS !== "web") return;
    const video = videoRef.current;
    if (!video) return;

    const sync = () => {
      setSbs3dVideoPlaying(!video.paused && !video.ended);
      setSbs3dVideoTime(Number(video.currentTime || 0));
      const d = Number(video.duration || 0);
      setSbs3dVideoDuration(Number.isFinite(d) ? d : 0);
    };

    ["play", "pause", "timeupdate", "durationchange", "loadedmetadata", "ended", "seeked"].forEach((name) =>
      video.addEventListener(name, sync)
    );
    sync();

    return () => {
      ["play", "pause", "timeupdate", "durationchange", "loadedmetadata", "ended", "seeked"].forEach((name) =>
        video.removeEventListener(name, sync)
      );
    };
  }, [sbs3dProjectorMode, showVideo, currentVideoId]);

  const toggleSbs3dVideoPlayback = useCallback(() => {
    const video = videoRef.current;
    if (!video) return;
    try {
      if (video.paused || video.ended) {
        const result = video.play();
        if (result?.catch) result.catch(() => {});
      } else {
        video.pause();
      }
    } catch {}
  }, []);

  const formatSbs3dVideoTime = useCallback((value) => {
    const total = Math.max(0, Math.floor(Number(value) || 0));
    const minutes = Math.floor(total / 60);
    const seconds = String(total % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  }, []);

  // Keyboard support makes the projector setup/recovery usable even before the
  // duplicated software cursor is active.
  useEffect(() => {
    if (!sbs3dProjectorMode || Platform.OS !== "web" || typeof window === "undefined") return;

    const onKeyDown = (event) => {
      const key = String(event.key || "").toLowerCase();

      // Teacher escape hatch for multi-monitor kiosk setups. This releases only
      // Pointer Lock; Edge stays in kiosk and the SBS framebuffer remains valid.
      if (
        sbs3dKioskMode &&
        !sbs3dPwoTakeover &&
        event.ctrlKey &&
        event.altKey &&
        key === "m"
      ) {
        event.preventDefault();
        event.stopPropagation();
        releaseSbs3dPointer();
        return;
      }

      if (event.key !== "Enter") return;

      if (!sbs3dSetupStarted) {
        event.preventDefault();
        beginSbs3dSetup();
        return;
      }

      if (!sbs3dSetupComplete) {
        event.preventDefault();
        continueSbs3dSetup();
        return;
      }

      if (sbs3dPwoTakeover && sbs3dPwoRecoveryVisible) {
        event.preventDefault();
        resumeSbs3dPwo();
        return;
      }

      if (!sbs3dPwoTakeover && !sbs3dPointerLocked) {
        event.preventDefault();
        resumeSbs3dPointer();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [
    sbs3dProjectorMode,
    sbs3dSetupStarted,
    sbs3dSetupComplete,
    sbs3dPwoTakeover,
    sbs3dPwoRecoveryVisible,
    sbs3dPointerLocked,
    beginSbs3dSetup,
    continueSbs3dSetup,
    resumeSbs3dPointer,
    resumeSbs3dPwo,
    releaseSbs3dPointer,
    sbs3dKioskMode,
  ]);
  const responsiveRailWidth = getResponsiveRailWidth(width); // Responsive rail width for browser zoom
  const showSuggestionRail = responsiveRailWidth > 0; // Hide rail at narrow viewports (< 960px)
  // Responsive content padding for browser zoom support (more aggressive)
  const getResponsiveContentPadding = (viewportWidth) => {
    if (viewportWidth < 960) return 4;   // Minimal spacing
    if (viewportWidth < 1280) return 4;  // Tighter spacing
    if (viewportWidth < 1536) return 6;  // Reduced spacing
    return 8;                             // Normal spacing (down from 10)
  };
  const responsiveContentPadding = getResponsiveContentPadding(width);

  // Responsive left sidebar width for browser zoom support (redesign: 20% target)
  const getResponsiveSidebarWidth = (viewportWidth) => {
    if (viewportWidth < 1100) return "85%"; // Overlay mode (increased threshold)
    if (viewportWidth < 1280) return "14%"; // Very compact
    if (viewportWidth < 1536) return "16%"; // Compact
    return "20%";                            // Normal (redesign: 20/40/40 split)
  };
  const responsiveSidebarWidth = getResponsiveSidebarWidth(width);
  // Responsive video max-height for browser zoom support
  // Subtracts header (~60px) and bottom dock (~80px) from viewport height
  const getResponsiveVideoMaxHeight = (viewportHeight, viewportWidth) => {
    // At higher zoom (smaller effective viewport), reduce max-height slightly more
    if (viewportWidth < 960) return viewportHeight - 76;   // High zoom
    if (viewportWidth < 1280) return viewportHeight - 74;   // Medium zoom
    if (viewportWidth < 1536) return viewportHeight - 72;   // Low zoom
    return viewportHeight - 70;                              // No zoom
  };
  const responsiveVideoMaxHeight = getResponsiveVideoMaxHeight(height, width);
  const SHEET_MAX_WIDTH = 520;         // narrower, modern width on big screens
  const BOTTOM_BAR_HEIGHT = 56;        // adjust if your bottom tab bar is taller
  // put near top of the component (outside JSX)
  // raise the stripe above the dock by ~60px
  const LOADER_NUDGE = 10; // BDD 10/5/2025

  const bottomSafePad = Platform.OS === "web" ? 16 : 24;
  const sheetBottomPadding = bottomSafePad + BOTTOM_BAR_HEIGHT;
  const isNarrow = width < 480;
  const sparksCacheRef = useRef(new Map()); // key: collectionId, val: string[]
  const [sparkTopicId, setSparkTopicId] = useState(null);
  // last-activity state // BDD 10/5/20225
  const [lastActivity, setLastActivity] = useState(null);

  // Responsive tile wrapper style: full width on mobile, two-column on tablet, fixed on desktop
  // Responsive tile wrapper: 1 col mobile, 2 col tablet, fixed on desktop
  const tileWrapperWidthStyle = width < 768 ? { width: "100%" } : (width < 1024 ? { width: "48%" } : { width: 280 });

  // Auto-minimize dock when entering mobile or tablet range
  const prevWidthRangeRef = useRef(null);
  useEffect(() => {
    const isCollapsible = width <= TABLET_BREAKPOINT; // mobile + tablet
    const currentRange = width < 768 ? 'mobile' : width <= TABLET_BREAKPOINT ? 'tablet' : 'desktop';

    // Auto-minimize when entering collapsible range (mobile or tablet) from desktop
    if (prevWidthRangeRef.current === 'desktop' && isCollapsible) {
      setIsDockMinimized(true);
    }

    // Also auto-minimize when transitioning between mobile and tablet
    if (prevWidthRangeRef.current !== null && prevWidthRangeRef.current !== currentRange && isCollapsible) {
      setIsDockMinimized(true);
    }

    // Reset to expanded when going to desktop
    if (currentRange === 'desktop' && prevWidthRangeRef.current !== 'desktop') {
      setIsDockMinimized(false);
    }

    prevWidthRangeRef.current = currentRange;
  }, [width]);

  // Number of cards to show initially (before "View All")
  const INITIAL_CARDS_TO_SHOW = 8;

  // State for expanded topic view
  const [showAllTopics, setShowAllTopics] = useState(false);

  // Responsive tile card sizing (for 160px fixed tiles used in curriculum trees)
  const tileSize160 = width < 768 ? { width: "48%", minHeight: 120 } : (width < 1024 ? { width: "45%", minHeight: 110 } : { width: 160 });
  // --- Answer style: "concise" | "detailed"
  const [answerStyle, setAnswerStyle] = useState("concise");
  // BDD 10/17/2025
  // --- View mode: "collections" | "curriculum"
  // BDD 01/18/2026 - Initialize from sessionStorage to remember user's last selection
  const userHasSavedPreferenceRef = useRef(false);
  const [viewMode, setViewMode] = useState(() => {
    try {
      // Try to load from sessionStorage first (web-compatible)
      if (typeof window !== 'undefined' && window.sessionStorage) {
        const saved = window.sessionStorage.getItem("view_mode");
        if (saved === "collections" || saved === "curriculum") {
          userHasSavedPreferenceRef.current = true;
          return saved;
        }
      }
    } catch (e) {
      // Silent fail
    }
    return "collections"; // Default fallback
  });

  // BDD 01/15/2026 - Summarize this topic AI ask
  const activeTopicForAIRef = React.useRef(null);
  const lastTopicScopeKeyRef = React.useRef(null);
  // BDD 01/15/2026 - Summarize this topic AI ask
  const [suggestedQuestionsMeta, setSuggestedQuestionsMeta] = React.useState({
    kind: null,        // "topic" | "chat" | null
    topicScope: null,  // object | null
  });
  const [boardToSourceTopicMap, setBoardToSourceTopicMap] = useState({});
  
  // BDD 01/18/2026 - Persist viewMode to sessionStorage whenever it changes
  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        window.sessionStorage.setItem("view_mode", viewMode);
      }
      // Also try AsyncStorage as fallback for React Native
      AsyncStorage.setItem("view_mode", viewMode).catch(() => { });
    } catch (e) {
      // Silent fail
    }
    // Keep curriculumView in sync with viewMode
    setCurriculumView(viewMode === "curriculum");
  }, [viewMode]);

  // BDD 02/08/2026 - derive skip_translate_for_ref from language selection
  const shouldSkipTranslateForRef = () => {
     const lang = String(selectedSecondaryLang || "en").toLowerCase().trim();
     // Only skip translation for English variants
     return (lang === "en" || lang === "en-in" || lang.startsWith("en-"));
  };


  const user_id = user ? user.email : "Guest";
  const activeJourneyStudentId =
    String(journeyPreviewStudent?.email || user_id || "").trim();
  const isPreviewingStudentJourney =
    Boolean(journeyPreviewStudent?.email) &&
    String(journeyPreviewStudent.email).trim().toLowerCase() !==
      String(user_id || "").trim().toLowerCase();
  // console.log("User ID:", user_id);
  // console.log("Auth Token:", authToken);


  // Function to fetch resume states from API
  const fetchResumeStates = useCallback(async () => {
    if (!user_id || user_id === "Guest") return;
    try {
      const lang = resolveCurriculumLang(selectedSecondaryLang);
      const [learningResp, curiosityResp] = await Promise.all([
        axios.get(`${FASTAPI_BASE_URL}/resume_state`, {
          params: { workspace: "LEARNING", user_id: user_id, lang },
          timeout: 15000,
        }).catch(() => ({ data: { resume_state: null } })),
        axios.get(`${FASTAPI_BASE_URL}/resume_state`, {
          params: { workspace: "CURIOSITY_AI", user_id: user_id, lang },
          timeout: 15000,
        }).catch(() => ({ data: { resume_state: null } })),
      ]);
      console.log("[resume_states] fetched - learning:", learningResp?.data?.resume_state, "curiosity:", curiosityResp?.data?.resume_state);
      setLearningResumeState(learningResp?.data?.resume_state || null);
      setCuriosityResumeState(curiosityResp?.data?.resume_state || null);
    } catch (e) {
      console.warn("[resume_states] fetch failed:", e?.message);
    }
  }, [user_id, selectedSecondaryLang]);

  // Fetch resume states when user logs in
  useEffect(() => {
    fetchResumeStates();
  }, [fetchResumeStates]);

  // Refresh resume states when returning to home screen
  const prevActiveModuleRef = useRef(activeModule);
  useEffect(() => {
    // Only fetch when transitioning TO home, not on every render while on home
    if (activeModule === "home" && prevActiveModuleRef.current !== "home" && user_id && user_id !== "Guest") {
      fetchResumeStates();
    }
    prevActiveModuleRef.current = activeModule;
  }, [activeModule, user_id, fetchResumeStates]);
  // 🔹 Expanded Language List (OpenAI + Gujarati + Telugu)
  // const languages = [
  //     { id: "auto", name: "Auto Detect" },
  //     // { id: "en-US", name: "English-USA" },
  //     // { id: "en-IN", name: "English-India" },
  //     { id: "en", name: "English" },
  //     { id: "es", name: "Spanish" },
  //     { id: "hi", name: "Hindi" },
  //     { id: "fr", name: "French" },
  //     { id: "zh", name: "Chinese (Simplified)" },
  //     { id: "ja", name: "Japanese" },
  //     { id: "ko", name: "Korean" },
  //     { id: "de", name: "German" },
  //     { id: "it", name: "Italian" },
  //     { id: "ru", name: "Russian" },
  //     { id: "ar", name: "Arabic" },
  //     { id: "gu", name: "Gujarati" },  // ✅ Added
  //     { id: "te", name: "Telugu" },  // ✅ Added
  //     { id: "mr", name: "Marathi" },  // ✅ Added
  //     // { id: "pt-BR", name: "Portuguese-Brazil" }, // ✅ Added
  //     // { id: "pt-PT", name: "Portuguese-Portugal" }  // ✅ Added
  //     { id: "pt", name: "Portuguese" }  // ✅ Added
  // ];

  const languages = [
    { id: "auto", name: "Auto Detect" },
    // { id: "en", name: "English – English" },
    // BDD 12/31/2025 - Choice of EN - IN and EN - US
    { id: "en", name: "English (US) – English" },     // implied EN-US
    { id: "en-in", name: "English (India) – English" }, // NEW: EN-IN
    { id: "es", name: "Spanish – Español" },
    { id: "hi", name: "Hindi – हिन्दी" },
    { id: "fr", name: "French – Français" },
    { id: "zh", name: "Chinese (Simplified) – 简体中文" },
    { id: "ja", name: "Japanese – 日本語" },
    { id: "ko", name: "Korean – 한국어" },
    { id: "de", name: "German – Deutsch" },
    { id: "it", name: "Italian – Italiano" },
    { id: "ru", name: "Russian – Русский" },
    { id: "ar", name: "Arabic – العربية" },
    { id: "gu", name: "Gujarati – ગુજરાતી" },
    { id: "te", name: "Telugu – తెలుగు" },
    { id: "mr", name: "Marathi – मराठी" },
    { id: "pt", name: "Portuguese – Português" },
  ];
  const [menuVisible, setMenuVisible] = useState(false);
  const [hamburgerMenuOpen, setHamburgerMenuOpen] = useState(false);

  // Breakpoint constants for responsive hamburger menus
  const isTeacher = user?.can_use_teacher_tools ?? canUseTeacherTools(user?.role);
  // Responsive cascade for teacher header: labels visible → icons only → hamburger
  const HEADER_COLLAPSE_WIDTH_LEFT = 1000; // Left nav hamburger breakpoint (icons collapse to menu)
  const HEADER_COLLAPSE_WIDTH_RIGHT = 1100; // Right nav hamburger breakpoint
  // HEADER_HIDE_LABELS_WIDTH (intermediate breakpoint: hide teacher nav
  // labels before collapsing to hamburger) is derived from the visible pill
  // count once lessonPlanEnabled/learningLoopEnabled are known — see below.
  const CLASS_BADGE_HIDE_WIDTH = 500;
  const CLASS_BADGE_MOVE_TO_CENTER_WIDTH = 1300;

  // Dynamic breakpoints that account for zoom level
  const effectiveCollapseWidthLeft = HEADER_COLLAPSE_WIDTH_LEFT * zoomLevel;
  const effectiveCollapseWidthRight = HEADER_COLLAPSE_WIDTH_RIGHT * zoomLevel;
  const effectiveClassBadgeHideWidth = CLASS_BADGE_HIDE_WIDTH * zoomLevel;
  const effectiveClassBadgeMoveWidth = CLASS_BADGE_MOVE_TO_CENTER_WIDTH * zoomLevel;
  const [languageModal, setLanguageModal] = useState(false);
  const [selectedPrimaryLang, setSelectedPrimaryLang] = useState("auto");
  // 🔄 Ref to store screenshot promise resolver
  const screenshotPromiseResolverRef = useRef(null);
  const [suggestedQuestions, setSuggestedQuestions] = useState([]);
  const [suggestedQuestionsHeader, setSuggestedQuestionsHeader] = useState([]);
  // Stores the context from the last AI answer so we can re-fetch suggestions
  // in the new language when the user switches language mid-session.
  const lastSuggestionsContextRef = useRef(null);

  // When language changes, re-fetch suggestions in the new language.
  // PWO questions are re-fetched via fetchCollectionSuggestedQuestions (they
  // use translated default strings that must be rebuilt with the new t() values).
  // Regular post-answer suggestions are re-fetched via fetchSuggestedQuestions.
  useEffect(() => {
    setSuggestedQuestions([]);
    setSuggestedQuestionsHeader([]);
    if (isPwoOpen && lastPwoSuggestionsContextRef.current) {
      const defaultPwoHeader = t("Explore and experiment with this PWO:");
      const defaultPwoQuestions = [
        t("What is this Play With Object (PWO)?"),
        t("How do I interact with this Play With Object (PWO)?"),
        t("Explain the concepts shown here."),
      ];
      lastPwoSuggestionsContextRef.current = { kind: "pwo", defaultPwoHeader, defaultPwoQuestions };
      fetchCollectionSuggestedQuestions("pwo", defaultPwoHeader, defaultPwoQuestions);
    } else if (lastSuggestionsContextRef.current) {
      fetchSuggestedQuestions(lastSuggestionsContextRef.current).then((raw) => {
        if (Array.isArray(raw) && raw.length > 0) {
          setSuggestedQuestions(raw.filter(Boolean));
        }
      }).catch(() => {});
    }
  }, [selectedSecondaryLang]);

  // BDD 02/15/2026 - test/healthCheckpwo
  // ===== PWO Healthcheck mode =====
  const pwoHealthcheckModeRef = useRef(false);
  // BDD 02/15/2026 - test/healthCheckpwo
  // During healthcheck, force “cold boot / non-investor” path even if investor_mode flag is true
  const pwoForceColdBootRef = useRef(false);

  // BDD 02/15/2026 - test/healthCheckpwo - start
  // ===== Internal PWO Healthcheck Runner =====
  const [pwoQaVisible, setPwoQaVisible] = useState(false);
  const [pwoQaRunning, setPwoQaRunning] = useState(false);
  const [pwoQaPaused, setPwoQaPaused] = useState(false);
  const [pwoQaItems, setPwoQaItems] = useState([]);        // [{pwoID, sceneName, title}]
  const [pwoQaIndex, setPwoQaIndex] = useState(0);
  const [pwoQaResults, setPwoQaResults] = useState([]);    // result rows
  // const [pwoQaMaxItems, setPwoQaMaxItems] = useState(200); // default subset to start
  const [pwoQaMaxItems, setPwoQaMaxItems] = useState(2000); // default subset to start

  const pwoQaAbortRef = useRef(false);
  const pwoQaActiveRef = useRef(null);
  const pwoQaLastErrorRef = useRef(null);

  const PWO_QA_READY_TIMEOUT_MS = 120000; // wait for WEBGL_READY
  const PWO_QA_STABILITY_MS = 12000;      // wait after args sent
  const PWO_QA_BETWEEN_MS = 6000;
  const PWO_QA_HARD_REFRESH_EVERY = 30;
  // BDD 02/15/2026 - test/healthCheckpwo
  const PWO_QA_POST_READY_WAIT_MS = 65000; // time-based "let it finish loading" (50-60s)
  // IMPORTANT: state values get "captured" in async loops; use a ref for pause
  const pwoQaPausedRef = useRef(false);
  useEffect(() => {
    pwoQaPausedRef.current = pwoQaPaused;
  }, [pwoQaPaused]);

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  // const sleep = (ms) => new Promise(r => setTimeout(r, ms));

  // BDD 02/15/2026 - test/healthCheckpwo
  const [pwoQaSubjectId, setPwoQaSubjectId] = useState(""); // selected subject to run
  const [pwoQaSubjectOptions, setPwoQaSubjectOptions] = useState([]); // [{ id, label }]


  // BDD 02/15/2026 - test/healthCheckpwo - endt

  // BDD 02/20/2026 - PWO QA - Grade scope test/healthCheckpwo - start
  const [pwoQaGradeId, setPwoQaGradeId] = useState("");          // selected level.id
  const [pwoQaGradeOptions, setPwoQaGradeOptions] = useState([]); // [{id,label}]
  const [pwoQaGradeRunning, setPwoQaGradeRunning] = useState(false);
  // BDD 02/20/2026 smoketest - Smoke Test Runner
  // BDD 04/16/2026 - local llm AI comparison smoke plan
  const SMOKE_TEST_PLAN_AI_COMPARE_V1 = require("./smoke_test_plan_ai_compare_v1.json");
  // const SMOKE_TEST_PLAN_CLASSIC_V1 = require("./smoke_test_plan_v1.json");
  const SMOKE_TEST_PLAN_V1 = SMOKE_TEST_PLAN_AI_COMPARE_V1;
  // BDD 02/20/2026 smoketest - Smoke Test Runner

  const smokeAbortRef = useRef(false);
  const smokeCleanupRef = useRef(null); // AIT-255: always points at the latest render's cleanupSmokeMedia
  const [smokeRunning, setSmokeRunning] = useState(false);
  const [smokeStepIndex, setSmokeStepIndex] = useState(0);
  const [smokeLastError, setSmokeLastError] = useState(null);

  const [smokeResults, setSmokeResults] = useState([]);
  const smokeResultsRef = useRef([]);

  useEffect(() => {
    smokeResultsRef.current = smokeResults || [];
  }, [smokeResults]);

  // BDD 02/20/2026 - PWO QA - Grade scope test/healthCheckpwo - end

  // BDD 02/20/2026 smoketest - Smoke Test Runner
  // BDD 02/20/2026 - Smoke Test Runner
  async function waitFor(predicateFn, timeoutMs = 60000, pollMs = 250) {
    const t0 = Date.now();
    while (Date.now() - t0 < timeoutMs) {
      if (smokeAbortRef.current) throw new Error("SMOKE_ABORTED");
      try {
        if (predicateFn()) return true;
      } catch (_) {}
      await sleep(pollMs);
    }
    return false;
  }

  const SMOKE_BAD_ANSWER_PATTERNS = [
  /error fetching response/i,
  /api error/i,
  /traceback/i,
  /exception/i,
  /stack trace/i,
  /internal server error/i,
  /no response from ai/i,
  /failed to fetch/i,
  /could you let me know what topic/i,
  /what topic are you interested in/i,
  /favorite subject is physics/i,
  /the ai service hit an internal error/i,
  /i ran into a temporary error/i,
  /please try again\./i,
];

// BDD 04/13/2026 - AI smoke metrics for current ask
// BDD 04/16/2026 - local llm / museum latency experiment
function resetAiAskMetrics(askRequestId, options = {}) {
  const {
    aiMode = null,
    transportMode = null,
    backendPath = null,
  } = options || {};

  aiAskMetricsRef.current = {
    active: true,
    askRequestId: askRequestId || null,

    // BDD 04/16/2026 - local llm / museum latency experiment
    aiMode: aiMode || null,              // "cloud_realtime" | "local_nvidia"
    transportMode: transportMode || null, // "stream" | "non_stream"
    backendPath: backendPath || null,    // "cloud_api" | "local_service"

    requestStartedAt: Date.now(),
    firstTextAt: null,
    textDoneAt: null,
    doneAt: null,
    firstAudioAt: null,
    firstActionAt: null,

    hadAudio: false,
    hadError: false,
    errorMessages: [],
  };
}

// BDD 04/13/2026 - AI smoke metrics for current ask
function getAiAskMetricsSnapshot() {
  const m = aiAskMetricsRef.current || {};
  const ttftMs =
    m.requestStartedAt && m.firstTextAt ? (m.firstTextAt - m.requestStartedAt) : null;

  const textDoneMs =
    m.requestStartedAt && m.textDoneAt ? (m.textDoneAt - m.requestStartedAt) : null;

  const doneMs =
    m.requestStartedAt && m.doneAt ? (m.doneAt - m.requestStartedAt) : null;

  const firstAudioMs =
    m.requestStartedAt && m.firstAudioAt ? (m.firstAudioAt - m.requestStartedAt) : null;

  // BDD 04/16/2026 - local llm / museum latency experiment
  const firstActionMs =
    m.requestStartedAt && m.firstActionAt ? (m.firstActionAt - m.requestStartedAt) : null;

    // BDD 04/16/2026 - local llm / museum latency experiment
  return {
    askRequestId: m.askRequestId || null,

    // BDD 04/16/2026 - local llm / museum latency experiment
    aiMode: m.aiMode || null,
    transportMode: m.transportMode || null,
    backendPath: m.backendPath || null,

    // backward compatibility for old smoke output readers
    mode: m.transportMode || null,

    requestStartedAt: m.requestStartedAt || null,
    ttftMs,
    textDoneMs,
    doneMs,
    firstAudioMs,
    firstActionMs,
    hadAudio: !!m.hadAudio,
    hadError: !!m.hadError,
    errorMessages: Array.isArray(m.errorMessages) ? m.errorMessages.slice(0, 5) : [],
  };
}

function smokePreviewText(s, n = 280) {
  const t = String(s || "").replace(/\s+/g, " ").trim();
  return t.length > n ? (t.slice(0, n) + "…") : t;
}

function smokeIncludesAny(text, arr) {
  if (!Array.isArray(arr) || !arr.length) return true;
  const t = String(text || "").toLowerCase();
  return arr.some((x) => t.includes(String(x || "").toLowerCase()));
}

function summarizePwosForSmoke(list, max = 3) {
  const a = Array.isArray(list) ? list : [];
  return a.slice(0, max).map((p) => ({
    pwoID: p?.pwoID ?? p?.pwo_id ?? p?.pwo_source_id ?? p?.source_id ?? p?.id ?? null,
    sceneName: p?.sceneName ?? p?.scene_name ?? p?.scene_key ?? null,
    name: p?.display_name ?? p?.name ?? p?.title ?? null,
  }));
}

function summarizeVideosForSmoke(list, max = 3) {
  const a = Array.isArray(list) ? list : [];
  return a.slice(0, max).map((v) => ({
    videoID: v?.videoID ?? v?.video_id ?? v?.source_id ?? v?.id ?? null,
    tagID: v?.tagID ?? v?.tag_id ?? null,
    name: v?.name ?? v?.display_name ?? null,
    tagName: v?.tag_name ?? null,
  }));
}

  async function waitForNewHistoryEntry(prevLen, prevTopId, timeoutMs) {
  return await waitFor(() => {
    const h = historyRef.current || [];
    const top = h[0] || null;
    const topId = top?.student_message_id ?? top?.assistant_turn_id ?? null;

    // Must have an answer (prevents false positives)
    const ans = String(top?.answer || answerRef.current || "").trim();
    if (!ans) return false;

    // ✅ Accept if top message id changed (even if array length didn’t grow)
    if (prevTopId != null && topId != null && String(topId) !== String(prevTopId)) return true;

    // ✅ Also accept classic “length increased” case
    if (h.length > prevLen) return true;

    return false;
  }, timeoutMs, 250);
}

  function exportSmokeJsonl(name = "smoke", rowsOverride = null) {
    const rows = Array.isArray(rowsOverride) ? rowsOverride : (smokeResultsRef.current || []);
    if (!rows.length) {
      console.warn("[SMOKE] exportSmokeJsonl: no rows to export");
      alert("Smoke JSONL is empty (no results captured).");
      return;
    }

    const jsonl = rows.map((r) => JSON.stringify(r)).join("\n") + "\n";
    const ts = new Date().toISOString().replace(/[:.]/g, "-");
    downloadTextFile(`smoke_${name}_${ts}.jsonl`, jsonl);
  }

  // BDD 04/13/2026 - AI smoke metrics for current ask
  const aiAskMetricsRef = useRef({
    active: false,
    askRequestId: null,

    // BDD 04/16/2026 - local llm / museum latency experiment
    aiMode: null,           // "cloud_realtime" | "local_nvidia"
    transportMode: null,    // "stream" | "non_stream"
    backendPath: null,      // "cloud_api" | "local_service"

    requestStartedAt: 0,
    firstTextAt: null,
    textDoneAt: null,
    doneAt: null,
    firstAudioAt: null,
    firstActionAt: null,

    hadAudio: false,
    hadError: false,
    errorMessages: [],
  });
  // BDD 02/21/2026 HomeWorkHelpMVP
  // ===========================
  // Homework Help Mode (Phase-1)
  // ===========================
  const [homeworkHelpEnabled, setHomeworkHelpEnabled] = useState(() => {
    try {
      if (typeof window !== "undefined" && window.sessionStorage) {
        return sessionStorage.getItem("homeworkHelpEnabled") === "1";
      }
    } catch {}
    return false;
  });

  useEffect(() => {
    try {
      if (typeof window !== "undefined" && window.sessionStorage) {
        sessionStorage.setItem("homeworkHelpEnabled", homeworkHelpEnabled ? "1" : "0");
      }
    } catch {}
  }, [homeworkHelpEnabled]);

  const homeworkHelpEnabledRef = useRef(homeworkHelpEnabled);
  useEffect(() => {
    homeworkHelpEnabledRef.current = homeworkHelpEnabled;
  }, [homeworkHelpEnabled]);

  // When toggled ON, make the next ask start a fresh dialog exactly once
  const homeworkHelpNewDialogOnNextAskRef = useRef(false);


  // MVP payload builder (later you can expose help_type/show_final_answer in UI)
  const buildHomeworkHelpPayload = () => ({
    mode: "homework_help",
    help_type: "hint_then_steps",     // MVP default
    show_final_answer: false,         // MVP default
    prefer_socratic: true,            // MVP default
    answer_style: answerStyle || null // you already have concise/detailed
  });
  const [questionInput, setQuestionInput] = useState("");
  const [conversation, setConversation] = useState([]);
  const lang = selectedSecondaryLang === "auto"
    ? "en"
    : selectedSecondaryLang

  const langCode = selectedSecondaryLang === "auto"
    ? "en"
    : selectedSecondaryLang;

  // map to your quiz‐DB language_id
  const quizLanguageMap = {
    en: 1,
    pt: 3,
    te: 4,
    es: 6, // BDD 11/15/2025
    // …in future you could add other languages here…
  };
  // default to English (=1) if nothing matches
  const languageIDquiz = quizLanguageMap[langCode] ?? 1;

  // BDD 9/1/2025 Support for US English US_EN
  // --- Language IDs used in your DB ---
  const LANG_IDS = {
    EN: 1,      // regular English: 
    GU: 2,      // BDD 02/06/2026 bugfix_gujarati_video_2026_02_06
    PT: 3,      // Portuguese
    TE: 4,      // Telugu
    EN_US: 5,   // US English (new)
    ES: 6, // Spanish # BDD 11/15/2025
  };
  // Prefer-logic for VIDEOS ONLY
  // If langCode is 'en' or 'auto' => [5, 1]
  // Otherwise try that language's ID (if known), else default to [1]
  const getVideoLanguagePriority = (langCode, preferUSEnglish = true) => {
    // Normalize
    const lc = (langCode || "en").toLowerCase();

    // BDD 12/31/2025 - Choice of EN - IN and EN - US
    // NEW: EN-IN should ALWAYS use regular English (LanguageId 1) for videos
    // (No US-English preference for EN-IN)
    if (lc === "en-in" || lc === "en_in") {
      return [LANG_IDS.EN];
    }


    // English or Auto → prefer US English then regular English
    if (lc === "en" || lc === "auto") {
      return preferUSEnglish ? [LANG_IDS.EN_US, LANG_IDS.EN] : [LANG_IDS.EN];
    }

    // // Known non-English languages
    // if (lc === "pt") return [LANG_IDS.PT];
    // if (lc === "te") return [LANG_IDS.TE];
    // if (lc === "es") return [LANG_IDS.ES]; // BDD 11/15/2025

    // // Fallback
    // BDD 12/31/2025 - Choice of EN - IN and EN - US 
    // Desired behavior (Videos only)
    // If user selects PT / ES / TE / any non-English:
    // Try that language’s LanguageId
    // If missing → fallback to US English (5)
    // If missing → fallback to English (1)
    // If user selects EN (US) / auto → [5, 1] (same as now)
    // If user selects EN-IN → [1] (same as now)
    // return [LANG_IDS.EN];
    // Non-English: try selected language first, then fallback to US English (5), then English (1)
    if (lc === "pt") return [LANG_IDS.PT, LANG_IDS.EN_US, LANG_IDS.EN];
    if (lc === "te") return [LANG_IDS.TE, LANG_IDS.EN_US, LANG_IDS.EN];
    if (lc === "es") return [LANG_IDS.ES, LANG_IDS.EN_US, LANG_IDS.EN];
    if (lc === "gu") return [LANG_IDS.GU, LANG_IDS.EN]; // BDD 02/06/2026 bugfix_gujarati_video_2026_02_06

    // Unknown language code: fallback to US English then English
    return [LANG_IDS.EN_US, LANG_IDS.EN];

  };
  // VIDEO: compute a priority list, first entry is the "preferred" request ID
  const videoLanguagePriority = useMemo(
    () => getVideoLanguagePriority(langCode, /* prefer US English? */ true),
    [langCode]
  );
  // If you need a single ID for an API param (first try):
  const languageIDVideo = videoLanguagePriority[0];
  // const languageIDVideo = quizLanguageMap[langCode] ?? 1;

  const { t } = useTranslation();

  const languageMap = {
    "auto": "Eng_USA", // Default to English if auto-detect
    "en": "Eng_USA",
    "en-in": "Eng_USA", // NEW: EN-IN (PWO stays English) // BDD 12/31/2025 - Choice of EN - IN and EN - US
    "es": "Spanish",
    "hi": "Hindi",
    "fr": "French",
    "zh": "Chinese_Simplified",
    "ja": "Japanese",
    "ko": "Korean",
    "de": "German",
    "it": "Italian",
    "ru": "Russian",
    "ar": "Arabic",
    "gu": "Gujarati",
    "te": "Telugu",
    "mr": "Marathi",
    "pt": "Portuguese",
  };

// BDD 12/08/2025 – normalize UI/content language for curriculum API
// BDD 02/07/2026 bipin_zach_dashboard_tweaks_v2 - gj localization
const resolveCurriculumLang = (code) => {
  if (!code || code === "auto") return "en";

  const lower = String(code).toLowerCase().trim();

  if (lower.startsWith("es")) return "es"; // es, es-ES, etc.
  if (lower.startsWith("pt")) return "pt"; // pt, pt-BR, etc.
  if (lower.startsWith("en")) return "en";

  // ✅ Gujarati support (your app/db uses "gj"; ISO code is "gu")
  if (lower === "gj" || lower.startsWith("gj-") || lower.startsWith("gj_")) return "gj";
  if (lower === "gu" || lower.startsWith("gu-") || lower.startsWith("gu_")) return "gj";

  // Fallback: English
  return "en";
};

  // Function to get the language code based on secondary_language_id
  const getLocalLanguage = (secondaryLanguageId) => {
    return languageMap[secondaryLanguageId] || "Eng_USA"; // Default to English if no match
  };
  // BDD 12/08/2025 - helper to pick localized label for curriculum tree
  // const labelForCurriculumNode = (node) =>
  //   (node?.display_name || node?.name || "").trim();
  // BDD DEBUG 01/19/2026 - Hot Fix label name screwup due to localization
  // const labelForCurriculumNode = (node) =>
  //   (node?.name || node?.display_name || "").trim();
  // BDD 01/24/2026 - localization.db is regenerated for new mapped database
  const labelForCurriculumNode = (node) =>
    (node?.display_name || node?.name || "").trim();

  // --- Collections (student-facing) ---
  const [availableCollections, setAvailableCollections] = useState([]);
  const [activeStudyCollection, setActiveStudyCollection] = useState(null);
  const [collectionResolved, setCollectionResolved] = useState(null);
  // const [collectionsLoading, setCollectionsLoading] = useState(false);
  // === PATCH BDD 11/3/2025 - 2025-11-03: split list vs detail loading and unify guards ===
  const [collectionsListLoading, setCollectionsListLoading] = useState(false);   // list fetch only
  const [collectionsDetailLoading, setCollectionsDetailLoading] = useState(false); // detail (resolve) fetch only
  // === PATCH 2025-11-03: derived helper ===

  // Single orchestration guard: "have we already handled auto-behavior for this {user,board}?"
  const autoHandledForKeyRef = useRef(new Set());
  const collectionResolveRequestRef = useRef(0);
  // BDD 12/30/2025 - Track if we've auto-switched to curriculum for current board
  const autoSwitchedToCurriculumRef = useRef(null);

  const [collectionsFetched, setCollectionsFetched] = useState(false);
  const [collectionProgressPercentage, setCollectionProgressPercentage] = useState(null);
  const [chapterProgressPercentage, setChapterProgressPercentage] = useState(null);

  // ===== Load KT popup preference from AsyncStorage =====
  useEffect(() => {
    const loadKtPreference = async () => {
      try {
        const disabled = await AsyncStorage.getItem("kt_popup_disabled");
        if (disabled === "true") {
          setKtPopupDisabled(true);
        }
        ktPopupDisabledLoadedRef.current = true;
      } catch (err) {
        console.log("Failed to load KT popup preference:", err.message);
        ktPopupDisabledLoadedRef.current = true;
      }
    };
    loadKtPreference();
  }, []);



  // KT popup answer handler — returns {is_correct, correct_answer, feedback}
  const handleKtAnswer = useCallback(async (questionId, selectedAnswer) => {
    try {
      // Track that the student answered (for skip rate)
      const answeredCount = parseInt(await AsyncStorage.getItem("kt_popups_answered") || "0", 10) + 1;
      await AsyncStorage.setItem("kt_popups_answered", String(answeredCount));

      const clientSessionId = await AsyncStorage.getItem("client_session_id");
      const triggerCtx = activeModule === 'video' ? 'video' : activeModule === 'pwo' ? 'pwo' : 'chat';

      const res = await axios.post(
        `${FASTAPI_BASE_URL}/kt/topic/${ktPopupQuestion.source_topic_id}/respond`,
        {
          kt_topic_question_id: questionId,
          selected_answer: selectedAnswer,
          trigger_context: triggerCtx,
          session_id: clientSessionId || 'default',
        },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
      return res.data; // {is_correct, correct_answer, feedback, new_mastery}
    } catch (err) {
      console.error('KT response failed:', err.message);
      return null;
    }
  }, [activeModule, authToken, ktPopupQuestion]);

  // KT popup skip handler — reason: "button" (explicit skip) or "backdrop" (clicked outside)
  const handleKtSkip = useCallback(async (questionId, reason = "button") => {
    try {
      const skipCount = parseInt(await AsyncStorage.getItem("kt_popups_skipped") || "0", 10) + 1;
      await AsyncStorage.setItem("kt_popups_skipped", String(skipCount));
      console.log(`[KT] skip — reason: ${reason}, questionId: ${questionId}, total skips: ${skipCount}`);
    } catch (e) { /* ignore */ }
    setKtPopupVisible(false);
    setKtPopupQuestion(null);
  }, []);

  // KT popup dismiss handler — reason: "timeout" (timer expired) or "answered" (after feedback)
  const handleKtDismiss = useCallback(async (reason = "timeout", questionId = null) => {
    if (reason === "timeout") {
      try {
        const timeoutCount = parseInt(await AsyncStorage.getItem("kt_popups_timed_out") || "0", 10) + 1;
        await AsyncStorage.setItem("kt_popups_timed_out", String(timeoutCount));
        console.log(`[KT] timeout — questionId: ${questionId}, total timeouts: ${timeoutCount}`);
      } catch (e) { /* ignore */ }
    }
    setKtPopupVisible(false);
    setKtPopupQuestion(null);
  }, []);

  // KT popup preference toggle handler (for profile modal)
  const handleKtPopupToggle = useCallback(async (newValue) => {
    setKtPopupDisabled(newValue);
    await AsyncStorage.setItem("kt_popup_disabled", newValue ? "true" : "false");
    if (!newValue) {
      // Re-enabling: reset the auto-disable notification flag
      ktAutoDisableNotifiedRef.current = false;
    }
  }, []);

  // const noCollections = (availableCollections?.length || 0) === 0;
  // BDD 01/07/2026 Collection vs Curriculum Display Bug
  const noCollectionsRaw = (availableCollections?.length || 0) === 0;

  // BDD 11/3/2025
  // === PATCH 2025-11-03: reflect both loading flags ===
  const hasCollections = useMemo(() => {
    if (collectionsListLoading || collectionsDetailLoading) return true;
    if (Array.isArray(availableCollections) && availableCollections.length > 0) return true;
    if (activeStudyCollection && collectionResolved) return true;
    return false;
  }, [
    collectionsListLoading,
    collectionsDetailLoading,
    availableCollections?.length,
    activeStudyCollection,
    collectionResolved,
  ]);
  // BDD 01/07/2026 Collection vs Curriculum Display Bug
  const noCollectionsForSure = Boolean(collectionsFetched && !hasCollections);
  // BDD 01/07/2026 Collection vs Curriculum Display Bug
  const effectiveViewMode = noCollectionsForSure ? "curriculum" : viewMode;

  // BDD 11/14/2025
  const isCollectionsOnly =
    user?.role === "student" && user?.content_scope === "collections_only";

  // # BDD 01/21/2026 - 01/22/2026 - add_subscription_notifications_and_support
  const canSeeAdminNotifications =
    !!user?.is_internal_admin ||
    !!(user?.can_use_admin_tools ?? canUseAdminTools(user?.role));

  // BDD 01/25/2026 studen resum states
  const showContinueButton = !!user?.is_internal_admin || !!flags?.show_continue_button;

  // // BDD 02/21/2026 HomeWorkHelpMVP - feature gate
  // const isHomeworkHelpEnabled = React.useMemo(() => {
  //   const fromFlags = !!(flags && flags.homeworkHelp); 
  //   // allow internal admins to see it even if flag is off (optional safety hatch)
  //   const isInternal = !!user?.is_internal_admin;
  //   return fromFlags || isInternal;
  // }, [flags, user?.is_internal_admin]);

  // BDD 02/23/2026 HomeWorkHelpMVP - feature gate (flag only)
  const isHomeworkHelpEnabled = React.useMemo(() => {
    return !!(flags && flags.homeworkHelp);
  }, [flags]);

    // BDD 02/21/2026 HomeWorkHelpMVP - safety: disable mode when flag is off
  useEffect(() => {
    if (!isHomeworkHelpEnabled && homeworkHelpEnabled) {
      homeworkHelpNewDialogOnNextAskRef.current = false; // reset one-shot
      setHomeworkHelpEnabled(false);
    }
  }, [isHomeworkHelpEnabled, homeworkHelpEnabled]);

  // ZA 03/01/2026 - Turn off homework mode when user navigates away from homework panel
  useEffect(() => {
    const isOnHomeworkPanel = activeModule === "learning" && learningSubModule === "homework";
    if (!isOnHomeworkPanel && homeworkHelpEnabled) {
      setHomeworkHelpEnabled(false);
      homeworkHelpNewDialogOnNextAskRef.current = false;
    }
  }, [activeModule, learningSubModule, homeworkHelpEnabled]);  

  // BDD 11/7/2025
  // BDD 01/03/2026 schooladmin-teacher-engagement
  // Now these come from roles.js
  // const canUseTeacherTools = (role) => {
  //   const r = (role || "").toLowerCase();
  //   return r === "teacher" || r === "admin" || r === "institute_admin" || r === "superadmin" || r === "schooladmin";
  // };

  // // BDD 01/03/2026 schooladmin-teacher-engagement
  // const canUseAdminTools = (role) => {
  //   const r = (role || "").toLowerCase();
  //   return r === "admin" || r === "institute_admin" || r === "superadmin" || r === "schooladmin";
  // };

  // BDD 01/07/2026 Collection vs Curriculum Display Bug
  // BDD 01/18/2026 - Respect user's saved preference unless absolutely necessary
  // BDD 01/18/2026 - Always update viewMode when auto-switching to curriculum due to no collections
  useEffect(() => {
    // If student is collections-only, always force collections (hard requirement)
    if (isCollectionsOnly) {
      if (viewMode !== "collections") {
        setViewMode("collections");
      }
      return;
    }

    // BDD 01/18/2026 - If no collections exist, ALWAYS switch to curriculum (even if user has saved preference)
    // This ensures the tab label updates correctly when switching to boards with no collections
    if (noCollectionsForSure && viewMode !== "curriculum") {
      setViewMode("curriculum");
      setActiveSidebarTab("collections");
    }
  }, [isCollectionsOnly, noCollectionsForSure, viewMode]);

  // BDD 11/9/2025
  const [myClasses, setMyClasses] = useState([]);

  // BDD 11/9/2025
  useEffect(() => {
    if (!user) {
      setMyClasses([]);
      return;
    }

    const load = async () => {
      try {
        const res = await fetchWithAuth(`${FASTAPI_BASE_URL}/classes/mine`);
        if (!res.ok) return;
        const json = await res.json();
        if (Array.isArray(json)) {
          setMyClasses(json);
        }
      } catch (e) {
        console.log("classes/mine error", e);
      }
    };

    load();
  }, [user, fetchWithAuth]);

  // BDD 12/02/2025
  const [guideMeLoading, setGuideMeLoading] = useState(false);
  const [chatSessions, setChatSessions] = useState([]);
  const [selectedConversationId, setSelectedConversationId] = useState(null);
  const [sessionsLoading, setSessionsLoading] = useState(false);
  const [sessionTurnsLoading, setSessionTurnsLoading] = useState(false);

  // TEMP: hardcode the default view for testing ("collections" | "curriculum")
  const [preferredView, setPreferredView] = useState('collections'); // 'collections' or 'curriculum'
  // ^ switch to 'curriculum' to verify the other path
  // Run-once guard per board (user+contentDb)
  const initAttemptedForBoardRef = useRef(new Set());
  // Prevent parallel in-flight selects
  const selectingRef = useRef(false);
  const asBool = (v, def) => {
    if (v === undefined || v === null) return def;        // keep client default
    if (typeof v === 'boolean') return v;                 // already boolean
    if (typeof v === 'number') return v !== 0;            // 0/1
    if (typeof v === 'string') {
      const s = v.trim().toLowerCase();
      if (['true', '1', 'yes', 'y', 'on'].includes(s)) return true;
      if (['false', '0', 'no', 'n', 'off'].includes(s)) return false;
      return def; // unknown string -> keep default
    }
    return def;
  };
  // BDD - 10/22/2025
  // guards + handles for one-at-a-time recording
  const isListeningRef = useRef(false);
  const mrRef = useRef(null);   // MediaRecorder
  const gumStreamRef = useRef(null);   // getUserMedia stream
  const stopTimerRef = useRef(null);   // timeout to stop

  // BDD 9/18/2025 - PWO Zoom function
  // ==== PWO Zoom state (session-persistent) ====

  const MIN_PWO_ZOOM = 0.30;   // 30%
  const MAX_PWO_ZOOM = 2.00;   // 200%
  const PWO_ZOOM_STEP = 0.10;  // 10% step
  const PWO_SCALE_KEY = "pwoZoomV1";
  const [stageMaximized, setStageMaximized] = useState(false);   // BDD 11/21/2025

  // Auto-fit scale calculation for fullscreen mode
  // Native PWO content size is 1280x720, scale to FIT viewport (contain, may have black bars)
  const PWO_NATIVE_WIDTH = 1280;
  const PWO_NATIVE_HEIGHT = 720;
  // The contextual Learning sub-tab row is always present (directly under the
  // bar) while PWO is on stage, so the header's effective height includes it.
  const HEADER_HEIGHT = HEADER.barHeight + HEADER.subBarHeight;
  // Separate scale factors for fullscreen fill mode (stretch to fill viewport)
  const fullscreenScaleX = useMemo(() => {
    if (!stageMaximized || typeof window === 'undefined') return 1;
    return width / PWO_NATIVE_WIDTH;
  }, [stageMaximized, width]);

  const fullscreenScaleY = useMemo(() => {
    if (!stageMaximized || typeof window === 'undefined') return 1;
    return (height - HEADER_HEIGHT) / PWO_NATIVE_HEIGHT;
  }, [stageMaximized, height]);

  // Legacy contain scale (kept for reference, but no longer used for fullscreen fill)
  const fullscreenAutoScale = useMemo(() => {
    return Math.min(fullscreenScaleX, fullscreenScaleY);
  }, [fullscreenScaleX, fullscreenScaleY]);

  // SBS 3D projector mode: Unity already emits a complete 16:9 packed SBS frame.
  // Fit that native frame to the full browser viewport without subtracting AITutor chrome.
  const sbs3dPwoScale = useMemo(() => {
    if (!sbs3dPwoTakeover) return 1;
    return Math.min(width / PWO_NATIVE_WIDTH, height / PWO_NATIVE_HEIGHT);
  }, [sbs3dPwoTakeover, width, height]);

  const [pwoScale, setPwoScale] = useState(() => {
    if (typeof window === "undefined") return 1;
    try {
      const saved = sessionStorage.getItem(PWO_SCALE_KEY);
      const n = saved ? parseFloat(saved) : 1;
      return Number.isFinite(n)
        ? Math.min(MAX_PWO_ZOOM, Math.max(MIN_PWO_ZOOM, n))
        : 1;
    } catch { return 1; }
  });

  // BDD 10/29/2025
  // ==== VIDEO Zoom state (session-persistent) ====
  const MIN_VIDEO_ZOOM = 0.30;   // 30%
  const MAX_VIDEO_ZOOM = 2.00;   // 200%
  const VIDEO_ZOOM_STEP = 0.10;  // 10% step
  const VIDEO_SCALE_KEY = "videoZoomV1";

  const [videoScale, setVideoScale] = useState(() => {
    if (typeof window === "undefined") return 1;
    try {
      const saved = sessionStorage.getItem(VIDEO_SCALE_KEY);
      const n = saved ? parseFloat(saved) : 1;
      return Number.isFinite(n)
        ? Math.min(MAX_VIDEO_ZOOM, Math.max(MIN_VIDEO_ZOOM, n))
        : 1;
    } catch { return 1; }
  });

  const zoomVideo = (delta) =>
    setVideoScale(s =>
      Math.min(
        MAX_VIDEO_ZOOM,
        Math.max(MIN_VIDEO_ZOOM, +(s + delta).toFixed(2))
      )
    );

  // BDD 11/18/2025
  // Call this when a PWO is opened/launched
  const trackPwoLaunch = () => {
    console.log("pwoLaunchesRef.current", pwoLaunchesRef.current);

    clickCountRef.current += 1;
    setClickCount((prev) => prev + 1);
    pwoLaunchesRef.current += 1;
    showReward();
  };
  // BDD 11/18/2025
  // Call this when a video is played (or opened)
  const trackVideoPlay = () => {
    console.log("videoPlaysRef.current", videoPlaysRef.current);

    clickCountRef.current += 1;
    setClickCount((prev) => prev + 1);
    videoPlaysRef.current += 1;
    showReward();
  };
  // BDD 11/18/2025
  // Call this just before sending a question to the AI
  const trackAiQuestion = () => {
    console.log("aiQuestionsRef.current", aiQuestionsRef.current);

    aiQuestionsRef.current += 1;

    const now = Date.now();
    if (now - lastAiRewardTimeRef.current > 60000) {
      showReward();
      lastAiRewardTimeRef.current = now;
    }

  };

  // persist to session this run
  useEffect(() => {
    try { sessionStorage.setItem(VIDEO_SCALE_KEY, String(videoScale)); } catch { }
  }, [videoScale]);

  // BDD 10/4/2025
  const [picker, setPicker] = useState({ visible: false, title: "", rows: [] });
  function dismissPicker() {
    setPicker({ visible: false, title: "", rows: [] });
  }
  // BDD 11/3/2025
  // If user or board changes, clear the guard so we can run again
  useEffect(() => {
    autoHandledForKeyRef.current.clear();
  }, [user_id, contentDb]);

  // BDD 10/5/2025
  useEffect(() => {
    setSparkTopicId(null);
  }, [activeStudyCollection?.id]);

  // Function to refresh collection progress
  const refreshCollectionProgress = useCallback(async () => {
    if (!activeStudyCollection?.id || !user_id) {
      setCollectionProgressPercentage(null);
      return;
    }

    // Da Vinci challenge: mirror the challenge GATE % (PWO + video + passed
    // quizzes, ÷ all items) so the COLLECTION PROGRESS bar matches the
    // "Challenge X%" chip exactly instead of the looser pwo%+video% sum.
    if (user?.science_center === "da_vinci" && Array.isArray(challengeState?.days)) {
      const dayMatch = challengeState.days.find(
        (d) => d.collection_id === activeStudyCollection.id
      );
      if (dayMatch && typeof dayMatch.percent === "number") {
        setCollectionProgressPercentage(dayMatch.percent);
        return;
      }
    }

    try {
      const res = await axios.get(
        `${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/collections/${activeStudyCollection.id}/guide-me-state`
      );

      const coverage = res.data?.coverage;
      if (coverage) {
        // Calculate average of PWO and video coverage
        const pwoCoverage = coverage.pwo_coverage_fraction || 0;
        const videoCoverage = coverage.video_coverage_fraction || 0;
        const totalCoverage = (pwoCoverage + videoCoverage);
        setCollectionProgressPercentage(Math.round(totalCoverage * 100));
      }
    } catch (err) {
      console.error("Failed to fetch collection progress:", err);
      // Keep null to show random progress in development
    }
  }, [activeStudyCollection?.id, user_id, user, challengeState]);

  // Fetch collection progress when active collection changes
  useEffect(() => {
    refreshCollectionProgress();
  }, [refreshCollectionProgress]);

  // ===== Da Vinci 3-Day Challenge wiring =====================================
  // All challenge behavior is gated on the Da Vinci science center; for every
  // other user these helpers no-op and no network calls are made.
  const isInternalAdmin = user?.is_internal_admin === true;
  // An internal admin keeps visibility into both programmes -- on top of the
  // per-user flags -- for demos and support. A programme whose journeys don't
  // exist hides itself in ExploreSection (components/home/student/ExploreSection.js)
  // rather than being gated here, so an admin sees a programme exactly when
  // there is something in it to open.
  const canAccessSummerCampJourneys = isInternalAdmin || user?.is_summer_camp === true;
  const canAccessStemMissions = isInternalAdmin || user?.is_stem_missions === true;
  const wonderLabsEntry = Platform.OS === "web" && typeof window !== "undefined"
    ? getWonderLabsEntryRoute(window.location.pathname)
    : { isWonderLabs: false, slug: null, catalog: null };
  // Route selects child-focused UI; it does not override the account's program access.
  const wonderLabsPreviewEnabled = Boolean(
    canAccessStemMissions && Platform.OS === "web" && typeof window !== "undefined" &&
    (wonderLabsEntry.isWonderLabs ||
      new URLSearchParams(window.location.search).get("ff_swan_unified_panel") === "1")
  );
  const isDavinciUser = user?.science_center === "da_vinci";
  const isDavinciStudent = isDavinciUser && !isInternalAdmin;

  // Kiosk lockdown: an enrolled, not-yet-finished Da Vinci student sees ONLY the
  // challenge — the current day's collection + the right-side AI chat. The header
  // /nav is hidden and the intro screen gates entry. Every other user is
  // unaffected (challengeState stays null -> challengeLockdown is false).
  // Stay in the locked trail even after all_done so the student can reach the
  // "Get Your Exclusive QR Code" button on the hub (header stays hidden).
  const challengeLockdown =
    isDavinciStudent && !!challengeState?.enrolled;

  // Fetch the latest challenge state. Returns the parsed payload (or null).
  const fetchChallengeState = useCallback(async () => {
    if (!isDavinciStudent) return null;
    try {
      const res = await fetchWithAuth(`${FASTAPI_BASE_URL}/davinci/challenge/state`);
      if (!res || !res.ok) return null;
      const data = await res.json();
      setChallengeState(data);
      return data;
    } catch (err) {
      console.warn("[challenge] fetchChallengeState failed", err);
      return null;
    }
  }, [isDavinciStudent, fetchWithAuth]);

  // Sync challenge progress with the server. Debounced against rapid repeats.
  // On a freshly-completed day it raises the celebration modal + confetti.
  // AIT-274: a result that arrives while a video/PWO is open is parked here and
  // shown once the content closes, instead of interrupting it.
  const pendingChallengeRevealRef = useRef(null);
  const contentOpenRef = useRef(false);
  contentOpenRef.current = shouldDeferChallengeReveal({ showVideo, showPwo, activeModule });

  const applyChallengeReveal = useCallback((action) => {
    if (!action) return;
    try {
      showReward();
    } catch (_e) {
      /* confetti is best-effort flair */
    }
    if (action.type === "hub") {
      // Final collection done — return to the trail hub, where the
      // "Get Your Exclusive QR Code" button is now enabled.
      setChallengeIntroDismissed(false);
      setChallengeHubClosed(false);
      setChallengeModal(null);
    } else {
      setChallengeModal(action.modal);
    }
  }, [showReward]);

  const syncChallenge = useCallback(async (collectionId) => {
    if (!isDavinciStudent) return;
    if (challengeSyncInFlightRef.current) return;
    const now = Date.now();
    if (now < challengeSyncCooldownRef.current) return; // debounce window
    challengeSyncInFlightRef.current = true;
    challengeSyncCooldownRef.current = now + 1500;
    try {
      const body =
        collectionId != null ? { collection_id: Number(collectionId) } : {};
      const res = await fetchWithAuth(
        `${FASTAPI_BASE_URL}/davinci/challenge/sync`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        }
      );
      if (res && res.ok) {
        const data = await res.json();
        const action = planChallengeReveal(data);
        if (action) {
          if (contentOpenRef.current) {
            pendingChallengeRevealRef.current = action;
          } else {
            applyChallengeReveal(action);
          }
        }
      }
    } catch (err) {
      console.warn("[challenge] syncChallenge failed", err);
    } finally {
      challengeSyncInFlightRef.current = false;
      // Always refresh state so progress UI stays current.
      fetchChallengeState();
    }
  }, [isDavinciStudent, fetchWithAuth, applyChallengeReveal, fetchChallengeState]);

  // Show a parked challenge result as soon as the video/PWO is gone.
  useEffect(() => {
    if (shouldDeferChallengeReveal({ showVideo, showPwo, activeModule })) return;
    const pending = pendingChallengeRevealRef.current;
    if (!pending) return;
    pendingChallengeRevealRef.current = null;
    applyChallengeReveal(pending);
  }, [showVideo, showPwo, activeModule, applyChallengeReveal]);

  // On first load for a Da Vinci user, fetch state and route into the current
  // (incomplete) challenge collection exactly once — never fight the user.
  useEffect(() => {
    if (!isDavinciStudent) {
      challengeBootstrappedForRef.current = null;
      challengeAutoRoutedRef.current = false;
      return;
    }
    // Bootstrap once per user identity. If auth hydration is still settling
    // (common right after verification-link/auto-login flows), retry until the
    // first challenge-state fetch succeeds instead of giving up permanently.
    if (challengeBootstrappedForRef.current === user?.email) return;
    let cancelled = false;
    let retryId;

    const bootstrap = async () => {
      const data = await fetchChallengeState();
      if (cancelled) return;
      if (!data) {
        retryId = setTimeout(() => {
          if (!cancelled && challengeBootstrappedForRef.current !== user?.email) {
            bootstrap();
          }
        }, 1000);
        return;
      }

      challengeBootstrappedForRef.current = user?.email;
      if (
        data.enrolled &&
        !data.all_done &&
        data.current?.collection_id &&
        !challengeAutoRoutedRef.current
      ) {
        challengeAutoRoutedRef.current = true;
        const route = handleCollectionClickRef.current;
        if (typeof route === "function") {
          route(data.current.collection_id);
        }
      }
    };

    bootstrap();
    return () => {
      cancelled = true;
      if (retryId) clearTimeout(retryId);
    };
  }, [isDavinciStudent, user?.email, fetchChallengeState]);

  // While a Da Vinci student is locked into the challenge, poll progress so the
  // "complete" popup fires as soon as they cross the threshold — instead of only
  // on the next open/close of an item. syncChallenge is debounced internally.
  useEffect(() => {
    if (!challengeLockdown) return undefined;
    const id = setInterval(() => {
      syncChallenge(activeStudyCollection?.id);
    }, 3000);
    return () => clearInterval(id);
  }, [challengeLockdown, syncChallenge, activeStudyCollection?.id]);

  // When the student finishes the whole challenge we ASK for the name to print
  // on the certificate, then call the backend completion endpoint ONCE (it mints
  // the redeem code + emails the QR/certificate). The engine no longer mints, so
  // this is the single source of the email.
  const [certName, setCertName] = useState("");
  const [certSubmit, setCertSubmit] = useState({ status: "idle", message: "" }); // idle|sending|sent|error
  const certPrefilledRef = useRef(false);

  // Prefill the name field (from the account) the first time the finish modal opens.
  useEffect(() => {
    if (challengeModal?.allDone) {
      if (!certPrefilledRef.current) {
        certPrefilledRef.current = true;
        setCertName((prev) => prev || user?.name || "");
        setCertSubmit({ status: "idle", message: "" });
      }
    } else {
      certPrefilledRef.current = false;
    }
  }, [challengeModal?.allDone, user]);

  const submitChallengeCertificate = useCallback(async () => {
    const name = (certName || "").trim();
    if (!name) {
      setCertSubmit({ status: "error", message: t("Please enter your name.") });
      return;
    }
    setCertSubmit({ status: "sending", message: "" });
    try {
      const subjects = (challengeState?.days || [])
        .map((d) => d.subject_label || d.collection_name)
        .filter(Boolean);
      const res = await fetchWithAuth(`${FASTAPI_BASE_URL}/davinci/challenge-completed`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ full_name: name, subjects }),
      });
      if (res && res.ok) {
        const data = await res.json().catch(() => ({}));
        setChallengeModal((prev) =>
          prev ? { ...prev, cert: { minted: true, redeem_code: data?.qr_value } } : prev
        );
        setCertSubmit({ status: "sent", message: t("Certificate sent to your email!") });
      } else {
        setCertSubmit({ status: "error", message: t("Could not send certificate. Please try again.") });
      }
    } catch (e) {
      console.warn("[challenge] challenge-completed call failed", e);
      setCertSubmit({ status: "error", message: t("Network error. Please try again.") });
    }
  }, [certName, challengeState, fetchWithAuth, t]);

  // BDD 10/29/2025
  const ENABLE_COVERAGE_EXPORT = false; // keep true ONLY FOR DEBUG CAUTION NOTE BDD // keep it false for production
  // Web download (DOM)
  function exportCoverageWeb(board) {
    const url = `${FASTAPI_BASE_URL}/curriculum_coverage.xlsx?board=${encodeURIComponent(board)}`;
    const a = document.createElement("a");
    a.href = url;
    a.download = `${board.toUpperCase()}_Curriculum_Coverage.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  // Native open (let the device handle the file/URL)
  function exportCoverageNative(board) {
    const url = `${FASTAPI_BASE_URL}/curriculum_coverage.xlsx?board=${encodeURIComponent(board)}`;
    Linking.openURL(url);
  }

  function handleExportCoverage(board) {
    const b = (board || "").toLowerCase();
    if (!SUPPORTED_EXPORT_BOARDS.has(b)) {
      const msg = `${t("Coverage export not available for board:")}: ${board}`;
      if (Platform.OS === "web") alert(msg);
      else Alert.alert(t("Export Unavailable"), msg);
      return;
    }
    if (Platform.OS === "web") exportCoverageWeb(b);
    else exportCoverageNative(b);
  }
  // BDD 10/29/2025
  const SUPPORTED_EXPORT_BOARDS = new Set(["cbse", "igcse", "anatomy", "saras"]);

  // BDD 10/5/2025 - Bottombar
  // Bottom UI kind + padding inset
  const bottomUiKind = flags.club_mode ? "club" : (flags.ask_dock ? "askdock" : "legacy");
  // BDD 10/13/2025 - ShelvesLayout
  // Option A: reuse utility_drawer as the “shelves layout” switch
  const shelvesLayout = !!flags.investor_mode && !!flags.utility_drawer;
  // BDD 10/14/2025 
  const [isAsking, setIsAsking] = useState(false);          // true while awaiting AI
  const [triviaItem, setTriviaItem] = useState(null);       // current trivia card
  const triviaCursorRef = useRef({});                       // per-topic round-robin
  const curriculumTileView = !!flags.curriculum_tile_view; // BDD 10/17/2025
  const askAgentMode = !!flags.ask_agent; // BDD FG 10/17/2025

  // BDD 10/14/2025
  const demoPreset = getDemoPreset(); // null if investor_mode is off
  const featureOverride = flags?.show_trivia_when_waiting; // boolean or undefined
  // BDD 10/15/2025
  const [curriculumModalVisible, setCurriculumModalVisible] = useState(false);
  // Selected chapter to tile in mainContent (curriculum view)
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [folderNavDepth, setFolderNavDepth] = useState(0); // 0=root, 1=grade, 2=subject, 3=chapter (show topics)
  const skipChapterRestoreUntilRef = useRef(0); // timestamp: skip storage restore until this time
  // keep scroll without re-renders
  const sidebarScrollRef = useRef(null);
  const sidebarScrollYRef = useRef(0);
  // Track chapter element refs for scrolling
  const chapterRefsMap = useRef({});
  // BDD 02/11/2026 - Chapter level Curiosity Sparks
  const lastChapterTitleRef = useRef("");
  const lastChapterSubjectRef = useRef("");
  const chapterSparksCacheRef = useRef(new Map()); // key -> list
  // BDD 02/11/2026 - Chapter level Curiosity Sparks
  const chapterSparksRetryRef = useRef(new Map()); // key -> retry count
  const chapterSparksInFlightRef = useRef(new Set()); // key -> inflight
  // BDD 02/11/2026 - Chapter level Curiosity Sparks
  const [collectionSparks, setCollectionSparks] = useState([]);
  const [chapterSparks, setChapterSparks] = useState([]);
  // ZA 03/01/2026 - Ref mirror for sparks so replenish can read current value without adding to useCallback deps
  const chapterSparksRef = useRef([]);
  useEffect(() => { chapterSparksRef.current = chapterSparks; }, [chapterSparks]);
  const collectionSparksRef = useRef([]);
  useEffect(() => { collectionSparksRef.current = collectionSparks; }, [collectionSparks]);


  // Stable chapter ID for dependency tracking
  const selectedChapterId = selectedChapter?.chapterId ?? selectedChapter?.id ?? null;

  // ===== Knowledge Tracing event-driven popup trigger =====
  // topicIdOverride: optional source_topic_id to query directly (e.g. from topic summary)
  const triggerKtPopup = useCallback(async ({ topicIdOverride = null } = {}) => {
    console.log('[KT] triggerKtPopup called', { topicIdOverride, email: user?.email, showQuiz, ktPopupVisible, ktPopupDisabled });
    if (!user?.email || showQuiz || ktPopupVisible || ktPopupDisabled) {
      console.log('[KT] blocked by guard', { noEmail: !user?.email, showQuiz, ktPopupVisible, ktPopupDisabled });
      return;
    }

    try {
      // Build topic IDs for the request
      let topicIds = [];
      if (topicIdOverride) {
        topicIds = [String(topicIdOverride)];
      } else if (activeStudyCollection?.id) {
        // Collection context — gather topic IDs from collection items
        const expandedTopicId = activeTopicForAIRef.current?.source_topic_id;
        if (expandedTopicId) {
          topicIds = [String(expandedTopicId)];
        }
      } else {
        // Curriculum / topic context — collect topic IDs
        const expandedTopicId = activeTopicForAIRef.current?.source_topic_id;
        if (expandedTopicId) {
          topicIds = [String(expandedTopicId)];
        } else if (selectedChapter) {
          const chapterId = selectedChapter?.chapterId ?? selectedChapter?.id;
          try {
            for (const grade of (curriculum || [])) {
              for (const subject of (grade?.subjects || [])) {
                for (const chapter of (subject?.chapters || [])) {
                  const cId = chapter?.id ?? chapter?.chapterId;
                  if (String(cId) === String(chapterId)) {
                    const topics = chapter?.topics || chapter?.children || [];
                    topicIds = topics
                      .map(t => t?.source_topic_id ?? t?.sourceTopicId ?? t?.source_id)
                      .filter(Boolean)
                      .map(String);
                    break;
                  }
                }
              }
            }
          } catch (e) { /* ignore parse errors */ }
        }
      }
      if (!topicIds.length) {
        console.log('[KT] triggerKtPopup: no topic IDs found, skipping');
        return;
      }
      const response = await axios.get(
        `${FASTAPI_BASE_URL}/kt/topic/questions`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
          params: { topic_ids: topicIds.join(","), popup_disabled: ktPopupDisabled },
        }
      );

      const questions = response.data?.questions || [];
      console.log('[KT] API response', { questionsCount: questions.length, reason: response.data?.reason, url: response.config?.url });
      if (questions.length > 0) {
        // Track that a popup was shown (for skip rate calculation)
        const shownCount = parseInt(await AsyncStorage.getItem("kt_popups_shown") || "0", 10) + 1;
        await AsyncStorage.setItem("kt_popups_shown", String(shownCount));

        setKtPopupQuestion(questions[0]);
        setKtPopupVisible(true);


        // Periodically check skip rate for auto-disable (every 5 popups)
        if (shownCount >= 20 && shownCount % 5 === 0 && !ktAutoDisableNotifiedRef.current) {
          const answeredCount = parseInt(await AsyncStorage.getItem("kt_popups_answered") || "0", 10);
          try {
            const skipRes = await axios.post(
              `${FASTAPI_BASE_URL}/kt/skip-rate`,
              { popups_shown: shownCount, popups_answered: answeredCount },
              { headers: { Authorization: `Bearer ${authToken}` } }
            );
            if (skipRes.data?.should_auto_disable) {
              ktAutoDisableNotifiedRef.current = true;
              setKtPopupDisabled(true);
              await AsyncStorage.setItem("kt_popup_disabled", "true");
              showNotification(
                "We noticed you've been skipping knowledge checks. We've paused them \u2014 you can re-enable in your profile settings.",
                "info"
              );
            }
          } catch (skipErr) {
            console.log("KT skip rate check failed:", skipErr.message);
          }
        }
      }
    } catch (err) {
      console.log('[KT] trigger failed:', err.message);
    }
  }, [user?.email, showQuiz, ktPopupVisible, ktPopupDisabled, activeStudyCollection?.id, authToken, selectedChapter, curriculum]);

  // Handler for video ended — triggers KT popup
  const handleVideoEnded = useCallback(() => {
    triggerKtPopup({ topicIdOverride: activeTopicForAIRef.current?.source_topic_id });
  }, [triggerKtPopup]);

  // Function to refresh chapter progress
  const refreshChapterProgress = useCallback(async () => {
    if (!selectedChapterId || !user_id) {
      return;
    }

    try {
      const res = await axios.get(
        `${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/chapters/${selectedChapterId}/guide-me-state`
      );

      // BDD 02/11/2026 - Chapter level Curiosity Sparks
      lastChapterTitleRef.current = res.data?.chapter_title || res.data?.chapter || lastChapterTitleRef.current;
      lastChapterSubjectRef.current = res.data?.subject || lastChapterSubjectRef.current;

      if (res.data) {
        const coverage = res.data?.coverage;
        const pwoCoverage = coverage.pwo_coverage_fraction || 0;
        const videoCoverage = coverage.video_coverage_fraction || 0;
        const totalCoverage = (pwoCoverage + videoCoverage);
        const newProgress = Math.round(totalCoverage * 100);
        setChapterProgressPercentage(prev => prev === newProgress ? prev : newProgress);
      }
    } catch (err) {
      console.error("Failed to fetch chapter progress:", err);
    }
  }, [selectedChapterId, user_id]);

  // Fetch chapter progress when selected chapter changes
  useEffect(() => {
    if (selectedChapterId && user_id) {
      refreshChapterProgress();
    } else {
      setChapterProgressPercentage(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedChapterId, user_id]);


  // // BDD 01/08/2026 - enhance-fetch-reference
  // DEBUGGING
  // const renderSeqRef = useRef(0);
  // useEffect(() => {
  //   renderSeqRef.current += 1;
  //   console.log("🖥️ render#", renderSeqRef.current, {
  //     viewMode,
  //     activeModule,
  //     activeSidebarTab,
  //     hasActiveCollection: !!activeStudyCollection?.id,
  //     hasCollectionResolved: !!collectionResolved,
  //     selectedChapterId: selectedChapter?.chapterId,
  //     selectedCollectionId: activeStudyCollection?.id,
  //   });
  // });

  // BDD 10/15/2025
  // === Curriculum Picker state & helpers (place right above the header block)

  // BDD 10/28/2025 - added "saras" // BDD 11/4/2025 added ap
  // BDD 12/28/2025 - added ngss-hs

  const [curriculumMenuOpen, setCurriculumMenuOpen] = useState(false);
  const [currentCurriculum, setCurrentCurriculum] = useState(null);
  const [isChangingCurriculum, setIsChangingCurriculum] = useState(false);
  const BOARD_KEY = currentCurriculum || "default";
  const LAST_CHAPTER_KEY = `lastChapter:${user_id}:${BOARD_KEY}`;
  const SIDEBAR_SCROLL_KEY = `curriculumSidebarScrollY:${user_id}:${BOARD_KEY}`;


  // If features.js provides a boolean, use it; otherwise fall back to preset flag
  const showTriviaWhenWaiting =
    (typeof featureOverride === "boolean")
      ? featureOverride
      : !!demoPreset?.flags?.SHOW_TRIVIA_WHEN_WAITING;

  // console.log("[TRIVIA] gate", {
  //   investor_on: !!demoPreset,
  //   preset: !!demoPreset?.flags?.SHOW_TRIVIA_WHEN_WAITING,
  //   override: featureOverride,
  //   final: showTriviaWhenWaiting
  // });

  function pickNextTrivia(topicId = null) {
    const pool = getTriviaForTopic(topicId);
    if (!pool || pool.length === 0) return null;
    const key = topicId ? String(topicId) : "_all_";
    const c = triviaCursorRef.current[key] || 0;
    const next = pool[c % pool.length];
    triviaCursorRef.current[key] = (c + 1) % pool.length;
    return next;
  }

  // Dock heights imported from ./constants

  const bottomInset =
    bottomUiKind === "club" ? CLUB_DOCK_HEIGHT :
      bottomUiKind === "askdock" ? ASK_DOCK_HEIGHT :
        LEGACY_BAR_HEIGHT;
  const dockBottomPad =
    (bottomUiKind === "club" || bottomUiKind === "askdock") ? 88 : 72; // tweak if needed
  // BDD 10/8/2025
  // AITutorApp.js (inside component, near other useState)
  const lastAskedRef = React.useRef("");
  const lastTopicSourceIdRef = React.useRef(null);
  // BDD 10/12/2025
  // keep Unity iframe mounted even when PWO is not “visible”
  const [pwoKeepAlive, setPwoKeepAlive] = useState(false);
  // handy flag derived from URL: ?ff_investor_mode=1
  // BDD 10/12/2025
  const investorMode = useMemo(() => {
    try {
      return new URLSearchParams(window.location.search).get("ff_investor_mode") === "1";
    } catch {
      return false;
    }
  }, []);
  // BDD 10/12/2025
  const lastPwoKeyRef = useRef(null);       // NEW: remembers last "pwoID|sceneName"
  // PWO/WebGL perf: cache args + avoid repeated cold boots
  const pwoWebglArgsCacheRef = useRef(new Map()); // key -> { authToken, ts, encodedArgs }
  const pwoHotSwitchCountRef = useRef(0);         // number of hot-switches since last cold boot
  const pwoLastColdBootAtRef = useRef(0);

  function getPwoArgsCacheMs(flagsObj) {
    const raw = flagsObj?.pwo_args_cache_ms;
    const n = typeof raw === "number" ? raw : parseInt(String(raw ?? ""), 10);
    return Number.isFinite(n) && n >= 0 ? n : 120000;
  }

  function getPwoHotSwitchMax(flagsObj) {
    const raw = flagsObj?.pwo_hot_switch_max;
    const n = typeof raw === "number" ? raw : parseInt(String(raw ?? ""), 10);
    return Number.isFinite(n) && n >= 0 ? n : 6;
  }

  function clearPwoWebglTimersAndListeners() {
    try {
      if (pwoInitTimeoutId.current) {
        clearTimeout(pwoInitTimeoutId.current);
        pwoInitTimeoutId.current = null;
      }
    } catch {}
    try {
      if (pwofallbackTimeoutId?.current) {
        clearTimeout(pwofallbackTimeoutId.current);
        pwofallbackTimeoutId.current = null;
      }
    } catch {}
    try {
      if (pwoBootSrcTimeoutId.current) {
        clearTimeout(pwoBootSrcTimeoutId.current);
        pwoBootSrcTimeoutId.current = null;
      }
    } catch {}
    try {
      if (webglReadyHandlerRef.current) {
        window.removeEventListener("message", webglReadyHandlerRef.current);
        webglReadyHandlerRef.current = null;
      }
    } catch {}
  }
  // ===== DEMO VIDEO WARM CACHE =====
  const videoWarmCacheRef = useRef(new Map());
  // BDD 12/06/2025
  function getVideoCacheKey(videoID, tagID, languageIDVideo) {
    // languageIDVideo is numeric; fall back to 'default' if ever null/undefined
    const langPart = (languageIDVideo ?? "default").toString();
    return `${videoID}-${tagID}-${langPart}`;
  }
  // BDD 12/06/2025 – clear warm cache when the *video* language changes
  useEffect(() => {
    console.log("[VIDEO] clearing warm cache because language changed", {
      selectedSecondaryLang,
      langCode,
      videoLangRefCurrent: videoLangRef.current,
    });
    videoWarmCacheRef.current = new Map();
  }, [langCode]);

  // BDD 10/12/2025
  // Preconnect to the origin of a URL (DNS+TLS warmup)
  function ensurePreconnect(originUrl) {
    try {
      const u = new URL(originUrl);
      const origin = `${u.protocol}//${u.host}`;
      if (![...document.head.querySelectorAll('link[rel="preconnect"]')].some(l => l.href === origin)) {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = origin;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      }
      if (![...document.head.querySelectorAll('link[rel="dns-prefetch"]')].some(l => l.href === origin)) {
        const link2 = document.createElement('link');
        link2.rel = 'dns-prefetch';
        link2.href = origin;
        document.head.appendChild(link2);
      }
    } catch { }
  }
  // BDD 10/12/2025
  // Treat a signed URL as “expiring soon” if <5m left
  function willExpireSoon(expiresAtMs, bufferMs = 5 * 60 * 1000) {
    return !!expiresAtMs && (expiresAtMs - Date.now() < bufferMs);
  }
  // BDD 10/12/2025
  // (optional) try to read ?expires= epoch from a URL
  function extractExpiresEpochFromUrl(u) {
    try {
      const url = new URL(u);
      if (url.searchParams.has('expires')) {
        const epoch = Number(url.searchParams.get('expires'));
        return Number.isFinite(epoch) ? epoch * 1000 : null;
      }
    } catch { }
    return null;
  }
  // BDD 10/12/2025
  // Very small m3u8 line parser: return first few non-# lines
  function parseFirstSegmentUrlsFromPlaylistText(txt, maxCount = 3) {
    const urls = [];
    for (const raw of txt.split('\n')) {
      const line = raw.trim();
      if (!line || line.startsWith('#')) continue;
      urls.push(line);
      if (urls.length >= maxCount) break;
    }
    return urls;
  }
  // BDD 10/12/2025
  // Fire-and-forget GET (segment/key warm)
  async function prefetch(url) {
    try { await fetch(url, { method: 'GET', mode: 'cors', credentials: 'omit', cache: 'default' }); } catch { }
  }
  // BDD 10/12/2025
  /**
   * Warm a video (videoID/tagID):
   * - fetch metadata → sign master → secure playlist
   * - preconnect and (optionally) prefetch first segments/key
   * - cache { playlistUrl, tagTime, expiresAtMs } in videoWarmCacheRef
   */
  // async function warmVideoForDemo(videoID, tagID, authToken, languageIDVideo) {
  //   const cacheKey = `${videoID}-${tagID}`;
  //   const cached = videoWarmCacheRef.current.get(cacheKey);
  //   if (cached && !willExpireSoon(cached.expiresAtMs)) return cached;

  //   // 1) metadata
  //   const metadata = await fetchVideoMetadata(videoID, tagID, languageIDVideo);
  //   if (!metadata || metadata.uuid_2D_720P === "Unknown Video" || metadata.version_2D_720P === "Unknown") {
  //     return null;
  //   }

  //   // 2) choose asset (you already handle US_EN via uuid/version)
  //   const preferSBS3D = false; // keep false for demo stability
  //   const videoUUID = (preferSBS3D && metadata.uuid_3D) ? metadata.uuid_3D : metadata.uuid_2D_720P;
  //   const videoVersion = String((preferSBS3D && metadata.version_3D) ? metadata.version_3D : metadata.version_2D_720P);

  //   // 3) tag time → seconds
  //   let tagTime = 0;
  //   if (metadata.tag_time) {
  //     const [m, s] = metadata.tag_time.split(':').map(Number);
  //     tagTime = (m || 0) * 60 + (s || 0);
  //   }

  //   // 4) sign master → secure m3u8
  //   const master = await axios.post(
  //     API_URL_MASTER_PLAYLIST,
  //     { video_uuid: videoUUID, video_version: videoVersion },
  //     { headers: { Authorization: `Bearer ${authToken}`, "Content-Type": "application/json" } }
  //   );
  //   const mediaPlaylistUrl = master?.data?.signed_media_playlist_url;
  //   if (!mediaPlaylistUrl) return null;

  //   // carry audio_lines only if your backend uses it; harmless if omitted
  //   const audioLines = master?.data?.audio_lines || [];

  //   const secureRes = await axios.get(
  //     `${API_URL_SECURE_M3U8}?media_url=${encodeURIComponent(mediaPlaylistUrl)}&video_uuid=${videoUUID}&audio_lines=${encodeURIComponent(JSON.stringify(audioLines))}`,
  //     { headers: { Authorization: `Bearer ${authToken}` }, responseType: "json" }
  //   );
  //   const playlistUrl = secureRes?.data?.playlist_url2 || secureRes?.data?.playlist_url || "";
  //   if (!playlistUrl) return null;

  //   // 5) preconnect + (optional) prefetch a couple segments & key to make start instant
  //   ensurePreconnect(playlistUrl);

  //   let expiresAtMs = null;
  //   try {
  //     const txt = await (await fetch(playlistUrl, { cache: 'reload' })).text();
  //     // const firstSegs = parseFirstSegmentUrlsFromPlaylistText(txt, 3);
  //     // if (firstSegs[0]) {
  //     //   const exp = extractExpiresEpochFromUrl(firstSegs[0]);
  //     //   if (exp) expiresAtMs = exp;
  //     // }
  //     // const keyMatch = txt.match(/#EXT-X-KEY:[^\n]*URI="([^"]+)"/);
  //     // if (keyMatch?.[1]) prefetch(keyMatch[1]);
  //     // for (const seg of firstSegs) prefetch(seg);
  //     const nearTag = segmentUrlsNearTag(txt, playlistUrl, tagTime, 3);
  //     if (nearTag[0]) {
  //       const exp = extractExpiresEpochFromUrl(nearTag[0]);
  //       if (exp) expiresAtMs = exp;
  //     }
  //     const keyMatch = txt.match(/#EXT-X-KEY:[^\n]*URI="([^"]+)"/);
  //     if (keyMatch?.[1]) prefetch(keyMatch[1]);
  //     for (const seg of nearTag) prefetch(seg);
  //   } catch {}

  //   const entry = { playlistUrl, tagTime, expiresAtMs };
  //   videoWarmCacheRef.current.set(cacheKey, entry);
  //   return entry;
  // }

  // BDD 12/06/2025
  /**
   * Warm a video (videoID/tagID/languageIDVideo):
   * - fetch metadata → sign master → secure playlist
   * - preconnect and (optionally) prefetch first segments/key
   * - cache { playlistUrl, tagTime, expiresAtMs } in videoWarmCacheRef
   */

  // BDD 02/06/2026 feature_video_gujarati_audio_track_2026_02_06
  // async function warmVideoForDemo(videoID, tagID, authToken, languageIDVideo) {
  //   const cacheKey = getVideoCacheKey(videoID, tagID, languageIDVideo);
  //   const cached = videoWarmCacheRef.current.get(cacheKey);
  //   if (cached && !willExpireSoon(cached.expiresAtMs)) return cached;

  //   // 1) metadata
  //   const metadata = await fetchVideoMetadata(videoID, tagID, languageIDVideo);
  //   if (!metadata || metadata.uuid_2D_720P === "Unknown Video" || metadata.version_2D_720P === "Unknown") {
  //     return null;
  //   }

  //   const preferSBS3D = false;
  //   const videoUUID = (preferSBS3D && metadata.uuid_3D) ? metadata.uuid_3D : metadata.uuid_2D_720P;
  //   const videoVersion = String((preferSBS3D && metadata.version_3D) ? metadata.version_3D : metadata.version_2D_720P);

  //   let tagTime = 0;
  //   if (metadata.tag_time) {
  //     const [m, s] = metadata.tag_time.split(':').map(Number);
  //     tagTime = (m || 0) * 60 + (s || 0);
  //   }

  //   const master = await axios.post(
  //     API_URL_MASTER_PLAYLIST,
  //     { video_uuid: videoUUID, video_version: videoVersion },
  //     { headers: { Authorization: `Bearer ${authToken}`, "Content-Type": "application/json" } }
  //   );
  //   const mediaPlaylistUrl = master?.data?.signed_media_playlist_url;
  //   if (!mediaPlaylistUrl) return null;

  //   const audioLines = master?.data?.audio_lines || [];

  //   const secureRes = await axios.get(
  //     `${API_URL_SECURE_M3U8}?media_url=${encodeURIComponent(mediaPlaylistUrl)}&video_uuid=${videoUUID}&audio_lines=${encodeURIComponent(JSON.stringify(audioLines))}`,
  //     { headers: { Authorization: `Bearer ${authToken}` }, responseType: "json" }
  //   );
  //   const playlistUrl = secureRes?.data?.playlist_url2 || secureRes?.data?.playlist_url || "";
  //   if (!playlistUrl) return null;

  //   ensurePreconnect(playlistUrl);

  //   let expiresAtMs = null;
  //   try {
  //     const txt = await (await fetch(playlistUrl, { cache: 'reload' })).text();
  //     const nearTag = segmentUrlsNearTag(txt, playlistUrl, tagTime, 3);
  //     if (nearTag[0]) {
  //       const exp = extractExpiresEpochFromUrl(nearTag[0]);
  //       if (exp) expiresAtMs = exp;
  //     }
  //     const keyMatch = txt.match(/#EXT-X-KEY:[^\n]*URI="([^"]+)"/);
  //     if (keyMatch?.[1]) prefetch(keyMatch[1]);
  //     for (const seg of nearTag) prefetch(seg);
  //   } catch { }

  //   const entry = { playlistUrl, tagTime, expiresAtMs };
  //   videoWarmCacheRef.current.set(cacheKey, entry);
  //   return entry;
  // }

  // BDD 10/12/2025
 
   // BDD 02/06/2026 feature_video_gujarati_audio_track_2026_02_06
  // async function warmVideoForDemo(videoID, tagID, authToken, languageIDVideo) {
  //   const cacheKey = getVideoCacheKey(videoID, tagID, languageIDVideo);
  //   const cached = videoWarmCacheRef.current.get(cacheKey);
  //   if (cached && !willExpireSoon(cached.expiresAtMs)) return cached;

  //   // 1) metadata
  //   const metadata = await fetchVideoMetadata(videoID, tagID, languageIDVideo);
  //   if (!metadata || metadata.uuid_2D_720P === "Unknown Video" || metadata.version_2D_720P === "Unknown") {
  //     return null;
  //   }

  //   const preferSBS3D = false;
  //   const videoUUID = (preferSBS3D && metadata.uuid_3D) ? metadata.uuid_3D : metadata.uuid_2D_720P;
  //   const videoVersion = String((preferSBS3D && metadata.version_3D) ? metadata.version_3D : metadata.version_2D_720P);

  //   let tagTime = 0;
  //   if (metadata.tag_time) {
  //     const [m, s] = metadata.tag_time.split(":").map(Number);
  //     tagTime = (m || 0) * 60 + (s || 0);
  //   }

  //   const master = await axios.post(
  //     API_URL_MASTER_PLAYLIST,
  //     { video_uuid: videoUUID, video_version: videoVersion },
  //     { headers: { Authorization: `Bearer ${authToken}`, "Content-Type": "application/json" } }
  //   );

  //   const masterData = master?.data || {};
  //   const mediaPlaylistUrl = masterData.signed_media_playlist_url;
  //   const masterUrl = masterData.signed_master_playlist_url;

  //   if (!mediaPlaylistUrl) return null;

  //   const audioLines = masterData.audio_lines || "";
  //   const audioLinesStr = typeof audioLines === "string" ? audioLines : JSON.stringify(audioLines);
  //   const hasAltAudio =
  //     audioLinesStr.includes("#EXT-X-MEDIA:TYPE=AUDIO") ||
  //     audioLinesStr.includes("TYPE=AUDIO");

  //   console.log("[WARM] hasAltAudio:", hasAltAudio, "videoUUID:", videoUUID, "lang:", languageIDVideo);

  //   // 2) Decide which playlist we warm:
  //   //    - alt-audio => warm SECURE MASTER (so Hls.js can discover audioTracks)
  //   //    - else      => keep existing SECURE MEDIA behavior
  //   let playlistUrl = "";

  //   if (hasAltAudio && masterUrl) {
  //     console.log("[WARM] using /secure_master_m3u8");
  //     const secureMasterResp = await axios.get(
  //       `${FASTAPI_BASE_URL}/secure_master_m3u8?master_url=${encodeURIComponent(masterUrl)}&video_uuid=${encodeURIComponent(videoUUID)}`,
  //       { headers: { Authorization: `Bearer ${authToken}` }, responseType: "json" }
  //     );
  //     playlistUrl = secureMasterResp?.data?.playlist_url || "";
  //   } else {
  //     console.log("[WARM] using /secure_m3u8 (existing)");
  //     const secureRes = await axios.get(
  //       `${API_URL_SECURE_M3U8}?media_url=${encodeURIComponent(mediaPlaylistUrl)}&video_uuid=${encodeURIComponent(videoUUID)}`,
  //       { headers: { Authorization: `Bearer ${authToken}` }, responseType: "json" }
  //     );
  //     playlistUrl = secureRes?.data?.playlist_url2 || secureRes?.data?.playlist_url || "";
  //   }

  //   if (!playlistUrl) return null;
  //   ensurePreconnect(playlistUrl);

  //   // 3) Prefetch: if master playlist, prefetch using its first variant media playlist
  //   let expiresAtMs = null;

  //   try {
  //     const playlistTxt = await (await fetch(playlistUrl, { cache: "reload" })).text();

  //     const isMaster = playlistTxt.includes("#EXT-X-STREAM-INF");
  //     let mediaTxt = playlistTxt;
  //     let mediaBaseUrl = playlistUrl;

  //     if (isMaster) {
  //       // Find first variant playlist line (next non-# after a STREAM-INF)
  //       const lines = playlistTxt.split("\n").map(s => s.trim());
  //       let variantLine = "";
  //       for (let i = 0; i < lines.length; i++) {
  //         if (lines[i].startsWith("#EXT-X-STREAM-INF")) {
  //           // next non-empty non-# line
  //           for (let j = i + 1; j < Math.min(i + 6, lines.length); j++) {
  //             const L = lines[j];
  //             if (L && !L.startsWith("#")) {
  //               variantLine = L;
  //               break;
  //             }
  //           }
  //           if (variantLine) break;
  //         }
  //       }

  //       if (variantLine) {
  //         const variantUrl = new URL(variantLine, new URL(playlistUrl)).toString();
  //         mediaBaseUrl = variantUrl;
  //         mediaTxt = await (await fetch(variantUrl, { cache: "reload" })).text();
  //       }
  //     }

  //     const nearTag = segmentUrlsNearTag(mediaTxt, mediaBaseUrl, tagTime, 3);
  //     if (nearTag[0]) {
  //       const exp = extractExpiresEpochFromUrl(nearTag[0]);
  //       if (exp) expiresAtMs = exp;
  //     }

  //     const keyMatch = mediaTxt.match(/#EXT-X-KEY:[^\n]*URI="([^"]+)"/);
  //     if (keyMatch?.[1]) prefetch(keyMatch[1]);
  //     for (const seg of nearTag) prefetch(seg);
  //   } catch (e) {
  //     console.warn("[WARM] prefetch failed", e);
  //   }

  //   const entry = { playlistUrl, tagTime, expiresAtMs };
  //   videoWarmCacheRef.current.set(cacheKey, entry);
  //   return entry;
  // }

  // BDD 02/06/2026 feature_video_gujarati_audio_track_2026_02_06 - try2
  async function warmVideoForDemo(videoID, tagID, authToken, languageIDVideo) {
  const cacheKey = getVideoCacheKey(videoID, tagID, languageIDVideo);
  const cached = videoWarmCacheRef.current.get(cacheKey);
  if (cached && !willExpireSoon(cached.expiresAtMs)) return cached;

  // tiny helper: fetch text with cache-bust (ONLY for warm verification/prefetch)
  async function fetchTextNoCache(url) {
    const u = url + (url.includes("?") ? "&" : "?") + "cb=" + Date.now();
    const r = await fetch(u, { cache: "reload" });
    return await r.text();
  }

  // tiny helper: parse expires=... from /api/video_key?expires=EPOCH
  function extractExpiresFromKeyUrl(keyUrl) {
    try {
      const u = new URL(keyUrl);
      const exp = u.searchParams.get("expires") || u.searchParams.get("Expires");
      const n = exp ? parseInt(exp, 10) : NaN;
      return Number.isFinite(n) ? n : null;
    } catch {
      return null;
    }
  }

  // 1) metadata
  const metadata = await fetchVideoMetadata(videoID, tagID, languageIDVideo);
  if (!metadata || metadata.uuid_2D_720P === "Unknown Video" || metadata.version_2D_720P === "Unknown") {
    return null;
  }

  const preferSBS3D = false;
  const videoUUID = (preferSBS3D && metadata.uuid_3D) ? metadata.uuid_3D : metadata.uuid_2D_720P;
  const videoVersion = String((preferSBS3D && metadata.version_3D) ? metadata.version_3D : metadata.version_2D_720P);

  let tagTime = 0;
  if (metadata.tag_time) {
    const [m, s] = metadata.tag_time.split(":").map(Number);
    tagTime = (m || 0) * 60 + (s || 0);
  }

  const master = await axios.post(
    API_URL_MASTER_PLAYLIST,
    { video_uuid: videoUUID, video_version: videoVersion },
    { headers: { Authorization: `Bearer ${authToken}`, "Content-Type": "application/json" } }
  );

  const masterData = master?.data || {};
  const mediaPlaylistUrl = masterData.signed_media_playlist_url;
  const masterUrl = masterData.signed_master_playlist_url;

  if (!mediaPlaylistUrl) return null;

  const audioLines = masterData.audio_lines || "";
  const audioLinesStr = typeof audioLines === "string" ? audioLines : JSON.stringify(audioLines);
  const hasAltAudio =
    audioLinesStr.includes("#EXT-X-MEDIA:TYPE=AUDIO") ||
    audioLinesStr.includes("TYPE=AUDIO");

  console.log("[WARM] hasAltAudio:", hasAltAudio, "videoUUID:", videoUUID, "lang:", languageIDVideo);

  // 2) Decide which playlist we warm:
  //    - alt-audio => warm SECURE MASTER (so Hls.js can discover audioTracks)
  //    - else      => keep existing SECURE MEDIA behavior
  let playlistUrl = "";

  // BDD 02/07/2026 bipin_zach_dashboard_tweaks - video tag time related

    if (hasAltAudio && masterUrl) {
      console.log("[WARM] using /secure_master_m3u8");

      // Γ£à map languageIDVideo -> preferred audio track
      // Gujarati languageIDVideo is 2 in your system
      const preferredAudio = (Number(languageIDVideo) === 2) ? "guj" : "eng";

      const secureMasterResp = await axios.get(
        `${FASTAPI_BASE_URL}/secure_master_m3u8` +
          `?master_url=${encodeURIComponent(masterUrl)}` +
          `&video_uuid=${encodeURIComponent(videoUUID)}` +
          `&preferred_audio=${encodeURIComponent(preferredAudio)}`,
        { headers: { Authorization: `Bearer ${authToken}` }, responseType: "json" }
      );

      playlistUrl = secureMasterResp?.data?.playlist_url || "";
    } else {
    console.log("[WARM] using /secure_m3u8 (existing)");
    const secureRes = await axios.get(
      `${API_URL_SECURE_M3U8}?media_url=${encodeURIComponent(mediaPlaylistUrl)}&video_uuid=${encodeURIComponent(videoUUID)}`,
      { headers: { Authorization: `Bearer ${authToken}` }, responseType: "json" }
    );
    playlistUrl = secureRes?.data?.playlist_url2 || secureRes?.data?.playlist_url || "";
  }

  if (!playlistUrl) return null;
  ensurePreconnect(playlistUrl);

  // 3) Prefetch: if master playlist, prefetch using its first variant media playlist
  let expiresAtMs = null;

  try {
    const playlistTxt = await fetchTextNoCache(playlistUrl);

    const isMaster = playlistTxt.includes("#EXT-X-STREAM-INF");
    let mediaTxt = playlistTxt;
    let mediaBaseUrl = playlistUrl;

    if (isMaster) {
      // Find first variant playlist line (next non-# after a STREAM-INF)
      const lines = playlistTxt.split("\n").map(s => s.trim());
      let variantLine = "";

      for (let i = 0; i < lines.length; i++) {
        if (lines[i].startsWith("#EXT-X-STREAM-INF")) {
          for (let j = i + 1; j < Math.min(i + 6, lines.length); j++) {
            const L = lines[j];
            if (L && !L.startsWith("#")) {
              variantLine = L;
              break;
            }
          }
          if (variantLine) break;
        }
      }

      if (variantLine) {
        // NOTE: variantLine is usually "secure_video_...m3u8" relative to the master
        const variantUrl = new URL(variantLine, new URL(playlistUrl)).toString();
        ensurePreconnect(variantUrl);

        mediaBaseUrl = variantUrl;
        mediaTxt = await fetchTextNoCache(variantUrl);
      }
    }

    // Γ£à Prefer expiry from KEY url (reliable), fallback to segment url (often not reliable with Policy)
    const keyMatch = mediaTxt.match(/#EXT-X-KEY:[^\n]*URI="([^"]+)"/);
    if (keyMatch?.[1]) {
      const keyUrl = keyMatch[1];
      prefetch(keyUrl);

      const expKey = extractExpiresFromKeyUrl(keyUrl);
      if (expKey) expiresAtMs = expKey * 1000;
    }

    const nearTag = segmentUrlsNearTag(mediaTxt, mediaBaseUrl, tagTime, 3);

    if (!expiresAtMs && nearTag[0]) {
      const expSeg = extractExpiresEpochFromUrl(nearTag[0]); // may be null with Policy URLs
      if (expSeg) expiresAtMs = expSeg * 1000;
    }

    for (const seg of nearTag) prefetch(seg);
  } catch (e) {
    console.warn("[WARM] prefetch failed", e);
  }

  // BDD 09/26/2026 - carry backend video start rule through warm cache
  const entry = {
    playlistUrl,
    tagTime,
    expiresAtMs,
    defaultStartSec: metadata?.default_start_sec ?? null,
  };

  videoWarmCacheRef.current.set(cacheKey, entry);
  return entry;
}

  async function waitForVideoElement(maxTries = 20, intervalMs = 25) {
    for (let i = 0; i < maxTries; i++) {
      if (videoRef.current) return true;
      await new Promise(r => setTimeout(r, intervalMs));
    }
    return !!videoRef.current;
  }
  // BDD 10/12/2025
  const hlsRef = useRef(null);
  const [nativeVideoUrl, setNativeVideoUrl] = useState(""); // used only for Safari/native-HLS
  // BDD 02/07/2026 bipin_zach_dashboard_tweaks - video tag time related - commenting out following
  // function destroyHls() {
  //   setVideoReady(false);  // Reset video ready state
  //   if (hlsRef.current) {
  //     try { hlsRef.current.destroy(); } catch { }
  //     hlsRef.current = null;
  //   }
  //   if (videoRef.current) {
  //     try {
  //       videoRef.current.pause();
  //       // Clear any existing MSE/src to avoid racing with the next attach
  //       videoRef.current.removeAttribute("src");
  //       videoRef.current.load();
  //     } catch { }
  //   }
  // }

  // BDD 02/07/2026 bipin_zach_dashboard_tweaks - video tag time related
  function destroyHls() {
    setVideoReady(false);  // Reset video ready state

    const h = hlsRef.current;
    if (h) {
      try { h.stopLoad(); } catch {}
      try { h.detachMedia(); } catch {}
      try { h.destroy(); } catch {}
      hlsRef.current = null;
    }

    if (videoRef.current) {
      try {
        videoRef.current.pause();

        // Γ£à Make sure audio is not "held" in a muted/0-volume state next open
        // (your Solution-2 forces silent initially)
        try { videoRef.current.muted = false; } catch {}
        try { videoRef.current.volume = 1; } catch {}

        // Γ£à Clear any existing MSE/src to avoid racing with the next attach
        videoRef.current.removeAttribute("src");
        videoRef.current.load();
      } catch {}
    }

    // Optional but safe: clear native fallback url state if you use it
    try { setNativeVideoUrl(""); } catch {}
  }
  // BDD 10/12/2025
  function segmentUrlsNearTag(m3u8Text, baseUrl, tagSeconds, count = 3) {
    // Resolve relative URLs against baseUrl:
    const base = new URL(baseUrl);
    const lines = m3u8Text.split('\n');

    const segments = [];
    let acc = 0;
    let pendingDur = 0;

    for (let i = 0; i < lines.length; i++) {
      const L = lines[i].trim();
      if (L.startsWith('#EXTINF:')) {
        const durStr = L.slice('#EXTINF:'.length).split(',')[0].trim();
        pendingDur = parseFloat(durStr) || 0;
      } else if (L && !L.startsWith('#')) {
        segments.push({ url: new URL(L, base).toString(), start: acc, dur: pendingDur });
        acc += pendingDur;
        pendingDur = 0;
      }
    }

    // find the first segment whose [start, start+dur] spans tagSeconds
    let idx = segments.findIndex(s => tagSeconds >= s.start && tagSeconds < s.start + s.dur);
    if (idx < 0) idx = 0;

    const out = [];
    for (let k = 0; k < count && idx + k < segments.length; k++) {
      out.push(segments[idx + k].url);
    }
    return out;
  }

  // ==========
  // BDD 10/8/2025
  // OPTIONAL – only if you decide to show a tiny HUD later; safe to omit
  // const [metricsOverlayVisible, setMetricsOverlayVisible] = useState(false);

  // Fetch per-item watch counts for picker modals
  async function fetchPickerEngagementCounts() {
    if (!user_id || user_id === "Guest") return null;
    try {
      const { data } = await axios.get(
        `${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/picker-engagement-counts`
      );
      return data; // { videos: { "vid|tag": count }, pwos: { "pid|scene": count } }
    } catch (err) {
      console.debug("fetchPickerEngagementCounts failed:", err);
      return null;
    }
  }

  // BDD 07/29/2026
  const normalizeJourneySessionState = (rawState) => {
    const next = rawState && typeof rawState === "object" ? rawState : {};

    return {
      ...DEFAULT_JOURNEY_SESSION_STATE,
      ...next,
      observations:
        Array.isArray(next?.observations) && next.observations.length
          ? [...next.observations, "", ""].slice(0, 3)
          : [...DEFAULT_JOURNEY_SESSION_STATE.observations],
      steps:
        next?.steps && typeof next.steps === "object" && !Array.isArray(next.steps)
          ? next.steps
          : {},
    };
  };

  const resetJourneySessionState = () => {
    setJourneySessionState({ ...DEFAULT_JOURNEY_SESSION_STATE });

    setJourneyActiveAsset(null);
    setJourneyRightTab("journey");
  };

  // BDD 07/28/2026
  const openJourney = async (journeyId = 1, previewStudent = null, options = {}) => {
    const previewEmail = String(previewStudent?.email || "").trim();
    const targetJourneyStudentId = previewEmail || String(user_id || "").trim();
    const isWonderLabsR2Entry = Boolean(options?.startWithSwan && !previewEmail &&
      wonderLabsPreviewEnabled && isWonderLabsLearningBeatsEnabled());

    // Do not load a stale snapshot while a prior R2 save is still in flight.
    // Keep ordinary/R1 Journey loading on its existing path.
    if (isWonderLabsR2Entry || wonderLabsDirectLaunchRef.current) {
      await wonderLabsR2SaveTailRef.current;
    }
    wonderLabsR2SaveEpochRef.current += 1;
    journeyStateHydratedRef.current = false;
    if (journeySaveTimeoutRef.current) {
      clearTimeout(journeySaveTimeoutRef.current);
      journeySaveTimeoutRef.current = null;
    }
    lastSavedJourneyStateRef.current = "";
    wonderLabsDirectLaunchRef.current = false;
    setWonderLabsWelcomeOpen(false);
    setWonderLabsWelcomeSlug(null);
    setWonderLabsStarting(false);

    wonderLabsActivityCursorRef.current = {};
    wonderLabsCheckpointStepRef.current = 0;
    wonderLabsReviewingRef.current = false;
    setJourneySwanPanelPreference({ collapsed: true, conversationOpen: false });
    resetJourneySessionState();
    setJourneyPreviewStudent(previewEmail ? previewStudent : null);
    setJourneyMode("teacher_led");
    setJourneyLoading(true);
    setJourneyAiContext(null);
    setJourneyConversationStarted(false);

    setJourneyStepIndex(0);
    setJourneyVisitedThroughIndex(0);

    try {
      const requests = [
        axios.get(`${FASTAPI_BASE_URL}/journeys/${journeyId}/runtime`, {
          params: {
            strict: true,
          },
        }),
      ];

      if (targetJourneyStudentId && targetJourneyStudentId !== "Guest") {
        requests.push(
          axios.get(
            `${FASTAPI_BASE_URL}/student/${encodeURIComponent(targetJourneyStudentId)}/journeys/${journeyId}/state`,
            authToken
              ? {
                  headers: {
                    Authorization: `Bearer ${authToken}`,
                  },
                }
              : undefined
          )
            .catch((error) => {
              if (isWonderLabsR2Entry) {
                // Never treat an inaccessible/failed saved state as a new
                // child session: Start Mission would overwrite prior work.
                throw error;
              }
              console.warn("[JOURNEY] State load soft-failed:", error);
              return null;
            })
        );
      }

      const [runtimeResponse, stateResponse] = await Promise.all(requests);

      console.log("[JOURNEY] Runtime loaded:", runtimeResponse.data);

      if (isWonderLabsR2Entry && targetJourneyStudentId && targetJourneyStudentId !== "Guest" &&
          (!stateResponse?.data || !stateResponse.data.state_json ||
            typeof stateResponse.data.state_json !== "object" ||
            Array.isArray(stateResponse.data.state_json))) {
        throw new Error("Saved Journey progress could not be verified. Please retry before starting.");
      }
      const loadedState = stateResponse?.data?.state_json || {};
      const normalizedSessionState = normalizeJourneySessionState(
        loadedState?.session_state
      );
      // R2.1: recover the last activity and its learning part before the
      // focused renderer mounts. Legacy/R1 presentation ignores this metadata.
      if (isWonderLabsR2Entry) {
        const savedCursor = normalizedSessionState.wonderlabs_activity_cursors;
        if (savedCursor && typeof savedCursor === "object" && !Array.isArray(savedCursor)) {
          const restored = {};
          Object.entries(savedCursor).forEach(([key, value]) => {
            if (key === "r2BeatCursors") {
              if (value && typeof value === "object" && !Array.isArray(value)) {
                restored.r2BeatCursors = {};
                Object.entries(value).forEach(([beatKey, beatIndex]) => {
                  if (Number.isSafeInteger(beatIndex) && beatIndex >= 0) {
                    restored.r2BeatCursors[beatKey] = beatIndex;
                  }
                });
              }
            } else if (Number.isSafeInteger(value) && value >= 0) {
              restored[key] = value;
            }
          });
          wonderLabsActivityCursorRef.current = restored;
        }
      }

      setJourneyRuntime(runtimeResponse.data);
      setJourneySessionState(normalizedSessionState);

      const runtimeSteps = Array.isArray(runtimeResponse?.data?.steps)
        ? runtimeResponse.data.steps
        : Array.isArray(runtimeResponse?.data?.runtime?.steps)
          ? runtimeResponse.data.runtime.steps
          : [];

      const maxStepIndex = Math.max(runtimeSteps.length - 1, 0);
      const nextStepIndex = Math.min(
        Math.max(Number(loadedState?.step_index) || 0, 0),
        maxStepIndex
      );
      const nextVisitedIndex = Math.min(
        Math.max(
          Number(loadedState?.visited_through_index) || nextStepIndex,
          nextStepIndex
        ),
        maxStepIndex
      );

      wonderLabsCheckpointStepRef.current = nextStepIndex;
      wonderLabsReviewingRef.current = false;
      setJourneyStepIndex(nextStepIndex);
      setJourneyVisitedThroughIndex(nextVisitedIndex);
      // R2-only Step 0: existing saved work takes priority, including work
      // begun in Phase 1. URL visits alone do not establish progress.
      const startedBefore = hasMeaningfulJourneyState(loadedState) ||
        Boolean(normalizedSessionState.wonderlabs_started);
      const step0Enabled = Boolean(options?.startWithSwan && !previewEmail &&
        wonderLabsPreviewEnabled && isWonderLabsLearningBeatsEnabled());
      const matchingMission = step0Enabled && WONDERLABS_MISSIONS.find((mission) =>
        mission.slug === options?.missionSlug ||
        mission.slug === runtimeResponse?.data?.slug ||
        mission.slug === runtimeResponse?.data?.manifest?.slug
      );
      setWonderLabsWelcomeSlug(matchingMission?.slug || null);
      setWonderLabsWelcomeOpen(Boolean(matchingMission && !startedBefore));
      // Only the explicit, flagged WonderLabs tile requests self-guided mode.
      // Existing launcher calls still start in teacher-led mode.
      const startWithSwan = Boolean(options?.startWithSwan && !previewEmail);
      wonderLabsDirectLaunchRef.current = startWithSwan;
      setJourneyMode(startWithSwan ? "self_guided" : "teacher_led");
      setShowJourney(true);

      const persistedPayload = JSON.stringify({
        session_state: normalizedSessionState,
        step_index: nextStepIndex,
        visited_through_index: nextVisitedIndex,
      });
      lastSavedJourneyStateRef.current = persistedPayload;
      journeyStateHydratedRef.current = true;
    } catch (error) {
      console.error("[JOURNEY] Failed to load:", error);

      const message = error?.response?.data?.detail || error?.message ||
        "Unable to load the Journey.";
      if (isWonderLabsR2Entry && Platform.OS === "web" &&
          typeof window !== "undefined" && typeof window.alert === "function") {
        window.alert(`Your saved progress couldn't be loaded. No changes were made.\n${message}`);
      } else {
        Alert.alert("Journey could not be opened", message);
      }
    } finally {
      setJourneyLoading(false);
    }
  };

  const closeJourney = () => {
    wonderLabsR2SaveEpochRef.current += 1;
    wonderLabsDirectLaunchRef.current = false;
    setWonderLabsWelcomeOpen(false);
    setWonderLabsWelcomeSlug(null);
    setWonderLabsStarting(false);
    journeyStateHydratedRef.current = false;
    if (journeySaveTimeoutRef.current) {
      clearTimeout(journeySaveTimeoutRef.current);
      journeySaveTimeoutRef.current = null;
    }

    wonderLabsCheckpointStepRef.current = 0;
    wonderLabsReviewingRef.current = false;
    resetJourneySessionState();
    setJourneyPresentMode(false);
    setJourneyPresentStepIndex(0);
    setShowJourney(false);
    setJourneyRuntime(null);
    setJourneyPreviewStudent(null);
    setJourneyMode("teacher_led");
    setJourneyAiContext(null);
    setJourneyConversationStarted(false);

    setJourneyStepIndex(0);
    setJourneyVisitedThroughIndex(0);
  };

  // ── Lesson in a Box (2026-08-13) ─────────────────────────────────────────

  const lessonPlanEnabled = flags?.lesson_plan === true;
  const lessonPlanStudentEmail = (user?.email || "").trim().toLowerCase();
  const lessonPlanMode = isTeacher ? "teacher" : "student";
  // Students get their progress saved and resumed. Teacher runs always start
  // fresh and write nothing (no state, responses, mastery or exploration
  // events), so a teacher's answers never resume and never count as evidence.
  const lessonPlanPersists = shouldPersistLessonRun(
    lessonPlanMode,
    lessonPlanStudentEmail
  );

  const resetLessonPlanState = React.useCallback(() => {
    lessonPlanHydratedRef.current = false;
    lessonPlanLastSavedRef.current = null;
    if (lessonPlanSaveTimeoutRef.current) {
      clearTimeout(lessonPlanSaveTimeoutRef.current);
      lessonPlanSaveTimeoutRef.current = null;
    }
    setLessonPlanSessionState({});
    setLessonPlanStepIndex(LESSON_COVER_INDEX);
    setLessonPlanMastery([]);
    // Drop buffered events with the session they describe: posting them
    // against the next lesson would attribute one lesson's exploration to
    // another.
    lessonExplorationBufferRef.current = [];
  }, []);

  /** Load one lesson's runtime plus this student's saved progress. */
  const loadLessonPlan = React.useCallback(
    async (lessonPlanId, siblings) => {
      const runtime = await apiGetLessonPlanRuntime(fetchWithAuth, lessonPlanId, {
        mode: lessonPlanMode,
      });
      runtime.siblings = siblings || runtime.siblings || [];

      resetLessonPlanState();

      // Teacher runs (persists=false) skip both reads and start fresh. A
      // failure in either read must not stop a lesson opening.
      const progress = await loadLessonRunProgress({
        persists: lessonPlanPersists,
        coverIndex: LESSON_COVER_INDEX,
        loadState: () =>
          apiGetLessonPlanState(
            fetchWithAuth,
            lessonPlanStudentEmail,
            lessonPlanId
          ),
        loadMastery: () =>
          apiGetLessonMastery(fetchWithAuth, lessonPlanStudentEmail, lessonPlanId),
      });
      if (lessonPlanPersists) {
        setLessonPlanSessionState(progress.sessionState);
        setLessonPlanStepIndex(progress.stepIndex);
        setLessonPlanMastery(progress.mastery);
      }

      // Hydration is complete only now — the save effect must not fire before
      // this point or it would overwrite saved progress with an empty object.
      lessonPlanHydratedRef.current = true;
      setLessonPlanRuntime(runtime);
      return runtime;
    },
    [
      fetchWithAuth,
      lessonPlanMode,
      lessonPlanPersists,
      lessonPlanStudentEmail,
      resetLessonPlanState,
    ]
  );

  /** Open a lesson picked from the dashboard launcher. */
  const openLessonPlan = React.useCallback(
    async (lesson) => {
      const lessonPlanId = lesson?.id ?? lesson?.lesson_plan_id ?? null;
      if (!lessonPlanId) return;

      setLessonPlanLoading(true);
      try {
        // The sibling switcher offers the other lessons on the same topic.
        const siblings = lessonPlanList.filter(
          (entry) => entry.board_topic_id === lesson.board_topic_id
        );
        await loadLessonPlan(lessonPlanId, siblings);
        setShowLessonPlan(true);
        setActiveModule("lessonPlans");
      } catch (error) {
        console.error("[LESSON] Failed to open:", error);
        Alert.alert(
          t("Lesson plan could not be opened"),
          error?.message || t("Unable to load the lesson plan.")
        );
      } finally {
        setLessonPlanLoading(false);
      }
    },
    [lessonPlanList, loadLessonPlan, t]
  );

  const selectLessonPlan = React.useCallback(
    async (lessonPlanId) => {
      if (!lessonPlanId || lessonPlanId === lessonPlanRuntime?.lesson_plan_id) return;
      setLessonPlanLoading(true);
      try {
        await loadLessonPlan(lessonPlanId, lessonPlanRuntime?.siblings);
      } catch (error) {
        console.error("[LESSON] Failed to switch lesson:", error);
      } finally {
        setLessonPlanLoading(false);
      }
    },
    [loadLessonPlan, lessonPlanRuntime]
  );

  const openLessonInsights = React.useCallback(async () => {
    const lessonPlanId = lessonPlanSaveInputsRef.current?.runtime?.lesson_plan_id;
    if (!lessonPlanId) return;

    setLessonInsightsOpen(true);
    setLessonInsightsLoading(true);
    setLessonInsightsError(null);
    try {
      const data = await apiGetLessonClassInsights(fetchWithAuth, lessonPlanId);
      setLessonInsights(data);
    } catch (error) {
      console.warn("[LESSON] insights failed:", error?.message);
      setLessonInsightsError(error?.message || "Could not load insights");
    } finally {
      setLessonInsightsLoading(false);
    }
  }, [fetchWithAuth]);

  /** "Finish lesson" — record completion, then close. */
  const finishLessonPlan = React.useCallback(async () => {
    const inputs = lessonPlanSaveInputsRef.current;
    if (inputs?.runtime && lessonPlanPersists) {
      const steps = inputs.runtime.steps || [];
      try {
        await apiSaveLessonPlanState(
          fetchWithAuth,
          lessonPlanStudentEmail,
          inputs.runtime.lesson_plan_id,
          {
            stateJson: inputs.sessionState,
            lastActiveStepKey: steps[inputs.stepIndex]?.step_key || null,
            stepIndex: Math.max(0, inputs.stepIndex),
            visitedThroughIndex: Math.max(0, inputs.stepIndex),
            completed: true,
          }
        );
        await apiRecordLessonResponses(
          fetchWithAuth,
          lessonPlanStudentEmail,
          inputs.runtime.lesson_plan_id,
          buildResponsePayload(steps, inputs.sessionState)
        );
      } catch (error) {
        console.warn("[LESSON] Could not record completion:", error?.message);
      }
    }
    closeLessonPlanRef.current?.();
  }, [fetchWithAuth, lessonPlanPersists, lessonPlanStudentEmail]);

  const closeLessonPlan = React.useCallback(() => {
    lessonPlanAssetLaunchRef.current = false;
    setLessonPlanActiveBlockId(null);
    // Flush first: the debounce cleanup would otherwise drop whatever was
    // answered in the last 1.2 seconds.
    if (lessonPlanSaveTimeoutRef.current) {
      clearTimeout(lessonPlanSaveTimeoutRef.current);
      lessonPlanSaveTimeoutRef.current = null;
    }
    saveLessonPlanProgressRef.current?.();
    resetLessonPlanState();
    setShowLessonPlan(false);
    setLessonPlanRuntime(null);
    setLessonPlanLaunchingBlockId(null);
  }, [resetLessonPlanState]);

  // ── Present mode (2026-08-27) ─────────────────────────────────────────────
  // Present mode takes over the viewport: the rail, the header and the app's
  // navigation all go, and the lesson fills the window. It deliberately does
  // NOT ask for browser fullscreen.
  //
  // It used to. The request is refused whenever the activation that would have
  // granted it has been spent — which opening the presenter popup does — and
  // inside fullscreen the UA swallows Escape and reports only that fullscreen
  // ended, so "the teacher is done", "a popup opened" and "the panel was
  // dismissed" all arrived as the same event and had to be told apart by
  // guards. The URL bar staying visible costs the class nothing; the lesson
  // still fills the screen.
  const enterLessonPresentMode = React.useCallback(() => {
    setLessonPresentMode(true);
  }, []);

  /** Idempotent — Escape, the exit control and the teardown effect all land here. */
  const exitLessonPresentMode = React.useCallback(() => {
    setLessonPresentMode(false);
  }, []);

  // The surface can go away without anyone pressing exit: the lesson closes, or
  // an asset launch switches module.
  useEffect(() => {
    if (!lessonPresentMode) return;
    if (showLessonPlan && lessonPlanRuntime && activeModule === "lessonPlans") return;
    setLessonPresentMode(false);
  }, [lessonPresentMode, showLessonPlan, lessonPlanRuntime, activeModule]);

  // Journey Present mode follows the same viewport-takeover idea as Lesson in a
  // Box, but keeps its own ephemeral step index inside JourneyPresentMode.
  // Entering/exiting therefore never changes a student's saved Journey state.
  const enterJourneyPresentMode = React.useCallback(() => {
    setJourneyPresentStepIndex(journeyStepIndex);
    setJourneyPresentMode(true);
  }, [journeyStepIndex]);

  const exitJourneyPresentMode = React.useCallback(() => {
    setJourneyPresentMode(false);
  }, []);

  useEffect(() => {
    if (!journeyPresentMode) return;
    if (showJourney && journeyRuntime) return;
    setJourneyPresentMode(false);
  }, [journeyPresentMode, showJourney, journeyRuntime]);

  /** Loads the board's lessons. Shared by the effect and by post-save refresh. */
  const refreshLessonPlanList = React.useCallback(
    async ({ isCancelled = () => false } = {}) => {
      if (!lessonPlanEnabled || !authToken || !contentDb) return;

      setLessonPlanListLoading(true);
      setLessonPlanListError(null);
      try {
        // Authors need to see their own drafts here; the server only honours
        // include_drafts for teacher-like accounts, so this is safe to always send.
        const rows = await apiListLessonPlans(fetchWithAuth, {
          board: contentDb,
          includeDrafts: true,
        });
        if (isCancelled()) return;
        setLessonPlanList(Array.isArray(rows) ? rows : []);
      } catch (error) {
        if (isCancelled()) return;
        console.warn("[LESSON] lesson list failed:", error?.message);
        setLessonPlanList([]);
        setLessonPlanListError(error?.message || "Failed to load lesson plans");
      } finally {
        if (!isCancelled()) setLessonPlanListLoading(false);
      }
    },
    [authToken, contentDb, fetchWithAuth, lessonPlanEnabled]
  );

  /**
   * "Make my copy" — turns a lesson the teacher cannot edit into a draft they
   * own. The wizard opens on the new copy the same way it opens on any other
   * lesson id, so editing it afterwards is the ordinary edit path, not a
   * special one.
   */
  const onForkLesson = React.useCallback(
    async (lesson) => {
      setForkingLessonId(lesson.id);
      try {
        const created = await apiForkLessonPlan(fetchWithAuth, lesson.id);
        await refreshLessonPlanList();
        setLessonWizardTarget(created?.lesson_plan_id ?? created?.id);
      } catch (error) {
        console.warn("[LESSON] fork failed:", error?.message);
        showNotification(
          error?.message || "Could not copy this lesson. Try again.",
          "error"
        );
      } finally {
        setForkingLessonId(null);
      }
    },
    [fetchWithAuth, refreshLessonPlanList, showNotification]
  );

  /**
   * Every published lesson for the current board, for the dashboard launcher.
   * One call per board — the launcher renders whatever comes back, so seeding a
   * new lesson makes it appear with no code change and no rebuild.
   */
  useEffect(() => {
    if (!lessonPlanEnabled || !authToken || !contentDb) {
      setLessonPlanList([]);
      return;
    }

    let cancelled = false;
    refreshLessonPlanList({ isCancelled: () => cancelled });

    return () => {
      cancelled = true;
    };
  }, [lessonPlanEnabled, authToken, contentDb, refreshLessonPlanList]);

  /**
   * Completion badges for the lessons page. Refetched when a lesson closes
   * (`lessonPlanRuntime` goes null) so finishing one updates the card behind it.
   */
  useEffect(() => {
    if (!lessonPlanEnabled || !authToken || !lessonPlanStudentEmail) {
      setLessonPlanProgress({});
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const rows = await apiGetLessonPlanProgress(
          fetchWithAuth,
          lessonPlanStudentEmail,
          { board: contentDb }
        );
        if (cancelled) return;
        const byLesson = {};
        (Array.isArray(rows) ? rows : []).forEach((row) => {
          byLesson[row.lesson_plan_id] = row;
        });
        setLessonPlanProgress(byLesson);
      } catch (error) {
        if (!cancelled) {
          console.warn("[LESSON] progress lookup failed:", error?.message);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [
    lessonPlanEnabled,
    authToken,
    contentDb,
    fetchWithAuth,
    lessonPlanStudentEmail,
    lessonPlanRuntime,
  ]);

  /**
   * A lesson replaces the module content, so if the user picks something from
   * the top bar the lesson must get out of the way. Asset launches change the
   * module on purpose and are excluded — the pill brings the lesson back.
   */
  // ── Saras Discovery Journey ─────────────────────────────────────────────

  const learningLoopEnabled = flags?.learning_loop === true;

  // "Programs ▾" nav menu (Lessons / Discovery Journeys / STEM Missions /
  // Summer Camp) — replaces the separate Lessons and Journeys tabs and also
  // reaches STEM Missions / Summer Camp, previously reachable only from
  // Home. See docs/superpowers/specs/2026-09-16-home-redesign.md §11 WP10.
  // useJourneyMap resolves each mission/day slug to a journey id (and, for
  // a signed-in student, its progress) the same way ExploreSection's pills
  // do.
  const { journeysBySlug: programJourneysBySlug, loading: programJourneysLoading } = useJourneyMap({
    studentEmail: user?.email,
    authToken,
  });

  const wonderLabsAutoOpenRef = useRef(null);
  useEffect(() => {
    const slug = wonderLabsEntry.slug;
    if (!wonderLabsPreviewEnabled || !slug || programJourneysLoading ||
        wonderLabsAutoOpenRef.current === slug) return;
    const entry = programJourneysBySlug instanceof Map
      ? programJourneysBySlug.get(slug) : programJourneysBySlug?.[slug];
    const id = getWonderLabsJourneyId(entry);
    if (!id) return; // Do not open guessed IDs or bypass existing program permissions.
    wonderLabsAutoOpenRef.current = slug;
    openJourney(id, null, { startWithSwan: true, missionSlug: slug });
  }, [wonderLabsPreviewEnabled, wonderLabsEntry.slug, programJourneysBySlug, programJourneysLoading]);

  const programItems = useMemo(
    () =>
      buildProgramItems({
        lessonPlanEnabled,
        learningLoopEnabled,
        canAccessStemMissions,
        canAccessSummerCampJourneys,
        journeysBySlug: programJourneysBySlug,
        journeysLoading: programJourneysLoading,
        activeModule,
        openJourney: withHomeModule(setActiveModule, openJourney),
        setActiveModule,
        t,
      }),
    [
      lessonPlanEnabled,
      learningLoopEnabled,
      canAccessStemMissions,
      canAccessSummerCampJourneys,
      programJourneysBySlug,
      programJourneysLoading,
      activeModule,
      openJourney,
      setActiveModule,
      t,
    ]
  );
  const programsActive =
    ["lessonPlans", "discoveryJourneys"].includes(activeModule) || showJourney;

  // Label breakpoint derived from the pills actually visible in the left
  // cluster: brand + right cluster take ≈650px, plus ≈120px per labeled
  // pill (Home always shown; Curriculum shown unless collections-only;
  // Collections always shown; Programs ▾ when it has any item that can be
  // opened; for teachers Dashboard/Create ▾/Manage ▾).
  const labeledPillCount =
    1 + (isCollectionsOnly ? 1 : 2) + (shouldShowProgramsMenu(programItems) ? 1 : 0) + (isTeacher ? 3 : 0);
  const HEADER_HIDE_LABELS_WIDTH = 650 + labeledPillCount * 120;
  const effectiveHideLabelsWidth = HEADER_HIDE_LABELS_WIDTH * zoomLevel;
  // Teacher nav: show labels only when enough room, icons-only in between
  const showTeacherNavLabels = !isTeacher || width >= effectiveHideLabelsWidth;

  const openDiscoveryJourney = React.useCallback(
    async (journey) => {
      const journeyId = journey?.id ?? journey?.discovery_journey_id ?? journey;
      if (journeyId == null) return;

      setDiscoveryJourneyLoading(true);
      setDiscoveryJourneyError(null);
      setActiveModule("discoveryJourneys");
      try {
        const runtime = await apiGetDiscoveryJourneyRuntime(fetchWithAuth, journeyId, {
          studentEmail: lessonPlanStudentEmail || undefined,
        });
        setDiscoveryJourney(runtime);

        // The mastery map is a second call on purpose: the chain should paint
        // as soon as it can, and a slow rollup must not hold the map hostage.
        try {
          const map = await apiGetJourneyMasteryMap(fetchWithAuth, journeyId, {
            studentEmail: lessonPlanStudentEmail || undefined,
          });
          setDiscoveryJourneyMastery(map?.concepts || []);
        } catch (masteryError) {
          console.warn("[JOURNEY] Mastery map unavailable:", masteryError?.message);
          setDiscoveryJourneyMastery([]);
        }
      } catch (error) {
        setDiscoveryJourneyError(error?.message || "Could not open this journey");
        setDiscoveryJourney(null);
      } finally {
        setDiscoveryJourneyLoading(false);
      }
    },
    [fetchWithAuth, lessonPlanStudentEmail]
  );

  const closeDiscoveryJourney = React.useCallback(() => {
    discoveryJourneyLoopRef.current = false;
    setDiscoveryJourney(null);
    setDiscoveryJourneyMastery([]);
    setDiscoveryJourneyError(null);
  }, []);

  /** Open one loop of the journey. A loop is a lesson plan. */
  const openJourneyLoop = React.useCallback(
    async (lessonPlanId) => {
      if (lessonPlanId == null) return;
      discoveryJourneyLoopRef.current = true;
      await openLessonPlan({ id: lessonPlanId });
    },
    [openLessonPlan]
  );

  /**
   * Closing a loop returns to the journey it belongs to.
   *
   * Only the deliberate exits route back: the X and "Finish lesson". The
   * navigate-away watcher must NOT, because there the student pressed another
   * top-bar module and sending them to the map would override the choice they
   * just made.
   */
  const closeLessonPlanFromJourney = React.useCallback(() => {
    const cameFromJourney = discoveryJourneyLoopRef.current && !!discoveryJourney;
    closeLessonPlan();
    if (cameFromJourney) {
      discoveryJourneyLoopRef.current = false;
      setActiveModule("discoveryJourneys");
    }
  }, [closeLessonPlan, discoveryJourney]);

  const finishLessonPlanFromJourney = React.useCallback(async () => {
    const cameFromJourney = discoveryJourneyLoopRef.current && !!discoveryJourney;
    await finishLessonPlan();
    if (cameFromJourney) {
      discoveryJourneyLoopRef.current = false;
      setActiveModule("discoveryJourneys");
      // Finishing a loop is exactly when the mastery map has new evidence to
      // show, so refresh it rather than leaving the student looking at bands
      // computed before the work they just did.
      const journeyId =
        discoveryJourney?.discovery_journey_id ?? discoveryJourney?.id ?? null;
      if (journeyId != null) {
        try {
          const map = await apiGetJourneyMasteryMap(fetchWithAuth, journeyId, {
            studentEmail: lessonPlanStudentEmail || undefined,
          });
          setDiscoveryJourneyMastery(map?.concepts || []);
        } catch (error) {
          console.warn("[JOURNEY] Could not refresh mastery:", error?.message);
        }
      }
    }
  }, [
    finishLessonPlan,
    discoveryJourney,
    fetchWithAuth,
    lessonPlanStudentEmail,
  ]);

  const lessonPlanLastModuleRef = useRef(null);
  useEffect(() => {
    if (!showLessonPlan) {
      lessonPlanLastModuleRef.current = null;
      return;
    }
    if (lessonPlanLastModuleRef.current === null) {
      lessonPlanLastModuleRef.current = activeModule;
      return;
    }
    if (lessonPlanLastModuleRef.current === activeModule) return;
    lessonPlanLastModuleRef.current = activeModule;

    // Back on the lesson: the asset excursion is over. Clearing here covers
    // every route home, including the stage's own X (which goes through
    // handleCloseModule and never touches the ref).
    if (activeModule === "lessonPlans") {
      lessonPlanAssetLaunchRef.current = false;
      setLessonPlanActiveBlockId(null);
      return;
    }

    // Asset launches leave the module on purpose; the companion brings it back.
    if (lessonPlanAssetLaunchRef.current) return;
    closeLessonPlan();
  }, [activeModule, showLessonPlan, closeLessonPlan]);

  // Latest values, so a flush triggered from an event handler (closing the
  // lesson) writes what is on screen rather than a stale closure.
  /**
   * Fold the deltas a write returned into the mastery list already on screen.
   *
   * The deltas carry the same shape as a mastery row, so merging by concept
   * beats a second GET: the band moves the moment the answer lands, and a
   * concept the batch did not touch keeps the value it had.
   */
  const applyMasteryDeltas = React.useCallback((deltas) => {
    if (!Array.isArray(deltas) || deltas.length === 0) return;
    const lessonScoped = deltas.filter(
      (delta) => (delta?.scope_type || "lesson") === "lesson"
    );
    if (lessonScoped.length === 0) return;

    setLessonPlanMastery((previous) => {
      const byKey = new Map(
        (previous || []).map((row) => [row.concept_key, row])
      );
      lessonScoped.forEach((delta) => {
        byKey.set(delta.concept_key, {
          ...(byKey.get(delta.concept_key) || {}),
          ...delta,
        });
      });
      return Array.from(byKey.values());
    });
  }, []);

  /**
   * Record how the student is exploring. Never awaited by a caller and never
   * surfaced as an error: this is evidence about the session, not part of it.
   */
  const handleLessonExplorationEvent = React.useCallback(
    (event) => {
      if (!event?.event_type || !lessonPlanPersists) return;
      lessonExplorationBufferRef.current = [
        ...lessonExplorationBufferRef.current,
        event,
      ];
    },
    [lessonPlanPersists]
  );

  /**
   * Send one free-text answer to Saras and write the verdict back onto the
   * block, so the feedback survives a step change and the debounced save.
   *
   * Only the block id and the text travel: the prompt, rubric and concept come
   * from the lesson server-side.
   */
  const handleLessonAiEvaluate = React.useCallback(
    async (blockId, blockType, value) => {
      const runtime = lessonPlanSaveInputsRef.current?.runtime;
      const lessonPlanId = runtime?.lesson_plan_id;
      // A teacher run asks for feedback with persist=false: the server scores
      // the text but writes no response row and moves no mastery.
      if (!lessonPlanId || !lessonPlanStudentEmail || !blockId) return;

      const text =
        typeof value === "string" ? value : value?.text ?? value?.value ?? "";
      if (!String(text).trim()) return;

      const step = (runtime.steps || []).find((candidate) =>
        (candidate.blocks || []).some((block) => block.id === blockId)
      );
      if (!step) return;

      try {
        const result = await apiEvaluateLessonAnswer(
          fetchWithAuth,
          lessonPlanStudentEmail,
          lessonPlanId,
          { stepKey: step.step_key, blockId, text, persist: lessonPlanPersists }
        );
        setLessonPlanSessionState((previous) =>
          recordAiResult(previous, blockId, {
            score: result?.ai_score ?? null,
            feedback: result?.ai_feedback ?? null,
          })
        );
        applyMasteryDeltas(result?.mastery);
      } catch (error) {
        // A lesson must keep running when Saras cannot answer. The written
        // answer is already saved; only the feedback is missing.
        console.warn("[LESSON] Could not evaluate answer:", error?.message);
      }
    },
    [fetchWithAuth, lessonPlanStudentEmail, lessonPlanPersists, applyMasteryDeltas]
  );

  // applyMasteryDeltas is declared above the saver, but the saver is a
  // useCallback that must not re-create on every mastery change; a ref keeps
  // its dependency list stable.
  const applyMasteryDeltasRef = useRef(null);
  applyMasteryDeltasRef.current = applyMasteryDeltas;

  const lessonPlanSaveInputsRef = useRef(null);
  // closeLessonPlan is declared earlier in this component, so it reaches the
  // saver through a ref rather than a forward reference.
  const saveLessonPlanProgressRef = useRef(null);
  const closeLessonPlanRef = useRef(null);
  lessonPlanSaveInputsRef.current = {
    runtime: lessonPlanRuntime,
    sessionState: lessonPlanSessionState,
    stepIndex: lessonPlanStepIndex,
  };

  const saveLessonPlanProgress = React.useCallback(async () => {
    const inputs = lessonPlanSaveInputsRef.current;
    if (!inputs?.runtime || !lessonPlanPersists) return;
    if (!lessonPlanHydratedRef.current) return;

    const { runtime, sessionState, stepIndex } = inputs;
    const snapshot = JSON.stringify({ state: sessionState, index: stepIndex });
    if (snapshot === lessonPlanLastSavedRef.current) return;

    const lessonPlanId = runtime.lesson_plan_id;
    const steps = runtime.steps || [];
    try {
      await apiSaveLessonPlanState(
        fetchWithAuth,
        lessonPlanStudentEmail,
        lessonPlanId,
        {
          stateJson: sessionState,
          lastActiveStepKey: steps[stepIndex]?.step_key || null,
          stepIndex: Math.max(0, stepIndex),
          visitedThroughIndex: Math.max(0, stepIndex),
        }
      );
      const written = await apiRecordLessonResponses(
        fetchWithAuth,
        lessonPlanStudentEmail,
        lessonPlanId,
        buildResponsePayload(steps, sessionState)
      );
      lessonPlanLastSavedRef.current = snapshot;

      // The write already recomputed mastery for whatever it touched, so the
      // bands move without a second round trip.
      applyMasteryDeltasRef.current?.(written?.mastery);

      // Exploration events ride out on the same debounce. Taken from the
      // buffer before the await so events arriving mid-flight are not lost,
      // and put back on failure rather than dropped.
      const pendingEvents = lessonExplorationBufferRef.current;
      if (pendingEvents.length) {
        lessonExplorationBufferRef.current = [];
        try {
          await apiRecordExplorationEvents(
            fetchWithAuth,
            lessonPlanStudentEmail,
            lessonPlanId,
            pendingEvents
          );
        } catch (eventError) {
          lessonExplorationBufferRef.current = [
            ...pendingEvents,
            ...lessonExplorationBufferRef.current,
          ];
          console.warn(
            "[LESSON] Could not record exploration:",
            eventError?.message
          );
        }
      }
    } catch (error) {
      console.warn("[LESSON] Could not save progress:", error?.message);
    }
  }, [fetchWithAuth, lessonPlanPersists, lessonPlanStudentEmail]);

  saveLessonPlanProgressRef.current = saveLessonPlanProgress;
  closeLessonPlanRef.current = closeLessonPlan;

  /** Debounced persistence of lesson progress + answered checks. */
  useEffect(() => {
    if (!showLessonPlan || !lessonPlanRuntime || !lessonPlanPersists) return;
    if (!lessonPlanHydratedRef.current) return;

    if (lessonPlanSaveTimeoutRef.current) {
      clearTimeout(lessonPlanSaveTimeoutRef.current);
    }
    lessonPlanSaveTimeoutRef.current = setTimeout(saveLessonPlanProgress, 1200);

    return () => {
      if (lessonPlanSaveTimeoutRef.current) {
        clearTimeout(lessonPlanSaveTimeoutRef.current);
        lessonPlanSaveTimeoutRef.current = null;
      }
    };
  }, [
    saveLessonPlanProgress,
    lessonPlanPersists,
    lessonPlanRuntime,
    lessonPlanSessionState,
    lessonPlanStepIndex,
    showLessonPlan,
  ]);

  useEffect(() => {
    if (!showJourney || !journeyRuntime || !activeJourneyStudentId || activeJourneyStudentId === "Guest") return;
    if (isPreviewingStudentJourney) return;
    if (!journeyStateHydratedRef.current) return;

    const journeyId =
      journeyRuntime?.journey_id ?? journeyRuntime?.id ?? null;

    if (journeyId == null) return;

    const runtimeSteps = Array.isArray(journeyRuntime?.steps)
      ? journeyRuntime.steps
      : Array.isArray(journeyRuntime?.runtime?.steps)
        ? journeyRuntime.runtime.steps
        : [];

    const savedStepIndex = wonderLabsDirectLaunchRef.current && isWonderLabsLearningBeatsEnabled()
      ? wonderLabsCheckpointStepRef.current : journeyStepIndex;
    const activeStep = runtimeSteps[savedStepIndex] || null;
    const payload = {
      session_state: normalizeJourneySessionState(journeySessionState),
      step_index: savedStepIndex,
      visited_through_index: journeyVisitedThroughIndex,
    };
    const serialized = JSON.stringify(payload);

    // In R2 an earlier in-flight PUT may still replace the server state.
    // Queue even a "same as last saved" snapshot so a quick Next/Back action
    // cannot leave the older in-flight value as the final server version.
    const queuedR2Save = wonderLabsDirectLaunchRef.current && isWonderLabsLearningBeatsEnabled();
    if (!queuedR2Save && serialized === lastSavedJourneyStateRef.current) return;

    if (journeySaveTimeoutRef.current) {
      clearTimeout(journeySaveTimeoutRef.current);
    }

    journeySaveTimeoutRef.current = setTimeout(() => {
      if (queuedR2Save) {
        journeySaveTimeoutRef.current = null;
        queueWonderLabsR2Save(journeyId, activeJourneyStudentId, payload,
          activeStep?.step_id || activeStep?.id || null
        ).catch((error) => {
          console.error("[WONDERLABS R2] Failed to save state:", error);
        });
        return;
      }
      axios.put(
        `${FASTAPI_BASE_URL}/student/${encodeURIComponent(activeJourneyStudentId)}/journeys/${journeyId}/state`,
        {
          state_json: payload,
          last_active_step_id:
            activeStep?.step_id || activeStep?.id || null,
        },
        authToken
          ? {
              headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
              },
            }
          : undefined
      )
        .then(() => {
          lastSavedJourneyStateRef.current = serialized;
        })
        .catch((error) => {
          console.error("[JOURNEY] Failed to save state:", error);
        })
        .finally(() => {
          journeySaveTimeoutRef.current = null;
        });
    }, 500);
  }, [
    showJourney,
    journeyRuntime,
    activeJourneyStudentId,
    isPreviewingStudentJourney,
    journeySessionState,
    journeyStepIndex,
    journeyVisitedThroughIndex,
  ]);

  useEffect(() => {
    const normalizedUserId = String(user_id || "").trim().toLowerCase();

    if (!canAccessSummerCampJourneys) return;
    if (!normalizedUserId || normalizedUserId === "guest") return;
    if (!authToken) return;
    if (activeModule !== "home") return;
    if (showJourney || journeyLoading) return;

    const promptKey = normalizedUserId;
    if (resumeJourneyPromptedForUserRef.current === promptKey) return;
    if (resumeJourneyCheckInFlightRef.current) return;

    let cancelled = false;
    resumeJourneyCheckInFlightRef.current = true;
    resumeJourneyPromptedForUserRef.current = promptKey;

    const maybePromptToResumeJourney = async () => {
      try {
        const catalogResponse = await axios.get(`${FASTAPI_BASE_URL}/journeys`, {
          params: { board: "saras" },
        });

        if (cancelled) return;

        const rows = Array.isArray(catalogResponse.data)
          ? catalogResponse.data
          : [];
        const journeyBySlug = {};

        rows.forEach((journey) => {
          const slug = String(journey?.slug || "").trim();
          if (slug) journeyBySlug[slug] = journey;
        });

        const availableJourneys = SUMMER_CAMP_DAYS.map((item) => ({
          ...item,
          journey: journeyBySlug[item.slug] || null,
        })).filter((item) => Number.isFinite(Number(item?.journey?.id)));

        if (!availableJourneys.length) {
          resumeJourneyPromptedForUserRef.current = promptKey;
          return;
        }

        const stateResponses = await Promise.all(
          availableJourneys.map((item) =>
            axios
              .get(
                `${FASTAPI_BASE_URL}/student/${encodeURIComponent(normalizedUserId)}/journeys/${Number(item.journey.id)}/state`,
                authToken
                  ? {
                      headers: {
                        Authorization: `Bearer ${authToken}`,
                      },
                    }
                  : undefined
              )
              .then((response) => ({ item, data: response.data }))
              .catch(() => null)
          )
        );

        if (cancelled) return;

        const resumableJourneys = stateResponses
          .filter(Boolean)
          .map(({ item, data }) => ({
            item,
            data,
            updatedAtMs: data?.updated_at ? Date.parse(data.updated_at) : NaN,
          }))
          .filter(({ data, updatedAtMs }) =>
            Number.isFinite(updatedAtMs) && hasMeaningfulJourneyState(data?.state_json)
          )
          .sort((a, b) => b.updatedAtMs - a.updatedAtMs);

        if (!resumableJourneys.length) {
          resumeJourneyPromptedForUserRef.current = promptKey;
          return;
        }

        const latest = resumableJourneys[0];
        const promptTitle = t("Continue Journey");
        const promptMessage = t(
          `Continue ${latest.item.storyTitle} where you left off?`
        );

        if (Platform.OS === "web" && typeof window !== "undefined" && window.confirm) {
          resumeJourneyPromptedForUserRef.current = promptKey;
          const confirmed = window.confirm(`${promptTitle}

${promptMessage}`);
          if (confirmed && !cancelled) {
            openJourney(Number(latest.item.journey.id));
          }
          return;
        }

        resumeJourneyPromptedForUserRef.current = promptKey;

        Alert.alert(promptTitle, promptMessage, [
          { text: t("Not now"), style: "cancel" },
          {
            text: t("Continue"),
            onPress: () => {
              if (!cancelled) openJourney(Number(latest.item.journey.id));
            },
          },
        ]);
      } catch (error) {
        console.debug("[JOURNEY] Resume prompt check skipped:", error);
      } finally {
        resumeJourneyCheckInFlightRef.current = false;
      }
    };

    maybePromptToResumeJourney();

    return () => {
      cancelled = true;
      resumeJourneyCheckInFlightRef.current = false;
    };
  }, [
    activeModule,
    canAccessSummerCampJourneys,
    hasMeaningfulJourneyState,
    journeyLoading,
    showJourney,
    t,
    user_id,
    authToken,
  ]);

  // BDD 12/08/2025
  // ✨ Fallback-capable PWO picker (works for collections + curriculum)
  function openPwoPicker(
    topicId,
    topicLabel,
    _authToken = authToken,
    _selectedSecondaryLang = selectedSecondaryLang,
    _chap_id = null
  ) {
    const tnode = topicNodeById.get(topicId);

    // const labelForPwo = (p, index) =>
    //   (p?.display_name || p?.name || `${t("Scene")} ${index + 1}`);

    // BDD 12/22/2025
    const labelForPwo = (p, index) => {
      const pwoName = formatPwoName((p?.name || "").trim()); // often already "PWO - scene"
      const sceneLabel = formatPwoName(he.decode((
        p?.display_name || p?.scene_title || p?.scene_name || ""
      ).trim()));

      // If we already have a full label in name, prefer it
      if (pwoName && sceneLabel) {
        const a = pwoName.toLowerCase();
        const b = sceneLabel.toLowerCase();
        if (a.includes(b)) return pwoName;              // avoid "PWO - scene - scene"
        return `${pwoName} - ${sceneLabel}`;            // if name is only PWO title
      }

      return pwoName || sceneLabel || `${t("Scene")} ${index + 1}`;
    };

    // helper to show the sheet from an array of pwos
    const showFromPwos = (pwos = []) => {
      const rows = (pwos || []).map((p, i) => ({
        key: `${p?.pwo_source_id}|${p?.scene_name}|${i}`,
        label: labelForPwo(p, i),
        icon: "cube-outline",
        pwo_source_id: p?.pwo_source_id,
        scene_name: p?.scene_name,
        watched: false,
        watchCount: 0,
        countLoading: true,
        onPress: () => {
          dismissPicker();
          setSparkTopicId(topicId);
          handlePWOClick(
            p?.pwo_source_id,
            p?.scene_name,
            _authToken,
            _selectedSecondaryLang,
            _chap_id,
            topicId
          );
        },
      }));

      if (!rows.length) {
        Alert.alert(t("No scenes"), t("This topic has no 3D scenes yet."));
        return;
      }
      if (rows.length === 1) {
        rows[0].onPress();
        return;
      }
      setPicker({ visible: true, title: `${topicLabel} — ${t("Scenes")}`, rows, icon: "cube-outline" });

      // Async fetch watch counts and merge into rows
      fetchPickerEngagementCounts().then((counts) => {
        setPicker((prev) => {
          if (!prev.visible) return prev;
          const updated = prev.rows.map((r) => {
            const cnt = counts?.pwos?.[`${r.pwo_source_id}|${r.scene_name}`] || 0;
            return { ...r, watched: cnt > 0, watchCount: cnt, countLoading: false };
          });
          return { ...prev, rows: updated };
        });
      });
    };

    if (tnode) {
      // BDD 12/09/2025 Localization For Collections
      console.log("[openPwoPicker] COLLECTIONS path", {
        topicId,
        topicLabel,
        pwos: (tnode.pwos || []).map((p, i) => ({
          i,
          name: p.name,
          display_name: p.display_name,
          pwo_source_id: p.pwo_source_id,
          scene_name: p.scene_name,
        })),
      });

      // collections path (unchanged, but now can use display_name if backend sends it)
      showFromPwos(tnode.pwos);
      return;
    }

    // ⬇️ curriculum fallback: resolve board topic id then fetch content once
    const realTid = resolveBoardTopicId(topicId);
    if (!realTid) {
      Alert.alert(t("Not available"), t("This topic is not available yet."));
      return;
    }


    const curriculumLang = resolveCurriculumLang(langRef.current || selectedSecondaryLang);
    axios
      .get(`${FASTAPI_BASE_URL}/content/${realTid}`, {
        params: { language_id: languageID, user_id, lang: curriculumLang },
      })
      .then(({ data }) => {
        // data.pwos: { name, display_name?, pwo_source_id, scene_name, ... }
        showFromPwos(data?.pwos || []);
      })
      .catch((err) => {
        console.debug("openPwoPicker fallback failed:", err);
        Alert.alert(t("Not available"), t("Couldn’t load scenes for this topic."));
      });
  }


  // BDD 02/15/2026 - test/healthCheckpwo
    const fetchPwosForTopic = async (topicId, _selectedSecondaryLang = selectedSecondaryLang) => {
    // 1) collections path
    const tnode = topicNodeById?.get?.(topicId);
    if (tnode && Array.isArray(tnode.pwos)) {
      return tnode.pwos || [];
    }

    // 2) curriculum fallback path (exactly like openPwoPicker)
    const realTid = resolveBoardTopicId(topicId);
    if (!realTid) return [];

    const curriculumLang = resolveCurriculumLang(langRef.current || _selectedSecondaryLang);

    try {
      const { data } = await axios.get(`${FASTAPI_BASE_URL}/content/${realTid}`, {
        params: { language_id: languageID, user_id, lang: curriculumLang },
      });
      return data?.pwos || [];
    } catch (err) {
      console.debug("[PWO QA] fetchPwosForTopic failed:", { topicId, realTid }, err);
      return [];
    }
    };

  // BDD 02/15/2026 - test/healthCheckpwo
    const buildPwoQaListForVisibleTopics = async () => {
      console.log("[PWO QA] Build List clicked", {
        topics: topicsFlatForChapterWithCounts?.length || 0,
        selectedChapterId,
      });

      const topics = topicsFlatForChapterWithCounts || [];
      if (!topics.length) {
        console.warn("[PWO QA] No visible topics to build from.");
        return;
      }

      const items = [];
      for (let idx = 0; idx < topics.length; idx++) {
        const t = topics[idx];
        const topicId = t.topicId ?? t.topic_id;
        if (!topicId) continue;

        const pwos = await fetchPwosForTopic(topicId, selectedSecondaryLang);

        // pwos expected shape (per your comments):
        // { name, display_name?, pwo_source_id, scene_name, ... }
        for (let i = 0; i < (pwos || []).length; i++) {
          const p = pwos[i];
          const pwoID = p?.pwo_source_id;
          const sceneName = p?.scene_name;
          if (!pwoID || !sceneName) continue;

          items.push({
            pwoID,
            sceneName,
            topicId,
            chapterId: t.chapterId ?? t.chapter_id ?? selectedChapterId ?? null,
            // Keep a friendly title similar to picker label
            title: formatPwoName(
              (p?.name && p?.display_name)
                ? (p.name.toLowerCase().includes(String(p.display_name).toLowerCase()) ? p.name : `${p.name} - ${p.display_name}`)
                : (p?.name || p?.display_name || `${pwoID} - ${sceneName}`)
            ),
          });

          if (pwoQaMaxItems && items.length >= pwoQaMaxItems) break;
        }

        if (pwoQaMaxItems && items.length >= pwoQaMaxItems) break;
      }

      console.log("[PWO QA] Build List done", { items: items.length });
      setPwoQaItems(items);
      setPwoQaIndex(0);
      setPwoQaResults([]);
    };

  // BDD 12/08/2025
  // ✨ Fallback-capable Video picker (works for collections + curriculum)
  // // BDD 12/08/2025 - try 2
  // function openVideoPicker(
  //   topicId,
  //   topicLabel,
  //   _authToken = authToken,
  //   _chap_id = null,
  //   _selectedSecondaryLang = selectedSecondaryLang  // 👈 new param, default for safety
  // ) {
  //   const tnode = topicNodeById.get(topicId);

  //   // BDD 03/24/2026
  //   console.log("[openVideoPicker][collection debug]", {
  //     topicId,
  //     tnodeExists: !!tnode,
  //     tnodeVideosLen: Array.isArray(tnode?.videos) ? tnode.videos.length : null,
  //     tnodeFirstVideo: tnode?.videos?.[0]?.name,
  //   });

  //   const labelForVideo = (v, index) =>
  //     (v?.display_name || v?.name || `${t("Segment")} ${index + 1}`);

  //   // helper to show the sheet from an array of videos
  //   const showFromVideos = (videos = []) => {
  //     const rows = (videos || []).map((v, i) => {
  //       const label = labelForVideo(v, i);
  //       return {
  //         key: `${v?.source_id}|${v?.tag_id}|${i}`,
  //         label,
  //         source_id: v?.source_id,
  //         tag_id: v?.tag_id,
  //         watched: false,
  //         watchCount: 0,
  //         countLoading: true,
  //         onPress: () => {
  //           dismissPicker();
  //           setSparkTopicId(topicId);
  //           handleVideoClick(
  //             v?.source_id,
  //             v?.tag_id,
  //             _authToken,
  //             _chap_id,
  //             topicId,
  //             false,
  //             null,
  //             null,
  //             label
  //           );
  //         },
  //       };
  //     });

  //     if (!rows.length) {
  //       Alert.alert(t("No videos"), t("This topic has no videos yet."));
  //       return;
  //     }
  //     if (rows.length === 1) {
  //       rows[0].onPress();
  //       return;
  //     }
  //     setPicker({ visible: true, title: `${topicLabel} — ${t("Videos")}`, rows, icon: "play-circle-outline" });

  //     // Async fetch watch counts and merge into rows
  //     fetchPickerEngagementCounts().then((counts) => {
  //       setPicker((prev) => {
  //         if (!prev.visible) return prev;
  //         const updated = prev.rows.map((r) => {
  //           const cnt = counts?.videos?.[`${r.source_id}|${r.tag_id}`] || 0;
  //           return { ...r, watched: cnt > 0, watchCount: cnt, countLoading: false };
  //         });
  //         return { ...prev, rows: updated };
  //       });
  //     });
  //   };

  //   if (tnode) {
  //     // collections path
  //     showFromVideos(tnode.videos);
  //     return;
  //   }

  //   // ⬇️ curriculum fallback
  //   const realTid = resolveBoardTopicId(topicId);
  //   if (!realTid) {
  //     Alert.alert(t("Not available"), t("This topic is not available yet."));
  //     return;
  //   }

  //   // ✅ Prefer the explicit arg; fall back to ref just in case
  //   const curriculumLang = resolveCurriculumLang(
  //     _selectedSecondaryLang || langRef.current || selectedSecondaryLang
  //   );

  //   console.log("[openVideoPicker] curriculum fallback", {
  //     topicId: realTid,
  //     selectedSecondaryLang,
  //     _selectedSecondaryLang,
  //     langRef: langRef.current,
  //     curriculumLang,
  //     languageIDVideo,
  //   });

  //   axios
  //     .get(`${FASTAPI_BASE_URL}/content/${realTid}`, {
  //       params: {
  //         // For VideoName lookup (title)
  //         language_id: languageIDVideo,
  //         user_id,
  //         // For localization_runtime (video_tag labels)
  //         lang: curriculumLang,
  //       },
  //     })
  //     .then(({ data }) => {
  //       // data.videos: { name, display_name?, source_id, tag_id, ... }
  //       showFromVideos(data?.videos || []);
  //     })
  //     .catch((err) => {
  //       console.debug("openVideoPicker fallback failed:", err);
  //       Alert.alert(
  //         t("Not available"),
  //         t("Couldn’t load videos for this topic.")
  //       );
  //     });
  // }

  // BDD 03/24/2026 - handle no tagID videos for collection
  function openVideoPicker(
    topicId,
    topicLabel,
    _authToken = authToken,
    _chap_id = null,
    _selectedSecondaryLang = selectedSecondaryLang,  // 👈 new param, default for safety
    _preferredVideos = null
  ) {
    const tnode = topicNodeById.get(topicId);

    // BDD 03/24/2026
    console.log("[openVideoPicker][collection debug]", {
      topicId,
      tnodeExists: !!tnode,
      tnodeVideosLen: Array.isArray(tnode?.videos) ? tnode.videos.length : null,
      tnodeFirstVideo: tnode?.videos?.[0]?.name,
    });

    // const labelForVideo = (v, index) =>
    //   (v?.display_name || v?.name || `${t("Segment")} ${index + 1}`);

    // BDD 04/27/2026 - DEBUG
    const fixMojibake = (text) => {
      if (!text || typeof text !== "string") return text;

      // Only attempt repair when classic UTF-8-as-Latin1 mojibake appears
      if (!/[ÃÂ]/.test(text)) return text;

      try {
        return decodeURIComponent(
          escape(text)
        );
      } catch {
        return text;
      }
    };

    // BDD 04/27/2026 - DEBUG
    // const labelForVideo = (v, index) =>
    //   (v?.tag_id == null
    //     ? (v?.name || v?.display_name || `${t("Segment")} ${index + 1}`)
    //     : (v?.display_name || v?.name || `${t("Segment")} ${index + 1}`));

    // // BDD 04/27/2026 - DEBUG
    // const labelForVideo = (v, index) => {
    //   const rawLabel =
    //     v?.tag_id == null
    //       ? (v?.name || v?.display_name || `${t("Segment")} ${index + 1}`)
    //       : (v?.display_name || v?.name || `${t("Segment")} ${index + 1}`);

    //   return fixMojibake(rawLabel);
    // };

    // BDD 05/02/2026
    // For collection playback and picker display, prefer display_name first for all videos.
    // Resolved collections may keep original saved English `name` but attach localized
    // `display_name` at runtime. If we prefer `name` for no-tag videos, PT/ES/etc. will
    // incorrectly show English labels even though localization already ran.
    const labelForVideo = (v, index) => {
      const rawLabel =
        v?.display_name || v?.name || `${t("Segment")} ${index + 1}`;

      return fixMojibake(rawLabel);
    };

    // helper to show the sheet from an array of videos
    const showFromVideos = (videos = []) => {
      // BDD 04/27/2026 - DEBUG
      // console.log("[openVideoPicker][showFromVideos INPUT]", {
      //   topicId,
      //   count: Array.isArray(videos) ? videos.length : null,
      //   videos: Array.isArray(videos)
      //     ? videos.map(v => ({
      //         id: v?.id,
      //         source_id: v?.source_id,
      //         name: v?.name,
      //         display_name: v?.display_name,
      //         tag_id: v?.tag_id,
      //         tag_start_time: v?.tag_start_time,
      //       }))
      //     : videos,
      // });
      const rows = (videos || []).map((v, i) => {
        const label = labelForVideo(v, i);
        return {
          key: `${v?.source_id}|${v?.tag_id}|${i}`,
          label,
          source_id: v?.source_id,
          tag_id: v?.tag_id,
          watched: false,
          watchCount: 0,
          countLoading: true,
          onPress: () => {
            dismissPicker();
            setSparkTopicId(topicId);
            handleVideoClick(
              v?.source_id,
              v?.tag_id,
              _authToken,
              _chap_id,
              topicId,
              false,
              null,
              null,
              label
            );
          },
        };
      });

      if (!rows.length) {
        Alert.alert(t("No videos"), t("This topic has no videos yet."));
        return;
      }
      if (rows.length === 1) {
        rows[0].onPress();
        return;
      }
      setPicker({ visible: true, title: `${topicLabel} — ${t("Videos")}`, rows, icon: "play-circle-outline" });

      // Async fetch watch counts and merge into rows
      fetchPickerEngagementCounts().then((counts) => {
        setPicker((prev) => {
          if (!prev.visible) return prev;
          const updated = prev.rows.map((r) => {
            const cnt = counts?.videos?.[`${r.source_id}|${r.tag_id}`] || 0;
            return { ...r, watched: cnt > 0, watchCount: cnt, countLoading: false };
          });
          return { ...prev, rows: updated };
        });
      });
    };

    if (tnode) {
      // collections path
      const videosForPicker =
        Array.isArray(tnode?.videos) && tnode.videos.length > 0
          ? tnode.videos
          : (Array.isArray(_preferredVideos) ? _preferredVideos : []);

      console.log("[openVideoPicker] COLLECTIONS path", {
        topicId,
        tnodeVideosLen: Array.isArray(tnode?.videos) ? tnode.videos.length : null,
        preferredVideosLen: Array.isArray(_preferredVideos) ? _preferredVideos.length : null,
        finalVideosLen: Array.isArray(videosForPicker) ? videosForPicker.length : null,
        firstVideo: videosForPicker?.[0]?.name,
      });

      showFromVideos(videosForPicker);
      return;
    }

    // ⬇️ curriculum fallback
    const realTid = resolveBoardTopicId(topicId);
    if (!realTid) {
      Alert.alert(t("Not available"), t("This topic is not available yet."));
      return;
    }

    // ✅ Prefer the explicit arg; fall back to ref just in case
    const curriculumLang = resolveCurriculumLang(
      _selectedSecondaryLang || langRef.current || selectedSecondaryLang
    );

    console.log("[openVideoPicker] curriculum fallback", {
      topicId: realTid,
      selectedSecondaryLang,
      _selectedSecondaryLang,
      langRef: langRef.current,
      curriculumLang,
      languageIDVideo,
    });

    axios
      .get(`${FASTAPI_BASE_URL}/content/${realTid}`, {
        params: {
          // For VideoName lookup (title)
          language_id: languageIDVideo,
          user_id,
          // For localization_runtime (video_tag labels)
          lang: curriculumLang,
        },
      })
      .then(({ data }) => {
        // BDD 04/27/2026 - DEBUG
        // console.log("[openVideoPicker][API response debug]", {
        //   topicId: realTid,
        //   languageIDVideo,
        //   curriculumLang,
        //   videosLen: Array.isArray(data?.videos) ? data.videos.length : null,
        //   videos: Array.isArray(data?.videos)
        //     ? data.videos.map(v => ({
        //         id: v?.id,
        //         source_id: v?.source_id,
        //         name: v?.name,
        //         display_name: v?.display_name,
        //         tag_id: v?.tag_id,
        //         tag_start_time: v?.tag_start_time,
        //       }))
        //     : data?.videos,
        // });
        // data.videos: { name, display_name?, source_id, tag_id, ... }
        showFromVideos(data?.videos || []);
      })
      .catch((err) => {
        console.debug("openVideoPicker fallback failed:", err);
        Alert.alert(
          t("Not available"),
          t("Couldn’t load videos for this topic.")
        );
      });
  }
  useEffect(() => {
    try { sessionStorage.setItem(PWO_SCALE_KEY, String(pwoScale)); } catch { }
  }, [pwoScale]);


  const zoomPwo = (delta) =>
    setPwoScale(s =>
      Math.min(
        MAX_PWO_ZOOM,
        Math.max(MIN_PWO_ZOOM, +(s + delta).toFixed(2))
      )
    );

  const resetPwoZoom = () => setPwoScale(1);


  useEffect(() => {
    const handleVisibilityChange = () => {
      console.log("👁️ Document visibility:", document.visibilityState);

      // When returning to the tab, nudge the video decoder to resume rendering frames.
      // Browsers throttle background tabs and can pause video decoding while audio
      // continues via MSE buffers — a no-op seek forces the decoder to repaint.
      if (document.visibilityState === "visible" && videoRef?.current) {
        const v = videoRef.current;
        try {
          if (!v.paused && v.readyState >= 2) {
            v.currentTime = v.currentTime; // no-op seek to kick the decoder
            console.log("[VIDEO] nudged video decoder after tab return");
          }
        } catch {}
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  const activeModuleRef = useRef(activeModule);
  useEffect(() => {
    // every time activeModule state changes, update the ref immediately
    activeModuleRef.current = activeModule;
    // console.log("activeModule changed →", activeModule);

    // Save to sessionStorage for page refresh restoration
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.setItem('activeModule', activeModule);
    }
  }, [activeModule]);

  // Save learningSubModule to sessionStorage for page refresh restoration
  useEffect(() => {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.setItem('learningSubModule', learningSubModule);
    }
  }, [learningSubModule]);

  // Save teacherDashboardView to sessionStorage for page refresh restoration
  useEffect(() => {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.setItem('teacherDashboardView', teacherDashboardView);
    }
  }, [teacherDashboardView]);

  const currentPwoIdRef = useRef(currentPwoId)
  useEffect(() => {
    // every time currentPwoId state changes, update the ref immediately
    currentPwoIdRef.current = currentPwoId;
    // console.log("currentPwoId changed →", currentPwoId);
  }, [currentPwoId]);

  const currentPwoSceneRef = useRef(currentPwoScene)
  useEffect(() => {
    // every time currentPwoId state changes, update the ref immediately
    currentPwoSceneRef.current = currentPwoScene;
    // console.log("currentPwoId changed →", currentPwoScene);
  }, [currentPwoScene]);

  const collectionCurriculum = React.useMemo(
    () => buildCollectionTree(collectionResolved, activeStudyCollection, t), // BDD 12/15/2025 - added t here
    [collectionResolved, activeStudyCollection, t]
  );

  // BDD 10/4/2025
  const topicNodeById = useMemo(() => {
    const map = new Map();
    (collectionCurriculum || []).forEach(level =>
      (level.subjects || []).forEach(s =>
        (s.chapters || []).forEach(c =>
          (c.topics || []).forEach(topic => map.set(topic.id, topic)) // BDD 12/15/2025 - cleaning to avoid confusing topic and t 
        )
      )
    );
    return map;
  }, [collectionCurriculum]);

  // Build a fast lookup: topic.id -> { board_topic_id, source_id }
  const collectionTopicMap = React.useMemo(() => {
    const map = new Map();
    const walk = (levels = []) => {
      levels.forEach(level => {
        (level.subjects || []).forEach(sub => {
          (sub.chapters || []).forEach(ch => {
            (ch.topics || []).forEach(t => {
              map.set(t.id, {
                board_topic_id: t.board_topic_id ?? null,
                source_id: t.source_id ?? null,
              });
            });
          });
        });
      });
    };
    walk(collectionCurriculum || []);
    return map;
  }, [collectionCurriculum]);

  // Parse "col-<collectionId>-t-<itemIdx>"
  function parseCollectionTopicKey(k) {
    const m = /^col-(\d+)-t-(\d+)$/.exec(String(k || ""));
    if (!m) return null;
    return { collectionId: Number(m[1]), itemIdx: Number(m[2]) };
  }

  // Fallback directly from the resolved payload if needed
  function fallbackBoardTopicIdFromResolved(key) {
    const info = parseCollectionTopicKey(key);
    if (!info || !collectionResolved?.items) return null;
    return collectionResolved.items[info.itemIdx]?.board_topic_id ?? null;
  }

  // Final resolvers you can call anywhere (e.g. toggleExpandTopic)
  function resolveBoardTopicId(keyOrId) {
    if (typeof keyOrId === "number") return keyOrId;
    const fromMap = collectionTopicMap.get(keyOrId)?.board_topic_id ?? null;
    return fromMap ?? fallbackBoardTopicIdFromResolved(keyOrId);
  }

  function resolveSourceTopicId(keyOrId) {
    if (typeof keyOrId === "number") return keyOrId;
    const fromMap = collectionTopicMap.get(keyOrId)?.source_id ?? null;
    const info = parseCollectionTopicKey(keyOrId);
    const fromResolved = info && collectionResolved?.items
      ? (collectionResolved.items[info.itemIdx]?.source_topic_id ??
        collectionResolved.items[info.itemIdx]?.topic_snapshot?.source_topic_id ?? null)
      : null;
    return fromMap ?? fromResolved;
  }

  // BDD 01/15/2026 - Summarize this topic AI ask
  function buildTopicScope(chapterId, topicId, realBoardTopicId, topicContentMaybe) {
    const sourceTopicId = resolveSourceTopicId(topicId);

    const topicName =
      (topicContentMaybe?.topic_name ||
        topicContentMaybe?.topicName ||
        topicContentMaybe?.name ||
        topicContentMaybe?.topic_title ||
        topicContentMaybe?.displayName ||
        "")?.trim?.() || "";

    const chapterName =
      (topicContentMaybe?.chapter_name ||
        topicContentMaybe?.chapterName ||
        "")?.trim?.() || "";

    return {
      chapterId,
      topicId,
      board_topic_id: realBoardTopicId ?? null,
      source_topic_id: sourceTopicId ?? null,
      topic_name: topicName,
      chapter_name: chapterName,
    };
  }

  // BDD 11/3/2025 - removing below useEffect as it is causing double calls to detailed collections opening.
  // useEffect(() => {
  //   if (preferredView !== 'collections') return;

  //   // Wait until we know what's available
  //   if (!Array.isArray(availableCollections) || availableCollections.length === 0) return;

  //   // If already selected, nothing to do (and mark done so we don't try again)
  //   if (activeStudyCollection) {
  //     const key = `${user_id || 'anon'}::${contentDb || 'default'}`;
  //     initAttemptedForBoardRef.current.add(key);
  //     return;
  //   }

  //   // Avoid repeats & races
  //   if (collectionsListLoading || collectionsDetailLoading || selectingRef.current) return;

  //   const key = `${user_id || 'anon'}::${contentDb || 'default'}`;
  //   if (initAttemptedForBoardRef.current.has(key)) return;

  //   // Mark BEFORE awaiting to prevent re-entrancy on re-render
  //   initAttemptedForBoardRef.current.add(key);
  //   selectingRef.current = true;

  //   (async () => {
  //     try {
  //       // Try server-remembered selection first
  //       let savedId = null;
  //       const saved = await apiGetActiveCollection({ user_id, base_board: contentDb });
  //       savedId = saved?.collection_id ?? null;

  //       const toOpen =
  //         (savedId && availableCollections.find(c => String(c.id) === String(savedId))) ||
  //         availableCollections.find(c => c.is_active) || // optional hint flag
  //         availableCollections[0]; // fallback: first available

  //       if (toOpen) {
  //         await openStudentCollection(toOpen, "line-1744-useEffect");
  //       }
  //     } catch (e) {
  //       console.warn('Auto-select collection failed', e);
  //       // Allow a retry later if it failed
  //       initAttemptedForBoardRef.current.delete(key);
  //     } finally {
  //       selectingRef.current = false;
  //     }
  //   })();
  //   // Only depend on stable scalars to avoid identity churn
  // }, [
  //   preferredView,
  //   user_id,
  //   contentDb,
  //   availableCollections.length,
  //   activeStudyCollection,
  //   collectionsListLoading,
  //   collectionsDetailLoading
  // ]);

  // Returns { collection_id } or null
  async function apiGetActiveCollection({ user_id, base_board }) {
    try {
      if (!user_id || !base_board) return null;
      const url = `${FASTAPI_BASE_URL}/collections/active`
        + `?user_id=${encodeURIComponent(user_id)}`
        + `&base_board=${encodeURIComponent(base_board)}`;
      const res = await fetch(url);
      if (!res.ok) return null;
      const body = await res.json();
      return body && body.collection_id != null ? body : null;
    } catch (e) {
      console.warn("apiGetActiveCollection failed", e);
      return null;
    }
  }

  // // Build: topic.id -> { board_topic_id, source_id }
  // const collectionTopicMap = React.useMemo(() => {
  //   const map = new Map();
  //   const walk = (levels=[]) => {
  //     levels.forEach(level => {
  //       (level.subjects || []).forEach(sub => {
  //         (sub.chapters || []).forEach(ch => {
  //           (ch.topics || []).forEach(t => {
  //             map.set(t.id, {
  //               board_topic_id: t.board_topic_id ?? null,
  //               source_id: t.source_id ?? null,
  //             });
  //           });
  //         });
  //       });
  //     });
  //   };
  //   walk(collectionCurriculum || []);
  //   return map;
  // }, [collectionCurriculum]);

  // function isCollectionTopicKey(k) {
  //   return typeof k === "string" && k.startsWith("col-");
  // }

  // function resolveBoardTopicIdFromTree(keyOrId) {
  //   if (!isCollectionTopicKey(keyOrId)) return typeof keyOrId === "number" ? keyOrId : null;
  //   return collectionTopicMap.get(keyOrId)?.board_topic_id ?? null;
  // }

  // function resolveSourceTopicIdFromTree(keyOrId) {
  //   if (!isCollectionTopicKey(keyOrId)) return typeof keyOrId === "number" ? keyOrId : null;
  //   return collectionTopicMap.get(keyOrId)?.source_id ?? null;
  // }

  //   // Map a "col-*-t-*" key to the actual board topic id
  // const resolveBoardTopicId = React.useCallback(
  //   (maybeKey) => {
  //     if (!isCollectionTopicKey(maybeKey)) {
  //       return typeof maybeKey === "number" ? maybeKey : null;
  //     }
  //     const meta = parseCollectionTopicKey(maybeKey);
  //     if (!meta || !collectionResolved?.items) return null;
  //     const item = collectionResolved.items[meta.itemIdx];
  //     return item?.board_topic_id ?? null;
  //   },
  //   [collectionResolved]
  // );

  // Map a "col-*-t-*" key to the actual source topic id (for quizzes)
  // const resolveSourceTopicId = React.useCallback(
  //   (maybeKey) => {
  //     if (!isCollectionTopicKey(maybeKey)) {
  //       return typeof maybeKey === "number" ? maybeKey : null;
  //     }
  //     const meta = parseCollectionTopicKey(maybeKey);
  //     if (!meta || !collectionResolved?.items) return null;
  //     const item = collectionResolved.items[meta.itemIdx];
  //     return item?.source_topic_id ?? null;
  //   },
  //   [collectionResolved]
  // );

  // useEffect(() => {
  //   if (autoFetchReferences && autoOpenPWO && autoPlayVideo) {
  //     setAutoWalkthroughMode(true);
  //   } else {
  //     setAutoWalkthroughMode(false);
  //   }
  // }, [autoFetchReferences, autoOpenPWO, autoPlayVideo]);
  // BDD 10/8/2025 - above was conflicting with my demo mode
  // auto effect (your existing one, with a guard)
  useEffect(() => {
    if (flags?.investor_mode) return; // demo owns it; don't touch
    setAutoWalkthroughMode(autoFetchReferences && (autoOpenPWO || autoPlayVideo));
  }, [flags?.investor_mode, autoFetchReferences, autoOpenPWO, autoPlayVideo]);

  // BDD 8/17/2025 - IQH3D and Leia and Android APK Related
  const runtimeRef = React.useRef(null);

  useEffect(() => {
    if (isAndroidApkWebView()) {
      runtimeRef.current = getAndroidRuntimeInfoSafe();
    }
  }, []);
  // BDD 10/12/2025
  // Warm demo videos as soon as the demo loads
  useEffect(() => {
    if (!flags?.investor_mode || !authToken) return;

    const vids = listDemoVideos(getDemoPreset());
    if (!vids.length) return;

    (async () => {
      // Gentle parallelism: warm in sequence to avoid a burst; switch to Promise.all if you prefer
      for (const v of vids) {
        try {
          if (v.videoID) {
            // await warmVideoForDemo(v.videoID, v.tagID, authToken, languageIDVideo);
            // BDD 12/31/2025 - Choice of EN - IN and EN - US
            const prewarmPriority =
              (Array.isArray(videoLanguagePriority) && videoLanguagePriority.length)
                ? videoLanguagePriority
                : [languageIDVideo];

            for (const langIdTry of prewarmPriority) {
              const ok = await warmVideoForDemo(v.videoID, v.tagID, authToken, langIdTry);
              if (ok) break;
            }

          } else if (v.uuid) {
            // (Optional) implement warm-by-uuid if you ever add uuid/version to the preset
            // await warmVideoForDemoByUuid(v.uuid, v.version, authToken);
          }
        } catch { }
      }
    })();
  }, [flags?.investor_mode, authToken, languageIDVideo]);

  // const waitUntilVoiceFinished = async () => {
  //   let retries = 0;
  //   while (!hasPlayed && retries < 40) {  // wait up to ~8 seconds
  //     await new Promise((res) => setTimeout(res, 200));
  //     retries++;
  //   }
  // };

  // useEffect(() => {
  //   if (Platform.OS === "web" && quizMode === "test") {
  //     const handleBlur = async () => {
  //       setTabSwitchCount((prev) => {
  //         const newCount = prev + 1;

  //         if (newCount === 1) {
  //           alert("⚠️ Warning: Please do not switch tabs during the test.");
  //         } else if (newCount === 2) {
  //           alert("🚨 Final Warning: Switching tabs again will submit the test.");
  //         } else if (newCount >= 3) {
  //           alert("❌ You switched tabs too many times. Your test will now be submitted.");
  //           handleSubmitTest();
  //           cleanupModule();
  //         }

  //         return newCount;
  //       });
  //     };

  //     window.addEventListener("blur", handleBlur);
  //     return () => window.removeEventListener("blur", handleBlur);
  //   }
  // }, [quizMode]);

  // useEffect(() => {
  //   if (Platform.OS === "web" && quizMode === "test") {
  //     const handleBlur = async () => {
  //       if (!tabSwitchDetectionEnabled) return; // ⛔ Skip if paused

  //       setTabSwitchCount((prev) => {
  //         const newCount = prev + 1;

  //         if (newCount === 1) {
  //           alert("⚠️ Warning: Please do not switch tabs during the test.");
  //         } else if (newCount === 2) {
  //           alert("🚨 Final Warning: Switching tabs again will submit the test.");
  //         } else if (newCount >= 3) {
  //           alert("❌ You switched tabs too many times. Your test will now be submitted.");
  //           handleSubmitTest();
  //           cleanupModule();
  //         }

  //         return newCount;
  //       });
  //     };

  //     window.addEventListener("blur", handleBlur);
  //     return () => window.removeEventListener("blur", handleBlur);
  //   }
  // }, [quizMode, tabSwitchDetectionEnabled]); // 👈 Ensure dependency is updated

  // useEffect(() => {
  //   if (Platform.OS === "web" && quizMode === "test") {
  //     const handleBlur = async () => {
  //       if (!tabSwitchDetectionEnabledRef.current) return; // ⛔ skip if paused

  //       setTabSwitchCount((prev) => {
  //         const newCount = prev + 1;

  //         if (newCount === 1) {
  //           alert("⚠️ Warning: Please do not switch tabs during the test.");
  //         } else if (newCount === 2) {
  //           alert("🚨 Final Warning: Switching tabs again will submit the test.");
  //         } else if (newCount >= 3) {
  //           alert("❌ You switched tabs too many times. Your test will now be submitted.");
  //           handleSubmitTest();
  //           cleanupModule();
  //         }

  //         return newCount;
  //       });
  //     };

  //     window.addEventListener("blur", handleBlur);
  //     return () => window.removeEventListener("blur", handleBlur);
  //   }
  // }, [quizMode]);

  // BDD 11/3/2025
  // // BDD 10/3/2025
  // useEffect(() => {
  //   let cancelled = false;
  //   async function run() {
  //     if (activeSidebarTab !== "collections") return;
  //     try {
  //       setCollectionsFetched(false);           // NEW: mark “not done yet”
  //       setCollectionsLoading(true);
  //       const list = await apiListAvailableCollections(user_id, contentDb);
  //       if (!cancelled) setAvailableCollections(list || []);
  //     } catch (e) {
  //       console.error("list available collections failed", e);
  //       if (!cancelled) setAvailableCollections([]);
  //     } finally {
  //       if (!cancelled) {
  //         setCollectionsLoading(false);
  //         setCollectionsFetched(true);          // NEW: fetch finished (success or fail)
  //       }
  //     }
  //   }
  //   run();
  //   return () => { cancelled = true; };
  // }, [activeSidebarTab, user_id, contentDb]);

  // BDD 11/3/2025
  // === COLL METRICS (lightweight debug) ===
  const COLL_DBG = false; // BDD 11/3/2025 keep it false for production, only use as true for debugging

  const collMetricsRef = useRef({
    listFetches: 0,
    lastListMs: null,
    lastListCount: 0,
    detailOpens: 0,
    lastDetailMs: null,
    lastDetailKB: null,
    lastOpenReason: null, // 'auto-orchestrator' | 'user-tap' | 'other'
  });

  function collLog(...args) {
    if (COLL_DBG) console.log("[COLL]", ...args);
  }

  // Expose metrics in DevTools for a quick glance (web only)
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.COLL_METRICS = collMetricsRef.current;
      collLog("COLL_METRICS available on window.COLL_METRICS");
    }
  }, []);

  // === PATCH 2025-11-03: reset module state on board change ===
  useEffect(() => {
    setActiveStudyCollection(null);
    setCollectionResolved(null);
    // Don’t change viewMode here; the orchestrator will handle it after the list fetch.
  }, [contentDb]);

  // === PATCH 2025-11-03: list fetch uses collectionsListLoading only ===
  // useEffect(() => {
  //   let cancelled = false;
  //   async function run() {
  //     if (activeSidebarTab !== "collections") return;
  //     try {
  //       setCollectionsFetched(false);
  //       setCollectionsListLoading(true);  // was: setCollectionsLoading(true)
  //       const list = await apiListAvailableCollections(user_id, contentDb);
  //       if (!cancelled) setAvailableCollections(list || []);
  //     } catch (e) {
  //       console.error("list available collections failed", e);
  //       if (!cancelled) setAvailableCollections([]);
  //     } finally {
  //       if (!cancelled) {
  //         setCollectionsListLoading(false); // was: setCollectionsLoading(false)
  //         setCollectionsFetched(true);
  //       }
  //     }
  //   }
  //   run();
  //   return () => { cancelled = true; };
  // }, [activeSidebarTab, user_id, contentDb]);
  // BDD 11/3/2025 - with some logs
  useEffect(() => {
    let cancelled = false;

    async function run() {
      if (activeSidebarTab !== "collections") return;
      try {
        setCollectionsFetched(false);
        setCollectionsListLoading(true);

        const t0 = (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();
        collLog("LIST start", { board: contentDb, user: user_id });

        const list = await apiListAvailableCollections(user_id, contentDb);

        const t1 = (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();
        const ms = Math.round(t1 - t0);

        if (!cancelled) {
          // Filter out collections with no items so they don't appear in the sidebar
          const filtered = (list || []).filter(c => c.item_count == null || c.item_count > 0);
          setAvailableCollections(filtered);
          collMetricsRef.current.listFetches += 1;
          collMetricsRef.current.lastListMs = ms;
          collMetricsRef.current.lastListCount = Array.isArray(list) ? list.length : 0;

          collLog(`LIST done in ${ms} ms`, {
            count: collMetricsRef.current.lastListCount,
            fetches: collMetricsRef.current.listFetches,
          });

          // BDD 12/30/2025 - Auto-switch to curriculum if no collections found for this board
          // BDD 01/18/2026 - Always auto-switch when no collections, this updates the tab label correctly
          const noCollectionsFound = !filtered.length;
          if (
            noCollectionsFound &&
            autoSwitchedToCurriculumRef.current !== contentDb
          ) {
            console.log("[AUTO-SWITCH] No collections found for board, auto-switching to curriculum view", {
              board: contentDb,
              listCount: Array.isArray(list) ? list.length : 'not-array',
              currentRef: autoSwitchedToCurriculumRef.current
            });
            collLog("No collections found for board, auto-switching to curriculum view", { board: contentDb });
            // Use setTimeout to defer the state update and avoid conflicts with other effects
            setTimeout(() => {
              console.log("[AUTO-SWITCH] Setting viewMode to curriculum");
              setViewMode("curriculum");
            }, 0);
            autoSwitchedToCurriculumRef.current = contentDb;
          } else {
            console.log("[AUTO-SWITCH] Skipping auto-switch", {
              noCollectionsFound,
              listCount: Array.isArray(list) ? list.length : 'not-array',
              currentRef: autoSwitchedToCurriculumRef.current,
              contentDb,
              refMatchesBoard: autoSwitchedToCurriculumRef.current === contentDb
            });
          }
        }
      } catch (e) {
        console.error("list available collections failed", e);
        if (!cancelled) {
          setAvailableCollections([]);
          // BDD 12/30/2025 - Also auto-switch on error since no collections available
          // BDD 01/18/2026 - Always auto-switch to update tab label
          if (autoSwitchedToCurriculumRef.current !== contentDb) {
            collLog("Collections fetch failed, auto-switching to curriculum view", { board: contentDb });
            setTimeout(() => {
              setViewMode("curriculum");
            }, 0);
            autoSwitchedToCurriculumRef.current = contentDb;
          }
        }
      } finally {
        if (!cancelled) {
          setCollectionsListLoading(false);
          setCollectionsFetched(true);
        }
      }
    }

    run();
    return () => { cancelled = true; };
  }, [activeSidebarTab, user_id, contentDb]);

  // // when user changes, reopen the gate and mark profile as not-fetched yet
  // useEffect(() => {
  //   initialSidebarSetRef.current = false;
  //   setProfileFetched(false);         // <- add this
  // }, [user_id]);

  // useEffect(() => {
  //   if (initialSidebarSetRef.current) return;  // only do this once per login
  //   if (!profileFetched) return;               // wait until profile fetch completes

  //   const desired = curriculumView ? 'learning' : 'collections';
  //   setActiveSidebarTab(desired);
  //   initialSidebarSetRef.current = true;
  // }, [profileFetched, curriculumView]);

  // BDD 10/3/2025 - giving up - as it does not remember the curriculum_view from login to login
  // and I do not have time. Later we will get back to it.
  // Reset per session (per login)
  // useEffect(() => {
  //   // session default: NOT curriculum view
  //   setCurriculumView(false);

  //   // clear any local cache so it doesn't carry over
  //   AsyncStorage.removeItem("curriculum_view").catch(() => {});

  //   // pick the default sidebar for a fresh session
  //   initialSidebarSetRef.current = false;
  //   setActiveSidebarTab("collections");
  // }, [user_id]);


  let lastBlurTime = 0;

  useEffect(() => {
    if (Platform.OS === "web" && quizMode === "test") {
      // const handleBlur = async () => {
      //   const now = Date.now();
      //   const timeSinceLastBlur = now - lastBlurTime;

      //   // Guard: Ignore if less than 800ms since last blur (likely accidental)
      //   if (timeSinceLastBlur < 800) {
      //     console.log("🟡 Ignored quick blur (likely touch or focus issue).");
      //     return;
      //   }

      //   lastBlurTime = now;

      //   if (!tabSwitchDetectionEnabledRef.current) return;

      //   setTabSwitchCount((prev) => {
      //     const newCount = prev + 1;

      //     if (newCount === 1) {
      //       alert("⚠️ Warning: Please do not switch tabs during the test.");
      //     } else if (newCount === 2) {
      //       alert("🚨 Final Warning: Switching tabs again will submit the test.");
      //     } else if (newCount >= 3) {
      //       alert("❌ You switched tabs too many times. Your test will now be submitted.");
      //       handleSubmitTest();
      //       cleanupModule();
      //     }

      //     return newCount;
      //   });
      // };

      const handleBlur = async () => {
        const now = Date.now();
        const timeSinceLastBlur = now - lastBlurTime;

        if (!tabSwitchFeatureEnabledRef.current) {
          console.log("🔕 Tab switch feature is globally disabled.");
          return;
        }

        if (timeSinceLastBlur < 800) {
          console.log("🟡 Ignored quick blur (likely touch or focus issue).");
          return;
        }

        lastBlurTime = now;

        if (!tabSwitchDetectionEnabledRef.current) return;

        setTabSwitchCount((prev) => {
          const newCount = prev + 1;

          if (newCount === 1) {
            alert("⚠️ Warning: Please do not switch tabs during the test.");
          } else if (newCount === 2) {
            alert("🚨 Final Warning: Switching tabs again will submit the test.");
          } else if (newCount >= 3) {
            alert("❌ You switched tabs too many times. Your test will now be submitted.");
            handleSubmitTest();
            cleanupModule();
          }

          return newCount;
        });
      };

      window.addEventListener("blur", handleBlur);
      return () => window.removeEventListener("blur", handleBlur);
    }
  }, [quizMode]);
  // BDD 11/3/2025
  // === PATCH 2025-11-03: unified collections orchestrator ===
  useEffect(() => {
    // Only operate when user is actually on Collections tab
    if (activeSidebarTab !== "collections") return;

    // Wait for the list to finish the first fetch
    if (!collectionsFetched) return;

    // Use a key so we only act once per {user,board}
    const key = `${user_id || 'anon'}::${contentDb || 'default'}`;
    if (autoHandledForKeyRef.current.has(key)) return;

    // 1) If empty, keep the collections tab selected (rightmost) - curriculum view will be shown
    // BDD 12/31/2025 - Removed auto-switch to history; user stays on collections tab
    if (noCollectionsForSure) {
      console.log("COLL ORCH: empty → staying on collections tab (curriculum view will be shown)");
      autoHandledForKeyRef.current.add(key);
      return;
    }

    // 2) If a collection is already active or detail is resolving, we're done
    if (activeStudyCollection || collectionsDetailLoading) {
      autoHandledForKeyRef.current.add(key);
      return;
    }

    // 3) Decide whether to auto-open:
    //    - In club_mode OR when the preferred view is "collections", auto-open once.
    const shouldAutoOpen = Boolean(flags.club_mode || preferredView === "collections");
    if (!shouldAutoOpen) {
      autoHandledForKeyRef.current.add(key);
      return;
    }

    // 4) Auto-open preferred/saved/first collection once
    (async () => {
      try {
        let savedId = null;
        // If you have a server-remembered active collection, try it first
        const saved = await apiGetActiveCollection({ user_id, base_board: contentDb });
        savedId = saved?.collection_id ?? null;

        const toOpen =
          (savedId && availableCollections.find(c => String(c.id) === String(savedId))) ||
          availableCollections.find(c => c.is_active) ||
          availableCollections[0];

        if (toOpen) {
          console.log("COLL ORCH: auto-opening", toOpen?.id, toOpen?.name);
          await openStudentCollection(toOpen, "auto-orchestrator");
        }
      } catch (err) {
        console.warn("COLL ORCH: auto-open failed", err);
        // Intentionally do not add key here if you want a later retry on user action.
      } finally {
        autoHandledForKeyRef.current.add(key);
      }
    })();
  }, [
    activeSidebarTab,
    collectionsFetched,
    availableCollections?.length, // stable scalar
    activeStudyCollection,
    collectionsDetailLoading,
    flags.club_mode,
    preferredView,
    user_id,
    contentDb,
    viewMode,              // 👈 added so we can flip it safely
    noCollectionsForSure,         // 👈 added
  ]);

  // BDD 11/3/2025 - remove following
  // // BDD 10/2/2025
  // const didAutoOpenRef = useRef(false);
  // useEffect(() => {
  //   if (!flags.club_mode) return;
  //   if (didAutoOpenRef.current) return;
  //   if (activeStudyCollection) return;
  //   if (collectionsLoading) return;
  //   if (!availableCollections || availableCollections.length === 0) return;

  //   const preferred = availableCollections.find(c => c.is_active) || availableCollections[0];
  //   didAutoOpenRef.current = true;
  //   console.log("CLUB DEBUG: auto-opening", preferred?.id, preferred?.name);
  //   openStudentCollection(preferred);
  // }, [flags.club_mode, activeStudyCollection, availableCollections, collectionsLoading]);

  // // 10/3/2025
  // // Auto-switch away from Collections if it's empty
  // useEffect(() => {
  //   if (curriculumView) return;    // BDD 10/17/2025            // ← your requested guard
  //   if (activeSidebarTab !== "collections") return;
  //   if (!collectionsFetched) return;                 // wait for first fetch
  //   if (collectionsLoading) return;                  // still loading, bail

  //   if ((availableCollections?.length || 0) === 0) {
  //     console.log("CLUB DEBUG: no modules; switching to", history);
  //   }
  // }, [activeSidebarTab, collectionsFetched, collectionsLoading, availableCollections, curriculumView]);

  const runAutoWalkthrough = async (aiAnswer, references, forceRun = false) => {
    console.log("🧠 Running Auto Walkthrough...");
    console.log("🗂 References received:", references);

    if (!autoWalkthroughMode && !forceRun) return;

    // ✅ Early exit if nothing to walk through (no log spam)
    const hasRefs =
      !!references &&
      ((references.pwo && references.pwo.length) ||
        (references.video && references.video.length) ||
        (references.quiz && references.quiz.length));
    if (!hasRefs) return;

    const pwoRef = autoOpenPWO ? references?.pwo?.[0] : null;
    const videoRef = autoPlayVideo ? references?.video?.[0] : null;
    const quizRef = references?.quiz;

    if (!pwoRef && !videoRef) {
      console.log("⏭️ Auto walkthrough: no toggle-eligible refs (autoOpenPWO/autoPlayVideo gated).");
      return;
    }

    // AIT-246: remember where the student was before the auto-open takes over.
    const returnTo = captureAutoOpenReturn(navStateRef.current);
    if (returnTo) autoOpenReturnRef.current = returnTo;

    if (pwoRef) {
      console.log("🎮 Launching PWO:", pwoRef);
      flushSync(() => {
        setWalkthroughReferences(references);
        setWalkthroughStep("pwo");
      });


      handlePWOClick(
        pwoRef.pwoID,
        pwoRef.pwo_scene_name,
        authToken,
        selectedSecondaryLang,
        null,
        null,
        true, // ✅ isAuto = true
        "pwo",           // ✅ pass manually
        references,       // ✅ pass manually
        true // investor_mode as true.
      );


    } else if (videoRef) {
      console.log("🎥 Launching video:", videoRef);
      flushSync(() => {
        setWalkthroughReferences(references);
        setWalkthroughStep("video");
      });
      handleVideoClick(videoRef.videoID, videoRef.tagID, authToken, null, null, true, "video", references); // ✅ isAuto = true
    }
  };

  const openAutoWalkthroughQuiz = async (quizReferences) => {
    if (!quizReferences || quizReferences.length === 0) return;

    // Reset previous quiz answers/state so retrying starts fresh
    setUserAnswers({});
    setAnswerFeedback({});
    setShowHints({});
    setShowSolutions({});
    setQuizResponses({});
    setAttemptedQuestions([]);

    const selectedQuestions = quizReferences.slice(0, 3); // Take only first 3
    setQuiz(selectedQuestions);
    setQuizMode("quiz");         // Mode = quiz
    setShowQuiz(true);           // Enable quiz display
    setActiveModule("quiz");     // Replace video/pwo if needed
    setActiveTopic(null);        // Clear active content
    setActiveVideo(null);
    setActivePWO(null);
  };


  useEffect(() => {
    window.onPwoScreenshot = (base64) => {
      // console.log("📸 [AITutorApp] onPwoScreenshot:", base64.slice(0,50) + "…");
      const resolve = screenshotPromiseResolverRef.current;
      if (resolve) {
        resolve({ imagebytes: base64, scenename: null });
        screenshotPromiseResolverRef.current = null;
      }
    };
    return () => { window.onPwoScreenshot = null; };
  }, []);

  useEffect(() => {
    window.onChatOverlayAsk = (text) => {
      console.log("📥 [AITutorApp] onChatOverlayAsk:", text);
      // setActiveModule(""); // BDD TEMP EXPERIMENT CAUTION
      setActiveModule('pwo'); // once we have image capture part implemented
      // setQuestion(text);
      // setInputValue(text);
      // setIsVoiceInput(false);
      // handleAsk(text);         // fire off your existing ask logic
      askFromAnywhere(text); // 10/5/2025

    };

    window.onChatOverlayVoice = async (filename, base64) => {
      // setActiveModule(""); // BDD TEMP EXPERIMENT CAUTION
      setActiveModule('pwo'); // once we have image capture part implemented

      // console.log("📥 [AITutorApp] onChatOverlayVoice:", filename);
      // mirror your existing voice‐handling path:
      // const blob = b64toBlob(base64, "audio/wav");
      // const audioFile = new File([blob], filename, { type: "audio/wav" });
      // Android recorded M4A, so use the correct MIME
      const blob = b64toBlob(base64, "audio/m4a");
      const audioFile = new File([blob], filename, { type: "audio/m4a" });

      // console.log("📤 [AITutorApp] sendAudioToFastAPI with File:", audioFile);
      // wait for transcription before your isVoiceInput effect fires
      await sendAudioToFastAPI(audioFile);

    };

    return () => {
      window.onChatOverlayAsk = null;
      window.onChatOverlayVoice = null;
    };
  }, []);

  const OUT_OF_SCOPE_SENTINEL =
    "I could not find an answer within the current collection or scope.";

  // BDD 12/06/2025
  // BDD 04/14/2026 - stale async side-job protection
  async function fetchSuggestedQuestions(context, askRequestId = null) {
    try {
      const language =
        typeof selectedSecondaryLang === "string" &&
        selectedSecondaryLang.toLowerCase() !== "auto"
          ? String(selectedSecondaryLang).toLowerCase()
          : "en";

      const uid =
        typeof user_id === "string" || typeof user_id === "number"
          ? String(user_id)
          : "";

      const conversation = Array.isArray(context?.conversation)
        ? context.conversation
        : [];

      const rawView = context?.current_view;
      const current_view =
        typeof rawView === "string"
          ? rawView
          : viewMode === "collections"
            ? "collection"
            : "question";

      const rawAnswer =
        typeof context?.current_answer === "string"
          ? context.current_answer.trim()
          : "";

      if (
        current_view === "collection" &&
        rawAnswer &&
        rawAnswer.includes(OUT_OF_SCOPE_SENTINEL)
      ) {
        console.log(
          "[suggested_questions] Skipping deepen suggestions: answer is out-of-scope for this collection."
        );
        return [];
      }

      const payload = {
        user_id: uid,
        subject: context?.subject ?? "",
        chapter: context?.chapter ?? "",
        topic: context?.topic ?? "",
        current_view,
        instructions: context?.instructions ?? "",
        current_question: context?.current_question ?? "",
        current_answer: rawAnswer,
        conversation,
        language,
        collection_id: context?.collection_id ?? null,
        collection_name: context?.collection_name ?? "",
        collection_info: context?.collection_info ?? "",
        context_kind:
          current_view === "collection"
            ? "collection"
            : context?.context_kind ?? "general",
        chapter_id: context?.chapter_id ?? null,
        content_db: context?.content_db ?? null,
      };

      console.log("[suggested_questions] POST", {
        current_view: payload.current_view,
        context_kind: payload.context_kind,
        collection_id: payload.collection_id,
        chapter_id: payload.chapter_id,
        content_db: payload.content_db,
        language: payload.language,
        askRequestId,
      });

      // BDD 04/14/2026 - abort any older suggestions request
      try {
        suggestedQuestionsAbortRef.current?.abort();
      } catch {}
      const controller = new AbortController();
      suggestedQuestionsAbortRef.current = controller;

      const res = await fetch(`${FASTAPI_BASE_URL}/suggested_questions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(payload.content_db ? { "X-Content-DB": payload.content_db } : {}),
        },
        body: JSON.stringify(payload),
        signal: controller.signal,
      });

      if (!res.ok) {
        let body = null;
        try {
          body = await res.json();
        } catch {}
        console.warn(
          "[suggested_questions] HTTP",
          res.status,
          JSON.stringify(body, null, 2)
        );
        return [];
      }

      const data = await res.json();

      // BDD 04/14/2026 - stale async suggestions protection
      if (askRequestId && currentAskRequestIdRef.current !== askRequestId) {
        console.warn("[suggested_questions] stale response ignored", {
          askRequestId,
          currentAskRequestId: currentAskRequestIdRef.current,
        });
        return [];
      }

      try {
        const keys = data && typeof data === "object" ? Object.keys(data) : [];
        const sq = data?.suggested_questions;
        const q = data?.questions;
        const rsq = data?.result?.suggested_questions;
        const rq = data?.result?.questions;

        console.log("[suggested_questions][RESP_SHAPE]", {
          http_ok: res.ok,
          status: res.status,
          keys,
          suggested_questions_type: Array.isArray(sq) ? "array" : typeof sq,
          suggested_questions_len: Array.isArray(sq) ? sq.length : null,
          questions_type: Array.isArray(q) ? "array" : typeof q,
          questions_len: Array.isArray(q) ? q.length : null,
          result_suggested_questions_type: Array.isArray(rsq) ? "array" : typeof rsq,
          result_suggested_questions_len: Array.isArray(rsq) ? rsq.length : null,
          result_questions_type: Array.isArray(rq) ? "array" : typeof rq,
          result_questions_len: Array.isArray(rq) ? rq.length : null,
          sample: JSON.stringify(data).slice(0, 350),
        });
      } catch (e) {
        console.warn("[suggested_questions][RESP_SHAPE] log failed", e);
      }

      return Array.isArray(data?.suggested_questions)
        ? data.suggested_questions
        : [];
    } catch (err) {
      if (err?.name === "AbortError") {
        console.log("[suggested_questions] aborted");
        return [];
      }
      console.error("Error fetching suggested questions:", err);
      return [];
    }
  }

  // BDD 02/11/2026 - Chapter level Curiosity Sparks - try2
  const refreshChapterSparksOnce = useCallback(async ({ chapterId, chapterName, subjectName }) => {
    const langKey =
      (typeof selectedSecondaryLang === "string" && selectedSecondaryLang.toLowerCase() !== "auto")
        ? selectedSecondaryLang.toLowerCase()
        : "en";

    const contentDbHeader =
      (currentCurriculum && String(currentCurriculum).toLowerCase()) ||
      (contentDb && String(contentDb).toLowerCase()) ||
      "saras";

    const cacheKey = `chapter|${contentDbHeader}|${chapterId}|${langKey}`;

    console.log("[ChapterSparks] refreshChapterSparksOnce", {
      chapterId, chapterName, subjectName, cacheKey, langKey, contentDbHeader
    });

    // ✅ Use chapter cache (not sparksCacheRef)
    const cached = chapterSparksCacheRef.current.get(cacheKey);
    if (Array.isArray(cached) && cached.length > 0) {
      console.log("[ChapterSparks] using cached list", cached.length);
      setChapterSparks(cached);
      return;
    }

    // ✅ prevent duplicate concurrent calls
    if (chapterSparksInFlightRef.current.has(cacheKey)) {
      console.log("[ChapterSparks] skip (in flight)", cacheKey);
      return;
    }
    chapterSparksInFlightRef.current.add(cacheKey);

    try {
      // -------------------------
      // Stage A: try DB prompts
      // -------------------------
      const listA = await fetchChapterPromptsRaw(chapterId, "chapter");
      if (Array.isArray(listA) && listA.length > 0) {
        setChapterSparks(listA);
        chapterSparksCacheRef.current.set(cacheKey, listA);
        console.log("[ChapterSparks] StageA success; cached", { cacheKey, len: listA.length });
        return;
      }

      // -------------------------
      // Prepare context
      // -------------------------
      const cleanChapterName = (chapterName || "").trim();
      const cleanSubjectName = (subjectName || "").trim();

      // If name not ready yet, retry a few times quickly
      if (!cleanChapterName) {
        const tries = (chapterSparksRetryRef.current.get(cacheKey) || 0) + 1;
        chapterSparksRetryRef.current.set(cacheKey, tries);

        console.log("[ChapterSparks] StageA empty + chapterName not ready -> retry", {
          chapterId, cacheKey, tries
        });

        if (tries <= 12) {
          setTimeout(() => {
            refreshChapterSparksOnce({
              chapterId,
              chapterName: (selectedChapter?.chapterName || lastChapterTitleRef.current || ""),
              subjectName: (selectedChapter?.subjectName || lastChapterSubjectRef.current || ""),
            });
          }, 250);
        }
        return;
      }

      // -------------------------
      // Stage B: GPT fallback
      // -------------------------
      const ctx = {
        user_id: String(user_id || ""),
        subject: cleanSubjectName,
        chapter: cleanChapterName,
        topic: "",
        current_view: "chapter",
        context_kind: "chapter",
        chapter_id: chapterId,
        content_db: contentDbHeader,
        current_question: "",
        current_answer: "",
        instructions: "",
        language: langKey,
        conversation: [],
      };

      console.log("[ChapterSparks] StageB -> POST /suggested_questions", ctx);

      const listB = await fetchSuggestedQuestions(ctx);

      console.log("[ChapterSparks][StageB_RETURN]", {
        returned_type: Array.isArray(listB) ? "array" : typeof listB,
        returned_len: Array.isArray(listB) ? listB.length : null,
        preview: Array.isArray(listB) ? listB.slice(0, 3) : listB,
      });

      const finalList = Array.isArray(listB) ? listB.filter(Boolean) : [];

      console.log("[ChapterSparks] StageB GPT returned", finalList.length);

      setChapterSparks(finalList);

      if (finalList.length) {
        chapterSparksCacheRef.current.set(cacheKey, finalList);
        console.log("[ChapterSparks] cached GPT list under", cacheKey);
      }

    } finally {
      chapterSparksInFlightRef.current.delete(cacheKey);
    }
  }, [
    FASTAPI_BASE_URL,
    user_id,
    selectedSecondaryLang,
    currentCurriculum,
    contentDb,
    selectedChapter?.chapterName,
    selectedChapter?.subjectName,
  ]);

  // ZA 03/01/2026 - Fetch a replacement spark after one is asked
  // Uses refs to avoid stale closures in handleAskButtonPress's useCallback.
  async function replenishSparks(askedQuestion) {
    try {
      const chId = selectedChapter?.chapterId ?? selectedChapter?.id ?? null;
      if (!chId || !user_id) return;

      const chapterName = selectedChapter?.chapterName || lastChapterTitleRef.current || "";
      const subjectName = selectedChapter?.subjectName || lastChapterSubjectRef.current || "";
      if (!chapterName) return;

      const langKey =
        (typeof selectedSecondaryLang === "string" && selectedSecondaryLang.toLowerCase() !== "auto")
          ? selectedSecondaryLang.toLowerCase()
          : "en";
      const contentDbHeader =
        (currentCurriculum && String(currentCurriculum).toLowerCase()) ||
        (contentDb && String(contentDb).toLowerCase()) ||
        "saras";

      const ctx = {
        user_id: String(user_id || ""),
        subject: subjectName,
        chapter: chapterName,
        topic: "",
        current_view: "chapter",
        context_kind: "chapter",
        chapter_id: chId,
        content_db: contentDbHeader,
        current_question: askedQuestion || "",
        current_answer: "",
        instructions: "Generate questions that are DIFFERENT from: " + askedQuestion,
        language: langKey,
        conversation: [],
      };

      console.log("[replenishSparks] fetching replacement spark", { chId, askedQuestion });
      const raw = await fetchSuggestedQuestions(ctx);

      if (!Array.isArray(raw) || raw.length === 0) return;

      // Fuzzy-filter out any that match existing sparks or the asked question
      const _norm = (s) => (s || "").trim().toLowerCase().replace(/[?!.,;:'"()\-–—]/g, "").replace(/\s+/g, " ").trim();
      const currentSparks = chapterSparksRef.current || [];
      const excludeNorms = new Set([
        ...currentSparks.map(_norm),
        _norm(askedQuestion),
      ]);

      const fresh = raw.filter((q) => {
        const n = _norm(q);
        if (!n || n.length < 5) return false;
        for (const ex of excludeNorms) {
          if (!ex) continue;
          if (n === ex) return false;
          if (n.length > 10 && ex.length > 10 && (n.includes(ex) || ex.includes(n))) return false;
          const nW = new Set(n.split(" ").filter(w => w.length > 2));
          const eW = new Set(ex.split(" ").filter(w => w.length > 2));
          if (nW.size >= 3 && eW.size >= 3) {
            let ov = 0;
            for (const w of nW) { if (eW.has(w)) ov++; }
            if (ov / Math.min(nW.size, eW.size) > 0.8) return false;
          }
        }
        return true;
      });

      if (fresh.length === 0) {
        console.log("[replenishSparks] no unique replacement found");
        return;
      }

      console.log("[replenishSparks] adding replacement:", fresh[0]);
      setChapterSparks((prev) => {
        const updated = [...prev, fresh[0]];
        // Update cache so the replacement persists
        const cacheKey = `chapter|${contentDbHeader}|${chId}|${langKey}`;
        chapterSparksCacheRef.current.set(cacheKey, updated);
        return updated;
      });
    } catch (e) {
      console.log("[replenishSparks] error:", e);
    }
  }

  // Helper to get the last N exchanges from the conversation
  const getLimitedConversation = (limit = 5) => {
    // Returns an array of the last 'limit' question-answer pairs.
    return conversation.slice(-limit);
  };


  //   // BDD 11/15/2025
  //   async function fetchCollectionSuggestedQuestions(
  //   contextKind,
  //   defaultHeaderText,
  //   defaultQuestionsArray
  // ) {
  //   try {
  //     // If no active collection, just use defaults
  //     if (!activeStudyCollection?.id) {
  //       setSuggestedQuestionsHeader([defaultHeaderText]);
  //       setSuggestedQuestions(defaultQuestionsArray);
  //       return;
  //     }

  //     const lang =
  //       (typeof selectedSecondaryLang === "string" &&
  //         selectedSecondaryLang.toLowerCase() !== "auto")
  //         ? String(selectedSecondaryLang).toLowerCase()
  //         : "en";

  //     const url = `${FASTAPI_BASE_URL}/collections/${activeStudyCollection.id}/suggested_questions` +
  //                 `?lang=${encodeURIComponent(lang)}&context_kind=${encodeURIComponent(contextKind)}`;

  //     const res = await fetch(url, {
  //       method: "GET",
  //       headers: { "Content-Type": "application/json" },
  //     });

  //     if (!res.ok) {
  //       console.warn(
  //         "[collection_suggested_questions] HTTP",
  //         res.status
  //       );
  //       // fallback
  //       setSuggestedQuestionsHeader([defaultHeaderText]);
  //       setSuggestedQuestions(defaultQuestionsArray);
  //       return;
  //     }

  //     const data = await res.json();
  //     const list = Array.isArray(data?.questions) ? data.questions : [];

  //     if (list.length > 0) {
  //       setSuggestedQuestionsHeader([defaultHeaderText]);
  //       setSuggestedQuestions(list);
  //     } else {
  //       // no curated questions → fallback
  //       setSuggestedQuestionsHeader([defaultHeaderText]);
  //       setSuggestedQuestions(defaultQuestionsArray);
  //     }
  //   } catch (err) {
  //     console.error("Error loading collection suggested questions:", err);
  //     setSuggestedQuestionsHeader([defaultHeaderText]);
  //     setSuggestedQuestions(defaultQuestionsArray);
  //   }
  // }

  // BDD 11/16/2025 - try 2
  async function fetchCollectionSuggestedQuestions(
    contextKind,
    defaultHeaderText,
    defaultQuestionsArray
  ) {
    try {
      // If no active collection, just use defaults
      if (!activeStudyCollection?.id) {
        setSuggestedQuestionsHeader([defaultHeaderText]);
        setSuggestedQuestions(defaultQuestionsArray);
        return;
      }

      // Decide which content DB to talk to
      const contentDb =
        (activeStudyCollection?.base_board &&
          String(activeStudyCollection.base_board).toLowerCase()) ||
        (currentCurriculum && String(currentCurriculum).toLowerCase()) ||
        "saras";

      const lang =
        (typeof selectedSecondaryLang === "string" &&
          selectedSecondaryLang.toLowerCase() !== "auto")
          ? String(selectedSecondaryLang).toLowerCase()
          : "en";

      const url =
        `${FASTAPI_BASE_URL}/collections/${activeStudyCollection.id}/suggested_questions` +
        `?lang=${encodeURIComponent(lang)}&context_kind=${encodeURIComponent(contextKind)}`;

      console.log("[collection_suggested_questions] GET", {
        url,
        contentDb,
        contextKind,
        lang,
      });

      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Content-DB": contentDb,      // 👈 IMPORTANT
        },
      });

      console.log(
        "[collection_suggested_questions] HTTP status",
        res.status
      );

      if (!res.ok) {
        let bodyText = "";
        try {
          bodyText = await res.text();
        } catch { }
        console.warn(
          "[collection_suggested_questions] non-OK response",
          res.status,
          bodyText
        );
        // fallback
        setSuggestedQuestionsHeader([defaultHeaderText]);
        setSuggestedQuestions(defaultQuestionsArray);
        return;
      }

      const data = await res.json();
      console.log("[collection_suggested_questions] JSON", data);

      const list = Array.isArray(data?.questions) ? data.questions : [];

      if (list.length > 0) {
        setSuggestedQuestionsHeader([defaultHeaderText]);
        setSuggestedQuestions(list);
      } else {
        // no curated questions → fallback
        setSuggestedQuestionsHeader([defaultHeaderText]);
        setSuggestedQuestions(defaultQuestionsArray);
      }
    } catch (err) {
      console.error("Error loading collection suggested questions:", err);
      setSuggestedQuestionsHeader([defaultHeaderText]);
      setSuggestedQuestions(defaultQuestionsArray);
    }
  }

  // // BDD 11/16/2025 - raw fetch that returns just the list, no state changes
  // async function fetchCollectionPromptsRaw(contextKind) {
  //   try {

  //     console.log("[collection_prompts_raw] start", {
  //       activeCollectionId: activeStudyCollection?.id,
  //       contextKind,
  //       selectedSecondaryLang,
  //     });

  //     if (!activeStudyCollection?.id) {
  //       console.log("[collection_prompts_raw] no active collection → []");
  //       return [];
  //     }

  //     const lang =
  //       (typeof selectedSecondaryLang === "string" &&
  //         selectedSecondaryLang.toLowerCase() !== "auto")
  //         ? String(selectedSecondaryLang).toLowerCase()
  //         : "en";

  //     const url =
  //       `${FASTAPI_BASE_URL}/collections/${activeStudyCollection.id}/suggested_questions` +
  //       `?lang=${encodeURIComponent(lang)}&context_kind=${encodeURIComponent(contextKind)}`;

  //     console.log("[collection_prompts_raw] GET", url);

  //     const res = await fetch(url, {
  //       method: "GET",
  //       headers: { "Content-Type": "application/json" },
  //     });
  //     console.log("[collection_prompts_raw] HTTP status", res.status);

  //     if (!res.ok) {
  //       let bodyText = "";
  //       try { bodyText = await res.text(); } catch {}
  //       console.warn("[collection_prompts_raw] non-OK response", res.status, bodyText);
  //       return [];
  //     }

  //     const data = await res.json();
  //     console.log("[collection_prompts_raw] response JSON", data);

  //     const list = Array.isArray(data?.questions) ? data.questions : [];
  //     console.log("[collection_prompts_raw] list length", list.length);

  //     return list;
  //   } catch (err) {
  //     console.error("Error in fetchCollectionPromptsRaw:", err);
  //     return [];
  //   }
  // }

  // BDD 11/16/2025 - try 2 - raw fetch that returns just the list, no state changes
  async function fetchCollectionPromptsRaw(contextKind) {
    try {
      if (!activeStudyCollection?.id) {
        console.log("[collection_prompts_raw] no active collection → []");
        return [];
      }

      const contentDb =
        (activeStudyCollection?.base_board &&
          String(activeStudyCollection.base_board).toLowerCase()) ||
        (currentCurriculum && String(currentCurriculum).toLowerCase()) ||
        "saras";

      const lang =
        (typeof selectedSecondaryLang === "string" &&
          selectedSecondaryLang.toLowerCase() !== "auto")
          ? String(selectedSecondaryLang).toLowerCase()
          : "en";

      const url =
        `${FASTAPI_BASE_URL}/collections/${activeStudyCollection.id}/suggested_questions` +
        `?lang=${encodeURIComponent(lang)}&context_kind=${encodeURIComponent(contextKind)}`;

      console.log("[collection_prompts_raw] GET", { url, contentDb, contextKind, lang });

      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Content-DB": contentDb,   // 👈 same header
        },
      });

      console.log("[collection_prompts_raw] HTTP status", res.status);

      if (!res.ok) {
        let bodyText = "";
        try { bodyText = await res.text(); } catch { }
        console.warn("[collection_prompts_raw] non-OK response", res.status, bodyText);
        return [];
      }

      const data = await res.json();
      console.log("[collection_prompts_raw] JSON", data);

      const list = Array.isArray(data?.questions) ? data.questions : [];
      console.log("[collection_prompts_raw] list length", list.length);

      return list;
    } catch (err) {
      console.error("Error in fetchCollectionPromptsRaw:", err);
      return [];
    }
  }

  // BDD 02/11/2026 - Chapter level Curiosity Sparks - try2
  async function fetchChapterPromptsRaw(chapterId, contextKind = "chapter") {
    try {
      if (!chapterId) return [];

      const lang =
        (typeof selectedSecondaryLang === "string" &&
          selectedSecondaryLang.toLowerCase() !== "auto")
          ? selectedSecondaryLang.toLowerCase()
          : "en";

      const contentDbHeader =
        (currentCurriculum && String(currentCurriculum).toLowerCase()) ||
        (contentDb && String(contentDb).toLowerCase()) ||
        "saras";

      const url =
        `${FASTAPI_BASE_URL}/chapters/${chapterId}/suggested_questions` +
        `?lang=${encodeURIComponent(lang)}&context_kind=${encodeURIComponent(contextKind)}`;

      console.log("[ChapterSparks][StageA] GET", { url, contentDbHeader, lang, contextKind });

      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Content-DB": contentDbHeader,
        },
      });

      if (!res.ok) {
        let bodyText = "";
        try { bodyText = await res.text(); } catch {}
        console.warn("[ChapterSparks][StageA] non-OK", res.status, bodyText);
        return [];
      }

      const data = await res.json();
      // BDD 02/11/2026 - try2
      try {
        const keys = data && typeof data === "object" ? Object.keys(data) : [];
        const q = data?.questions;
        const sq = data?.suggested_questions;

        console.log("[ChapterSparks][StageA_RESP_SHAPE]", {
          http_ok: res.ok,
          status: res.status,
          keys,
          questions_len: Array.isArray(q) ? q.length : null,
          suggested_questions_len: Array.isArray(sq) ? sq.length : null,
          sample: JSON.stringify(data).slice(0, 250),
        });
      } catch (e) {
        console.warn("[ChapterSparks][StageA_RESP_SHAPE] log failed", e);
      }

      const list = Array.isArray(data?.questions) ? data.questions : [];
      console.log("[ChapterSparks][StageA] list length", list.length);
      return list;
    } catch (err) {
      console.error("[ChapterSparks][StageA] error", err);
      return [];
    }
  }

  // Following is for Leia Integration with PWO
  // useEffect(() => {
  //   const handleChatOverlayMessages = (event) => {
  //     const { type, text, filename, base64 } = event.data || {};

  //     if (type === "ASK_TEXT" && text) {
  //       console.log("📥 Received text from ChatOverlay:", text);
  //       setQuestion(text);
  //       setInputValue(text);
  //       setIsVoiceInput(false);
  //       handleAsk(text);
  //     } else if (type === "ASK_VOICE" && filename && base64) {
  //       console.log("📥 Received voice from ChatOverlay:", filename);
  //       // Now send to your sendAudioToFastAPI
  //       const blob = b64toBlob(base64, "audio/wav");
  //       const audioFile = new File([blob], filename, { type: "audio/wav" });
  //       sendAudioToFastAPI(audioFile);
  //     }
  //   };

  //   window.addEventListener("message", handleChatOverlayMessages);
  //   return () => {
  //     window.removeEventListener("message", handleChatOverlayMessages);
  //   };
  // }, []);

  function b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  // End of -- for Leia Integration with PWO

  useEffect(() => {
    if (inputValue && !inputValue.startsWith(activeSuggestedQuestion)) {
      setActiveSuggestedQuestion(null);
    }
  }, [inputValue]);

  // useEffect(() => {
  //     const handleUnityMessages = (event) => {
  //       // console.log("handleUnityMessages event heard",event.data.type);
  //       if (event.data?.type === "SCREENSHOT_TAKEN" && screenshotPromiseResolverRef.current) {
  //         console.log("handleUnityMessages SCREENSHOT_TAKEN heard");
  //         screenshotPromiseResolverRef.current(event.data);
  //         console.log("handleUnityMessages event.data.imagebytes", event.data.imagebytes);
  //         const imageBytes = event.data.imagebytes;
  //         const sceneName = event.data.scenename;

  //         console.log("📏 Length of imageBytes:", imageBytes?.length);
  //         console.log("🔤 First 100 chars:", typeof imageBytes === "string" ? imageBytes.slice(0, 100) : imageBytes);
  //         console.log("🔍 Is likely base64?", typeof imageBytes === "string" && /^[A-Za-z0-9+/=]+$/.test(imageBytes.slice(0, 100)));

  //         let safeImageBytes = null;

  //         if (typeof imageBytes !== "string") {
  //             console.warn("⚠️ imagebytes is not a string. Type is:", typeof imageBytes);
  //         } else if (imageBytes.startsWith("System.Byte")) {
  //             console.warn("🛑 Unity sent placeholder text: 'System.Byte[]'. Skipping screenshot.");
  //             safeImageBytes = null;  // ⛔️ force skip
  //         } else {
  //             safeImageBytes = imageBytes;
  //         }

  //         // Resolve the promise with cleaned data
  //         screenshotPromiseResolverRef.current({
  //             imagebytes: safeImageBytes,
  //             scenename: sceneName,
  //         });
  //         // if (typeof imageBytes !== "string") {
  //         //   console.warn("⚠️ imagebytes is not a string. Type is:", typeof imageBytes);
  //         // } else if (imageBytes.startsWith("System.Byte")) {
  //         //   console.warn("🛑 Unity sent placeholder text: 'System.Byte[]'. Not valid base64.");
  //         // } else if (imageBytes.startsWith("data:image")) {
  //         //    console.log("✅ Already includes data:image prefix.");
  //         // } else {
  //         //    console.log("ℹ️ Might be raw base64, will prepend data:image/png;base64,");
  //         // }
  //         // console.log("handleUnityMessages event.data.scenename", event.data.scenename);

  //         screenshotPromiseResolverRef.current = null;
  //       }
  //     };

  //     window.addEventListener("message", handleUnityMessages);
  //     return () => window.removeEventListener("message", handleUnityMessages);
  //   }, []);
  useEffect(() => {
    const handleUnityMessages = (event) => {
      if (event.data?.type === "SCREENSHOT_TAKEN" && screenshotPromiseResolverRef.current) {
        console.log("📸 SCREENSHOT_TAKEN received:", event.data);

        const imageBytes = event.data.imagebytes;
        const sceneName = event.data.scenename;

        // Log what we received
        console.log("📏 Length of imageBytes:", imageBytes?.length);
        console.log("🔤 First 100 chars:", typeof imageBytes === "string" ? imageBytes.slice(0, 100) : "[not a string]");
        console.log("🔍 Likely base64?", typeof imageBytes === "string" && /^[A-Za-z0-9+/=]+$/.test(imageBytes.slice(0, 100)));

        let safeImageBytes = null;

        if (!imageBytes || !sceneName) {
          console.warn("❌ Screenshot response missing required fields:", {
            imageBytesType: typeof imageBytes,
            sceneName,
            fullResponse: event.data
          });
          screenshotPromiseResolverRef.current(null);
        } else if (typeof imageBytes !== "string") {
          console.warn("⚠️ imagebytes is not a string. Type is:", typeof imageBytes);
          screenshotPromiseResolverRef.current(null);
        } else if (imageBytes.startsWith("System.Byte")) {
          console.warn("🛑 Unity sent placeholder text: 'System.Byte[]'. Skipping screenshot.");
          screenshotPromiseResolverRef.current(null);
        } else {
          safeImageBytes = imageBytes;
          screenshotPromiseResolverRef.current({
            imagebytes: safeImageBytes,
            scenename: sceneName
          });
        }

        screenshotPromiseResolverRef.current = null;
      }
    };

    window.addEventListener("message", handleUnityMessages);
    return () => window.removeEventListener("message", handleUnityMessages);
  }, []);

  //   const requestUnityScreenshot = () => {
  //     return new Promise((resolve) => {
  //       screenshotPromiseResolverRef.current = resolve;

  //       if (pwoIframeRef.current?.contentWindow) {
  //         pwoIframeRef.current.contentWindow.postMessage({ type: "TAKE_SCREENSHOT" }, "*");
  //         console.log("PWO iframe request screenshot sent TAKE_SCREENSHOT");

  //       } else {
  //         console.warn("❌ PWO iframe not available to request screenshot.");
  //         resolve(null);
  //       }
  //     });
  //   };

  // Unity team now wants this additional argument
  // const requestUnityScreenshot = (width = 1280, height = 720) => {



  //   return new Promise((resolve) => {
  //     screenshotPromiseResolverRef.current = resolve;

  //     // 1️⃣ Build the Base64-config
  //     const config = { width, height };
  //     const encodedConfig = btoa(JSON.stringify(config));

  //     console.log(
  //       "%c[requestUnityScreenshot] ENVIRONMENT:",
  //       "font-weight:bold",
  //       ENVIRONMENT,
  //       "AndroidBridge:",
  //       window.AndroidBridge,
  //       "takeScreenshot:",
  //       typeof window.AndroidBridge?.takeScreenshot
  //     );

  //     // 2️⃣ Dispatch to Leia or to the WebGL iframe
  //     if (
  //       ENVIRONMENT === "leia"
  //     ) {
  //       window.AndroidBridge.takeScreenshot(encodedConfig);
  //       console.log("📸 [Leia] takeScreenshot sent", config, encodedConfig);

  //     } else if (pwoIframeRef.current?.contentWindow) {
  //       pwoIframeRef.current.contentWindow.postMessage(
  //         { type: "TAKE_SCREENSHOT", value: encodedConfig },
  //         "*"
  //       );
  //       console.log("📸 PWO iframe request screenshot sent:", config, encodedConfig);

  //     } else {
  //       console.warn("❌ PWO iframe not available to request screenshot.");
  //       resolve(null);
  //     }
  //   });
  // };

  // following is latest but no timeout
  // const requestUnityScreenshot = (width = 1280, height = 720) =>
  //   new Promise((resolve) => {
  //     screenshotPromiseResolverRef.current = resolve;
  //     const config = btoa(JSON.stringify({ width, height }));
  //     if (ENVIRONMENT === "leia" && window.AndroidBridge.requestPwoScreenshot) {
  //       window.AndroidBridge.requestPwoScreenshot(config);
  //       console.log("📸 [Leia] requestPwoScreenshot sent", config);
  //     } else if (pwoIframeRef.current?.contentWindow) {
  //       // fallback WebGL path
  //       pwoIframeRef.current.contentWindow.postMessage(
  //         { type: "TAKE_SCREENSHOT", value: config },
  //         "*"
  //       );
  //       console.log("📸 PWO iframe request screenshot sent:", config);
  //     } else {
  //       console.warn("❌ no route to request screenshot");
  //       resolve(null);
  //     }
  //   });
  // following is with timeout of 5 seconds for image
  // const requestUnityScreenshot = (width = 1280, height = 720) => {
  //   return new Promise((resolve) => {
  //     // ✅ PRECONDITION: WebGL must be ready before requesting screenshot
  //     if (!isWebGLReadyRef.current) {
  //       console.warn("❌ [requestUnityScreenshot] WebGL not ready — skipping screenshot");
  //       return resolve(null);
  //     }

  //     // Store the resolve so your onPwoScreenshot listener can fire it later
  //     screenshotPromiseResolverRef.current = resolve;

  //     const config = btoa(JSON.stringify({ width, height }));
  //     // console.log(
  //     //   "%c[requestUnityScreenshot] ENVIRONMENT:", 
  //     //   "font-weight:bold", ENVIRONMENT, 
  //     //   "AndroidBridge:", window.AndroidBridge, 
  //     //   "takeScreenshot:", typeof window.AndroidBridge?.requestPwoScreenshot
  //     // );

  //     // Dispatch the request
  //     if (ENVIRONMENT === "leia" && typeof window.AndroidBridge?.requestPwoScreenshot === "function") {
  //       window.AndroidBridge.requestPwoScreenshot(config);
  //       console.log("📸 [Leia] requestPwoScreenshot sent", config);

  //     } else if (pwoIframeRef.current?.contentWindow) {
  //       // fallback to WebGL path
  //       // pwoIframeRef.current.contentWindow.postMessage(
  //       //   { type: "TAKE_SCREENSHOT", value: config },
  //       //   "*"
  //       // );
  //       try {
  //         pwoIframe.contentWindow.postMessage(
  //           { type: "TAKE_SCREENSHOT", value: config },
  //           "*"
  //         );
  //         console.log("📸 Screenshot request sent to Unity with config:", config);
  //       } catch (e) {
  //         console.error("❌ Failed to send postMessage to Unity:", e);
  //       }

  //       console.log("📸 PWO iframe request screenshot sent:", config);

  //     } else {
  //       console.warn("❌ no route to request screenshot");
  //       screenshotPromiseResolverRef.current = null;
  //       return resolve(null);
  //     }

  //     // If nothing comes back in 5 seconds, resolve with null so you don’t hang forever
  //     setTimeout(() => {
  //       if (screenshotPromiseResolverRef.current) {
  //         console.warn("⏱️ requestUnityScreenshot timed out, resolving null");
  //         screenshotPromiseResolverRef.current = null;
  //         resolve(null);
  //       }
  //     }, 5000);
  //   });
  // };
  const requestThreePwoScreenshot = (activePwoId) => new Promise((resolve) => {
    const frame = threePwoFrameRef.current;
    if (!frame?.contentWindow || !threePwoUrl || typeof window === "undefined") {
      resolve(null);
      return;
    }
    const expectedOrigin = new URL(threePwoUrl).origin;
    const requestId = `wlframe_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    let completed = false;
    let timeout = null;
    const finish = (result) => {
      if (completed) return;
      completed = true;
      clearTimeout(timeout);
      window.removeEventListener("message", onMessage);
      resolve(result);
    };
    const onMessage = (event) => {
      if (event.source !== frame.contentWindow || event.origin !== expectedOrigin) return;
      const m = event.data || {};
      if (m.type !== "wonderlabs:pwo:screenshot" || m.request_id !== requestId ||
          m.pwo_id !== activePwoId || !isKnownThreeJsPwoScene(activePwoId, m.scene_name) ||
          m.scene_name !== currentPwoSceneRef.current) return;
      const dataUrl = String(m.detail?.data_url || "");
      // A blank, missing or excessive image is not a valid screenshot.
      if (!/^data:image\/png;base64,[A-Za-z0-9+/=]+$/.test(dataUrl) ||
          dataUrl.length < 350 || dataUrl.length > 9000000) {
        finish(null);
      } else {
        finish({ scene_name: m.scene_name, data_url: dataUrl, state: m.detail?.state || {} });
      }
    };
    window.addEventListener("message", onMessage);
    timeout = setTimeout(() => finish(null), 5000);
    frame.contentWindow.postMessage({
      type: "wonderlabs:pwo:capture", pwo_id: activePwoId,
      request_id: requestId,
    }, expectedOrigin);
  });

  const requestUnityScreenshot = (width = 1280, height = 720) => {
    return new Promise(async (resolve) => {
      // ✅ PRECONDITION: WebGL must be ready before requesting screenshot
      if (!isWebGLReadyRef.current) {
        console.warn("❌ [requestUnityScreenshot] WebGL not ready — skipping screenshot");
        return resolve(null);
      }

      // Store the resolve so your onPwoScreenshot listener can fire it later
      screenshotPromiseResolverRef.current = resolve;

      const config = btoa(JSON.stringify({ width, height }));

      if (ENVIRONMENT === "leia" && typeof window.AndroidBridge?.requestPwoScreenshot === "function") {
        window.AndroidBridge.requestPwoScreenshot(config);
        console.log("📸 [Leia] requestPwoScreenshot sent", config);

      } else {
        // ✅ Wait for iframe readiness
        let retries = 0;
        while (!pwoIframeRef.current?.contentWindow && retries < 10) {
          console.warn("⏳ Waiting for iframe contentWindow...");
          await new Promise((res) => setTimeout(res, 200));
          retries++;
        }

        if (!pwoIframeRef.current?.contentWindow) {
          console.error("❌ Iframe contentWindow not ready. Aborting screenshot.");
          screenshotPromiseResolverRef.current = null;
          return resolve(null);
        }

        try {
          pwoIframeRef.current.contentWindow.postMessage(
            { type: "TAKE_SCREENSHOT", value: config },
            "*"
          );
          console.log("📸 Screenshot request sent to Unity with config:", config);
        } catch (e) {
          console.error("❌ Failed to send postMessage to Unity:", e);
          screenshotPromiseResolverRef.current = null;
          return resolve(null);
        }
      }

      // Fallback if Unity doesn't respond with SCREENSHOT_TAKEN
      setTimeout(() => {
        if (screenshotPromiseResolverRef.current) {
          console.warn("⏱️ requestUnityScreenshot timed out, resolving null");
          screenshotPromiseResolverRef.current = null;
          resolve(null);
        }
      }, 5000);
    });
  };

  // const startStudentTest = async (testId) => {
  //   try {
  //     // 1️⃣ Fetch test metadata
  //     const res = await axios.get(`${FASTAPI_BASE_URL}/tests/${testId}`);
  //     setActiveTest(res.data.test);
  //     setTestTimeLeft(res.data.test.duration_minutes * 60);
  //     setTestTimerActive(true);

  //     // 2️⃣ Fetch actual questions separately
  //     const response = await axios.get(`${FASTAPI_BASE_URL}/tests/${testId}/questions`);
  //     const parsedQuiz = response.data.quiz;

  //     // 3️⃣ Load into quiz state
  //     setQuiz(parsedQuiz);
  //     setQuizMode("test");
  //     setShowQuiz(false); // Don’t show until they press "Start Test"
  //     setTestReadyToStart(true);
  //     //   console.log("parsedQuiz for a test rendering:", parsedQuiz);

  //     // 4️⃣ Reset answer-related state
  //     //   setUserAnswers({});
  //     //   setAnswerFeedback({});
  //     //   setShowHints({});
  //     //   setShowSolutions({});

  //   } catch (err) {
  //     console.error("Error loading test:", err);
  //   }
  // };

  // BDD 02/03/2026 student-practice-test-phase1
  // because practice tests are often untimed) is to make duration_minutes handling safe 
  // so we  don’t end up with NaN or a timer running when it shouldn’t.
    const startStudentTest = async (testId, returnTarget = "tests") => {
    testReturnTargetRef.current =
      returnTarget === "home" ? "home" : "tests";

    // Home redesign (2026-09-16, WP7/B3): record that the student opened
    // this test, for the teacher "not started" / "opened not submitted"
    // insights. Fire-and-forget — never blocks or fails starting the test.
    if (user?.email) {
      axios
        .post(`${FASTAPI_BASE_URL}/tests/${testId}/open`, null, {
          params: { email: user.email },
        })
        .catch((err) => {
          console.error("Error recording test open:", err);
        });
    }

    try {
      // 1️⃣ Fetch test metadata
      const res = await axios.get(`${FASTAPI_BASE_URL}/tests/${testId}`);

      // backend might return { test: {...} } or directly {...}
      const testObj = res?.data?.test || res?.data || null;

      if (!testObj) {
        console.error("Error loading test: missing test object", res?.data);
        return;
      }

      setActiveTest(testObj);

      // ✅ SAFE: duration_minutes can be null/undefined for untimed practice tests
      // Practice tests are always untimed regardless of any duration value.
      const practiceTest =
        testObj?.test_kind === "practice" || !!testObj?.owner_email;
      const durationMinutes = Number(testObj.duration_minutes);
      const hasTimer =
        !practiceTest && Number.isFinite(durationMinutes) && durationMinutes > 0;

      if (hasTimer) {
        setTestTimeLeft(durationMinutes * 60);
        setTestTimerActive(true);
      } else {
        setTestTimeLeft(0);
        setTestTimerActive(false);
      }

      // 2️⃣ Fetch actual questions separately
      const response = await axios.get(`${FASTAPI_BASE_URL}/tests/${testId}/questions`);
      const parsedQuiz = response?.data?.quiz || null;

      console.log("TEST RAW Q0:", response?.data?.quiz?.[0]);

      if (!parsedQuiz) {
        console.error("Error loading test questions: missing quiz", response?.data);
        return;
      }

      // 3️⃣ Load into quiz state
      setQuiz(parsedQuiz);
      setQuizMode("test");
      setShowQuiz(false); // Don’t show until they press "Start Test"
      setTestReadyToStart(true);

      // 4️⃣ Reset answer-related state
      setUserAnswers({});
      setAnswerFeedback({});
      setShowHints({});
      setShowSolutions({});
      setQuizResponses({});
      setAttemptedQuestions([]);
    } catch (err) {
      console.error("Error loading test:", err);
    }
  };

  // AIT-249: extended to handle MCQ (type 2), True/False (type 4 — numeric or
  // textual storage), and Fill-in-the-Blank (type 1 — exact string match,
  // tolerant of arrays of accepted answers). Anything else returns
  // "unattempted" / "ungraded" so the review screen can show a neutral state.
  const computeAnswerFeedback = (quizData, studentAnswers) => {
    const feedback = {};
    if (!Array.isArray(quizData)) return feedback;

    const norm = (v) => {
      if (v == null) return "";
      return String(v).trim().toLowerCase();
    };
    const optionToNumber = (v) => {
      const s = norm(v);
      if (!s) return null;
      const stripped = s.startsWith("option") ? s.slice(6) : s;
      const m = stripped.match(/\d+/);
      return m ? parseInt(m[0], 10) : null;
    };

    quizData.forEach((question) => {
      const qid = question.question_id;
      const qType = parseInt(question.question_type, 10);
      const studentAns = studentAnswers?.[qid];
      const correct = question.options?.correct_answer;

      if (
        studentAns === undefined ||
        studentAns === null ||
        studentAns === "" ||
        (Array.isArray(studentAns) && studentAns.filter(Boolean).length === 0)
      ) {
        feedback[qid] = "unattempted";
        return;
      }

      // MCQ
      if (qType === 2) {
        const correctIndex = optionToNumber(correct);
        const studentIndex = optionToNumber(studentAns);
        feedback[qid] =
          correctIndex != null && studentIndex != null && studentIndex === correctIndex
            ? "correct"
            : "wrong";
        return;
      }

      // True / False (question_type 3): stored MCQ-style as option1="True",
      // option2="False" with a numeric correct_answer ("1"/"2"). Some legacy
      // rows store the literal label "True"/"False" instead.
      if (qType === 3) {
        const correctIdx = optionToNumber(correct);
        const studentIdx = optionToNumber(studentAns);
        if (correctIdx != null && studentIdx != null) {
          feedback[qid] = studentIdx === correctIdx ? "correct" : "wrong";
        } else {
          feedback[qid] = norm(studentAns) === norm(correct) ? "correct" : "wrong";
        }
        return;
      }

      // Multi-select (question_type 4): correct_answer is a pipe/comma
      // delimited list of 1-based option indices ("1|2|4"); the student's
      // answer is an array of option keys (["option1", "option2"]). Full
      // credit only when the selected set exactly matches the correct set.
      if (qType === 4) {
        const toIdxSet = (raw) => {
          const parts = Array.isArray(raw) ? raw : String(raw ?? "").split(/[|,]/);
          return new Set(parts.map(optionToNumber).filter((n) => n != null));
        };
        const correctSet = toIdxSet(correct);
        const studentSet = toIdxSet(studentAns);
        const same =
          correctSet.size > 0 &&
          correctSet.size === studentSet.size &&
          [...correctSet].every((n) => studentSet.has(n));
        feedback[qid] = same ? "correct" : "wrong";
        return;
      }

      // Fill in the blank
      if (qType === 1) {
        const s = norm(studentAns);
        if (Array.isArray(correct)) {
          feedback[qid] = correct.some((c) => norm(c) === s) ? "correct" : "wrong";
        } else {
          feedback[qid] = s === norm(correct) ? "correct" : "wrong";
        }
        return;
      }

      // Essays / matching / anything else — not auto-gradable
      feedback[qid] = "ungraded";
    });

    return feedback;
  };

  // AIT-249: builds the rich per-question payload that powers the
  // post-submit review screen. Walks quizData + raw userAnswers, computes
  // per-question feedback via computeAnswerFeedback, and produces aggregate
  // counts. Returns the same shape used by `reviewSummary` state.
  const buildReviewSummary = React.useCallback((quizArr, answersMap) => {
    if (!Array.isArray(quizArr) || quizArr.length === 0) {
      return {
        total: 0, correct: 0, wrong: 0, unattempted: 0,
        score: 0, totalScore: 0, perQuestion: {},
      };
    }
    const feedback = computeAnswerFeedback(quizArr, answersMap || {});
    const perQuestion = {};
    let correct = 0, wrong = 0, unattempted = 0, score = 0, totalScore = 0;

    quizArr.forEach((q) => {
      const qid = q.question_id;
      const status = feedback[qid] || "unattempted";
      const max = (q.score != null && q.score > 0) ? q.score : 1;
      totalScore += max;
      if (status === "correct") { correct += 1; score += max; }
      else if (status === "wrong") { wrong += 1; }
      else if (status === "unattempted") { unattempted += 1; }
      // "ungraded" doesn't count in correct/wrong/unattempted aggregates.

      perQuestion[qid] = {
        status,
        userAnswer: answersMap?.[qid] ?? null,
        correctAnswer: q?.options?.correct_answer ?? null,
        solution: q?.solution ?? null,
      };
    });

    return {
      total: quizArr.length,
      correct, wrong, unattempted,
      score, totalScore,
      perQuestion,
    };
  }, []);

  const handleSelectPastTestResult = async (result) => {
    try {
      setLoading(true);
      // Use the student's email and the selected result's id.
      //   const response = await axios.get(`${FASTAPI_BASE_URL}/student/${user.email}/tests/${parseInt(result.id, 10)}`);
      const response = await axios.get(`${FASTAPI_BASE_URL}/student/${encodeURIComponent(user.email)}/tests/single/${result.id}`)

      const testResult = response.data; // This includes "answers"

      // BDD 08/30/2026 - preserve reviewed test metadata for Ask AI and review header
      setActiveTest({
        ...result,
        id: testResult.test_id,
        title: result.test_title || testResult.test_title || "Test",
      });
      // Fetch detailed questions for this test.
      const response2 = await axios.get(`${FASTAPI_BASE_URL}/tests/${testResult.test_id}/questions`);
      const parsedQuiz = response2.data.quiz;
      setQuiz(parsedQuiz);

      // Set the student's answers from the detailed test result.
      setUserAnswers(testResult.answers);
      //   console.log("handleSelectPastTestResult testResult.answers", testResult.answers)

      // Compute feedback based on the fetched questions and the student answers.
      const computedFeedback = computeAnswerFeedback(parsedQuiz, testResult.answers);
      setAnswerFeedback(computedFeedback);
      //   console.log("handleSelectPastTestResult computedFeedback", computedFeedback)

      // Set the mode to "pastTestView" so that the results are read-only.
      setQuizMode("pastTestView");
      setShowQuiz(true);
    } catch (error) {
      console.error("Error fetching test result details:", error);
      setMessage("Error fetching test result details.");
    } finally {
      setLoading(false);
    }
  };

  // BDD 08/30/2026 - completed-test review -> existing Saras-3D /api/ask_ai pipeline
  const handleExamReviewAskAI = async ({
    question,
    questionIndex,
    screenshot,
  }) => {
    const hasScreenshot =
      typeof screenshot === "string" &&
      screenshot.startsWith("data:image/");

    const reviewQuestionId =
      question?.question_id ?? question?.id ?? questionIndex;

    const segmentsToText = (segments) =>
      Array.isArray(segments)
        ? segments
            .map((segment) =>
              segment?.text ??
              segment?.content ??
              segment?.latex ??
              segment?.value ??
              ""
            )
            .filter(Boolean)
            .join(" ")
            .trim()
        : "";

    const questionText = String(
      question?.question?.text ||
      segmentsToText(question?.question?.segments) ||
      question?.prompt ||
      ""
    ).slice(0, 4000);

    const officialSolution = String(
      question?.solution?.text ||
      segmentsToText(question?.solution?.segments) ||
      question?.official_solution ||
      ""
    ).slice(0, 4000);

    const officialExplanation = String(
      question?.explanation?.text ||
      segmentsToText(question?.explanation?.segments) ||
      (typeof question?.explanation === "string" ? question.explanation : "") ||
      ""
    ).slice(0, 4000);

    const rawStudentAnswer =
      userAnswers?.[reviewQuestionId] ??
      userAnswers?.[String(reviewQuestionId)] ??
      null;

    let studentAnswer = "";
    if (rawStudentAnswer != null) {
      try {
        studentAnswer =
          typeof rawStudentAnswer === "string"
            ? rawStudentAnswer
            : JSON.stringify(rawStudentAnswer);
      } catch (_e) {
        studentAnswer = String(rawStudentAnswer);
      }
      studentAnswer = studentAnswer.slice(0, 2500);
    }

    const examReviewContext = {
      screenshot,
      test_title: activeTest?.title || "Official exam",
      test_id: activeTest?.id ?? activeTest?.test_id ?? null,
      question_index: Number.isFinite(questionIndex) ? questionIndex : null,
      question_number: Number.isFinite(questionIndex) ? questionIndex + 1 : null,
      question_id: question?.question_id ?? question?.id ?? null,
      external_question_id: question?.external_question_id ?? null,
      question_text: questionText,
      student_answer: studentAnswer,
      official_solution: officialSolution,
      official_explanation: officialExplanation,
      official_marks:
        question?.official_points ??
        question?.official_marks ??
        question?.marks ??
        question?.points ??
        null,
    };

    console.log("Exam review Ask AI capture:", {
      testTitle: examReviewContext.test_title,
      questionIndex,
      questionId: examReviewContext.question_id,
      externalQuestionId: examReviewContext.external_question_id,
      hasScreenshot,
      screenshotLength: screenshot?.length ?? 0,
    });

    // Keep the proven local inspection hook while this feature is being validated.
    if (typeof window !== "undefined") {
      window.__sarasExamReviewCapture = screenshot;
    }

    if (!hasScreenshot) {
      console.error("Exam review Ask AI aborted: rendered question screenshot is missing.");
      return;
    }

    const reviewPrompt =
      "Help me understand this completed exam question. Explain what the question is asking, " +
      "the correct reasoning, and where my submitted answer differs from the official solution. " +
      "Use the attached rendered question card as the authoritative visual context.";

    // Reuse the normal Ask AI UI, transport, logging and exact-turn reference pipeline.
    // handleAsk will force context.type=exam_review and keep references enabled.
    handleAsk(reviewPrompt, {
      skipReferences: false,
      examReviewContext,
    });
  };

  // BDD 02/03/2026 student-practice-test-phase1
  // Practice tests are marked by test_kind="practice"; older rows / paths may
  // not carry it, so owner_email (only ever set on student-owned practice
  // tests) is used as a robust fallback. Assigned tests use teacher_email.
  const isPractice =
    activeTest?.test_kind === "practice" || !!activeTest?.owner_email;

  // AIT-249: Derived gate for legacy "reveal correctness on selection" behavior
  // during LIVE answering. Only affects in-progress quizzes/tests — review
  // modes (pastTestView, quizReview) always show correctness via isReviewMode.
  // AIT-249: feedback is always deferred until submission across all quiz and
  // test surfaces. The review screen renders correctness after Submit.
  const immediateFeedbackEnabled = false;

  // BDD 02/03/2026 student-practice-test-phase1 - try4
  const deletePracticeTest = React.useCallback(async (testId) => {
    const email = (user?.email || user_id || "").trim();
    if (!email) throw new Error("Missing user email for deletePracticeTest");

    const res = await axios.delete(`${FASTAPI_BASE_URL}/practice_tests/${testId}`, {
      params: { email }, // backend expects ?email=
    });

    return res.data;
  }, [FASTAPI_BASE_URL, user?.email, user_id]);

  // BDD 02/03/2026 student-practice-test-phase1 - try4
  const refreshMyPracticeTests = React.useCallback(async () => {
    try {
      const email = (user?.email || user_id || "").trim().toLowerCase();
      if (!email) return [];

      const res = await axios.get(`${FASTAPI_BASE_URL}/practice_tests/my`, {
        params: { email },
      });

      const list = Array.isArray(res.data) ? res.data : [];
      setMyPracticeTests(list);
      return list;
    } catch (e) {
      console.error("refreshMyPracticeTests failed", e);
      setMyPracticeTests([]);
      return [];
    }
  }, [FASTAPI_BASE_URL, user?.email, user_id, setMyPracticeTests]);

  // BDD 02/03/2026 student-practice-test-phase1 - try4
  useEffect(() => {
    refreshMyPracticeTests();
  }, [refreshMyPracticeTests]);

  // BDD 02/03/2026 student-practice-test-phase1
  // Build subject list from your existing curriculum (assuming you already have `curriculum` in AITutorApp)
  // const practiceSubjects = useMemo(() => {
  //   const out = [];
  //   const levels = Array.isArray(curriculum) ? curriculum : [];
  //   for (const g of levels) {
  //     for (const s of (g.subjects || [])) {
  //       out.push({ id: s.id, name: s.name, grade: g.grade ?? g.id });
  //     }
  //   }
  //   return out;
  // }, [curriculum]);

  // BDD 02/03/2026 student-practice-test-phase1 - try4
  // Build subject list from your existing curriculum (assuming you already have `curriculum` in AITutorApp)
  // const practiceSubjects = useMemo(() => {
  //   const out = [];
  //   const levels = Array.isArray(curriculum) ? curriculum : [];

  //   const pick = (obj, keys, fallback = null) => {
  //     for (const k of keys) if (obj && obj[k] != null) return obj[k];
  //     return fallback;
  //   };

  //   for (const g of levels) {
  //     const gradeId = pick(g, ["grade", "id"], "");
  //     const gradeLabel = pick(g, ["grade", "name", "id"], gradeId);

  //     for (const s of (g.subjects || [])) {
  //       const subjectId = pick(s, ["id", "subject_id"], "");
  //       const subjectName = pick(s, ["name", "subject_name"], "Subject");

  //       const chaptersRaw = pick(s, ["chapters", "chapter_list", "children"], []) || [];
  //       const chapters = (Array.isArray(chaptersRaw) ? chaptersRaw : []).map((ch) => ({
  //         chapter_id: pick(ch, ["chapter_id", "chapterId", "id"], null),
  //         chapter_name: pick(ch, ["chapter_name", "chapterName", "name"], "Chapter"),
  //       }));

  //       out.push({
  //         key: `${gradeId}::${subjectId}`,                     // ✅ disambiguate duplicates
  //         id: subjectId,
  //         name: subjectName,
  //         grade: gradeId,
  //         label: `Grade ${gradeLabel} • ${subjectName}`,      // ✅ what user sees
  //         chapters,                                           // ✅ only for UI
  //       });
  //     }
  //   }
  //   return out;
  // }, [curriculum]);

  // BDD 02/03/2026 student-practice-test-phase1 - try4
  // Build subject list from your existing curriculum (assuming you already have `curriculum` in AITutorApp)
  // const practiceSubjects = useMemo(() => {
  //   const out = [];
  //   const levels = Array.isArray(curriculum) ? curriculum : [];

  //   for (const level of levels) {
  //     const gradeId = level?.id;
  //     const gradeLabel = labelForCurriculumNode(level); // ✅ same as your UI

  //     for (const subject of (level.subjects || [])) {
  //       const subjectId = subject?.id;
  //       const subjectLabel = labelForCurriculumNode(subject); // ✅ same as your UI

  //       const chapters = (subject.chapters || []).map((ch) => ({
  //         chapter_id: ch?.id,                       // ✅ normalized for backend payload
  //         chapter_name: labelForCurriculumNode(ch), // ✅ same as your UI
  //       }));

  //       out.push({
  //         key: `${gradeId}::${subjectId}`,
  //         id: subjectId,
  //         name: subjectLabel,
  //         grade: gradeId,
  //         label: `${gradeLabel} • ${subjectLabel}`,
  //         chapters,
  //       });
  //     }
  //   }
  //   return out;
  // }, [curriculum]);

  // BDD 02/03/2026 student-practice-test-phase1 - try4
  const practiceSubjects = useMemo(() => {
    const levels = Array.isArray(curriculum) ? curriculum : [];
    const out = [];

    const toText = (v, fallback = "") => (v == null ? fallback : String(v));

    for (const g of levels) {
      // Your logs show grade has keys: id, grade, subjects (no grade label)
      const gradeVal = g?.grade ?? g?.id ?? "";
      const gradeLabel = toText(gradeVal, g?.id ?? "");

      for (const s of (g?.subjects || [])) {
        const subjectId = s?.id ?? s?.subject_id;
        const subjectName = s?.display_name ?? s?.name ?? "Subject";

        const chaptersRaw = Array.isArray(s?.chapters) ? s.chapters : [];
        // BDD 02/03/2026 student-practice-test-phase1 - try6
        const chapters = chaptersRaw
          .map((ch) => ({
            chapter_id: ch?.chapter_id ?? ch?.id,
            chapter_name: ch?.chapter_name ?? ch?.display_name ?? ch?.name ?? "Chapter",
          }))
          .filter((ch) => ch.chapter_id != null);

        out.push({
          key: `${gradeLabel}::${subjectId}`,              // ✅ disambiguate duplicates
          id: subjectId,
          name: subjectName,
          grade: gradeLabel,
          label: `Grade ${gradeLabel} • ${subjectName}`,  // ✅ what user sees
          chapters,
        });
      }
    }

    return out;
  }, [curriculum]);

  // BDD 02/03/2026 student-practice-test-phase1
  // Initialize default subject once curriculum loads
  // useEffect(() => {
  //   if (!practiceSubjects.length) return;
  //   if (practiceSubjectId != null) return;
  //   setPracticeSubjectId(practiceSubjects[0].id);
  //   setPracticeSubjectName(practiceSubjects[0].name);
  // }, [practiceSubjects, practiceSubjectId]);

  // BDD 02/03/2026 student-practice-test-phase1 - try4
  // Initialize default subject once curriculum loads
  // useEffect(() => {
  //   if (!practiceSubjects.length) return;
  //   if (practiceSubjectKey) return;

  //   const first = practiceSubjects[0];
  //   setPracticeSubjectKey(String(first.key));
  //   setPracticeSubjectId(String(first.id));
  //   setPracticeSubjectName(first.name || "");

  //   setPracticeChapters(Array.isArray(first.chapters) ? first.chapters : []);
  //   setPracticeChapterMode("all");
  //   setPracticeSelectedChapterIds([]);
  // }, [practiceSubjects, practiceSubjectKey]);

  // BDD 02/03/2026 student-practice-test-phase1 - try4
  // Initialize default subject once curriculum loads
  useEffect(() => {
    if (!practiceSubjects.length) return;
    if (practiceSubjectKey) return;

    const first = practiceSubjects[0];
    setPracticeSubjectKey(first.key);
    setPracticeSubjectId(first.id);
    setPracticeSubjectName(first.name);

    setPracticeChapters(first.chapters || []);
    setPracticeChapterMode("all");
    setPracticeSelectedChapterIds([]);
  }, [practiceSubjects, practiceSubjectKey]);

  // Bumped by every start and by the nav-away reset, so a questions fetch that
  // resolves after the student left the pre-start screen is discarded.
  const testStartTokenRef = useRef(0);
  const handleStartTest = async () => {
    testStartTokenRef.current += 1;
    const startToken = testStartTokenRef.current;
    try {
      const response = await axios.get(`${FASTAPI_BASE_URL}/tests/${activeTest.id}/questions`);
      if (testStartTokenRef.current !== startToken) return;
      const parsedQuiz = response.data.quiz;
      setQuiz(parsedQuiz);

      // setTestTimeLeft(activeTest.duration_minutes * 60);
      // setTestTimerActive(true);
      // BDD 02/03/2026 student-practice-test-phase1
      // Practice tests are always untimed — never start the timer for them,
      // even if a stale duration_minutes value is present on the test row.
      const practiceTest =
        activeTest?.test_kind === "practice" || !!activeTest?.owner_email;
      if (!practiceTest && activeTest.duration_minutes && activeTest.duration_minutes > 0) {
        setTestTimeLeft(activeTest.duration_minutes * 60);
        setTestTimerActive(true);
      } else {
        // ✅ Untimed practice test
        setTestTimeLeft(0);
        setTestTimerActive(false);
      }

      setShowQuiz(true);
      setTestReadyToStart(false);
      // Da Vinci 3-Day Challenge: re-check progress after opening a quiz.
      syncChallenge(activeStudyCollection?.id);
    } catch (err) {
      console.error("Error fetching test questions:", err);
    }
  };

  // Tick the test timer once per second while active.
  // IMPORTANT: depend ONLY on testTimerActive — not testTimeLeft. Including
  // testTimeLeft makes the effect tear down + recreate the interval on every
  // tick, and any unrelated parent re-render that lands between tick N and
  // tick N+1 can clear the interval before it has a chance to fire, leaving
  // the displayed time frozen at its initial value.
  useEffect(() => {
    if (!testTimerActive) return;
    const timer = setInterval(() => {
      setTestTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [testTimerActive]);

  // Auto-submit when the timer hits zero.
  useEffect(() => {
    if (testTimerActive && testTimeLeft === 0) {
      handleSubmitTest();
    }
  }, [testTimerActive, testTimeLeft]);

  //   useEffect(() => {
  //     console.log("🎯 quizData updated:", quizData);
  //   }, [quizData]); 

  const handleSaveProfile = async () => {
    try {
      // console.log("💾 Saving Profile:", profileData);
      await AsyncStorage.setItem("user_profile", JSON.stringify(profileData));
      // ✅ Save to backend (DB)
      await saveStudentProfile();

      Alert.alert(t("✅ Profile Updated"), t("Your changes have been saved successfully!"));
      setProfileModalVisible(false);
    } catch (error) {
      console.error("❌ Error saving profile:", error);
      Alert.alert(t("⚠️ Error"), t("Could not save profile. Try again."));
    }
  };

  // BDD 02/03/2026 student-practice-test-phase1
  const handleQuickPractice = async () => {
    try {
      // TODO: replace subjectId with your current selected subject in the app
      const subjectId = selectedSubjectId; // <-- use your existing state
      const subjectName = selectedSubjectName; // optional

      const payload = {
        student_email: user.email,
        subject_id: subjectId,
        subject_name: subjectName,
        total_questions: 10,
        difficulty_mix: "balanced",
        language_id: 1,
        timed: false
      };

      const res = await axios.post(`${FASTAPI_BASE_URL}/practice_tests/quick_create`, payload);

      const newTest = res.data.test;
      setActiveTest(newTest);
      setQuizMode("test");          // reuse existing test runner
      setShowQuiz(false);           // AIT-253: pre-start view, not a running test
      setTestReadyToStart(true);
    } catch (err) {
      console.error("Quick practice failed:", err);
    }
  };

  // BDD 02/03/2026 student-practice-test-phase1
  // const quickCreatePracticeTest = async (payload) => {
  //   const res = await axios.post(`${FASTAPI_BASE_URL}/practice_tests/quick_create`, payload);

  //   // normalize the response a bit
  //   const data = res?.data || {};
  //   const testObj = data?.test || data; // supports either {test:{...}} or direct object
  //   const testId = testObj?.id ?? data?.id ?? data?.test_id ?? data?.testId ?? null;

  //   return { data, testObj, testId };
  // };

  // BDD 02/03/2026 student-practice-test-phase1 - try 2
  const quickCreatePracticeTest = async (payload) => {
    const res = await axios.post(`${FASTAPI_BASE_URL}/practice_tests/quick_create`, payload);

    const data = res?.data || {};

    // Prefer explicit id fields first (most reliable)
    const testId =
      data?.test_id ??
      data?.testId ??
      data?.id ??
      data?.test?.id ??
      data?.test?.test_id ??
      null;

    // Normalize test object (best-effort)
    const testObj =
      data?.test && Object.keys(data.test).length > 0
        ? data.test
        : data;

    return { data, testObj, testId };
  };

  // BDD 11/3/2025
  // async function openStudentCollection(col) {
  //   try {
  //     setActiveStudyCollection(col);
  //     setCollectionResolved(null);
  //     setCollectionsDetailLoading(true);

  //     // Remember selection server-side (so it persists across sessions)
  //     await apiSelectActiveCollection({
  //       user_id,
  //       base_board: col.base_board,
  //       collection_id: col.id
  //     });

  //     // Load resolved items to render in the main pane
  //     const resolved = await apiGetCollectionResolved(col.id, { student_email: user.email });
  //     setCollectionResolved(resolved || null);
  //   } catch (e) {
  //     console.error("openStudentCollection failed", e);
  //     // Nice UX if access is blocked:
  //     if (e?.status === 403 || (typeof e?.message === "string" && e.message.includes("403"))) {
  //       try {
  //         // RN Alert works on native; on web, it’s okay to fall back to window.alert
  //         Alert?.alert?.(t("Not in your pilot set."));
  //       } catch {}
  //       if (typeof window !== "undefined" && window.alert) window.alert(t("Not in your pilot set."));
  //     }
  //   } finally {
  //     setCollectionsDetailLoading(false);
  //   }
  // }

  // === PATCH 2025-11-03: collections tab press ===
  const onPressCollectionsTab = () => {
    setActiveSidebarTab("collections");
    // Only force curriculum mode if board has no collections at all
    // Otherwise, keep whatever view mode the user is currently in
    if (noCollectionsForSure) {
      if (viewMode !== "curriculum") setViewMode("curriculum");
      setActiveStudyCollection(null);
      setCollectionResolved(null);
    }
    // Removed: no longer force switch to collections mode - let user stay in their current view
  };

  // === PATCH 2025-11-03: detail loading is independent; don't block on persist ===
  async function openStudentCollection(col, reason = "other") {
    let requestId = null;
    try {
      requestId = collectionResolveRequestRef.current + 1;
      collectionResolveRequestRef.current = requestId;
      collMetricsRef.current.detailOpens += 1;
      collMetricsRef.current.lastOpenReason = reason;
      const t0 = (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();

      collLog("DETAIL open start", { id: col?.id, name: col?.name, reason });

      setActiveStudyCollection(col);
      setCollectionResolved(null);
      setCollectionsDetailLoading(true);

      // persist (non-blocking)
      const persistPromise = apiSelectActiveCollection({
        user_id,
        base_board: col.base_board,
        collection_id: col.id
      }).catch((e) => console.warn("persist active collection failed (non-blocking)", e));

      const curriculumLang = resolveCurriculumLang(selectedSecondaryLang);
      const resolved = await apiGetCollectionResolved(col.id, {
        student_email: user.email,
        lang: curriculumLang,
        payload: "outline",
      });

      if (requestId !== collectionResolveRequestRef.current) return;

      setCollectionResolved(resolved || null);
      // BDD 12/09/2025 Localization For Collections 
      console.log("[COLLECTION] resolved outline items (lang =", curriculumLang, ")",
        resolved?.items?.map(it => ({
          subj: it.subject,
          chap: it.chapter,
          topic: it.topic,
          title: it.title,
          // for sanity:
          firstVideo: it.videos?.[0]?.name,
        }))
      );

      // crude payload size (KB) for visibility
      let kb = null;
      try { kb = Math.round(JSON.stringify(resolved || {}).length / 1024); } catch { kb = null; }

      const t1 = (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();
      const ms = Math.round(t1 - t0);

      collMetricsRef.current.lastDetailMs = ms;
      collMetricsRef.current.lastDetailKB = kb;

      collLog(`DETAIL outline done in ${ms} ms`, {
        id: col?.id,
        kb,
        loaded: resolved?.items?.length || 0,
        opens: collMetricsRef.current.detailOpens,
        reason,
      });

      await persistPromise;
    } catch (e) {
      console.error("openStudentCollection failed", e);
      if (requestId === collectionResolveRequestRef.current) {
        try { Alert?.alert?.(t("Not in your pilot set.")); } catch { }
        if (typeof window !== "undefined" && window.alert) window.alert(t("Not in your pilot set."));
      }
    } finally {
      if (requestId === collectionResolveRequestRef.current) {
        setCollectionsDetailLoading(false);
      }
    }
  }

  // Optional: clear active selection for this board
  async function clearStudentCollection() {
    try {
      await apiSelectActiveCollection({
        user_id,
        base_board: contentDb,
        collection_id: null
      });
      collectionResolveRequestRef.current += 1;
      setActiveStudyCollection(null);
      setCollectionResolved(null);
    } catch (e) {
      console.error("clearStudentCollection failed", e);
    }
  }

  // BDD 10/5/2025 - short - detailed response related
  // Load once
  useEffect(() => {
    (async () => {
      const saved = await AsyncStorage.getItem("answer_style");
      if (saved === "concise" || saved === "detailed") setAnswerStyle(saved);
    })();
  }, []);

  // Persist when changed
  useEffect(() => {
    AsyncStorage.setItem("answer_style", answerStyle).catch(() => { });
  }, [answerStyle]);

  // Keep this inside the component
  // const applyAnswerStyle = React.useCallback((raw) => {
  //   if (!raw) return raw;
  //   const ageNum = parseInt((profileData?.age ?? ""), 10);
  //   const ageHint = Number.isFinite(ageNum) ? ` Explain it for a ${ageNum}-year-old.` : "";

  //   if (answerStyle === "concise") {
  //     return `${raw} Please answer in 2–3 short sentences.${ageHint}`;
  //   }
  //   // detailed
  //   return `${raw} Please give a thorough, step-by-step explanation with a quick example. Bullet points welcome where helpful.${ageHint}`;
  // }, [answerStyle, profileData?.age]);

  // BDD 11/10/2025 - age and detailed/concise is handled in backend
  // Build metadata for how the answer should be shaped
  const applyAnswerStyle = React.useCallback(
    (raw) => {
      if (!raw) return { text: raw, answer_length: undefined };

      let answer_length;
      if (answerStyle === "concise") {
        answer_length = "short";
      } else if (answerStyle === "detailed") {
        answer_length = "detailed";
      }

      return { text: raw, answer_length };
    },
    [answerStyle]
  );


  // Fetch available and upcoming tests when user is logged in (for home screen)
  useEffect(() => {
    if (!user?.email) return;

    const fetchAllTests = async () => {
      try {
        const [availableRes, upcomingRes] = await Promise.all([
          axios.get(`${FASTAPI_BASE_URL}/tests/available`, { params: { email: user.email } }),
          axios.get(`${FASTAPI_BASE_URL}/tests/upcoming`, { params: { email: user.email } }),
        ]);
        setAvailableTests(availableRes.data || []);
        setUpcomingTests(upcomingRes.data || []);
      } catch (err) {
        console.error("Error fetching tests:", err);
      }
    };

    fetchAllTests();
    fetchMyPracticeTests();
  }, [user?.email]);

  // Fetch my test results - extracted so it can be called after submission
  const fetchMyTestResults = async () => {
    if (!user?.email) return;
    try {
      const res = await axios.get(
        `${FASTAPI_BASE_URL}/student/${encodeURIComponent(user.email)}/tests/alltestresult`
      );
      setMyTestResults(res.data);
    } catch (err) {
      console.error("Error fetching my test results:", err);
    }
  };

  // BDD 02/03/2026 student-practice-test-phase1
  const fetchMyPracticeTests = async () => {
    if (!user?.email) return;
    try {
      const res = await axios.get(`${FASTAPI_BASE_URL}/practice_tests/my`, {
        params: { email: user.email },
      });
      setMyPracticeTests(res.data);
    } catch (err) {
      console.error("Error fetching my practice tests:", err);
    }
  };

  // Fetch test results when the "tests" tab is active or navigating to tests page:
  useEffect(() => {
    if (activeSidebarTab === 'tests' || learningSubModule === 'tests') {
      fetchMyTestResults();
      fetchMyPracticeTests();
    }
  }, [activeSidebarTab, learningSubModule]);


  // Update click and quiz functions:
  const handleClick = () => {
    setClickCount(prev => {
      const newVal = prev + 1;
      clickCountRef.current = newVal; // update ref
      // console.log("click count:", newVal);
      return newVal;
    });
  };

  // Function to track quiz attempts locally
  const handleQuizStart = () => {
    setQuizAttempts(prev => {
      const newVal = prev + 1;
      quizAttemptsRef.current = newVal; // update ref
      // console.log("quiz count:", newVal);
      showReward();
      return newVal;
    });
  };

  const handleSubmitTest = async () => {
    const answersPayload = Object.entries(userAnswers).reduce((acc, [questionId, ans]) => {
      acc[questionId] = ans;
      return acc;
    }, {});

    const payload = {
      student_email: user_id,
      time_taken: activeTest.duration_minutes * 60 - testTimeLeft,
      answers: answersPayload
    };

    try {
      const res = await axios.post(
        `${FASTAPI_BASE_URL}/tests/${activeTest.id}/submit-eval`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      const scoreMsg = `${t("Score")}: ${res.data.score}/${res.data.total}`;

      // Refresh result lists so the newly submitted attempt shows up.
      fetchMyTestResults();
      fetchMyPracticeTests();

      // Practice tests land on the new-style result review screen
      // (same surface as tapping a past result) instead of a plain alert.
      if (isPractice) {
        const feedback = computeAnswerFeedback(quizData, userAnswers);
        setAnswerFeedback(feedback);
        setQuizMode("pastTestView");
        setQuizNav(null);
        setTestReadyToStart(false);
        setTestTimerActive(false);
        setShowQuiz(true);
        return;
      }

      if (Platform.OS === "web") {
        alert(`${t("Test Submitted")}\n\n${scoreMsg}`);
      } else {
        Alert.alert(t("Test Submitted"), scoreMsg);
      }
      // Reset all test-related state
      setShowQuiz(false);
      setQuiz([]);
      setQuizMode(null);
      setQuizNav(null);
      setUserAnswers({});
      setAnswerFeedback({});
      setTestReadyToStart(false);
      setActiveTest(null);
      setTestTimerActive(false);
      const shouldReturnHome =
        testReturnTargetRef.current === "home";
      testReturnTargetRef.current = "tests";

      if (shouldReturnHome) {
        setLearningSubModule("modules");
        setActiveModule("home");
      } else {
        // Preserve the existing behavior for tests launched elsewhere.
        setLearningSubModule("tests");
      }
    } catch (err) {
      console.error("Failed to submit test:", err);
      const errorMsg = t("Something went wrong while submitting your test. Please try again.");
      if (Platform.OS === "web") {
        alert(`${t("Error")}\n\n${errorMsg}`);
      } else {
        Alert.alert(t("Error"), errorMsg);
      }
      // Bug fix: even on submit error, release the UI lock. The back button
      // is hidden during an active test, so a failed submit otherwise leaves
      // the student stranded on the "Test in Progress" screen.
      setShowQuiz(false);
      setQuiz([]);
      setQuizMode(null);
      setQuizNav(null);
      setUserAnswers({});
      setAnswerFeedback({});
      setTestReadyToStart(false);
      setActiveTest(null);
      setTestTimerActive(false);
      testReturnTargetRef.current = "tests";
      setLearningSubModule("tests");
    }
  };


  // BDD Begin New Code 3/14/2025 to fix engagement and activity etc
  const fetchAssessmentsAndEngagementLogs = async (append = false, viewTypeOverride = null) => {
    try {
      const currentViewType = viewTypeOverride || engagementViewType;
      const offset = append ? engagementLogs.length : 0;
      const [assessmentsResponse, engagementResponse] = await Promise.all([
        axios.get(`${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/assessments`),
        axios.get(`${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/get-engagement`, {
          params: { view_type: currentViewType, limit: 7, offset }
        })
      ]);
      // console.log("assessmentsResponse:", assessmentsResponse);
      // console.log("engagementResponse:", engagementResponse);

      setAssessments(assessmentsResponse.data || []);
      const engData = engagementResponse.data;
      if (append) {
        setEngagementLogs(prev => [...prev, ...(engData.data || [])]);
      } else {
        setEngagementLogs(engData.data || []);
      }
      setEngagementHasMore(engData.has_more || false);
    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  };

  const loadMoreEngagement = () => {
    fetchAssessmentsAndEngagementLogs(true);
  };

  const handleEngagementViewTypeChange = (newViewType) => {
    setEngagementViewType(newViewType);
    setEngagementLogs([]); // Clear existing data
    fetchAssessmentsAndEngagementLogs(false, newViewType);
  };

  const fetchEngagementExtraData = async () => {
    try {
      const [nudgeResponse, leaderboardResponse, badgesResponse] = await Promise.all([
        // axios.get(`${FASTAPI_BASE_URL}/student/${user_id}/nudge`),
        axios.get(`${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/nudge`),
        axios.get(`${FASTAPI_BASE_URL}/leaderboard`),
        axios.get(`${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/badges`)
      ]);
      setAiNudge(nudgeResponse.data.nudge);
      setLeaderboard(leaderboardResponse.data || []);
      setBadges(badgesResponse.data.badges || []);
    } catch (error) {
      console.error("Error fetching engagement extra data:", error);
    }
  };

  const fetchAdaptiveRecommendation = async () => {
    try {
      const response = await axios.get(`${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/adaptive-learning`);
      setAdaptiveRecommendation(t(response.data.recommendation));
    } catch (error) {
      console.error("Error fetching adaptive learning recommendation:", error);
    }
  };
  // Run on mount or when user_id changes to load baseline student data:
  useEffect(() => {
    if (user_id !== "Guest") {
      fetchAssessmentsAndEngagementLogs();
    }
  }, [user_id]);

  // Update Engagement function to use refs:
  // const updateEngagement = async () => {
  //     // console.log("updateEngagement() triggered");

  //     // Use refs to get the latest values
  //     if (clickCountRef.current > 0 || quizAttemptsRef.current > 0) {
  //         try {
  //             const response = await axios.post(
  //                 `${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/update-engagement`,
  //                 { clicks: clickCountRef.current, quiz_attempts: quizAttemptsRef.current }
  //             );
  //             // console.log("Engagement updated successfully:", response.data);
  //             // Reset counters after a successful API call (reset both state and refs)
  //             setClickCount(0);
  //             setQuizAttempts(0);
  //             clickCountRef.current = 0;
  //             quizAttemptsRef.current = 0;
  //             // Refresh the displayed data
  //             fetchAssessmentsAndEngagementLogs();
  //             fetchEngagementExtraData();
  //         } catch (error) {
  //             console.error("Error updating engagement:", error);
  //         }
  //     } else {
  //         // console.log("No engagement updates sent (No new activity).");
  //     }
  // };
  // BDD 11/18/2025
  const updateEngagement = async () => {
    // Use refs to get the latest values
    const hasActivity =
      clickCountRef.current > 0 ||
      quizAttemptsRef.current > 0 ||
      timeActiveSecondsRef.current > 0 ||
      pwoLaunchesRef.current > 0 ||
      videoPlaysRef.current > 0 ||
      aiQuestionsRef.current > 0;

    if (!hasActivity) {
      // console.log("No engagement updates sent (No new activity).");
      return;
    }

    try {
      const payload = {
        clicks: clickCountRef.current,
        quiz_attempts: quizAttemptsRef.current,
        time_active_seconds: timeActiveSecondsRef.current,
        pwo_launches: pwoLaunchesRef.current,
        video_plays: videoPlaysRef.current,
        ai_questions: aiQuestionsRef.current,
      };

      const response = await axios.post(
        `${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/update-engagement`,
        payload
      );


      setClickCount(0);
      setQuizAttempts(0);

      clickCountRef.current = 0;
      quizAttemptsRef.current = 0;
      timeActiveSecondsRef.current = 0;
      pwoLaunchesRef.current = 0;
      videoPlaysRef.current = 0;
      aiQuestionsRef.current = 0;

      // Refresh the displayed data
      fetchAssessmentsAndEngagementLogs();
      fetchEngagementExtraData();
    } catch (error) {
      console.error("Error updating engagement:", error);
    }
  };

  const fetchStudentProfile = async () => {
    try {
      // const storedEmail = await AsyncStorage.getItem("auth_email");
      // if (!storedEmail) return;

      // console.log("📥 Fetching Student Profile...");

      const response = await fetch(`${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/profile`);
      if (!response.ok) throw new Error("Failed to fetch profile");

      const data = await response.json();
      // console.log("✅ Student Profile Fetched:", data);

      // Set profile data state
      setProfileData({
        grade: data.grade || "",
        age: data.age ? data.age.toString() : "",
        passion: data.passion || "",
        favorite_stem_subject: data.favorite_stem_subject || "",
        extracurricular_activity: data.extracurricular_activity || "",
        preferred_learning_style: data.preferred_learning_style || "",
      });

      setSelectedPrimaryLang(String(data.primary_language || "auto"));
      await AsyncStorage.setItem("primary_language_id", data.primary_language || "auto");

      // This will update context _and_ AsyncStorage:
      updateSecondaryLang(String(data.secondary_language || "auto"));
      // await AsyncStorage.setItem("secondary_language_id", data.secondary_language || "none");

      // ← NEW: load the three auto‑flags from the server payload
      // setAutoFetchReferences(data.auto_fetch_references);
      // setAutoPlayVideo(data.auto_play_video);
      // setAutoOpenPWO(data.auto_open_pwo);
      // setRestrictToRAGOnly(!!data.restrict_to_rag_only);  // NEW BDD 9/5/2025

      // setAutoFetchReferences(asBool(data.auto_fetch_references, true)); // BDD 11/7/2025
      setAutoPlayVideo(asBool(data.auto_play_video, false));
      setAutoOpenPWO(asBool(data.auto_open_pwo, false));
      // setRestrictToRAGOnly(asBool(data.restrict_to_rag_only, false));

      // BDD 10/3/2025
      // BDD 01/18/2026 - Only set viewMode from server if user has no saved preference
      if (!userHasSavedPreferenceRef.current) {
        const cv = asBool(data.curriculum_view, false);
        setViewMode(cv ? "curriculum" : "collections");
      }
      // // optional: cache locally so we can pick a better default before server returns next time
      // await AsyncStorage.setItem("curriculum_view", cv ? "1" : "0");      // NEW


    } catch (error) {
      console.error("❌ Error fetching profile:", error);
    }
    // finally { // BDD 10/3/2025 -- remove this for now as it was not working
    //   setProfileFetched(true);          // <-- you were missing this
    // }

  };
  fetchStudentProfileRef.current = fetchStudentProfile;
  const saveStudentProfile = async () => {
    try {
      // Fetch existing profile from the backend
      const response = await fetch(`${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/profile`);
      if (!response.ok) throw new Error("Failed to fetch existing profile");
      const existingProfile = await response.json();

      // Extract new input (and trim text fields)

      const updatedProfile = {
        grade: profileData.grade?.trim() || null,
        age: profileData.age ? parseInt(profileData.age, 10) : null,
        passion: profileData.passion?.trim() || null,
        favorite_stem_subject: profileData.favorite_stem_subject?.trim() || null,
        extracurricular_activity: profileData.extracurricular_activity?.trim() || null,
        preferred_learning_style: profileData.preferred_learning_style?.trim() || null,
        secondary_language: selectedSecondaryLang && selectedSecondaryLang !== "auto"
          ? selectedSecondaryLang
          : null,  // Treat "auto" as no selection
      };


      // Merge: Keep existing value if updated value is null or empty
      const mergedProfile = {
        grade: updatedProfile.grade || existingProfile.grade,
        age: updatedProfile.age !== null ? updatedProfile.age : existingProfile.age,
        passion: updatedProfile.passion || existingProfile.passion,
        favorite_stem_subject: updatedProfile.favorite_stem_subject || existingProfile.favorite_stem_subject,
        extracurricular_activity: updatedProfile.extracurricular_activity || existingProfile.extracurricular_activity,
        preferred_learning_style: updatedProfile.preferred_learning_style || existingProfile.preferred_learning_style,
        secondary_language: updatedProfile.secondary_language || existingProfile.secondary_language,
        school: updatedProfile.school || existingProfile.school, // ✅ ADD THIS LINE

        // ← NEW: include the three auto‑flags in the payload
        // auto_fetch_references: autoFetchReferences,
        auto_play_video: autoPlayVideo,
        auto_open_pwo: autoOpenPWO,
        // restrict_to_rag_only: restrictToRAGOnly,   // NEW BDD 9/5/2025
        skip_translate_for_ref: shouldSkipTranslateForRef(), // BDD 02/08/2026 - derive skip_translate_for_ref from language selection
        curriculum_view: curriculumView,
      };


      // Save the merged profile
      const saveResponse = await fetch(`${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/update-profile`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(mergedProfile),
      });

      if (!saveResponse.ok) throw new Error("Failed to save merged profile");
      // BDD 10/3/2025
      // // NEW: also remember locally
      // await AsyncStorage.setItem("curriculum_view", curriculumView ? "1" : "0");

      Alert.alert(t("✅ Success"), t("Profile updated successfully!"));
    } catch (error) {
      console.error("❌ Error saving profile:", error);
      Alert.alert(t("⚠️ Error"), t("Could not save profile."));
    }
  };

  useEffect(() => {
    if (user_id) {
      fetchStudentProfile();
    }
  }, [user_id]);


  // 🔹 Save profile automatically when profileData or languages change
  useEffect(() => {
    if (selectedSecondaryLang && selectedSecondaryLang !== "none") {
      saveStudentProfile();
    }
  }, [selectedSecondaryLang]);


  // useEffect(() => {
  //   // console.log("Engagement tracking effect triggered.");

  //   let lastUpdateTime = Date.now();

  //   const handleUnload = () => {
  //     // console.log("User exiting - Saving engagement data...");
  //     updateEngagement();
  //   };

  //   const interval = setInterval(() => {
  //     const currentTime = Date.now();
  //     if (currentTime - lastUpdateTime >= 300000) {  // 5 minutes
  //       // console.log(`${(currentTime - lastUpdateTime) / 1000}s since last update - Sending engagement data...`);
  //       updateEngagement();
  //       lastUpdateTime = Date.now();
  //     }
  //   }, 60000); // check every minute

  //   window.addEventListener("beforeunload", handleUnload);

  //   return () => {
  //     // console.log("Cleaning up interval and event listener...");
  //     clearInterval(interval);
  //     window.removeEventListener("beforeunload", handleUnload);
  //   };
  // }, []);
  // BDD 11/18/2025
  useEffect(() => {
    let lastUpdateTime = Date.now();

    const flushWithTime = () => {
      const now = Date.now();
      const deltaMs = now - lastUpdateTime;
      if (deltaMs > 0) {
        const deltaSeconds = Math.floor(deltaMs / 1000);
        // Accumulate time spent since lastUpdateTime
        timeActiveSecondsRef.current += deltaSeconds;
      }
      updateEngagement();
      lastUpdateTime = now;
    };

    const handleUnload = () => {
      // console.log("User exiting - Saving engagement data...");
      flushWithTime();
    };

    const interval = setInterval(() => {
      const now = Date.now();
      const deltaMs = now - lastUpdateTime;
      // 300000 ms = 5 minutes (so you were sending every 5 min, not 10 😉)
      if (deltaMs >= 300000) {
        // console.log(`${deltaMs / 1000}s since last update - Sending engagement data...`);
        flushWithTime();
      }
    }, 60000); // check every minute

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      clearInterval(interval);
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, []);

  // BDD End New Code 3/14/2025 to fix engagement and activity etc

  // useEffect(() => {
  //   const fetchCurriculum = async () => {
  //       try {
  //           const response = await axios.get(API_URL_CURRICULUM);
  //           setCurriculum(response.data);
  //       } catch (error) {
  //           console.error("Error fetching curriculum:", error);
  //       }
  //   };
  //   fetchCurriculum();
  //   }, []);
  // BDD 6/16/2025 to switch to tile look based on images
  // useEffect(() => {
  //   const fetchCurriculum = async () => {
  //     try {
  //       // const response = await axios.get(`${FASTAPI_BASE_URL}/curriculum_with_images`, {
  //       //   params: { user_id: user_id }, 
  //       // });

  //       // BDD 12/08/2025
  //       const curriculumLang = resolveCurriculumLang(selectedSecondaryLang);

  //       const response = await axios.get(`${FASTAPI_BASE_URL}/curriculum_with_images`, {
  //         params: {
  //           user_id: user_id,
  //           lang: curriculumLang, // 👈 NEW
  //         },
  //       });

  //       // ✅ store curriculum and lookup maps
  //       setCurriculum(response.data.curriculum);

  //       setPwoTopicMap(response.data.pwo_topic_map);
  //       setVideoTopicMap(response.data.video_topic_map);
  //       // setCurrentCurriculum(response.data.curriculum_name || null); // BDD 10/15/2025
  //       setCurrentCurriculum((response.data.curriculum_name || "").toLowerCase()); // BDD 10/23

  //       setQuizCountMap(response.data.quiz_count_map || {}); // BDD 10/17/2025
  //     } catch (error) {
  //       console.error("Error fetching enriched curriculum:", error);
  //     }
  //   };

  //   fetchCurriculum();
  // }, []);

  // BDD 12/08/2025
  useEffect(() => {
    const fetchCurriculum = async () => {
      try {
        const curriculumLang = resolveCurriculumLang(selectedSecondaryLang);

        const response = await axios.get(`${FASTAPI_BASE_URL}/curriculum_with_images`, {
          params: {
            user_id: user_id,
            lang: curriculumLang,   // 👈 drives localization on backend
          },
        });

         // BDD 03/16/2026
        // ===== DEBUG: inspect chapter 341 from raw API response =====
        if (DEBUG_VIDEO_CHAPTER) {
          try {
            const curriculumData = response.data.curriculum || [];
            const videoMap = response.data.video_topic_map || {};

            let debugChapter = null;
            let debugSubject = null;
            let debugLevel = null;

            for (const level of curriculumData) {
              for (const subject of (level.subjects || [])) {
                const foundChapter = (subject.chapters || []).find(
                  (c) => String(c.id) === String(DEBUG_CHAPTER_ID)
                );
                if (foundChapter) {
                  debugChapter = foundChapter;
                  debugSubject = subject;
                  debugLevel = level;
                  break;
                }
              }
              if (debugChapter) break;
            }

            console.log("====================================================");
            console.log("[API DEBUG] Chapter 341 lookup from /curriculum_with_images");
            console.log({
              levelId: debugLevel?.id,
              levelName: debugLevel?.display_name || debugLevel?.name,
              subjectId: debugSubject?.id,
              subjectName: debugSubject?.display_name || debugSubject?.name,
              chapterId: debugChapter?.id,
              chapterName: debugChapter?.display_name || debugChapter?.name,
              topicCount: debugChapter?.topics?.length || 0,
            });

            const chapterTopicRows = (debugChapter?.topics || []).map((topic) => {
              const boardTopicId = topic.id;
              const sourceTopicId = topic.source_id;
              const key = `${String(boardTopicId)}|${String(sourceTopicId)}`;
              const vRaw = videoMap[key];

              return {
                topicName: topic.display_name || topic.name,
                boardTopicId,
                sourceTopicId,
                key,
                hasVideoKey: !!vRaw,
                videoShape: summarizeVideoRaw(vRaw),
                videoCount: countFrom(vRaw, "video"),
              };
            });

            console.table(chapterTopicRows);

            const missingVideoKeys = chapterTopicRows.filter(r => !r.hasVideoKey);
            if (missingVideoKeys.length) {
              console.log("[API DEBUG] Missing video_topic_map keys for chapter 341:");
              console.table(missingVideoKeys);
            }

            console.log("====================================================");
          } catch (e) {
            console.error("[API DEBUG] chapter 341 inspection failed:", e);
          }
        }
        // ===== END DEBUG =====
        // ✅ store curriculum and lookup maps
        setCurriculum(response.data.curriculum);
        setPwoTopicMap(response.data.pwo_topic_map);
        setVideoTopicMap(response.data.video_topic_map);
        setCurrentCurriculum((response.data.curriculum_name || "").toLowerCase());
        setQuizCountMap(response.data.quiz_count_map || {});
        setBoardToSourceTopicMap(response.data.board_to_source_topic_map || {});

        // BDD 02/03/2026 student-practice-test-phase1 - try4
        console.log("CURRICULUM[0] keys:", Object.keys(response.data.curriculum?.[0] || {}));
        console.log("GRADE id:", response.data.curriculum?.[0]?.id, "label:", response.data.curriculum?.[0]?.name);

        const subj0 = response.data.curriculum?.[0]?.subjects?.[0];
        console.log("SUBJECT[0] keys:", Object.keys(subj0 || {}), "id:", subj0?.id);

        const ch0 = subj0?.chapters?.[0];
        console.log("CHAPTER[0] keys:", Object.keys(ch0 || {}), "id:", ch0?.id);

      } catch (error) {
        console.error("Error fetching enriched curriculum:", error);
      }
    };

    fetchCurriculum();
  }, [
    selectedSecondaryLang,  // 👈 re-run whenever user changes language
    user_id,                // (and if user ever changes)
    contentDb,              // 👈 re-run when board changes (e.g., after onboarding)
  ]);

  // BDD 6/16/2025 to switch to tile look based on images
  useEffect(() => {
    async function loadAllImages() {
      if (!authToken) return;
      const topicPaths = [];
      const chapterPaths = [];
      curriculum.forEach(level =>
        level.subjects.forEach(subject =>
          subject.chapters.forEach(chap => {
            if (chap.chapter_image_path) chapterPaths.push(chap.chapter_image_path);
            chap.topics.forEach(topic => {
              if (topic.topic_image_path) topicPaths.push(topic.topic_image_path);
            });
          })
        )
      );
      const allPaths = [...new Set([...topicPaths, ...chapterPaths])];
      if (!allPaths.length) return;

      const signed = await fetchPresignedUrls(allPaths).catch(err => {
        console.error("Image fetch failed:", err);
        return [];
      });
      const pathToUrl = {};
      signed.forEach(entry => {
        pathToUrl[entry.key.replace("content_streaming/image", "")] = entry.url;
      });
      console.log(`🖼️ [Tiles] Loaded ${signed.length} image URLs`);
      setImageUrlMap(pathToUrl);
      setImagesLoaded(true);
    }
    if (curriculum.length && pwoTopicMap && videoTopicMap) {
      loadAllImages();
    }
  }, [curriculum, pwoTopicMap, videoTopicMap, imageExpiredTrigger]);

  // Subjects now start collapsed - only the selected chapter's subject
  // gets expanded via ensureExpandedForChapter when chapter is restored from storage

  const onImageExpired = () => {
    console.warn("Refreshing all presigned URLs...");
    setImageExpiredTrigger(t => t + 1);
  };

  const toggleExpandGrade = (gradeId) => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    setExpandedGrades((prev) => ({
      ...prev,
      [gradeId]: !prev[gradeId],
    }));
  };

  const toggleExpandSubject = (gradeId, subjectId) => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    setExpandedSubjects((prev) => ({
      ...prev,
      [gradeId]: { ...prev[gradeId], [subjectId]: !prev[gradeId]?.[subjectId] },
    }));
  };

  const toggleExpandChapter = (subjectId, chapterId) => {

    setExpandedChapters((prev) => ({
      ...prev,
      [subjectId]: { ...prev[subjectId], [chapterId]: !prev[subjectId]?.[chapterId] },
    }));
    const defaultHeader = t("Connect and reflect on this chapter:");
    const defaultQuestions = [
      t("Summarize this chapter"),
      t("Explain the key concepts of this chapter"),
      t("How does this chapter connect with earlier topics?"),
    ];

    // Fire-and-forget is fine here
    fetchCollectionSuggestedQuestions("chapter", defaultHeader, defaultQuestions);

  };

  // BDD 01/15/2026 - Summarize this topic AI ask
  const toggleExpandTopic = async (chapterId, topicId, topicMeta = null) => {
    console.log("[AI][toggleExpandTopic called] meta?", !!topicMeta, topicMeta);

    try {

      console.log("In1 toggleExpandTopic: chapterId, topicId", chapterId, topicId);

      // Always resolve real board_topic_id first (supports collection keys too)
      const realTopicId = resolveBoardTopicId(topicId);
      if (!realTopicId) {
        console.warn("Could not resolve topic id for", topicId);
        return;
      }
      console.log("In2 toggleExpandTopic: chapterId, topicId", chapterId, topicId);

      // ✅ meta topic/chapter names: support both snake_case and camelCase
      const metaTopicName = (
        topicMeta?.topic_name ||
        topicMeta?.topicName ||
        topicMeta?.display_name ||
        topicMeta?.displayName ||
        topicMeta?.name ||
        ""
      ).trim();

      const metaChapterName = (
        topicMeta?.chapter_name ||
        topicMeta?.chapterName ||
        topicMeta?.chapter_display_name ||
        topicMeta?.chapterDisplayName ||
        topicMeta?.display_name ||     // sometimes callers pass a generic label
        topicMeta?.displayName ||
        topicMeta?.name ||
        ""
      ).trim();

      // ✅ meta source_topic_id (if caller provided)
      const metaSourceTopicId =
        topicMeta?.source_topic_id ??
        topicMeta?.sourceTopicId ??
        topicMeta?.source_id ??
        topicMeta?.sourceId ??
        null;

      // ✅ authoritative map fallback: board_topic_id -> source_topic_id
      const mappedSourceTopicId =
        boardToSourceTopicMap?.[String(realTopicId)] ?? null;

      const defaultHeader = t("Focus and apply this topic:");
      const defaultQuestions = [
        t("Summarize this topic"),
        t("Explain the key concepts of this topic"),
        t("How would you apply what you learned in this topic?"),
      ];

      const alreadyLoaded = !!expandedTopics[chapterId]?.[topicId]?.videos;
      const wasExpanded = !!expandedTopics[chapterId]?.[topicId]?.expanded;
      const willExpand = !wasExpanded;

      // ✅ Helper: build topicScope from any content-like object
      const buildScopeFrom = (obj) => {
        const contentSourceTopicId =
          obj?.source_topic_id ??
          obj?.topic_snapshot?.source_topic_id ??
          obj?.sourceTopicId ??
          obj?.source_id ??
          obj?.sourceId ??
          null;

        const contentTopicName = (
          obj?.topic_name ||
          obj?.topicName ||
          obj?.display_name ||
          obj?.displayName ||
          obj?.name ||
          ""
        ).trim();

        const contentChapterName = (
          obj?.chapter_name ||
          obj?.chapterName ||
          obj?.chapter_display_name ||
          obj?.chapterDisplayName ||
          ""
        ).trim();

        const scope = {
          chapterId,
          topicId,
          board_topic_id: realTopicId,

          // ✅ IMPORTANT: include mappedSourceTopicId as the last fallback
          source_topic_id:
            contentSourceTopicId ?? metaSourceTopicId ?? mappedSourceTopicId ?? null,

          // ✅ IMPORTANT: include metaTopicName fallback (fixes blank topic_name)
          topic_name: contentTopicName || metaTopicName || "",

          chapter_name: contentChapterName || metaChapterName || "",
          chapter_id: chapterId,
        };

        activeTopicForAIRef.current = scope;
        setSuggestedQuestionsMeta({ kind: "topic", topicScope: scope });

        console.log("[AI][topic scope set by toggleExpandTopic]", scope);
        return scope;
      };

      // If not loaded yet, fetch content
      if (!alreadyLoaded) {
        const curriculumLang = resolveCurriculumLang(selectedSecondaryLang);

        const response = await axios.get(`${FASTAPI_BASE_URL}/content/${realTopicId}`, {
          params: { language_id: languageID, user_id: user_id, lang: curriculumLang },
        });
        const topicContent = response.data;
        console.log('[DEBUG] topic content for', realTopicId, { videos: topicContent?.videos, pwos: topicContent?.pwos, keys: Object.keys(topicContent || {}) });

        // ✅ set scope from content + meta + map
        buildScopeFrom(topicContent);

        setExpandedTopics((prev) => ({
          ...prev,
          [chapterId]: {
            ...prev[chapterId],
            [topicId]: { expanded: true, ...topicContent },
          },
        }));

        // Videos/PWOs initially collapsed
        setExpandedVideos((prev) => ({
          ...prev,
          [`${chapterId}-${topicId}`]: false,
        }));
        setExpandedPWOs((prev) => ({
          ...prev,
          [`${chapterId}-${topicId}`]: false,
        }));

        // Refresh topic suggestions for this topic
        await fetchCollectionSuggestedQuestions("topic", defaultHeader, defaultQuestions);
        return;
      }

      // Already loaded → build scope from cached object
      const existing = expandedTopics[chapterId]?.[topicId] || {};
      buildScopeFrom(existing);

      // If expanding now, refresh topic suggestions (prevents “previous topic” prompts)
      if (willExpand) {
        await fetchCollectionSuggestedQuestions("topic", defaultHeader, defaultQuestions);
      }

      // Toggle expand/collapse
      setExpandedTopics((prev) => ({
        ...prev,
        [chapterId]: {
          ...prev[chapterId],
          [topicId]: {
            ...prev[chapterId][topicId],
            expanded: !prev[chapterId][topicId].expanded,
          },
        },
      }));
    } catch (error) {
      console.error(`Error fetching content for topic ${topicId}:`, error);
    }
  };

  // const toggleExpandVideos = (chapterId, topicId) => {
  //   setExpandedVideos((prev) => ({
  //     ...prev,
  //     [`${chapterId}-${topicId}`]: !prev[`${chapterId}-${topicId}`]
  //   }));
  // };

  const toggleExpandVideos = (chapterId, topicId) => {
    const realTopicId = resolveBoardTopicId(topicId);
    const tc = expandedTopics?.[chapterId]?.[topicId] || {};

    const scope = {
      chapterId,
      topicId,
      board_topic_id: realTopicId,
      source_topic_id: tc?.source_topic_id ?? tc?.topic_snapshot?.source_topic_id ?? null,
      topic_name: (tc?.topic_name || tc?.topicName || tc?.name || "").trim(),
      chapter_name: (tc?.chapter_name || tc?.chapterName || "").trim(),
      chapter_id: chapterId,
    };

    if (scope.board_topic_id) {
      activeTopicForAIRef.current = scope;
      setSuggestedQuestionsMeta({ kind: "topic", topicScope: scope });
      console.log("[AI][topic scope set by toggleExpandVideos]", scope);
    }

    setExpandedVideos((prev) => ({
      ...prev,
      [`${chapterId}-${topicId}`]: !prev[`${chapterId}-${topicId}`],
    }));
  };

  const toggleExpandPWOs = (chapterId, topicId) => {
    const realTopicId = resolveBoardTopicId(topicId);
    const tc = expandedTopics?.[chapterId]?.[topicId] || {};

    const scope = {
      chapterId,
      topicId,
      board_topic_id: realTopicId,
      source_topic_id: tc?.source_topic_id ?? tc?.topic_snapshot?.source_topic_id ?? null,
      topic_name: (tc?.topic_name || tc?.topicName || tc?.name || "").trim(),
      chapter_name: (tc?.chapter_name || tc?.chapterName || "").trim(),
      chapter_id: chapterId,
    };

    if (scope.board_topic_id) {
      activeTopicForAIRef.current = scope;
      setSuggestedQuestionsMeta({ kind: "topic", topicScope: scope });
      console.log("[AI][topic scope set by toggleExpandVideos]", scope);
    }
    setExpandedPWOs((prev) => ({
      ...prev,
      [`${chapterId}-${topicId}`]: !prev[`${chapterId}-${topicId}`]
    }));
  };
  const handleTeacherDashboard = async () => {
    // Reset any open module before switching. If a test is running, the exit
    // warning is shown; Cancel (canClose === false) must keep the student in
    // the test, so bail out before touching any navigation state (AIT-299).
    const canClose = await handleCloseModule(true);
    if (showQuiz && quizMode === "test" && !canClose) return;
    setActiveModule("teacherDashboard");
    setShowQuiz(false);  // Hide quiz
    // setShowQuiz(false);
    setActiveTopic(null); /* Reset if not PWO or video */
    setActiveVideo(null);
    setActivePWO(null);  // Reset PWO when playing video
  };
  // BDD 6/16/2025 - tile image based layout
  // BDD 9/7/2025 - passed on the token argument instead of using global authToken
  // BDD 10/3/2025 - wrap with fetchWithAuth so it fetches new token if stale
  // async function fetchPresignedUrls(imagePathList, token) {
  //   if (!token) {
  //     console.error("❌ No auth token found. Cannot fetch presigned URLs.");
  //     return [];
  //   }
  //   console.log("🟢 React → FastAPI: Authorization header = ", token);
  async function fetchPresignedUrls(imagePathList) {

    try {
      // const res = await fetch(`${FASTAPI_BASE_URL}/proxy_contentimageurl/`, {
      const res = await fetchWithAuth(`${FASTAPI_BASE_URL}/proxy_contentimageurl/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: token, // BDD 10/3/2025
        },
        body: JSON.stringify({
          image_path_list: imagePathList,
        }),
        rawAuth: true, // <-- this endpoint expects the token without "Bearer "

      });

      if (!res.ok) {
        const error = await res.json();
        console.error("❌ Failed to fetch presigned URLs:", error.message);
        return [];
      }

      const result = await res.json();
      return result.data?.url_list || [];
    } catch (err) {
      console.error("❌ Error calling proxy_contentimageurl:", err);
      return [];
    }
  }


  const fetchQuiz = async (topicId, languageIDquiz, subjectName, subjectId, topicName, chapterName) => {
    // AIT-246: fetchQuiz is only reached by manual opens (auto uses openAutoWalkthroughQuiz).
    autoOpenReturnRef.current = null;
    // await handleCloseModule();  // Reset any open module before switching
    const canClose = await handleCloseModule(true);
    if (showQuiz && quizMode === "test" && !canClose) return;

    setActiveModule("quiz");    // ✅ keep this (your UI switches on it)
    handleQuizStart();          // Γ£à Log that a quiz is started
    handleClick();
    setLoading(true);
    setQuiz([]);                // Clear stale quiz data before fetching new topic
    setShowQuiz(true);
    setActiveTopic(null);       // Reset if not PWO or video
    setActiveVideo(null);
    setActivePWO(null);

    // Reset previous quiz answers/state so retrying starts fresh
    setUserAnswers({});
    setAnswerFeedback({});
    setShowHints({});
    setShowSolutions({});
    setQuizResponses({});
    setAttemptedQuestions([]);

    try {
      const response = await axios.get(`${FASTAPI_BASE_URL}/quiz/${topicId}`, {
        params: {
          language_id: languageIDquiz,
          subject_name: subjectName,
          subject_id: subjectId,
          topic_name: topicName,
          chapter_name: chapterName
        }
      });

      setSuggestedQuestions([]);
      setSuggestedQuestionsHeader([]);

      if (!response.data || !response.data.quiz || !response.data.assessment_id) {
        // Treat as empty quiz (rare, but safe)
        setAssessmentId(null);
        setQuiz([]);            // your UI shows “No questions available…”
        setQuizMode("quiz");
        return;
      }

      // Store assessment_id for later use in `submitQuiz`
      setAssessmentId(response.data.assessment_id);

      const parsedQuiz = normalizeQuizQuestions(response.data.quiz);
      const quizSize = Array.isArray(parsedQuiz) ? parsedQuiz.length : 0;
      console.log("[QuizEngagement] quizSize:", quizSize, "raw quiz length:", response.data.quiz?.length, "parsed:", parsedQuiz?.length);

      // Log quiz engagement (include quiz size so total_questions is always correct)
      quizEngagementIdRef.current = null;
      if (user_id && user_id !== "Guest") {
        axios.post(
          `${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/quiz-engagement`,
          {
            source_topic_id: topicId ?? null,
            collection_id: activeStudyCollection?.id ?? null,
            assessment_id: response.data.assessment_id ?? null,
            source: "manual",
            display_title: topicName || null,
            total_questions: quizSize,
          }
        ).then((res) => {
          quizEngagementIdRef.current = res.data?.engagement_id ?? null;
        }).catch(() => {});
      }
      setQuiz(parsedQuiz);
      setShowQuiz(true);
      setQuizMode("quiz");
      // BDD 10/10/2025
      // Keep these full questions around for debug/demos
      if (typeof window !== "undefined") {
        const full = Array.isArray(parsedQuiz) ? parsedQuiz : [];
        window.__latestQuizFull = full;         // <-- last quiz as full objects
        window.__quizCache = window.__quizCache || {};
        for (const q of full) {
          const qid = q?.question_id ?? q?.id ?? q?.qid;
          if (qid != null) window.__quizCache[String(qid)] = q;
        }
        console.log("🧠 (quiz) cache size:", Object.keys(window.__quizCache).length);
      }
    } catch (error) {
      const status = error?.response?.status;

      if (status === 404) {
        // ✅ No quiz for this topic → quietly show empty state
        setAssessmentId(null);
        setQuiz([]);            // your UI already renders “No questions available…”
        setShowQuiz(true);
        setQuizMode("quiz");
        // no console.error here — intentional
      } else {
        // Real error (network/5xx) → small, non-blocking log
        console.debug("Quiz fetch failed:", error);
        // If you want a toast or banner, do it here; avoid Alert on web.
        // Alert.alert is supported on web (maps to window.alert) but is blocking/ugly.
      }
    } finally {
      setLoading(false);
    }
  };

  const normalizeQuizQuestions = (rawQuiz) => {
    return rawQuiz.map((question) => ({
      ...question,
      options: {
        correct_answer: question.options?.correct_answer,
        option1: question.options?.option1,
        option2: question.options?.option2,
        option3: question.options?.option3,
        option4: question.options?.option4
      },
      hints: {
        hint1: question.hints?.hint1,
        hint2: question.hints?.hint2
      },
      solution: question.solution
    }));
  };

  // Open Collections builder with current board, language and curriculum
  const handleOpenCollections = () => {
    const board = (contentDb && String(contentDb).toLowerCase()) || "anatomy"; // valid: cbse|anatomy|igcse|nyssls
    const languageId = (typeof languageIDquiz !== "undefined" && languageIDquiz) || 1;
    const curriculumTree = curriculum || [];

    navigation.navigate("Collections", {
      board,
      teacherEmail: user_id,   // you defined user_id = user?.email
      ownerEmail: user_id,
      languageId,
      curriculum: curriculumTree,
    });
  };

  // BDD 10/13/2025
  // 🎉 Confetti state (web-only overlay component no-ops on native)
  const [confettiVisible, setConfettiVisible] = React.useState(false);
  const confettiFiredRef = React.useRef(false);
  const quizEngagementIdRef = React.useRef(null);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [insightsOpen, setInsightsOpen] = useState(false);
  const [launcherOpen, setLauncherOpen] = useState(false);
  const [activeLauncherTab, setActiveLauncherTab] = useState("modules"); // "modules" | "tests"

  // Optional: if you don't already have this
  // import { useWindowDimensions, Platform } from "react-native";
  // const { width, height } = useWindowDimensions();

  // 🔎 History filtered per *active collection*; fallback to global if not tagged yet.
  // Expect your history items to carry a `collection_id` you persist server-side.
  const activeCollectionId = activeStudyCollection?.id;
  const collectionHistory = useMemo(() => {
    if (!Array.isArray(history)) return [];
    if (!activeCollectionId) return history;         // fallback: whole session
    const filtered = history.filter(h => h.collection_id === activeCollectionId);
    return filtered.length ? filtered : history;      // fallback if server not tagging yet
  }, [history, activeCollectionId]);



  // BDD 10/13/2025
  // AIT-249: rewritten to compute the score from raw userAnswers + quizData
  // via computeAnswerFeedback instead of relying on quizResponses (which is
  // now empty during deferred quizzes). Analytics payload shape preserved.
  // Also: builds reviewSummary, populates answerFeedback for the review screen,
  // transitions quizMode → "quizReview", and triggers confetti when 100% correct.
  // Returns the summary so callers can decide what to do (transition vs close).
  const submitQuiz = async () => {
    const quizArr = Array.isArray(quizData) ? quizData : [];
    const summary = buildReviewSummary(quizArr, userAnswers);

    // Populate answerFeedback for the review screen render path (which still
    // reads from answerFeedback in QuestionDisplay for status coloring).
    const feedbackMap = {};
    Object.entries(summary.perQuestion).forEach(([qid, info]) => {
      feedbackMap[qid] = info.status;
    });
    setAnswerFeedback(feedbackMap);
    setQuizResponses(feedbackMap);
    setReviewSummary(summary);

    // AIT-249: Confetti is now driven by the post-submit summary, not by a
    // useEffect on answerFeedback. (The legacy effect at L21725 also remains
    // gated so it cannot mis-fire during deferred answering.)
    const allCorrectNow = summary.total > 0 && summary.correct === summary.total;
    if (allCorrectNow && !confettiFiredRef.current) {
      confettiFiredRef.current = true;
      setConfettiVisible(true);
    }

    // BDD 10/14/2025 - HOT FIX CAUTION
    if (!assessmentId || investorMode) {
      console.warn("Skipping quiz analytics submit (no assessment or investor demo).");
      return summary;
    }

    // Preserve historical analytics payload shape. Counts are derived from
    // the freshly-computed summary so the values match what the student sees.
    const totalQuestionsForAnalytics = summary.total;
    const correctAnswers = summary.correct;
    const unattempted = summary.unattempted;
    const score = correctAnswers;            // 1 point per correct (legacy)
    const totalScore = totalQuestionsForAnalytics;

    // Note: "quizData" state var holds the quiz questions array — don't shadow it
    const quizSubmitPayload = {
      assessment_id: Number(assessmentId),
      student_id: String(user_id),
      correct_answers: Number(correctAnswers),
      total_questions: Number(totalQuestionsForAnalytics),
      unattempted: Number(unattempted),
      score: Number(score),
      total_score: Number(totalScore)
    };

    try {
      const response = await axios.post(
        `${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/submit-quiz`,
        quizSubmitPayload,
        { headers: { "Content-Type": "application/json" } }
      );

      // Update quiz engagement with score (use full quiz size, not just answered count)
      const fullQuizSize = Array.isArray(quizData) ? quizData.length : totalQuestionsForAnalytics;
      if (quizEngagementIdRef.current && user_id && user_id !== "Guest") {
        axios.patch(
          `${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/quiz-engagement/${quizEngagementIdRef.current}/score`,
          {
            score: Number(correctAnswers),
            total_questions: Number(fullQuizSize),
            correct_answers: Number(correctAnswers),
          }
        ).catch(() => {});
        quizEngagementIdRef.current = null;
      }
    } catch (error) {
      console.error("Error submitting quiz:", error.response ? error.response.data : error);
    }
    return summary;
  };


  const recognition = useRef(null);
  // ≡ƒÜÇ Called when "Hey Saras" is detected
  const handleWakeWord = () => {
    // console.log("≡ƒÜÇ Wake word detected, activating Whisper...");
    handleVoiceInput(); // Γ£à Triggers Whisper voice recording
  };

  // BDD 10/12/2025 - new version for demo investor_mode cachine etc - try#2
  const handleVideoClick = async (
    videoID,
    tagID,
    authToken,
    chapterID = null,
    topicID = null,
    isAuto = false,
    walkthroughStepOverride = null,
    walkthroughRefsOverride = null,
    _displayLabel = null, // pre-resolved localized "VideoName - TagName"
    minimumStartSecOverride = null // BDD 08/03/2026 - jouney notebook llm video starting at 11 seconds temp fix
  ) => {
    console.log("≡ƒÄ¼ handleVideoClick triggered", {
      videoID,
      tagID,
      currentStep: walkthroughStep,
      autoWalkthroughMode
    });

    // // # BDD 03/18/2026 - Debug Video PKL Reference Search
    // console.log("[VIDEO START DEBUG] handleVideoClick input", {
    //   videoID,
    //   tagID,
    //   isAuto,
    //   displayLabel: _displayLabel,
    //   fromHistoryMatch: history?.some?.(entry =>
    //     (entry.videos || []).some(v => (v.videoID === videoID || v.source_id === videoID) &&
    //                                   (v.tagID === tagID || v.tag_id === tagID))
    //   ),
    // });
    // AIT-246: a manual open ends any pending auto-open return.
    if (!isAuto) autoOpenReturnRef.current = null;

    // BDD 08/30/2026 - Rev 1: remember that this reference was launched from
    // a completed exam review. If we are already inside an asset that itself was
    // launched from review, carry that return target forward across asset hops.
    const shouldReturnToExamReview =
      examReviewAssetReturnRef.current ||
      (showQuiz && quizMode === "pastTestView");

    const canClose = await handleCloseModule(true, walkthroughStepOverride, walkthroughRefsOverride);
    if (showQuiz && quizMode === "test" && !canClose) return;

    if (shouldReturnToExamReview) {
      examReviewAssetReturnRef.current = true;
      console.log("[EXAM REVIEW] Video launch preserved exam-review return target");
    }

    setThreePwoActive(false);
    // Look up video_name and tag_name from available sources (localized at click time)
    // Hoisted outside try blocks so both resume state and engagement can use them
    let videoDisplayName = null;
    let videoTagName = null;

    // 0) Use caller-provided display label (e.g. from picker modal)
    if (_displayLabel && _displayLabel.includes(" - ")) {
      const idx = _displayLabel.indexOf(" - ");
      videoDisplayName = _displayLabel.substring(0, idx);
      videoTagName = _displayLabel.substring(idx + 3);
    } else if (_displayLabel) {
      videoDisplayName = _displayLabel;
    }

    // 1) Try chat history (AI references have name + tag_name)
    if (!videoDisplayName && !videoTagName)
    for (const entry of history) {
      const match = (entry.videos || []).find(
        (v) => (v.videoID === videoID || v.source_id === videoID) &&
               (v.tagID === tagID || v.tag_id === tagID)
      );
      if (match) {
        videoDisplayName = match.name || null;
        videoTagName = match.tag_name || null;
        break;
      }
    }

    // 2) Fallback: search expandedTopics (curriculum/collection loaded content)
    if (!videoDisplayName && !videoTagName) {
      for (const chapTopics of Object.values(expandedTopics || {})) {
        for (const topicData of Object.values(chapTopics || {})) {
          const match = (topicData.videos || []).find(
            (v) => (v.source_id == videoID || v.id == videoID) &&
                   (v.tag_id == tagID)
          );
          if (match) {
            // Prefer display_name (localized) over name (English)
            const displayLabel = match.display_name || match.name || "";
            if (displayLabel && displayLabel.includes(" - ")) {
              const idx = displayLabel.indexOf(" - ");
              videoDisplayName = displayLabel.substring(0, idx);
              videoTagName = displayLabel.substring(idx + 3);
            } else {
              videoDisplayName = displayLabel || null;
            }
            break;
          }
        }
        if (videoDisplayName || videoTagName) break;
      }
    }

    // BDD 01/25/2026 - ResumeState bookmark for video launch
    // # BDD 01/25/2026 studen resum states
    try {
      const resolvedSourceTopicId = resolveSourceTopicId(topicID);
      const parsedKey = parseCollectionTopicKey(topicID);
      const resolvedCollectionId = parsedKey?.collectionId ?? null;
      const canShowCollection = Boolean(activeStudyCollection && collectionResolved);
      const inCollectionModeNow = (viewMode === "collections") && canShowCollection;

      const collectionIdForResume =
        inCollectionModeNow
          ? (resolvedCollectionId ?? activeStudyCollection?.id ?? null)
          : null;

      const contentDbForResume =
        (activeStudyCollection?.base_board) || contentDb || null;

      // Prefer CHAPTER when clicked from chapter/curriculum view, then TOPIC, then COLLECTION
      const resumeChapterId = chapterID ?? selectedChapterId ?? null;
      const scopeType = resumeChapterId ? "CHAPTER" : (collectionIdForResume ? "COLLECTION" : null);
      const scopeId = resumeChapterId ?? collectionIdForResume ?? null;

      await updateLearningResumeForAsset({
        content_db: contentDbForResume,
        scope_type: scopeType,
        scope_source_id: scopeId,
        asset_type: "VIDEO",
        asset_source_id: videoID,
        state_json: {
          board_topic_id: topicID ?? null,
          source_topic_id: resolvedSourceTopicId ?? null,
          collection_id: collectionIdForResume ?? null,
          collection_name: activeStudyCollection?.name ?? null,
          tag_id: tagID ?? null,
          video_name: videoDisplayName,
          tag_name: videoTagName,
          content_db: contentDbForResume ?? null,
          chapter_id: resumeChapterId ?? null,
          chapter_name: selectedChapter?.chapterName ?? null,
          topic_name: activeTopicForAIRef.current?.topic_name ?? null,
        },
      });
    } catch (e) {
      console.warn("[resume_state] video launch update failed:", e);
    }

    // BDD 01/10/2026 - guideme-next-steps merge
    // BDD 01/08/2026 - guideme-next-steps
    try {
      const resolvedSourceTopicId = resolveSourceTopicId(topicID);
      const parsedKey = parseCollectionTopicKey(topicID);
      const resolvedCollectionId = parsedKey?.collectionId ?? null;
      const canShowCollection = Boolean(activeStudyCollection && collectionResolved);
      const inCollectionModeNow = (viewMode === "collections") && canShowCollection;

      // BDD 01/10/2026 - guideme-next-steps
      const collectionIdForLog =
        inCollectionModeNow
          ? (resolvedCollectionId ?? activeStudyCollection?.id ?? null)
          : null;

      axios
        .post(
          `${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/video-engagement`,
          {
            video_id: videoID,
            source_topic_id: resolvedSourceTopicId ?? null,
            collection_id: collectionIdForLog, // Γ£à fallback
            tag_id: tagID ?? null,
            source: isAuto ? "ai_walkthrough" : "manual",
            display_title: videoDisplayName && videoTagName && videoDisplayName !== videoTagName
              ? `${videoDisplayName} - ${videoTagName}`
              : videoDisplayName || videoTagName || null,
          }
        )
        .then(() => {
          const cid = resolvedCollectionId ?? activeStudyCollection?.id ?? null;
          if (cid && activeStudyCollection?.id === cid) {
            refreshCollectionProgress();
          }
          if (curriculumView && selectedChapter) {
            refreshChapterProgress();
          }
        })
        .catch((err) => {
          console.warn("Failed to log video engagement", err);
        });
    } catch (e) {
      console.warn("Video engagement logging threw synchronously", e);
    }

    setLoading(true);
    setShowVideo(true);
    setShowQuiz(false);
    setShowPwo(false);
    setIsPwoOpen(false);
    setSuggestedQuestions([]);
    setSuggestedQuestionsHeader([]);
    lastPwoSuggestionsContextRef.current = null;
    setActiveModule("video");
    setCurrentVideoId(videoID);
    setCurrentVideoTagID(tagID);
    handleClick();
    // BDD 11/18/2025 - for engagement logs
    trackVideoPlay();
    setActiveVideo(`${videoID}-${tagID}`);
    setActivePWO(null);

    // Da Vinci 3-Day Challenge: re-check progress after opening a video.
    syncChallenge(activeStudyCollection?.id);

    if (chapterID !== null && topicID !== null) {
      setActiveTopic(`${chapterID}-${topicID}`);
    }

    try {
      // setSuggestedQuestionsHeader([t("Capture key ideas from this video:")]);
      // setSuggestedQuestions([
      //   t("Summarize this video segment"),
      //   t("Summarize this video"),
      //   t("What are the key takeaways?")
      // ]);
      const defaultVideoHeader = t("Capture key ideas from this video:");
      const defaultVideoQuestions = [
        t("Summarize this video segment"),
        t("Summarize this video"),
        t("What are the key takeaways?"),
      ];

      fetchCollectionSuggestedQuestions(
        "video",
        defaultVideoHeader,
        defaultVideoQuestions
      );



      // --- BDD 12/06/2025: compute effective video language at click time ---
      // Use the *video-specific* normalized ref first; fall back to current langCode.
      const rawVideoLangCode =
        videoLangRef.current && videoLangRef.current !== "auto"
          ? videoLangRef.current
          : (langCode || "en");

      // Use your existing priority helper for videos
      const videoPriorityNow = getVideoLanguagePriority(rawVideoLangCode, /* prefer USEnglish */ true);
      const effectiveLanguageIDVideo = videoPriorityNow[0];

      // BDD 03/20/2026 - DEBUG missing video tag behavior - fix bug
      // BDD 08/03/2026 - jouney notebook llm video starting at 11 seconds temp fix
      const normalizeVideoStartSec = (
        rawSec,
        currentTagID,
        metadataDefaultStartSec = null,
        minimumStartSecOverride = null
      ) => {
        const hasMinimumOverride =
          minimumStartSecOverride !== null &&
          minimumStartSecOverride !== undefined &&
          minimumStartSecOverride !== "" &&
          Number.isFinite(Number(minimumStartSecOverride));

        const hasMetadataDefault =
          metadataDefaultStartSec !== null &&
          metadataDefaultStartSec !== undefined &&
          metadataDefaultStartSec !== "" &&
          Number.isFinite(Number(metadataDefaultStartSec));

        const minStartSec = hasMinimumOverride
          ? Number(minimumStartSecOverride)
          : hasMetadataDefault
            ? Number(metadataDefaultStartSec)
            : currentTagID == null
              ? 0
              : 11;

        let sec = Number(rawSec) || 0;

        if (sec < minStartSec) {
          sec = minStartSec;
        }

        return {
          sec,
          minStartSec,
          hasMinimumOverride,
        };
      };

      console.log("[VIDEO] language debug:", {
        selectedSecondaryLang,
        langCode,
        videoLangRefCurrent: videoLangRef.current,
        effectiveLangCode: rawVideoLangCode,
        effectiveLanguageIDVideo,
      });

    
      // BDD 12/31/2025 - Choice of EN - IN and EN - US
      // BDD 01/25/2026 - Debugging
      // Try video languages in priority order (EN: [5,1]; EN-IN: [1])
      let warmed = null;
      let usedLanguageIDVideo = null;

      const priorityListNow =
        (Array.isArray(videoPriorityNow) && videoPriorityNow.length)
          ? videoPriorityNow
          : [LANG_IDS.EN];

      console.log("[VIDEO] warm priority list", {
        videoID,
        tagID,
        priorityListNow,
      });

      for (const langIdTry of priorityListNow) {
        const cacheKeyTry = getVideoCacheKey(videoID, tagID, langIdTry);
        const cached = videoWarmCacheRef.current.get(cacheKeyTry);

        console.log("[VIDEO] trying language", {
          langIdTry,
          cacheKeyTry,
          hasCached: !!cached,
        });

        // // BDD 03/18/2026 - Debug Video PKL Reference Search
        // console.log("[VIDEO START DEBUG] before warm/fetch", {
        //   videoID,
        //   tagID,
        //   videoDisplayName,
        //   videoTagName,
        // });

        let warmedLocal = cached;

        if (!warmedLocal || willExpireSoon(warmedLocal?.expiresAtMs)) {
          try {
            warmedLocal = await warmVideoForDemo(videoID, tagID, authToken, langIdTry);
            console.log("[VIDEO] warmVideoForDemo result", {
              langIdTry,
              warmedLocal,
            });
          } catch (e) {
            console.warn("[VIDEO] warmVideoForDemo failed:", { langIdTry, e });
            warmedLocal = null;
          }
        } else {
          console.log("[VIDEO] using cached warm", {
            langIdTry,
            warmedLocal,
          });
        }

        if (warmedLocal) {
          warmed = warmedLocal;
          usedLanguageIDVideo = langIdTry;
          console.log("[VIDEO] selected warmed language", {
            videoID,
            tagID,
            usedLanguageIDVideo,
          });
          // // BDD 03/18/2026 - Debug Video PKL Reference Search
          // console.log("[VIDEO START DEBUG] warmed result", warmedLocal);
          // if (!usedLanguageIDVideo) {
          //   usedLanguageIDVideo = LANG_IDS.EN;
          //   console.log("[VIDEO] no language hit, falling back to EN(1)", {
          //     videoID,
          //     tagID,
          //     usedLanguageIDVideo,
          //   });
          // }
          break;
        }
      }


      let playlistUrlLocal = warmed?.playlistUrl || "";
      let tagTimeLocal = warmed?.tagTime ?? 0;

      // // BDD 02/12/2026 - Skip intro music + avoid time-0 autoplay/mute trap
      // const MIN_START_SEC = 11;
      // const _rawTagTime = tagTimeLocal;
      // tagTimeLocal = Number(tagTimeLocal) || 0;
      // if (tagTimeLocal < MIN_START_SEC) tagTimeLocal = MIN_START_SEC;

      // console.log("[VIDEO] normalized start time", {
      //   rawTagTime: _rawTagTime,
      //   normalizedTagTimeLocal: tagTimeLocal,
      //   MIN_START_SEC
      // });
        // # BDD 03/16/2026 - DEBUG missing video tag behavior
        // BDD 03/17/2026 - Infer intro skip from tag presence

        const _rawTagTime = tagTimeLocal;

        // BDD 09/26/2026 - use backend start rule carried through warmVideoForDemo
        const { sec: normalizedEarlyStartSec, minStartSec: minStartSecEarly } =
          normalizeVideoStartSec(
            tagTimeLocal,
            tagID,
            warmed?.defaultStartSec,
            minimumStartSecOverride
          );

        tagTimeLocal = normalizedEarlyStartSec;

        console.log("[VIDEO] normalized start time", {
          rawTagTime: _rawTagTime,
          normalizedTagTimeLocal: tagTimeLocal,
          minStartSec: minStartSecEarly,
          tagID,
          defaultStartSecFromWarm: warmed?.defaultStartSec,
        });

      // Decide at runtime whether to launch native player or stay in WebView.
      // BDD 10/202/2025 default: WebView (because flags.native_iqh3d_video is false).
      const inAndroidWv = (typeof isAndroidApkWebView === "function") && isAndroidApkWebView();
      const hasBridge = !!(window.AndroidBridge && typeof window.AndroidBridge.playHls === "function");
      const inApkvideo = !!(flags?.native_iqh3d_video && inAndroidWv && hasBridge);

      // Stereoscopic is optional; leaving off for BDD 10/20/2025 IQH3D Release
      const preferSBS3D = false;

      // ΓÇöΓÇö FALLBACK: your original fetch chain ΓÇöΓÇö
      if (!playlistUrlLocal) {
        console.log(`Fetching metadata for Video ID: ${videoID}, Tag ID: ${tagID}`);
        // const metadata = await fetchVideoMetadata(videoID, tagID, languageIDVideo);
        // BDD 12/06/2025
        const metadata = await fetchVideoMetadata(
          videoID,
          tagID,
          effectiveLanguageIDVideo
        );

        console.log("Metadata fetched:", metadata);
        // // BDD 03/18/2026 - Debug Video PKL Reference Search
        // console.log("[VIDEO START DEBUG] fetchVideoMetadata result", metadata);
        if (!metadata || metadata.uuid_2D_720P === "Unknown Video" || metadata.version_2D_720P === "Unknown") return;

        const videoUUID = (preferSBS3D && metadata.uuid_3D) ? metadata.uuid_3D : metadata.uuid_2D_720P;
        const videoVersion = String((preferSBS3D && metadata.version_3D) ? metadata.version_3D : metadata.version_2D_720P);

        // if (metadata.tag_time) {
        //   const [m, s] = metadata.tag_time.split(":").map(Number);
        //   tagTimeLocal = (m || 0) * 60 + (s || 0);
        // }

        //# BDD 03/16/2026 - DEBUG missing video tag behavior
        if (metadata.tag_time) {
          const [m, s] = String(metadata.tag_time).split(":").map(Number);
          tagTimeLocal = (m || 0) * 60 + (s || 0);
        } else {
          tagTimeLocal = 0;
        }

        const _rawMetadataTagTime = tagTimeLocal;
        const { sec: normalizedMetadataStartSec, minStartSec: minStartSecMetadata } =
          normalizeVideoStartSec(tagTimeLocal, tagID, metadata?.default_start_sec, minimumStartSecOverride);
          // BDD 08/03/2026 - jouney notebook llm video starting at 11 seconds temp fix
        tagTimeLocal = normalizedMetadataStartSec;

        console.log("[VIDEO] normalized metadata start time", {
          rawMetadataTagTime: _rawMetadataTagTime,
          normalizedTagTimeLocal: tagTimeLocal,
          minStartSec: minStartSecMetadata,
          tagID,
          hasTag: metadata?.has_tag,
          defaultStartSecFromMetadata: metadata?.default_start_sec,
        });
        const masterPlaylistResponse = await axios.post(
          API_URL_MASTER_PLAYLIST,
          { video_uuid: videoUUID, video_version: videoVersion },
          { headers: { Authorization: `Bearer ${authToken}`, "Content-Type": "application/json" } }
        );
        if (!masterPlaylistResponse?.data?.signed_media_playlist_url) return;

        // // BDD 02/06/2026 feature_video_gujarati_audio_track_2026_02_06
        const masterData = masterPlaylistResponse?.data || {};
        const mediaPlaylistUrl = masterData.signed_media_playlist_url;
        const masterUrl = masterData.signed_master_playlist_url;

        console.log("[VIDEO] masterData keys:", Object.keys(masterData));
        console.log("[VIDEO] masterUrl:", masterUrl);
        console.log("[VIDEO] mediaPlaylistUrl:", mediaPlaylistUrl);

        const audioLines = masterData.audio_lines || "";
        const audioLinesStr = typeof audioLines === "string" ? audioLines : JSON.stringify(audioLines);
        const hasAltAudio =
          audioLinesStr.includes("#EXT-X-MEDIA:TYPE=AUDIO") ||
          audioLinesStr.includes("TYPE=AUDIO");

        console.log("[VIDEO] audio_lines length:", audioLinesStr.length);
        console.log("[VIDEO] hasAltAudio:", hasAltAudio);
        console.log("[VIDEO] audio_lines head:", audioLinesStr.split("\n").slice(0, 3).join("\\n"));

        let playlistUrlLocalTmp = "";

        if (hasAltAudio) {
          console.log("[VIDEO] using /secure_master_m3u8");

          // BDD 02/07/2026 bipin_zach_dashboard_tweaks - video tag time related
          const preferredAudio = (Number(effectiveLanguageIDVideo) === 2) ? "guj" : "eng";
          const secureMasterResp = await axios.get(
            `${FASTAPI_BASE_URL}/secure_master_m3u8` +
              `?master_url=${encodeURIComponent(masterUrl)}` +
              `&video_uuid=${encodeURIComponent(videoUUID)}` +
              `&preferred_audio=${encodeURIComponent(preferredAudio)}`,
            { headers: { Authorization: `Bearer ${authToken}` }, responseType: "json" }
          );

          console.log("[VIDEO] secureMasterResp.data =", secureMasterResp?.data);
          playlistUrlLocalTmp = secureMasterResp?.data?.playlist_url || "";
        } else {
          console.log("[VIDEO] using /secure_m3u8 (existing)");

          const securePlaylistResp = await axios.get(
            `${API_URL_SECURE_M3U8}?media_url=${encodeURIComponent(mediaPlaylistUrl)}&video_uuid=${encodeURIComponent(videoUUID)}`,
            { headers: { Authorization: `Bearer ${authToken}` }, responseType: "json" }
          );

          console.log("[VIDEO] securePlaylistResp.data =", securePlaylistResp?.data);
          playlistUrlLocalTmp = securePlaylistResp?.data?.playlist_url2 || "";
        }

        if (!playlistUrlLocalTmp) {
          console.warn("[VIDEO] playlistUrlLocalTmp empty; abort");
          return;
        }

        playlistUrlLocal = playlistUrlLocalTmp;
        console.log("[VIDEO] FINAL playlistUrlLocal =", playlistUrlLocal);

        // BDD 02/07/2026 bipin_zach_dashboard_tweaks - video tag time related - remove
        try {
          const r = await fetch(playlistUrlLocal + (playlistUrlLocal.includes("?") ? "&" : "?") + "cb=" + Date.now());
          const txt = await r.text();
          console.log("[LOCAL MASTER AUDIO]\n" +
            txt.split("\n").filter(l => l.includes("#EXT-X-MEDIA:TYPE=AUDIO")).join("\n")
          );
        } catch (e) {
          console.warn("Could not fetch local master", e);
        }

      }

      // BDD 10/12/2025
      // IMPORTANT: ensure no native src is set for MSE path
      setNativeVideoUrl("");       // <-- prevents React from assigning a conflicting src

      // Nuke previous instance/media to avoid MSE fighting
      destroyHls();

      // Wait until the <video> is actually mounted
      await waitForVideoElement();
      if (!videoRef.current) {
        console.warn("[VIDEO] <video> not mounted; aborting attach");
        return;
      }


      // BDD 10/20/2025 IQH3D Release
      if (inApkvideo) {
        try {
          // Hide inline WebView player if weΓÇÖre handing off to native
          setShowVideo(false);

          window.AndroidBridge.playHls(JSON.stringify({
            url: playlistUrlLocal,
            // startSeconds: tagTimeLocal || 0,
            startSeconds: Number(tagTimeLocal) || 0, // BDD 02/12/2026 - Skip intro music + avoid time-0 autoplay/mute trap
            isSbs: false,          // flip later if you ship SBS
            audioTrackIndex: 0
          }));

          return; // Native player owns playback now
        } catch (e) {
          console.error("AndroidBridge.playHls failed; falling back to web HLS", e);
          // If native fails, we fall back to WebView inline player below
          setShowVideo(true);
        }
      }

      // BDD 02/07/2026 bipin_zach_dashboard_tweaks - video tag time related
      console.log("[VIDEO] tagTimeLocal =", tagTimeLocal, "selectedSecondaryLang =", selectedSecondaryLang, "usedLanguageIDVideo =", usedLanguageIDVideo);

      // BDD 02/12/2026 - Skip intro music + avoid time-0 autoplay/mute trap
      // ------------------------------------------------------------
      // HLS playback (Solution-2: preload 1 fragment earlier + HARD_GATE on Gujarati audio)
      // ------------------------------------------------------------
      if (Hls.isSupported()) {
        // Cache-bust the local playlist URL
        const playlistUrlToLoad =
          playlistUrlLocal +
          (playlistUrlLocal.includes("?") ? "&" : "?") +
          "cb=" + Date.now();

        const expectsAltAudio = String(playlistUrlLocal || "").includes("secure_master_");

        // tagTimeLocal already normalized earlier
        // - tagged legacy videos => minimum 11 sec
        // - no-tag concept videos => minimum 0 sec
        const desiredStart = Number(tagTimeLocal) || 0;

        // Decide desired track from dropdown
        const sel = String(selectedSecondaryLang || "").toLowerCase();
        const wantGujarati = sel.startsWith("gu") || sel.startsWith("gj") || sel.includes("guj");
        const desiredLang = wantGujarati ? "guj" : "eng";

        // Preload ~ one segment earlier (segments are ~8.333s)
        const PRELOAD_BACK_SEC = 8.6;
        const preloadStart = Math.max(desiredStart - PRELOAD_BACK_SEC, 0);

        // IMPORTANT:
        // - For secure_master (alt-audio), starting earlier can help bring Gujarati audio in sooner.
        // - For secure_m3u8 (no alt-audio), NEVER shift start position earlier (causes "starts at ~2s" issue).
        const startLoadPos = expectsAltAudio ? preloadStart : desiredStart;

        let _gujFragCoversDesired = false; // NEW (set true in FRAG_BUFFERED when frag covers desiredStart)
        let _recenteredAfterGate = false; // NEW
        let _audioLockAfterPlay = false; // NEW

        // Read local master once (so we know what tracks actually exist)
        let masterHasGujarati = false;
        if (expectsAltAudio) {
          try {
            const r = await fetch(playlistUrlToLoad);
            const masterTxt = await r.text();

            const audioLines = masterTxt
              .split("\n")
              .filter((l) => l.includes("#EXT-X-MEDIA:TYPE=AUDIO"))
              .join("\n");

            console.log("[LOCAL MASTER AUDIO]\n" + audioLines);

            masterHasGujarati =
              /LANGUAGE="guj"/i.test(masterTxt) ||
              /LANGUAGE=guj/i.test(masterTxt) ||
              /NAME="Gujarati"/i.test(masterTxt);
          } catch (e) {
            console.warn("[LOCAL MASTER AUDIO] fetch failed", e);
          }

          console.log("[AUDIOGATE] plan", {
            playlistUrlLocal,
            desiredStart,
            preloadStart,
            startLoadPos,
            PRELOAD_BACK_SEC,
            wantGujarati,
            desiredLang,
            expectsAltAudio,
            masterHasGujarati,
          });
        }

        // Create hls instance
        const hls = new Hls({
          autoStartLoad: false,
          startFragPrefetch: true,
          maxInitialBitrate: 800000,
          enableWorker: true,
          maxBufferLength: 30,
          backBufferLength: 30,
          maxBufferHole: 0.5,
          maxSeekHole: 2,
        });
        hlsRef.current = hls;

        const v = videoRef.current;

        // Sane user-facing defaults (avoid the "muted + 0 volume" confusion if anything fails)
        if (v) {
          try { v.muted = false; } catch {}
          try { v.volume = 1; } catch {}
        }

        // Gate state
        let _startedLoad = false;
        let _playIssued = false;

        let _hardGateEnabled = !!(expectsAltAudio && wantGujarati && masterHasGujarati);
        let _hardGateSatisfied = !_hardGateEnabled;

        let _idxDesired = -1;
        let _lastAudioTrackUrl = "";

        const _bufferHasTime = (t) => {
          if (!v || !v.buffered) return false;
          const EPS = 0.35;
          try {
            for (let i = 0; i < v.buffered.length; i++) {
              const s = v.buffered.start(i);
              const e = v.buffered.end(i);
              if (t >= (s - EPS) && t <= (e - 0.05)) return true;
            }
          } catch {}
          return false;
        };

        const _findTrackIndex = (tracks, lang) => {
          if (!Array.isArray(tracks) || !tracks.length) return -1;
          return tracks.findIndex((t) => {
            const tl = String(t.lang || t.attrs?.LANGUAGE || "").toLowerCase();
            const tn = String(t.name || "").toLowerCase();
            if (lang === "guj") return tl.startsWith("guj") || tn.includes("gujarati");
            if (lang === "eng") return tl.startsWith("eng") || tn.includes("english");
            return false;
          });
        };

        // NOTE: This MUST exist before we register handlers that call it.
        const _selectDesiredTrack = (tracks) => {
          if (!expectsAltAudio) {
            _hardGateEnabled = false;
            _hardGateSatisfied = true;
            return;
          }

          // If Gujarati requested but not present, disable gate and proceed default
          if (wantGujarati && masterHasGujarati === false) {
            console.warn("[HLS] Gujarati requested but not present in master; starting default audio");
            _hardGateEnabled = false;
            _hardGateSatisfied = true;
            return;
          }

          _idxDesired = _findTrackIndex(tracks, desiredLang);
          if (_idxDesired >= 0) {
            console.log("[HLS] selecting audioTrack", _idxDesired, tracks[_idxDesired]?.name, tracks[_idxDesired]?.lang);
            try { hls.audioTrack = _idxDesired; } catch {}
            // If we are hard-gating, keep it closed until we see a Gujarati audio frag buffered
            if (_hardGateEnabled) _hardGateSatisfied = false;
            return;
          }

          if (_hardGateEnabled) {
            console.warn("[HLS] Desired track exists in master but not selectable yet; waiting (hard gate closed)");
          }
        };

        const _startLoadOnce = () => {
          if (_startedLoad) return;
          _startedLoad = true;
          console.log("[AUDIOGATE] startLoad", {
            startLoadPos,
            preloadStart,
            desiredStart,
            expectsAltAudio,
          });
          try { hls.startLoad(startLoadPos); } catch {}
        };

        const _seekAndPlayAtDesired = () => {
          if (_playIssued) return;
          _playIssued = true;
          if (!v) return;

          // Always snap to desired start before play
          try { v.currentTime = desiredStart; } catch {}

          // Start muted for autoplay reliability + prevent any early audio bleed
          try { v.muted = true; v.volume = 0; } catch {}

          // Unmute ONLY when we are actually playing at/after desiredStart.
          // For Gujarati hard-gate, also require proof that the Gujarati frag covering desiredStart is buffered.
          const _unmuteIfReady = () => {
            if (!v) return;
            try {
              const t = Number(v.currentTime || 0);
              const atDesired = t >= (desiredStart + 0.05);

              const okGujarati = (!_hardGateEnabled) || (_gujFragCoversDesired === true);

              if (atDesired && okGujarati) {
                try { v.removeEventListener("timeupdate", _unmuteIfReady); } catch {}
                try { v.removeEventListener("seeking", _unmuteIfReady); } catch {}
                try { v.removeEventListener("seeked", _unmuteIfReady); } catch {}

                try { v.muted = false; v.volume = 1; } catch {}
                console.log("[AUDIOGATE] unmute at desiredStart", { t, desiredStart, okGujarati });
              }
            } catch {}
          };

          // Track readiness as the clock advances / seeking completes
          try { v.addEventListener("timeupdate", _unmuteIfReady); } catch {}
          try { v.addEventListener("seeking", _unmuteIfReady); } catch {}
          try { v.addEventListener("seeked", _unmuteIfReady); } catch {}

          const p = v.play();
          if (p && typeof p.then === "function") {
            p.then(() => {
              _audioLockAfterPlay = true; // NEW: lock after playback begins
              setVideoReady(true);
              // In case timeupdate is slow to fire, do one immediate check
              _unmuteIfReady();
            }).catch((err) => {
              console.warn("[VIDEO] autoplay blocked; waiting for user click", err);

              // IMPORTANT: Do NOT force unmute here (that could reintroduce English bleed).
              // Keep muted until user clicks play; after click, the same event listeners will unmute at desiredStart.
              setVideoReady(true);
            });
          } else {
            setVideoReady(true);
            _unmuteIfReady();
          }
        };

        const _maybeStart = () => {
          if (!_bufferHasTime(desiredStart)) return;
          if (_hardGateEnabled && !_hardGateSatisfied) return;
          _seekAndPlayAtDesired();
        };

        ensurePreconnect(playlistUrlToLoad);
        hls.attachMedia(v);

        hls.on(Hls.Events.MEDIA_ATTACHED, () => {
          if (hlsRef.current !== hls) return;

          // OPTIONAL: if alt-audio preload, keep UI pinned to desiredStart (prevents showing 2.4s)
          if (expectsAltAudio && v) {
            try { v.currentTime = desiredStart; } catch {}
          }

          hls.loadSource(playlistUrlToLoad);
        });

        hls.on(Hls.Events.MANIFEST_PARSED, (_evt, data) => {
          const tracks = data?.audioTracks || hls.audioTracks || [];
          console.log("[HLS] MANIFEST_PARSED audioTracks:", tracks);

          _selectDesiredTrack(tracks);
          _startLoadOnce();
          _maybeStart();
        });

        hls.on(Hls.Events.AUDIO_TRACKS_UPDATED, (_evt, data) => {
          const tracks = data?.audioTracks || hls.audioTracks || [];
          console.log("[HLS] AUDIO_TRACKS_UPDATED:", tracks);

          _selectDesiredTrack(tracks);
          _maybeStart();
        });

        hls.on(Hls.Events.AUDIO_TRACK_SWITCHING, (_evt, data) => {
          _lastAudioTrackUrl = String(data?.url || "");
        });

        // HARD_GATE satisfaction: only open once a Gujarati audio fragment was actually buffered
        hls.on(Hls.Events.FRAG_BUFFERED, (_evt, data) => {
          if (!_hardGateEnabled || _hardGateSatisfied) return;

          const frag = data?.frag;
          if (!frag || frag.type !== "audio") return;

          const u = String(frag.url || frag.baseurl || frag.relurl || "");
          const looksGujarati =
            /guj/i.test(u) ||
            /gujarati/i.test(u) ||
            /secure_audio_guj/i.test(u) ||
            /audio_guj/i.test(u) ||
            /guj/i.test(_lastAudioTrackUrl);

          // Require: it’s Gujarati-looking AND we are on the desired audio track
          if (!looksGujarati || !((_idxDesired >= 0) && (hls.audioTrack === _idxDesired))) return;

          // NEW: Only open the gate if this *audio frag timeline* actually covers desiredStart
          const fs = (typeof frag.start === "number") ? frag.start : null;
          const fd = (typeof frag.duration === "number") ? frag.duration : null;
          const fe = (fs !== null && fd !== null) ? (fs + fd) : null;

          // If we can’t read timing, be conservative but still allow (rare)
          const coversDesired =
            (fs === null || fe === null)
              ? true
              : (desiredStart >= (fs - 0.05) && desiredStart <= (fe - 0.05));

          if (!coversDesired) {
            // Keep waiting for the Gujarati frag that actually contains desiredStart
            console.log("[AUDIOGATE] Gujarati audio frag buffered but does NOT cover desiredStart; waiting", {
              fragStart: fs,
              fragEnd: fe,
              fragDur: fd,
              desiredStart,
              fragUrl: u,
              audioTrack: hls.audioTrack,
              idxDesired: _idxDesired,
            });
            return;
          }

          _gujFragCoversDesired = true;
          _hardGateSatisfied = true;

          // NEW: Once Gujarati gate is satisfied, recenter loader to desiredStart to avoid choppy "preloadStart drag"
          if (!_recenteredAfterGate) {
            _recenteredAfterGate = true;
            try { hls.stopLoad(); } catch {}
            try { hls.startLoad(desiredStart); } catch {}
            console.log("[AUDIOGATE] recenter load to desiredStart after gate", { desiredStart });
          }

          console.log("[AUDIOGATE] HARD_GATE satisfied: Gujarati audio frag covers desiredStart", {
            fragStart: fs,
            fragEnd: fe,
            fragDur: fd,
            fragUrl: u,
            lastAudioTrackUrl: _lastAudioTrackUrl,
            audioTrack: hls.audioTrack,
            idxDesired: _idxDesired,
            desiredStart,
            preloadStart,
          });

          _maybeStart();
        });

        hls.on(Hls.Events.BUFFER_APPENDED, () => {
          _maybeStart();
        });

        // Guardrail: if hls switches away from desired track, force it back
        hls.on(Hls.Events.AUDIO_TRACK_SWITCHED, () => {
          if (!expectsAltAudio) return;
          // NEW: after playback has begun, don’t thrash tracks (can cause micro-stalls)
          if (_audioLockAfterPlay) return;

          const tracks = hls.audioTracks || [];
          const idxDesired2 = _findTrackIndex(tracks, desiredLang);
          if (idxDesired2 >= 0 && hls.audioTrack !== idxDesired2) {
            console.warn("[HLS] audio switched unexpectedly; forcing back to", desiredLang);
            try { hls.audioTrack = idxDesired2; } catch {}
          }
        });

        hls.on(Hls.Events.ERROR, (_evt, data) => {
          console.warn("[HLS ERROR]", {
            type: data?.type,
            details: data?.details,
            fatal: data?.fatal,
            reason: data?.reason,
            error: data?.error ? String(data.error) : null,
            responseCode: data?.response?.code,
          });

          // Extra stall diagnostics (non-fatal, safe)
          if (data?.details === Hls.ErrorDetails.BUFFER_STALLED_ERROR) {
            try {
              const vv = videoRef.current || v;
              const ranges = [];

              if (vv && vv.buffered) {
                for (let i = 0; i < vv.buffered.length; i++) {
                  ranges.push([vv.buffered.start(i), vv.buffered.end(i)]);
                }
              }

              console.warn("[STALL DBG]", {
                t: vv ? Number(vv.currentTime || 0) : null,
                buf: ranges,
                readyState: vv ? vv.readyState : null,       // 0..4
                networkState: vv ? vv.networkState : null,   // 0..3
                paused: vv ? !!vv.paused : null,
                ended: vv ? !!vv.ended : null,
                muted: vv ? !!vv.muted : null,
                volume: vv ? Number(vv.volume ?? 0) : null,
                playbackRate: vv ? Number(vv.playbackRate ?? 1) : null,
                hidden: typeof document !== "undefined" ? !!document.hidden : null,
              });
            } catch (e) {
              console.warn("[STALL DBG] failed", e);
            }
          }

          // Your existing stall recovery (keep behavior)
          if (!data?.fatal && data?.details === Hls.ErrorDetails.BUFFER_STALLED_ERROR) {
            const vv = videoRef.current;
            if (vv) {
              try {
                const t = vv.currentTime || 0;
                vv.currentTime = t + 0.04;
              } catch {}
            }
            try { if (hlsRef.current === hls) hls.startLoad(); } catch {}
            return;
          }

          if (!data?.fatal) return;

          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              try { if (hlsRef.current === hls) hls.startLoad(); } catch {}
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              try { if (hlsRef.current === hls) hls.recoverMediaError(); } catch {}
              break;
            default:
              destroyHls();
          }
        });

      } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
        // Ensure audio is ON for native HLS playback
        try { videoRef.current.muted = false; } catch {}
        try { videoRef.current.volume = 1; } catch {}

        const playlistUrlToLoad =
          playlistUrlLocal +
          (playlistUrlLocal.includes("?") ? "&" : "?") +
          "cb=" + Date.now();

        setNativeVideoUrl(playlistUrlToLoad);
        videoRef.current.addEventListener("loadedmetadata", () => {
          if (tagTimeLocal && tagTimeLocal > 0) {
            try { videoRef.current.currentTime = tagTimeLocal; } catch {}
          }
          videoRef.current.play().catch(err => console.error("Auto-play blocked:", err));
        }, { once: true });
      } else {
        console.warn("HLS not supported");
      }

      // Keep your duration capture, but ensure it only fires once
      videoRef.current.addEventListener("loadedmetadata", () => {
        setVideoDuration(videoRef.current.duration);
      }, { once: true });

    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          console.warn("ΓÜá∩╕Å Received 401, but suppressing logout during demo.");
        } else {
          console.error(`ΓÜá∩╕Å Server responded with ${error.response.status}:`, error.response.data);
        }
      } else {
        console.error("Γ¥î Error fetching secure video:", error);
      }
    } finally {
      setLoading(false);
    }
  };



  const attachUnauthorizedHandler = () => {
    // Avoid stacking multiple listeners across repeated opens/hot-switches
    try {
      if (unauthorizedHandlerRef.current) {
        window.removeEventListener("message", unauthorizedHandlerRef.current);
        unauthorizedHandlerRef.current = null;
      }
    } catch {}
    unauthorizedHandlerRef.current = (event) => {
      if (event.data && event.data.type === "UNAUTHORIZED") {
        console.warn("⚠️ Unauthorized message from WebGL. Ignoring for now.");
        // console.warn("Unauthorized message received from WebGL. Logging out."); // BDD 5/20/2021 for DEMO TEMP CAUTION
        // logout();
      }
    };
    window.addEventListener("message", unauthorizedHandlerRef.current);
  };


  // // BDD 11/20/2025
  const langRef = useRef(selectedSecondaryLang);
  useEffect(() => {
    langRef.current = selectedSecondaryLang;
  }, [selectedSecondaryLang]);

  // --- NEW: video-specific normalized language ref ---
  // BDD 12/06/2025
  const videoLangRef = useRef(langCode);

  useEffect(() => {
    videoLangRef.current = langCode;
  }, [langCode]);

//////////////////////////////////////////////////////////
// BDD 02/15/2026 - test/healthCheckpwo - START
/////////////////////////////////////////////////////////

  const BENIGN_WEBGL_PATTERNS = [
    /UnityCache/i,
    /indexedDB cache/i,
    /successfully (downloaded|revalidated)/i,
    /navigator\.mediaDevices support available/i,
    /FS\.syncfs operations in flight/i,
    /Added non-passive event listener/i,
    /INVALID_ENUM: getInternalformatParameter/i,
    /DontDestroyOnLoad only works/i,
  ];

  const FATAL_WEBGL_PATTERNS = [
    /Uncaught/i,
    /WebAssembly\.RuntimeError/i,
    /out of memory/i,
    /wasm streaming compile failed/i,
    /abort\(/i,
    /Failed to load/i,
    /Data file is corrupt/i,
    /stack overflow/i,

    // Unity / content failure signals that you *do* want to catch
    /The referenced script on this Behaviour.*is missing/i,
    /MissingReferenceException/i,
    /NullReferenceException/i,
    /IndexOutOfRangeException/i,
    /ArgumentNullException/i,
    /ArgumentException/i,
  ];

  function classifyWebglConsole(kind, message) {
    if (!message) return { level: "info", fatal: false };

    if (BENIGN_WEBGL_PATTERNS.some((re) => re.test(message))) {
      return { level: "info", fatal: false };
    }

    // Only treat *errors* as potentially fatal, and only if they match known bad patterns
    if (kind === "WEBGL_CONSOLE_error" && FATAL_WEBGL_PATTERNS.some((re) => re.test(message))) {
      return { level: "error", fatal: true };
    }

    // Everything else: warn/info, not fatal
    if (kind === "WEBGL_CONSOLE_error") return { level: "warn", fatal: false };
    if (kind === "WEBGL_CONSOLE_warn") return { level: "warn", fatal: false };
    return { level: "info", fatal: false };
  }

  // BDD 02/15/2026 - test/healthCheckpwo
  function downloadTextFile(filename, text) {
    const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 500);
  }

  // // BDD 02/15/2026 - test/healthCheckpwo
  // function buildPwoListFromExpandedTopics(expandedTopicsObj) {
  //   const seen = new Set();
  //   const out = [];

  //   for (const chapTopics of Object.values(expandedTopicsObj || {})) {
  //     for (const topicData of Object.values(chapTopics || {})) {
  //       for (const p of (topicData?.pwos || [])) {
  //         const pwoID = p.pwo_source_id ?? p.pwo_id ?? p.pwoID;
  //         const sceneName = p.scene_name ?? p.scene_key ?? p.pwo_scene_name;
  //         if (!pwoID || !sceneName) continue;

  //         const key = `${pwoID}|${sceneName}`;
  //         if (seen.has(key)) continue;
  //         seen.add(key);

  //         out.push({
  //           pwoID,
  //           sceneName,
  //           title: p.name ?? p.display_name ?? `${pwoID} - ${sceneName}`,
  //         });
  //       }
  //     }
  //   }
  //   return out;
  // }

  // BDD 02/15/2026 - test/healthCheckpwo - try2 - chapter level
  function buildPwoListFromExpandedTopics(expandedTopicsObj, allowedChapterIdsSet = null) {
    const seen = new Set();
    const out = [];

    for (const [chapterIdKey, chapTopics] of Object.entries(expandedTopicsObj || {})) {
      const chapterIdNum = Number(chapterIdKey);

      // ✅ Optional filter: only include chapters in allowedChapterIdsSet
      if (allowedChapterIdsSet && !allowedChapterIdsSet.has(chapterIdNum) && !allowedChapterIdsSet.has(chapterIdKey)) {
        continue;
      }

      for (const topicData of Object.values(chapTopics || {})) {
        for (const p of (topicData?.pwos || [])) {
          const pwoID = p.pwo_source_id ?? p.pwo_id ?? p.pwoID;
          const sceneName = p.scene_name ?? p.scene_key ?? p.pwo_scene_name;
          if (!pwoID || !sceneName) continue;

          const key = `${pwoID}|${sceneName}`;
          if (seen.has(key)) continue;
          seen.add(key);

          out.push({
            pwoID,
            sceneName,
            title: formatPwoName(p.name ?? p.display_name ?? `${pwoID} - ${sceneName}`),
            chapterId: chapterIdNum || null,
            topicId: p.topic_id ?? p.topicId ?? null,
          });
        }
      }
    }

    return out;
  }

  // BDD 02/15/2026 - test/healthCheckpwo
  useEffect(() => {
    const onMessage = (event) => {
      const t = event?.data?.type;

      if (t === "WEBGL_ALERT") {
        const err = {
          kind: "WEBGL_ALERT",
          message: event.data?.message || "",
          ts: event.data?.ts || Date.now(),
          fatal: true,
        };
        pwoQaLastErrorRef.current = err;
        if (pwoQaActiveRef.current) pwoQaActiveRef.current.errors.push(err);
        return;
      }

      if (t === "WEBGL_RUNTIME_ERROR" || t === "WEBGL_UNHANDLED_REJECTION") {
        const err = {
          kind: t,
          message: event.data?.message || "",
          stack: event.data?.stack || null,
          ts: event.data?.ts || Date.now(),
          fatal: true,
        };
        pwoQaLastErrorRef.current = err;
        if (pwoQaActiveRef.current) pwoQaActiveRef.current.errors.push(err);
        return;
      }

      if (t === "WEBGL_CONSOLE") {
        const level = String(event.data?.level || "log"); // "log" | "warn" | "error"
        const msg = String(event.data?.message || "");
        const kind = "WEBGL_CONSOLE_" + level;

        const classified = classifyWebglConsole(kind, msg);

        const entry = {
          kind,
          level,                 // original level from sender
          message: msg,
          ts: event.data?.ts || Date.now(),
          fatal: classified.fatal,
          classifiedLevel: classified.level, // "info" | "warn" | "error" (your classifier)
        };

        if (pwoQaActiveRef.current) {
          pwoQaActiveRef.current.console.push(entry);

          // ✅ only treat as error if classifier says fatal
          if (entry.fatal) {
            pwoQaLastErrorRef.current = entry;
            pwoQaActiveRef.current.errors.push(entry);
          }
        }
      }
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);


  // BDD 02/15/2026 - test/healthCheckpwo
  function waitForMessageType(type, timeoutMs) {
    return new Promise((resolve, reject) => {
      let done = false;

      const timer = setTimeout(() => {
        if (done) return;
        done = true;
        window.removeEventListener("message", onMsg);
        reject(new Error(`Timeout waiting for ${type}`));
      }, timeoutMs);

      const onMsg = (event) => {
        if (event?.data?.type !== type) return;
        if (done) return;
        done = true;
        clearTimeout(timer);
        window.removeEventListener("message", onMsg);
        resolve(event.data);
      };

      window.addEventListener("message", onMsg);
    });
  }

  // BDD 02/15/2026 - test/healthCheckpwo
  function waitForCustomEvent(name, timeoutMs) {
    return new Promise((resolve, reject) => {
      let done = false;

      const timer = setTimeout(() => {
        if (done) return;
        done = true;
        window.removeEventListener(name, onEv);
        reject(new Error(`Timeout waiting for ${name}`));
      }, timeoutMs);

      const onEv = (ev) => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        window.removeEventListener(name, onEv);
        resolve(ev?.detail);
      };

      window.addEventListener(name, onEv);
    });
  }

  // BDD 02/15/2026 - test/healthCheckpwo
  // BDD 02/15/2026 - test/healthCheckpwo
  async function runOnePwoHealthcheck(item) {
    const startTs = Date.now();
    pwoQaLastErrorRef.current = null;

    pwoQaActiveRef.current = {
      item,
      startTs,
      webglReadyTs: null,
      argsSentTs: null, // will remain null until you add PWO_ARGS_SENT later
      errors: [],
      console: [],
    };

    // Force cold boot / no-investor reuse during healthcheck
    pwoHealthcheckModeRef.current = true;
    pwoForceColdBootRef.current = true;

    // Launch
    handlePWOClick(
      item.pwoID,
      item.sceneName,
      authToken,
      selectedSecondaryLang,
      null,
      null,
      false // isAuto
    );

    // Wait for WEBGL_READY
    try {
      await waitForMessageType("WEBGL_READY", PWO_QA_READY_TIMEOUT_MS);
      pwoQaActiveRef.current.webglReadyTs = Date.now();
    } catch (e) {
      try { await handleCloseModule(false); } catch {}
      await sleep(PWO_QA_BETWEEN_MS);

      pwoForceColdBootRef.current = false;
      pwoHealthcheckModeRef.current = false;
      pwoQaActiveRef.current = null;

      return {
        status: "TIMEOUT_WEBGL_READY",
        pwoID: item.pwoID,
        sceneName: item.sceneName,
        title: item.title,
        startTs,
        endTs: Date.now(),
        msTotal: Date.now() - startTs,
        error: String(e?.message || e),
        note: "Timed out waiting for WEBGL_READY",
      };
    }

    // === Time-based loading window (since Unity scene-ready signal will come later) ===
    const loadStart = Date.now();
    while (Date.now() - loadStart < PWO_QA_POST_READY_WAIT_MS) {
      if (pwoQaAbortRef.current) break;

      // Pause support
      if (pwoQaPausedRef.current) {
        await sleep(250);
        continue;
      }

      // Stop early only if we saw a *fatal* classified error
      if (pwoQaLastErrorRef.current) break;

      await sleep(250);
    }

    const endTs = Date.now();
    const ctx = pwoQaActiveRef.current;

    const gotFatal = !!pwoQaLastErrorRef.current || (ctx.errors?.length > 0);

    // Hard close
    try { await handleCloseModule(false); } catch {}
    await sleep(PWO_QA_BETWEEN_MS);

    // Stop forcing flags after each item
    pwoForceColdBootRef.current = false;
    pwoHealthcheckModeRef.current = false;

    pwoQaActiveRef.current = null;

    return {
      status: gotFatal ? "FAIL" : "PASS",
      pwoID: item.pwoID,
      sceneName: item.sceneName,
      title: item.title,
      startTs,
      webglReadyTs: ctx.webglReadyTs,
      argsSentTs: ctx.argsSentTs, // null for now
      endTs,
      msTotal: endTs - startTs,
      msAfterReady: ctx.webglReadyTs ? (endTs - ctx.webglReadyTs) : null,
      msAfterArgs: ctx.argsSentTs ? (endTs - ctx.argsSentTs) : null,
      errors: (ctx.errors || []).slice(0, 12),
      fatalConsole: (ctx.console || []).filter(x => x.fatal).slice(0, 12),
      // Helpful to inspect non-fatal error logs too (won't fail the run)
      notableConsole: (ctx.console || [])
        .filter(x => (x.level === "error" || x.level === "warn"))
        .slice(0, 20),
      userAgent: navigator.userAgent,
      note: "PASS/FAIL is based on fatal console/runtime signals only. No Unity scene-ready signal yet; uses time-based wait.",
    };
  }

  // BDD 02/20/2026 - PWO QA - Grade scope test/healthCheckpwo
  async function startPwoQaRun(itemsOverride = null) {
    pwoQaAbortRef.current = false;

    // Use override if provided (grade-run uses this); else use state
    let itemsToRun = Array.isArray(itemsOverride) ? itemsOverride : pwoQaItems;

    // Build list if empty (fallback: expandedTopics)
    if (!itemsToRun?.length) {
      const list = buildPwoListFromExpandedTopics(expandedTopics);
      setPwoQaItems(list);
      itemsToRun = list;

      if (!itemsToRun.length) {
        alert("No PWOs found in expandedTopics yet. Expand/load curriculum first, then click Build List again.");
        return [];
      }
    }

    setPwoQaRunning(true);
    setPwoQaPaused(false);

    const localResults = [];
    const limit = Math.min(itemsToRun.length, pwoQaIndex + (Number(pwoQaMaxItems) || 999999));

    for (let i = pwoQaIndex; i < limit; i++) {
      if (pwoQaAbortRef.current) break;

      while (pwoQaPaused && !pwoQaAbortRef.current) {
        await sleep(250);
      }
      if (pwoQaAbortRef.current) break;

      setPwoQaIndex(i);

      // Periodic hard refresh to avoid WebGL memory creep
      if (i > 0 && (i % PWO_QA_HARD_REFRESH_EVERY === 0)) {
        try { await handleCloseModule(false); } catch {}
        await sleep(400);
        try {
          if (pwoIframeRef?.current) pwoIframeRef.current.src = "about:blank";
        } catch {}
        await sleep(300);
      }

      const item = itemsToRun[i];
      const res = await runOnePwoHealthcheck(item);

      localResults.push(res);
      setPwoQaResults((prev) => [...prev, res]);
    }

    setPwoQaRunning(false);
    return localResults;
  }

  // BDD 02/15/2026 - test/healthCheckpwo
  function stopPwoQaRun() {
    pwoQaAbortRef.current = true;
    setPwoQaPaused(false);
    setPwoQaRunning(false);
    pwoHealthcheckModeRef.current = false;
    pwoForceColdBootRef.current = false;
  }

  // BDD 02/15/2026 - test/healthCheckpwo
  function exportPwoQaJsonl() {
    const jsonl = (pwoQaResults || []).map((r) => JSON.stringify(r)).join("\n");
    const ts = new Date().toISOString().replace(/[:.]/g, "-");
    downloadTextFile(`pwo_healthcheck_${ts}.jsonl`, jsonl + "\n");
  }

  // BDD 02/15/2026 - test/healthCheckpwo
  function resetPwoQa() {
    pwoQaAbortRef.current = true;
    setPwoQaRunning(false);
    setPwoQaPaused(false);
    setPwoQaIndex(0);
    setPwoQaResults([]);
  }


  function waitForCustomEventOrFatal(name, timeoutMs) {
    return new Promise((resolve, reject) => {
      let done = false;

      const cleanup = () => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        clearInterval(tick);
        window.removeEventListener(name, onEv);
      };

      const timer = setTimeout(() => {
        cleanup();
        reject(new Error(`Timeout waiting for ${name}`));
      }, timeoutMs);

      const tick = setInterval(() => {
        if (pwoQaLastErrorRef.current) {
          cleanup();
          reject(new Error(`Fatal error before ${name}: ${pwoQaLastErrorRef.current.kind}`));
        }
      }, 200);

      const onEv = (ev) => {
        cleanup();
        resolve(ev?.detail);
      };

      window.addEventListener(name, onEv);
    });
  }


    // BDD 02/15/2026 - test/healthCheckpwo
    const closePwoQaPanel = () => {
      try { stopPwoQaRun(); } catch {}
      setPwoQaVisible(false);
    };

    // BDD 02/15/2026 - test/healthCheckpwo
    function getNodeId(n) {
      return n?.subjectId ?? n?.subject_id ?? n?.id ?? n?.value ?? null;
    }
    function getNodeLabel(n) {
      return (
        n?.display_name ??
        n?.displayName ??
        n?.subjectName ??
        n?.name ??
        n?.label ??
        ""
      ).toString().trim();
    }

    // Extract subjects from sortedCurriculum with flexible shape support
    function extractSubjectNodes(tree) {
      const out = [];

      if (!tree) return out;

      // Common shapes:
      // 1) [ { gradeId, subjects:[...] }, ... ]
      // 2) { grades:[...] }
      // 3) [ { subjects:[...] } ] OR already an array of subjects
      const gradesArr =
        Array.isArray(tree) ? tree :
        Array.isArray(tree?.grades) ? tree.grades :
        Array.isArray(tree?.items) ? tree.items :
        null;

      if (gradesArr) {
        for (const g of gradesArr) {
          const subjects = g?.subjects ?? g?.children ?? g?.nodes ?? [];
          if (Array.isArray(subjects)) {
            for (const s of subjects) out.push(s);
          }
        }
        return out;
      }

      // If it's already an array of subjects
      if (Array.isArray(tree)) return tree;

      // Fallback: try direct subjects field
      if (Array.isArray(tree?.subjects)) return tree.subjects;

      return out;
    }

    function extractChaptersFromSubject(subjectNode) {
      return subjectNode?.chapters ?? subjectNode?.children ?? subjectNode?.nodes ?? [];
    }

    function extractTopicsFromChapter(chapterNode) {
      return chapterNode?.topics ?? chapterNode?.children ?? chapterNode?.nodes ?? [];
    }



    // BDD 02/20/2026 - test/healthCheckpwo
    const buildPwoQaListForSelectedSubject = async () => {
      const sid = String(pwoQaSubjectId || "").trim();
      if (!sid) {
        alert("Select a subject first.");
        return;
      }
      await buildPwoQaListForSubjectId(sid);
    };
    // BDD 02/20/2026 - PWO QA - Grade scope test/healthCheckpwo - end

  //////////////////////////////////////////////////////////
  // BDD 02/15/2026 - test/healthCheckpwo - END
  /////////////////////////////////////////////////////////


  //////////////////////////////////////////////////////////
  // BDD 05/15/2026 - Exhibit AI + Unity local kiosk mode - START
  /////////////////////////////////////////////////////////

  // BDD 05/15/2026 - Exhibit AI + Unity local kiosk mode
  // FASTAPI_BASE_URL usually ends in /api, but exhibit endpoints live at root:
  //   http://localhost:5000/api      -> http://localhost:5000
  //   https://api-preview.../api     -> https://api-preview...
  const EXHIBIT_RUNTIME_BASE_URL = String(FASTAPI_BASE_URL || "http://localhost:5000/api")
    .replace(/\/api\/?$/, "");

  // Temporary activation path:
  // Open React with ?exhibitMode=1 to route PWO clicks to local Windows Unity Player.
  // Later this can become user.feature_flag === "exhibit_mode".
  const isExhibitModeEnabled =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("exhibitMode") === "1";

  const callExhibitRuntime = async (path, body = null) => {
    const response = await fetch(`${EXHIBIT_RUNTIME_BASE_URL}${path}`, {
      method: body ? "POST" : "GET",
      headers: {
        "Content-Type": "application/json",
      },
      body: body ? JSON.stringify(body) : undefined,
    });

    const data = await response.json().catch(() => null);

    if (!response.ok || !data?.ok) {
      throw new Error(data?.message || `Exhibit runtime call failed: ${path}`);
    }

    return data;
  };

  const waitForUnityRuntimeConnected = async (maxAttempts = 90, delayMs = 1000) => {
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      const status = await callExhibitRuntime("/exhibit/runtime-status");

      console.log("[EXHIBIT_MODE] Waiting for Unity runtime", {
        attempt,
        unity_connected: status?.unity_connected,
        unity_process_running: status?.unity_process_running,
        last_event: status?.state?.last_event,
      });

      if (
        status?.unity_connected &&
        ["UNITY_READY", "PONG", "PWO_LOAD_STARTED", "LOAD_PWO_SENT"].includes(status?.state?.last_event)
      ) {
        return status;
      }
      await new Promise((resolve) => setTimeout(resolve, delayMs));
    }

    throw new Error("Unity runtime did not connect to FastAPI in time.");
  };

  const handleExhibitPWOClick = async (
    pwoID,
    sceneName,
    authTokenForPwo,
    localLanguage
  ) => {
    console.log("[EXHIBIT_MODE] handleExhibitPWOClick", {
      pwoID,
      sceneName,
      localLanguage,
    });

    if (!pwoID || !sceneName) {
      Alert.alert("Exhibit mode", "Missing PWO ID or scene name.");
      return;
    }

    if (!authTokenForPwo) {
      Alert.alert("Exhibit mode", "Missing auth token. Please log in again.");
      return;
    }

    try {
      let status = await callExhibitRuntime("/exhibit/runtime-status");

      if (!status?.unity_connected) {
        console.log("[EXHIBIT_MODE] Unity not connected. Starting Unity...");
        await callExhibitRuntime("/exhibit/start-unity", {});
        status = await waitForUnityRuntimeConnected();
      }

      console.log("[EXHIBIT_MODE] Unity runtime ready", status);

      const loadResult = await callExhibitRuntime("/exhibit/load-pwo-windows", {
        pwo_id: String(pwoID),
        scene_name: String(sceneName),
        auth_token: authTokenForPwo,
        local_language: localLanguage || "Eng_USA",
        local_windows_path: "E:",
      });

      console.log("[EXHIBIT_MODE] PWO load command sent", loadResult);
    } catch (error) {
      console.error("[EXHIBIT_MODE] Failed to load PWO", error);
      Alert.alert("Exhibit mode error", error?.message || "Unable to load PWO.");
    }
  };


  //////////////////////////////////////////////////////////
  // BDD 05/15/2026 - Exhibit AI + Unity local kiosk mode - END
  /////////////////////////////////////////////////////////

  // BDD 10/202/2025 - Da Vinci students got skybox
  // BDD 10/12/2025 with option for investor_mode  - temp try 4
  const handlePWOClick = async (
    pwoID,
    sceneName,
    authToken,
    lang,   // just for debugging / fallback
    chapterID = null,
    topicID = null,
    isAuto = false,
    walkthroughStepOverride = null,
    walkthroughRefsOverride = null
  ) => {
    console.log("🚀 handlePWOClick called with pwoID, scenename, lang, chapterID, topicID, isAuto:", pwoID, sceneName, lang, chapterID, topicID, isAuto);
    console.log("🔄 handlePWOClick triggered", {
      pwoID,
      sceneName,
      currentStep: walkthroughStep,
      autoWalkthroughMode: autoWalkthroughMode
    });


    // BDD 02/12/2026 - debug/openpwo - this should be done AFTER handleclosemodule
    // // Reset cancellation flag for this new PWO launch
    // pwoClickCancelledRef.current = false;

    if (!isAuto) {
      // AIT-246: a manual open ends any pending auto-open return.
      autoOpenReturnRef.current = null;
      setAutoWalkthroughMode(false);
      setWalkthroughStep(null);
      setWalkthroughReferences(null);
    }

    // BDD 08/30/2026 - Rev 1: preserve completed-exam review as the return
    // target when this PWO was opened from an exam AI reference (or from another
    // asset that was itself opened from that review).
    const shouldReturnToExamReview =
      examReviewAssetReturnRef.current ||
      (showQuiz && quizMode === "pastTestView");

    // BDD 02/12/2026 - debug/openpwo - passing on isAuto as first argument
    const canClose = await handleCloseModule(isAuto, walkthroughStepOverride, walkthroughRefsOverride);
    console.log("[PWO] after close", { cancelled: pwoClickCancelledRef.current, canClose, isAuto });
    if (showQuiz && quizMode === "test" && !canClose) {
      return;
    }

    if (shouldReturnToExamReview) {
      examReviewAssetReturnRef.current = true;
      console.log("[EXAM REVIEW] PWO launch preserved exam-review return target");
    }

    // BDD 02/12/2026 - debug/openpwo
    // Reset cancellation flag for THIS PWO launch (after close/cleanup completes)
    // Start a fresh cancellation window for THIS launch (cleanupModule sets it true)
    pwoClickCancelledRef.current = false;

    setThreePwoActive(false);
    // Look up pwo_name and scene label from available sources (localized at click time)
    // Hoisted outside try blocks so both resume state and engagement can use them
    let pwoDisplayName = null;
    let pwoSceneLabel = null;

    // 1) Try chat history (AI references have pwo_name + pwo_scene_label)
    for (const entry of history) {
      const match = (entry.pwos || []).find(
        (p) => (p.pwoID === pwoID || p.pwo_source_id === pwoID) &&
               (p.pwo_scene_name === sceneName || p.scene_name === sceneName)
      );
      if (match) {
        pwoDisplayName = match.pwo_name || null;
        pwoSceneLabel = match.pwo_scene_label || match.display_name || null;
        break;
      }
    }

    // 2) Fallback: search expandedTopics (curriculum/collection loaded content)
    if (!pwoDisplayName && !pwoSceneLabel) {
      for (const chapTopics of Object.values(expandedTopics || {})) {
        for (const topicData of Object.values(chapTopics || {})) {
          const match = (topicData.pwos || []).find(
            (p) => (p.pwo_source_id == pwoID || p.pwo_id == pwoID) &&
                   (p.scene_name === sceneName || p.scene_key === sceneName)
          );
          if (match) {
            // match.name is already "PWO Name - Scene Label" (localized)
            if (match.name && match.name.includes(" - ")) {
              const idx = match.name.indexOf(" - ");
              pwoDisplayName = match.name.substring(0, idx);
              pwoSceneLabel = match.name.substring(idx + 3);
            } else {
              pwoDisplayName = match.name || null;
              pwoSceneLabel = match.display_name || match.scene_label || null;
            }
            break;
          }
        }
        if (pwoDisplayName || pwoSceneLabel) break;
      }
    }

    // BDD 01/25/2026 - ResumeState bookmark for PWO launch
    // BDD 01/25/2026 studen resum states
    if (!pwoHealthcheckModeRef.current || !isHealthcheckEnabled) { // BDD 02/15/2026 - test/healthCheckpwo
      try {
        const resolvedSourceTopicId = resolveSourceTopicId(topicID);
        const parsedKey = parseCollectionTopicKey(topicID);
        const resolvedCollectionId = parsedKey?.collectionId ?? null;
        const canShowCollection = Boolean(activeStudyCollection && collectionResolved);
        const inCollectionModeNow = (viewMode === "collections") && canShowCollection;

        const collectionIdForResume =
          inCollectionModeNow
            ? (resolvedCollectionId ?? activeStudyCollection?.id ?? null)
            : null;

        const contentDbForResume =
          (activeStudyCollection?.base_board) || contentDb || null;

        // Prefer CHAPTER when clicked from chapter/curriculum view, then COLLECTION
        const resumeChapterId = chapterID ?? selectedChapterId ?? null;
        const scopeType = resumeChapterId ? "CHAPTER" : (collectionIdForResume ? "COLLECTION" : null);
        const scopeId = resumeChapterId ?? collectionIdForResume ?? null;

        await updateLearningResumeForAsset({
          content_db: contentDbForResume,
          scope_type: scopeType,
          scope_source_id: scopeId,
          asset_type: "PWO",
          asset_source_id: pwoID,
          state_json: {
            board_topic_id: topicID ?? null,
            source_topic_id: resolvedSourceTopicId ?? null,
            collection_id: collectionIdForResume ?? null,
            collection_name: activeStudyCollection?.name ?? null,
            pwo_scene_name: sceneName ?? null,
            pwo_name: pwoDisplayName,
            pwo_scene_label: pwoSceneLabel,
            content_db: contentDbForResume ?? null,
            chapter_id: resumeChapterId ?? null,
            chapter_name: selectedChapter?.chapterName ?? null,
            topic_name: activeTopicForAIRef.current?.topic_name ?? null,
          },
        });
      } catch (e) {
        console.warn("[resume_state] pwo launch update failed:", e);
      }
    }
    // BDD 01/10/2026 - guideme-next-steps merge
    // BDD 01/08/2026 - guideme-next-steps
    if (!pwoHealthcheckModeRef.current || !isHealthcheckEnabled) { // BDD 02/15/2026 - test/healthCheckpwo
      try {
        const resolvedSourceTopicId = resolveSourceTopicId(topicID);
        const parsedKey = parseCollectionTopicKey(topicID);
        const resolvedCollectionId = parsedKey?.collectionId ?? null;
        const canShowCollection = Boolean(activeStudyCollection && collectionResolved);
        const inCollectionModeNow = (viewMode === "collections") && canShowCollection;

        // BDD 01/10/2026 - guideme-next-steps
        const collectionIdForLog =
          inCollectionModeNow
            ? (resolvedCollectionId ?? activeStudyCollection?.id ?? null)
            : null;

        axios
          .post(
            `${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/pwo-engagement`,
            {
              pwo_id: pwoID,
              pwo_scene_name: sceneName || null, // ✅ NEW: scene-level tracking
              source_topic_id: resolvedSourceTopicId ?? null,
              collection_id: collectionIdForLog,
              source: isAuto ? "ai_walkthrough" : "manual",
              display_title: pwoDisplayName && pwoSceneLabel
                ? `${pwoDisplayName} - ${pwoSceneLabel}`
                : pwoDisplayName || pwoSceneLabel || null,
            }
          )
          .then(() => {
            const cid = resolvedCollectionId ?? activeStudyCollection?.id ?? null;
            if (cid && activeStudyCollection?.id === cid) {
              refreshCollectionProgress();
            }
            if (curriculumView && selectedChapter) {
              refreshChapterProgress();
            }
          })
          .catch((err) => {
            console.warn("Failed to log PWO engagement", err);
          });
      } catch (e) {
        console.warn("PWO engagement logging threw synchronously", e);
      }
    }
    // const localLanguage = getLocalLanguage(lang);
    // BDD 11/18/2025 - PWO switching to new language was lagging
    // Always prefer current context language; fall back to the param if needed
    // BDD 11/20/2025

    const rawLangRef =
      langRef.current && langRef.current !== "auto"
        ? langRef.current
        : (lang || "en");

    const localLanguage = getLocalLanguage(rawLangRef);

    console.log("[PWO] language debug:", {
      langParam: lang,
      selectedSecondaryLang,
      langRefCurrent: langRef.current,
      effectiveLang: rawLangRef,
      localLanguage,
    });

    //////////////////////////////////////////////////////////
    // BDD 05/15/2026 - Exhibit AI + Unity local kiosk mode - START
    /////////////////////////////////////////////////////////

    // BDD 05/15/2026 - Exhibit AI + Unity local kiosk mode
    if (isExhibitModeEnabled) {
      console.log("[EXHIBIT_MODE] Routing PWO click to local Unity Windows Player", {
        pwoID,
        sceneName,
        localLanguage,
      });

      await handleExhibitPWOClick(pwoID, sceneName, authToken, localLanguage);
      return;
    }

    //////////////////////////////////////////////////////////
    // BDD 05/15/2026 - Exhibit AI + Unity local kiosk mode - END
    /////////////////////////////////////////////////////////


    // Bail out if module was closed while we were awaiting resume/engagement calls
    if (pwoClickCancelledRef.current) {
      console.log("[PWO] handlePWOClick cancelled (module closed during await)");
      return;
    }

    setLoading(true);
    setActiveModule(assetLaunchModuleRef.current || "pwo");
    setCurrentPwoId(pwoID);
    setCurrentPwoScene(sceneName);
    handleClick();
    // BDD 11/18/2025 - for engagement logs
    trackPwoLaunch();
    setActivePWO(`${pwoID}-${sceneName}`);
    setActiveVideo(null);
    setShowVideo(false);
    setShowQuiz(false);
    // SBS projector mode must never expose Unity's initial unsynchronized frame.
    // Cover it with an AITutor-owned, eye-safe SBS placeholder until shortly
    // after the 3D_0 argument blob is actually handed to Unity.
    beginSbs3dPwoCover();
    setShowPwo(true);
    // Da Vinci 3-Day Challenge: re-check progress after opening a PWO.
    syncChallenge(activeStudyCollection?.id);
    // If we previously soft-closed (keepalive) we may have manually hidden the iframe.
    // React won't necessarily flip `display` back because the computed style can remain "block".
    try {
      setTimeout(() => {
        if (pwoIframeRef.current) pwoIframeRef.current.style.display = "block";
      }, 0);
    } catch {}

    attachUnauthorizedHandler();

    const inApk = isAndroidApkWebView() && window.AndroidBridge && typeof window.AndroidBridge.launchPWO === "function";
    const bridged = !!window.AndroidBridge;
    const canLaunch = bridged && typeof window.AndroidBridge.launchPWO === "function";
    const inAndroidWv = (typeof isAndroidApkWebView === "function") && isAndroidApkWebView();

    console.log("[overlay] env check " + JSON.stringify({
      ua: navigator.userAgent,
      inAndroidWv,
      bridged,
      canLaunch,
      inApk
    }));

    // ===== ANDROID APK PATH (unchanged) =====
    if (inApk) {
      try {
        if (!authToken) {
          console.error("❌ Failed to fetch auth token.");
          return;
        }

        const defaultPwoHeader = t("Explore and experiment with this PWO:");
        const defaultPwoQuestions = [
          t("What is this Play With Object (PWO)?"),
          t("How do I interact with this Play With Object (PWO)?"),
          t("Explain the concepts shown here."),
        ];

        lastPwoSuggestionsContextRef.current = { kind: "pwo", defaultPwoHeader, defaultPwoQuestions };
        setIsPwoOpen(true);
        if (!pwoHealthcheckModeRef.current || !isHealthcheckEnabled) { // BDD 02/15/2026 - test/healthCheckpwo
          fetchCollectionSuggestedQuestions(
            "pwo",
            defaultPwoHeader,
            defaultPwoQuestions
          );
        }
        const apiUrl = `${FASTAPI_BASE_URL}/get_pwo_arguments_leia`;
        const pwoResponse = await axios.get(apiUrl, {
          params: { pwo_id: pwoID, scene_name: sceneName, auth_token: authToken, local_language: localLanguage },
        });

        // BDD 02/12/2026 - debug/openpwo
        if (pwoClickCancelledRef.current) {
          console.log("[PWO] cancelled during APK args fetch — aborting launch");
          setLoading(false);
          return;
        }

        let payloadStr = pwoResponse?.data?.leia_arguments;
        let obj; try { obj = JSON.parse(payloadStr); } catch { obj = {}; }

        const rt = getAndroidRuntimeInfoSafe();
        const unityMfg = mapRuntimeToUnityManufacturer(rt);
        if (unityMfg) obj.device_manufacturer = unityMfg;
        const mfg = (unityMfg ?? "").toLowerCase();
        const is3DDevice = mfg.includes("leia") || mfg.includes("alldocube");
        obj.arg2 = `${is3DDevice ? "3D" : "2D"}_1`;
        if ((obj.arg3 === undefined || obj.arg3 === null || obj.arg3 === "") && rt?.isTouch === true) {
          obj.arg3 = "Touched";
        }

        const patched = JSON.stringify(obj);
        const result = window.AndroidBridge.launchPWO(patched);
        console.log("Android APK LaunchPWO result", result);

        setLoading(false);
        return;
      } catch (error) {
        console.error("❌ Error handling PWO click (APK path):", error, JSON.stringify(error));
      } finally {
        setLoading(false);
      }
      return;
    }

    // ===== WEBGL PATH =====
    // Keep the Unity-specific camera-mode strings on the backend. The frontend
    // only decides whether this AITutor session is projector-wide SBS 3D.
    const requestedPwoCamMode = sbs3dProjectorMode ? "3D_0" : "2D_1";
    const key = `${pwoID}|${sceneName}|${requestedPwoCamMode}`;
    const samePwoAsLast = (lastPwoKeyRef.current === key);
    // BDD 02/15/2026 - test/healthCheckpwo
    const investor = !!(flags?.investor_mode) && !pwoForceColdBootRef.current;

    // Ask backend for webgl args up front (you already did this early)
    let webglArguments = null;
    try {
      console.log("🎮 Fetching WebGL arguments for PWO", {
        pwoID,
        sceneName,
        sbs3d: sbs3dProjectorMode,
        expectedCamMode: requestedPwoCamMode,
      });
      if (!authToken) {
        console.error("❌ Failed to fetch auth token.");
        setLoading(false);
        return;
      }

      const defaultPwoHeader = t("Explore and experiment with this PWO:");
      const defaultPwoQuestions = [
        t("What is this Play With Object (PWO)?"),
        t("How do I interact with this Play With Object (PWO)?"),
        t("Explain the concepts shown here."),
      ];
      lastPwoSuggestionsContextRef.current = { kind: "pwo", defaultPwoHeader, defaultPwoQuestions };
      setIsPwoOpen(true);
      if (!pwoHealthcheckModeRef.current || !isHealthcheckEnabled) { // BDD 02/15/2026 - test/healthCheckpwo
        fetchCollectionSuggestedQuestions(
          "pwo",
          defaultPwoHeader,
          defaultPwoQuestions
        );
      }
      const apiUrl = `${FASTAPI_BASE_URL}/get_pwo_arguments_webgl`;
      // Camera mode is part of the cache identity so a 2D argument blob can never
      // be reused for an SBS session (or vice versa).
      const cacheKey = `${pwoID}|${sceneName}|${localLanguage}|${requestedPwoCamMode}`;
      const cacheMs = getPwoArgsCacheMs(flags);
      const nowTs = Date.now();
      const cached = pwoWebglArgsCacheRef.current.get(cacheKey);

      let pwoResponse = null;
      if (
        cached &&
        cached.encodedArgs &&
        cached.authToken === authToken &&
        cacheMs > 0 &&
        (nowTs - (cached.ts || 0) <= cacheMs)
      ) {
        pwoResponse = { data: { webgl_arguments: cached.encodedArgs } };
        console.log("⚡ Using cached WebGL arguments", { cacheKey, ageMs: nowTs - (cached.ts || 0) });
      } else {
        pwoResponse = await axios.get(apiUrl, {
          params: {
            pwo_id: pwoID,
            scene_name: sceneName,
            auth_token: authToken,
            local_language: localLanguage,
            sbs3d: sbs3dProjectorMode ? 1 : 0,
          },
        });
        console.log("✅ API Response Data:", pwoResponse.data);
      }

      // BDD 02/12/2026 - debug/openpwo
      // ✅ If user closed during the await, abort BEFORE any further work
      if (pwoClickCancelledRef.current) {
        console.log("[PWO] cancelled during WebGL args fetch — aborting launch");
        setLoading(false);
        return;
      }

      if (!pwoResponse.data || !pwoResponse.data.webgl_arguments) {
        console.warn(`⚠️ Skipping PWO launch for pwo_id=${pwoID}:`, pwoResponse.data?.error || "Missing WebGL arguments in response.");
        setLoading(false);
        return;
      }
      webglArguments = pwoResponse.data.webgl_arguments;
      console.log("🛠️ WebGL Arguments:", webglArguments);

      // Update cache on success (in-memory only)
      try {
        if (cacheMs > 0 && webglArguments && authToken) {
          pwoWebglArgsCacheRef.current.set(cacheKey, { authToken, ts: nowTs, encodedArgs: webglArguments });
        }
      } catch {}
    } catch (err) {
      console.error("❌ Error fetching WebGL arguments:", err);
      setLoading(false);
      return;
    }

    // ==== HOT SWITCH (reuse warm Unity runtime) ====
    // When Unity is already booted + ready, avoid reloading the iframe and just send new args.
    // This significantly reduces PWO switching time during a session, but we still force a
    // cold reboot after N switches to avoid long-session degradation.
    const hotSwitchEnabled = flags?.pwo_hot_switch !== false;
    const hotSwitchMax = getPwoHotSwitchMax(flags);
    const allowHotSwitchInThisMode =
      !investor || samePwoAsLast || flags?.pwo_hot_switch_in_investor === true;

    const canHotSwitch =
      Platform.OS === "web" &&
      hotSwitchEnabled &&
      allowHotSwitchInThisMode &&
      hotSwitchMax > 0 &&
      !pwoForceColdBootRef.current &&
      !(isHealthcheckEnabled && pwoHealthcheckModeRef.current) &&
      !!pwoIframeRef.current?.contentWindow &&
      !!webglArguments &&
      isWebGLReadyRef.current;

    if (canHotSwitch) {
      // If we've hot-switched too many times in a row, fall back to a cold reboot.
      if (pwoHotSwitchCountRef.current < hotSwitchMax) {
        try {
          clearPwoWebglTimersAndListeners();
          // ensure visible (if previously soft-closed)
          try { if (pwoIframeRef.current) pwoIframeRef.current.style.display = "block"; } catch {}

          console.log("⚡ PWO hot-switch: sending CALL_UNITY_FUNCTION without iframe reload", {
            samePwoAsLast,
            hotSwitchCount: pwoHotSwitchCountRef.current,
            hotSwitchMax,
          });
          pwoIframeRef.current.contentWindow.postMessage(
            { type: "CALL_UNITY_FUNCTION", value: webglArguments },
            "*"
          );
          scheduleSbs3dPwoReveal();
          // Resume audio only AFTER the new PWO is requested (prevents old-PWO music from resuming briefly).
          try { pwoIframeRef.current?.contentWindow?.postMessage({ type: "APP_RESUME" }, "*"); } catch {}
          lastPwoKeyRef.current = key;
          pwoHotSwitchCountRef.current += 1;
          setLoading(false);
          return;
        } catch (e) {
          console.warn("Hot-switch failed; falling back to cold boot.", e);
          // fall through to cold boot path
        }
      } else {
        console.log("🧹 PWO hot-switch max reached; forcing cold reboot", {
          hotSwitchCount: pwoHotSwitchCountRef.current,
          hotSwitchMax,
        });
      }
    }

    // ==== INVESTOR MODE BRANCH ====
    if (investor) {
      const iframe = pwoIframeRef.current;
      // TEMP: version gate disabled for release hardening.
      // Restore by switching this back to:
      //   const webglEntryPath = (flags?.pwo_webgl_gate === false) ? "/webgl/index.html" : "/webgl_gate";
      const webglEntryPath = "/webgl/index.html";

      // Ensure the hidden/persistent iframe exists
      if (!iframe) {
        console.warn("(investor) No iframe yet; falling back to reload path.");
      }

      // If SAME PWO as last time AND Unity already ready => hot reuse
      if (iframe && samePwoAsLast && isWebGLReadyRef.current) {
        try {
          console.log("(investor) Reusing warm Unity — sent CALL_UNITY_FUNCTION immediately");
          iframe.contentWindow?.postMessage({ type: "CALL_UNITY_FUNCTION", value: webglArguments }, "*");
          scheduleSbs3dPwoReveal();
          // Resume audio only after requesting the PWO.
          iframe.contentWindow?.postMessage({ type: "APP_RESUME" }, "*");
          // keep lastPwoKeyRef as-is
          setLoading(false);
          return;
        } catch (e) {
          console.warn("(investor) Immediate send failed; will reload iframe.", e);
          // fall through to reload path
        }
      }

      // Different PWO or not ready → soft reload (cached, fast), then send
      try {
        console.log("(investor) Soft reloading Unity iframe for a different PWO or not-ready state…");
        pwoHotSwitchCountRef.current = 0;
        pwoLastColdBootAtRef.current = Date.now();
        isWebGLReadyRef.current = false;
        setIsWebGLReady(false);

        // Reset src to ensure a clean boot scene with AssetBundleLoader
        if (iframe) {
          iframe.src = "about:blank";
          if (pwoBootSrcTimeoutId.current) {
            clearTimeout(pwoBootSrcTimeoutId.current);
            pwoBootSrcTimeoutId.current = null;
          }
          pwoBootSrcTimeoutId.current = setTimeout(() => {
          pwoBootSrcTimeoutId.current = null;
          if (pwoClickCancelledRef.current) return;
          iframe.src = `${WEBGL_BASE_URL}${webglEntryPath}`;
          console.log("✅ (investor) Setting pwoIframe.src to", iframe.src);
        }, 200);
      }

        // Wait for WEBGL_READY, then call Unity
        const onReady = (event) => {
          if (event.data?.type !== "WEBGL_READY") return;
          console.log("✅ (investor) Received WEBGL_READY message.");
          isWebGLReadyRef.current = true;
          setIsWebGLReady(true);

          // Send immediately (no extra delay)
          try {
          console.log("(investor) Sending CALL_UNITY_FUNCTION to Unity (no extra delay)");
          iframe?.contentWindow?.postMessage({ type: "CALL_UNITY_FUNCTION", value: webglArguments }, "*");
          scheduleSbs3dPwoReveal();
          try { iframe?.contentWindow?.postMessage({ type: "APP_RESUME" }, "*"); } catch {}
          lastPwoKeyRef.current = key;  // update to new PWO key
        } catch (e) {
          console.error("(investor) Failed to post CALL_UNITY_FUNCTION after ready:", e);
        } finally {
          window.removeEventListener("message", onReady);
            setLoading(false);
          }
        };

        window.addEventListener("message", onReady);

        // Safety timeout (2 min) same as your legacy path
        pwofallbackTimeoutId.current = setTimeout(() => {
          window.removeEventListener("message", onReady);
          console.warn("(investor) Fallback: WEBGL_READY not seen; trying to send anyway…");
          iframe?.contentWindow?.postMessage({ type: "CALL_UNITY_FUNCTION", value: webglArguments }, "*");
          scheduleSbs3dPwoReveal();
          try { iframe?.contentWindow?.postMessage({ type: "APP_RESUME" }, "*"); } catch {}
          lastPwoKeyRef.current = key;
          setLoading(false);
        }, 120000);

        return;
      } catch (e) {
        console.error("(investor) Unexpected error during reload path:", e);
        setLoading(false);
        return;
      }
    }

    // BDD 02/12/2026 - debug/openpwo
    if (pwoClickCancelledRef.current) {
      console.log("[PWO] cancelled before scheduling init — aborting");
      setLoading(false);
      return;
    }

    // ==== NON-INVESTOR (patched legacy behavior) ====
    // BDD 02/15/2026 - test/healthCheckpwo
    // Speed up perceived load: rely on iframe-retry loop instead of a fixed 3s delay.
    const initDelayMs = pwoHealthcheckModeRef.current ? 0 : 250;
    pwoInitTimeoutId.current = setTimeout(async () => {
      pwoInitTimeoutId.current = null;
      // Bail out if module was closed during the 3-second wait
      if (pwoClickCancelledRef.current) {
        console.log("[PWO] Init timeout cancelled (module closed)");
        return;
      }
      console.log("⏳ PWO init delay passed — starting PWO init logic");
      const MAX_RETRIES = 5;
      let retries = 0;
      while (!pwoIframeRef.current && retries < MAX_RETRIES) {
        console.warn("PWO iframe not found, retrying in 500ms...");
        await new Promise((res) => setTimeout(res, 500));
        retries++;
      }
      if (!pwoIframeRef.current) {
        console.error("❌ PWO iframe not found after retries. Aborting.");
        setLoading(false);
        return;
      }

      try {
        // Helper that always uses the *latest* iframe ref and args
        const sendCallUnity = () => {
          const frame = pwoIframeRef.current;
          const args = webglArguments;
          const hasIframe = !!frame;
          const hasContentWindow = !!frame?.contentWindow;
          const hasArgs = !!args;

          if (hasIframe && hasContentWindow && hasArgs) {
            console.log("🚀 Sending CALL_UNITY_FUNCTION to Unity", {
              hasIframe,
              hasContentWindow,
              hasArgs,
              isWebGLReady: isWebGLReadyRef.current,
            });
            frame.contentWindow.postMessage(
              { type: "CALL_UNITY_FUNCTION", value: args },
              "*"
            );
            scheduleSbs3dPwoReveal();
            // Resume audio only after requesting the new PWO (prevents old-PWO music from resuming briefly).
            try { frame.contentWindow.postMessage({ type: "APP_RESUME" }, "*"); } catch {}
            lastPwoKeyRef.current = key;

            // BDD 02/15/2026 - test/healthCheckpwo
            try {
              window.dispatchEvent(new CustomEvent("PWO_ARGS_SENT", {
                detail: { pwoID, sceneName, key, ts: Date.now() }
              }));
            } catch {}

          } else {
            console.warn(
              "⚠️ Unable to send CALL_UNITY_FUNCTION — iframe or args missing",
              { hasIframe, hasContentWindow, hasArgs, isWebGLReady: isWebGLReadyRef.current }
            );
          }
        };

        const frame = pwoIframeRef.current;
        // TEMP: version gate disabled for release hardening.
        // Restore by switching this back to:
        //   const webglEntryPath = (flags?.pwo_webgl_gate === false) ? "/webgl/index.html" : "/webgl_gate";
        const webglEntryPath = "/webgl/index.html";
        // Reset and boot the WebGL build
        pwoHotSwitchCountRef.current = 0;
        pwoLastColdBootAtRef.current = Date.now();
          frame.src = "about:blank";
          if (pwoBootSrcTimeoutId.current) {
            clearTimeout(pwoBootSrcTimeoutId.current);
            pwoBootSrcTimeoutId.current = null;
          }
          pwoBootSrcTimeoutId.current = setTimeout(() => {
            pwoBootSrcTimeoutId.current = null;
            if (pwoClickCancelledRef.current) return;
            const f = pwoIframeRef.current;
            if (!f) {
              console.warn("PWO iframe disappeared before setting src to WebGL build.");
              return;
            }

            // BDD 02/15/2026 - test/healthCheckpwo
            const baseUrl = `${WEBGL_BASE_URL}${webglEntryPath}`;
            const qaSuffix =
              (isHealthcheckEnabled && pwoHealthcheckModeRef.current)
                ? (baseUrl.includes("?") ? "&qa=1" : "?qa=1")
                : "";
            f.src = baseUrl + qaSuffix;
            console.log("✅ Setting pwoIframe.src to", f.src);
          }, 200);
        setIsWebGLReady(false);
        isWebGLReadyRef.current = false;
        console.log("WebGL loaded, waiting for WEBGL_READY message...");

        webglReadyHandlerRef.current = (event) => {
          if (event.data?.type === "WEBGL_READY") {
            console.log("✅ Received WEBGL_READY message. Scheduling Unity function call...");
            setIsWebGLReady(true);
            isWebGLReadyRef.current = true;

            if (pwofallbackTimeoutId.current) {
              clearTimeout(pwofallbackTimeoutId.current);
              pwofallbackTimeoutId.current = null;
            }

            // Small delay instead of 3s, and use the helper
            setTimeout(sendCallUnity, 500);

            window.postMessage({ type: "WEBGL_READY_FOR_AI" }, "*");
            window.removeEventListener("message", webglReadyHandlerRef.current);
            webglReadyHandlerRef.current = null;
          }
        };

        window.addEventListener("message", webglReadyHandlerRef.current);

        // Fallback: if WEBGL_READY never arrives, still try to send
        pwofallbackTimeoutId.current = setTimeout(() => {
          if (webglReadyHandlerRef.current) {
            window.removeEventListener("message", webglReadyHandlerRef.current);
            webglReadyHandlerRef.current = null;
          }
          console.warn(
            "⏰ Fallback: WEBGL_READY not seen in time; attempting CALL_UNITY_FUNCTION anyway…"
          );
          sendCallUnity();
        }, 120000);

      } catch (error) {
        console.error("❌ Error handling PWO click:", error);
      } finally {
        setLoading(false);
      }
    }, initDelayMs);

  };

  // BDD 01/08/2026 enhance-fetch-reference
  // ─────────────────────────────────────────
  // Chapter / Collection reference navigation (history sidebar)
  // ─────────────────────────────────────────
  const handleChapterClick = (chapterRef) => {
    try {
      // Clean up any active PWO/video/quiz before navigating away
      if (showPwo || showVideo || showQuiz) {
        cleanupModule();
      }

      const chapterId =
        chapterRef?.chapterId ??
        chapterRef?.id ??
        chapterRef?.chapter_id ??
        chapterRef;

      if (chapterId == null) return;

      // BDD 08/30/2026 - chapter reference must leave Tests submodule
      // and immediately show the referenced curriculum chapter.
      setLearningSubModule("modules");
      setActiveModule("learning");
      userHasSavedPreferenceRef.current = true;
      setViewMode("curriculum");
      setActiveStudyCollection(null);

      const path = findChapterPath(({ chap }) => {
        const cid = chap?.chapterId ?? chap?.id ?? chap?.chapter_id;
        return String(cid) === String(chapterId);
      });

      if (!path) {
        console.warn("⚠️ Chapter ref clicked but chapter not found:", chapterId);
        return;
      }

      const candidate = {
        levelId: path.level?.id ?? path.level?.levelId,
        subjectId: path.subject?.id ?? path.subject?.subjectId,
        subjectName: labelForCurriculumNode(path.subject),
        chapterId: path.chap?.id ?? path.chap?.chapterId ?? chapterId,
        chapterName: labelForCurriculumNode(path.chap),
      };

      skipChapterRestoreUntilRef.current = Date.now() + 3000; // prevent useEffect from overwriting with saved chapter
      setSelectedChapter(candidate);
      ensureExpandedForChapter(candidate.levelId, candidate.subjectId, candidate.chapterId);
      storage.set(LAST_CHAPTER_KEY, candidate); // persist so next restore picks up the right chapter

      // BDD 02/11/2026 - Chapter level Curiosity Sparks
      setTimeout(async () => {
        try {
          console.log("[DBG] forcing chapter prompts fetch from handleChapterClick", candidate.chapterId);
          const list = await fetchChapterPromptsRaw(candidate.chapterId, "chapter");
          console.log("[DBG] chapter prompts raw result len =", list?.length, list);
        } catch (e) {
          console.error("[DBG] forced chapter prompts fetch failed", e);
        }
      }, 0);

    } catch (e) {
      console.warn("handleChapterClick failed:", e);
    }
  };

  // BDD 01/08/2026 enhance-fetch-reference
  const handleCollectionClick = async (collectionRef) => {
    try {
      // Clean up any active PWO/video/quiz before navigating away
      if (showPwo || showVideo || showQuiz) {
        cleanupModule();
      }

      const colId =
        collectionRef?.collection_id ??
        collectionRef?.id ??
        collectionRef;

      if (colId == null) return;

      setActiveModule("learning");
      userHasSavedPreferenceRef.current = true; // Mark user preference
      setViewMode("collections");

      await openStudentCollection(
        {
          id: Number(colId),
          name:
            collectionRef?.display_name ||
            collectionRef?.name_localized ||
            collectionRef?.localized_name ||
            collectionRef?.name ||
            `Collection ${colId}`,
          base_board: collectionRef?.base_board || contentDb,
        },
        "ref-click"
      );
    } catch (e) {
      console.warn("handleCollectionClick failed:", e);
    }
  };

  // Keep the challenge auto-route / CTA callbacks pointed at the latest
  // handleCollectionClick (they are declared earlier in the component body).
  handleCollectionClickRef.current = handleCollectionClick;

  // BDD 12/02/2025
  const buildGuideMePromptFromState = (state) => {
    const goal =
      state.learning_goal ||
      t(
        "This collection does not yet have a written learning goal. Still, summarize progress and suggest next steps."
      );

    const collectionTitle =
      state.collection_title ||
      activeStudyCollection?.title ||
      activeStudyCollection?.name ||
      t("this collection");

    return `
You are an AI tutor helping a student work through the collection "${collectionTitle}".

Learning goal:
${goal}

Here is structured data about this student's progress:
- PWOs opened: ${state.coverage.pwo_opened} / ${state.coverage.pwo_total}
- Videos/segments opened: ${state.coverage.video_segments_opened} / ${state.coverage.video_segments_total}
- PWO launches (including revisits): ${state.practice.pwo_total_launches}
- Video plays (including revisits): ${state.practice.video_total_plays}
- Curiosity-spark clicks: ${state.ai_usage.total_spark_clicks}
- AI messages in this collection: ${state.ai_usage.total_messages}
- Overall progress level: ${state.level}

Task:
1. In 2–3 short sentences, explain to the student where they currently are with respect to the learning goal.
2. Suggest 2–3 concrete next actions using PWOs, videos, and/or quizzes from this collection.
3. Suggest 1–2 specific questions they could ask you next to deepen their understanding.

Speak directly to the student in clear, encouraging language.
`.trim();
  };

  // BDD 12/05/2025
  const handleGuideMeClick = async () => {
    if (!activeStudyCollection || !activeStudyCollection.id) {
      console.warn("Guide Me: no active collection id");
      return;
    }

    try {
      setGuideMeLoading(true);

      // 1) Fetch the structured guide-me state from backend
      const res = await axios.get(
        `${FASTAPI_BASE_URL}/student/${encodeURIComponent(
          user_id
        )}/collections/${activeStudyCollection.id}/guide-me-state`
      );

      const state = res.data;

      // 2) Collection title for nicer prompts/logging
      const collectionTitle =
        activeStudyCollection.title || activeStudyCollection.name;

      // 3) Pack everything into customInstructions that backend can parse
      const customInstructions = {
        mode: "guide_me_collection",
        collection_id: activeStudyCollection.id,
        collection_title: collectionTitle,
        guide_me_state: state,
      };

      console.log("[GUIDEME] customInstructions", customInstructions);
      // 4) The visible "question" text is simple; real brains are in customInstructions
      const prompt = t(
        "Please review my progress in this collection and guide me on what to do next."
      );

      // IMPORTANT: skipReferences so we don't fetch PWO/video refs or autowalkthrough
      askFromAnywhere(prompt, {
        customInstructions,
        skipReferences: true,
      });
    } catch (err) {
      console.error("Guide Me call failed", err);
      Alert.alert(
        t("Guide Me unavailable"),
        t("We couldn’t load your progress for this collection. Please try again.")
      );
    } finally {
      setGuideMeLoading(false);
    }
  };

  // BDD 12/27/2025 - Guide Me extended to Chapters
  // ===== Guide Me (Chapter) =====
  const handleGuideMeChapterClick = async (chapterId, chapterTitle = null) => {
    if (!chapterId) {
      console.warn("Guide Me (chapter): no chapterId");
      return;
    }

    try {
      setGuideMeLoading(true);

      const res = await axios.get(
        `${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/chapters/${chapterId}/guide-me-state`
      );

      const state = res.data;

      const customInstructions = {
        mode: "guide_me_chapter",
        chapter_id: chapterId,
        chapter_title: chapterTitle || state?.chapter_title || null,
        guide_me_state: state,
      };

      console.log("[GUIDEME][CHAPTER] customInstructions", customInstructions);

      const prompt = t(
        "Please review my progress in this chapter and guide me on what to do next."
      );

      askFromAnywhere(prompt, {
        customInstructions,
        skipReferences: true,
      });

    } catch (err) {
      console.error("Guide Me (chapter) call failed", err);
      Alert.alert(
        t("Guide Me unavailable"),
        t("We couldn’t load your progress for this chapter. Please try again.")
      );
    } finally {
      setGuideMeLoading(false);
    }
  };

  useEffect(() => {
    const unsubscribe = navigation.addListener('beforeRemove', (e) => {
      if (showQuiz && quizMode === "test") {
        // Prevent default behavior of leaving the screen
        e.preventDefault();
        Alert.alert(
          "Exit Test?",
          "Leaving the test now will submit it automatically. Do you want to proceed?",
          [
            { text: "Cancel", style: "cancel", onPress: () => { } },
            {
              text: "Submit and Exit",
              onPress: async () => {
                await handleSubmitTest();
                cleanupModule();
                // Now that the test is submitted, allow navigation
                navigation.dispatch(e.data.action);
              },
            },
          ]
        );
      }
    });

    return unsubscribe;
  }, [navigation, showQuiz, quizMode]);

  // BDD 02/12/2026 - debug/openpwo 
  // let lastCloseTimestamp = 0;

  // BDD 10/12/2025 - temp change commenting out this and trying new - again
  // BDD 02/12/2026 - debug/openpwo 
  /**
   * Where closing a PWO/video/quiz should land.
   *
   * `handleCloseModule` has always hardcoded "learning", which dumps a teacher
   * who launched a scene from inside a lesson back onto the topic tiles.
   * `lessonPlanAssetLaunchRef` is set synchronously when a lesson launches an
   * asset, so it is the reliable signal for "this asset belongs to a lesson".
   */
  navStateRef.current = { activeModule, learningSubModule, activeSidebarTab };

  // AIT-253: the pre-start test screen no longer locks the header nav, so leaving it
  // via the nav must also drop the pending test (same reset as its Close button),
  // otherwise it would re-render the next time the student lands on that view.
  // The stamp records where the pre-start screen was opened so an open that
  // changes module in the same commit is not mistaken for a nav-away.
  const testReadyNavStampRef = useRef("");
  useEffect(() => {
    if (testReadyToStart) testReadyNavStampRef.current = `${activeModule}|${learningSubModule}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testReadyToStart]);
  useEffect(() => {
    if (!testReadyToStart || showQuiz) return;
    if (`${activeModule}|${learningSubModule}` === testReadyNavStampRef.current) return;
    testStartTokenRef.current += 1;
    setTestReadyToStart(false);
    setActiveTest(null);
    setTestTimerActive(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeModule, learningSubModule]);

  // `consume` makes the snapshot single-use: callers that END a flow (no chain
  // continues after them) pass true so it cannot go stale and hijack a later close.
  const resolveModuleAfterClose = ({ consume = false } = {}) => {
    const defaultModule = resolveDefaultModuleAfterClose();
    const destination = resolveCloseDestination(autoOpenReturnRef.current, defaultModule);
    if (consume) autoOpenReturnRef.current = null;
    return destination;
  };

  // AIT-246: the auto-open walkthrough is over (or never had a next item):
  // put the screen back that was open before it, then forget it.
  const finishAutoOpenReturn = () => {
    const saved = autoOpenReturnRef.current;
    if (!saved) return;
    autoOpenReturnRef.current = null;
    setActiveModule(saved.activeModule);
    if (saved.learningSubModule) setLearningSubModule(saved.learningSubModule);
    if (saved.activeSidebarTab) setActiveSidebarTab(saved.activeSidebarTab);
  };

  const resolveDefaultModuleAfterClose = () => {
    if (showLessonPlan && lessonPlanRuntime && lessonPlanAssetLaunchRef.current) {
      return "lessonPlans";
    }
    // A journey open with no lesson over it: closing an asset belongs back on
    // the map, not on the topic tiles. Without this branch a scene launched
    // from inside a journey-hosted loop drops the user out of the story.
    if (discoveryJourney) return "discoveryJourneys";
    return "learning";
  };

  // BDD 08/30/2026 - Rev 1 exam-review asset return.
  // This intentionally restores the already-loaded review state instead of
  // re-fetching the test result. That keeps the same activeTest, quizData,
  // submitted answers, AI history, and fetched references intact.
  const restoreExamReviewAfterAssetClose = () => {
    if (
      !examReviewAssetReturnRef.current ||
      quizMode !== "pastTestView"
    ) {
      return false;
    }

    examReviewAssetReturnRef.current = false;
    setStageMaximized(false);
    setActiveModule("learning");
    setLearningSubModule("tests");
    setShowQuiz(true);
    console.log("[EXAM REVIEW] Returned to completed exam review after asset close");
    return true;
  };

  const handleCloseModule = async (
    isAuto = false,
    walkthroughStepOverride = null,
    walkthroughRefsOverride = null
  ) => {
    console.log("📦 handleCloseModule triggered", {
      isAuto,
      walkthroughStep: walkthroughStepOverride ?? walkthroughStep,
      walkthroughReferences: walkthroughRefsOverride ?? walkthroughReferences,
      autoWalkthroughMode
    });

    // ✅ Prevent re-entrant close calls (e.g., rapid close + visibilitychange + internal close)
    if (closeInProgressRef.current) {
      console.log("[close] ignored: close already in progress");
      return false;
    }

    // ✅ Small debounce (50ms) to ignore accidental double taps
    const now = Date.now();
    if (now - (lastCloseTimestampRef.current || 0) < 50) {
      console.log("[close] ignored: debounce <50ms");
      return false;
    }
    lastCloseTimestampRef.current = now;

    closeInProgressRef.current = true;

    try {
      // BDD 10/12/2025
      if (showVideo /* or detecting that a video is open */) {
        destroyHls();
      }

      // -- keep your existing "test mode" guard unchanged --
      if (showQuiz && quizMode === "test") {
        if (Platform.OS === "web") {
          const prevTabSwitchDetection = tabSwitchDetectionEnabledRef.current;
          tabSwitchDetectionEnabledRef.current = false; // ⛔ pause blur detection
          const confirmed = window.confirm(
            "Warning: This action will automatically submit your current answers. Do you want to proceed?"
          );
          if (confirmed) {
            await handleSubmitTest();
            cleanupModule();
            return true;
          } else {
            // Cancel: the student stays in the test. Resume blur detection after a buffer so the
            // dialog's own blur is not counted as a tab switch.
            setTimeout(() => {
              tabSwitchDetectionEnabledRef.current = prevTabSwitchDetection;
            }, 2000);
            return false;
          }
        } else {
          return new Promise((resolve) => {
            Alert.alert(
              "Exit Test?",
              "Leaving the test now will submit it automatically. Do you want to proceed?",
              [
                { text: "Cancel", style: "cancel", onPress: () => resolve(false) },
                {
                  text: "Submit and Exit",
                  onPress: async () => {
                    await handleSubmitTest();
                    cleanupModule();
                    resolve(true);
                  },
                },
              ]
            );
          });
        }
      }

      setStageMaximized(false); // BDD 12/21/2025 – exit fullscreen

      // Quiz mode: close without submitting — only the Submit button should submit
      // (Removed auto-submit on close per AIT-XXX)

      // ===== investor mode soft-close for PWO =====
      // If we are currently on a PWO and investor mode is on, do NOT tear down the iframe:
      // BDD 02/15/2026 - test/healthCheckpwo
      if (investorMode && showPwo && !(isHealthcheckEnabled && pwoHealthcheckModeRef.current)) {
        try {
          // keep iframe mounted but invisible; clear PWO-specific questions
          setPwoKeepAlive(true);
          setShowPwo(false);
          setIsPwoOpen(false);
          setSuggestedQuestions([]);
          setSuggestedQuestionsHeader([]);
          lastPwoSuggestionsContextRef.current = null;

          // Pause Unity audio when closing (music PWOs).
          try {
            pwoIframeRef.current?.contentWindow?.postMessage({ type: "APP_PAUSE" }, "*");
          } catch {}

          // Reset WebGL ready flag so next open takes the reload path for a different PWO.
          // Keep lastPwoKeyRef intact so same-PWO reopen can still use warm reuse.
          isWebGLReadyRef.current = false;

          // hide visually (prevents input, keeps runtime warm)
          // (hidden via keepalive styles in JSX)

          // clear any PWO-specific timers/listeners (but don't blank src)
          try {
            if (pwofallbackTimeoutId?.current) {
              clearTimeout(pwofallbackTimeoutId.current);
              pwofallbackTimeoutId.current = null;
            }
          } catch {}
          try {
            if (webglReadyHandlerRef.current) {
              window.removeEventListener("message", webglReadyHandlerRef.current);
              webglReadyHandlerRef.current = null;
            }
          } catch {}
          try {
            if (unauthorizedHandlerRef.current) {
              window.removeEventListener("message", unauthorizedHandlerRef.current);
              unauthorizedHandlerRef.current = null;
            }
          } catch {}

          // Trigger KT popup on PWO close (skip during auto-walkthrough)
          if (showPwo && !autoWalkthroughMode) {
            triggerKtPopup({ topicIdOverride: activeTopicForAIRef.current?.source_topic_id });
          }

          // shift UI back to the launch surface. Completed exam review gets
          // first priority because this PWO was opened from its AI references.
          if (!restoreExamReviewAfterAssetClose()) {
            setActiveModule(resolveModuleAfterClose());
          }

          // proceed with your walkthrough chaining (unchanged)
          if (
            autoWalkthroughMode &&
            autoPlayVideo &&
            (walkthroughStepOverride ?? walkthroughStep) === "pwo" &&
            (walkthroughRefsOverride ?? walkthroughReferences)?.video?.[0]
          ) {
            console.log("➡️ Moving from PWO to video");
            const videoRef = (walkthroughRefsOverride ?? walkthroughReferences).video[0];
            setWalkthroughStep("video");
            handleVideoClick(
              videoRef.videoID,
              videoRef.tagID,
              authToken,
              null,
              null,
              true,
              "video",
              walkthroughRefsOverride ?? walkthroughReferences
            );
            return true;
          } else if (
            autoWalkthroughMode &&
            (walkthroughStepOverride ?? walkthroughStep) === "video" &&
            (walkthroughRefsOverride ?? walkthroughReferences)?.quiz?.length > 0
          ) {
            console.log("➡️ Moving from video to quiz");
            const quizRef = (walkthroughRefsOverride ?? walkthroughReferences).quiz;
            setWalkthroughStep("quiz");
            await openAutoWalkthroughQuiz(quizRef);
            return true;
          } else if (
            autoWalkthroughMode &&
            (walkthroughStepOverride ?? walkthroughStep) === "quiz" &&
            (walkthroughRefsOverride ?? walkthroughReferences)?.quiz?.length > 0
          ) {
            const feedbackPrompt = generateQuizFeedbackPrompt(quizData, userAnswers, quizResponses);
            setWalkthroughStep(null);
            setAutoWalkthroughMode(false);
            if (!isAuto) finishAutoOpenReturn(); // launch-time closes (isAuto) must keep the snapshot
            askFromAnywhere(feedbackPrompt, { skipReferences: true });
            return true;
          } else if (autoWalkthroughMode) {
            console.warn("❗ No references found for walkthrough.");
            if (!isAuto) {
              setWalkthroughStep(null);
              setWalkthroughReferences(null);
            }
          }

          if (!isAuto) finishAutoOpenReturn(); // launch-time closes (isAuto) must keep the snapshot

          return true; // soft close complete
        } catch (e) {
          console.warn("Soft-close (investor) fell back to hard cleanup due to error:", e);
          // if anything goes sideways, fall through to your normal cleanup
        }
      }
      // ===== END investor soft-close =====

      // ===== PWO soft-close (keep WebGL warm) =====
      // Keeps Unity runtime alive to make subsequent PWOs open faster.
      // Guarded by feature flag and disabled during healthcheck runs.
      if (
        Platform.OS === "web" &&
        (flags?.pwo_keepalive !== false) &&
        showPwo &&
        !(isHealthcheckEnabled && pwoHealthcheckModeRef.current)
      ) {
        try {
          setPwoKeepAlive(true);
          setShowPwo(false);
          setIsPwoOpen(false);
          setSuggestedQuestions([]);
          setSuggestedQuestionsHeader([]);
          lastPwoSuggestionsContextRef.current = null;
          setLoading(false);
          setCurrentPwoId(null);
          setCurrentPwoScene(null);

          // Pause Unity audio when closing (music PWOs).
          try {
            pwoIframeRef.current?.contentWindow?.postMessage({ type: "APP_PAUSE" }, "*");
          } catch {}

          // Hide visually (prevents input) while keeping the runtime alive.
          // (hidden via keepalive styles in JSX)

          // Clear PWO boot timers/listeners (but don't blank src)
          try { clearPwoWebglTimersAndListeners(); } catch {}
          try {
            if (unauthorizedHandlerRef.current) {
              window.removeEventListener("message", unauthorizedHandlerRef.current);
              unauthorizedHandlerRef.current = null;
            }
          } catch {}

          if (!autoWalkthroughMode) {
            triggerKtPopup({ topicIdOverride: activeTopicForAIRef.current?.source_topic_id });
          }

          if (!restoreExamReviewAfterAssetClose()) {
            setActiveModule(resolveModuleAfterClose());
          }

          // Walkthrough chaining (same as investor branch)
          if (
            autoWalkthroughMode &&
            autoPlayVideo &&
            (walkthroughStepOverride ?? walkthroughStep) === "pwo" &&
            (walkthroughRefsOverride ?? walkthroughReferences)?.video?.[0]
          ) {
            console.log("➡️ Moving from PWO to video");
            const videoRef = (walkthroughRefsOverride ?? walkthroughReferences).video[0];
            setWalkthroughStep("video");
            handleVideoClick(
              videoRef.videoID,
              videoRef.tagID,
              authToken,
              null,
              null,
              true,
              "video",
              walkthroughRefsOverride ?? walkthroughReferences
            );
            return true;
          } else if (
            autoWalkthroughMode &&
            (walkthroughStepOverride ?? walkthroughStep) === "video" &&
            (walkthroughRefsOverride ?? walkthroughReferences)?.quiz?.length > 0
          ) {
            console.log("➡️ Moving from video to quiz");
            const quizRef = (walkthroughRefsOverride ?? walkthroughReferences).quiz;
            setWalkthroughStep("quiz");
            await openAutoWalkthroughQuiz(quizRef);
            return true;
          } else if (
            autoWalkthroughMode &&
            (walkthroughStepOverride ?? walkthroughStep) === "quiz" &&
            (walkthroughRefsOverride ?? walkthroughReferences)?.quiz?.length > 0
          ) {
            const feedbackPrompt = generateQuizFeedbackPrompt(quizData, userAnswers, quizResponses);
            setWalkthroughStep(null);
            setAutoWalkthroughMode(false);
            if (!isAuto) finishAutoOpenReturn(); // launch-time closes (isAuto) must keep the snapshot
            askFromAnywhere(feedbackPrompt, { skipReferences: true });
            return true;
          } else if (autoWalkthroughMode) {
            console.warn("❗ No references found for walkthrough.");
            if (!isAuto) {
              setWalkthroughStep(null);
              setWalkthroughReferences(null);
            }
          }

          if (!isAuto) finishAutoOpenReturn(); // launch-time closes (isAuto) must keep the snapshot

          return true;
        } catch (e) {
          console.warn("Soft-close (pwo_keepalive) fell back to hard cleanup due to error:", e);
          // fall through to hard cleanup
        }
      }
      // ===== END PWO soft-close =====

      // Trigger KT popup on video close (skip during auto-walkthrough)
      if ((showVideo || activeModule === 'video') && !autoWalkthroughMode) {
        triggerKtPopup({ topicIdOverride: activeTopicForAIRef.current?.source_topic_id });
      }

      // Trigger KT popup on PWO close (skip during auto-walkthrough)
      if ((showPwo || activeModule === 'pwo') && !autoWalkthroughMode) {
        triggerKtPopup({ topicIdOverride: activeTopicForAIRef.current?.source_topic_id });
      }

      // default: old behavior
      cleanupModule(); // Always clean up state

      if (autoWalkthroughMode && autoPlayVideo && walkthroughStep === "pwo" && walkthroughReferences?.video?.[0]) {
        console.log("➡️ Moving from PWO to video");
        const videoRef = walkthroughReferences.video[0];
        setWalkthroughStep("video");
        handleVideoClick(
          videoRef.videoID,
          videoRef.tagID,
          authToken,
          null,
          null,
          true,
          "video",
          walkthroughReferences
        );
        return true;
      } else if (autoWalkthroughMode && walkthroughStep === "video" && walkthroughReferences?.quiz?.length > 0) {
        console.log("➡️ Moving from video to quiz");
        const quizRef = walkthroughReferences.quiz;
        setWalkthroughStep("quiz");
        await openAutoWalkthroughQuiz(quizRef);
        return true;
      } else if (autoWalkthroughMode && walkthroughStep === "quiz" && walkthroughReferences?.quiz?.length > 0) {
        const feedbackPrompt = generateQuizFeedbackPrompt(quizData, userAnswers, quizResponses);
        setWalkthroughStep(null);
        setAutoWalkthroughMode(false);
        if (!isAuto) finishAutoOpenReturn(); // launch-time closes (isAuto) must keep the snapshot
        askFromAnywhere(feedbackPrompt, { skipReferences: true });
        return true;
      } else if (autoWalkthroughMode) {
        console.warn("❗ No references found for walkthrough.");
        if (!isAuto) {
          setWalkthroughStep(null);
          setWalkthroughReferences(null);
        }
      }

      if (!isAuto) finishAutoOpenReturn(); // launch-time closes (isAuto) must keep the snapshot

      return true;
    } finally {
      closeInProgressRef.current = false;
    }
  };


  // BDD 11/20/2025 - Da Vinci teacher saw students stuck at skybox for pwo
  const cleanupModule = () => {
    // BDD 08/30/2026 - Rev 1: if this asset originated in completed exam
    // review, restore that already-loaded review instead of dropping to Tests.
    const returningToExamReview =
      examReviewAssetReturnRef.current &&
      quizMode === "pastTestView";

    if (returningToExamReview) {
      examReviewAssetReturnRef.current = false;
      setActiveModule("learning");
      setLearningSubModule("tests");
    } else {
      // Not a hardcoded "learning": resolveModuleAfterClose only diverges from it
      // when a lesson is open AND flagged as the thing that sent us away, so every
      // other close behaves exactly as before. Without this, finishing a topic quiz
      // launched from a lesson dumps the teacher on the tiles.
      // Inside handleCloseModule the snapshot is managed by finishAutoOpenReturn /
      // the isAuto guards; any other caller is ending a flow, so consume it.
      setActiveModule(resolveModuleAfterClose({ consume: !closeInProgressRef.current }));
    }

    setShowVideo(false);
    setUploadedFile(null);
    setCurrentVideoId(null);
    setCurrentVideoTagID(null);
    setCurrentPwoId(null);
    setCurrentPwoScene(null);
    setShowQuiz(returningToExamReview);
    setShowPwo(false);
    setThreePwoActive(false);
    setIsPwoOpen(false);
    setSuggestedQuestions([]);
    setSuggestedQuestionsHeader([]);
    lastPwoSuggestionsContextRef.current = null;
    setPwoKeepAlive(false);
    setLoading(false);  // ✅ Clear loading so "Working on your query..." doesn't get stuck
    setSuggestedQuestions([]);  // ✅ Clear suggestions on module close
    setSuggestedQuestionsHeader([]);
    setTabSwitchCount(0);

    // ✅ Cancel any in-flight handlePWOClick async work
    pwoClickCancelledRef.current = true;

    // ✅ Clear generic fallback timeout (if used elsewhere)
    if (typeof fallbackTimeoutId !== "undefined" && fallbackTimeoutId !== null) {
      clearTimeout(fallbackTimeoutId);
    }

    // ✅ Clear PWO 3-second init timeout
    if (pwoInitTimeoutId.current) {
      clearTimeout(pwoInitTimeoutId.current);
      pwoInitTimeoutId.current = null;
    }

    // ✅ Clear PWO-specific fallback timeout
    if (pwofallbackTimeoutId?.current) {
      clearTimeout(pwofallbackTimeoutId.current);
      pwofallbackTimeoutId.current = null;
    }

    // BDD 02/12/2026 - debug/openpwo
    // BDD NOTE CAUTION: 
    // This will only have full effect if (later) you also assign the timer id where you currently do setTimeout(() => { iframe.src = ... }, 1000)
    if (pwoBootSrcTimeoutId.current) {
      clearTimeout(pwoBootSrcTimeoutId.current);
      pwoBootSrcTimeoutId.current = null;
    }

    // ✅ Reset WebGL ready flags
    setIsWebGLReady(false);
    isWebGLReadyRef.current = false;

    // ✅ Remove WEBGL_READY listener
    if (webglReadyHandlerRef.current) {
      window.removeEventListener("message", webglReadyHandlerRef.current);
      webglReadyHandlerRef.current = null;
    }

    // ✅ Remove UNAUTHORIZED listener
    if (unauthorizedHandlerRef.current) {
      window.removeEventListener("message", unauthorizedHandlerRef.current);
      unauthorizedHandlerRef.current = null;
    }

    // ✅ Blank iframe src so old Unity scene doesn't persist
    if (pwoIframeRef.current) {
      pwoIframeRef.current.src = "about:blank";
    }

    // ✅ Reset last PWO key so next open doesn't compare against stale state
    lastPwoKeyRef.current = null;
    pwoHotSwitchCountRef.current = 0;

    // Da Vinci 3-Day Challenge: re-check progress on every module dismissal
    // (this is the single close funnel for video/PWO/quiz).
    syncChallenge(activeStudyCollection?.id);
  };

  // BDD 07/29/2026 - Journey
  const handleJourneyStageClose = async () => {
    if (threePwoActive) {
      stopTtsStream();
      setThreePwoActive(false);
      setShowPwo(false);
      setIsPwoOpen(false);
      setCurrentPwoId(null);
      setCurrentPwoScene(null);
      setJourneyActiveAsset(null);
      setJourneyRightTab("journey");
      setJourneyAiContext((current) => current
        ? { ...current, active_activity: { type: "question" } } : current);
      setActiveModule("home");
      return true;
    }
    stopTtsStream();
    setStageMaximized(false);

    const shouldReturnToJourney = Boolean(
      journeyActiveAsset &&
      showJourney &&
      journeyRuntime
    );

    const canClose = await handleCloseModule(false);

    if (canClose === false) {
      return false;
    }

    if (shouldReturnToJourney) {
      setJourneyActiveAsset(null);
      setJourneyRightTab("journey");

      setJourneyAiContext((current) =>
        current
          ? {
              ...current,
              active_activity: {
                type: "question",
              },
            }
          : current
      );

      setActiveModule("home");
    }

    return true;
  };

  // Phase 2B kiosk semantics: Esc inside a PWO means "return to AITutor",
  // NOT "leave fullscreen". Listen in the parent and, when the local WebGL
  // iframe is same-origin, inside the iframe as well so Unity focus does not
  // swallow the key. No Unity rebuild is required for the local deployment.
  useEffect(() => {
    if (
      !sbs3dKioskMode ||
      !sbs3dPwoTakeover ||
      Platform.OS !== "web" ||
      typeof window === "undefined"
    ) return;

    let frameWindow = null;
    let iframe = pwoIframeRef.current;
    let closeStarted = false;

    const closePwoFromEsc = (event) => {
      if (String(event?.key || "").toLowerCase() !== "escape") return;
      if (closeStarted) return;
      closeStarted = true;

      try {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation?.();
      } catch {}

      console.log("[SBS3D KIOSK] Esc from PWO -> return to AITutor");
      setSbs3dPwoRecoveryVisible(false);

      // Close immediately through the existing module funnel. Then make a
      // best-effort Pointer Lock handoff back to AITutor while this interaction
      // is still fresh. If the browser refuses, the normal SBS resume overlay
      // remains as the safe fallback.
      Promise.resolve(handleJourneyStageClose())
        .then((closed) => {
          if (closed === false) {
            closeStarted = false;
            return;
          }
          setTimeout(() => {
                    requestSbs3dPointerLock();
          }, 80);
        })
        .catch(() => {
          closeStarted = false;
        });
    };

    const attachToIframe = () => {
      iframe = pwoIframeRef.current;
      if (!iframe) return;
      try {
        frameWindow = iframe.contentWindow;
        frameWindow?.addEventListener("keydown", closePwoFromEsc, true);
        console.log("[SBS3D KIOSK] PWO Esc listener attached inside WebGL iframe");
      } catch (error) {
        frameWindow = null;
        console.debug("[SBS3D KIOSK] WebGL iframe is cross-origin; parent Esc listener only", error);
      }
    };

    window.addEventListener("keydown", closePwoFromEsc, true);
    iframe?.addEventListener?.("load", attachToIframe);
    attachToIframe();

    return () => {
      window.removeEventListener("keydown", closePwoFromEsc, true);
      iframe?.removeEventListener?.("load", attachToIframe);
      try {
        frameWindow?.removeEventListener("keydown", closePwoFromEsc, true);
      } catch {}
    };
  }, [
    sbs3dKioskMode,
    sbs3dPwoTakeover,
    handleJourneyStageClose,
    requestSbs3dPointerLock,
  ]);

  // In PWO recovery mode the first Esc has already left browser fullscreen.
  // A second Esc (or X) is an explicit request to leave the PWO entirely.
  useEffect(() => {
    if (
      !sbs3dProjectorMode ||
      sbs3dKioskMode ||
      !sbs3dPwoTakeover ||
      !sbs3dPwoRecoveryVisible ||
      Platform.OS !== "web" ||
      typeof window === "undefined"
    ) return;

    const onPwoRecoveryKeyDown = (event) => {
      const key = String(event.key || "").toLowerCase();
      if (key !== "escape" && key !== "x") return;

      event.preventDefault();
      event.stopPropagation();
      setSbs3dPwoRecoveryVisible(false);
      // Close through the existing module funnel. Do NOT request fullscreen
      // here: after returning to AITutor, the normal SBS recovery overlay owns
      // the separate user gesture that restores fullscreen + Pointer Lock.
      handleJourneyStageClose();
    };

    window.addEventListener("keydown", onPwoRecoveryKeyDown, true);
    return () => window.removeEventListener("keydown", onPwoRecoveryKeyDown, true);
  }, [
    sbs3dProjectorMode,
    sbs3dKioskMode,
    sbs3dPwoTakeover,
    sbs3dPwoRecoveryVisible,
    handleJourneyStageClose,
  ]);


  // BDD LEIA INTEGRATION - following is when Leia PWO closes from Android
  useEffect(() => {
    const onUnityExit = () => {
      handleCloseModule();
    };
    window.addEventListener("unityExit", onUnityExit);
    return () => {
      window.removeEventListener("unityExit", onUnityExit);
    };
  }, [handleCloseModule]);

  // ===== Clean up active PWO/video/quiz when navigating away from Learning =====
  // The Home button (and other nav buttons) call setActiveModule() directly without
  // going through handleCloseModule, so stale content state (showVideo, showPwo,
  // pwoKeepAlive) persists and causes a black/stuck screen on return.
  useEffect(() => {
    const learningModules = ["learning", "video", "pwo"];
    if (learningModules.includes(activeModule)) return; // still in learning group

    // Video cleanup
    destroyHls();
    setShowVideo(false);
    setCurrentVideoId(null);
    setCurrentVideoTagID(null);

    // PWO cleanup
    setShowPwo(false);
    setIsPwoOpen(false);
    setSuggestedQuestions([]);
    setSuggestedQuestionsHeader([]);
    lastPwoSuggestionsContextRef.current = null;
    setPwoKeepAlive(false);
    setCurrentPwoId(null);
    setCurrentPwoScene(null);
    pwoClickCancelledRef.current = true;
    setIsWebGLReady(false);
    isWebGLReadyRef.current = false;
    if (pwoIframeRef.current) {
      pwoIframeRef.current.src = "about:blank";
    }
    lastPwoKeyRef.current = null;
    pwoHotSwitchCountRef.current = 0;

    // Quiz cleanup (non-test — test mode has its own exit guard)
    if (quizMode !== "test") {
      setShowQuiz(false);
    }

    // General cleanup
    setUploadedFile(null);
    setLoading(false);
    setSuggestedQuestions([]);
    setSuggestedQuestionsHeader([]);
    setTabSwitchCount(0);
    setStageMaximized(false);

    // Clear PWO timers
    if (pwoInitTimeoutId.current) {
      clearTimeout(pwoInitTimeoutId.current);
      pwoInitTimeoutId.current = null;
    }
    if (pwofallbackTimeoutId?.current) {
      clearTimeout(pwofallbackTimeoutId.current);
      pwofallbackTimeoutId.current = null;
    }
    if (pwoBootSrcTimeoutId.current) {
      clearTimeout(pwoBootSrcTimeoutId.current);
      pwoBootSrcTimeoutId.current = null;
    }

    // Remove event listeners
    if (webglReadyHandlerRef.current) {
      window.removeEventListener("message", webglReadyHandlerRef.current);
      webglReadyHandlerRef.current = null;
    }
    if (unauthorizedHandlerRef.current) {
      window.removeEventListener("message", unauthorizedHandlerRef.current);
      unauthorizedHandlerRef.current = null;
    }
  }, [activeModule]);
  // ===== END navigation-away cleanup =====

  // Function to handle text-based answers (Fill in the Blank, Long Answer)
  const handleAnswerChange = (questionId, answer) => {
    setUserAnswers((prev) => ({
      ...prev,
      [questionId]: answer
    }));
  };

  const checkTextAnswer = async (questionId, correctAnswer) => {
    // AIT-249: PRESERVE the raw user answer at all costs. Previous logic
    // destructively overwrote userAnswers[questionId] with display strings
    // ("✅ Correct!" / "❌ Incorrect"), which corrupted the score-on-submit
    // path and made the deferred review screen impossible.
    const rawAnswer = userAnswers[questionId];

    if (!rawAnswer) {
      // Only record an "unattempted" feedback marker if we're in legacy
      // immediate-feedback mode; otherwise the review screen derives this
      // at submit time.
      if (immediateFeedbackEnabled) {
        setQuizResponses(prev => ({
          ...prev,
          [questionId]: "unattempted"
        }));
      }
      return;
    }

    // Track that the question has been attempted regardless of mode.
    setAttemptedQuestions(prev => (prev.includes(questionId) ? prev : [...prev, questionId]));

    // AIT-249: in deferred mode we DO NOT make a server call to reveal
    // correctness, do not write to quizResponses, do not mutate userAnswers.
    // The score is computed at submit time from raw userAnswers via
    // computeAnswerFeedback.
    if (!immediateFeedbackEnabled) {
      return;
    }

    try {
      const response = await axios.post("${FASTAPI_BASE_URL}/check-answer", {
        question_id: questionId,
        user_answer: rawAnswer,
      });

      const isCorrect = response.data.is_correct;

      // NOTE (AIT-249 bug fix): Do NOT overwrite userAnswers with a display
      // string here — the answer must remain the raw value so that scoring,
      // analytics, and the review screen stay correct on resubmit / re-render.
      setQuizResponses(prev => ({
        ...prev,
        [questionId]: isCorrect ? "correct" : "wrong"
      }));
      setAnswerFeedback(prev => ({
        ...prev,
        [questionId]: isCorrect ? "correct" : "wrong"
      }));
    } catch (error) {
      console.error("Error checking answer:", error);
    }
  };

  const handleMCQSelection = (questionId, selectedOption, selectedIndex, correctAnswerIndex) => {
    const correctIndex = parseInt(correctAnswerIndex, 10);

    if (isNaN(correctIndex)) {
      console.error(`Γ¥î Error: correctAnswerIndex is NaN for Question ID: ${questionId}`);
      return;
    }

    const isCorrect = selectedIndex + 1 === correctIndex;

    // AIT-249: always record the raw selection so the review screen and
    // submit-time scoring can read it back. Feedback writes are gated.
    if (immediateFeedbackEnabled) {
      setQuizResponses(prev => ({
        ...prev,
        [questionId]: isCorrect ? "correct" : "wrong"
      }));
    }

    setUserAnswers(prev => ({
      ...prev,
      [questionId]: selectedOption
    }));

    if (immediateFeedbackEnabled) {
      setAnswerFeedback(prev => ({
        ...prev,
        [questionId]: isCorrect ? "correct" : "wrong"
      }));
    }

    // Γ£à Increment attempted count only if this is the first attempt for the question
    setAttemptedQuestions(prev => (prev.includes(questionId) ? prev : [...prev, questionId]));
  };

  // Multi-select (question_type 4): toggle an option's membership in the
  // array stored under userAnswers[questionId]. Grading is deferred to
  // submit time (computeAnswerFeedback does the set comparison), so here we
  // only track the raw selection — mirroring handleMCQSelection's contract.
  const handleMultiSelect = (questionId, selectedOption) => {
    setUserAnswers(prev => {
      const current = Array.isArray(prev[questionId]) ? prev[questionId] : [];
      const next = current.includes(selectedOption)
        ? current.filter(k => k !== selectedOption)
        : [...current, selectedOption];
      return { ...prev, [questionId]: next };
    });
    setAttemptedQuestions(prev => (prev.includes(questionId) ? prev : [...prev, questionId]));
  };

  const generateQuizFeedbackPrompt = (quiz, userAnswers, quizResponses) => {

    if (!quiz || quiz.length === 0) {
      return t("I didn't get any quiz questions. Can you give me a summary of the topic?");
    }

    const incorrectQuestions = quiz.filter((q) => {
      const status = quizResponses[q.question_id];
      return status === "wrong";
    });

    if (incorrectQuestions.length === 0) {
      return t("I answered all quiz questions correctly. Can you summarize the key takeaways?");
    }

    let prompt = t("I got the following quiz questions wrong. Please explain the correct answers:\n\n");

    incorrectQuestions.forEach((q, index) => {
      const studentAnswer = userAnswers[q.question_id] || t("No answer");

      prompt += `Q${index + 1}: ${q.question?.text || t("Unknown question")}\n`;
    });

    prompt += t("Can you explain these to help me understand better?");
    return prompt;
  };

  // Function to toggle hints visibility
  const toggleHint = (questionId) => {
    setShowHints((prev) => ({
      ...prev,
      [questionId]: !prev[questionId]
    }));
  };

  // Function to toggle solutions visibility
  const toggleSolution = (questionId) => {
    setShowSolutions((prev) => ({
      ...prev,
      [questionId]: !prev[questionId]
    }));
  };

  // BDD 3/5/2025 - Fresh Try3 - to handle multi line equations as well

  // const MarkdownRenderer = ({ content }) => {
  //     // console.log("≡ƒöì Raw Markdown Content:", content);

  //     // Γ£à Pre-process Math Equations & Fix JSX Interpretation Issues
  //     const preProcessedContent = content
  //         .replace(/\$\$(.*?)\$\$/gs, (_, equation) => {
  //             equation = equation.trim().replace(/\s+/g, ' '); // Γ£à Remove extra spaces
  //             equation = equation.replace(/\\left/g, "").replace(/\\right/g, ""); // Γ£à Fix `{}` JSX parsing issue
  //             equation = equation.replace(/\\/g, "\\\\"); // Γ£à Escape backslashes properly
  //             equation = equation.replace(/_/g, "\\_"); // Γ£à Escape underscores to prevent JSX misinterpretation
  //             equation = equation.replace(/}/g, "\\}").replace(/{/g, "\\{"); // Γ£à Escape `{}` braces
  //             return `<BlockMath>${equation}</BlockMath>`; // Γ£à Ensure block math renders correctly
  //         })
  //         .replace(/\$(.*?)\$/g, (_, equation) => {
  //             equation = equation.trim().replace(/\s+/g, ' '); // Γ£à Remove extra spaces
  //             equation = equation.replace(/\\left/g, "").replace(/\\right/g, ""); // Γ£à Fix `{}` JSX parsing issue
  //             equation = equation.replace(/\\/g, "\\\\"); // Γ£à Escape backslashes properly
  //             equation = equation.replace(/_/g, "\\_"); // Γ£à Escape underscores
  //             equation = equation.replace(/}/g, "\\}").replace(/{/g, "\\{"); // Γ£à Escape `{}` braces
  //             return `<InlineMath>${equation}</InlineMath>`; // Γ£à Ensure inline math renders correctly
  //         });

  //     // console.log("≡ƒöì Processed Content for Markdown:", preProcessedContent);

  //     // return (
  //     //     <View>
  //     //         <Markdown
  //     //             options={{
  //     //                 overrides: {
  //     //                     BlockMath: {
  //     //                         component: ({ children }) => {
  //     //                             // Γ£à Convert 'children' into a STRING for proper rendering
  //     //                             let equation = Array.isArray(children) ? children.join("") : children;
  //     //                             equation = String(equation);
  //     //                             // console.log("≡ƒƒó BlockMath Equation:", equation);
  //     //                             return <BlockMath>{equation}</BlockMath>;
  //     //                         },
  //     //                     },
  //     //                     InlineMath: {
  //     //                         component: ({ children }) => {
  //     //                             let equation = Array.isArray(children) ? children.join("") : children;
  //     //                             equation = String(equation);
  //     //                             // console.log("≡ƒƒó InlineMath Equation:", equation);
  //     //                             return <InlineMath>{equation}</InlineMath>;
  //     //                         },
  //     //                     },
  //     //                 },
  //     //             }}
  //     //         >
  //     //             {preProcessedContent}
  //     //         </Markdown>
  //     //     </View>
  //     // );
  //     // BDD 11/21/2025 - font size of answers
  //   return (
  //     <View>
  //       <Markdown
  //         options={{
  //           overrides: {
  //             // Base paragraphs
  //             p: {
  //               component: (props) => (
  //                 <p
  //                   style={{
  //                     fontSize: 18,      // 🔼 bump from default
  //                     lineHeight: 24,
  //                     margin: "4px 0",
  //                   }}
  //                   {...props}
  //                 />
  //               ),
  //             },
  //             // List items
  //             li: {
  //               component: (props) => (
  //                 <li
  //                   style={{
  //                     fontSize: 18,
  //                     lineHeight: 24,
  //                   }}
  //                   {...props}
  //                 />
  //               ),
  //             },
  //             BlockMath: {
  //               component: ({ children }) => {
  //                 let equation = Array.isArray(children)
  //                   ? children.join("")
  //                   : children;
  //                 equation = String(equation);
  //                 return <BlockMath>{equation}</BlockMath>;
  //               },
  //             },
  //             InlineMath: {
  //               component: ({ children }) => {
  //                 let equation = Array.isArray(children)
  //                   ? children.join("")
  //                   : children;
  //                 equation = String(equation);
  //                 return <InlineMath>{equation}</InlineMath>;
  //               },
  //             },
  //           },
  //         }}
  //       >
  //         {preProcessedContent}
  //       </Markdown>
  //     </View>
  //   );

  // };
  // BDD 10/22/2025 - had to add some debounce
  // const handleVoiceInput = async () => {
  //     handleClick();

  //     try {
  //         setMicError(null); // Clear previous error

  //         // ✅ Check for microphone permission
  //         if (navigator.permissions) {
  //             const status = await navigator.permissions.query({ name: 'microphone' });
  //             if (status.state === 'denied') {
  //                 setMicError("Microphone access is denied. Please enable it in browser settings.");
  //                 setIsListening(false);
  //                 return;
  //             }
  //         }

  //         setIsListening(true);
  //         const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  //         const mediaRecorder = new MediaRecorder(stream);
  //         let chunks = [];

  //         mediaRecorder.ondataavailable = (event) => {
  //             chunks.push(event.data);
  //         };

  //         mediaRecorder.onstop = async () => {
  //             setIsListening(false);
  //             const blob = new Blob(chunks, { type: "audio/wav" });
  //             const file = new File([blob], "speech.wav", { type: "audio/wav" });

  //             await sendAudioToFastAPI(file);
  //         };

  //         mediaRecorder.start();

  //         setTimeout(() => {
  //             mediaRecorder.stop();
  //         }, 7500);

  //     } catch (error) {
  //         console.error("🎙️ Error accessing microphone:", error);
  //         setMicError("Unable to access the microphone. Please check browser settings.");
  //         setIsListening(false);
  //     }
  // };
  // BDD 10/22/2025 - had to add some debounce
  const handleVoiceInput = async () => {
    // Toggle: if already recording, stop early and send what we have
    if (isListeningRef.current || mrRef.current) {
      try { if (mrRef.current && mrRef.current.state !== "inactive") mrRef.current.stop(); } catch { }
      if (stopTimerRef.current) { clearTimeout(stopTimerRef.current); stopTimerRef.current = null; }
      return;
    }

    handleClick();

    try {
      setMicError(null);

      // (Permissions API may be unsupported in WebView—treat errors as "unknown", not fatal)
      try {
        if (navigator.permissions?.query) {
          const status = await navigator.permissions.query({ name: 'microphone' });
          if (status.state === 'denied') {
            setMicError("Microphone access is denied. Please enable it in Settings.");
            return;
          }
        }
      } catch { }

      isListeningRef.current = true;
      setIsListening(true);

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      gumStreamRef.current = stream;

      // Use webm (Chrome/Edge default) — Whisper API accepts webm natively
      const mimeType = MediaRecorder.isTypeSupported("audio/webm;codecs=opus")
        ? "audio/webm;codecs=opus"
        : MediaRecorder.isTypeSupported("audio/webm")
          ? "audio/webm"
          : undefined; // fallback to browser default
      const mediaRecorder = new MediaRecorder(stream, mimeType ? { mimeType } : undefined);
      mrRef.current = mediaRecorder;

      const chunks = [];
      mediaRecorder.ondataavailable = (e) => { if (e?.data?.size) chunks.push(e.data); };

      mediaRecorder.onstop = async () => {
        try {
          const actualMime = mediaRecorder.mimeType || "audio/webm";
          const ext = actualMime.includes("webm") ? "webm" : actualMime.includes("ogg") ? "ogg" : "wav";
          const blob = new Blob(chunks, { type: actualMime });
          const file = new File([blob], `speech_${Date.now()}.${ext}`, { type: actualMime });
          await sendAudioToFastAPI(file);
        } catch (err) {
          console.error("🎙️ onstop finalization error:", err);
        } finally {
          // cleanup
          try { gumStreamRef.current?.getTracks().forEach(t => t.stop()); } catch { }
          gumStreamRef.current = null;
          mrRef.current = null;
          if (stopTimerRef.current) { clearTimeout(stopTimerRef.current); stopTimerRef.current = null; }
          isListeningRef.current = false;
          setIsListening(false);
        }
      };

      mediaRecorder.start();

      // max recording limit: 30s safety cap (user taps to stop before this)
      stopTimerRef.current = setTimeout(() => {
        try { if (mrRef.current && mrRef.current.state !== "inactive") mrRef.current.stop(); } catch { }
      }, 30000);

    } catch (error) {
      console.error("🎙️ Error accessing microphone:", error);
      setMicError("Unable to access the microphone. Please check Settings.");
      // cleanup guard
      try { gumStreamRef.current?.getTracks().forEach(t => t.stop()); } catch { }
      gumStreamRef.current = null;
      mrRef.current = null;
      if (stopTimerRef.current) { clearTimeout(stopTimerRef.current); stopTimerRef.current = null; }
      isListeningRef.current = false;
      setIsListening(false);
    }
  };

  const startListening = () => {
    setIsListening(true);
    recognition.current?.start();
  };

  const stopListening = () => {
    setIsListening(false);
    recognition.current?.stop();
  };
  // BDD 10/5/2025 - short and long answers
  // const handleAskButtonPress = () => {
  //   // console.log("≡ƒƒó Ask button clicked!");
  //   setIsVoiceInput(false);  // Ensure no interference from voice input
  //   handleAsk();  // Calls handleAsk() manually
  // };
  // const handleAskButtonPress = React.useCallback((maybeText,  options = {}) => {
  //   setIsVoiceInput(false);

  //   const base =
  //     typeof maybeText === "string" && maybeText.trim()
  //       ? maybeText.trim()
  //       : (inputValue || "").trim();

  //   if (!base) return;

  //   // ✅ use your existing decorator from 4A/4B
  //   const finalText = applyAnswerStyle ? applyAnswerStyle(base) : base;

  //   // (optional) reflect in the input
  //   // setInputValue(finalText);

  //   // ✅ keep your existing ask path
  //   if (typeof askFromUI === "function") {
  //     askFromUI(finalText);
  //   } else if (typeof handleAsk === "function") {
  //     handleAsk(finalText);
  //   }
  // }, [inputValue, applyAnswerStyle, askFromUI, handleAsk, setIsVoiceInput, setInputValue]);

  const sendAudioToFastAPI = async (audioFile) => {
    const formData = new FormData();
    formData.append("file", audioFile);
    // formData.append("language", selectedSecondaryLang); // BDD AI Language is sent here
    // BDD 12/31/2025 - Choice of EN - IN and EN - US
    formData.append("language", resolveCurriculumLang(selectedSecondaryLang)); // BDD: normalize (en-in -> en) for Whisper

    try {
      // console.log("≡ƒôí Uploading audio...");
      const response = await fetch(`${FASTAPI_BASE_URL}/whisper-transcribe/`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (data.transcription) {
        // console.log("≡ƒô£ Whisper Transcription:", data.transcription);
        setQuestion(data.transcription);
        setInputValue(data.transcription);
        setIsVoiceInput(true);
      } else {
        console.error("Γ¥î Whisper API Error:", data.error);
      }
    } catch (error) {
      console.error("Γ¥î Error sending audio:", error);
    }
  };

  // Toggle new dialog state
  const handleNewDialog = () => {
    setIsNewDialog(true);  // Enables new_dialog for next question
  };
  // State to track whether audio is playing and whether it has been played already.
  const [audioUrl, setAudioUrl] = useState(null); // Store AI speech URL
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasPlayed, setHasPlayed] = useState(false);
  const audioRef = useRef(new Audio());

  // ─────── load from AsyncStorage once ───────
  useEffect(() => {
    (async () => {
      // const fetchRef = JSON.parse(await AsyncStorage.getItem('autoFetchReferences') || 'true'); // BDD 11/7/2025
      const playVid = JSON.parse(await AsyncStorage.getItem('autoPlayVideo') || 'false');
      const openPwo = JSON.parse(await AsyncStorage.getItem('autoOpenPWO') || 'false');
      // const ragOnly  = JSON.parse(await AsyncStorage.getItem('restrictToRAGOnly')     || 'true'); // BDD 9/5/2025
      const currView = JSON.parse(await AsyncStorage.getItem('curriculumView') || 'false'); // BDD 9/14/2025

      // setAutoFetchReferences(fetchRef);
      setAutoPlayVideo(playVid);
      setAutoOpenPWO(openPwo);
      // setRestrictToRAGOnly(ragOnly); // BDD 9/5/2025

      // BDD 01/18/2026 - Only set viewMode from AsyncStorage if user has no saved preference in sessionStorage
      if (!userHasSavedPreferenceRef.current) {
        setViewMode(currView ? "curriculum" : "collections");
      }
    })();
  }, []);
  // ─────── persist when they change ───────
  // useEffect(() => {
  //     AsyncStorage.setItem('autoFetchReferences', JSON.stringify(autoFetchReferences));
  //   }, [autoFetchReferences]);

  useEffect(() => {
    AsyncStorage.setItem('autoPlayVideo', JSON.stringify(autoPlayVideo));
  }, [autoPlayVideo]);

  useEffect(() => {
    AsyncStorage.setItem('autoOpenPWO', JSON.stringify(autoOpenPWO));
  }, [autoOpenPWO]);

  // BDD 9/5/2025
  // useEffect(() => {
  //   AsyncStorage.setItem('restrictToRAGOnly', JSON.stringify(restrictToRAGOnly));
  // }, [restrictToRAGOnly]);

  useEffect(() => {
    AsyncStorage.setItem('curriculumView', JSON.stringify(curriculumView));
  }, [curriculumView]);

  // Whenever a new audio URL is received, reset the flag.
  useEffect(() => {
    if (audioUrl && audioUrl.trim() !== "") {
      setHasPlayed(false);
    }
  }, [audioUrl]);

  // Centralized effect to handle playback when audioUrl or mute state changes.
  useEffect(() => {
    if (!audioUrl || typeof audioUrl !== "string" || audioUrl.trim() === "") {
      return;
    }

    if (isMuted) {
      return;
    }

    if (hasPlayed) {
      return;
    }

    // BDD 04/12/2026 - if streamed chunk audio already played, do not
    // auto-play the final full Audio again. Keep it only for replay.
    if (suppressNextAudioAutoplayRef.current) {
      suppressNextAudioAutoplayRef.current = false;
      setHasPlayed(true);
      return;
    }

    if (!audioRef.current) {
      console.error("audioRef is not initialized!");
      return;
    }

    // Ensure the URL is properly formatted. If it's a relative URL, convert it to an absolute one.
    let formattedUrl = audioUrl;
    if (!/^https?:\/\//.test(audioUrl)) {
      formattedUrl = `${WEBGL_BASE_URL}${audioUrl}`;
    }

    // Set and load the new audio source.
    audioRef.current.src = formattedUrl;
    audioRef.current.load();

    const handleCanPlayThrough = () => {
      audioRef.current
        .play()
        .then(() => setIsPlaying(true))
        .catch(error => console.error("Error playing audio:", error));
    };

    const handleEnded = () => {
      setIsPlaying(false);
      setHasPlayed(true);
      audioRef.current.src = "";
    };

    const handleError = (error) => {
      console.error("Error loading audio:", error, formattedUrl);
    };

    // Attach event listeners.
    audioRef.current.addEventListener("canplaythrough", handleCanPlayThrough);
    audioRef.current.addEventListener("ended", handleEnded);
    audioRef.current.addEventListener("error", handleError);

    // Cleanup event listeners on dependency change.
    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener("canplaythrough", handleCanPlayThrough);
        audioRef.current.removeEventListener("ended", handleEnded);
        audioRef.current.removeEventListener("error", handleError);
      }
    };
  }, [audioUrl, isMuted, hasPlayed]);

  // BDD 04/12/2026 - stream through /api/ask_ai itself - try6
  // Function to manually stop the audio (e.g., when user clicks mute).
  const stopAudio = () => {
  if (audioRef.current) {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    audioRef.current.removeAttribute("src");
    audioRef.current.load();
  }
    // Also stop streamed chunk audio queue
    stopTtsStream();

    // Also stop browser speech synthesis if active
    if (typeof window !== 'undefined' && window.speechSynthesis) {
      window.speechSynthesis.cancel();
    }
    setAudioUrl(""); // once muted, audio is gone, does not come back for current conversation, comes back for future questions
    setIsPlaying(false);
    setHasPlayed(true);
  };

  // BDD 04/12/2026 - stream through /api/ask_ai itself - try6
  // Toggle mute and persist preference
  const handleToggleMute = useCallback(() => {
    const newMuted = !isMuted;
    setIsMuted(newMuted);
    if (newMuted) {
      stopAudio();
    }
    AsyncStorage.setItem('isSpeakerMuted', JSON.stringify(newMuted)).catch(() => {});
  }, [isMuted]);

  // Play/replay the latest AI answer audio
  const handlePlayAnswer = useCallback(() => {
    // Unmute if currently muted
    if (isMuted) {
      setIsMuted(false);
      AsyncStorage.setItem('isSpeakerMuted', 'false').catch(() => {});
    }

    // If we have a backend audio URL, replay it
    if (audioUrl) {
      // Explicit replay should not be suppressed
      suppressNextAudioAutoplayRef.current = false;
      setHasPlayed(false); // Reset to trigger playback via existing useEffect
    } else {
      // Fallback: use browser Speech API for the latest answer
      const latestAnswer = history.length > 0 ? history[history.length - 1]?.answer : null;
      if (latestAnswer && typeof window !== 'undefined' && window.speechSynthesis) {
        window.speechSynthesis.cancel(); // Stop any ongoing speech
        const utterance = new SpeechSynthesisUtterance(
          latestAnswer.replace(/[#*_`>\[\]()]/g, '') // Strip markdown
        );
        utterance.lang = 'en-US';
        utterance.onstart = () => setIsPlaying(true);
        utterance.onend = () => setIsPlaying(false);
        utterance.onerror = () => setIsPlaying(false);
        window.speechSynthesis.speak(utterance);
      }
    }
  }, [isMuted, audioUrl, history]);

  // Load saved mute preference on mount
  useEffect(() => {
    (async () => {
      try {
        const saved = await AsyncStorage.getItem('isSpeakerMuted');
        if (saved !== null) {
          setIsMuted(JSON.parse(saved));
        }
      } catch (_) { /* ignore parse errors */ }
    })();
  }, []);

  //  const waitUntilVoiceFinished = async (timeoutMs = 10000) => {
  //   if (hasPlayed || isMuted || !isPlaying) return;

  //   const start = Date.now();
  //   while (!hasPlayed && isPlaying && (Date.now() - start < timeoutMs)) {
  //     await new Promise((res) => setTimeout(res, 200));
  //   }
  // };
  // const waitUntilMinimumTimeAndVoiceReady = async (minWaitMs = 15000) => {
  //   const start = Date.now();

  //   // Keep checking voice playback status
  //   while (!hasPlayed && isPlaying && !isMuted) {
  //     await new Promise((res) => setTimeout(res, 200));
  //   }

  //   // Ensure at least 15 seconds passed
  //   const elapsed = Date.now() - start;
  //   if (elapsed < minWaitMs) {
  //     const remaining = minWaitMs - elapsed;
  //     console.log(`🕒 Waiting extra ${remaining}ms to reach minimum delay`);
  //     await new Promise((res) => setTimeout(res, remaining));
  //   }
  // };

  const isMutedRef = useRef(isMuted);
  const isPlayingRef = useRef(isPlaying);
  const hasPlayedRef = useRef(hasPlayed);
  useEffect(() => {
    isMutedRef.current = isMuted;
    isPlayingRef.current = isPlaying;
    hasPlayedRef.current = hasPlayed;
  }, [isMuted, isPlaying, hasPlayed]);

  // const waitUntilMinimumTimeAndVoiceReady = async (minWaitMs = 15000) => {
  //   const start = Date.now();

  //   while (true) {
  //     const elapsed = Date.now() - start;

  //     const voiceDone =
  //       isMutedRef.current ||
  //       hasPlayedRef.current ||
  //       !isPlayingRef.current;
  //     const timerDone = elapsed >= minWaitMs;

  //     console.log(`⏳ voiceDone=${voiceDone}, timerDone=${timerDone}, elapsed=${elapsed}`);

  //     if (voiceDone && timerDone) {
  //       break;
  //     }

  //     await new Promise((res) => setTimeout(res, 200));
  //   }
  // };
  const waitUntilMinimumTimeAndVoiceReady = async (minWaitMs = 15000, maxWaitMs = 60000) => {
    const start = Date.now();

    while (true) {
      const elapsed = Date.now() - start;

      const voiceDone =
        isMutedRef.current ||
        hasPlayedRef.current ||
        !isPlayingRef.current;
      const timerDone = elapsed >= minWaitMs;
      const timeoutExceeded = elapsed >= maxWaitMs;

      // console.log(`⏳ voiceDone=${voiceDone}, timerDone=${timerDone}, elapsed=${elapsed}`);

      if ((voiceDone && timerDone) || timeoutExceeded) {
        if (timeoutExceeded) {
          console.warn("⏰ Max wait time exceeded. Exiting wait loop.");
        }
        break;
      }

      await new Promise((res) => setTimeout(res, 200));
    }
  };


  // useEffect(() => {
  //   const handleUnityMessages = async (event) => {
  //     if (event.data?.type === "WEBGL_READY") {
  //       console.log("✅ Received WEBGL_READY");

  //       setIsWebGLReady(true);

  //       if (autoWalkthroughMode && walkthroughStep === "pwo") {
  //         console.log("⏳ Waiting for voice to finish before follow-up ask...");
  //         // await waitUntilVoiceFinished();
  //         await waitUntilMinimumTimeAndVoiceReady();
  //         console.log("🤖 [WEBGL_READY] Triggering follow-up ask...");
  //         handleAsk(t("Explain the concepts shown here."), { skipReferences: true });
  //       }

  //     }
  //   };

  //   window.addEventListener("message", handleUnityMessages);
  //   return () => window.removeEventListener("message", handleUnityMessages);
  // }, [autoWalkthroughMode, walkthroughStep, hasPlayed, isPlaying]);
  useEffect(() => {
    const handleWebGLReadyForAI = async (event) => {
      if (event.data?.type === "WEBGL_READY_FOR_AI") {
        console.log("✅ [AI Listener] Received WEBGL_READY_FOR_AI");

        if (autoWalkthroughMode && walkthroughStep === "pwo") {
          console.log("⏳ Waiting for voice to finish before follow-up ask...");
          await waitUntilMinimumTimeAndVoiceReady();
          console.log("🤖 [WEBGL_READY_FOR_AI] Triggering follow-up ask...");
          // handleAsk(t("Explain the concepts shown here."), { skipReferences: true });
          askFromAnywhere(t("Explain the concepts shown here."), { skipReferences: true }); // 10/5/2025
        }
      }
    };

    window.addEventListener("message", handleWebGLReadyForAI);
    return () => window.removeEventListener("message", handleWebGLReadyForAI);
  }, [autoWalkthroughMode, walkthroughStep, hasPlayed, isPlaying]);


  // BDD new after refactoring the code to speed up voice and text answer and do pwo,video reference separately and in parallel
  // const handleAsk = async (customQuestion) => {
  // BDD 11/10/2025 - adding mode to restrict ask_ai to only open collection as an option
  // const handleAsk = async (customQuestion = "", options = {}) => {
  //   // const { skipReferences = false, debugPromptMode = false, customInstructions = null, answer_length, } = options;

  //   // BDD 01/15/2026 - Summarize this topic AI ask
  //   const {
  //     skipReferences = false,
  //     debugPromptMode = false,
  //     customInstructions = null,
  //     answer_length,

  //     // ✅ NEW (only used when passed) BDD 01/15/2026 - Summarize this topic AI ask
  //     topicScope = null,
  //     forceNewDialog = false,
  //   } = options;

  //   const module = activeModuleRef.current;
  //   const pwoid_current = currentPwoIdRef.current;
  //   const pwoscene_current = currentPwoSceneRef.current;
  //   const isClub = !!(flags && flags.club_mode); // BDD 10/5/2025

  //   // BDD 10/17/2025
  //   // ⬇️ Add this normalization right after the line above
  //   const customInstructionsStr =
  //     customInstructions == null
  //       ? null
  //       : (typeof customInstructions === "string"
  //         ? customInstructions
  //         : JSON.stringify(customInstructions));

  //   console.log("ΓÜí handleAsk triggered with custom question:", customQuestion);
  //   console.log("ΓÜí handleAsk triggered with option skipReferences:", skipReferences);
  //   console.log("ΓÜí handleAsk includeRefs:", (includeReference || autoFetchReferences));
  //   console.log("ΓÜí handleAsk triggered with option pwoscene_current:", pwoscene_current);
  //   console.log("ΓÜí handleAsk triggered with option pwoid_current:", pwoid_current);
  //   console.log("ΓÜí handleAsk triggered with option debugPromptMode:", debugPromptMode);
  //   console.log("ΓÜí handleAsk triggered with option customInstructions:", customInstructions);
  //   // 👇 ensure the sidebar switches to Chat immediately // BDD 10/1/2025
  //   setActiveSidebarTab('history');


  //   // console.log("ΓÜí handleAsk triggered with inputValue:", inputValue);

  //   // console.log("ΓÜí handleAsk triggered with question:", question);

  //   handleClick();
  //   // BDD 11/18/2025 - engagement logs related
  //   trackAiQuestion();

  //   if (showQuiz && quizMode === "test") {
  //     // Temporarily disable tab detection while confirming
  //     tabSwitchDetectionEnabledRef.current = false;

  //     const canClose = await handleCloseModule(true);

  //     if (!canClose) {
  //       console.log("🛑 Ask cancelled, NOT proceeding.");
  //       // Re-enable blur after a longer buffer
  //       setTimeout(() => {
  //         tabSwitchDetectionEnabledRef.current = true;
  //       }, 2000);
  //       return;
  //     }

  //     // Only re-enable if confirmed
  //     tabSwitchDetectionEnabledRef.current = true;
  //   }

  //   // BDD 6/23/2022 - useing debugPromptMode for Da Vinci - not for development of promot
  //   // const finalQuestion = debugPromptMode ? customQuestion : (customQuestion || inputValue);
  //   // const finalQuestion = customQuestion || inputValue;

  //   // BDD 01/15/2026 - Summarize this topic AI ask
  //   const finalQuestionDisplay = customQuestion || inputValue;

  //   let finalQuestionToSend = finalQuestionDisplay;
  //   const scopedTopicName = (topicScope?.topic_name || "").trim();

  //   if (scopedTopicName) {
  //     if (/this topic/i.test(finalQuestionToSend)) {
  //       finalQuestionToSend = finalQuestionToSend.replace(
  //         /this topic/gi,
  //         `the topic "${scopedTopicName}"`
  //       );
  //     } else {
  //       finalQuestionToSend = `${finalQuestionToSend} (Topic: "${scopedTopicName}")`;
  //     }
  //   }

  //   console.log("ΓÜí handleAsk finalQuestionToSend:", finalQuestionToSend);
  //   console.log("ΓÜí handleAsk finalQuestionDisplay:", finalQuestionDisplay);


  //   if (!finalQuestionDisplay.trim()) {
  //     console.log("No question provided, returning...");
  //     return;
  //   }

  //   setLoading(true);
  //   stopAudio();  // Γ£à Stop any previous AI speech
  //   // Append the user's question to the conversation
  //   let updatedConversation = [...conversation, { finalQuestionToSend }];
  //   setConversation(updatedConversation);
  //   // BDD 10/8/2025
  //   // right after you have finalQuestion
  //   lastAskedRef.current = finalQuestionToSend;
  //   // BDD 10/8/2025
  //   // lastTopicSourceIdRef.current =
  //   //   activeTopic?.source_id ??
  //   //   activeTopic?.source_topic_id ??
  //   //   collectionResolved?.items?.[0]?.source_topic_id ??
  //   //   collectionResolved?.items?.[0]?.topic_snapshot?.source_topic_id ??
  //   //   null;

  //   // BDD 01/15/2026 - Summarize this topic AI ask
  //   lastTopicSourceIdRef.current =
  //     topicScope?.source_topic_id ??
  //     activeTopic?.source_id ??
  //     activeTopic?.source_topic_id ??
  //     collectionResolved?.items?.[0]?.source_topic_id ??
  //     collectionResolved?.items?.[0]?.topic_snapshot?.source_topic_id ??
  //     null;

  //   // === TRIVIA START (show while waiting) === BDD 10/14/2025
  //   if (showTriviaWhenWaiting) {
  //     const topicIdForTrivia =
  //       lastTopicSourceIdRef.current ||
  //       (module && (module.source_topic_id || module?.topic?.source_topic_id)) ||
  //       null;

  //     setTriviaItem(pickNextTrivia(topicIdForTrivia));
  //     setIsAsking(true);
  //   }
  //   // === TRIVIA START END ===

  //   // BDD 11/10/2025 - start 
  //   const wantCollectionsView = !curriculumView;
  //   const canShowCollection = Boolean(activeStudyCollection && collectionResolved);
  //   const inCollectionMode = (viewMode === "collections") && canShowCollection;

  //   // const inCollectionMode =
  //   //   activeSidebarTab === "collections" ||
  //   //   (activeModule === "learning" && wantCollectionsView && canShowCollection);

  //   const activeCollectionId =
  //     inCollectionMode && activeStudyCollection?.id
  //       ? activeStudyCollection.id
  //       : null;

  //   // content_db must match backend CONTENT_DB_URLS keys: "cbse", "anatomy", "saras", etc.
  //   const activeContentDb =
  //     inCollectionMode && activeStudyCollection?.base_board
  //       ? activeStudyCollection.base_board
  //       : null;

  //   console.log("[ASK] collection wiring", {
  //     inCollectionMode,
  //     activeCollectionId,
  //     activeContentDb,
  //     activeStudyCollection,
  //   });
  //   // BDD 11/10/2025 - end 
  //   // BDD 11/11/2025
  //   // Mode A: inside collection -> strict RAG only
  //   // Mode B: curriculum / board view -> medium (no forced RAG lock)
  //   const effectiveRestrictToRagOnly = !!activeCollectionId; // true only in Mode A

  //   // For now: always ask backend to include references;
  //   // visibility is handled in UI and by fetch_references.
  //   const effectiveIncludeReferences = true;

  //   try {
  //     // combine manual “Include References” with auto‑fetch flag (OR so we default to true)
  //     const includeRefs = includeReference || autoFetchReferences;

  //     // BDD 01/15/2026 - Summarize this topic AI ask
  //     const topicKey = topicScope
  //       ? `topic:${topicScope.source_topic_id || topicScope.board_topic_id || topicScope.topicId || ""}`
  //       : null;
  //     // BDD 01/15/2026 - Summarize this topic AI ask
  //     const topicChanged =
  //       !!topicKey && lastTopicScopeKeyRef.current !== topicKey;
  //     // BDD 01/15/2026 - Summarize this topic AI ask
  //     if (topicKey && topicChanged) {
  //       lastTopicScopeKeyRef.current = topicKey;
  //     }
  //     // BDD 01/15/2026 - Summarize this topic AI ask
  //     const effectiveNewDialog =
  //       isNewDialog || (forceNewDialog && topicChanged);
  //     console.log("HandleAsk: topicKey, topicChanged, effectiveNewDialog", topicKey, topicChanged, effectiveNewDialog)
  //     // Γ£à Set up request payload

  //     const client_session_id = await AsyncStorage.getItem("client_session_id");

  //     let requestData = {
  //       user_id: user_id, // "bipin.dama@saras-3d.com",
  //       // question: finalQuestion,
  //       // new_dialog: isNewDialog,
  //       question: finalQuestionToSend,             // ✅ send scoped text // BDD 01/15/2026 - Summarize this topic AI ask
  //       new_dialog: effectiveNewDialog,            // ✅ avoid “previous topic” // BDD 01/15/2026 - Summarize this topic AI ask
  //       context: {},
  //       include_references: includeRefs, // Γ£à Use the button state
  //       debugPromptMode: debugPromptMode, // ✅ NEW!
  //       custom_instructions: customInstructionsStr, // ✅ 10/17/2025
  //       is_speaker_muted: isMuted, // BDD 8/30/2025 - turn off tts if isMuted is true to speed up AI response
  //       // restrict_to_rag_only: effectiveRestrictToRagOnly,  // BDD 11/11/2025 - NEW BDD 9/5/2025
  //       restrict_to_rag_only: (effectiveRestrictToRagOnly || !!scopedTopicName), // ✅ only tightened for topic-suggestions // BDD 01/15/2026 - Summarize this topic AI ask
  //       skip_translate_for_ref: shouldSkipTranslateForRef(), // BDD 02/08/2026 - derive skip_translate_for_ref from language selection
  //       client_session_id: client_session_id || null
  //     };
  //     // BDD 11/10/2025 🔹 Only add if provided; does NOT break old callers
  //     if (answer_length) {
  //       requestData.answer_length = answer_length;
  //     }

  //     console.log("📚 restrict_to_rag_only:", effectiveRestrictToRagOnly);
  //     console.log("📚 skip_translate_for_ref (derived):", shouldSkipTranslateForRef(), "lang=", selectedSecondaryLang);
  //     // BDD 11/11/2025 - Attach collection scope ONLY in Mode A
  //     if (inCollectionMode && activeCollectionId && activeContentDb) {
  //       requestData.collection_id = activeCollectionId;
  //       requestData.content_db = activeContentDb;
  //       console.log("[ASK] Mode A: collection scope attached", {
  //         collection_id: activeCollectionId,
  //         content_db: activeContentDb,
  //       });
  //     } else {
  //       console.log("[ASK] Mode B: curriculum/global scope (no collection_id)");
  //     }

  //     // BDD 11/10/2025 - end

  //     // console.log("ΓÜí handleAsk triggered with activeModule:", activeModule);
  //     // console.log("ΓÜí handleAsk triggered with module:", module);

  //     // setActiveModule('pwo'); // once we have image capture part implemented
  //     // console.log("ΓÜí BDD TEMP CAUTION DEBUG handleAsk forced to activeModule:", activeModule);

  //     // Γ£à Check active module and include relevant details
  //     if (module === "video") {
  //       requestData.context.type = "video";
  //       requestData.context.videoId = currentVideoId;
  //       requestData.context.videotagId = currentVideoTagID;
  //       requestData.context.videotimestamp = getCurrentVideoTime();
  //       requestData.context.videoDurationSeconds = videoDuration;
  //       requestData.context.screenshot = await captureScreenshot(videoRef.current);
  //       // Include chapter/topic IDs for resume state navigation
  //       if (selectedChapterId != null) {
  //         requestData.context.chapterId = selectedChapterId;
  //       } else if (activeTopic) {
  //         const parts = String(activeTopic).split('-');
  //         if (parts.length >= 1 && parts[0]) requestData.context.chapterId = parseInt(parts[0], 10) || null;
  //       }
  //       setIncludeReference(false); // we do not include reference for non-question querries
  //       lastContextType.current = "video";  // Update last context

  //     }
  //     else if (module === "pwo") {
  //       requestData.context.type = "pwo";
  //       requestData.context.pwoId = pwoid_current;
  //       console.log("handleAsk pwo module pwoID.", pwoid_current);

  //       try {

  //         let result = null;
  //         if (!isWebGLReadyRef.current) {
  //           console.warn("❌ Tried to take screenshot before WEBGL_READY");
  //         } else {
  //           result = await requestUnityScreenshot();  // ✅ reuses the outer `result`
  //           console.log("✅ Unity screenshot result:", result);
  //         }

  //         if (result?.imagebytes) {
  //           const base64imagefromUnity = `data:image/png;base64,${result.imagebytes}`;
  //           requestData.context.screenshot = base64imagefromUnity; // now it is base64 image
  //           console.log("screenshot in Unity response.", base64imagefromUnity.slice(0, 100));
  //         } else {
  //           // requestData.context.screenshot = null;
  //           console.warn("❌ Screenshot or scene name missing in Unity response. Proceeding with fake screenshot");
  //         }

  //         if (result?.scenename) {
  //           requestData.context.pwoScene = result.scenename;
  //           console.log("scenename in Unity response.", result.scenename);
  //         } else {
  //           requestData.context.pwoScene = pwoscene_current;
  //           console.warn("❌ Scene name missing in Unity response. Proceeding with last scenename clicked", pwoscene_current);
  //         }

  //       } catch (error) {
  //         console.error("❌ Failed to get screenshot from Unity:", error);
  //       }

  //       // Include chapter ID for resume state navigation
  //       if (selectedChapterId != null) {
  //         requestData.context.chapterId = selectedChapterId;
  //       } else if (activeTopic) {
  //         const parts = String(activeTopic).split('-');
  //         if (parts.length >= 1 && parts[0]) requestData.context.chapterId = parseInt(parts[0], 10) || null;
  //       }
  //       setIncludeReference(false);
  //       lastContextType.current = "pwo";
  //     }
  //     else if (module === "whiteboard" && uploadedFile) {
  //       requestData.context.type = "whiteboard";
  //       requestData.context.file_name = uploadedFile.name;
  //       requestData.context.screenshot = uploadedFile.content;
  //       setIncludeReference(false); // we do not include reference for non-question querries
  //       lastContextType.current = "whiteboard";  // Update last context

  //     }
  //     else if (module === "uploaded" && uploadedFile) {
  //       requestData.context.type = "uploaded_file";
  //       requestData.context.file_name = uploadedFile.name;

  //       if (uploadedFile.content.startsWith("data:image")) {
  //         requestData.context.screenshot = uploadedFile.content;
  //         requestData.context.file_content = null;
  //       } else {
  //         requestData.context.file_content = uploadedFile.content;
  //         requestData.context.screenshot = null;
  //       }
  //       setIncludeReference(false); // we do not include reference for non-question querries
  //       lastContextType.current = "uploaded";  // Update last context

  //     }
  //     else {
  //       requestData.context.type = "question";

  //       // BDD 01/15/2026 - Summarize this topic AI ask
  //       if (scopedTopicName || topicScope?.board_topic_id || topicScope?.source_topic_id) {
  //         requestData.context.topic = {
  //           board_topic_id: topicScope?.board_topic_id ?? null,
  //           source_topic_id: topicScope?.source_topic_id ?? null,
  //           topic_name: topicScope?.topic_name ?? null,
  //           chapter_name: topicScope?.chapter_name ?? null,
  //           chapter_id: topicScope?.chapterId ?? null,
  //         };
  //         // BDD 01/15/2026 - Summarize this topic AI ask
  //         // Optional safety net (only if caller didn't pass customInstructions)
  //         if (!requestData.custom_instructions && scopedTopicName) {
  //           requestData.custom_instructions =
  //             `Answer ONLY using Saras-3D content for the topic "${scopedTopicName}". Ignore earlier topics.`;
  //         }
  //       }

  //       // 🔁 Logic to set includeReference
  //       if (lastContextType.current !== "question") {
  //         setIncludeReference(true);  // This is the first "question" after something else
  //         console.log("setIncludeReference is  being set true:", includeReference);
  //         console.log("lastContextType.current is:", lastContextType.current);
  //       } else {
  //         setIncludeReference(false); // Previous was also a question
  //         console.log("setIncludeReference is  being set false:", includeReference);
  //         console.log("lastContextType.current is:", lastContextType.current);
  //       }

  //       lastContextType.current = "question";  // Update last context
  //       console.log("lastContextType.current is being reset to question:", lastContextType.current);

  //     }

  //     // console.log("≡ƒöä Sending request to", API_URL_ASK, "with payload:", requestData);
  //     // console.log(
  //     //   `≡ƒöä Sending request to ${API_URL_ASK} with payload:\n`,
  //     //   JSON.stringify(requestData, null, 2)
  //     // );
  //     // BDD 10/5/2025
  //     // --- replace your current `if (includeRefs && !skipReferences) { ... }` with:
  //     const shouldFetchRefs =
  //       // In Club mode: only fetch refs if user explicitly wants them
  //       (isClub ? autoFetchReferences : true)
  //       && includeRefs
  //       && !skipReferences;

  //     console.log("[refs gate]", {
  //       isClub,
  //       autoFetchReferences,
  //       includeRefs,
  //       skipReferences,
  //       shouldFetchRefs,
  //     });

  //     // Γ£à Call API for AI response (without references blocking it)
  //     // const response = await axios.post(API_URL_ASK, requestData);
  //     // BDD 10/14/2025  call fast_ask for investor_mode demo
  //     const url = investorMode ? API_URL_FAST_ASK : API_URL_ASK;
  //     const response = await axios.post(url, requestData);

  //     let responseData = Array.isArray(response.data) && response.data.length > 0 ? response.data[0] : response.data;

  //     if (typeof responseData === "string") {
  //       responseData = JSON.parse(responseData);
  //     }

  //     // ✅ if backend returns conversation_id, select that session
  //     const convoId = responseData?.conversation_id ?? null;
  //     if (convoId != null) {
  //       setSelectedConversationId(convoId);
  //       // keep sessions list updated (so most recent rises to top)
  //       fetchChatSessions(10);
  //     }

  //     // Γ£à Store the AI response
  //     if (responseData["Formatted AI response"]) {
  //       setAnswer(responseData["Formatted AI response"] || "No response from AI.");
  //     }

  //     setDocuments(responseData["Description"] || []);
  //     setVideos(responseData["Video"] || []);
  //     setPwos(responseData["PWO"] || []);

  //     setIsNewDialog(false);
  //     setInputValue("");
  //     window.AndroidBridge?.notifyProcessingDone?.();// for ChatOverlay side Leia Unity PWO

  //     // ************************************************************ BEGIN AI question suggestion related
  //     // answer is global variable set by setAnswer -- const answer = "This is the AI answer."; // Replace with the actual answer from your API
  //     updatedConversation = [...updatedConversation, { answer }]; // BDD CAUTION NOTE - I could use History and other things here for future enhancements
  //     setConversation(updatedConversation);

  //     // Get the last few exchanges (e.g., last 5)
  //     const limitedContext = getLimitedConversation(5) || [];

  //     // Build context for the API call
  //     const context = {
  //       user_id: user_id,
  //       subject: "currentSubject",
  //       chapter: "currentChapter",
  //       topic: "currentTopic",
  //       collection_id: activeStudyCollection?.id ?? null,
  //       collection_name: activeStudyCollection?.name ?? "",
  //       collection_info: activeStudyCollection?.info ?? "",   // <- once you add it to the API
  //       // current_view: module || "question",
  //       current_view: viewMode === "collections" ? "collection" : (module || "question"),
  //       instructions: "currentInstructions",
  //       // Optionally, include the limited conversation context as a string (if your API expects it)
  //       conversation: limitedContext,
  //       // You might also include the most recent Q/A if needed:
  //       current_question: finalQuestionToSend,
  //       current_answer: responseData["Formatted AI response"] || "No response from AI.",
  //     };

  //     // BDD 02/10/2026 - suggested questions improvement
  //     // // console.log("context for suggestions:", context)
  //     // // Fetch suggested questions
  //     // const suggestions = await fetchSuggestedQuestions(context);
  //     // // console.log("suggestions:", suggestions)
  //     // setSuggestedQuestions(suggestions);
  //     // setSuggestedQuestionsHeader([t("Deepen your understanding:")]);
  //     // // BDD 01/15/2026 - Summarize this topic AI ask
  //     // setSuggestedQuestionsMeta({ kind: "chat", topicScope: null });

  //     // BDD 02/10/2026 - suggested questions improvement
  //     // Fetch suggested questions (Deepen) + prepend basic follow-ups
  //     const BASIC_FOLLOWUPS = [
  //       t("I didn’t understand — explain more simply."),
  //       t("Can you explain step-by-step with an example?"),
  //     ];
  //     // BDD 02/10/2026 - suggested questions improvement
  //     // Normalize AI output (remove intros, numbering, bullets, etc.)
  //     function normalizeSuggestedQuestions(list) {
  //       if (!Array.isArray(list)) return [];

  //       return list
  //         .map((q) => (typeof q === "string" ? q.trim() : ""))
  //         .filter(Boolean)
  //         // Drop common non-question “intro” lines
  //         .filter((q) => {
  //           const s = q.toLowerCase();
  //           if (s.startsWith("sure!") || s.startsWith("sure,")) return false;
  //           if (s.includes("here are") && s.includes("questions")) return false;
  //           if (s.includes("insightful questions")) return false;
  //           if (s.includes("you could ask next")) return false;
  //           return true;
  //         })
  //         // Strip bullets and numbering: "- ...", "1. ...", "2) ..."
  //         .map((q) =>
  //           q
  //             .replace(/^\s*[-•]\s*/g, "")
  //             .replace(/^\s*\d+[\).\]]\s*/g, "")
  //             .trim()
  //         )
  //         .filter(Boolean);
  //     }

  //     // BDD 02/10/2026 - suggested questions improvement
  //     function mergeUniqueQuestions(primary, secondary, maxCount = 4) {
  //       const seen = new Set();
  //       const out = [];

  //       const push = (q) => {
  //         const s = (q || "").trim();
  //         if (!s) return;
  //         const key = s.toLowerCase();
  //         if (seen.has(key)) return;
  //         seen.add(key);
  //         out.push(s);
  //       };

  //       (primary || []).forEach(push);
  //       (secondary || []).forEach(push);

  //       return out.slice(0, maxCount);
  //     }
  //     // BDD 02/10/2026 - suggested questions improvement
  //     const suggestionsRaw = await fetchSuggestedQuestions(context);
  //     const suggestionsClean = normalizeSuggestedQuestions(suggestionsRaw);

  //     // 2 basics + up to 2 deepen = 4 total
  //     const mergedSuggestions = mergeUniqueQuestions(BASIC_FOLLOWUPS, suggestionsClean, 4);

      
  //     console.log("[BDD0210][SUGG] raw=", suggestionsRaw);
  //     console.log("[BDD0210][SUGG] clean=", suggestionsClean);
  //     console.log("[BDD0210][SUGG] merged=", mergedSuggestions, "len=", mergedSuggestions.length);

  //     // BDD 02/10/2026 - suggested questions improvement
  //     setSuggestedQuestions(mergedSuggestions);
  //     setSuggestedQuestionsHeader([t("Deepen your understanding:")]);
  //     // BDD 02/10/2026 - suggested questions improvement
  //     setSuggestedQuestionsMeta({ kind: "chat", topicScope: null });

  //     // ************************************************************ END AI question suggestion related

  //     if (responseData["Audio"]) {
  //       const fixedAudioUrl = responseData["Audio"].replace(/\\/g, "/");
  //       setAudioUrl(fixedAudioUrl);
  //     } else {
  //       // console.warn("ΓÜá∩╕Å No audio received from API");
  //     }

  //     setHistory((prev) => {
  //       const newEntry = {
  //         question: finalQuestionDisplay,
  //         answer: responseData["Formatted AI response"],
  //         videos: responseData["Video"],
  //         documents: responseData["Description"],
  //         pwos: responseData["PWO"],
  //         quiz: responseData["Quiz"],
  //         chapters: responseData["Chapter"] || responseData["Chapters"] || [],
  //         collections: responseData["Collection"] || responseData["Collections"] || [],
  //         guideMeActions: responseData["GuideMeActions"] || [],

  //         // BDD 02/12/2026 -- updates to: BDD 02/08/2026 Stale turn_id issue for fetchreference
  //         student_message_id: responseData?.student_message_id ?? responseData?.assistant_turn_id ?? null,
  //         assistant_turn_id: responseData?.assistant_turn_id ?? null,
  //         conversation_id: responseData?.conversation_id ?? null,
  //         content_db: responseData?.content_db ?? null,
  //         collection_id: responseData?.collection_id ?? null,

  //         is_current_content_db: true,
  //       };

  //       // ✅ Important: if the conversation changed (or we were on sessions list),
  //       // don't carry over turns from another conversation into this view
  //       const convoId = newEntry.conversation_id;
  //       const sameConvo =
  //         convoId != null &&
  //         selectedConversationId != null &&
  //         String(convoId) === String(selectedConversationId);

  //       const base = sameConvo ? (prev || []) : [];



  //       return [newEntry, ...base];
  //     });

  //     if (shouldFetchRefs) {
  //       // console.log("📥 includeRefs and skipReferences...", includeRefs, skipReferences);
  //       console.log("📥 shouldFetchRefs...", shouldFetchRefs);

  //       let reEnableAuto = false;
  //       if (
  //         !autoWalkthroughMode &&
  //         module === "learning" &&
  //         autoFetchReferences &&
  //         autoOpenPWO &&
  //         autoPlayVideo
  //       ) {
  //         console.log("🔁 Re-enabling autoWalkthroughMode on fresh Ask");
  //         setAutoWalkthroughMode(true);
  //         reEnableAuto = true; // BDD to take care of React async state update issue

  //       }

  //       console.log("📥 Calling fetchReferences...");
  //       // const { videos, pwos, quiz } = await fetchReferences();
  //       // BDD 01/08/2026 enhance-fetch-reference
  //       // const { videos, pwos, quiz, chapters, collections } = await fetchReferences();

  //       // BDD 02/12/2026 -- updates to: BDD 02/08/2026 Stale turn_id issue for fetchreference
  //       const anchor = {
  //         student_message_id: responseData?.student_message_id ?? responseData?.assistant_turn_id ?? null,
  //         conversation_id: responseData?.conversation_id ?? selectedConversationId ?? null,
  //         collection_id: responseData?.collection_id ?? activeStudyCollection?.id ?? null,
  //         content_db: responseData?.content_db ?? null,
  //       };
  //       // BDD 02/12/2026 -- updates to: BDD 02/08/2026 Stale turn_id issue for fetchreference
  //       const { videos, pwos, quiz, chapters, collections } = await fetchReferences(anchor);

  //       console.log("🚀 autoWalkthroughMode", autoWalkthroughMode);
  //       console.log("🚀 reEnableAuto", reEnableAuto);
  //       console.log("🎥 Current chapters:", chapters);
  //       console.log("🎥 Current collections:", collections);

  //       if (autoWalkthroughMode || reEnableAuto) {
  //         console.log("🚀 Auto walkthrough mode triggered");
  //         console.log("🧪 Current pwos:", pwos);
  //         console.log("🎥 Current videos:", videos);
  //         console.log("🎥 Current quiz:", quiz);
  //         console.log("🎥 Current chapters:", chapters);
  //         console.log("🎥 Current collections:", collections);

  //         // Wait a moment to ensure state updates
  //         setTimeout(() => {
  //           runAutoWalkthrough(responseData["Formatted AI response"], {
  //             pwo: pwos,
  //             video: videos,
  //             quiz: quiz
  //           }, true); // 🔁 forceRun = true ensures this triggers now
  //         }, 200); // short delay to allow pwos/videos to be up to date
  //       }
  //     } else {
  //       console.log("⏭️ Skipping references (gate blocked).");
  //     }


  //   } catch (error) {
  //     console.error("API Error:", error);
  //     setAnswer("Error fetching response from AI.");
  //   } finally {
  //     // === TRIVIA STOP (hide when answer arrives or on error) === BDD 10/14/2025
  //     setIsAsking(false);
  //     setTriviaItem(null);
  //     // === TRIVIA STOP END ===

  //     setLoading(false);
  //     setQuestion("");

  //     // Γ£à Reset includeReference back to false after use
  //     setIncludeReference(false);
  //   }
  // };

  
    // BDD new after refactoring the code to speed up voice and text answer and do pwo,video reference separately and in parallel
  // const handleAsk = async (customQuestion) => {
  // BDD 11/10/2025 - adding mode to restrict ask_ai to only open collection as an option
  // BDD 02/21/2026 HomeWorkHelpMVP

      const handleAsk = async (customQuestion = "", options = {}) => {
        // const { skipReferences = false, debugPromptMode = false, customInstructions = null, answer_length, } = options;

        // BDD 01/15/2026 - Summarize this topic AI ask
        const {
          skipReferences = false,
          debugPromptMode = false,
          customInstructions = null,
          answer_length,

          // ✅ NEW (only used when passed) BDD 01/15/2026 - Summarize this topic AI ask
          topicScope = null,
          forceNewDialog = false,

          // BDD 04/14/2026 - hidden follow-up metadata
          followupKind = null,
          previousAnswerText = "",
          previousQuestionText = "",

          // BDD 08/30/2026 - completed official-exam review with rendered screenshot
          examReviewContext = null,
          // Self-guided media uses Journey Swan UI/browser speech, not AI Tutor TTS.
          swanMediaAsk = false,
          swanMediaAssetKey = null,
          swanMediaGuardBlockId = null,

        // Learning Journey context // BDD 07/28/2026
        journeyContext = null,

        } = options;
        const isJourneyAsk = !!journeyContext;
        const isExamReviewAsk = !!examReviewContext;

        // Da Vinci challenge: log this AI question as a collection-scoped
        // engagement so "Ask Saras AI" counts toward the challenge gate %.
        // Fire-and-forget; only for enrolled challenge users inside a collection.
        try {
          if (isDavinciUser && challengeState?.enrolled && activeStudyCollection?.id) {
            const dvCid = activeStudyCollection.id;
            const dvQ = String(customQuestion || "").slice(0, 500) || "AI question";
            fetchWithAuth(
              `${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/collection-prompt-engagement`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  collection_id: dvCid,
                  context_kind: "ai_question",
                  prompt_text: dvQ,
                }),
              }
            )
              .then(() => {
                try { syncChallenge(dvCid); } catch (_e) { /* best effort */ }
              })
              .catch(() => {});
          }
        } catch (_e) { /* never block the ask */ }

        const module = activeModuleRef.current;
        const pwoid_current = currentPwoIdRef.current;
        const pwoscene_current = currentPwoSceneRef.current;
        const isClub = !!(flags && flags.club_mode); // BDD 10/5/2025
        const isAiStreamEnabled = !!(flags && flags.ai_stream); // BDD 04/12/2026 - stream through /api/ask_ai itself

        // BDD 04/16/2026 - local llm / museum latency experiment
        const aiMode = (flags && flags.ai_mode) || "cloud_realtime";
        const isCloudRealtimeMode = aiMode === "cloud_realtime";
        const isLocalNvidiaMode = aiMode === "local_nvidia";

        const isAiLatencyOverlayEnabled = !!(flags && flags.ai_latency_overlay);
        const isAiLocalVoiceEnabled = !!(flags && flags.ai_local_voice);
        const isAiLocalTtsEnabled = !!(flags && flags.ai_local_tts);
        const isAiLocalAsrEnabled = !!(flags && flags.ai_local_asr);
        const isAiLocalActionsEnabled = !!(flags && flags.ai_local_actions);

        // Homework Help should only affect the "question" context (not video/pwo/whiteboard/uploaded)
        const homeworkEnabled = !!homeworkHelpEnabledRef.current;
        const isQuestionContext =
          !["video", "pwo", "whiteboard", "uploaded"].includes(String(module || "").toLowerCase());
        // Exam review is its own visual context and must never inherit Homework Help instructions.
        const homeworkEnabledForThisAsk =
          homeworkEnabled && isQuestionContext && !isExamReviewAsk;

        // BDD 10/17/2025
        // ⬇️ Add this normalization right after the line above
        const customInstructionsStr =
          customInstructions == null
            ? null
            : (typeof customInstructions === "string"
              ? customInstructions
              : JSON.stringify(customInstructions));

        // If no explicit customInstructions, Homework mode supplies a JSON custom_instructions (question-only)
        // BDD 07/28/2026
        const homeworkCustomInstructionsStr =
          (homeworkEnabledForThisAsk && !customInstructionsStr)
            ? JSON.stringify(buildHomeworkHelpPayload())
            : null;

        const effectiveCustomInstructionsStr =
          customInstructionsStr || homeworkCustomInstructionsStr;

        console.log("🧠 handleAsk triggered with custom question:", customQuestion);
        console.log("🧠 handleAsk triggered with option skipReferences:", skipReferences);
        console.log("🧠 handleAsk includeRefs:", (includeReference || autoFetchReferences));
        console.log("🧠 handleAsk triggered with option pwoscene_current:", pwoscene_current);
        console.log("🧠 handleAsk triggered with option pwoid_current:", pwoid_current);
        console.log("🧠 handleAsk triggered with option debugPromptMode:", debugPromptMode);
        console.log("🧠 handleAsk triggered with option customInstructions:", customInstructions);
        console.log("📘 Homework enabled (global):", homeworkEnabled);
        console.log("📘 Homework enabled (this ask):", homeworkEnabledForThisAsk);

        console.log("[JOURNEY ASK]", {
          hasJourneyContext: !!journeyContext,
          stepId: journeyContext?.step_id || null,
          
          focusItemId:
            journeyContext?.focus_item?.id || null,

          focusItemKind:
            journeyContext?.focus_item?.kind || null,            
          observationCount:
            journeyContext?.student_work?.observations?.length || 0,
          hasTheory:
            !!journeyContext?.student_work?.initial_theory,
        });

        // 👇 ensure the sidebar switches to Chat immediately // BDD 10/1/2025
        setActiveSidebarTab('history');

        // ZA 03/01/2026 - Clear stale suggested questions while new ones are fetched
        setSuggestedQuestions([]);
        setSuggestedQuestionsHeader([]);

        handleClick();
        // BDD 11/18/2025 - engagement logs related
        trackAiQuestion();

        if (showQuiz && quizMode === "test") {
          // Temporarily disable tab detection while confirming
          tabSwitchDetectionEnabledRef.current = false;

          const canClose = await handleCloseModule(true);

          if (!canClose) {
            console.log("🛑 Ask cancelled, NOT proceeding.");
            // Re-enable blur after a longer buffer
            setTimeout(() => {
              tabSwitchDetectionEnabledRef.current = true;
            }, 2000);
            return;
          }

          // Only re-enable if confirmed
          tabSwitchDetectionEnabledRef.current = true;
        }

        // BDD 04/14/2026 - basic_followups need some previous context - start
        const finalQuestionDisplay = customQuestion || inputValue;

        // BDD 04/12/2026 - unique id for this ask so late refs cannot patch a newer ask
        const askRequestId = `ask_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
        currentAskRequestIdRef.current = askRequestId;
          // BDD 04/21/2026 - Thinking... remained on when I clicked quickly one suggsted quetion to next        
        const clearPendingForAskRequestId = (requestId, patch = {}) => {
          setHistory((prev) => {
            const idx = (prev || []).findIndex(e => e?._askRequestId === requestId);
            if (idx < 0) return prev;

            const updated = [...prev];
            updated[idx] = {
              ...updated[idx],
              _isPending: false,
              ...patch,
            };
            return updated;
          });
        };
        // BDD 04/14/2026 - lightweight ask flow debug
        console.log("[ASK FLOW][FE]", {
          askRequestId,
          streamEnabled: isAiStreamEnabled,
          module,
          viewMode,
          contentDb: axios.defaults.headers.common?.["X-Content-DB"] || null,
          questionPreview: String(finalQuestionDisplay || "").slice(0, 80),
        });

        // BDD 04/14/2026 - invalidate stale async side-jobs from older asks
        try { suggestedQuestionsAbortRef.current?.abort(); } catch {}
        try { fetchReferencesAbortRef.current?.abort(); } catch {}

        let finalQuestionToSend = finalQuestionDisplay;
        const scopedTopicName = (topicScope?.topic_name || "").trim();

        // BDD 04/14/2026 - hidden strengthening for generic follow-up prompts
        const prevAnswer = String(previousAnswerText || "").trim();
        if (followupKind === "simplify_previous_answer" && prevAnswer) {
          finalQuestionToSend =
            `Please explain your previous answer more simply.\n\n` +
            `Previous answer:\n${prevAnswer}`;
        } else if (followupKind === "step_by_step_previous_answer" && prevAnswer) {
          finalQuestionToSend =
            `Please explain your previous answer step-by-step with an example.\n\n` +
            `Previous answer:\n${prevAnswer}`;
        }

        // Apply topic wording only when this is not one of the hidden follow-up rewrites
        if (!followupKind && scopedTopicName) {
          if (/this topic/i.test(finalQuestionToSend)) {
            finalQuestionToSend = finalQuestionToSend.replace(
              /this topic/gi,
              `the topic "${scopedTopicName}"`
            );
          } else {
            finalQuestionToSend = `${finalQuestionToSend} (Topic: "${scopedTopicName}")`;
          }
        }

        console.log("🧠 handleAsk finalQuestionToSend:", finalQuestionToSend);
        console.log("🧠 handleAsk finalQuestionDisplay:", finalQuestionDisplay);
        console.log("🧠 handleAsk followupKind:", followupKind);
        // BDD 04/14/2026 - basic_followups need some previous context - end

        if (!finalQuestionDisplay.trim()) {
          console.log("No question provided, returning...");
          return;
        }

        setLoading(true);
        stopAudio();  // 🛑 Stop any previous AI speech

        // Immediately push user's question into history (answer: null = still loading)
        setHistory((prev) => {
          const placeholderEntry = {
            question: finalQuestionDisplay,
            answer: null,
            videos: [],
            documents: [],
            pwos: [],
            quiz: [],
            chapters: [],
            collections: [],
            guideMeActions: [],
            student_message_id: null,
            assistant_turn_id: null,
            conversation_id: null,
            content_db: null,
            collection_id: null,
            is_current_content_db: true,
            _isPending: true,
            _askRequestId: askRequestId,
            _swanMediaAsk: Boolean(swanMediaAsk),
            _swanMediaStepId: journeyContext?.step_id || null,
            _swanMediaAssetKey: swanMediaAssetKey,
            _swanMediaGuardBlockId: swanMediaGuardBlockId,
          };

          // BDD 04/12/2026 - stable row target for streamed refs patching
          pendingHistoryIndexRef.current = null;

          return [placeholderEntry, ...prev];
        });
        // Append the user's question to the conversation
        let updatedConversation = [...conversation, { finalQuestionToSend }];
        setConversation(updatedConversation);

        // BDD 10/8/2025
        lastAskedRef.current = finalQuestionToSend;

        // BDD 01/15/2026 - Summarize this topic AI ask
        lastTopicSourceIdRef.current =
          topicScope?.source_topic_id ??
          activeTopic?.source_id ??
          activeTopic?.source_topic_id ??
          collectionResolved?.items?.[0]?.source_topic_id ??
          collectionResolved?.items?.[0]?.topic_snapshot?.source_topic_id ??
          null;

        // === TRIVIA START (show while waiting) === BDD 10/14/2025
        if (showTriviaWhenWaiting) {
          const topicIdForTrivia =
            lastTopicSourceIdRef.current ||
            (module && (module.source_topic_id || module?.topic?.source_topic_id)) ||
            null;

          setTriviaItem(pickNextTrivia(topicIdForTrivia));
          setIsAsking(true);
        }
        // === TRIVIA START END ===

        // BDD 11/10/2025 - start
        const wantCollectionsView = !curriculumView;
        const canShowCollection = Boolean(activeStudyCollection && collectionResolved);

        const inCollectionMode = // BDD 07/28/2026 Journey
            !isJourneyAsk &&
            viewMode === "collections" &&
            canShowCollection;

        const activeCollectionId =
          inCollectionMode && activeStudyCollection?.id
            ? activeStudyCollection.id
            : null;

        // content_db must match backend CONTENT_DB_URLS keys: "cbse", "anatomy", "saras", etc.
        const activeContentDb =
          inCollectionMode && activeStudyCollection?.base_board
            ? activeStudyCollection.base_board
            : null;

        console.log("[ASK] collection wiring", {
          inCollectionMode,
          activeCollectionId,
          activeContentDb,
          activeStudyCollection,
        });
        // BDD 11/10/2025 - end

        // Mode A: inside collection -> strict RAG only
        const effectiveRestrictToRagOnly = !!activeCollectionId; // true only in Mode A

        // Homework: if scoped (collection/topic), tighten to RAG-only
        const homeworkIsScoped =
          !!activeCollectionId ||
          !!scopedTopicName ||
          !!topicScope?.source_topic_id ||
          !!topicScope?.board_topic_id;

        try {
          // combine manual “Include References” with auto-fetch flag
          // Homework Help should always include references for question context
          // BDD 07/28/2026 - Journey - skip reference
          const includeRefs = isJourneyAsk
            ? false
            : isExamReviewAsk
              ? true
              : homeworkEnabledForThisAsk
                ? true
                : (includeReference || autoFetchReferences);

          // BDD 01/15/2026 - Summarize this topic AI ask
          const topicKey = topicScope
            ? `topic:${topicScope.source_topic_id || topicScope.board_topic_id || topicScope.topicId || ""}`
            : null;

          const topicChanged =
            !!topicKey && lastTopicScopeKeyRef.current !== topicKey;

          if (topicKey && topicChanged) {
            lastTopicScopeKeyRef.current = topicKey;
          }

          const effectiveNewDialog =
            isNewDialog || (forceNewDialog && topicChanged);

          console.log("HandleAsk: topicKey, topicChanged, effectiveNewDialog",
            topicKey, topicChanged, effectiveNewDialog);

          const client_session_id = await AsyncStorage.getItem("client_session_id");

          let requestData = {
            user_id: user_id,
            question: finalQuestionToSend,
            new_dialog: effectiveNewDialog,
            context: {},
            include_references: includeRefs,
            debugPromptMode: debugPromptMode,
            custom_instructions: effectiveCustomInstructionsStr, // explicit caller instructions only (homework added later in question branch)
            journey_context: journeyContext || null,

            // BDD 04/16/2026 - local llm / museum latency experiment
            ai_mode: aiMode,
            ai_local_voice: isAiLocalVoiceEnabled,
            ai_local_tts: isAiLocalTtsEnabled && !swanMediaAsk,
            ai_local_asr: isAiLocalAsrEnabled,
            ai_local_actions: isAiLocalActionsEnabled,

            is_speaker_muted: swanMediaAsk
              ? (!journeySwanReadAloudRef.current || Boolean(journeyContext?.activity_progress?.inquiry_guard?.protect_answer))
              : isMuted,
            restrict_to_rag_only: (
              effectiveRestrictToRagOnly ||
              !!scopedTopicName ||
              (homeworkEnabledForThisAsk && homeworkIsScoped)
            ),
            skip_translate_for_ref: shouldSkipTranslateForRef(),
            client_session_id: client_session_id || null
          };

          if (answer_length) {
            requestData.answer_length = answer_length;
          }

          console.log("📚 restrict_to_rag_only:", requestData.restrict_to_rag_only);
          console.log("📚 skip_translate_for_ref (derived):", shouldSkipTranslateForRef(), "lang=", selectedSecondaryLang);

          console.log("[JOURNEY REQUEST PAYLOAD]", {
            present: !!journeyContext,
            journeyId: journeyContext?.journey_id || null,
            stepId: journeyContext?.step_id || null,
            focusItemId:
              journeyContext?.focus_item?.id || null,

            focusItemKind:
              journeyContext?.focus_item?.kind || null,
            observationCount:
              journeyContext?.student_work?.observations?.length || 0,
            activeActivityType:
              journeyContext?.active_activity?.type || "question",
          });

          // Attach collection scope ONLY in Mode A
          if (inCollectionMode && activeCollectionId && activeContentDb) {
            requestData.collection_id = activeCollectionId;
            requestData.content_db = activeContentDb;
            console.log("[ASK] Mode A: collection scope attached", {
              collection_id: activeCollectionId,
              content_db: activeContentDb,
            });
          } else {
            console.log("[ASK] Mode B: curriculum/global scope (no collection_id)");
          }

          // BDD 04/13/2026 - ensure content_db is present even outside collection mode
          if (!requestData.content_db) {
            const headerContentDb = axios.defaults.headers.common?.["X-Content-DB"] || null;
            requestData.content_db = headerContentDb;
            console.log("[ASK] content_db fallback from axios default header:", requestData.content_db);
          }

          // Homework: if user just toggled it ON, start fresh exactly once
          if (homeworkEnabledForThisAsk && homeworkHelpNewDialogOnNextAskRef.current) {
            requestData.new_dialog = true;
            homeworkHelpNewDialogOnNextAskRef.current = false;
          }

          // ✅ Check active module and include relevant details
          // BDD 08/30/2026 - exam review overrides whichever workspace/module is currently active.
          if (isExamReviewAsk) {
            requestData.context = {
              type: "exam_review",
              screenshot: examReviewContext.screenshot,
              test_title: examReviewContext.test_title ?? null,
              test_id: examReviewContext.test_id ?? null,
              question_index: examReviewContext.question_index ?? null,
              question_number: examReviewContext.question_number ?? null,
              question_id: examReviewContext.question_id ?? null,
              external_question_id: examReviewContext.external_question_id ?? null,
              question_text: examReviewContext.question_text ?? "",
              student_answer: examReviewContext.student_answer ?? "",
              official_solution: examReviewContext.official_solution ?? "",
              official_explanation: examReviewContext.official_explanation ?? "",
              official_marks: examReviewContext.official_marks ?? null,
            };

            // Each reviewed question starts clean so an unrelated prior chat cannot contaminate it.
            requestData.new_dialog = true;
            // The screenshot/official solution are authoritative for answering; RAG is for references afterwards.
            requestData.restrict_to_rag_only = false;
            requestData.include_references = true;
            lastContextType.current = "exam_review";
          }
          else if (module === "video") {
            requestData.context.type = "video";
            requestData.context.videoId = currentVideoId;
            requestData.context.videotagId = currentVideoTagID;
            requestData.context.videotimestamp = getCurrentVideoTime();
            requestData.context.videoDurationSeconds = videoDuration;
            requestData.context.screenshot = await captureScreenshot(videoRef.current);

            if (selectedChapterId != null) {
              requestData.context.chapterId = selectedChapterId;
            } else if (activeTopic) {
              const parts = String(activeTopic).split('-');
              if (parts.length >= 1 && parts[0]) requestData.context.chapterId = parseInt(parts[0], 10) || null;
            }

            setIncludeReference(false);
            lastContextType.current = "video";
          }
          else if (module === "pwo") {
            requestData.context.type = "pwo";
            requestData.context.pwoId = pwoid_current;
            console.log("handleAsk pwo module pwoID.", pwoid_current);

            try {
              // Three.js renders synchronously inside its own WebGL canvas
              // before returning the frame. Do not draw an already-cleared
              // WebGL buffer into a React 2D canvas (black screenshot bug).
              if (threePwoActive && isThreeJsPwo(pwoid_current)) {
                const captured = await requestThreePwoScreenshot(pwoid_current);
                if (captured?.data_url) {
                  requestData.context.screenshot = captured.data_url;
                  requestData.context.pwoScene = captured.scene_name;
                  // Never take PWO/scene teaching text from the client.
                  // Live state is descriptive, not proof of physical completion.
                  requestData.journey_context = {
                    ...(requestData.journey_context || {}),
                    active_activity: {
                      ...(requestData.journey_context?.active_activity || {}),
                      type: "pwo", source_pwo_id: pwoid_current,
                      scene_name: captured.scene_name,
                      pwo_state: captured.state,
                    },
                  };
                } else {
                  requestData.context.pwoScene = currentPwoSceneRef.current;
                  console.warn("[Three.js PWO] Current screenshot unavailable; metadata-only AI help");
                }
              } else {
              let result = null;
              if (!isWebGLReadyRef.current) {
                console.warn("❌ Tried to take screenshot before WEBGL_READY");
              } else {
                result = await requestUnityScreenshot();
                console.log("✅ Unity screenshot result:", result);
              }

              if (result?.imagebytes) {
                const base64imagefromUnity = `data:image/png;base64,${result.imagebytes}`;
                requestData.context.screenshot = base64imagefromUnity;
                console.log("screenshot in Unity response.", base64imagefromUnity.slice(0, 100));
              } else {
                console.warn("❌ Screenshot or scene name missing in Unity response. Proceeding with fake screenshot");
              }

              if (result?.scenename) {
                requestData.context.pwoScene = result.scenename;
                console.log("scenename in Unity response.", result.scenename);
              } else {
                requestData.context.pwoScene = pwoscene_current;
                console.warn("❌ Scene name missing in Unity response. Proceeding with last scenename clicked", pwoscene_current);
              }
              }
            } catch (error) {
              console.error("❌ Failed to get screenshot from Unity:", error);
            }

            if (selectedChapterId != null) {
              requestData.context.chapterId = selectedChapterId;
            } else if (activeTopic) {
              const parts = String(activeTopic).split('-');
              if (parts.length >= 1 && parts[0]) requestData.context.chapterId = parseInt(parts[0], 10) || null;
            }

            setIncludeReference(false);
            lastContextType.current = "pwo";
          }
          else if (module === "whiteboard" && uploadedFile) {
            requestData.context.type = "whiteboard";
            requestData.context.file_name = uploadedFile.name;
            requestData.context.screenshot = uploadedFile.content;
            setIncludeReference(false);
            lastContextType.current = "whiteboard";
          }
          else if (module === "uploaded" && uploadedFile) {
            requestData.context.type = "uploaded_file";
            requestData.context.file_name = uploadedFile.name;

            if (uploadedFile.content.startsWith("data:image")) {
              requestData.context.screenshot = uploadedFile.content;
              requestData.context.file_content = null;
            } else {
              requestData.context.file_content = uploadedFile.content;
              requestData.context.screenshot = null;
            }
            setIncludeReference(false);
            lastContextType.current = "uploaded";
          }
          else {
            // -------------------------------
            // QUESTION CONTEXT (Homework lives here)
            // -------------------------------
            requestData.context.type = "question";

            // Attach topic scope (existing)
            if (scopedTopicName || topicScope?.board_topic_id || topicScope?.source_topic_id) {
              requestData.context.topic = {
                board_topic_id: topicScope?.board_topic_id ?? null,
                source_topic_id: topicScope?.source_topic_id ?? null,
                topic_name: topicScope?.topic_name ?? null,
                chapter_name: topicScope?.chapter_name ?? null,
                chapter_id: topicScope?.chapterId ?? null,
              };

              // Optional safety net (only if caller didn't pass customInstructions)
              if (!requestData.custom_instructions && scopedTopicName) {
                requestData.custom_instructions =
                  `Answer ONLY using Saras-3D content for the topic "${scopedTopicName}". Ignore earlier topics.`;
              }
            }

            // Homework: if no explicit customInstructions, inject homework JSON instructions
            if (!requestData.custom_instructions && homeworkCustomInstructionsStr) {
              requestData.custom_instructions = homeworkCustomInstructionsStr;
            }

            // 🔁 Existing includeReference state heuristic (kept as-is)
            if (lastContextType.current !== "question") {
              setIncludeReference(true);
              console.log("setIncludeReference is being set true:", includeReference);
              console.log("lastContextType.current is:", lastContextType.current);
            } else {
              setIncludeReference(false);
              console.log("setIncludeReference is being set false:", includeReference);
              console.log("lastContextType.current is:", lastContextType.current);
            }

            lastContextType.current = "question";
            console.log("lastContextType.current is being reset to question:", lastContextType.current);
          }

          // --- refs gating (Homework overrides Club gating)
          const shouldFetchRefs =
            (
              isExamReviewAsk ||
              (isClub ? autoFetchReferences : true) ||
              homeworkEnabledForThisAsk
            )
            && requestData.include_references
            && !skipReferences;

          console.log("[refs gate]", {
            isClub,
            autoFetchReferences,
            includeRefs: requestData.include_references,
            skipReferences,
            homeworkEnabledForThisAsk,
            isExamReviewAsk,
            shouldFetchRefs,
          });

          console.log("[HOMEWORK][SEND] context.type=", requestData?.context?.type);
          console.log("[HOMEWORK][SEND] custom_instructions=", requestData.custom_instructions);

          // BDD 04/12/2026 - stream through /api/ask_ai itself
          // Backend /api/ask_ai remains the single orchestration point.
          // Frontend only requests streaming transport when the feature flag is ON.
          const canStream = !investorMode && isAiStreamEnabled;
          requestData.stream_response = canStream;
          // BDD 04/13/2026 - smoke metrics for this ask
          // BDD 04/16/2026 - local llm / museum latency experiment
          resetAiAskMetrics(askRequestId, {
            aiMode,
            transportMode: canStream ? "stream" : "non_stream",
            backendPath: isLocalNvidiaMode ? "local_service" : "cloud_api",
          });
          // console.log("[AI_STREAM]", {
          //   isAiStreamEnabled,
          //   investorMode,
          //   canStream,
          //   contextType: requestData?.context?.type,
          // });

          let responseData;

          if (canStream) {
            let liveText = "";
            let finalText = "";
            let finalFormatted = "";
            let finalMeta = {};
            // Throttle history updates so we don't dispatch a setHistory on every token
            let lastHistoryFlush = 0;
            const HISTORY_FLUSH_INTERVAL_MS = 60;

            // Cancel any in-flight stream from a previous call before starting a new one
            try {
              if (streamAbortControllerRef.current) {
                streamAbortControllerRef.current.abort();
              }
            } catch {}
            const streamController = new AbortController();
            streamAbortControllerRef.current = streamController;

            try {
              await streamNdjson({
                url: API_URL_ASK, // BDD 04/12/2026 - stream through /api/ask_ai itself  
                body: requestData,
                signal: streamController.signal,
                onEvent: (event) => {
                  // console.log("[STREAM EVENT]", event.type, event);
                  switch (event.type) {
                    case "start":
                      setAnswer("");
                      // Clear any leftover TTS queue from a previous response
                      stopTtsStream();
                      hadStreamAudioChunksRef.current = false;
                      suppressNextAudioAutoplayRef.current = false;
                      break;
                    case "text_delta": {
                      // BDD 04/13/2026 - AI smoke metrics for current ask
                      if (!aiAskMetricsRef.current.firstTextAt) {
                        aiAskMetricsRef.current.firstTextAt = Date.now();
                      }
                      liveText += event.delta || "";
                      setAnswer(liveText);
                      // Throttle history updates to avoid 100s of re-renders per second
                      const now = Date.now();
                      if (now - lastHistoryFlush >= HISTORY_FLUSH_INTERVAL_MS) {
                        lastHistoryFlush = now;
                        const snapshot = liveText;
                        setHistory((prev) => {
                          // const idx = (prev || []).findIndex((e) => e._isPending);
                          // BDD 04/12/2026 - stream through /api/ask_ai itself - try6
                          const idx = (prev || []).findIndex(e => e._askRequestId === askRequestId);
                          if (idx < 0) return prev;
                          const updated = [...prev];
                          updated[idx] = { ...updated[idx], answer: snapshot };
                          return updated;
                        });
                      }
                      break;
                    }
                    case "audio_chunk":
                      // Sequential TTS chunks: enqueue + auto-play next when current ends
                      // BDD 04/13/2026 - AI smoke metrics for current ask
                      if (!aiAskMetricsRef.current.firstAudioAt) {
                        aiAskMetricsRef.current.firstAudioAt = Date.now();
                      }
                      aiAskMetricsRef.current.hadAudio = true;

                      if ((swanMediaAsk
                        ? journeySwanReadAloudRef.current &&
                          !journeyContext?.activity_progress?.inquiry_guard?.protect_answer &&
                          !journeyVideoInterruptedSpeechRef.current
                        : !isMuted) && event.url) {
                        hadStreamAudioChunksRef.current = true;
                        enqueueTtsChunk(event.url);
                      }
                      break;
                    case "text_done":
                      // BDD 04/13/2026 - AI smoke metrics for current ask
                      if (!aiAskMetricsRef.current.textDoneAt) {
                        aiAskMetricsRef.current.textDoneAt = Date.now();
                      }
                      finalText = event.text || liveText;
                      finalFormatted = event.formatted || finalText;
                      setAnswer(finalFormatted);
                      break;
                    case "error":
                      // BDD 04/13/2026 - AI smoke metrics for current ask
                      aiAskMetricsRef.current.hadError = true;
                      aiAskMetricsRef.current.errorMessages.push(String(event.message || "stream_error"));
                      console.warn("[stream] error event:", event.message);
                      break;
                    case "done":
                      // Immutable merge — avoid Object.assign mutation
                      // BDD 04/13/2026 - AI smoke metrics for current ask
                      if (!aiAskMetricsRef.current.doneAt) {
                        aiAskMetricsRef.current.doneAt = Date.now();
                      }
                      finalMeta = { ...finalMeta, ...event };
                      break;
                  }
                },
              });

              // Fallback: if text_done was never received but we accumulated deltas,
              // use the live text as the canonical response
              if (!finalText) finalText = liveText;
              if (!finalFormatted) finalFormatted = liveText;

              // BDD 04/12/2026 - stream through /api/ask_ai itself - try7
              if (!finalText || !String(finalText).trim()) {
                throw new Error("Streaming completed without usable text; forcing non-stream fallback.");
              }

              // Final flush of the chat bubble in case the throttle skipped the last update
              if (finalText) {
                const finalSnapshot = finalFormatted || finalText;
                setHistory((prev) => {
                  // const idx = (prev || []).findIndex((e) => e._isPending);
                  // BDD 04/12/2026 - stream through /api/ask_ai itself - try6
                  const idx = (prev || []).findIndex(e => e._askRequestId === askRequestId);
                  if (idx < 0) return prev;
                  const updated = [...prev];
                  updated[idx] = { ...updated[idx], answer: finalSnapshot };
                  return updated;
                });
              }

              // Build a responseData shape that matches the non-streaming endpoint
              // so the existing post-response logic below works unchanged.
              responseData = {
                "AI response": finalText,
                "Formatted AI response": finalFormatted,
                Description: finalMeta.Description || [],
                Video: finalMeta.Video || [],
                PWO: finalMeta.PWO || [],
                Audio: finalMeta.Audio || null,
                conversation_id: finalMeta.conversation_id ?? null,
                assistant_turn_id: finalMeta.assistant_turn_id ?? null,
                student_message_id: finalMeta.student_message_id ?? null,
                content_db: finalMeta.content_db || null,
                collection_id: finalMeta.collection_id ?? null,
                allow_reference_fetch: finalMeta.allow_reference_fetch !== false,
                reference_block_reason: finalMeta.reference_block_reason || null,
                Exhibit: finalMeta.Exhibit || null,
              };
            } catch (e) {
              if (e?.name === "AbortError") {
                // User cancelled — don't fall back, just exit cleanly
                return;
              }
              // BDD 04/12/2026 - stream through /api/ask_ai itself - try7

              console.warn("🌊 Streaming failed, falling back to non-streaming:", e?.message || e);
              const url = API_URL_ASK;

              // IMPORTANT: force true non-stream fallback
              const fallbackRequestData = {
                ...requestData,
                stream_response: false,
              };
              // BDD 04/13/2026 - AI smoke metrics for current ask
              aiAskMetricsRef.current.hadError = true;
              aiAskMetricsRef.current.errorMessages.push(
                `stream_fallback: ${String(e?.message || e)}`
              );
              const response = await axios.post(url, fallbackRequestData);
              responseData = Array.isArray(response.data) && response.data.length > 0 ? response.data[0] : response.data;
              if (typeof responseData === "string") {
                try {
                  responseData = JSON.parse(responseData);
                } catch (parseError) {
                  console.warn("Fallback response was not valid JSON string:", responseData);
                  throw parseError;
                }
              }
              if (!responseData || typeof responseData !== "object") {
                throw new Error("Fallback /api/ask_ai did not return a valid JSON object.");
              } 
              // BDD 04/13/2026 - AI smoke metrics for current ask
              const now = Date.now();
              if (!aiAskMetricsRef.current.firstTextAt) aiAskMetricsRef.current.firstTextAt = now;
              if (!aiAskMetricsRef.current.textDoneAt) aiAskMetricsRef.current.textDoneAt = now;
              if (!aiAskMetricsRef.current.doneAt) aiAskMetricsRef.current.doneAt = now;
              // BDD 04/13/2026 - AI smoke metrics for current ask
              if (responseData?.Audio) {
                aiAskMetricsRef.current.hadAudio = true;
                if (!aiAskMetricsRef.current.firstAudioAt) {
                  aiAskMetricsRef.current.firstAudioAt = Date.now();
                }
              }
              } finally {
              if (streamAbortControllerRef.current === streamController) {
                streamAbortControllerRef.current = null;
              }
            }
          } else {
            // Non-streaming path (video/PWO/whiteboard/guide_me/homework/investor)
            const url = investorMode ? API_URL_FAST_ASK : API_URL_ASK;
            const response = await axios.post(url, requestData);
            responseData = Array.isArray(response.data) && response.data.length > 0 ? response.data[0] : response.data;
            if (typeof responseData === "string") {
              responseData = JSON.parse(responseData);
            }
            // BDD 04/13/2026 - AI smoke metrics for current ask
            const now = Date.now();
            if (!aiAskMetricsRef.current.firstTextAt) aiAskMetricsRef.current.firstTextAt = now;
            if (!aiAskMetricsRef.current.textDoneAt) aiAskMetricsRef.current.textDoneAt = now;
            if (!aiAskMetricsRef.current.doneAt) aiAskMetricsRef.current.doneAt = now;
            // BDD 04/13/2026 - AI smoke metrics for current ask
            if (responseData?.Audio) {
              aiAskMetricsRef.current.hadAudio = true;
              if (!aiAskMetricsRef.current.firstAudioAt) {
                aiAskMetricsRef.current.firstAudioAt = now;
              }
            }
          }

          // BDD 03/19/2026 - do not fetch references if we have inappropriate question
          const backendAllowsReferenceFetch = responseData?.allow_reference_fetch !== false;
          const backendReferenceBlockReason = responseData?.reference_block_reason || null;
          console.log("[refs backend decision]", {
            backendAllowsReferenceFetch,
            backendReferenceBlockReason,
          });

          // If backend returns conversation_id, select that session
          const convoId = responseData?.conversation_id ?? null;
          if (convoId != null) {
            setSelectedConversationId(convoId);
            fetchChatSessions(10);
          }

          if (responseData["Formatted AI response"]) {
            setAnswer(responseData["Formatted AI response"] || "No response from AI.");
          }

          setDocuments(responseData["Description"] || []);
          setVideos(responseData["Video"] || []);
          setPwos(responseData["PWO"] || []);

          setIsNewDialog(false);
          setInputValue("");
          window.AndroidBridge?.notifyProcessingDone?.();

          // ************************************************************ BEGIN AI question suggestion related
          // Use the actual response text (not the stale `answer` state which hasn't flushed yet)
          const conversationAnswer =
            responseData?.["Formatted AI response"] ||
            responseData?.["AI response"] ||
            answer ||
            "";
          updatedConversation = [...updatedConversation, { answer: conversationAnswer }];
          setConversation(updatedConversation);

          const limitedContext = getLimitedConversation(5) || [];

          const context = {
            user_id: user_id,
            subject: "currentSubject",
            chapter: "currentChapter",
            topic: "currentTopic",
            collection_id: activeStudyCollection?.id ?? null,
            collection_name: activeStudyCollection?.name ?? "",
            collection_info: activeStudyCollection?.info ?? "",
            current_view: viewMode === "collections" ? "collection" : (module || "question"),
            instructions: "currentInstructions",
            conversation: limitedContext,
            current_question: finalQuestionToSend,
            current_answer: responseData["Formatted AI response"] || "No response from AI.",
          };

          const BASIC_FOLLOWUPS = [
            t("I didn’t understand — explain more simply."),
            t("Can you explain step-by-step with an example?"),
          ];
          // const BASIC_FOLLOWUPS = [
          //   t("Please explain your previous answer more simply."),
          //   t("Please explain your previous answer step-by-step with an example."),
          // ];

          function normalizeSuggestedQuestions(list) {
            if (!Array.isArray(list)) return [];
            return list
              .map((q) => (typeof q === "string" ? q.trim() : ""))
              .filter(Boolean)
              .filter((q) => {
                const s = q.toLowerCase();
                if (s.startsWith("sure!") || s.startsWith("sure,")) return false;
                if (s.includes("here are") && s.includes("questions")) return false;
                if (s.includes("insightful questions")) return false;
                if (s.includes("you could ask next")) return false;
                return true;
              })
              .map((q) =>
                q
                  .replace(/^\s*[-•]\s*/g, "")
                  .replace(/^\s*\d+[\).\]]\s*/g, "")
                  .trim()
              )
              .filter(Boolean);
          }

          // ZA 03/01/2026 - Improved dedup: normalize for comparison and use substring/similarity check
          function _normalizeForCompare(s) {
            return (s || "").trim().toLowerCase()
              .replace(/[?!.,;:'"()\-–—]/g, "")  // strip punctuation
              .replace(/\s+/g, " ")               // collapse whitespace
              .trim();
          }

          function _isTooSimilar(candidate, excludeNorms) {
            const norm = _normalizeForCompare(candidate);
            if (!norm || norm.length < 5) return false;
            for (const ex of excludeNorms) {
              if (!ex) continue;
              // Exact normalized match
              if (norm === ex) return true;
              // One contains the other (catches slight rewording)
              if (norm.length > 10 && ex.length > 10) {
                if (norm.includes(ex) || ex.includes(norm)) return true;
              }
              // High word overlap (>80% of words match)
              const normWords = new Set(norm.split(" ").filter(w => w.length > 2));
              const exWords = new Set(ex.split(" ").filter(w => w.length > 2));
              if (normWords.size >= 3 && exWords.size >= 3) {
                let overlap = 0;
                for (const w of normWords) { if (exWords.has(w)) overlap++; }
                const overlapRatio = overlap / Math.min(normWords.size, exWords.size);
                if (overlapRatio > 0.8) return true;
              }
            }
            return false;
          }

          function mergeUniqueQuestions(primary, secondary, maxCount = 4, exclude = []) {
            // Build normalized versions of excluded questions
            const excludeNorms = (exclude || [])
              .map(_normalizeForCompare)
              .filter(Boolean);
            const seen = new Set(excludeNorms);
            const out = [];
            const push = (q) => {
              const s = (q || "").trim();
              if (!s) return;
              const norm = _normalizeForCompare(s);
              if (seen.has(norm)) return;
              if (_isTooSimilar(s, excludeNorms)) return;
              seen.add(norm);
              out.push(s);
            };
            (primary || []).forEach(push);
            (secondary || []).forEach(push);
            return out.slice(0, maxCount);
          }

          // Collect previously asked questions from conversation history to exclude
          const askedQuestions = [
            finalQuestionToSend,
            ...(limitedContext || [])
              .filter((m) => m.role === "user")
              .map((m) => m.content),
          ];

          // BDD 04/14/2026 - fix calls to fetchXX - add askRequestId as new argument
          lastSuggestionsContextRef.current = context;
          const suggestionsRaw = await fetchSuggestedQuestions(context, askRequestId);

          // BDD 04/14/2026 - do not let stale asks overwrite follow-up UI/meta
          // BDD 04/21/2026 - Thinking... remained on when I clicked quickly one suggsted quetion to next
          if (currentAskRequestIdRef.current !== askRequestId) {
            console.warn("[BDD0210][SUGG] stale ask after fetchSuggestedQuestions; skipping UI/meta update", {
              askRequestId,
              currentAskRequestId: currentAskRequestIdRef.current,
            });

            clearPendingForAskRequestId(askRequestId);
            return;
          }
          const suggestionsClean = normalizeSuggestedQuestions(suggestionsRaw);
          const mergedSuggestions = mergeUniqueQuestions(BASIC_FOLLOWUPS, suggestionsClean, 4, askedQuestions);

          console.log("[BDD0210][SUGG] raw=", suggestionsRaw);
          console.log("[BDD0210][SUGG] clean=", suggestionsClean);
          console.log("[BDD0210][SUGG] merged=", mergedSuggestions, "len=", mergedSuggestions.length);
          // BDD 04/14/2026 - stale ask double-check before writing followup meta
          // BDD 04/21/2026 - Thinking... remained on when I clicked quickly one suggsted quetion to next
          if (currentAskRequestIdRef.current !== askRequestId) {
            console.warn("[BDD0210][SUGG] stale ask before setSuggestedQuestionsMeta; skipping", {
              askRequestId,
              currentAskRequestId: currentAskRequestIdRef.current,
            });

            clearPendingForAskRequestId(askRequestId);
            return;
          }          
          setSuggestedQuestions(mergedSuggestions);
          setSuggestedQuestionsHeader([t("Deepen your understanding:")]);
          // BDD 04/14/2026 - basic_followups need some previous context
          function buildFollowupAnswerExcerpt(text, maxLen = 1200) {
            const s = String(text || "").trim();
            if (!s) return "";
            return s.length <= maxLen ? s : `${s.slice(0, maxLen)}…`;
          }
          // BDD 04/14/2026 - basic_followups need some previous context
          const previousAnswerExcerpt = buildFollowupAnswerExcerpt(
            responseData["Formatted AI response"] || responseData["AI response"] || ""
          );
          // BDD 04/14/2026 - basic_followups need some previous context
          // setSuggestedQuestionsMeta({ kind: "chat", topicScope: null });
          setSuggestedQuestionsMeta({
            kind: "chat",
            topicScope: null,

            // BDD 04/14/2026 - hidden follow-up metadata for ask-based suggested questions
            followupMeta: {
              [t("I didn’t understand — explain more simply.")]: {
                followupKind: "simplify_previous_answer",
                previousAnswerText: previousAnswerExcerpt,
                previousQuestionText: finalQuestionToSend,
              },
              [t("Can you explain step-by-step with an example?")]: {
                followupKind: "step_by_step_previous_answer",
                previousAnswerText: previousAnswerExcerpt,
                previousQuestionText: finalQuestionToSend,
              },
            },
          });

          // ************************************************************ END AI question suggestion related

          if (responseData["Audio"] && !swanMediaAsk) {
            const fixedAudioUrl = responseData["Audio"].replace(/\\/g, "/");

            // BDD 04/12/2026 - if chunked streaming audio already played,
            // keep the final full Audio URL for replay, but do not auto-play it again.
            if (canStream && hadStreamAudioChunksRef.current) {
              suppressNextAudioAutoplayRef.current = true;
            }

            setAudioUrl(fixedAudioUrl);
          }

          setHistory((prev) => {
            const responseAnswer = responseData["Formatted AI response"];
            const convoId2 = responseData?.conversation_id ?? null;

            // Find the pending placeholder
            // const pendingIdx = (prev || []).findIndex((e) => e._isPending);
            // BDD 04/12/2026 - stream through /api/ask_ai itself - try6
            const pendingIdx = (prev || []).findIndex(e => e._askRequestId === askRequestId);

            if (pendingIdx >= 0) {
              const updated = [...prev];
              updated[pendingIdx] = {
                ...updated[pendingIdx],
                answer: responseAnswer,
                videos: responseData["Video"] || [],
                documents: responseData["Description"] || [],
                pwos: responseData["PWO"] || [],
                quiz: responseData["Quiz"] || [],
                chapters: responseData["Chapter"] || responseData["Chapters"] || [],
                collections: responseData["Collection"] || responseData["Collections"] || [],
                guideMeActions: responseData["GuideMeActions"] || [],
                student_message_id: responseData?.student_message_id ?? responseData?.assistant_turn_id ?? null,
                assistant_turn_id: responseData?.assistant_turn_id ?? null,
                conversation_id: convoId2,
                content_db: responseData?.content_db ?? null,
                collection_id: responseData?.collection_id ?? null,
                _isPending: false,
              };

              // If new conversation, keep only entries from this conversation
              if (convoId2 != null) {
                const otherConvoEntries = updated.some(
                  (e, i) => i !== pendingIdx && e.conversation_id != null && String(e.conversation_id) !== String(convoId2)
                );
                if (otherConvoEntries) {
                  return [updated[pendingIdx]];
                }
              }
              return updated;
            }

            // Fallback: no placeholder found
            const newEntry = {
              question: finalQuestionDisplay,
              answer: responseAnswer,
              videos: responseData["Video"] || [],
              documents: responseData["Description"] || [],
              pwos: responseData["PWO"] || [],
              quiz: responseData["Quiz"] || [],
              chapters: responseData["Chapter"] || responseData["Chapters"] || [],
              collections: responseData["Collection"] || responseData["Collections"] || [],
              guideMeActions: responseData["GuideMeActions"] || [],
              student_message_id: responseData?.student_message_id ?? responseData?.assistant_turn_id ?? null,
              assistant_turn_id: responseData?.assistant_turn_id ?? null,
              conversation_id: convoId2,
              content_db: responseData?.content_db ?? null,
              collection_id: responseData?.collection_id ?? null,
              is_current_content_db: true,
              _swanMediaAsk: Boolean(swanMediaAsk),
              _swanMediaStepId: journeyContext?.step_id || null,
              _swanMediaAssetKey: swanMediaAssetKey,
              _swanMediaGuardBlockId: swanMediaGuardBlockId,
            };
            return [newEntry, ...(prev || [])];
          });

          // Trigger KT popup after topic summary is delivered
          if (topicScope?.source_topic_id && !autoWalkthroughMode) {
            triggerKtPopup({ topicIdOverride: topicScope.source_topic_id });
          }

          // if (shouldFetchRefs) {
          // BDD 03/19/2026 - do not fetch references if we have inappropriate question
          if (shouldFetchRefs && backendAllowsReferenceFetch) {
            console.log("📥 shouldFetchRefs...", shouldFetchRefs);

            let reEnableAuto = false;
            if (
              !autoWalkthroughMode &&
              module === "learning" &&
              autoFetchReferences &&
              (autoOpenPWO || autoPlayVideo)
            ) {
              console.log("🔁 Re-enabling autoWalkthroughMode on fresh Ask");
              setAutoWalkthroughMode(true);
              reEnableAuto = true;
            }

            console.log("📥 Calling fetchReferences...");

            const anchor = {
              student_message_id: responseData?.student_message_id ?? responseData?.assistant_turn_id ?? null,
              conversation_id: responseData?.conversation_id ?? selectedConversationId ?? null,
              collection_id: responseData?.collection_id ?? activeStudyCollection?.id ?? null,
              content_db: responseData?.content_db ?? null,
            };

            console.log("[ASK FLOW][FE][REFS]", {
              askRequestId,
              conversation_id: anchor?.conversation_id ?? null,
              student_message_id: anchor?.student_message_id ?? null,
              content_db: anchor?.content_db ?? null,
            });
            
            // BDD 04/12/2026 - stable row target for streamed refs patching
            const { videos, pwos, quiz, chapters, collections } = await fetchReferences(anchor, askRequestId);

            console.log("🚀 autoWalkthroughMode", autoWalkthroughMode);
            console.log("🚀 reEnableAuto", reEnableAuto);
            console.log("🎥 Current chapters:", chapters);
            console.log("🎥 Current collections:", collections);

            if (autoWalkthroughMode || reEnableAuto) {
              console.log("🚀 Auto walkthrough mode triggered");

              setTimeout(() => {
                runAutoWalkthrough(responseData["Formatted AI response"], {
                  pwo: pwos,
                  video: videos,
                  quiz: quiz
                }, true);
              }, 200);
            }
          } else {
            console.log("⏭️ Skipping references (gate blocked).", {
              shouldFetchRefs,
              backendAllowsReferenceFetch,
              backendReferenceBlockReason,
            });
          }

        } catch (error) {
          console.error("API Error:", error);
          setAnswer("Error fetching response from AI.");

          // BDD 04/13/2026 - AI smoke metrics for current ask
          aiAskMetricsRef.current.hadError = true;
          aiAskMetricsRef.current.errorMessages.push(String(error?.message || error));
          if (!aiAskMetricsRef.current.doneAt) {
            aiAskMetricsRef.current.doneAt = Date.now();
          }
          // Clear the pending placeholder on error
          setHistory((prev) => {

            // const pendingIdx = (prev || []).findIndex((e) => e._isPending);
            // BDD 04/12/2026 - stream through /api/ask_ai itself - try6
            const pendingIdx = (prev || []).findIndex(e => e._askRequestId === askRequestId);

            if (pendingIdx >= 0) {
              const updated = [...prev];
              updated[pendingIdx] = {
                ...updated[pendingIdx],
                answer: "Sorry, there was an error getting a response. Please try again.",
                _isPending: false,
              };
              return updated;
            }
            return prev;
          });
          // BDD 04/12/2026 - stream through /api/ask_ai itself - try6
          if (currentAskRequestIdRef.current === askRequestId) {
            pendingHistoryIndexRef.current = null;
            currentAskRequestIdRef.current = null;
          }        
          } finally {
          // === TRIVIA STOP ===
          setIsAsking(false);
          setTriviaItem(null);

          setLoading(false);
          setQuestion("");

          // Reset includeReference back to false after use
          setIncludeReference(false);

          if (currentAskRequestIdRef.current === askRequestId) {           // BDD 04/12/2026 - stream through /api/ask_ai itself - try6
            // BDD 04/12/2026 - clear stable row target and ask identity for this ask
            pendingHistoryIndexRef.current = null;
            currentAskRequestIdRef.current = null;
          }
        }
      };
  


  // BDD 02/22/2026 HomeworkHelpV2-A
  const askHomeworkProblem = React.useCallback((arg1, arg2) => {
    try {
      // Ensure homework mode is ON
      if (!homeworkHelpEnabledRef.current) {
        setHomeworkHelpEnabled(true);
      }

      // Make each problem start a fresh dialog (simple + predictable)
      homeworkHelpNewDialogOnNextAskRef.current = true;

      // Support both signatures:
      // A) (problemObject, assignmentIdNumber)
      // B) (statementString, {assignment_id, problem_id, ...})
      const meta = (arg2 && typeof arg2 === "object" && !Array.isArray(arg2)) ? arg2 : {};
      const problemObj = (arg1 && typeof arg1 === "object") ? arg1 : null;
      const statementDirect = (typeof arg1 === "string") ? arg1 : null;

      const assignmentIdRaw = meta.assignment_id ?? arg2 ?? null;
      const normalizedAssignmentId =
        assignmentIdRaw && typeof assignmentIdRaw === "object"
          ? (assignmentIdRaw.assignment_id ?? assignmentIdRaw.id ?? null)
          : assignmentIdRaw;

      const problemIdRaw =
        meta.problem_id ??
        problemObj?.id ??
        problemObj?.problem_id ??
        null;

      const statement =
        (statementDirect ||
          meta.statement_md ||
          problemObj?.statement_md_final ||
          problemObj?.statement_md_raw ||   // ✅ include raw
          problemObj?.statement_md ||
          problemObj?.statement_text ||
          ""
        ).toString().trim();

      const label =
        (problemObj?.label ||
          problemObj?.problem_label ||
          meta.label ||
          ""
        ).toString().trim();

      if (!statement) {
        console.warn("[Homework] askHomeworkProblem: empty statement; abort", { arg1, arg2 });
        return;
      }

      // Compose the question we send (keep markdown/LaTeX as-is)
      const q = label
        ? `Help me solve this homework problem (${label}):\n\n${statement}`
        : `Help me solve this homework problem:\n\n${statement}`;

      const customInstructions = {
        mode: "homework_help",
        help_type: "hint_then_steps",
        show_final_answer: false,
        prefer_socratic: true,
        answer_style: "concise",

        assignment_id: normalizedAssignmentId != null ? Number(normalizedAssignmentId) : null,
        problem_id: problemIdRaw != null ? Number(problemIdRaw) : null,
        content_db: String(meta.content_db || contentDb || ""),
      };

      handleAsk(q, { customInstructions });
    } catch (e) {
      console.warn("[Homework] askHomeworkProblem failed:", e);
    }
  }, [handleAsk, contentDb, setHomeworkHelpEnabled]);

  // BDD 02/08/2026 Stale turn_id issue for fetchreference
  function pickLatestTurnFromHistory(hist) {
    const arr = Array.isArray(hist) ? hist : [];
    if (!arr.length) return { entry: null, maxId: null };

    // Supports both new + old keys
    const getMsgId = (h) => h?.student_message_id ?? h?.assistant_turn_id ?? null;

    // If conversation_id exists, keep within the current conversation (prevents cross-session mixing)
    const convId = arr[0]?.conversation_id ?? null;
    const candidates =
      convId != null ? arr.filter((x) => x?.conversation_id === convId) : arr;

    let best = null;
    let maxId = null;

    for (const h of candidates) {
      const raw = getMsgId(h);

      // allow numeric strings too
      const id =
        typeof raw === "number"
          ? raw
          : typeof raw === "string" && raw.trim() !== "" && Number.isFinite(Number(raw))
            ? Number(raw)
            : null;

      if (id != null) {
        if (maxId == null || id > maxId) {
          maxId = id;
          best = h;
        }
      }
    }

    return { entry: best, maxId };
  }

  
  // // BDD 02/12/2026 -- updates to: BDD 02/08/2026 Stale turn_id issue for fetchreference - START
  // // BDD 04/12/2026 - stable row target for streamed refs patching
  // const fetchReferences = async (anchor = {}, askRequestId = null) => {
  //   console.log("🔁 fetchReferences() called for user:", user_id);

  //   // ===== Investor Mode: early-return for scripted flows =====
  //   try {
  //     if (flags?.investor_mode) {
  //       const lastQ =
  //         (lastAskedRef.current && lastAskedRef.current.trim()) ||
  //         (history?.[0]?.question ??
  //           history?.[0]?.userText ??
  //           history?.[0]?.text ??
  //           history?.[0]?.prompt ??
  //           "").trim();

  //       const topicSourceId =
  //         lastTopicSourceIdRef.current ??
  //         activeTopic?.source_id ??
  //         activeTopic?.source_topic_id ??
  //         collectionResolved?.items?.[0]?.source_topic_id ??
  //         collectionResolved?.items?.[0]?.topic_snapshot?.source_topic_id ??
  //         null;

  //       console.log("[DEMO check]", { topicSourceId, lastQ });

  //       const match = findFlowOrLegacyForQuestion(topicSourceId, lastQ);
  //       if (match && match.flow) {
  //         const { flow } = match;
  //         console.log("⭐ DEMO flow match:", lastQ, "→", flow.ask);

  //         const videos = flow.video
  //           ? [
  //             {
  //               videoID: flow.video.video_id ?? flow.video.source_id,
  //               tagID: flow.video.tag_id ?? flow.video.tag,
  //               tag_id: flow.video.tag_id ?? flow.video.tag,
  //               tag: flow.video.tag_id ?? flow.video.tag,
  //               source_id: flow.video.video_id ?? flow.video.source_id,
  //               outsideCollection: false,
  //             },
  //           ]
  //           : [];

  //         const pwos = flow.pwo
  //           ? [
  //             {
  //               pwoID: flow.pwo.source_pwo_id ?? flow.pwo.pwo_source_id,
  //               pwo_source_id: flow.pwo.source_pwo_id ?? flow.pwo.pwo_source_id,
  //               pwo_scene_name: flow.pwo.scene_name || null,
  //               scene_name: flow.pwo.scene_name || null,
  //               outsideCollection: false,
  //             },
  //           ]
  //           : [];

  //         function resolveQuestionsFromCache(ids) {
  //           const out = [];
  //           const missing = [];
  //           const cache = (typeof window !== "undefined" && window.__quizCache) || {};
  //           const latest =
  //             typeof window !== "undefined" && Array.isArray(window.__latestQuizRefs)
  //               ? window.__latestQuizRefs
  //               : [];
  //           const latestById = Object.fromEntries(
  //             latest.map((x) => [String(x?.question_id ?? x?.id ?? x?.qid), x])
  //           );
  //           for (const id of ids || []) {
  //             const key = String(id);
  //             const hit = cache[key] || latestById[key];
  //             if (hit) out.push(hit);
  //             else missing.push(id);
  //           }
  //           return { out, missing };
  //         }

  //         let quiz = [];
  //         if (flow.quiz) {
  //           if (Array.isArray(flow.quiz.questions)) {
  //             quiz = flow.quiz.questions;
  //           } else if (Array.isArray(flow.quiz.question_ids)) {
  //             const { out, missing } = resolveQuestionsFromCache(flow.quiz.question_ids);
  //             if (out.length) {
  //               quiz = out;
  //               console.log("📝 Investor-mode: resolved quiz from cache", {
  //                 requested: flow.quiz.question_ids.length,
  //                 resolved: out.length,
  //                 missing,
  //               });
  //             } else {
  //               quiz = flow.quiz.question_ids.map((qid) => ({ question_id: qid }));
  //               console.warn("📝 Investor-mode: quiz unresolved; returning id stubs only. Missing:", missing);
  //             }
  //           }
  //         }

  //         setVideos(videos);
  //         setPwos(pwos);

  //         setHistory((prev) => {
  //           if (!prev || !prev.length) return prev;
  //           const u = [...prev];
  //           u[0] = {
  //             ...u[0],
  //             videos: videos.length ? videos : u[0].videos,
  //             pwos: pwos.length ? pwos : u[0].pwos,
  //             quiz: quiz.length ? quiz : u[0].quiz,
  //           };
  //           return u;
  //         });

  //         if (typeof window !== "undefined") {
  //           window.__latestQuizRefs = quiz;
  //           console.log("📝 Saved quiz to window.__latestQuizRefs:", quiz?.length ?? 0);
  //         }

  //         return { videos, pwos, quiz };
  //       }
  //     }
  //   } catch (e) {
  //     console.warn("DEMO flow check failed; falling back to server:", e);
  //   }
  //   // ===== /Investor Mode early-return =====

  //   // ---- server-backed code ----

  //   console.log("🧾 activeStudyCollection", activeStudyCollection ? {
  //     id: activeStudyCollection.id,
  //     name: activeStudyCollection.name,
  //     base_board: activeStudyCollection.base_board
  //   } : null);

  //   const canShowCollection = !!(activeStudyCollection?.id && collectionResolved);
  //   const inCollectionMode = (viewMode === "collections") && canShowCollection;
  //   // BDD 02/12/2026 -- updates to: BDD 02/08/2026 Stale turn_id issue for fetchreference - START
  //   // --- pick latest assistant message id safely (supports new + old key)
  //   // BDD 02/12/2026 -- updates to: BDD 02/08/2026 Stale turn_id issue for fetchreference - END
  //   // ---- server-backed code ----

  //   // BDD 02/12/2026 -- updates to: BDD 02/08/2026 Stale turn_id issue for fetchreference - START
  //   // --- helper: supports new + old key
  //   const getMsgId = (h) => h?.student_message_id ?? h?.assistant_turn_id ?? null;

  //   // Anchor values (preferred when provided from handleAsk)
  //   const anchorMsgId = getMsgId(anchor);
  //   const anchorConvId = anchor?.conversation_id ?? null;
  //   const anchorCollectionId = anchor?.collection_id ?? null;
  //   const anchorContentDb = anchor?.content_db ?? null;

  //   // Fallback values from history (only used when anchor missing)
  //   const { entry: latestEntry, maxId } = pickLatestTurnFromHistory(history);
  //   const latest = latestEntry || (history?.[0] || {});

  //   const histMsgId = getMsgId(latest);
  //   const histConvId = latest?.conversation_id ?? null;
  //   const histContentDb = latest?.content_db ?? null;
  //   const histCollectionId = latest?.collection_id ?? null;

  //   console.log("🧭 refs anchor/fallback", {
  //     anchorMsgId,
  //     anchorConvId,
  //     anchorCollectionId,
  //     anchorContentDb,
  //     histMsgId,
  //     maxId,
  //     histConvId,
  //     histCollectionId,
  //     histContentDb,
  //   });

  //   // ---- Determine final scope params (anchor-first) ----
  //   const convIdForRefs = anchorConvId ?? histConvId ?? null;

  //   const collectionIdForRefs =
  //     (typeof anchorCollectionId === "number" ? anchorCollectionId : null) ??
  //     (typeof histCollectionId === "number" ? histCollectionId : null) ??
  //     (inCollectionMode && activeStudyCollection?.id ? activeStudyCollection.id : null);

  //   const contentDbForRefs = anchorContentDb ?? histContentDb ?? null;

  //   // If we’re NOT anchored, only send an id if it’s truly the latest id we can see.
  //   // Otherwise omit id and let backend pick latest (prevents stale turn bug).
  //   const safeHistMsgId =
  //     (maxId != null && histMsgId != null && histMsgId === maxId) ? histMsgId : null;

  //   // Final id we ask backend to attach refs to:
  //   const msgIdForRefs = anchorMsgId ?? safeHistMsgId ?? null;

  //   // ---- Build request URL ----
  //   const skipRefTranslate = shouldSkipTranslateForRef();

  //   let requestUrl =
  //     `${FASTAPI_BASE_URL}/fetch_references/${encodeURIComponent(user_id)}` +
  //     `?skip_translate_for_ref=${skipRefTranslate ? "true" : "false"}`;

  //   // Optional scoping
  //   if (convIdForRefs != null) {
  //     requestUrl += `&conversation_id=${encodeURIComponent(convIdForRefs)}`;
  //   }
  //   if (collectionIdForRefs != null) {
  //     requestUrl += `&collection_id=${encodeURIComponent(collectionIdForRefs)}`;
  //   }
  //   if (contentDbForRefs) {
  //     requestUrl += `&content_db=${encodeURIComponent(contentDbForRefs)}`;
  //   }

  //   // Attach to a specific assistant message when we can.
  //   // IMPORTANT: keep turn_id for current backend compatibility.
  //   // (student_message_id can be added later; safe to include too if you want.)
  //   if (msgIdForRefs != null) {
  //     requestUrl += `&turn_id=${encodeURIComponent(msgIdForRefs)}`;

  //     // If we were explicitly anchored (from handleAsk), FORCE attach to that bubble.
  //     // This avoids race conditions when two asks happen quickly.
  //     if (anchorMsgId != null) {
  //       requestUrl += `&exact_turn_id=true`;
  //     }
  //   }

  //   console.log("🌐 Making GET request to:", requestUrl);

  //   // ---- Call ----
  //   let data = {};
  //   try {
  //     const refResponse = await axios.get(requestUrl);
  //     data = refResponse.data || {};
  //   } catch (error) {
  //     console.error("❌ Error fetching references:", error);
  //     if (error.response) {
  //       console.error("🚨 status:", error.response.status, "data:", error.response.data);
  //     }
  //     return { videos: [], pwos: [], quiz: [], chapters: [], collections: [] };
  //   }

  //   // ---- Parse ----
  //   const videos = data.Video || [];
  //   const pwos = data.PWO || [];
  //   const quiz = data.Quiz || [];
  //   const chapters = data.Chapter || data.Chapters || [];
  //   const collections = data.Collection || data.Collections || [];

  //   const refsContentDb = data.content_db || contentDbForRefs || null;

  //   // Backend may override the target; use what it says if present
  //   const returnedMsgId = data.student_message_id ?? data.turn_id ?? null;

  //   // Final anchor id to patch into UI history
  //   const finalAnchorMsgId = returnedMsgId ?? msgIdForRefs ?? anchorMsgId ?? histMsgId ?? null;

  //   setVideos(videos);
  //   setPwos(pwos);

  //   // BDD 04/12/2026 - stream through /api/ask_ai itself - try6
  //   // ---- Patch the exact history entry ----
  //   setHistory((prev) => {
  //     if (!Array.isArray(prev) || !prev.length) return prev;

  //     let i = null;

  //     // BDD 04/12/2026 - prefer the row created for the current ask.
  //     if (askRequestId) {
  //       const askIdx = prev.findIndex((m) => m?._askRequestId === askRequestId);
  //       if (askIdx >= 0) {
  //         i = askIdx;
  //       }
  //     }

  //     // Fallback: try to match by either student or assistant turn id
  //     if (i == null) {
  //       const matchesAnchorId = (m, anchorId) => {
  //         if (anchorId == null) return false;
  //         const rowStudentId = m?.student_message_id;
  //         const rowAssistantId = m?.assistant_turn_id;
  //         return (
  //           (rowStudentId != null && String(rowStudentId) === String(anchorId)) ||
  //           (rowAssistantId != null && String(rowAssistantId) === String(anchorId))
  //         );
  //       };

  //       const idx =
  //         finalAnchorMsgId == null
  //           ? -1
  //           : prev.findIndex((m) => matchesAnchorId(m, finalAnchorMsgId));

  //       if (idx < 0) {
  //         console.warn(
  //           "⚠ refs: could not find history entry for msg id:",
  //           finalAnchorMsgId,
  //           "and no _askRequestId match was found; skipping refs patch"
  //         );
  //         return prev;
  //       }

  //       i = idx;
  //     }

  //     const out = [...prev];

  //     // BDD 04/12/2026 - stale async refs protection
  //     if (
  //       askRequestId &&
  //       out[i]?._askRequestId &&
  //       out[i]._askRequestId !== askRequestId
  //     ) {
  //       console.warn("⚠ refs: stale refs patch skipped for old ask", {
  //         rowAskRequestId: out[i]._askRequestId,
  //         askRequestId,
  //       });
  //       return prev;
  //     }

  //     out[i] = {
  //       ...out[i],
  //       videos: videos.length ? videos : out[i].videos,
  //       pwos: pwos.length ? pwos : out[i].pwos,
  //       quiz: quiz.length ? quiz : out[i].quiz,
  //       chapters: chapters.length ? chapters : (out[i].chapters || []),
  //       collections: collections.length ? collections : (out[i].collections || []),
  //       content_db: refsContentDb,
  //     };

  //     return out;
  //   });

  //   return { videos, pwos, quiz, chapters, collections };
  //   // BDD 02/12/2026 -- updates to: BDD 02/08/2026 Stale turn_id issue for fetchreference - END

  //   // // BDD 02/08/2026 Stale turn_id issue for fetchreference - following was commented out.
  //   // // // ✅ IMPORTANT: use the board + turn id of the message we are attaching refs to
  //   // // const latest = history?.[0] || {};
  //   // // const turnId = latest?.assistant_turn_id ?? null;
  //   // // const turnContentDb = latest?.content_db ?? null;

  //   // // // ✅ Prefer the collection_id stamped on the turn (if present),
  //   // // // otherwise fall back to current UI context.
  //   // // const turnCollectionId = latest?.collection_id ?? null;
  //   // // const collectionIdForRefs =
  //   // //   (typeof turnCollectionId === "number" ? turnCollectionId : null) ??
  //   // //   (inCollectionMode && activeStudyCollection?.id ? activeStudyCollection.id : null);

  //   // // console.log("🧭 refs mode", {
  //   // //   inCollectionMode,
  //   // //   collection_id: collectionIdForRefs,
  //   // //   turnId,
  //   // //   turnContentDb,
  //   // // });

  //   // // BDD 02/08/2026 Stale turn_id issue for fetchreference
  //   // function pickLatestTurnFromHistory(hist) {
  //   //   const arr = Array.isArray(hist) ? hist : [];
  //   //   if (!arr.length) return { entry: null, maxId: null };

  //   //   // If conversation_id exists, keep within the current conversation (prevents cross-session mixing)
  //   //   const convId = arr[0]?.conversation_id ?? null;
  //   //   const candidates = (convId != null)
  //   //     ? arr.filter(x => x?.conversation_id === convId)
  //   //     : arr;

  //   //   let best = null;
  //   //   let maxId = null;

  //   //   for (const h of candidates) {
  //   //     const id = h?.assistant_turn_id;
  //   //     if (typeof id === "number" && Number.isFinite(id)) {
  //   //       if (maxId == null || id > maxId) {
  //   //         maxId = id;
  //   //         best = h;
  //   //       }
  //   //     }
  //   //   }

  //   //   // fallback: if none have assistant_turn_id, return nulls
  //   //   return { entry: best, maxId };
  //   // }

  //   // // BDD 02/08/2026 Stale turn_id issue for fetchreference - start
  //   // const { entry: latestEntry, maxId } = pickLatestTurnFromHistory(history);

  //   // // ✅ Use the newest assistant turn we can find, not history[0]
  //   // const latest = latestEntry || (history?.[0] || {});
  //   // const turnId = latest?.assistant_turn_id ?? null;
  //   // const turnContentDb = latest?.content_db ?? null;

  //   // // ✅ Prefer collection_id stamped on the chosen turn, fallback to UI context
  //   // const turnCollectionId = latest?.collection_id ?? null;

  //   // console.log("🧭 refs anchor", {
  //   //   chosen_turn_id: turnId,
  //   //   max_assistant_turn_id_in_history: maxId,
  //   //   chosen_from_history_index0: latest === (history?.[0] || {}),
  //   //   chosen_conversation_id: latest?.conversation_id ?? null,
  //   // });

  //   // const collectionIdForRefs =
  //   //   (typeof turnCollectionId === "number" ? turnCollectionId : null) ??
  //   //   (inCollectionMode && activeStudyCollection?.id ? activeStudyCollection.id : null);

  //   // console.log("🧭 refs mode", {
  //   //   inCollectionMode,
  //   //   collection_id: collectionIdForRefs,
  //   //   turnId,
  //   //   turnContentDb,
  //   // });
  //   // // BDD 02/08/2026 Stale turn_id issue for fetchreference - end


  //   // // ---- Build request URL ----
  //   // const skipRefTranslate = shouldSkipTranslateForRef(); // BDD 02/08/2026 - derive skip_translate_for_ref from language selection

  //   // let requestUrl =
  //   //   `${FASTAPI_BASE_URL}/fetch_references/${encodeURIComponent(user_id)}`
  //   //   + `?skip_translate_for_ref=${skipRefTranslate  ? "true" : "false"}`; // BDD 02/08/2026 - derive skip_translate_for_ref from language selection

      
  //   // // BDD 02/08/2026 Stale turn_id issue for fetchreference - commenting out following
  //   // // if (collectionIdForRefs != null) {
  //   // //   requestUrl += `&collection_id=${encodeURIComponent(collectionIdForRefs)}`;
  //   // // }
  //   // // if (turnId != null) {
  //   // //   requestUrl += `&turn_id=${encodeURIComponent(turnId)}`;
  //   // // }
  //   // // if (turnContentDb) {
  //   // //   requestUrl += `&content_db=${encodeURIComponent(turnContentDb)}`;
  //   // // }

  //   // // BDD 02/08/2026 Stale turn_id issue for fetchreference
  //   // // If we detected a newer assistant turn in history than the one we're about to use,
  //   // // omit turn_id and let backend pick latest (prevents stale turnId bug)
  //   // // const safeTurnId =
  //   // //   (maxId != null && turnId != null && turnId === maxId) ? turnId : null;

  //   // // if (safeTurnId != null) {
  //   // //   requestUrl += `&turn_id=${encodeURIComponent(safeTurnId)}`;
  //   // // }

  //   // // if (turnContentDb) {
  //   // //   requestUrl += `&content_db=${encodeURIComponent(turnContentDb)}`;
  //   // // }

  //   // // console.log("🌐 Making GET request to:", requestUrl);

  //   // // try {
  //   // //   const refResponse = await axios.get(requestUrl);
  //   // //   console.log("✅ Reference API call succeeded");

  //   // //   const data = refResponse.data || {};
  //   // //   console.log("📦 Full response data (keys):", Object.keys(data));
  //   // //   console.log("🎥 Video refs len:", data?.Video?.length ?? 0, " sample:", data?.Video?.[0]);
  //   // //   console.log("🧪 PWO refs len:", data?.PWO?.length ?? 0, " sample:", data?.PWO?.[0]);
  //   // //   console.log("📝 Quiz refs len:", data?.Quiz?.length ?? 0);

  //   // //   const videos = data["Video"] || [];
  //   // //   const pwos = data["PWO"] || [];
  //   // //   const quiz = data["Quiz"] || [];

  //   // //   const chapters = data["Chapter"] || data["Chapters"] || [];
  //   // //   const collections = data["Collection"] || data["Collections"] || [];

  //   // //   const refsContentDb = data["content_db"] || turnContentDb || null;

  //   // //   // Cache only *full* questions
  //   // //   if (typeof window !== "undefined") {
  //   // //     const full = Array.isArray(quiz)
  //   // //       ? quiz.filter(q => q && (q.question || q.question_text || q.options || q.correct_answer || q.solution))
  //   // //       : [];
  //   // //     if (full.length) {
  //   // //       window.__latestQuizFull = full;
  //   // //       window.__quizCache = window.__quizCache || {};
  //   // //       for (const q of full) {
  //   // //         const qid = q?.question_id ?? q?.id ?? q?.qid;
  //   // //         if (qid != null) window.__quizCache[String(qid)] = q;
  //   // //       }
  //   // //       console.log("🧠 (refs) quiz cache size:", Object.keys(window.__quizCache).length);
  //   // //     }
  //   // //   }

  //   // //   setVideos(videos);
  //   // //   setPwos(pwos);

  //   // //   setHistory(prevHistory => {
  //   // //     if (!prevHistory || prevHistory.length === 0) {
  //   // //       console.warn("⚠ No history found to update references into");
  //   // //       return prevHistory;
  //   // //     }
  //   // //     const updatedHistory = [...prevHistory];

  //   // //     updatedHistory[0] = {
  //   // //       ...updatedHistory[0],
  //   // //       videos: videos.length ? videos : updatedHistory[0].videos,
  //   // //       pwos: pwos.length ? pwos : updatedHistory[0].pwos,
  //   // //       quiz: quiz.length ? quiz : updatedHistory[0].quiz,
  //   // //       chapters: chapters.length ? chapters : (updatedHistory[0].chapters || []),
  //   // //       collections: collections.length ? collections : (updatedHistory[0].collections || []),

  //   // //       // ✅ stamp board used to compute these refs (critical for gray-out)
  //   // //       content_db: refsContentDb,
  //   // //     };

  //   // //     console.log("📝 Updated latest history entry with references + content_db:", refsContentDb);
  //   // //     return updatedHistory;
  //   // //   });

  //   // //   return { videos, pwos, quiz, chapters, collections };

  //   // // } catch (error) {
  //   // //   console.error("❌ Error fetching references:", error);
  //   // //   if (error.response) {
  //   // //     console.error("🚨 Error response status:", error.response.status);
  //   // //     console.error("🧾 Error response data:", error.response.data);
  //   // //   } else if (error.request) {
  //   // //     console.error("📡 No response received. Possible network error.");
  //   // //     console.error("📤 Axios request object:", error.request);
  //   // //   } else {
  //   // //     console.error("⚙️ Axios config error:", error.message);
  //   // //   }
  //   // //   return { videos: [], pwos: [], quiz: [], chapters: [], collections: [] };
  //   // // }
  // };

  // BDD 04/14/2026 
  const fetchReferences = async (anchor = {}, askRequestId = null) => {
    console.log("🔁 fetchReferences() called for user:", user_id);

    try {
      if (flags?.investor_mode) {
        const lastQ =
          (lastAskedRef.current && lastAskedRef.current.trim()) ||
          (history?.[0]?.question ??
            history?.[0]?.userText ??
            history?.[0]?.text ??
            history?.[0]?.prompt ??
            "").trim();

        const topicSourceId =
          lastTopicSourceIdRef.current ??
          activeTopic?.source_id ??
          activeTopic?.source_topic_id ??
          collectionResolved?.items?.[0]?.source_topic_id ??
          collectionResolved?.items?.[0]?.topic_snapshot?.source_topic_id ??
          null;

        console.log("[DEMO check]", { topicSourceId, lastQ });

        const match = findFlowOrLegacyForQuestion(topicSourceId, lastQ);
        if (match && match.flow) {
          const { flow } = match;
          console.log("⭐ DEMO flow match:", lastQ, "→", flow.ask);

          const videos = flow.video
            ? [
                {
                  videoID: flow.video.video_id ?? flow.video.source_id,
                  tagID: flow.video.tag_id ?? flow.video.tag,
                  tag_id: flow.video.tag_id ?? flow.video.tag,
                  tag: flow.video.tag_id ?? flow.video.tag,
                  source_id: flow.video.video_id ?? flow.video.source_id,
                  outsideCollection: false,
                },
              ]
            : [];

          const pwos = flow.pwo
            ? [
                {
                  pwoID: flow.pwo.source_pwo_id ?? flow.pwo.pwo_source_id,
                  pwo_source_id: flow.pwo.source_pwo_id ?? flow.pwo.pwo_source_id,
                  pwo_scene_name: flow.pwo.scene_name || null,
                  scene_name: flow.pwo.scene_name || null,
                  outsideCollection: false,
                },
              ]
            : [];

          function resolveQuestionsFromCache(ids) {
            const out = [];
            const missing = [];
            const cache =
              (typeof window !== "undefined" && window.__quizCache) || {};
            const latest =
              typeof window !== "undefined" &&
              Array.isArray(window.__latestQuizRefs)
                ? window.__latestQuizRefs
                : [];
            const latestById = Object.fromEntries(
              latest.map((x) => [String(x?.question_id ?? x?.id ?? x?.qid), x])
            );
            for (const id of ids || []) {
              const key = String(id);
              const hit = cache[key] || latestById[key];
              if (hit) out.push(hit);
              else missing.push(id);
            }
            return { out, missing };
          }

          let quiz = [];
          if (flow.quiz) {
            if (Array.isArray(flow.quiz.questions)) {
              quiz = flow.quiz.questions;
            } else if (Array.isArray(flow.quiz.question_ids)) {
              const { out, missing } = resolveQuestionsFromCache(
                flow.quiz.question_ids
              );
              if (out.length) {
                quiz = out;
                console.log("📝 Investor-mode: resolved quiz from cache", {
                  requested: flow.quiz.question_ids.length,
                  resolved: out.length,
                  missing,
                });
              } else {
                quiz = flow.quiz.question_ids.map((qid) => ({
                  question_id: qid,
                }));
                console.warn(
                  "📝 Investor-mode: quiz unresolved; returning id stubs only. Missing:",
                  missing
                );
              }
            }
          }

          setVideos(videos);
          setPwos(pwos);

          setHistory((prev) => {
            if (!prev || !prev.length) return prev;
            const u = [...prev];
            u[0] = {
              ...u[0],
              videos: videos.length ? videos : u[0].videos,
              pwos: pwos.length ? pwos : u[0].pwos,
              quiz: quiz.length ? quiz : u[0].quiz,
            };
            return u;
          });

          if (typeof window !== "undefined") {
            window.__latestQuizRefs = quiz;
            console.log("📝 Saved quiz to window.__latestQuizRefs:", quiz?.length ?? 0);
          }

          return { videos, pwos, quiz };
        }
      }
    } catch (e) {
      console.warn("DEMO flow check failed; falling back to server:", e);
    }

    console.log(
      "🧾 activeStudyCollection",
      activeStudyCollection
        ? {
            id: activeStudyCollection.id,
            name: activeStudyCollection.name,
            base_board: activeStudyCollection.base_board,
          }
        : null
    );

    const canShowCollection = !!(activeStudyCollection?.id && collectionResolved);
    const inCollectionMode = viewMode === "collections" && canShowCollection;

    const getMsgId = (h) => h?.student_message_id ?? h?.assistant_turn_id ?? null;

    const anchorMsgId = getMsgId(anchor);
    const anchorConvId = anchor?.conversation_id ?? null;
    const anchorCollectionId = anchor?.collection_id ?? null;
    const anchorContentDb = anchor?.content_db ?? null;

    const { entry: latestEntry, maxId } = pickLatestTurnFromHistory(history);
    const latest = latestEntry || (history?.[0] || {});

    const histMsgId = getMsgId(latest);
    const histConvId = latest?.conversation_id ?? null;
    const histContentDb = latest?.content_db ?? null;
    const histCollectionId = latest?.collection_id ?? null;

    console.log("🧭 refs anchor/fallback", {
      anchorMsgId,
      anchorConvId,
      anchorCollectionId,
      anchorContentDb,
      histMsgId,
      maxId,
      histConvId,
      histCollectionId,
      histContentDb,
      askRequestId,
    });

    const convIdForRefs = anchorConvId ?? histConvId ?? null;

    const collectionIdForRefs =
      (typeof anchorCollectionId === "number" ? anchorCollectionId : null) ??
      (typeof histCollectionId === "number" ? histCollectionId : null) ??
      (inCollectionMode && activeStudyCollection?.id
        ? activeStudyCollection.id
        : null);

    const contentDbForRefs = anchorContentDb ?? histContentDb ?? null;

    const safeHistMsgId =
      maxId != null && histMsgId != null && histMsgId === maxId ? histMsgId : null;

    const msgIdForRefs = anchorMsgId ?? safeHistMsgId ?? null;

    // BDD 04/14/2026 - require exact identifiers when called for a specific ask
    if (askRequestId) {
      if (anchorMsgId == null || anchorConvId == null || !anchorContentDb) {
        console.warn("⚠ refs: skipping because exact anchor is missing for current ask", {
          askRequestId,
          anchorMsgId,
          anchorConvId,
          anchorContentDb,
        });
        return { videos: [], pwos: [], quiz: [], chapters: [], collections: [] };
      }
    }

    const skipRefTranslate = shouldSkipTranslateForRef();

    let requestUrl =
      `${FASTAPI_BASE_URL}/fetch_references/${encodeURIComponent(user_id)}` +
      `?skip_translate_for_ref=${skipRefTranslate ? "true" : "false"}`;

    if (convIdForRefs != null) {
      requestUrl += `&conversation_id=${encodeURIComponent(convIdForRefs)}`;
    }
    if (collectionIdForRefs != null) {
      requestUrl += `&collection_id=${encodeURIComponent(collectionIdForRefs)}`;
    }
    if (contentDbForRefs) {
      requestUrl += `&content_db=${encodeURIComponent(contentDbForRefs)}`;
    }

    if (msgIdForRefs != null) {
      requestUrl += `&turn_id=${encodeURIComponent(msgIdForRefs)}`;
    }

    // BDD 04/14/2026 - if current ask has an explicit anchor, force exact turn mode
    if (anchorMsgId != null) {
      requestUrl += `&exact_turn_id=true`;
    }

    console.log("🌐 Making GET request to:", requestUrl);

    let data = {};
    try {
      // BDD 04/14/2026 - abort older refs request
      try {
        fetchReferencesAbortRef.current?.abort();
      } catch {}
      const controller = new AbortController();
      fetchReferencesAbortRef.current = controller;

      const refResponse = await axios.get(requestUrl, {
        signal: controller.signal,
      });
      data = refResponse.data || {};
    } catch (error) {
      if (error?.name === "CanceledError" || error?.name === "AbortError") {
        console.log("🛑 fetchReferences aborted");
        return { videos: [], pwos: [], quiz: [], chapters: [], collections: [] };
      }
      console.error("❌ Error fetching references:", error);
      if (error.response) {
        console.error("🚨 status:", error.response.status, "data:", error.response.data);
      }
      return { videos: [], pwos: [], quiz: [], chapters: [], collections: [] };
    }

    const videos = data.Video || [];
    const pwos = data.PWO || [];
    const quiz = data.Quiz || [];
    const chapters = data.Chapter || data.Chapters || [];
    // const collections = data.Collection || data.Collections || [];

    // BDD 05/03/2026 - Use localized collection display names when backend provides them.
    // Keep original collection.name untouched because collection names are teacher-authored.
    const collectionsRaw = data.Collection || data.Collections || [];

    const collections = Array.isArray(collectionsRaw)
      ? collectionsRaw.map((c) => ({
          ...c,
          display_name:
            c.name_localized ||
            c.display_name ||
            c.localized_name ||
            c.name ||
            `Collection ${c.collection_id || c.id || ""}`.trim(),
        }))
      : [];
    const refsContentDb = data.content_db || contentDbForRefs || null;
    const returnedMsgId = data.student_message_id ?? data.turn_id ?? null;
    const finalAnchorMsgId =
      returnedMsgId ?? msgIdForRefs ?? anchorMsgId ?? histMsgId ?? null;

    setVideos(videos);
    setPwos(pwos);

    setHistory((prev) => {
      if (!Array.isArray(prev) || !prev.length) return prev;

      let i = null;

      if (askRequestId) {
        const askIdx = prev.findIndex((m) => m?._askRequestId === askRequestId);
        if (askIdx >= 0) {
          i = askIdx;
        }
      }

      if (i == null) {
        const matchesAnchorId = (m, anchorId) => {
          if (anchorId == null) return false;
          const rowStudentId = m?.student_message_id;
          const rowAssistantId = m?.assistant_turn_id;
          return (
            (rowStudentId != null && String(rowStudentId) === String(anchorId)) ||
            (rowAssistantId != null && String(rowAssistantId) === String(anchorId))
          );
        };

        const idx =
          finalAnchorMsgId == null
            ? -1
            : prev.findIndex((m) => matchesAnchorId(m, finalAnchorMsgId));

        if (idx < 0) {
          console.warn(
            "⚠ refs: could not find history entry for msg id:",
            finalAnchorMsgId,
            "and no _askRequestId match was found; skipping refs patch"
          );
          return prev;
        }

        i = idx;
      }

      const out = [...prev];

      if (
        askRequestId &&
        out[i]?._askRequestId &&
        out[i]._askRequestId !== askRequestId
      ) {
        console.warn("⚠ refs: stale refs patch skipped for old ask", {
          rowAskRequestId: out[i]._askRequestId,
          askRequestId,
        });
        return prev;
      }
      // BDD 04/14/2026 - References were not printing with this change 
      // if (askRequestId && currentAskRequestIdRef.current !== askRequestId) {
      //   console.warn("⚠ refs: stale refs response ignored", {
      //     askRequestId,
      //     currentAskRequestId: currentAskRequestIdRef.current,
      //   });
      //   return prev;
      // }

      out[i] = {
        ...out[i],
        videos: videos.length ? videos : out[i].videos,
        pwos: pwos.length ? pwos : out[i].pwos,
        quiz: quiz.length ? quiz : out[i].quiz,
        chapters: chapters.length ? chapters : (out[i].chapters || []),
        // collections: collections.length ? collections : (out[i].collections || []),
        // BDD 05/03/2026 - Ensure collection refs stored in chat history carry display_name.
        // This protects ChatPanel/SuggestionRail even if older/raw refs sneak in.
        collections: (collections.length ? collections : (out[i].collections || [])).map((c) => ({
          ...c,
          display_name:
            c?.display_name ||
            c?.name_localized ||
            c?.localized_name ||
            c?.name ||
            `Collection ${c?.collection_id || c?.id || ""}`.trim(),
        })),
        content_db: refsContentDb,
      };
      // // BDD 05/03/2026
      // console.log("[refs→history] storing collections", {
      //   askRequestId,
      //   collectionsForHistory: (collections.length ? collections : (out[i].collections || [])).map((c) => ({
      //     id: c?.id,
      //     collection_id: c?.collection_id,
      //     name: c?.name,
      //     name_localized: c?.name_localized,
      //     display_name: c?.display_name,
      //     scoped: c?.scoped,
      //   })),
      // });
      return out;
    });

    return { videos, pwos, quiz, chapters, collections };
  };

  // # BDD 01/16/2025 - ChatHistory Persistance
  const fetchRecentChatHistory = async (limit = 25) => {
    if (!user_id) return;

    const url =
      `${FASTAPI_BASE_URL}/chat_history`
      + `?user_id=${encodeURIComponent(user_id)}`
      + `&limit=${limit}`;

    console.log("🕘 Fetching chat history:", url);

    try {
      const res = await axios.get(url);
      const restored = Array.isArray(res?.data?.history) ? res.data.history : [];

      setHistory(
        restored
          .slice()
          .reverse() // keep your existing convention: history[0] is most recent
          .map((h) => ({
            question: h.question || "",
            answer: h.answer || "",
            videos: Array.isArray(h.videos) ? h.videos : [],
            pwos: Array.isArray(h.pwos) ? h.pwos : [],
            chapters: Array.isArray(h.chapters) ? h.chapters : [],
            collections: Array.isArray(h.collections) ? h.collections : [],
            guideMeActions: Array.isArray(h.guideMeActions) ? h.guideMeActions : [],

            // ✅ NEW metadata
            content_db: h.content_db || null,
            is_current_content_db: h.is_current_content_db !== false,
            assistant_turn_id: h.assistant_turn_id || null,
            collection_id: h.collection_id ?? null,
          }))
      );

      console.log("✅ Restored history entries:", restored.length);
    } catch (e) {
      console.error("❌ Failed to restore chat history:", e);
    }
  };

  useEffect(() => {
    if (!user_id) return;

    // On login: show sessions list (collapsed), not turns
    setSelectedConversationId(null);
    setHistory([]);              // history will hold turns for the selected session only
    fetchChatSessions(10);       // load last N sessions

  }, [user_id]);

  const fetchChatSessions = async (limit = 10) => {
    if (!user_id) return;

    const url =
      `${FASTAPI_BASE_URL}/chat_sessions`
      + `?user_id=${encodeURIComponent(user_id)}`
      + `&limit=${limit}`;

    console.log("🗂️ Fetching chat sessions:", url);

    setSessionsLoading(true);
    try {
      const res = await axios.get(url);
      const sessions = Array.isArray(res?.data?.sessions) ? res.data.sessions : [];
      setChatSessions(sessions);
      console.log("✅ Sessions loaded:", sessions.length);
    } catch (e) {
      console.error("❌ Failed to fetch chat sessions:", e);
      setChatSessions([]);
    } finally {
      setSessionsLoading(false);
    }
  };

  const openChatSession = async (conversationId, limit = 200) => {
    if (!user_id || !conversationId) return;

    const url =
      `${FASTAPI_BASE_URL}/chat_history`
      + `?user_id=${encodeURIComponent(user_id)}`
      + `&conversation_id=${encodeURIComponent(conversationId)}`
      + `&limit=${limit}`;

    console.log("🕘 Fetching chat turns for conversation:", conversationId, url);

    setSelectedConversationId(conversationId);
    setSessionTurnsLoading(true);

    try {
      const res = await axios.get(url);
      const restored = Array.isArray(res?.data?.history) ? res.data.history : [];

      // Your convention: history[0] = most recent
      setHistory(
        restored
          .slice()
          .reverse()
          .map((h) => ({
            question: h.question || "",
            answer: h.answer || "",
            videos: Array.isArray(h.videos) ? h.videos : [],
            pwos: Array.isArray(h.pwos) ? h.pwos : [],
            chapters: Array.isArray(h.chapters) ? h.chapters : [],
            collections: Array.isArray(h.collections) ? h.collections : [],
            guideMeActions: Array.isArray(h.guideMeActions) ? h.guideMeActions : [],

            content_db: h.content_db || null,
            is_current_content_db: h.is_current_content_db !== false,
            assistant_turn_id: h.assistant_turn_id || null,
            collection_id: h.collection_id ?? null,

            // helpful to keep around:
            conversation_id: conversationId,
          }))
      );

      console.log("✅ Restored turns:", restored.length);
    } catch (e) {
      console.error("❌ Failed to fetch chat turns:", e);
      setHistory([]);
    } finally {
      setSessionTurnsLoading(false);
    }
  };

  const closeChatSession = () => {
    setSelectedConversationId(null);
    setHistory([]);
  };

  // BDD 10/10/2025
  // Debug utility: dump last full quiz to JSON for demo_preset
  window.dumpQuizForDemo = function dumpQuizForDemo({ count = 3, embedFull = true } = {}) {
    if (flags?.investor_mode) return null; // demo owns it; don't touch
    try {
      const quizFull = (typeof window !== "undefined" && Array.isArray(window.__latestQuizFull))
        ? window.__latestQuizFull : [];

      if (!quizFull.length) {
        console.warn("⚠️ No full quiz cached (window.__latestQuizFull is empty). Open a Quiz first.");
        return null;
      }

      const pick = quizFull.slice(0, Math.max(0, count));
      const question_ids = pick.map(q => q?.question_id ?? q?.id ?? q?.qid).filter(Boolean);

      // Choose shape: embed full objects OR just ids
      const snippet = embedFull
        ? { quiz: { questions: pick } }
        : { quiz: { question_ids } };

      const json = JSON.stringify(snippet, null, 2);
      console.group("📝 Demo preset quiz snippet");
      console.log(json);
      console.groupEnd();

      if (navigator?.clipboard?.writeText) {
        navigator.clipboard.writeText(json).then(() => {
          console.log(`✅ Copied ${embedFull ? "full questions" : "question_ids"} snippet to clipboard`);
        }).catch(() => { });
      }
      return snippet;
    } catch (e) {
      console.error("dumpQuizForDemo failed:", e);
      return null;
    }
  };

  // BDD 10/8/2025
  useEffect(() => {
    if (flags?.investor_mode) return; // demo owns it; don't touch
    // expose a global you can call from DevTools
    window.dumpDemo = () => dumpActiveCollectionForPreset(collectionResolved, activeStudyCollection);
    console.log("💡 Tip: run window.dumpDemo() in DevTools to print PWO/Video candidates & a paste-ready preset snippet.");
  }, [collectionResolved, activeStudyCollection]);
  // BDD 10/8/2025
  // Remember/restore prior UI state when investor mode toggles
  const demoFlagsAppliedRef = useRef(false);
  const savedUiFlagsRef = useRef({
    autoWalkthroughMode: null,
    answerStyle: null,
    metricsOverlayVisible: null, // harmless even if you never use it
  });
  // BDD 10/8/2025
  useEffect(() => {
    const cfg = getDemoPreset(); // null when investor_mode is false
    const wantDemo = !!flags?.investor_mode && !!cfg;

    if (wantDemo && !demoFlagsAppliedRef.current) {
      // Save current values once
      savedUiFlagsRef.current = {
        autoWalkthroughMode,
        answerStyle,
        // only read overlay if it exists in state
        metricsOverlayVisible: typeof metricsOverlayVisible !== "undefined" ? metricsOverlayVisible : null,
      };

      // Apply preset flags
      const f = cfg.flags || {};

      if (f.FORCE_AUTOWALKTHROUGH) {
        setAutoWalkthroughMode(true);
      }

      // Map SHORT_ANSWER_MODE → "concise" (your state)
      if (f.SHORT_ANSWER_MODE && typeof setAnswerStyle === "function") {
        setAnswerStyle("concise");
      }

      // SHOW_METRICS_OVERLAY is optional; only set if you defined the setter
      if (f.SHOW_METRICS_OVERLAY && typeof setMetricsOverlayVisible === "function") {
        setMetricsOverlayVisible(true);
      }

      demoFlagsAppliedRef.current = true;
      console.log("[DEMO FLAGS] applied:", f);
    }

    if (!wantDemo && demoFlagsAppliedRef.current) {
      // Restore prior values (only if we saved them)
      const prev = savedUiFlagsRef.current || {};
      if (prev.autoWalkthroughMode !== null) setAutoWalkthroughMode(prev.autoWalkthroughMode);
      if (prev.answerStyle !== null && typeof setAnswerStyle === "function") setAnswerStyle(prev.answerStyle);
      if (prev.metricsOverlayVisible !== null && typeof setMetricsOverlayVisible === "function") {
        setMetricsOverlayVisible(prev.metricsOverlayVisible);
      }

      demoFlagsAppliedRef.current = false;
      console.log("[DEMO FLAGS] restored:", prev);
    }
  }, [
    flags?.investor_mode,
    // include these so we capture initial values when demo first turns on
    autoWalkthroughMode,
    answerStyle,
    // metricsOverlayVisible is optional; include only if you declared it
    // metricsOverlayVisible,
  ]);

  const speakResponse = (text) => {
    const synth = window.speechSynthesis;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US";
    synth.speak(utterance);
  };

  const handleFileChange = (event) => {
    setUploadedFile(event.target.files[0]);

  };

  const handleFileUpload = async () => {
    try {
      // console.log("≡ƒôé Requesting file selection from Electron...");
      handleClick();

      // const response = await axios.get("http://localhost:3001/select-file");
      const response = await axios.get(`$REACT_SELECT_FILE_URL`);


      if (response.data.status !== "success") {
        console.error("Γ¥î File selection failed:", response.data.message);
        setUploadedResponse("Failed to load file.");
        return;
      }

      // console.log("≡ƒô£ Extracted File Content:", response.data.content);

      // Store extracted file content but DO NOT send to AI yet
      setUploadedFile({
        name: response.data.fileName,
        content: response.data.content
      });

      setActiveModule("uploaded");  // Mark upload as active

    } catch (error) {
      console.error("Γ¥î Error selecting file:", error);
      setUploadedResponse("Error processing the file.");
    }
  };

  const handleSaveWhiteboard = async () => {
    if (!whiteboardRef.current) return;
    handleClick();

    whiteboardRef.current.getBase64(
      "png",
      false,
      false,
      (error, base64Image) => {
        if (error) {
          console.error("Γ¥î Whiteboard Save Error:", error);
          return;
        }

        // console.log("≡ƒû╝∩╕Å Whiteboard Captured:", base64Image.substring(0, 50) + "...");

        // Store whiteboard image in uploadedFile format
        setUploadedFile({
          name: `whiteboard_${Date.now()}.png`,
          content: `data:image/png;base64,${base64Image}`
        });

        setActiveModule("uploaded");  // Switch to uploaded mode after saving
      }
    );
  };


  const getCurrentVideoTime = () => {
    if (!videoRef.current || videoRef.current.currentTime === undefined) {
      // console.warn("ΓÜá∩╕Å Video reference not found or not playing.");
      return 0; // Default to 0 if not playing
    }
    return Math.floor(videoRef.current.currentTime); // Convert to seconds
  };


  const captureScreenshot = async (videoElement) => {
    if (!videoElement || videoElement.readyState < 2) {  // Check if the video is loaded
      // console.warn("ΓÜá∩╕Å No video element available for screenshot.");
      return null;
    }

    const canvas = document.createElement("canvas");
    canvas.width = videoElement.videoWidth;
    canvas.height = videoElement.videoHeight;
    console.log("[CAPTURE_IMAGE] width height",canvas.width, canvas.height);

    const ctx = canvas.getContext("2d");
    ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL("image/png"); // Γ£à Return as Base64 Image
  };

  const captureWebGLCanvasFromIframe = async (iframeElement) => {
    if (!iframeElement) {
      // console.warn("❌ No iframe element available for screenshot.");
      return null;
    }

    try {
      // console.log("📸 Capturing WebGL canvas screenshot using captureStream...");

      // Access the iframe's document and select the canvas
      const iframeDoc = iframeElement.contentDocument || iframeElement.contentWindow.document;
      const webglCanvas = iframeDoc.querySelector("canvas");
      if (!webglCanvas) {
        // console.warn("❌ No WebGL canvas found inside iframe.");
        return null;
      }

      // Capture a media stream from the WebGL canvas
      const stream = webglCanvas.captureStream();
      const video = document.createElement("video");
      video.srcObject = stream;
      video.play();

      // Wait until the video has loaded enough data
      await new Promise((resolve, reject) => {
        video.onloadeddata = () => resolve();
        video.onerror = (e) => reject(e);
      });

      // Wait a short period to ensure a frame is captured
      await new Promise(resolve => setTimeout(resolve, 200));

      // Create an offscreen canvas to draw the captured frame
      const offscreenCanvas = document.createElement("canvas");
      offscreenCanvas.width = webglCanvas.width;
      offscreenCanvas.height = webglCanvas.height;
      const ctx = offscreenCanvas.getContext("2d");

      // Draw the current frame from the video onto the offscreen canvas
      ctx.drawImage(video, 0, 0, webglCanvas.width, webglCanvas.height);

      // Clean up: stop all stream tracks
      stream.getTracks().forEach(track => track.stop());

      // Return the image as a data URL
      return offscreenCanvas.toDataURL("image/png");
    } catch (error) {
      console.error("❌ Error capturing WebGL canvas via captureStream:", error);
      return null;
    }
  };


  // // following is for pwo -- maybe we can do one for video and pwo and whiteboard etc in the future
  const captureIframeScreenshot = async (iframeElement) => {
    if (!iframeElement) {
      // console.warn("❌ No iframe element available for screenshot.");
      return null;
    }

    try {
      // console.log("📸 Capturing iframe screenshot...");

      // Capture full screen
      const canvas = await html2canvas(document.body, {
        useCORS: true,  // Enable cross-origin images (for best results)
        logging: false,
        scale: 1  // Keep it 1:1, adjust if needed for performance
      });

      // Get iframe position
      const rect = iframeElement.getBoundingClientRect();
      const croppedCanvas = document.createElement("canvas");
      croppedCanvas.width = rect.width;
      croppedCanvas.height = rect.height;

      const ctx = croppedCanvas.getContext("2d");
      ctx.drawImage(
        canvas,
        rect.left, rect.top, rect.width, rect.height, // Crop area
        0, 0, rect.width, rect.height // Destination area
      );

      return croppedCanvas.toDataURL("image/png");  // Return Base64 Image
    } catch (error) {
      console.error("❌ Error capturing WebGL iframe screenshot:", error);
      return null;
    }
  };

  const captureFullScreen = async () => {
    try {
      // console.log("📸 Capturing full screen screenshot...");

      // Capture the entire visible screen
      const canvas = await html2canvas(document.body, {
        useCORS: true, // Attempt to capture cross-origin images
        logging: false,
        scale: 1, // Keep it 1:1 for better debugging
      });

      const base64Image = canvas.toDataURL("image/png");

      if (!base64Image) {
        // console.warn("❌ Full screen capture failed, returning fallback image.");
        return "fallback-image.png";  // Debug fallback
      }

      // console.log("✅ Full screen screenshot captured successfully.");
      return base64Image;
    } catch (error) {
      console.error("❌ Error capturing full screen:", error);
      return "fallback-image.png";  // Always return a valid string
    }
  };

  const captureScreen = async () => {
    try {
      // console.log("📸 Requesting screen capture...");

      const stream = await navigator.mediaDevices.getDisplayMedia({ video: true });
      const video = document.createElement("video");
      video.srcObject = stream;
      video.play();

      await new Promise(resolve => video.onloadedmetadata = resolve);

      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      stream.getTracks().forEach(track => track.stop());

      // console.log("✅ Full-screen Screenshot Captured!");
      return canvas.toDataURL("image/png");
    } catch (error) {
      console.error("❌ Error capturing screen:", error);
      return null;
    }
  };


  // In your main application:
  const captureWebGLCanvas = async () => {
    try {
      // console.log("📸 Attempting to capture WebGL canvas...");

      const pwoIframe = document.getElementById("pwoIframe");
      if (!pwoIframe) {
        // console.warn("❌ No PWO iframe found.");
        return "fallback-image.png";
      }

      // Access the iframe's document. (This will work only if it's same-origin or properly CORS-enabled.)
      const iframeDoc = pwoIframe.contentWindow.document;
      const webglCanvas = iframeDoc.querySelector("canvas");
      if (!webglCanvas) {
        // console.warn("❌ No WebGL canvas found inside iframe.");
        return "fallback-image.png";
      }

      const canvas = document.createElement("canvas");
      canvas.width = webglCanvas.width;
      canvas.height = webglCanvas.height;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(webglCanvas, 0, 0, canvas.width, canvas.height);

      // console.log("✅ WebGL Canvas Screenshot Captured!");
      return canvas.toDataURL("image/png");
    } catch (error) {
      console.error("❌ Error capturing WebGL canvas:", error);
      return "fallback-image.png";
    }
  };

  // BDD 10/2/2025 New UI/UX
  // ===== Club Mode helpers/state (DROP-IN) =====
  // 10/5/2025
  //   const handleAskButtonPress = React.useCallback((maybeText, options = {}) => {
  //   setIsVoiceInput(false);

  //   const base =
  //     typeof maybeText === "string" && maybeText.trim()
  //       ? maybeText.trim()
  //       : (inputValue || "").trim();

  //   if (!base) return;

  //   // Apply “short/detailed” decorator if you’re using it
  //   const finalText = applyAnswerStyle ? applyAnswerStyle(base) : base;

  //   // Reflect into state so handlers that read from state stay in sync
  //   setInputValue(base);
  //   setQuestion(base);

  //   // 🔚 Always end in your existing handler
  //   if (typeof handleAsk === "function") {
  //     handleAsk(finalText, options);
  //   }
  // }, [inputValue, applyAnswerStyle, handleAsk, setInputValue, setQuestion, setIsVoiceInput]);

  // BDD 11/10/2025
  const handleAskButtonPress = React.useCallback(
    (maybeText, options = {}) => {
      setIsVoiceInput(false);

      const base =
        typeof maybeText === "string" && maybeText.trim()
          ? maybeText.trim()
          : (inputValue || "").trim();

      if (!base) return;

      const { text, answer_length } = applyAnswerStyle
        ? applyAnswerStyle(base)
        : { text: base, answer_length: undefined };

      setInputValue(base);
      setQuestion(base);

      // ZA 03/01/2026 - Remove the just-asked question from Curiosity Sparks
      // so it doesn't persist in the suggested questions panel after being asked.
      const _normQ = (s) => (s || "").trim().toLowerCase().replace(/[?!.,;:'"()\-–—]/g, "").replace(/\s+/g, " ").trim();
      const askedNorm = _normQ(base);
      if (askedNorm.length >= 5) {
        const _filterSparks = (list) =>
          list.filter((q) => {
            const qNorm = _normQ(q);
            if (!qNorm) return true;
            if (qNorm === askedNorm) return false;
            // substring containment
            if (qNorm.length > 10 && askedNorm.length > 10) {
              if (qNorm.includes(askedNorm) || askedNorm.includes(qNorm)) return false;
            }
            // high word overlap
            const qWords = new Set(qNorm.split(" ").filter(w => w.length > 2));
            const aWords = new Set(askedNorm.split(" ").filter(w => w.length > 2));
            if (qWords.size >= 3 && aWords.size >= 3) {
              let overlap = 0;
              for (const w of qWords) { if (aWords.has(w)) overlap++; }
              if (overlap / Math.min(qWords.size, aWords.size) > 0.8) return false;
            }
            return true;
          });
        // Check if a chapter spark will be removed (use ref to avoid stale closure)
        const prevChapterSparks = chapterSparksRef.current || [];
        const filteredChapterSparks = _filterSparks(prevChapterSparks);
        const chapterSparkRemoved = filteredChapterSparks.length < prevChapterSparks.length;

        setChapterSparks((prev) => _filterSparks(prev));
        setCollectionSparks((prev) => _filterSparks(prev));
        // Also update the cache so the question doesn't reappear on re-render
        if (chapterSparksCacheRef.current) {
          for (const [key, val] of chapterSparksCacheRef.current) {
            if (Array.isArray(val)) {
              chapterSparksCacheRef.current.set(key, _filterSparks(val));
            }
          }
        }

        // ZA 03/01/2026 - Fetch a replacement spark to keep the list full
        if (chapterSparkRemoved) {
          replenishSparks(base);
        }
      }

      // 🔹 Merge, do NOT break existing options
      const mergedOptions = { ...options };
      if (answer_length && !mergedOptions.answer_length) {
        mergedOptions.answer_length = answer_length;
      }

      if (typeof handleAsk === "function") {
        handleAsk(text, mergedOptions);
      }
    },
    [inputValue, applyAnswerStyle, handleAsk, setInputValue, setQuestion, setIsVoiceInput]
  );

  // 1) askFromUI: route chips/buttons into your existing ask flow
  // const askFromUI = (q) => {
  //   if (!q) return;
  //   try { setActiveSuggestedQuestion?.(q); } catch {}
  //   setQuestion(q);        // updates the "question" state (debounced pipeline)
  //   setInputValue(q);      // shows text in the input box
  //   handleAsk(q);          // your existing ask handler (customQuestion path)
  // };
  // 10/5/2025 - long short answers
  const askFromUI = React.useCallback((q, options = {}) => {
    if (!q) return;
    // keep the highlight behavior for sparks, etc.
    try { setActiveSuggestedQuestion?.(q); } catch { }

    // ✅ single path that sets state + calls handleAsk
    handleAskButtonPress(q, options);
  }, [handleAskButtonPress]);
  // BDD 10/5/2025 
  // Use this everywhere instead of calling handleAsk() directly.
  // BDD 04/14/2026 - basic_followups need some previous context
  const askFromAnywhere = React.useCallback(
    (text, options = {}) => {
      console.log("in askFromAnywhere", text);
      if (!text) return;

      try { setActiveSuggestedQuestion?.(text); } catch {}

      // BDD 04/14/2026 - auto-attach hidden follow-up metadata for basic followups
      let mergedOptions = { ...options };

      if (!mergedOptions.followupKind) {
        const followupMeta = suggestedQuestionsMeta?.followupMeta || null;
        const hidden = followupMeta?.[text];
        if (hidden) {
          mergedOptions = {
            ...mergedOptions,
            ...hidden,
          };
          console.log("[followupMeta] attached hidden followup options", {
            text,
            followupKind: mergedOptions.followupKind,
            previousAnswerLen: mergedOptions.previousAnswerText?.length || 0,
          });
        }
      }

      handleAskButtonPress(text, mergedOptions);
    },
    [handleAskButtonPress, suggestedQuestionsMeta]
  );
  // 2) rows state
  const [picks, setPicks] = useState([]);
  const [sparks, setSparks] = useState([]);

  // 3) flatten topics from your collectionCurriculum so we can render a small grid
  // const topicsFlat = useMemo(() => {
  //   const out = [];
  //   (collectionCurriculum || []).forEach(level => {
  //     (level.subjects || []).forEach(subject => {
  //       (subject.chapters || []).forEach(chap => {
  //         (chap.topics || []).forEach(topic => {
  //           // derive index from synthetic id: col-<collId>-t-<idx>
  //           let quizCountFromResolved = 0;
  //           const m = /-t-(\d+)$/.exec(String(topic.id || ""));
  //           if (m) {
  //             const idx = Number(m[1]);
  //             const item = collectionResolved?.items?.[idx];
  //             quizCountFromResolved = Array.isArray(item?.quiz?.questions)
  //               ? item.quiz.questions.length
  //               : 0;
  //           }
  //           out.push({
  //             topicId: topic.id,
  //             topicName: topic.name,
  //             chapterId: chap.id,
  //             chapterName: chap.name,
  //             subjectId: subject.id,
  //             subjectName: subject.name,
  //             sourceTopicId: topic.source_id ?? null,
  //             boardTopicId: topic.board_topic_id ?? null,
  //             topicImagePath: topic.topic_image_path ?? topic.topic_snapshot?.topic_image_path ?? null,
  //             pwoCount: Array.isArray(topic.pwos) ? topic.pwos.length : (expandedTopics[chap.id]?.[topic.id]?.pwos?.length ?? 0),
  //             videoCount: Array.isArray(topic.videos) ? topic.videos.length : (expandedTopics[chap.id]?.[topic.id]?.videos?.length ?? 0),
  //             quizCount: quizCountFromResolved, // ← now accurate
  //           });
  //         });
  //       });
  //     });
  //   });
  //   return out;
  // }, [collectionCurriculum, expandedTopics, collectionResolved]);
  // BDD 12/08/2025
  // const topicsFlat = useMemo(() => {
  //   const out = [];

  //   // 🔹 Single helper to choose the right label
  //   const labelOf = (node) =>
  //     (node?.display_name || node?.displayName || node?.name || "").trim();

  //   (collectionCurriculum || []).forEach((level) => {
  //     (level.subjects || []).forEach((subject) => {
  //       const subjectLabel = labelOf(subject);

  //       (subject.chapters || []).forEach((chap) => {
  //         const chapterLabel = labelOf(chap);

  //         (chap.topics || []).forEach((topic) => {
  //           const topicLabel = labelOf(topic);

  //           // derive index from synthetic id: col-<collId>-t-<idx>
  //           let quizCountFromResolved = 0;
  //           const m = /-t-(\d+)$/.exec(String(topic.id || ""));
  //           if (m) {
  //             const idx = Number(m[1]);
  //             const item = collectionResolved?.items?.[idx];
  //             quizCountFromResolved = Array.isArray(item?.quiz?.questions)
  //               ? item.quiz.questions.length
  //               : 0;
  //           }

  //           out.push({
  //             topicId: topic.id,
  //             // 🔹 use localized topic label if available
  //             topicName: topicLabel,

  //             chapterId: chap.id,
  //             // 🔹 localized chapter label
  //             chapterName: chapterLabel,

  //             subjectId: subject.id,
  //             // 🔹 localized subject label
  //             subjectName: subjectLabel,

  //             sourceTopicId: topic.source_id ?? null,
  //             boardTopicId: topic.board_topic_id ?? null,
  //             topicImagePath:
  //               topic.topic_image_path ??
  //               topic.topic_snapshot?.topic_image_path ??
  //               null,
  //             pwoCount: Array.isArray(topic.pwos)
  //               ? topic.pwos.length
  //               : expandedTopics[chap.id]?.[topic.id]?.pwos?.length ?? 0,
  //             videoCount: Array.isArray(topic.videos)
  //               ? topic.videos.length
  //               : expandedTopics[chap.id]?.[topic.id]?.videos?.length ?? 0,
  //             quizCount: quizCountFromResolved, // ← now accurate
  //           });
  //         });
  //       });
  //     });
  //   });

  //   return out;
  // }, [collectionCurriculum, expandedTopics, collectionResolved]);

  // BDD 03/24/2026
  const topicsFlat = useMemo(() => {
    const out = [];

    const labelOf = (node) =>
      (node?.display_name || node?.displayName || node?.name || "").trim();

    (collectionCurriculum || []).forEach((level) => {
      (level.subjects || []).forEach((subject) => {
        const subjectLabel = labelOf(subject);

        (subject.chapters || []).forEach((chap) => {
          const chapterLabel = labelOf(chap);

          (chap.topics || []).forEach((topic) => {
            const topicLabel = labelOf(topic);

            // derive index from synthetic id: col-<collId>-t-<idx>
            let quizCountFromResolved = 0;
            let videoCountFromResolved = 0;
            let pwoCountFromResolved = 0;
            let videosFromResolved = [];
            let pwosFromResolved = [];

            const m = /-t-(\d+)$/.exec(String(topic.id || ""));
            if (m) {
              const idx = Number(m[1]);
              const item = collectionResolved?.items?.[idx];
              const resolvedQuizCount = Number(item?.quiz_count ?? item?.quiz?.count);
              const resolvedVideoCount = Number(item?.video_count);
              const resolvedPwoCount = Number(item?.pwo_count);

              quizCountFromResolved = Number.isFinite(resolvedQuizCount)
                ? resolvedQuizCount
                : (Array.isArray(item?.quiz?.questions) ? item.quiz.questions.length : 0);

              videoCountFromResolved = Number.isFinite(resolvedVideoCount)
                ? resolvedVideoCount
                : (Array.isArray(item?.videos) ? item.videos.length : 0);

              pwoCountFromResolved = Number.isFinite(resolvedPwoCount)
                ? resolvedPwoCount
                : (Array.isArray(item?.pwos) ? item.pwos.length : 0);

              videosFromResolved = Array.isArray(item?.videos) ? item.videos : [];
              pwosFromResolved = Array.isArray(item?.pwos) ? item.pwos : [];
            }

            out.push({
              topicId: topic.id,
              topicName: topicLabel,

              chapterId: chap.id,
              chapterName: chapterLabel,

              subjectId: subject.id,
              subjectName: subjectLabel,

              sourceTopicId: topic.source_id ?? null,
              boardTopicId: topic.board_topic_id ?? null,
              topicImagePath:
                topic.topic_image_path ??
                topic.topic_snapshot?.topic_image_path ??
                null,

              // keep raw arrays too, so downstream handlers can use them if needed
              videos: videosFromResolved.length ? videosFromResolved : (Array.isArray(topic.videos) ? topic.videos : []),
              pwos: pwosFromResolved.length ? pwosFromResolved : (Array.isArray(topic.pwos) ? topic.pwos : []),

              // IMPORTANT: source counts from resolved item first
              videoCount: videoCountFromResolved || (Array.isArray(topic.videos) ? topic.videos.length : 0),
              pwoCount: pwoCountFromResolved || (Array.isArray(topic.pwos) ? topic.pwos.length : 0),
              quizCount: quizCountFromResolved,
            });
          });
        });
      });
    });

    return out;
  }, [collectionCurriculum, collectionResolved]);
  // // 4) build "Today's Picks" (teacher voice) from current collection
  // useEffect(() => {
  //   const colName = activeStudyCollection?.name || t("this module");
  //   const first = topicsFlat[0];

  //   setPicks([
  //     {
  //       key: "next",
  //       label: first ? `${t("Next Up")}: ${first.topicName}` : t("Next Up"),
  //       icon: "arrow-right-bold-circle-outline",
  //       onPress: () => askFromUI(
  //         first ? `${t("Guide me through")} ${first.topicName} ${t("step by step")}`
  //               : `${t("Guide me to the next topic in")} ${colName}`
  //       ),
  //     },
  //     {
  //       key: "revisit",
  //       label: t("Revisit: quick check"),
  //       icon: "history",
  //       onPress: () => askFromUI(`${t("Give me a short review quiz in")} ${colName}`),
  //     },
  //     {
  //       key: "challenge",
  //       label: t("Challenge Me"),
  //       icon: "rocket-launch-outline",
  //       onPress: () => askFromUI(`${t("Challenge me with a harder example in")} ${colName}`),
  //     },
  //   ]);
  // }, [activeStudyCollection?.id, topicsFlat.length]);
  // BDD 10/5/2025
  // Today’s Picks (teacher voice)
  // useEffect(() => {
  //   const colName = activeStudyCollection?.name || t("this module");
  //   const list = topicsFlat || [];

  //   if (!list.length) {
  //     setPicks([]);
  //     return;
  //   }

  //   const first = list[0];

  //   // find a topic with some quizzes for “Revisit”
  //   const revisit = list.find(x => (x.quizCount ?? 0) > 0) || list[Math.min(1, list.length - 1)];

  //   // challenge = a random topic that’s not the first or revisit
  //   const pool = list.filter(x => x.topicId !== first.topicId && x.topicId !== revisit.topicId);
  //   const challenge = pool.length ? pool[Math.floor(Math.random() * pool.length)] : list[list.length - 1];

  //   setPicks([
  //     {
  //       key: "next",
  //       label: first ? `${t("Next Up")}: ${first.topicName}` : t("Next Up"),
  //       icon: "arrow-right-bold-circle-outline",
  //       onPress: () => askFromUI(
  //         first ? `${t("Guide me through")} ${first.topicName} ${t("step by step")}`
  //               : `${t("Guide me to the next topic in")} ${colName}`
  //       ),
  //     },
  //     {
  //       key: "revisit",
  //       label: `${t("Revisit")}: ${revisit.topicName}`,
  //       icon: "history",
  //       onPress: () => askFromUI(`${t("Give me a short review quiz in")} ${revisit.topicName}`),
  //     },
  //     {
  //       key: "challenge",
  //       label: `${t("Challenge Me")}: ${challenge.topicName}`,
  //       icon: "rocket-launch-outline",
  //       onPress: () => askFromUI(`${t("Challenge me with a harder example in")} ${challenge.topicName}`),
  //     },
  //   ]);
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [activeStudyCollection?.id, topicsFlat.length]);


  // BDD 12/09/2025 Localization For Collections
  // BDD 02/11/2026 - I think I deleted this by mistake
  useEffect(() => {
    const colId = activeStudyCollection?.id;

      // ✅ guard: collection sparks only when a collection is active AND viewMode is collections
      if (!colId) return;
      if (viewMode !== "collections") return;

    // ≡ƒöæ normalize language for cache + fetch
    const langKey =
      typeof selectedSecondaryLang === "string" &&
        selectedSecondaryLang.toLowerCase() !== "auto"
        ? selectedSecondaryLang.toLowerCase()
        : "en";

    const cacheKey = colId ? `${colId}|${langKey}|${sparkTopicId || "first"}` : null;

    console.log("[Sparks useEffect] run", {
      colId,
      sparkTopicId,
      topicsFlatLen: topicsFlat.length,
      cacheKey,
      langKey,
    });

    // ≡ƒåò 1) If the language changed, refetch the resolved collection
    if (colId) {
      const prevLangKey = lastLangKeyForCollectionRef.current;

      if (prevLangKey === null) {
        // first time we see a collection+lang; just remember it, don't refetch
        lastLangKeyForCollectionRef.current = langKey;
      } else if (prevLangKey !== langKey) {
        // language changed ΓåÆ update ref and refetch
        lastLangKeyForCollectionRef.current = langKey;

        console.log("[i18n][collections] langKey changed ΓåÆ refetching collection", {
          colId,
          prevLangKey,
          newLangKey: langKey,
        });

        (async () => {
          try {
            // openStudentCollection already knows how to call
            // apiGetCollectionResolved with the current lang
            await openStudentCollection(activeStudyCollection, "lang-change");
          } catch (err) {
            console.error(
              "[i18n][collections] failed to refetch resolved collection on language change",
              err
            );
          }
        })();
      }
    }

    // ≡ƒƒª Existing Sparks logic ΓÇö unchanged
    if (cacheKey) {
      const cached = sparksCacheRef.current.get(cacheKey);
      if (cached) {
        console.log("[Sparks useEffect] using cached list, length", cached.length);
        setCollectionSparks(cached); //BDD 02/11/2026
        return;
      }
    }

    let cancelled = false;

    (async () => {
      // prefer the chosen topic, otherwise first tile
      const topicNode =
        (sparkTopicId && topicsFlat.find((x) => x.topicId === sparkTopicId)) ||
        topicsFlat?.[0];

      console.log("[Sparks useEffect] topicNode", {
        topicId: topicNode?.topicId,
        subjectName: topicNode?.subjectName,
        chapterName: topicNode?.chapterName,
        topicName: topicNode?.topicName,
      });

      // Γ£à 1) Try curated collection prompts for "collection" context
      let list = [];
      if (activeStudyCollection?.id) {
        list = await fetchCollectionPromptsRaw("collection");
        console.log("[Sparks useEffect] DB list length", list?.length);
      }

      if ((!list || list.length === 0) && !topicNode) {
        console.log("[Sparks useEffect] DB empty but topicNode not ready; waiting for topicsFlat...");
        return; // effect will rerun when topicsFlat.length changes
      }

      // Γ£à 2) If no curated prompts, fall back to GPT-based suggestions
      if (!list || list.length === 0) {
        const ctx = {
          subject: topicNode?.subjectName || "",
          chapter: topicNode?.chapterName || "",
          topic: topicNode?.topicName || "",
          collection_id: activeStudyCollection?.id ?? null,
          collection_name: activeStudyCollection?.name ?? "",
          collection_info: activeStudyCollection?.info ?? "",
          current_view: viewMode === "collections" ? "collection" : (module || "question"),
          current_question: "",
          current_answer: "",
          instructions: "",
        };

        console.log(
          "[Sparks useEffect] DB empty ΓåÆ falling back to GPT /suggested_questions with ctx",
          ctx
        );

        list = await fetchSuggestedQuestions(ctx);
        console.log("[Sparks useEffect] GPT list length", list?.length);
      }

      if (cancelled) {
        console.log("[Sparks useEffect] cancelled, aborting setState");
        return;
      }

      const finalList = Array.isArray(list) ? list : [];
      console.log("[Sparks useEffect] finalList length", finalList.length);

      setCollectionSparks(finalList); // BDD 02/11/2026

      if (cacheKey && finalList.length) {
        console.log("[Sparks useEffect] caching finalList under", cacheKey);
        sparksCacheRef.current.set(cacheKey, finalList);
      }
    })();

    return () => {
      cancelled = true;
    };
    // include sparkTopicId so this reruns when the student changes topic
    // and selectedSecondaryLang so it reruns when language changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStudyCollection?.id, topicsFlat.length, sparkTopicId, selectedSecondaryLang]);


  // BDD 02/11/2026 - Chapter level Curiosity Sparks (single source of truth) - ty2
  useEffect(() => {
    console.log("[ChapterSparks effect check]", {
      viewMode,
      selectedChapterId,
      user_id,
      activeCollectionId: activeStudyCollection?.id ?? null,
    });

    if (viewMode !== "curriculum") return;
    if (!selectedChapterId) return;
    if (!user_id) return;

    // ✅ HOLISTIC FIX:
    // If a collection is still active while we’re in curriculum,
    // clear it and continue (don’t block chapter sparks).
    if (activeStudyCollection?.id) {
      console.log("[ChapterSparks] curriculum mode but collection still active -> clearing", activeStudyCollection.id);

      // Prefer your centralized clearer if available:
      if (typeof clearStudentCollection === "function") {
        clearStudentCollection();
      } else {
        setActiveStudyCollection(null);
      }

      setCollectionSparks([]); // prevent stale sparks from showing
    }

    const chapterName =
      (selectedChapter && selectedChapter.chapterName) ||
      lastChapterTitleRef.current ||
      "";

    const subjectName =
      (selectedChapter && selectedChapter.subjectName) ||
      lastChapterSubjectRef.current ||
      "";

    refreshChapterSparksOnce({
      chapterId: selectedChapterId,
      chapterName,
      subjectName,
    });

  }, [
    viewMode,
    selectedChapterId,
    selectedSecondaryLang,
    currentCurriculum,
    contentDb,
    user_id,
    activeStudyCollection?.id,
  ]);


    
  
          // ==============================
        // BDD 01/25/2026 - Resume State (Continue)
        // BDD 01/25/2026 studen resum states
        // ==============================
        // BDD 01/25/2026 studen resum states
        const RESUME_WORKSPACES = {
          LEARNING: "LEARNING",
          CURIOSITY_AI: "CURIOSITY_AI",
        };

        // BDD 01/25/2026 studen resum states
        const safeUpper = (s) => (typeof s === "string" ? s.trim().toUpperCase() : "");
        const safeNum = (v) => {
          const n = Number(v);
          return Number.isFinite(n) ? n : null;
        };
        // BDD 01/25/2026 studen resum states
        const parseIsoMs = (iso) => {
          const t = Date.parse(iso || "");
          return Number.isFinite(t) ? t : 0;
        };
        // BDD 01/25/2026 studen resum states
        const fetchResumeState = async (workspace) => {
          try {
            const resp = await axios.get(`${FASTAPI_BASE_URL}/resume_state`, {
              params: { workspace, user_id: user_id },
              timeout: 15000,
            });
            return resp?.data?.resume_state || null;
          } catch (e) {
            console.warn("[resume_state] GET failed", workspace, e?.response?.status, e?.response?.data || e?.message);
            return null;
          }
        };
        // BDD 01/25/2026 studen resum states
        const postResumeState = async (payload) => {
          try {
            const resp = await axios.post(`${FASTAPI_BASE_URL}/resume_state`, payload, {
              params: { user_id: user_id },
              timeout: 15000,
            });
            return resp?.data?.resume_state || null;
          } catch (e) {
            console.warn("[resume_state] POST failed", e?.response?.status, e?.response?.data || e?.message);
            return null;
          }
        };
        // BDD 01/25/2026 studen resum states
        // Convenience for LEARNING bookmark updates when launching an asset.
        const updateLearningResumeForAsset = async ({
          content_db,
          scope_type,
          scope_source_id,
          asset_type,
          asset_source_id,
          state_json,
        }) => {
          return await postResumeState({
            workspace: RESUME_WORKSPACES.LEARNING,
            content_db: content_db ?? null,
            scope_type: scope_type ?? null,
            scope_source_id: safeNum(scope_source_id),
            asset_type: asset_type ?? null,
            asset_source_id: safeNum(asset_source_id),
            state_json: state_json ?? null,
          });
        };
        // BDD 01/25/2026 studen resum states
        const [continueBusy, setContinueBusy] = React.useState(false);
        // BDD 01/25/2026 studen resum states
        const handleContinuePress = React.useCallback(async () => {
          if (continueBusy) return;

          // Respect your “assessment/test cannot be interrupted” policy
          const canClose = await handleCloseModule(true);
          if (showQuiz && quizMode === "test" && !canClose) return;

          setContinueBusy(true);
          try {
            const learning = await fetchResumeState(RESUME_WORKSPACES.LEARNING);
            const curiosity = await fetchResumeState(RESUME_WORKSPACES.CURIOSITY_AI);

            const chosen =
              !learning && !curiosity
                ? null
                : !learning
                  ? curiosity
                  : !curiosity
                    ? learning
                    : (parseIsoMs(learning.updated_at) >= parseIsoMs(curiosity.updated_at) ? learning : curiosity);

            if (!chosen) {
              Alert.alert(t("Continue"), t("Nothing to continue yet. Ask a question or open a video/PWO first."));
              return;
            }

            const ws = safeUpper(chosen.workspace);

            // ---- CURIOSITY_AI: jump to chat/history session ----
            // if (ws === RESUME_WORKSPACES.CURIOSITY_AI) {
            //   setActiveSidebarTab("history");
            //   const convoId = chosen?.ai_pointer?.conversation_id ?? null;
            //   if (convoId != null) {
            //     setSelectedConversationId(convoId);
            //     fetchChatSessions(10);
            //   } else {
            //     // Still useful: user sees their history list
            //     fetchChatSessions(10);
            //   }
            //   return;
            // }

            // ---- CURIOSITY_AI: jump to chat/history session ----
            if (ws === RESUME_WORKSPACES.CURIOSITY_AI) {
              await makeContinueChatHandler({
                getCuriosityResumeState: () => chosen,
                fetchChatSessionsDirect,
                openChatSession,
                setActiveModule,
                setLearningSubModule,
                setActiveSidebarTab,
                alert: (title, message) => Alert.alert(title, message),
                t,
              })();
              return;
            }

            // ---- LEARNING: try asset first (Video/PWO), else scope (Collection/Chapter) ----
            const assetType = safeUpper(chosen.asset_type);
            const assetId = safeNum(chosen.asset_source_id);
            const scopeType = safeUpper(chosen.scope_type);
            const scopeId = safeNum(chosen.scope_source_id);
            const stateJson = chosen.state_json || {};
            const aiMeta = chosen?.ai_pointer?.context_metadata || {};

            // If we have a VIDEO bookmark, prefer reopening video
            if (assetType === "VIDEO" && assetId != null) {
              const tagId =
                safeNum(stateJson?.tag_id) ??
                safeNum(aiMeta?.video_tag_id) ??
                safeNum(aiMeta?.video_tag) ??
                null;

              const boardTopicId = safeNum(stateJson?.board_topic_id) ?? null;

              if (!tagId) {
                Alert.alert(t("Continue"), t("Found a video to continue, but tag_id is missing. Open the topic and pick the video."));
                return;
              }

              // Navigate to chapter first so closing the video lands in the right place
              if (scopeType === "CHAPTER" && scopeId != null) {
                handleChapterClick({ chapterId: scopeId, id: scopeId });
              }

              await handleVideoClick(
                assetId,
                tagId,
                authToken,
                (scopeType === "CHAPTER" && scopeId != null) ? scopeId : null,  // chapterID from resume state
                boardTopicId,  // topicID optional
                false          // isAuto
              );
              return;
            }

            // If we have a PWO bookmark, prefer reopening PWO
            if (assetType === "PWO" && assetId != null) {
              const sceneName =
                (stateJson?.pwo_scene_name || stateJson?.pwo_scene || aiMeta?.pwo_scene || aiMeta?.pwo_scene_name || "").trim() || null;

              if (!sceneName) {
                Alert.alert(t("Continue"), t("Found a PWO to continue, but scene name is missing. Open the topic and pick the PWO."));
                return;
              }

              // Navigate to chapter first so closing the PWO lands in the right place
              if (scopeType === "CHAPTER" && scopeId != null) {
                handleChapterClick({ chapterId: scopeId, id: scopeId });
              }

              await handlePWOClick(
                assetId,
                sceneName,
                authToken,
                selectedSecondaryLang,  // lang/debug param
                (scopeType === "CHAPTER" && scopeId != null) ? scopeId : null,
                safeNum(stateJson?.board_topic_id) ?? null,
                false
              );
              return;
            }

            // Otherwise, fall back to scope navigation
            if (scopeType === "COLLECTION" && scopeId != null) {
              handleCollectionClick({
                id: scopeId,
                collection_id: scopeId,
                name: stateJson?.collection_name || `Collection ${scopeId}`,
                base_board: chosen.content_db || stateJson?.content_db || contentDb,
              });
              return;
            }

            if (scopeType === "CHAPTER" && scopeId != null) {
              handleChapterClick({ chapterId: scopeId, id: scopeId });
              return;
            }

            const learningConvoId = chosen?.ai_pointer?.conversation_id ?? null;
              if (learningConvoId != null && (assetId == null)) {
                setActiveSidebarTab("history");
                await openChatSession(learningConvoId, 200);
                return;
              }

            // If we only know “LEARNING” but no scope/asset, just bring user to learning tab
            setActiveModule("learning");
            Alert.alert(t("Continue"), t("We found your learning context, but it has no specific asset. Opening Learning."));
          } catch (e) {
            console.warn("[Continue] failed:", e);
            Alert.alert(t("Continue"), t("Could not continue right now."));
          } finally {
            setContinueBusy(false);
          }
        }, [
          continueBusy,
          authToken,
          selectedSecondaryLang,
          handleVideoClick,
          handlePWOClick,
          handleCollectionClick,
          handleChapterClick,
          handleCloseModule,
          showQuiz,
          quizMode,
          setActiveSidebarTab,
          setSelectedConversationId,
          fetchChatSessions,
          setActiveModule,
          t,
          contentDb,
          user_id,
        ]);

  // BDD 01/25/2026 - helper: fetch sessions directly (for Continue → AI fallback)
  const fetchChatSessionsDirect = async (limit = 50) => {
    if (!user_id) return [];
    const url =
      `${FASTAPI_BASE_URL}/chat_sessions`
      + `?user_id=${encodeURIComponent(user_id)}`
      + `&limit=${encodeURIComponent(limit)}`;

    console.log("🗂️ Fetching chat sessions (direct):", url);

    try {
      const res = await axios.get(url, { timeout: 15000 });
      const d = res?.data;

      if (Array.isArray(d)) return d;
      if (Array.isArray(d?.sessions)) return d.sessions;
      if (Array.isArray(d?.chat_sessions)) return d.chat_sessions;
      if (Array.isArray(d?.items)) return d.items;

      return [];
    } catch (e) {
      console.warn("[Continue] fetchChatSessionsDirect failed:", e?.response?.status, e?.response?.data || e?.message);
      return [];
    }
  };


  // ===== simple inline UI helpers (no new files) =====
  // BDD 10/5/2025
  const ChipRow = ({ title, items = [], wrap = false, isDarkMode }) => {
    const chipBg = isDarkMode ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.06)";
    const textColor = isDarkMode ? "#fff" : "#111";

    const Chip = ({ p }) => {
      const firedRef = React.useRef(false);

      const fire = React.useCallback((from) => {
        if (firedRef.current) return;          // de-dupe bursty events
        firedRef.current = true;
        setTimeout(() => { firedRef.current = false; }, 200); // small cooldown

        console.log("[chip fire]", from, p.key, p.label);
        if (typeof p.onPress === "function") p.onPress();
      }, [p]);

      return (
        <TouchableOpacity
          onPress={() => fire("onPress")}
          onPressIn={() => console.log("[chip onPressIn]", p.key)}
          {...(Platform.OS === "web"
            ? {
              onClick: (e) => { e.preventDefault?.(); fire("onClick"); },
              onMouseDown: () => console.log("[chip onMouseDown]", p.key),
              onMouseUp: () => fire("onMouseUp"),
              onTouchEnd: () => fire("onTouchEnd"),
              onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") { e.preventDefault?.(); fire("onKeyDown"); }
              },
            }
            : {})}
          accessibilityRole="button"
          accessibilityLabel={p.label}
          hitSlop={{ top: 6, bottom: 6, left: 6, right: 6 }}
          style={{
            flexDirection: "row",
            alignItems: "center",
            paddingHorizontal: 14,
            paddingVertical: 10,
            borderRadius: 18,
            marginRight: 10,
            marginBottom: wrap ? 8 : 0,
            backgroundColor: chipBg,
            maxWidth: wrap ? 340 : 300,
            ...(Platform.OS === "web"
              ? { cursor: "pointer", userSelect: "none", touchAction: "manipulation", outlineStyle: "none" }
              : null),
          }}
        >
          {p.icon ? (
            <MaterialCommunityIcons name={p.icon} size={18} color={textColor} />
          ) : null}
          <Text
            style={{
              fontSize: rem(13) + 'rem',
              color: isDarkMode ? "#e6e9f2" : "#333",
              flexShrink: 1,
              marginLeft: p.icon ? 8 : 0,
            }}
            numberOfLines={2}
            ellipsizeMode="tail"
          >
            {p.label}
          </Text>
        </TouchableOpacity>
      );
    };

    return (
      <View style={{ paddingHorizontal: 16, paddingTop: 10, position: "relative" }} pointerEvents="auto">
        {title ? (
          <Text style={{ marginBottom: 8, color: isDarkMode ? "#cfd6e4" : "#5f6b7a", fontWeight: "600" }}>
            {title}
          </Text>
        ) : null}

        {wrap ? (
          <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
            {items.map((p, i) => <Chip key={p.key ?? i} p={p} />)}
          </View>
        ) : (
          <ScrollView
            horizontal
            keyboardShouldPersistTaps="always"
            showsHorizontalScrollIndicator={false}
            contentContainerStyle={{ alignItems: "center", paddingRight: 16 }}
            pointerEvents="auto"
          >
            {items.map((p, i) => <Chip key={p.key ?? i} p={p} />)}
          </ScrollView>
        )}
      </View>
    );
  };

  // BDD 10/5/2025
  const resolveTopicImgUrl = React.useCallback((rawPath) => {
    if (!rawPath || !imageUrlMap) return null;
    const stripped = String(rawPath).replace(/^\/?content_streaming\/image\/?/, "");
    const cleaned = stripped.replace(/\/{2,}/g, "/");
    return imageUrlMap[cleaned] || imageUrlMap[stripped] || null;
  }, [imageUrlMap]);
  // BDD 10/5/2025

  // a stable key per user+collection
  const LAST_KEY = useMemo(
    () => `last_activity:${user_id || "anon"}:${activeStudyCollection?.id || "none"}`,
    [user_id, activeStudyCollection?.id]
  );

  // persist + update in-memory
  const saveLastActivity = React.useCallback(
    async (activity) => {
      const record = { ...activity, ts: Date.now() };
      try { await AsyncStorage.setItem(LAST_KEY, JSON.stringify(record)); } catch { }
      setLastActivity(record);
    },
    [LAST_KEY]
  );

  // const onStartTopic = React.useCallback((item) => {
  //   setSparkTopicId(item.topicId);
  //   saveLastActivity({
  //     kind: "guide",
  //     topicId: item.topicId,
  //     topicName: item.topicName,
  //   });
  //   const q = `${t("Guide me through")} ${item.topicName} ${t("step by step")}`;
  //   // askFromUI(`${t("Guide me through")} ${item.topicName} ${t("step by step")}`);
  //   askFromUI(q);
  // }, [askFromUI, saveLastActivity, t]);
  // BDD 10/17/2025
  const onStartTopic = React.useCallback((item) => {
    // AIT-180: guard against missing topic name
    if (!item?.topicName && !item?.displayName && !item?.name) {
      console.warn("[onStartTopic] No topic name on item:", item);
      Alert.alert(t("Topic Unavailable"), t("Please select a topic from the list to get a summary."));
      return;
    }

    setSparkTopicId(item.topicId);

    // Save last viewed topic for home screen
    saveLastViewedTopic(item, item.chapterName, resolveTopicImgUrl(item.topicImagePath));

    // persist "last activity" exactly as before
    saveLastActivity({
      kind: "guide",
      topicId: item.topicId,
      topicName: item.topicName,
    });

    // build context: chapter/subject (if present) and/or collection
    const contextBits = [];
    if (item?.subjectName) contextBits.push(`${t("Subject")}: ${item.subjectName}`);
    if (item?.chapterName) contextBits.push(`${t("Chapter")}: ${item.chapterName}`);
    if (activeStudyCollection?.name) contextBits.push(`${t("Collection")}: ${activeStudyCollection.name}`);

    // include what’s available to explore (only if >0)
    const affordances = [];
    const vc = Number(item.videoCount || 0);
    const pc = Number(item.pwoCount || 0);
    const qc = Number(item.quizCount || 0);
    if (vc > 0) affordances.push(`${vc} ${t("videos")}`);
    if (pc > 0) affordances.push(`${pc} ${t("scenes")}`);
    if (qc > 0) affordances.push(`${qc} ${t("quiz questions")}`);

    // keep functionality: still asks the tutor; switch to an “overview” wording
    const q = `${t("Give me a quick overview of")} ${item.topicName}. ${t("Highlight key ideas, common misconceptions, and what to practice next.")}`;

    // pass extra context via customInstructions (read by handleAsk → requestData.custom_instructions)
    const customInstructions = {
      intent: "topic_overview",
      subject: item.subjectName || null,
      chapter: item.chapterName || null,
      topic: item.topicName,
      collection: activeStudyCollection?.name || null,
      board_topic_id: item.boardTopicId ?? item.board_topic_id ?? null,
      source_topic_id: item.sourceTopicId ?? item.source_id ?? null,
      affordances: {
        videos: vc,
        scenes: pc,
        quiz_questions: qc,
      },
      // small hint for the LLM to advertise next actions to the user
      footer_hint: affordances.length
        ? t("You can also explore: ") + affordances.join(", ") + "."
        : null,
      // keep responses tight for the “summary” entry point
      output_style: "3–5 bullets + 2 example questions",
    };

    // AIT-180: build topicScope so handleAsk can set context.topic and scope the question
    const topicScope = {
      topic_name: item.topicName || null,
      board_topic_id: item.boardTopicId ?? item.board_topic_id ?? null,
      source_topic_id: item.sourceTopicId ?? item.source_id ?? null,
      chapter_name: item.chapterName || null,
      chapterId: item.chapterId || null,
      topicId: item.topicId || null,
    };

    console.log("[onStartTopic] resolved context:", {
      topicName: item.topicName, topicId: item.topicId,
      boardTopicId: item.boardTopicId ?? item.board_topic_id,
      sourceTopicId: item.sourceTopicId ?? item.source_id,
      chapterId: item.chapterId, collection: activeStudyCollection?.name,
    });

    askFromUI(q, { customInstructions, topicScope, forceNewDialog: true });
  }, [askFromUI, saveLastActivity, saveLastViewedTopic, t, activeStudyCollection]);

  // BDD 10/17/2025 - updating to handle curriculum view with topicsflat style

  // BDD 10/17/2025
  // const ensureTopicLoaded = async (chapterId, topicId) => {
  //   const loaded = !!expandedTopics[chapterId]?.[topicId]?.videos;
  //   // if (!loaded) await toggleExpandTopic(chapterId, topicId);
  //   if (!loaded) await toggleExpandTopic(chapterId, topicId, {
  //                         topic_name: topic.displayName || topic.topicName || topic.name || "",
  //                         chapter_name: chapter.displayName || chapter.name || "",
  //                         source_topic_id: topic.sourceTopicId || topic.source_topic_id || topic.source_id || null,
  //                       });

  // };

  const ensureTopicLoaded = async (chapterId, topicId, topicMeta = null) => {
    const loaded = !!expandedTopics[chapterId]?.[topicId]?.videos;
    if (!loaded) {
      await toggleExpandTopic(chapterId, topicId, topicMeta);
    }
  };

  // BDD 12/08/2025
  const topicLabelOf = (item) =>
    (item.displayName || item.topicName || "").trim();

  // Actually launch the quiz (called from quiz info modal)
  const launchQuiz = React.useCallback(
    async (item) => {
      const boardId =
        item.boardTopicId ||
        item.board_topic_id ||
        resolveBoardTopicId(item.topicId);

      const mappedSourceTopicId =
        boardToSourceTopicMap?.[String(boardId)] ?? null;

      const quizTopicId =
        item.sourceTopicId ||
        item.source_topic_id ||
        item.source_id ||
        mappedSourceTopicId ||
        null;

      const topicLabel = topicLabelOf(item);
      const scopeNow = {
        chapterId: item.chapterId ?? null,
        topicId: item.topicId ?? null,
        board_topic_id: boardId ?? null,
        source_topic_id: quizTopicId,
        topic_name: (topicLabel || item.topicName || "").trim(),
        chapter_name: (item.chapterName || item.chapter_name || "").trim(),
        chapter_id: item.chapterId ?? null,
      };

      activeTopicForAIRef.current = scopeNow;
      setSuggestedQuestionsMeta({ kind: "topic", topicScope: scopeNow });

      saveLastActivity({
        kind: "quiz",
        topicId: item.topicId,
        topicName: topicLabel || item.topicName,
        sourceId: quizTopicId || null,
      });

      setQuizInfoModal((prev) => ({ ...prev, visible: false }));

      await fetchQuiz(
        quizTopicId,
        languageIDquiz,
        item.subjectName,
        item.subjectId,
        topicLabel || item.topicName,
        item.chapterName || item.chapter_name
      );
    },
    [
      fetchQuiz,
      saveLastActivity,
      languageIDquiz,
      resolveBoardTopicId,
      boardToSourceTopicMap,
      topicLabelOf,
      setSuggestedQuestionsMeta,
    ]
  );

  const onOpenQuiz = React.useCallback(
    (item) => {
      const boardId =
        item.boardTopicId ||
        item.board_topic_id ||
        resolveBoardTopicId(item.topicId);

      const mappedSourceTopicId =
        boardToSourceTopicMap?.[String(boardId)] ?? null;

      const quizTopicId =
        item.sourceTopicId ||
        item.source_topic_id ||
        item.source_id ||
        mappedSourceTopicId ||
        null;

      // Fast-fail if no quiz available
      if (
        quizTopicId &&
        Number.isFinite(quizCountMap?.[quizTopicId]) &&
        quizCountMap[quizTopicId] === 0
      ) {
        Alert.alert(t("No quiz available"), t("We could not find a quiz for this topic."));
        return;
      }
      if (!quizTopicId) {
        Alert.alert(t("No quiz available"), t("We could not find a quiz for this topic."));
        return;
      }

      const topicLabel = topicLabelOf(item);

      // Show quiz info modal with loading state
      setQuizInfoModal({
        visible: true,
        item,
        topicLabel: topicLabel || item.topicName || "",
        loading: true,
        count: 0,
        bestCorrect: null,
        bestTotal: null,
        attempts: [],
      });

      // Fetch attempt history
      if (user_id && user_id !== "Guest") {
        axios.get(
          `${FASTAPI_BASE_URL}/student/${encodeURIComponent(user_id)}/quiz-engagement-history`,
          { params: { source_topic_id: quizTopicId } }
        ).then(({ data }) => {
          const attempts = data?.attempts || [];
          const completed = attempts.filter(a => a.correct_answers != null && a.total_questions != null);
          const bestAttempt = completed.length > 0
            ? completed.reduce((best, a) => (a.correct_answers > best.correct_answers ? a : best), completed[0])
            : null;
          setQuizInfoModal((prev) => {
            if (!prev.visible) return prev;
            return {
              ...prev,
              loading: false,
              count: attempts.length,
              bestCorrect: bestAttempt?.correct_answers ?? null,
              bestTotal: bestAttempt?.total_questions ?? null,
              attempts,
            };
          });
        }).catch(() => {
          setQuizInfoModal((prev) => ({ ...prev, loading: false }));
        });
      } else {
        setQuizInfoModal((prev) => ({ ...prev, loading: false }));
      }
    },
    [
      t,
      quizCountMap,
      resolveBoardTopicId,
      boardToSourceTopicMap,
      topicLabelOf,
    ]
  );

  /**
   * Open the Saras asset a lesson block points at, in place inside the step.
   * The lesson stays on screen throughout; the step is still readable beside
   * the scene, the clip or the quiz that was opened from it.
   */
  const handleLessonPlanLaunch = React.useCallback((block) => {
    const resolved = block?.resolved_asset;
    if (!resolved || block.resolution_status !== "resolved") return;

    // Every authored asset now opens inside the step — the 3D scene, the video
    // segment, and as of the inline quiz player the topic quiz too. There is
    // nothing to launch *out* to any more, so this sets no excursion ref and
    // changes no module: LessonPwoPlayer, LessonVideoPlayer and
    // LessonQuizPlayer all render off `lessonPlanActiveBlockId` and drive
    // Unity, hls.js and the question bank themselves. The tile flows
    // (handlePWOClick / handleVideoClick / onOpenQuiz) are bound to the
    // Learning module's lifecycle and get torn down by the activeModule
    // cleanup effect the moment a lesson uses them.
    //
    // The quiz is the one that changed meaning here. Sending it out to the
    // global player put its answers in the general quiz tables, where they
    // moved no lesson mastery and never reached the lesson's Insights; opened
    // inline they are recorded as lesson responses like every other check.
    // `onOpenQuiz` itself is untouched and still serves the topic tile and the
    // collection player; nothing inside a lesson reaches it any more.
    lessonPlanAssetLaunchRef.current = false;
    assetLaunchModuleRef.current = null;
    setLessonPlanActiveBlockId(block.id);
    // Each player draws its own loading state inline, so the card's spinner
    // has nothing left to wait for.
    setLessonPlanLaunchingBlockId(null);
  }, []);

  const handleLessonPlanAsk = React.useCallback(
    (question) => {
      const text = String(question || "").trim();
      if (!text) return;
      // The Saras rail sits beside the lesson, so the answer lands in view —
      // no need to step the lesson aside the way an asset launch does.
      setInputValue("");
      handleAskButtonPress(text);
    },
    [handleAskButtonPress]
  );

  /**
   * Put an asset's authored summary where the Saras rail is.
   *
   * Deliberately not routed through `handleLessonPlanAsk`: that path asks, and
   * this one must not. It sets a string; there is no request to make, none to
   * cancel and no response to throw away, so "reaches the network" is not a
   * thing this function could start doing by accident. Same shape, and for the
   * same reason, as LessonPresentMode's `showSummary`.
   *
   * The block is the renderer's second argument and is ignored here — the
   * summary is already resolved by the time it arrives.
   */
  const showLessonPlanSummary = React.useCallback((summary) => {
    const text = String(summary?.text || "").trim();
    if (!text) return;
    setLessonPlanSummary({
      label: String(summary?.label || "").trim() || null,
      text,
    });
  }, []);

  const dismissLessonPlanSummary = React.useCallback(
    () => setLessonPlanSummary(null),
    []
  );

  // A summary belongs to a block on one step of one lesson. Carrying it across
  // a step change would leave the previous step's scene being described over
  // the step the teacher has just moved to; carrying it across a lesson, or
  // out of the lesson and back in, is the same mistake with a longer gap.
  useEffect(() => {
    setLessonPlanSummary(null);
  }, [lessonPlanStepIndex, lessonPlanRuntime?.lesson_plan_id, showLessonPlan]);

  const onOpenPwo = React.useCallback(
    async (item) => {
      const topicLabel = topicLabelOf(item);

      // ✅ Build topicMeta for toggleExpandTopic
      const realBoardTopicId = resolveBoardTopicId(item.topicId);
      const mappedSourceTopicId = boardToSourceTopicMap?.[String(realBoardTopicId)] ?? null;

      const topicMeta = {
        topic_name: topicLabel || "",
        chapter_name: item.chapterName || item.chapter_name || "",
        source_topic_id:
          item.sourceTopicId ||
          item.source_topic_id ||
          item.source_id ||
          mappedSourceTopicId ||
          null,
      };

      // ✅ Set scope immediately (so “Summarize this topic” is correctly scoped)
      const scopeNow = {
        chapterId: item.chapterId,
        topicId: item.topicId,
        board_topic_id: realBoardTopicId,
        source_topic_id: topicMeta.source_topic_id,
        topic_name: (topicMeta.topic_name || "").trim(),
        chapter_name: (topicMeta.chapter_name || "").trim(),
        chapter_id: item.chapterId,
      };
      activeTopicForAIRef.current = scopeNow;
      setSuggestedQuestionsMeta({ kind: "topic", topicScope: scopeNow });
      console.log("[AI][topic scope set by onOpenPwo]", scopeNow);

      saveLastActivity({ kind: "pwo", topicId: item.topicId, topicName: topicLabel });

      // ✅ Pass topicMeta so toggleExpandTopic doesn't get null meta
      await ensureTopicLoaded(item.chapterId, item.topicId, topicMeta);

      console.log(
        "[onOpenPwo][openPwoPicker] topicId, topicLabel, selectedSecondaryLang",
        item.topicId,
        topicLabel,
        selectedSecondaryLang
      );

      openPwoPicker(item.topicId, topicLabel, authToken, selectedSecondaryLang, null);
    },
    [
      openPwoPicker,
      authToken,
      selectedSecondaryLang,
      saveLastActivity,
      ensureTopicLoaded,
      resolveBoardTopicId,
      boardToSourceTopicMap,
      setSuggestedQuestionsMeta,
    ]
  );
  const onOpenVideo = React.useCallback(
    async (item) => {
      const topicLabel = topicLabelOf(item);

      const realBoardTopicId = resolveBoardTopicId(item.topicId);
      const mappedSourceTopicId = boardToSourceTopicMap?.[String(realBoardTopicId)] ?? null;

      const topicMeta = {
        topic_name: topicLabel || "",
        chapter_name: item.chapterName || item.chapter_name || "",
        source_topic_id:
          item.sourceTopicId ||
          item.source_topic_id ||
          item.source_id ||
          mappedSourceTopicId ||
          null,
      };

      const scopeNow = {
        chapterId: item.chapterId,
        topicId: item.topicId,
        board_topic_id: realBoardTopicId,
        source_topic_id: topicMeta.source_topic_id,
        topic_name: (topicMeta.topic_name || "").trim(),
        chapter_name: (topicMeta.chapter_name || "").trim(),
        chapter_id: item.chapterId,
      };
      activeTopicForAIRef.current = scopeNow;
      setSuggestedQuestionsMeta({ kind: "topic", topicScope: scopeNow });
      console.log("[AI][topic scope set by onOpenVideo]", scopeNow);

      saveLastActivity({ kind: "video", topicId: item.topicId, topicName: topicLabel });

      // ✅ Pass meta
      await ensureTopicLoaded(item.chapterId, item.topicId, topicMeta);
      // BDD 03/24/2026
      console.log("[onOpenVideo][item debug]", {
        topicId: item.topicId,
        itemVideosLen: Array.isArray(item?.videos) ? item.videos.length : null,
        itemFirstVideo: item?.videos?.[0]?.name,
      });
      openVideoPicker(
        item.topicId,
        topicLabel,
        authToken,
        null,                 // chap_id (unused here)
        selectedSecondaryLang, // language
        item.videos            // fallback only for broken collection topics // BDD 03/24/2026 - for notag ID videos in collection
      );
    },
    [
      openVideoPicker,
      authToken,
      selectedSecondaryLang,
      saveLastActivity,
      ensureTopicLoaded,
      resolveBoardTopicId,
      boardToSourceTopicMap,
      setSuggestedQuestionsMeta,
    ]
  );

  // BDD 10/5/2025 - updated:

  useEffect(() => {
    const colName = activeStudyCollection?.name || t("this module");
    const first = topicsFlat[0];

    // Default three (your existing ones)
    const base = [
      {
        key: "next",
        label: first ? `${t("Next Up")}: ${first.topicName}` : t("Next Up"),
        icon: "arrow-right-bold-circle-outline",
        onPress: () => askFromUI((
          first ? `${t("Guide me through")} ${first.topicName} ${t("step by step")}`
            : `${t("Guide me to the next topic in")} ${colName}`
        )),

      },
      {
        key: "revisit",
        label: t("Revisit: quick check"),
        icon: "history",
        // onPress: () => askFromUI(`${t("Give me a short review quiz in")} ${colName}`),
        onPress: () => askFromUI((`${t("Give me a short review quiz in")} ${colName}`)),
      },
      {
        key: "challenge",
        label: t("Challenge Me"),
        icon: "rocket-launch-outline",
        // onPress: () => askFromUI(`${t("Challenge me with a harder example in")} ${colName}`),
        onPress: () => askFromUI((`${t("Challenge me with a harder example in")} ${colName}`)),
      },
    ];


    const iconByKind = {
      guide: "walk",
      pwo: "cube-outline",
      video: "play-circle-outline",
      quiz: "check-decagram-outline",
    };

    if (lastActivity?.topicId) {
      const labelByKind = {
        guide: t("Continue: Guided"),
        pwo: t("Continue: Scene"),
        video: t("Continue: Video"),
        quiz: t("Continue: Quiz"),
      };
      const lbl = `${labelByKind[lastActivity.kind] || t("Continue")}: ${lastActivity.topicName}`;
      const icon = iconByKind[lastActivity.kind] || "play-circle-outline";

      const onPress = () => {
        const topicItem =
          topicsFlat.find(x => x.topicId === lastActivity.topicId) ||
          topicsFlat[0];
        if (!topicItem) {
          console.warn("[Continue] topicItem not found. topicsFlat:", topicsFlat.length, "lastActivity:", lastActivity.topicId);
          Alert.alert(t("Topic Not Found"), t("The topic from your last session could not be found. Please select a topic from the list."));
          return;
        }

        switch (lastActivity.kind) {
          case "guide": onStartTopic(topicItem); break;
          case "pwo": onOpenPwo(topicItem); break;
          case "video": onOpenVideo(topicItem); break;
          case "quiz": {
            const sid = lastActivity.sourceId || topicItem.sourceTopicId || topicItem.source_id;
            const bid = topicItem.boardTopicId || topicItem.board_topic_id;
            if (sid) fetchQuiz(sid);
            else if (bid) fetchQuiz(bid);
            else Alert.alert(t("No quiz available"), t("We could not find a quiz for this topic."));
            break;
          }
          default: onStartTopic(topicItem);
        }
      };

      setPicks([{ key: "continue", label: lbl, icon, onPress }, ...base]);
    } else {
      setPicks(base);
    }

  }, [activeStudyCollection?.id, topicsFlat, lastActivity, t, askFromUI, onStartTopic, onOpenPwo, onOpenVideo, fetchQuiz]);

  // BDD 02/11/2026 - Chapter level Curiosity Sparks
  // For sparks routing, use viewMode (NOT effectiveViewMode)
  const railViewMode = viewMode;

  // BDD 02/11/2026 - Chapter level Curiosity Sparks
  const sparksForRail =
    railViewMode === "collections" ? collectionSparks : chapterSparks;

  // BDD 02/11/2026 - Chapter level Curiosity Sparks
  const sparksMapped = sparksForRail.map((q, i) => ({
    key: `spark-${railViewMode}-${i}`,
    icon: "help-circle-outline",
    label: q,
    onPress: () => {
      console.log("[spark -> askFromUI]", q);
      askFromUI(q);
    },
  }));


  // load on user/collection change
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const raw = await AsyncStorage.getItem(LAST_KEY);
        if (cancelled) return;
        if (!raw) { setLastActivity(null); return; }
        const parsed = JSON.parse(raw);
        setLastActivity(parsed || null);
      } catch { setLastActivity(null); }
    })();
    return () => { cancelled = true; };
  }, [LAST_KEY]);


  // ===== Club Mode helpers/state (DROP-IN) ===== END
  // BDD 10/2/2025 New UI/UX
  const shortLang = (selectedSecondaryLang ?? lang ?? "en"); // fallbacks


  // const ensureTopicContent = async (chapterId, topicId) => {
  //   // If not loaded yet, trigger your expand (fetches content)
  //   if (!expandedTopics[chapterId]?.[topicId]?.videos && typeof toggleExpandTopic === "function") {
  //     // await toggleExpandTopic(chapterId, topicId);
  //     await toggleExpandTopic(chapterId, topicId, {
  //             topic_name: topic.displayName || topic.topicName || topic.name || "",
  //             chapter_name: chapter.displayName || chapter.name || "",
  //             source_topic_id: topic.sourceTopicId || topic.source_topic_id || topic.source_id || null,
  //           });

  //     // Wait until the fetch populates expandedTopics
  //     for (let i = 0; i < 30; i++) { // up to ~1.5s
  //       await sleep(50);
  //       if (expandedTopics[chapterId]?.[topicId]?.videos || expandedTopics[chapterId]?.[topicId]?.pwos) break;
  //     }
  //   }
  // };

  const ensureTopicContent = async (chapterId, topicId, topicMeta = null) => {
    if (!expandedTopics[chapterId]?.[topicId]?.videos && typeof toggleExpandTopic === "function") {
      await toggleExpandTopic(chapterId, topicId, topicMeta);

      for (let i = 0; i < 30; i++) {
        await sleep(50);
        if (expandedTopics[chapterId]?.[topicId]?.videos || expandedTopics[chapterId]?.[topicId]?.pwos) break;
      }
    }
  };

  // BDD 10/13/2025 - sidebar changed to shelf / nodal ui ux related
  // Web-safe tap helper (dedup + bridge mouse/touch/keyboard to one handler)
  // EXACT web tap bridge (matches your ChipRow pattern)
  // const makeWebTap = (handler) => {
  //   const firedRef = React.useRef(false);

  //   const fire = React.useCallback(() => {
  //     if (firedRef.current) return;         // de-dupe bursty events
  //     firedRef.current = true;
  //     setTimeout(() => { firedRef.current = false; }, 200);
  //     handler?.();
  //   }, [handler]);

  //   // Web: mirror ChipRow (onClick, onMouseDown/Up, onTouchEnd, keydown, plus onPress/onPressIn)
  //   if (Platform.OS === "web") {
  //     return {
  //       onPress: () => fire(),                                  // RNW may forward here; keep it
  //       onPressIn: () => {},                                    // keep parity with ChipRow
  //       onClick: (e) => { e.preventDefault?.(); fire(); },
  //       onMouseDown: () => {},                                  // optional—helps focus capture
  //       onMouseUp: () => fire(),
  //       onTouchEnd: () => fire(),
  //       onKeyDown: (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault?.(); fire(); } },
  //       tabIndex: 0,                                            // keyboard focusable
  //     };
  //   }

  //   // Native
  //   return { onPress: () => fire() };
  // };
  // BDD 10/17/2025
  // Web-safe tap helper (dedup + bridge mouse/touch/keyboard to one handler)
  // ✅ Hook-free version
  const makeWebTap = (handler) => {
    // simple per-prop closure dedupe; good enough to stop double fires
    let fired = false;

    const fire = () => {
      if (fired) return;           // de-dupe bursty events
      fired = true;
      setTimeout(() => { fired = false; }, 200);
      handler?.();
    };

    if (Platform.OS === "web") {
      return {
        onPress: fire,                                  // RNW may forward here; keep it
        onPressIn: () => { },                            // parity with your old version
        onClick: (e) => { e.preventDefault?.(); fire(); },
        onMouseDown: () => { },
        onMouseUp: fire,
        onTouchEnd: fire,
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault?.();
            fire();
          }
        },
        tabIndex: 0,                                    // keyboard focusable
      };
    }

    // Native
    return { onPress: fire };
  };


  // const openPwoDirect = async (item) => {
  //   await ensureTopicContent(item.chapterId, item.topicId);
  //   const topicState = expandedTopics[item.chapterId]?.[item.topicId];
  //   const pwo = topicState?.pwos?.[0] || null;
  //   if (!pwo) return;
  //   handlePWOClick(
  //     pwo.pwo_source_id,
  //     pwo.scene_name,
  //     authToken,
  //     shortLang,
  //     item.chapterId,
  //     item.topicId,
  //     false // isAuto
  //   );
  // };

  // const openVideoDirect = async (item) => {
  //   await ensureTopicContent(item.chapterId, item.topicId);
  //   const topicState = expandedTopics[item.chapterId]?.[item.topicId];
  //   const vid = topicState?.videos?.[0] || null;
  //   if (!vid) return;
  //   handleVideoClick(
  //     vid.source_id,
  //     vid.tag_id,
  //     authToken,
  //     item.chapterId,
  //     item.topicId,
  //     false // isAuto
  //   );
  // };

  // const openQuizDirect = async (item) => {
  //   // Prefer resolved sourceTopicId; fallback to your resolver if needed
  //   const topicIdForQuiz = (typeof resolveSourceTopicId === "function")
  //     ? resolveSourceTopicId(item.sourceTopicId ?? item.topicId)
  //     : (item.sourceTopicId ?? null);

  //   if (!topicIdForQuiz) return;
  //   fetchQuiz(
  //     topicIdForQuiz,
  //     languageIDquiz,
  //     item.subjectName,
  //     item.subjectId,
  //     item.topicName,
  //     item.chapterName
  //   );
  // };

  // const fetchVideoMetadata = async (videoID, tagID, languageId) => {
  //   try {
  //     // console.log(`Fetching metadata for Video ID: ${videoID}, Tag ID: ${tagID}`);
  //     const response = await axios.get(`${API_URL_VIDEOMETA}?video_id=${videoID}&tag_id=${tagID}&language_id=${languageId}`);
  //     // console.log(`metadata for Video ID ${videoID}, Tag ID ${tagID}, Lang ${languageId}:`, response);
  //     return response.data;
  //   } catch (error) {
  //     console.error(`Error fetching metadata for Video ID ${videoID}, Tag ID ${tagID}, Lang ${languageId}:`, error);
  //     return null;
  //   }
  // };

  // # BDD 03/16/2026 - DEBUG missing video tag behavior 
  const fetchVideoMetadata = async (videoID, tagID, languageId) => {
    try {
      const params = {
        video_id: videoID,
        language_id: languageId,
      };

      // Only send tag_id when it really exists
      if (tagID !== null && tagID !== undefined && tagID !== "") {
        params.tag_id = tagID;
      }

      const response = await axios.get(API_URL_VIDEOMETA, { params });
      return response.data;
    } catch (error) {
      console.error(`Error fetching metadata for Video ID ${videoID}, Tag ID ${tagID}, Lang ${languageId}:`, error);
      return null;
    }
  };

  useEffect(() => {
    const loadStoredLanguages = async () => {
      try {
        const storedPrimaryLang = await AsyncStorage.getItem("primary_language_id");
        if (storedPrimaryLang) setSelectedPrimaryLang(storedPrimaryLang);
        // Secondary language is owned by AuthContext — it loads and exposes
        // selectedSecondaryLang via useAuth(). A duplicate load here caused a
        // race condition where the app briefly rendered with "en" before the
        // AuthContext async load finished, making curriculum show in EN while
        // AI responses came back in the correct stored language.
      } catch (error) {
        console.error("❌ Error loading languages:", error);
      }
    };
    loadStoredLanguages();
  }, []);


  // 🔹 Extract User Initials
  const getUserInitials = (name) => {
    if (!name) return "U";  // Default if no name
    const initials = name.split(" ").map(word => word[0]).join("").toUpperCase();
    return initials.length > 2 ? initials.substring(0, 2) : initials;
  };

  const handleLogout = async () => {
    autoOpenReturnRef.current = null; // AIT-246: never carry a return snapshot across users
    try {
      // console.log("🚪 Logging out...");
      // await AsyncStorage.clear();

      // Clear activeModule from sessionStorage so next login goes to home
      if (typeof window !== 'undefined' && window.sessionStorage) {
        sessionStorage.removeItem('activeModule');
      }

      logout();
    } catch (error) {
      console.error("❌ Logout Error:", error);
    }
  };


  const handleLanguageSelect = async (lang, type) => {
    try {
      // console.log(`🌍 Setting ${type} language to:`, lang);

      if (type === "primary") {
        setSelectedPrimaryLang(lang);
        await AsyncStorage.setItem("primary_language_id", lang);
      } else {
        await updateSecondaryLang(lang);
        // setSelectedSecondaryLang(lang);
        // await AsyncStorage.setItem("secondary_language_id", lang);
      }

      // 🔹 Confirm change with notification
      showNotification(`Language updated to ${lang.toUpperCase()}`, "success");
      // saveStudentProfile();
      // setLanguageModal(false); // ✅ Close modal
      // setMenuVisible(false);   // ✅ Close profile menu
    } catch (error) {
      console.error("❌ Error setting language:", error);
      showNotification("Could not update language. Try again.", "error");
    }
  };



  // useEffect(() => {
  //     if (isVoiceInput) {
  //         // console.log("🔔 inside isVoiceInput effect")
  //         handleAsk(); // ≡ƒÜÇ Trigger the AI Tutor response // 10/5/2025 -- THis one is not changed to askFromAnywhere -- maybe later
  //         setIsVoiceInput(false);
  //     }
  // }, [isVoiceInput]); // Γ£à Only runs when voice input is processed
  // BDD 10/5/2025
  useEffect(() => {
    if (!isVoiceInput) return;

    const text = (inputValue || "").trim();
    if (text) {
      // ✅ go through your unified entrypoint
      handleAskButtonPress(text, { fromVoice: true });
    }

    // always clear the flag so it won't re-fire
    setIsVoiceInput(false);
  }, [isVoiceInput, inputValue, handleAskButtonPress]);


  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setQuestion(inputValue); // Γ£à Update only after user stops typing
    }, 300); // 300ms debounce delay

    return () => clearTimeout(delayDebounce); // Cleanup on unmount or new input
  }, [inputValue]); // Runs only when inputValue changes

  useEffect(() => {
    if (loading) {
      const interval = setInterval(() => {
        setLoadingDots((prev) => (prev + 1) % 4); // Cycles between 0,1,2,3 for dots
      }, 500); // Update every 500ms for smooth animation
      return () => clearInterval(interval);
    } else {
      setLoadingDots(0); // Reset when not loading
    }
  }, [loading]);

  let userRank = null;
  let user_score = 0;
  let user_name = "";

  if (leaderboard.length > 0 && user && user.email) {
    const userIndex = leaderboard.findIndex(entry => entry.email === user.email);
    if (userIndex !== -1) {
      userRank = userIndex + 1;
      user_score = leaderboard[userIndex].total_score;
      user_name = leaderboard[userIndex].name || user.email;
    }
  }

  const SHOW_OUTSIDE_BADGE = false; // flip to true to re-enable the badge later

  // const renderHistorySection = (
  //   history,
  //   isDarkMode,
  //   handleVideoClick,
  //   handlePWOClick,
  //   handleChapterClick, // BDD 01/08/2026 enhance-fetch-reference
  //   handleCollectionClick, // BDD 01/08/2026 enhance-fetch-reference
  //   authToken,
  //   styles
  // ) => {
  //   // // 🔧 HOTFIX: in investor demo, skip rendering refs lists to avoid the hook crash BDD CAUTION NOTE 10/14/2025
  //   // const hideRefs = investorMode && autoWalkthroughMode;
  //   // 🔧 HOTFIX: ALWAYS hide refs lists in investor demos to avoid hook crash
  //   const hideRefs = investorMode;
  //   // # BDD 01/16/2025 - ChatHistory Persistance
  //   const entryBoard = entry?.content_db ? String(entry.content_db).toUpperCase() : null;
  //   const isWrongBoard = entry?.is_current_content_db === false;

  //   return history.map((entry, index) => (
  //     <View key={index} style={styles(isDarkMode).chatCard}>
  //       {/* Subtle accent bar */}
  //       <View style={styles(isDarkMode).chatCardAccentBar} />
  //       <View style={styles(isDarkMode).answerContainer}>
  //         <View style={styles(isDarkMode).questionLabelRow}>
  //           <Text style={styles(isDarkMode).questionLabel}>{t("Question")}</Text>
  //         </View>
  //         <Text style={styles(isDarkMode).questionText}>{entry.question}</Text>
  //         <View style={styles(isDarkMode).answerDivider} />
  //         {entryBoard && (
  //           <Text style={{
  //             marginTop: 6,
  //             fontSize: 11,
  //             color: isWrongBoard ? (isDarkMode ? "#fbbf24" : "#b45309") : (isDarkMode ? "#94a3b8" : "#64748b"),
  //             opacity: isWrongBoard ? 0.95 : 0.7,
  //           }}>
  //             {isWrongBoard ? "⚠ Generated on board: " : "Board: "} {entryBoard}
  //           </Text>
  //         )}
  //         <MarkdownRenderer content={entry.answer} />

  //         {/* 🧭 Guide Me Next Actions (clickable) // BDD 01/08/2026 guideme-next-steps // BDD 01/10/2026 guideme-next-steps merge*/}
  //         {!hideRefs && Array.isArray(entry.guideMeActions) && entry.guideMeActions.length > 0 && (
  //           <View style={{ marginTop: 10 }}>
  //             <Text style={{
  //               fontSize: 12,
  //               fontWeight: "800",
  //               color: isDarkMode ? "#cbd5e1" : "#334155",
  //             }}>
  //               {"🧭"} {t("Next actions")}
  //             </Text>

  //             <View style={{ marginTop: 8, gap: 10 }}>
  //               {entry.guideMeActions.map((a, i) => {
  //                 const kind = String(a?.kind || "").toLowerCase();
  //                 const label = a?.name || (kind === "video" ? "Video" : "PWO");
  //                 const topic = a?.topic_name ? `${a.topic_name}` : null;

  //                 const cardStyle = {
  //                   paddingVertical: 10,
  //                   paddingHorizontal: 12,
  //                   borderRadius: 12,
  //                   borderWidth: 1,
  //                   borderColor: isDarkMode ? "rgba(148,163,184,0.18)" : "rgba(148,163,184,0.28)",
  //                   backgroundColor: isDarkMode ? "rgba(15,23,42,0.55)" : "rgba(255,255,255,0.85)",
  //                 };

  //                 const titleStyle = {
  //                   fontSize: 13,
  //                   fontWeight: "700",
  //                   color: isDarkMode ? "#e2e8f0" : "#0f172a",
  //                 };

  //                 const subStyle = {
  //                   marginTop: 4,
  //                   fontSize: 12,
  //                   color: isDarkMode ? "#94a3b8" : "#475569",
  //                 };

  //                 if (kind === "video") {
  //                   const videoId = a?.video_id ?? a?.id;
  //                   const tagId = a?.tag_id ?? null;
  //                   const topicIdForLog = a?.source_topic_id ?? null;
  //                   if (videoId == null) return null;

  //                   return (
  //                     <TouchableOpacity
  //                       key={`gm-video-${i}`}
  //                       disabled={isWrongBoard}
  //                       {...(isWrongBoard ? {} : makeWebTap(() => handleVideoClick(video.videoID, video.tagID, authToken, null, topicIdForLog, false)))}
  //                       style={cardStyle}
  //                       activeOpacity={0.85}
  //                     >
  //                       <Text style={titleStyle}>
  //                         {`#${i + 1} `}{"🎥 "}{label}
  //                       </Text>
  //                       {topic ? <Text style={subStyle}>{t("Topic:")} {topic}</Text> : null}
  //                       <Text style={subStyle}>{t("Tap to play this video segment")}</Text>
  //                     </TouchableOpacity>
  //                   );
  //                 }

  //                 if (kind === "pwo") {
  //                   const pwoId = a?.pwo_id ?? a?.id;
  //                   const topicIdForLog = a?.source_topic_id ?? null;
  //                   const sceneKey = a?.scene_key || a?.scene_name || "mainmenu";  // ✅ prefer scene_key

  //                   if (pwoId == null) return null;

  //                   return (
  //                     <TouchableOpacity
  //                       key={`gm-pwo-${i}`}
  //                       disabled={isWrongBoard}
  //                       // {...makeWebTap(() =>
  //                       //   handlePWOClick(
  //                       //     pwoId,
  //                       //     sceneKey,          // ✅ internal key
  //                       //     authToken,
  //                       //     lang,
  //                       //     null,              // chapterID
  //                       //     topicIdForLog,     // ✅ topicID used for resolveSourceTopicId()
  //                       //     false              // isAuto
  //                       //   )
  //                       // )}
  //                       {...(isWrongBoard ? {} : makeWebTap(() => handlePWOClick(pwoId, sceneKey, authToken, lang, null, topicIdForLog, false)))}
  //                       style={cardStyle}
  //                       activeOpacity={0.85}
  //                     >
  //                       <Text style={titleStyle}>
  //                         {`#${i + 1} `}{"🎮 "}{label}
  //                       </Text>
  //                       {topic ? <Text style={subStyle}>{t("Topic:")} {topic}</Text> : null}
  //                       <Text style={subStyle}>{t("Tap to open this 3D simulation")}</Text>
  //                     </TouchableOpacity>
  //                   );
  //                 }

  //                 return null;
  //               })}
  //             </View>
  //           </View>
  //         )}

  //       </View>

  //       {!hideRefs && entry.videos.length > 0 && (
  //         <View>
  //           <Text style={styles(isDarkMode).referenceHeader}>{'\uD83C\uDFAC'} {t("Video References:")}</Text>
  //           {entry.videos.map((video, i) => (
  //             // dev-log per item (toggle to 0 to silence)
  //             (1 && console.debug("🎬 render video:", { i, id: video?.videoID, outside: video?.outsideCollection }), null) ||
  //             <TouchableOpacity key={i} disabled={isWrongBoard} {...(isWrongBoard ? {} : makeWebTap(() => handleVideoClick(video.videoID, video.tagID, authToken)))}>
  //               <Text style={styles(isDarkMode).linkText}>
  //                 {'\uD83C\uDF9E'} {video.name ? `${video.name} - ${video.tag_name || ""}` : (video.tag_name || "Video")}
  //                 {SHOW_OUTSIDE_BADGE && video.outsideCollection ? ` — ${t("Outside this Learning Module")}` : ""}
  //               </Text>
  //             </TouchableOpacity>
  //           ))}
  //         </View>
  //       )}

  //       {!hideRefs && entry.pwos.length > 0 && (
  //         <View>
  //           <Text style={styles(isDarkMode).referenceHeader}>{'\uD83C\uDFAE'} {t("3D Simulations:")}</Text>

  //           {entry.pwos.map((pwo, i) => {
  //             const sceneLabel =
  //               pwo.pwo_scene_label || // 🌍 localized display label from backend
  //               pwo.pwo_scene_name ||  // fallback to internal key
  //               "Scene";

  //             return (
  //               (1 &&
  //                 console.debug("🧪 render pwo:", {
  //                   i,
  //                   id: pwo?.pwoID,
  //                   outside: pwo?.outsideCollection,
  //                   sceneKey: pwo?.pwo_scene_name,
  //                   sceneLabel,
  //                 }),
  //                 null) || (
  //                 <TouchableOpacity
  //                   key={i}
  //                   disabled={isWrongBoard}
  //                   // {...makeWebTap(() =>
  //                   //   handlePWOClick(
  //                   //     pwo.pwoID,
  //                   //     pwo.pwo_scene_name || "mainmenu", // still internal key
  //                   //     authToken,
  //                   //     lang
  //                   //   )
  //                   // )}
  //                   {...(isWrongBoard ? {} : makeWebTap(() => handlePWOClick(pwo.pwoID, pwo.pwo_scene_name || "mainmenu", authToken, lang)))}
  //                 >
  //                   <Text style={styles(isDarkMode).linkText}>
  //                     {"\uD83C\uDFAE"} {pwo.pwo_name || "3D Simulation"} - {sceneLabel}
  //                     {SHOW_OUTSIDE_BADGE && pwo.outsideCollection
  //                       ? ` — ${t("Outside this Learning Module")}`
  //                       : ""}
  //                   </Text>
  //                 </TouchableOpacity>
  //               )
  //             );
  //           })}

  //         </View>
  //       )}

  //       {/* 📚 Chapters // BDD 01/08/2026 enhance-fetch-reference */}
  //       {!hideRefs && (entry.chapters || []).length > 0 && (
  //         <View>
  //           <Text style={styles(isDarkMode).referenceHeader}>{"📚"} {t("Chapters:")}</Text>
  //           {entry.chapters.map((ch, i) => (
  //             <TouchableOpacity key={i} disabled={isWrongBoard} {...(isWrongBoard ? {} : makeWebTap(() => handleChapterClick(ch)))}>
  //               <Text style={styles(isDarkMode).linkText}>
  //                 {"📖"} {ch.chapter_name || ch.name || `Chapter ${ch.chapterId || ch.id}`}
  //               </Text>
  //             </TouchableOpacity>
  //           ))}
  //         </View>
  //       )}

  //       {/* 🗂️ Collections // BDD 01/08/2026 enhance-fetch-reference */}
  //       {!hideRefs && Array.isArray(entry.collections) && entry.collections.length > 0 && (() => {
  //         const scoped = entry.collections.find((c) => c && c.scoped);
  //         const others = entry.collections.filter((c) => c && !c.scoped);

  //         return (
  //           <View>
  //             {/* Current module (scoped collection) */}
  //             {scoped && (
  //               <View style={{ marginBottom: others.length ? 8 : 0 }}>
  //                 <Text style={styles(isDarkMode).referenceHeader}>
  //                   {"📌"} {t("Current module:")}
  //                 </Text>
  //                 <TouchableOpacity disabled={isWrongBoard} {...(isWrongBoard ? {} : makeWebTap(() => handleCollectionClick(scoped)))} >
  //                   <Text style={styles(isDarkMode).linkText}>
  //                     {"🧩"} {scoped.name || `Collection ${scoped.collection_id || scoped.id}`}
  //                   </Text>
  //                 </TouchableOpacity>
  //               </View>
  //             )}

  //             {/* Recommended collections */}
  //             {others.length > 0 && (
  //               <View>
  //                 <Text style={styles(isDarkMode).referenceHeader}>
  //                   {"🗂️"} {t("Collections:")}
  //                 </Text>
  //                 {others.map((c, i) => (
  //                   <TouchableOpacity
  //                     key={`${c.collection_id || c.id || i}`}
  //                     disabled={isWrongBoard}
  //                     // {...makeWebTap(() => handleCollectionClick(c))}
  //                     {...(isWrongBoard ? {} : makeWebTap(() => handleCollectionClick(c)))}
  //                   >
  //                     <Text style={styles(isDarkMode).linkText}>
  //                       {"🧩"} {c.name || `Collection ${c.collection_id || c.id}`}
  //                     </Text>
  //                   </TouchableOpacity>
  //                 ))}
  //               </View>
  //             )}
  //           </View>
  //         );
  //       })()}

  //     </View>
  //   ));
  // };

  // # BDD 01/16/2025 - ChatHistory Persistance
  const renderHistorySection = (
    history,
    isDarkMode,
    handleVideoClick,
    handlePWOClick,
    handleChapterClick, // BDD 01/08/2026 enhance-fetch-reference
    handleCollectionClick, // BDD 01/08/2026 enhance-fetch-reference
    authToken,
    styles
  ) => {
    // 🔧 HOTFIX: ALWAYS hide refs lists in investor demos to avoid hook crash
    const hideRefs = investorMode;

    return (history || []).map((entry, index) => {
      // ✅ BDD 01/16/2026 - ChatHistory Persistence (must be inside map)
      const entryBoard = entry?.content_db ? String(entry.content_db).toUpperCase() : null;
      const isWrongBoard = entry?.is_current_content_db === false;
      const disabledOpacity = isWrongBoard ? 0.45 : 1;

      return (
        <View key={index} style={styles(isDarkMode).chatCard}>
          {/* Subtle accent bar */}
          <View style={styles(isDarkMode).chatCardAccentBar} />

          <View style={styles(isDarkMode).answerContainer}>
            <View style={styles(isDarkMode).questionLabelRow}>
              <Text style={styles(isDarkMode).questionLabel}>{t("Question")}</Text>
            </View>

            <Text style={styles(isDarkMode).questionText}>{entry?.question}</Text>

            <View style={styles(isDarkMode).answerDivider} />

            {entryBoard && (
              <Text
                style={{
                  marginTop: 6,
                  fontSize: rem(11) + 'rem',
                  color: isWrongBoard
                    ? isDarkMode
                      ? "#fbbf24"
                      : "#b45309"
                    : isDarkMode
                      ? "#94a3b8"
                      : "#64748b",
                  opacity: isWrongBoard ? 0.95 : 0.7,
                }}
              >
                {isWrongBoard ? "⚠ Generated on board: " : "Board: "} {entryBoard}
              </Text>
            )}

            <MarkdownRenderer content={entry?.answer} />

            {/* 🧭 Guide Me Next Actions (clickable) */}
            {!hideRefs &&
              Array.isArray(entry?.guideMeActions) &&
              entry.guideMeActions.length > 0 && (
                <View style={{ marginTop: 10 }}>
                  <Text
                    style={{
                      fontSize: rem(12) + 'rem',
                      fontWeight: "800",
                      color: isDarkMode ? "#cbd5e1" : "#334155",
                    }}
                  >
                    {"🧭"} {t("Next actions")}
                  </Text>

                  <View style={{ marginTop: 8, gap: 10 }}>
                    {entry.guideMeActions.map((a, i) => {
                      const kind = String(a?.kind || "").toLowerCase();
                      const label = a?.name || (kind === "video" ? "Video" : "PWO");
                      const topic = a?.topic_name ? `${a.topic_name}` : null;

                      const cardStyle = {
                        paddingVertical: 10,
                        paddingHorizontal: 12,
                        borderRadius: 12,
                        borderWidth: 1,
                        borderColor: isDarkMode
                          ? "rgba(148,163,184,0.18)"
                          : "rgba(148,163,184,0.28)",
                        backgroundColor: isDarkMode
                          ? "rgba(15,23,42,0.55)"
                          : "rgba(255,255,255,0.85)",
                        opacity: disabledOpacity,
                      };

                      const titleStyle = {
                        fontSize: rem(13) + 'rem',
                        fontWeight: "700",
                        color: isDarkMode ? "#e2e8f0" : "#0f172a",
                      };

                      const subStyle = {
                        marginTop: 4,
                        fontSize: rem(12) + 'rem',
                        color: isDarkMode ? "#94a3b8" : "#475569",
                      };

                      if (kind === "video") {
                        const videoId = a?.video_id ?? a?.id;
                        const tagId = a?.tag_id ?? null;
                        const topicIdForLog = a?.source_topic_id ?? null;

                        if (videoId == null) return null;

                        return (
                          <TouchableOpacity
                            key={`gm-video-${i}`}
                            disabled={isWrongBoard}
                            {...(isWrongBoard
                              ? {}
                              : makeWebTap(() =>
                                handleVideoClick(
                                  videoId,         // ✅ FIX (was video.videoID)
                                  tagId,           // ✅ FIX (was video.tagID)
                                  authToken,
                                  null,            // chapterID
                                  topicIdForLog,   // topicID
                                  false            // isAuto
                                )
                              ))}
                            style={cardStyle}
                            activeOpacity={0.85}
                          >
                            <Text style={titleStyle}>
                              {`#${i + 1} `}{"🎥 "}{label}
                            </Text>
                            {topic ? (
                              <Text style={subStyle}>
                                {t("Topic:")} {topic}
                              </Text>
                            ) : null}
                            <Text style={subStyle}>{t("Tap to play this video segment")}</Text>
                          </TouchableOpacity>
                        );
                      }

                      if (kind === "pwo") {
                        const pwoId = a?.pwo_id ?? a?.id;
                        const topicIdForLog = a?.source_topic_id ?? null;
                        const sceneKey = a?.scene_key || a?.scene_name || "mainmenu";

                        if (pwoId == null) return null;

                        return (
                          <TouchableOpacity
                            key={`gm-pwo-${i}`}
                            disabled={isWrongBoard}
                            {...(isWrongBoard
                              ? {}
                              : makeWebTap(() =>
                                handlePWOClick(
                                  pwoId,
                                  sceneKey,
                                  authToken,
                                  lang,
                                  null,            // chapterID
                                  topicIdForLog,   // topicID
                                  false            // isAuto
                                )
                              ))}
                            style={cardStyle}
                            activeOpacity={0.85}
                          >
                            <Text style={titleStyle}>
                              {`#${i + 1} `}{"🎮 "}{label}
                            </Text>
                            {topic ? (
                              <Text style={subStyle}>
                                {t("Topic:")} {topic}
                              </Text>
                            ) : null}
                            <Text style={subStyle}>{t("Tap to open this 3D simulation")}</Text>
                          </TouchableOpacity>
                        );
                      }

                      return null;
                    })}
                  </View>
                </View>
              )}
          </View>

          {/* 🎥 Video References */}
          {!hideRefs && Array.isArray(entry?.videos) && entry.videos.length > 0 && (
            <View style={{ opacity: disabledOpacity }}>
              <Text style={styles(isDarkMode).referenceHeader}>
                {"\uD83C\uDFAC"} {t("Video References:")}
              </Text>

              {entry.videos.map((video, i) => (
                <TouchableOpacity
                  key={i}
                  disabled={isWrongBoard}
                  {...(isWrongBoard ? {} : makeWebTap(() => handleVideoClick(video?.videoID, video?.tagID, authToken)))}
                >
                  <Text style={styles(isDarkMode).linkText}>
                    {"\uD83C\uDF9E"}{" "}
                    {video?.name
                      ? `${video.name} - ${video.tag_name || ""}`
                      : (video?.tag_name || "Video")}
                    {SHOW_OUTSIDE_BADGE && video?.outsideCollection
                      ? ` — ${t("Outside this Learning Module")}`
                      : ""}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
          )}

          {/* 🎮 PWO References */}
          {!hideRefs && Array.isArray(entry?.pwos) && entry.pwos.length > 0 && (
            <View style={{ opacity: disabledOpacity }}>
              <Text style={styles(isDarkMode).referenceHeader}>
                {"\uD83C\uDFAE"} {t("3D Simulations:")}
              </Text>

              {entry.pwos.map((pwo, i) => {
                const sceneLabel =
                  pwo?.pwo_scene_label ||
                  pwo?.pwo_scene_name ||
                  "Scene";

                return (
                    <TouchableOpacity
                      key={i}
                      disabled={isWrongBoard}
                      {...(isWrongBoard
                        ? {}
                        : makeWebTap(() =>
                          handlePWOClick(
                            pwo?.pwoID,
                            pwo?.pwo_scene_name || "mainmenu",
                            authToken,
                            lang
                          )
                        ))}
                    >
                      <Text style={styles(isDarkMode).linkText}>
                        {"\uD83C\uDFAE"} {formatPwoName(pwo?.pwo_name || "3D Simulation")} - {formatPwoName(sceneLabel)}
                        {SHOW_OUTSIDE_BADGE && pwo?.outsideCollection
                          ? ` — ${t("Outside this Learning Module")}`
                          : ""}
                      </Text>
                    </TouchableOpacity>
                );
              })}
            </View>
          )}

          {/* 📚 Chapters */}
          {!hideRefs && Array.isArray(entry?.chapters) && entry.chapters.length > 0 && (
            <View style={{ opacity: disabledOpacity }}>
              <Text style={styles(isDarkMode).referenceHeader}>{"📚"} {t("Chapters:")}</Text>
              {entry.chapters.map((ch, i) => (
                <TouchableOpacity
                  key={i}
                  disabled={isWrongBoard}
                  {...(isWrongBoard ? {} : makeWebTap(() => handleChapterClick(ch)))}
                >
                  <Text style={styles(isDarkMode).linkText}>
                    {"📖"} {ch?.chapter_name || ch?.name || `Chapter ${ch?.chapterId || ch?.id}`}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
          )}

          {/* 🗂️ Collections */}
          {!hideRefs && Array.isArray(entry?.collections) && entry.collections.length > 0 && (() => {
            const scoped = entry.collections.find((c) => c && c.scoped);
            const others = entry.collections.filter((c) => c && !c.scoped);

            return (
              <View style={{ opacity: disabledOpacity }}>
                {scoped && (
                  <View style={{ marginBottom: others.length ? 8 : 0 }}>
                    <Text style={styles(isDarkMode).referenceHeader}>
                      {"📌"} {t("Current module:")}
                    </Text>
                    <TouchableOpacity
                      disabled={isWrongBoard}
                      {...(isWrongBoard ? {} : makeWebTap(() => handleCollectionClick(scoped)))}
                    >
                      <Text style={styles(isDarkMode).linkText}>
                        {"🧩"} {scoped?.name || `Collection ${scoped?.collection_id || scoped?.id}`}
                      </Text>
                    </TouchableOpacity>
                  </View>
                )}

                {others.length > 0 && (
                  <View>
                    <Text style={styles(isDarkMode).referenceHeader}>
                      {"🗂️"} {t("Collections:")}
                    </Text>

                    {others.map((c, i) => (
                      <TouchableOpacity
                        key={`${c?.collection_id || c?.id || i}`}
                        disabled={isWrongBoard}
                        {...(isWrongBoard ? {} : makeWebTap(() => handleCollectionClick(c)))}
                      >
                        <Text style={styles(isDarkMode).linkText}>
                          {"🧩"} {c?.name || `Collection ${c?.collection_id || c?.id}`}
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                )}
              </View>
            );
          })()}
        </View>
      );
    });
  };

  // BDD 10/14/2025
  function TriviaOverlayCard({ item, onNext }) {
    const [picked, setPicked] = useState(null);
    const isMCQ = item?.type === "mcq";

    function isCorrect(i) {
      if (!item) return false;
      return isMCQ ? i === item.answer_index : null;
    }

    return (
      <View
        style={{
          position: "absolute",
          left: 12,
          right: 12,
          bottom: 96, // keeps clear of Ask bar ~80; tweak if needed
          borderRadius: 16,
          padding: 14,
          backgroundColor: "rgba(18, 20, 24, 0.92)",
          borderWidth: 1,
          borderColor: "rgba(255,255,255,0.08)"
        }}
        pointerEvents="box-none"
      >
        <View pointerEvents="auto">
          <Text style={{ fontSize: rem(16) + 'rem', fontWeight: "700", color: "#fff", marginBottom: 8 }}>
            🧩 Quick Trivia
          </Text>

          <Text style={{ fontSize: rem(15) + 'rem', color: "#e6e6e6", marginBottom: 10 }}>
            {item?.q}
          </Text>

          {isMCQ ? (
            <View style={{ gap: 8 }}>
              {(item?.options || []).map((opt, i) => {
                const chosen = picked === i;
                const correct = picked != null && isCorrect(i);
                const wrong = chosen && !correct;

                return (
                  <Pressable
                    key={i}
                    onPress={() => setPicked(i)}
                    style={{
                      paddingVertical: 8,
                      paddingHorizontal: 10,
                      borderRadius: 12,
                      borderWidth: 1,
                      borderColor:
                        picked == null
                          ? "rgba(255,255,255,0.15)"
                          : correct
                            ? "rgba(34,197,94,0.9)"      // green-ish
                            : wrong
                              ? "rgba(239,68,68,0.9)"      // red-ish
                              : "rgba(255,255,255,0.15)",
                      backgroundColor:
                        picked == null
                          ? "rgba(255,255,255,0.04)"
                          : correct
                            ? "rgba(34,197,94,0.15)"
                            : wrong
                              ? "rgba(239,68,68,0.15)"
                              : "rgba(255,255,255,0.04)"
                    }}
                  >
                    <Text style={{ color: "#fff", fontSize: rem(14) + 'rem' }}>{opt}</Text>
                  </Pressable>
                );
              })}
            </View>
          ) : (
            <View style={{ flexDirection: "row", gap: 8 }}>
              {["True", "False"].map((label, i) => {
                const val = i === 0; // true for index 0
                const chosen = picked === i;
                const correct = picked != null && val === !!item?.answer_bool;
                const wrong = chosen && !correct;

                return (
                  <Pressable
                    key={label}
                    onPress={() => setPicked(i)}
                    style={{
                      flex: 1,
                      paddingVertical: 10,
                      borderRadius: 12,
                      borderWidth: 1,
                      borderColor:
                        picked == null
                          ? "rgba(255,255,255,0.15)"
                          : correct
                            ? "rgba(34,197,94,0.9)"
                            : wrong
                              ? "rgba(239,68,68,0.9)"
                              : "rgba(255,255,255,0.15)",
                      backgroundColor:
                        picked == null
                          ? "rgba(255,255,255,0.04)"
                          : correct
                            ? "rgba(34,197,94,0.15)"
                            : wrong
                              ? "rgba(239,68,68,0.15)"
                              : "rgba(255,255,255,0.04)",
                      alignItems: "center"
                    }}
                  >
                    <Text style={{ color: "#fff", fontWeight: "600" }}>{label}</Text>
                  </Pressable>
                );
              })}
            </View>
          )}

          {picked != null && !!item?.explain && (
            <Text style={{ color: "#cbd5e1", marginTop: 10, fontSize: rem(13) + 'rem' }}>
              {item.explain}
            </Text>
          )}

          <View style={{ flexDirection: "row", justifyContent: "flex-end", marginTop: 12, gap: 8 }}>
            <Pressable
              onPress={onNext}
              style={{
                paddingVertical: 8,
                paddingHorizontal: 12,
                borderRadius: 12,
                backgroundColor: "rgba(255,255,255,0.08)"
              }}
            >
              <Text style={{ color: "#fff" }}>Next</Text>
            </Pressable>
          </View>
        </View>
      </View>
    );
  }


  // BDD 12/08/2025 try 2 - ensuring we show correct language names with languageID
  const renderCurriculumTreeList = ({
    curriculum,
    isDarkMode,
    styles,
    expandedSubjects,
    expandedChapters,
    expandedTopics,
    expandedVideos,
    expandedPWOs,
    activeTopic,
    activeVideo,
    activePWO,
    authToken,
    toggleExpandSubject,
    toggleExpandChapter,
    toggleExpandTopic,
    toggleExpandVideos,
    toggleExpandPWOs,
    fetchQuiz,
    handleVideoClick,
    handlePWOClick,
    languageID,  // keep as-is; languageIDquiz/lang come from outer scope
    handleGuideMeChapterClick,
    guideMeLoading,
    t,
  }) => {
    // 🔹 Single place that decides what label to show
    const nodeLabel = (node) =>
      (node?.display_name || node?.name || "").trim();

    // 🔍 Debug: see what React gets vs what it renders
    if (Array.isArray(curriculum) && curriculum.length > 0) {
      const sampleSubject =
        curriculum?.[2]?.subjects?.[0] || curriculum?.[0]?.subjects?.[0];
      if (sampleSubject) {
        console.log("[CurriculumTree] sampleSubject raw:", sampleSubject);
        console.log(
          "[CurriculumTree] sampleSubject label used:",
          nodeLabel(sampleSubject)
        );
      }
    }

    if (!Array.isArray(curriculum) || curriculum.length === 0) {
      return (
        <Text style={styles(isDarkMode).emptyStateText}>
          {t("No curriculum data available")}
        </Text>
      );
    }

    return curriculum.map((level) => (
      <View key={level.id} style={styles(isDarkMode).levelContainer}>
        {level?.grade != null && String(level.grade).trim() !== "" && (
          <Text style={styles(isDarkMode).levelTitle}>
            {t("Grade")} {level.grade}
          </Text>
        )}

        {level.subjects.map((subject) => {
          const subjectLabel = nodeLabel(subject);

          return (
            <View key={subject.id} style={styles(isDarkMode).subjectContainer}>
              <TouchableOpacity
                onPress={() => toggleExpandSubject(level.id, subject.id)}
              >
                <Text style={styles(isDarkMode).subjectTitle}>
                  {subjectLabel}
                </Text>
              </TouchableOpacity>

              {expandedSubjects[level.id]?.[subject.id] &&
                subject.chapters.map((chapter) => {
                  const chapterLabel = nodeLabel(chapter);

                  return (
                    <View
                      key={chapter.id}
                      style={styles(isDarkMode).chapterContainer}
                    >
                      <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                        <TouchableOpacity onPress={() => toggleExpandChapter(subject.id, chapter.id)} style={{ flex: 1, paddingRight: 10 }}>
                          <Text style={styles(isDarkMode).chapterTitle}>
                            {expandedChapters[subject.id]?.[chapter.id] ? "🔽" : "▶"} {chapterLabel}
                          </Text>
                        </TouchableOpacity>

                        <TouchableOpacity
                          onPress={() => handleGuideMeChapterClick?.(chapter.id, chapterLabel)}
                          style={{
                            paddingVertical: 6,
                            paddingHorizontal: 10,
                            borderRadius: 10,
                            borderWidth: 1,
                            borderColor: isDarkMode ? "rgba(99,102,241,0.35)" : "rgba(99,102,241,0.25)",
                            backgroundColor: isDarkMode ? "rgba(99,102,241,0.12)" : "rgba(99,102,241,0.08)",
                          }}
                        >
                          <Text style={{ fontSize: rem(12) + 'rem', fontWeight: "600", color: isDarkMode ? "#a5b4fc" : "#4f46e5" }}>
                            {guideMeLoading ? (t ? t("Thinking…") : "Thinking…") : (t ? t("Guide Me") : "Guide Me")}
                          </Text>
                        </TouchableOpacity>
                      </View>

                      {expandedChapters[subject.id]?.[chapter.id] &&
                        chapter.topics.map((topic) => {
                          const topicLabel = nodeLabel(topic);
                          const topicKey = `${chapter.id}-${topic.id}`;
                          const isTopicActive =
                            activeTopic === topicKey;
                          const topicState =
                            expandedTopics[chapter.id]?.[topic.id];

                          return (
                            <View
                              key={topic.id}
                              style={[
                                styles(isDarkMode).topicTitleItem,
                                isTopicActive
                                  ? styles(isDarkMode).activeItem
                                  : {},
                              ]}
                            >
                              <TouchableOpacity
                                onPress={() =>
                                  toggleExpandTopic(chapter.id, topic.id, {
                                    topic_name: topic.display_name || topic.displayName || topic.topicName || topic.name || "",
                                    chapter_name: chapter.display_name || chapter.displayName || chapter.name || "",
                                    // ✅ this is the critical part (don’t use topic.id)
                                    source_topic_id: topic.source_topic_id || topic.sourceTopicId || topic.source_id || null,
                                  })
                                }
                              >
                                <Text style={styles(isDarkMode).topicTitle}>
                                  {topicState?.expanded ? "🔽" : "▶"}{" "}
                                  {topicLabel}
                                </Text>
                              </TouchableOpacity>

                              {topicState?.expanded && (
                                <View
                                  style={styles(isDarkMode).contentSection}
                                >
                                  {/* 🎬 Videos */}
                                  {topicState?.videos?.length > 0 && (
                                    <View>
                                      <TouchableOpacity
                                        onPress={() =>
                                          toggleExpandVideos(
                                            chapter.id,
                                            topic.id
                                          )
                                        }
                                      >
                                        <Text
                                          style={
                                            styles(isDarkMode).sectionTitle
                                          }
                                        >
                                          🎬 {t("Videos")}{" "}
                                          {expandedVideos[topicKey]
                                            ? "🔽"
                                            : "▶"}
                                        </Text>
                                      </TouchableOpacity>

                                      {expandedVideos[topicKey] &&
                                        topicState.videos.map((video) => (
                                          <TouchableOpacity
                                            key={`${video.source_id}-${video.tag_id}`}
                                            onPress={() =>
                                              handleVideoClick(
                                                video.source_id,
                                                video.tag_id,
                                                authToken,
                                                chapter.id,
                                                topic.id
                                              )
                                            }
                                          >
                                            <Text
                                              style={[
                                                styles(isDarkMode)
                                                  .contentItem,
                                                activeVideo ===
                                                  `${video.source_id}-${video.tag_id}`
                                                  ? styles(isDarkMode)
                                                    .activeItem
                                                  : {},
                                              ]}
                                            >
                                              {video.name}
                                            </Text>
                                          </TouchableOpacity>
                                        ))}
                                    </View>
                                  )}

                                  {/* 🎮 PWOs */}
                                  {topicState?.pwos?.length > 0 && (
                                    <View>
                                      <TouchableOpacity
                                        onPress={() =>
                                          toggleExpandPWOs(
                                            chapter.id,
                                            topic.id
                                          )
                                        }
                                      >
                                        <Text
                                          style={
                                            styles(isDarkMode).sectionTitle
                                          }
                                        >
                                          🎮 {t("Interactive PWOs")}{" "}
                                          {expandedPWOs[topicKey]
                                            ? "🔽"
                                            : "▶"}
                                        </Text>
                                      </TouchableOpacity>

                                      {expandedPWOs[topicKey] &&
                                        topicState.pwos.map((pwo) => (
                                          <TouchableOpacity
                                            key={`${pwo.pwo_source_id}-${pwo.scene_name}`}
                                            onPress={() =>
                                              handlePWOClick(
                                                pwo.pwo_source_id,
                                                pwo.scene_name,
                                                authToken,
                                                lang, // from outer scope as before
                                                chapter.id,
                                                topic.id
                                              )
                                            }
                                          >
                                            <Text
                                              style={[
                                                styles(isDarkMode)
                                                  .contentItem,
                                                activePWO ===
                                                  `${pwo.pwo_source_id}-${pwo.scene_name}`
                                                  ? styles(isDarkMode)
                                                    .activeItem
                                                  : {},
                                              ]}
                                            >
                                              {formatPwoName(pwo.name)}
                                            </Text>
                                          </TouchableOpacity>
                                        ))}
                                    </View>
                                  )}

                                  {/* 📝 Quiz */}
                                  <View>
                                    <TouchableOpacity
                                      style={
                                        styles(isDarkMode).quizButton
                                      }
                                      onPress={() => {
                                        const quizTopicId =
                                          resolveSourceTopicId(
                                            topic.source_id
                                          );
                                        if (!quizTopicId) return;

                                        const subjectLabelForQuiz =
                                          nodeLabel(subject);
                                        const chapterLabelForQuiz =
                                          nodeLabel(chapter);
                                        const topicLabelForQuiz =
                                          nodeLabel(topic);

                                        fetchQuiz(
                                          quizTopicId,
                                          languageIDquiz, // from outer scope
                                          subjectLabelForQuiz,
                                          subject.id,
                                          topicLabelForQuiz,
                                          chapterLabelForQuiz
                                        );
                                      }}
                                    >
                                      <Text
                                        style={
                                          styles(isDarkMode).sectionTitle
                                        }
                                      >
                                        📝 {t("Quiz This Topic")}
                                      </Text>
                                    </TouchableOpacity>

                                    {topicState?.quiz && (
                                      <View
                                        style={
                                          styles(isDarkMode).quizSection
                                        }
                                      >
                                        <Text
                                          style={
                                            styles(isDarkMode).sectionTitle
                                          }
                                        >
                                          📝 {t("Quiz Questions")}
                                        </Text>
                                        {topicState.quiz.questions.map(
                                          (q, index) => (
                                            <Text
                                              key={index}
                                              style={
                                                styles(isDarkMode)
                                                  .contentItem
                                              }
                                            >
                                              {q.question}
                                            </Text>
                                          )
                                        )}
                                      </View>
                                    )}
                                  </View>
                                </View>
                              )}
                            </View>
                          );
                        })}
                    </View>
                  );
                })}
            </View>
          );
        })}
      </View>
    ));
  };

  // Hardcoded visibility flags (can later be passed via props or loaded from settings)
  const showGrade = true;
  const showSubject = true;
  const showChapter = true;
  const showTopic = true;
  const showVideos = false;
  const showPWOs = true;
  const showQuizzes = false;

  const TopicTile = ({ topic, imgUrl, isExpanded, isDarkMode, onPress, onImageExpired }) => {
    return (
      <TouchableOpacity
        onPress={onPress}
        style={{
          ...tileSize160,
          margin: 4,
          backgroundColor: isDarkMode ? "#1e1e1e" : "#fff",
          borderRadius: 10,
          overflow: "hidden",
          borderWidth: 1,
          borderColor: isDarkMode ? "#444" : "#ddd",
          shadowColor: "#000",
          shadowOpacity: 0.2,
          shadowRadius: 4,
        }}
      >
        {imgUrl ? (
          <Image source={{ uri: imgUrl }}
            style={{ width: "100%", height: 90 }}
            resizeMode="cover"
            onError={() => {
              // trigger refresh pre-signed urls
              console.warn("Topic image expired");
              onImageExpired?.();
            }}
          />
        ) : (
          <View style={{ width: "100%", height: 90, backgroundColor: "#ccc", justifyContent: "center", alignItems: "center" }}>
            <Text style={{ color: "#666", fontSize: rem(12) + 'rem' }}>{t("No Image")}</Text>
          </View>
        )}
        <View style={{ padding: 8, alignItems: "center" }}>
          <Text
            style={{
              fontWeight: "600",
              fontSize: rem(14) + 'rem',
              color: isDarkMode ? "#fff" : "#000",
              textAlign: "center",
            }}
          >
            {topic.name}
          </Text>
          <Text style={{ fontSize: rem(12) + 'rem', color: "#999", marginTop: 4 }}>
            {isExpanded ? "🔽 " + t("Collapse") : "▶ " + t("Expand")}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };

  const ChapterTile = ({ chapter, imageUrlMap, isDarkMode, onImageExpired }) => {
    const chapterImgUrl = imageUrlMap[chapter.chapter_image_path];

    return (
      <TouchableOpacity
        style={{
          ...tileSize160,
          margin: 4,
          backgroundColor: isDarkMode ? "#1e1e1e" : "#fff",
          borderRadius: 10,
          overflow: "hidden",
          borderWidth: 1,
          borderColor: isDarkMode ? "#444" : "#ddd",
          shadowColor: "#000",
          shadowOpacity: 0.2,
          shadowRadius: 4,
        }}
      >
        {chapterImgUrl ? (
          <Image
            source={{ uri: chapterImgUrl }}
            style={{ width: "100%", height: 90 }}
            resizeMode="cover"
            onError={() => {
              // trigger refresh pre-signed urls
              console.warn("Chapter image expired");
              onImageExpired?.();
            }}
          />
        ) : (
          <View
            style={{
              width: "100%",
              height: 90,
              backgroundColor: "#ccc",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text style={{ color: "#666", fontSize: rem(12) + 'rem' }}>{t("No Image")}</Text>
          </View>
        )}
        <View style={{ padding: 8, alignItems: "center" }}>
          <Text
            style={{
              fontWeight: "600",
              fontSize: rem(14) + 'rem',
              color: isDarkMode ? "#fff" : "#000",
              textAlign: "center",
            }}
          >
            {chapter.name}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };

  const PwoTile = ({
    pwo,
    isActive,
    isDarkMode,
    imageUrlMap,
    onPress,
    onImageExpired
  }) => {
    // const imgUrl = imageUrlMap[pwo.image_path];
    const normalizedPath = pwo.image_path?.replace(/\/+/g, "/").trim();
    const imgUrl = imageUrlMap[normalizedPath];

    console.log("🔍 PWO normalizedPath:", normalizedPath);
    console.log("🔍 PWO image path:", pwo.image_path);
    console.log("🔍 PWO imgUrl:", imgUrl);

    return (
      <TouchableOpacity
        onPress={onPress}
        style={{
          ...tileSize160,
          margin: 4,
          backgroundColor: isDarkMode ? "#1e1e1e" : "#fff",
          borderRadius: 10,
          overflow: "hidden",
          borderWidth: 1,
          borderColor: isActive ? "#4CAF50" : isDarkMode ? "#444" : "#ddd",
          shadowColor: "#000",
          shadowOpacity: 0.2,
          shadowRadius: 4,
        }}
      >
        {imgUrl ? (
          <Image
            source={{ uri: imgUrl }}
            style={{ width: "100%", height: 90 }}
            resizeMode="cover"
            onError={() => {
              // trigger refresh pre-signed urls
              console.warn("PWO Image expired");
              onImageExpired?.();
            }}
          />
        ) : (
          <View
            style={{
              width: "100%",
              height: 90,
              backgroundColor: "#ccc",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text style={{ color: "#666", fontSize: rem(12) + 'rem' }}>{t("No Image")}</Text>
          </View>
        )}

        <View style={{ padding: 8, alignItems: "center" }}>
          <Text
            style={{
              fontWeight: "600",
              fontSize: rem(14) + 'rem',
              color: isDarkMode ? "#fff" : "#000",
              textAlign: "center",
            }}
          >
            {formatPwoName(pwo.name)}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };
  // BDD 6/23/2025 - do not want to do this - use debugPromptMode for Da Vinci only
  // const renderCurriculumTree = (props) => {
  //   if (debugPromptMode) {
  //     return renderCurriculumTreeTile(props);  // ✅ forward props
  //   } else {
  //     return renderCurriculumTreeList(props);  // ✅ forward props
  //   }
  // };
  const renderCurriculumTree = (props) => {
    return renderCurriculumTreeList(props);  // ✅ forward props
  };
  const renderCurriculumTreeTile = ({
    curriculum,
    isDarkMode,
    styles,
    expandedSubjects,
    expandedChapters,
    expandedTopics,
    expandedVideos,
    expandedPWOs,
    activeTopic,
    activeVideo,
    activePWO,
    authToken,
    toggleExpandSubject,
    toggleExpandChapter,
    toggleExpandTopic,
    toggleExpandVideos,
    toggleExpandPWOs,
    fetchQuiz,
    handleVideoClick,
    handlePWOClick,
    languageID,
  }) => {
    return curriculum.map((level) => (
      <View key={level.id} style={styles(isDarkMode).levelContainer}>
        {showGrade && (
          <Text style={styles(isDarkMode).levelTitle}>
            {t("Grade")} {level.grade}
          </Text>
        )}

        {level.subjects.map((subject) => (
          <View key={subject.id} style={styles(isDarkMode).subjectContainer}>
            {showSubject && (
              <TouchableOpacity onPress={() => toggleExpandSubject(level.id, subject.id)}>
                <Text style={styles(isDarkMode).subjectTitle}>{subject.name}</Text>
              </TouchableOpacity>
            )}

            {expandedSubjects[level.id]?.[subject.id] &&
              subject.chapters.map((chapter) => {
                if (!showChapter) return null;
                const chapterImgUrl = imageUrlMap[chapter.chapter_image_path];
                const isChapterExpanded = expandedChapters[subject.id]?.[chapter.id];

                return (
                  <View key={chapter.id} style={styles(isDarkMode).chapterContainer}>
                    <TouchableOpacity onPress={() => toggleExpandChapter(subject.id, chapter.id)}>
                      <Text style={styles(isDarkMode).chapterTitle}>
                        {isChapterExpanded ? "🔽" : "▶"} {chapter.name}
                      </Text>
                    </TouchableOpacity>

                    {isChapterExpanded && (
                      <>
                        <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ marginTop: 8, marginBottom: 12 }}>
                          <View style={{ marginTop: 12 }}>
                            <Text style={[styles(isDarkMode).sectionTitle, { marginBottom: 6 }]}>
                              📘 {chapter.name}
                            </Text>
                            <View style={{ flexDirection: "row", gap: 12, paddingHorizontal: 8 }}>
                              <ChapterTile chapter={chapter} imageUrlMap={imageUrlMap} isDarkMode={isDarkMode} onImageExpired={onImageExpired} />
                            </View>
                          </View>
                        </ScrollView>

                        <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 12 }}>
                          {chapter.topics.map((topic) => {
                            const imgUrl = imageUrlMap[topic.topic_image_path];
                            const isExpanded = expandedTopics[chapter.id]?.[topic.id]?.expanded;

                            return (
                              <View key={topic.id}>
                                {/* your existing topic tile code here */}
                              </View>
                            );
                          })}
                        </View>

                      </>
                    )}

                    {isChapterExpanded && showTopic && (

                      <ScrollView
                        horizontal={true}
                        showsHorizontalScrollIndicator={true}
                        contentContainerStyle={{ paddingHorizontal: 8 }}
                        style={{ marginTop: 8, marginBottom: 12 }}
                      >
                        {chapter.topics.map((topic) => {
                          const imgUrl = imageUrlMap[topic.topic_image_path];
                          const isExpanded = expandedTopics[chapter.id]?.[topic.id]?.expanded;

                          return (
                            <View key={topic.id}>
                              <TopicTile
                                topic={topic}
                                imgUrl={imgUrl}
                                isExpanded={isExpanded}
                                isDarkMode={isDarkMode}
                                onPress={() =>
                                  toggleExpandTopic(chapter.id, topic.id, {
                                    topic_name: topic.display_name || topic.displayName || topic.topicName || topic.name || "",
                                    chapter_name: chapter.display_name || chapter.displayName || chapter.name || "",
                                    // ✅ this is the critical part (don’t use topic.id)
                                    source_topic_id: topic.source_topic_id || topic.sourceTopicId || topic.source_id || null,
                                  })
                                }
                                onImageExpired={onImageExpired}
                              />

                              {isExpanded && (
                                <View style={[styles(isDarkMode).contentSection, { paddingLeft: 12, marginTop: 12 }]}>

                                  <View style={{ marginBottom: 10 }}>
                                    <Text style={[styles(isDarkMode).sectionTitle, { fontSize: rem(14) + 'rem', fontWeight: "600" }]}>
                                      📘 {chapter.name} {">"} 📗 {topic.name}
                                    </Text>

                                    {activePWO && (
                                      <Text style={[styles(isDarkMode).sectionTitle, { fontSize: rem(13) + 'rem', color: "#888", marginTop: 2 }]}>
                                        🎮 {t("Active PWO")}: {activePWO.split("-")[1]}
                                      </Text>
                                    )}

                                    {activeVideo && (
                                      <Text style={[styles(isDarkMode).sectionTitle, { fontSize: rem(13) + 'rem', color: "#888", marginTop: 2 }]}>
                                        🎬 {t("Active Video")}: {activeVideo.split("-")[1]}
                                      </Text>
                                    )}
                                  </View>


                                  <Text style={[styles(isDarkMode).sectionTitle, { marginBottom: 6 }]}>
                                    📗 {topic.name}
                                  </Text>
                                  {/* 🎬 Videos Section */}
                                  {showVideos && expandedTopics[chapter.id]?.[topic.id]?.videos?.length > 0 && (
                                    <View style={{ marginTop: 16, marginBottom: 16 }}>
                                      <Text style={styles(isDarkMode).sectionTitle}>
                                        🎬 {t("Videos")}
                                      </Text>

                                      <TouchableOpacity onPress={() => toggleExpandVideos(chapter.id, topic.id)}>
                                        <Text style={[styles(isDarkMode).sectionSubToggle]}>
                                          {expandedVideos[`${chapter.id}-${topic.id}`] ? "🔽 " + t("Collapse") : "▶ " + t("Expand")}
                                        </Text>
                                      </TouchableOpacity>

                                      {expandedVideos[`${chapter.id}-${topic.id}`] && (
                                        <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 12, marginTop: 8 }}>
                                          {expandedTopics[chapter.id][topic.id].videos.map((video) => (
                                            <TouchableOpacity
                                              key={`${video.source_id}-${video.tag_id}`}
                                              onPress={() =>
                                                handleVideoClick(video.source_id, video.tag_id, authToken, chapter.id, topic.id)
                                              }
                                            >
                                              <Text
                                                style={[
                                                  styles(isDarkMode).contentItem,
                                                  activeVideo === `${video.source_id}-${video.tag_id}`
                                                    ? styles(isDarkMode).activeItem
                                                    : {},
                                                ]}
                                              >
                                                {video.name}
                                              </Text>
                                            </TouchableOpacity>
                                          ))}
                                        </View>
                                      )}
                                    </View>
                                  )}

                                  {/* 🎮 Interactive PWOs Section */}
                                  {showPWOs && expandedTopics[chapter.id]?.[topic.id]?.pwos?.length > 0 && (
                                    <View style={{ marginTop: 16, marginBottom: 16 }}>
                                      <Text style={styles(isDarkMode).sectionTitle}>
                                        🎮 {t("Interactive PWOs")}
                                      </Text>

                                      <TouchableOpacity onPress={() => toggleExpandPWOs(chapter.id, topic.id)}>
                                        <Text style={[styles(isDarkMode).sectionSubToggle]}>
                                          {expandedPWOs[`${chapter.id}-${topic.id}`] ? "🔽 " + t("Collapse") : "▶ " + t("Expand")}
                                        </Text>
                                      </TouchableOpacity>

                                      {expandedPWOs[`${chapter.id}-${topic.id}`] && (
                                        <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 12, marginTop: 8 }}>
                                          {expandedTopics[chapter.id][topic.id].pwos.map((pwo) => {
                                            const isActive = activePWO === `${pwo.pwo_source_id}-${pwo.scene_name}`;
                                            return (
                                              <PwoTile
                                                key={`${pwo.pwo_source_id}-${pwo.scene_name}`}
                                                pwo={pwo}
                                                isActive={isActive}
                                                isDarkMode={isDarkMode}
                                                imageUrlMap={imageUrlMap}
                                                onPress={() =>
                                                  handlePWOClick(pwo.pwo_source_id, pwo.scene_name, authToken, lang, chapter.id, topic.id)
                                                }
                                                onImageExpired={onImageExpired}
                                              />
                                            );
                                          })}
                                        </View>
                                      )}
                                    </View>
                                  )}

                                  {/* 📝 Quiz Section */}
                                  {showQuizzes && (
                                    <View style={{ marginTop: 16, marginBottom: 16 }}>
                                      <Text style={styles(isDarkMode).sectionTitle}>
                                        📝 {t("Quiz")}
                                      </Text>

                                      <TouchableOpacity
                                        style={styles(isDarkMode).quizButton}
                                        onPress={() => {
                                          const quizTopicId = resolveSourceTopicId(topic.source_id);
                                          if (!quizTopicId) return;
                                          fetchQuiz(quizTopicId, languageIDquiz, subject.name, subject.id, topic.name, chapter.name);
                                        }}
                                      >
                                        <Text style={styles(isDarkMode).sectionSubToggle}>{t("Quiz This Topic")}</Text>
                                      </TouchableOpacity>

                                      {expandedTopics[chapter.id]?.[topic.id]?.quiz && (
                                        <View style={[styles(isDarkMode).quizSection, { marginTop: 8 }]}>
                                          <Text style={styles(isDarkMode).sectionTitle}>
                                            🧠 {t("Quiz Questions")}
                                          </Text>
                                          {expandedTopics[chapter.id][topic.id].quiz.questions.map((q, index) => (
                                            <Text key={index} style={styles(isDarkMode).contentItem}>
                                              {q.question}
                                            </Text>
                                          ))}
                                        </View>
                                      )}
                                    </View>
                                  )}

                                </View>
                              )}



                            </View>
                          );
                        })}
                      </ScrollView>
                    )}
                  </View>
                );
              })}
          </View>
        ))}
      </View>
    ));
  };

  // // BDD 9/23/2025
  // // Split <br> tags into explicit break tokens

  // // --- SegmentsRendererRN (updated inline images inside <Text>) ---

  // const BREAK = "__SEG_BREAK__";
  // const isWhitespaceOnly = (s) => (s ?? "").trim().length === 0;

  // function normalizeSegments(segments = []) {
  //   const out = [];
  //   for (const seg of segments) {
  //     if (!seg) continue;
  //     if (seg.type === "Text") {
  //       const parts = String(seg.text ?? "").split(/<br\s*\/?>/i);
  //       parts.forEach((part, idx) => {
  //         out.push({ type: "Text", text: part });
  //         if (idx < parts.length - 1) out.push({ type: BREAK });
  //       });
  //     } else if (seg.type === "Image") {
  //       const src = seg.src ?? seg.base64 ?? seg.uri;
  //       if (src) out.push({ ...seg, src });
  //     }
  //   }
  //   return out;
  // }

  // function splitIntoParagraphs(tokens) {
  //   const paras = [];
  //   let cur = [];
  //   const push = () => { if (cur.length) paras.push(cur); cur = []; };
  //   for (const t of tokens) (t?.type === BREAK ? push() : cur.push(t));
  //   push();
  //   return paras;
  // }

  // function ratioOf(img) {
  //   if (Number.isFinite(img?.aspect_ratio)) return img.aspect_ratio;
  //   if (Number.isFinite(img?.width) && Number.isFinite(img?.height) && img.height > 0) {
  //     return img.width / img.height;
  //   }
  //   return 1;
  // }

  // function isInlineImage(img, prev, next) {
  //   const surroundedByText =
  //     (prev?.type === "Text" && !isWhitespaceOnly(prev.text)) ||
  //     (next?.type === "Text" && !isWhitespaceOnly(next.text));

  //   const isVertical = img.orientation === "vertical";
  //   const veryWide = (img.aspect_ratio ?? ratioOf(img)) >= 3.5;
  //   const tallPx = (img.height ?? 0) >= 80;

  //   // Treat small-ish images inline by default; big/tall/very wide go block.
  //   if (isVertical || veryWide || tallPx) return false;
  //   return surroundedByText;
  // }

  // function BlockImage({ img }) {
  //   const hasDims = Number.isFinite(img?.width) && Number.isFinite(img?.height);
  //   const isHoriz = img?.orientation === "horizontal";
  //   const widthStyle =
  //     hasDims && img.width < 150 ? img.width : isHoriz ? "100%" : "50%";
  //   const heightStyle =
  //     hasDims && img.height < 150 ? img.height : img?.orientation === "vertical" ? 300 : 250;

  //   return (
  //     <Image
  //       source={{ uri: img.src }}
  //       style={{
  //         width: widthStyle,
  //         height: heightStyle,
  //         resizeMode: "contain",
  //         alignSelf: "center",
  //         marginVertical: 5,
  //       }}
  //     />
  //   );
  // }

  // export function SegmentsRendererRN({
  //   segments,
  //   isDarkMode = false,
  //   baseFontSize = 16,
  // }) 
  // {
  //   const tokens = normalizeSegments(segments);
  //   const paras = splitIntoParagraphs(tokens);

  //   const textStyle = {
  //     fontSize: baseFontSize,
  //     lineHeight: Math.round(baseFontSize * 1.5),
  //     color: isDarkMode ? "#FFF" : "#111827",
  //   };

  //   return (
  //     <View>
  //       {paras.map((para, i) => {
  //         if (!para.length) {
  //           return <View key={i} style={{ height: textStyle.lineHeight / 2 }} />;
  //         }

  //         // All images => show as block images stacked
  //         const onlyImages = para.every((t) => t.type === "Image");
  //         if (onlyImages) {
  //           return (
  //             <View key={i} style={{ marginBottom: 12 }}>
  //               {para.map((img, j) => (
  //                 <BlockImage key={j} img={img} />
  //               ))}
  //             </View>
  //           );
  //         }

  //         // Mixed content: build one <Text> that contains strings + inline <Image/> children.
  //         const children = [];
  //         const flushText = (txt) => {
  //           if (!txt) return;
  //           children.push(txt); // RN <Text> can take plain strings in the children array
  //         };

  //         let pendingText = "";

  //         const flushPendingText = () => {
  //           if (pendingText.length) {
  //             flushText(pendingText);
  //             pendingText = "";
  //           }
  //         };

  //         const rows = [];

  //         para.forEach((t, j) => {
  //           if (t.type === "Text") {
  //             pendingText += t.text ?? "";
  //             return;
  //           }
  //           // Image
  //           const prev = para[j - 1];
  //           const next = para[j + 1];
  //           const inline = isInlineImage(t, prev, next);

  //           if (inline) {
  //             // Close any accumulated text chunk before inserting the inline image?
  //             flushPendingText();
  //             const height = Math.round(baseFontSize * 1.1);
  //             const width = Math.round(height * ratioOf(t));
  //             children.push(
  //               <Image
  //                 key={`inline-${i}-${j}`}
  //                 source={{ uri: t.src }}
  //                 style={{
  //                   width,
  //                   height,
  //                   resizeMode: "contain",
  //                   marginHorizontal: 3,
  //                   // A tiny vertical tweak helps baseline alignment on Android:
  //                   transform: [{ translateY: Math.round((textStyle.lineHeight - height) / 4) * -1 }],
  //                 }}
  //               />
  //             );
  //           } else {
  //             // We hit a block image: close the current inline <Text>, then push the block image.
  //             flushPendingText();
  //             if (children.length) {
  //               rows.push(
  //                 <Text key={`ptext-${i}-${j}`} style={textStyle}>
  //                   {children}
  //                 </Text>
  //               );
  //               children.length = 0;
  //             }
  //             rows.push(<BlockImage key={`block-${i}-${j}`} img={t} />);
  //           }
  //         });

  //         // Flush trailing text/children as one <Text>
  //         flushPendingText();
  //         if (children.length) {
  //           rows.push(
  //             <Text key={`ptext-end-${i}`} style={textStyle}>
  //               {children}
  //             </Text>
  //           );
  //         }

  //         return (
  //           <View key={i} style={{ marginBottom: 12 }}>
  //             {rows}
  //           </View>
  //         );
  //       })}
  //     </View>
  //   );
  // }

  // // BDD 9/23/2025

  // ---- SegmentsRendererRN (single-file version; no export/import here) ----
  const BREAK = "__SEG_BREAK__";
  const isWhitespaceOnly = (s) => (s ?? "").trim().length === 0;

  // inside the paragraph render block:
  let inlines = [];
  let buffer = "";

  const flushBuffer = () => {
    if (!isWhitespaceOnly(buffer)) inlines.push(buffer);
    buffer = "";
  };

  const pushLine = (key) => {
    if (!inlines.length) return;
    const children = inlines.slice();   // copy to avoid later mutations
    rows.push(
      <Text key={key} style={textStyle}>
        {children}
      </Text>
    );
    inlines = []; // reassign (don’t mutate the same array)
  };

  function isInlineImage(img, prev, next) {
    const surroundedByText =
      (prev?.type === "Text" && !isWhitespaceOnly(prev.text)) ||
      (next?.type === "Text" && !isWhitespaceOnly(next.text));

    const isVertical = img.orientation === "vertical";
    const veryWide = (img.aspect_ratio ?? ratioOf(img)) >= 3.5;
    const tallPx = (img.height ?? 0) >= 80;

    // Small-ish images inline; big/tall/very-wide → block
    if (isVertical || veryWide || tallPx) return false;
    return surroundedByText;
  }

  function normalizeSegments(segments = []) {
    const out = [];
    for (const seg of segments) {
      if (!seg) continue;
      if (seg.type === "Text") {
        const parts = String(seg.text ?? "").split(/<br\s*\/?>/i);
        parts.forEach((part, idx) => {
          out.push({ type: "Text", text: part });
          if (idx < parts.length - 1) out.push({ type: BREAK });
        });
      } else if (seg.type === "Image") {
        const src = seg.src ?? seg.base64 ?? seg.uri;
        if (src) out.push({ ...seg, src });
      }
    }
    return out;
  }

  function splitIntoParagraphs(tokens) {
    const paras = [];
    let cur = [];
    const flush = () => { if (cur.length) paras.push(cur); cur = []; };
    for (const t of tokens) (t?.type === BREAK ? flush() : cur.push(t));
    flush();
    return paras;
  }

  function ratioOf(img) {
    if (Number.isFinite(img?.aspect_ratio)) return img.aspect_ratio;
    if (Number.isFinite(img?.width) && Number.isFinite(img?.height) && img.height > 0) {
      return img.width / img.height;
    }
    return 1;
  }


  const BlockImage = ({ img }) => {
    const hasDims = Number.isFinite(img?.width) && Number.isFinite(img?.height);
    const isHoriz = img?.orientation === "horizontal";
    const widthStyle =
      hasDims && img.width < 150 ? img.width : isHoriz ? "100%" : "50%";
    const heightStyle =
      hasDims && img.height < 150 ? img.height : img?.orientation === "vertical" ? 300 : 250;

    return (
      <Image
        source={{ uri: img.src }}
        style={{
          width: widthStyle,
          height: heightStyle,
          resizeMode: "contain",
          alignSelf: "center",
          marginVertical: 5,
        }}
      />
    );
  };

  const SegmentsRendererRN = ({
    segments,
    isDarkMode = false,
    baseFontSize = 16,
  }) => {
    const tokens = normalizeSegments(segments);
    const paras = splitIntoParagraphs(tokens);

    const textStyle = {
      fontSize: baseFontSize,
      lineHeight: Math.round(baseFontSize * 1.5),
      color: isDarkMode ? "#FFF" : "#111827",
      includeFontPadding: false,
    };


    return (
      <View>
        {paras.map((para, i) => {
          if (!para.length) {
            return <View key={i} style={{ height: textStyle.lineHeight / 2 }} />;
          }

          if (para.every((t) => t.type === "Image")) {
            return (
              <View key={i} style={{ marginBottom: 12 }}>
                {para.map((img, j) => (
                  <BlockImage key={j} img={img} />
                ))}
              </View>
            );
          }

          let inlines = [];           // <-- let, not const
          let buffer = "";
          const rows = [];

          const flushBuffer = () => {
            if (buffer.length) {
              inlines.push(buffer);
              buffer = "";
            }
          };

          const pushLine = (key) => {
            // no content? skip
            if (!inlines.length ||
              (inlines.length === 1 && typeof inlines[0] === "string" && inlines[0].trim() === "")) {
              inlines = [];            // reassign, don't mutate in place
              return;
            }
            const children = inlines.slice(); // safe copy
            rows.push(
              <Text key={key} style={textStyle}>
                {children}
              </Text>
            );
            inlines = [];              // reassign, don't mutate in place
          };

          para.forEach((t, j) => {
            if (t.type === "Text") {
              buffer += t.text ?? "";
              return;
            }

            const prev = para[j - 1];
            const next = para[j + 1];
            const inline = isInlineImage(t, prev, next);

            if (inline) {
              flushBuffer();
              const height = Math.round(baseFontSize * 1.1);
              const width = Math.round(height * ratioOf(t));
              inlines.push(
                <Image
                  key={`inline-${i}-${j}`}
                  source={{ uri: t.src }}
                  style={{
                    width,
                    height,
                    resizeMode: "contain",
                    marginHorizontal: 3,
                    transform: [{ translateY: Math.round((textStyle.lineHeight - height) / 4) * -1 }],
                  }}
                />
              );
            } else {
              // block image: finish any pending text run, then render the image
              flushBuffer();
              pushLine(`ptext-${i}-${j}`);
              rows.push(<BlockImage key={`block-${i}-${j}`} img={t} />);
            }
          });

          // finish the last pending text run (if any)
          flushBuffer();
          pushLine(`ptext-end-${i}`);

          return (
            <View key={i} style={{ marginBottom: 12 }}>
              {rows}
            </View>
          );
        })}
      </View>
    );
  };

  // const BREAK = "__SEG_BREAK__";
  // const isWhitespaceOnly = (s) => (s ?? "").trim().length === 0;

  // function normalizeSegments(segments = []) {
  //   const out = [];
  //   for (const seg of segments) {
  //     if (!seg) continue;
  //     if (seg.type === "Text") {
  //       const parts = String(seg.text ?? "").split(/<br\s*\/?>/i);
  //       parts.forEach((part, idx) => {
  //         out.push({ type: "Text", text: part });
  //         if (idx < parts.length - 1) out.push({ type: BREAK });
  //       });
  //     } else if (seg.type === "Image") {
  //       const src = seg.src ?? seg.base64 ?? seg.uri;
  //       if (src) out.push({ ...seg, src });
  //     }
  //   }
  //   return out;
  // }

  // function splitIntoParagraphs(tokens) {
  //   const paras = [];
  //   let cur = [];
  //   const flush = () => { if (cur.length) paras.push(cur); cur = []; };
  //   for (const t of tokens) (t?.type === BREAK ? flush() : cur.push(t));
  //   flush();
  //   return paras;
  // }

  // function ratioOf(img) {
  //   if (Number.isFinite(img?.aspect_ratio)) return img.aspect_ratio;
  //   if (Number.isFinite(img?.width) && Number.isFinite(img?.height) && img.height > 0) {
  //     return img.width / img.height;
  //   }
  //   return 1;
  // }

  // function isInlineImage(img, prev, next) {
  //   const surroundedByText =
  //     (prev?.type === "Text" && !isWhitespaceOnly(prev.text)) ||
  //     (next?.type === "Text" && !isWhitespaceOnly(next.text));

  //   const isVertical = img.orientation === "vertical";
  //   const veryWide = (img.aspect_ratio ?? ratioOf(img)) >= 3.5;
  //   const tallPx = (img.height ?? 0) >= 80;

  //   // Small-ish images inline; big/tall/very-wide are block.
  //   if (isVertical || veryWide || tallPx) return false;
  //   return surroundedByText;
  // }

  // function BlockImage({ img }) {
  //   const hasDims = Number.isFinite(img?.width) && Number.isFinite(img?.height);
  //   const isHoriz = img?.orientation === "horizontal";
  //   const widthStyle =
  //     hasDims && img.width < 150 ? img.width : isHoriz ? "100%" : "50%";
  //   const heightStyle =
  //     hasDims && img.height < 150 ? img.height : img?.orientation === "vertical" ? 300 : 250;

  //   return (
  //     <Image
  //       source={{ uri: img.src }}
  //       style={{
  //         width: widthStyle,
  //         height: heightStyle,
  //         resizeMode: "contain",
  //         alignSelf: "center",
  //         marginVertical: 5,
  //       }}
  //     />
  //   );
  // }

  // export function SegmentsRendererRN({
  //   segments,
  //   isDarkMode = false,
  //   baseFontSize = 16,
  // }) {
  //   const tokens = normalizeSegments(segments);
  //   const paras = splitIntoParagraphs(tokens);

  //   const textStyle = {
  //     fontSize: baseFontSize,
  //     lineHeight: Math.round(baseFontSize * 1.5),
  //     color: isDarkMode ? "#FFF" : "#111827",
  //     includeFontPadding: false, // helps Android baseline
  //   };

  //   return (
  //     <View>
  //       {paras.map((para, i) => {
  //         if (!para.length) {
  //           return <View key={i} style={{ height: textStyle.lineHeight / 2 }} />;
  //         }

  //         // Paragraph of only images → stack them as blocks
  //         if (para.every((t) => t.type === "Image")) {
  //           return (
  //             <View key={i} style={{ marginBottom: 12 }}>
  //               {para.map((img, j) => (
  //                 <BlockImage key={j} img={img} />
  //               ))}
  //             </View>
  //           );
  //         }

  //         // Mixed: one <Text> containing strings + inline <Image/>, interleaved.
  //         const inlines = [];
  //         let buffer = "";

  //         const flushBuffer = () => {
  //           if (buffer.length) {
  //             inlines.push(buffer);
  //             buffer = "";
  //           }
  //         };

  //         const rows = [];

  //         para.forEach((t, j) => {
  //           if (t.type === "Text") {
  //             buffer += t.text ?? "";
  //             return;
  //           }
  //           // t is Image
  //           const prev = para[j - 1];
  //           const next = para[j + 1];
  //           const inline = isInlineImage(t, prev, next);

  //           if (inline) {
  //             flushBuffer();
  //             const height = Math.round(baseFontSize * 1.1);
  //             const width = Math.round(height * ratioOf(t));
  //             inlines.push(
  //               <Image
  //                 key={`inline-${i}-${j}`}
  //                 source={{ uri: t.src }}
  //                 style={{
  //                   width,
  //                   height,
  //                   resizeMode: "contain",
  //                   marginHorizontal: 3,
  //                   transform: [{ translateY: Math.round((textStyle.lineHeight - height) / 4) * -1 }],
  //                 }}
  //               />
  //             );
  //           } else {
  //             // Close current <Text>, render block image, then continue.
  //             flushBuffer();
  //             if (inlines.length) {
  //               rows.push(
  //                 <Text key={`ptext-${i}-${j}`} style={textStyle}>
  //                   {inlines}
  //                 </Text>
  //               );
  //               inlines.length = 0;
  //             }
  //             rows.push(<BlockImage key={`block-${i}-${j}`} img={t} />);
  //           }
  //         });

  //         flushBuffer();
  //         if (inlines.length) {
  //           rows.push(
  //             <Text key={`ptext-end-${i}`} style={textStyle}>
  //               {inlines}
  //             </Text>
  //           );
  //         }

  //         return (
  //           <View key={i} style={{ marginBottom: 12 }}>
  //             {rows}
  //           </View>
  //         );
  //       })}
  //     </View>
  //   );
  // }

  // // BDD 9/23/2025

  // const BREAK = "__SEG_BREAK__";
  // const isWhitespaceOnly = (s) => (s ?? "").trim().length === 0;

  // function normalizeSegments(segments = []) {
  //   const out = [];
  //   for (const seg of segments) {
  //     if (!seg) continue;
  //     if (seg.type === "Text") {
  //       const raw = seg.text ?? "";
  //       const parts = String(raw).split(/<br\s*\/?>/i);
  //       parts.forEach((part, idx) => {
  //         out.push({ type: "Text", text: part });
  //         if (idx < parts.length - 1) out.push({ type: BREAK });
  //       });
  //     } else if (seg.type === "Image") {
  //       // Accept either {src: "..."} or {base64: "..."} shapes
  //       const src = seg.src ?? seg.base64 ?? seg.uri;
  //       if (src) out.push({ ...seg, src });
  //     }
  //   }
  //   return out;
  // }

  // function splitIntoParagraphs(tokens) {
  //   const paras = [];
  //   let cur = [];
  //   const push = () => {
  //     if (cur.length) paras.push(cur);
  //     cur = [];
  //   };
  //   for (const t of tokens) {
  //     if (t?.type === BREAK) push();
  //     else cur.push(t);
  //   }
  //   push();
  //   return paras;
  // }

  // function isInlineImage(img, prev, next) {
  //   const surroundedByText =
  //     (prev?.type === "Text" && !isWhitespaceOnly(prev.text)) ||
  //     (next?.type === "Text" && !isWhitespaceOnly(next.text));

  //   const isVertical = img.orientation === "vertical";
  //   const veryWide = (img.aspect_ratio ?? 0) >= 3.5;
  //   const tallPx = (img.height ?? 0) >= 80;

  //   if (isVertical || veryWide || tallPx) return false; // treat as block
  //   return surroundedByText; // inline if it sits between text
  // }

  // function ratioOf(img) {
  //   if (Number.isFinite(img?.aspect_ratio)) return img.aspect_ratio;
  //   if (Number.isFinite(img?.width) && Number.isFinite(img?.height) && img.height > 0) {
  //     return img.width / img.height;
  //   }
  //   return 1;
  // }

  // function InlineImage({ img, fontSize = 16 }) {
  //   const height = Math.round(fontSize * 1.1);
  //   const width = Math.round(height * ratioOf(img));
  //   return (
  //     <Image
  //       source={{ uri: img.src }}
  //       style={{
  //         width,
  //         height,
  //         marginHorizontal: 3,
  //         marginVertical: 2,
  //         resizeMode: "contain",
  //       }}
  //     />
  //   );
  // }

  // function BlockImage({ img }) {
  //   const hasDims = Number.isFinite(img?.width) && Number.isFinite(img?.height);
  //   const isHoriz = img?.orientation === "horizontal";
  //   const widthStyle =
  //     hasDims && img.width < 150 ? img.width : isHoriz ? "100%" : "50%";
  //   const heightStyle =
  //     hasDims && img.height < 150 ? img.height : img?.orientation === "vertical" ? 300 : 250;

  //   return (
  //     <Image
  //       source={{ uri: img.src }}
  //       style={{
  //         width: widthStyle,
  //         height: heightStyle,
  //         resizeMode: "contain",
  //         alignSelf: "center",
  //         marginVertical: 5,
  //       }}
  //     />
  //   );
  // }

  // export function SegmentsRendererRN({
  //   segments,
  //   isDarkMode = false,
  //   baseFontSize = 16,
  // }) {
  //   const tokens = normalizeSegments(segments);
  //   const paras = splitIntoParagraphs(tokens);

  //   const textStyle = {
  //     fontSize: baseFontSize,
  //     lineHeight: Math.round(baseFontSize * 1.5),
  //     color: isDarkMode ? "#FFF" : "#111827",
  //   };

  //   return (
  //     <View>
  //       {paras.map((para, i) => {
  //         if (!para.length) return <View key={i} style={{ height: textStyle.lineHeight / 2 }} />;

  //         const onlyImages = para.every((t) => t.type === "Image");
  //         if (onlyImages) {
  //           return (
  //             <View key={i} style={{ marginBottom: 12 }}>
  //               {para.map((img, j) => (
  //                 <BlockImage key={j} img={img} />
  //               ))}
  //             </View>
  //           );
  //         }

  //         // Mixed content: build runs; flush a row before/after block images
  //         const rows = [];
  //         let inlineRun = [];

  //         const flushRun = (key) => {
  //           if (!inlineRun.length) return;
  //           rows.push(
  //             <View
  //               key={key}
  //               style={{
  //                 flexDirection: "row",
  //                 flexWrap: "wrap",
  //                 alignItems: "baseline",
  //                 marginBottom: 4,
  //               }}
  //             >
  //               {inlineRun.map((node, idx) => {
  //                 if (node.type === "Text") {
  //                   return (
  //                     <Text key={idx} style={textStyle}>
  //                       {node.text}
  //                     </Text>
  //                   );
  //                 }
  //                 return <InlineImage key={idx} img={node} fontSize={textStyle.fontSize} />;
  //               })}
  //             </View>
  //           );
  //           inlineRun = [];
  //         };

  //         para.forEach((t, j) => {
  //           if (t.type === "Text") {
  //             inlineRun.push(t);
  //           } else {
  //             const prev = para[j - 1];
  //             const next = para[j + 1];
  //             const inline = isInlineImage(t, prev, next);
  //             if (inline) {
  //               inlineRun.push(t);
  //             } else {
  //               flushRun(`row-${i}-${j}-pre`);
  //               rows.push(<BlockImage key={`block-${i}-${j}`} img={t} />);
  //             }
  //           }
  //         });
  //         flushRun(`row-${i}-end`);

  //         return (
  //           <View key={i} style={{ marginBottom: 12 }}>
  //             {rows}
  //           </View>
  //         );
  //       })}
  //     </View>
  //   );
  // }

  // BDD 10/7/2025 - this is behaving funny in terms of click capture - my guess is that it is due to this new layout changes for UI/UX
  // I am replacing it, but should investigate really why this happened.
  // const renderQuizSection = ({
  //   quizData,
  //   userAnswers,
  //   answerFeedback,
  //   showHints,
  //   showSolutions,
  //   toggleHint,
  //   toggleSolution,
  //   handleAnswerChange,
  //   handleMCQSelection,
  //   isDarkMode,
  //   styles,
  // }) => {
  //   if (!quizData || !Array.isArray(quizData) || quizData.length === 0) {
  //     return <Text>{t("No questions available for this topic.")}</Text>;
  //   }
  //   // console.log("🧠 quizData in renderQuizSection:", quizData);

  //   const isTestMode = quizMode === "test"; // Or however you're tracking this
  //   // Use quizMode to decide if interactive events should be active.
  //   const isPastTestView = quizMode === "pastTestView";

  //   return quizData.map((question, index) => (
  //    <View key={index} style={styles(isDarkMode).quizCardContainer}>

  //       {/* 🧠 Question Content (segments-aware) */}
  //       {Array.isArray(question?.question?.segments) ? (
  //         <SegmentsRendererRN
  //           segments={question.question.segments}
  //           isDarkMode={isDarkMode}
  //           baseFontSize={16}
  //         />
  //       ) : (
  //         <>
  //           <Text style={styles(isDarkMode).quizQuestion}>
  //             {question.question?.text || t("No question available")}
  //           </Text>

  //           {/* fallback images (legacy shape) */}
  //           {question.question?.images?.length > 0 &&
  //             question.question.images.map((image, imgIndex) => (
  //               <Image
  //                 key={imgIndex}
  //                 source={{ uri: image.base64 }}
  //                 style={{
  //                   width:
  //                     image.width && image.width < 150
  //                       ? image.width
  //                       : image.orientation === "horizontal"
  //                       ? "100%"
  //                       : "50%",
  //                   height:
  //                     image.height && image.height < 150
  //                       ? image.height
  //                       : image.orientation === "vertical"
  //                       ? 300
  //                       : 250,
  //                   resizeMode: "contain",
  //                   marginVertical: 5,
  //                 }}
  //               />
  //             ))}
  //         </>
  //       )}

  //       {/* 🎯 Question Types */}
  //       {parseInt(question.question_type) === 1 ? (
  //         <>
  //           {/* 🔧 Fix: Parse options if it's a string (ONLY for FITB) */}
  //           {typeof question.options === "string" && (() => {
  //             try {
  //               question.options = JSON.parse(question.options);
  //             } catch (e) {
  //               console.warn("⚠️ Could not parse question.options:", e);
  //             }
  //           })()}

  //           {question.options?.word_bank?.length > 0 && (
  //             <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginBottom: 10 }}>
  //               <Text style={{ fontWeight: 'bold', marginRight: 5 }}>🧩 Word Bank:</Text>
  //               {question.options.word_bank.map((word, idx) => (
  //                 <Text
  //                   key={idx}
  //                   style={{
  //                     backgroundColor: "#eee",
  //                     paddingHorizontal: 8,
  //                     paddingVertical: 4,
  //                     borderRadius: 4,
  //                     marginRight: 8,
  //                     marginBottom: 6
  //                   }}
  //                 >
  //                   {word}
  //                 </Text>
  //               ))}
  //             </View>
  //           )}

  //           <TextInput
  //             style={styles(isDarkMode).inputField}
  //             placeholder={t("Type your answer...")}
  //             value={userAnswers?.[question.question_id] || ""}
  //             onChangeText={(text) => handleAnswerChange(question.question_id, text)}
  //             onBlur={() => {
  //               if (!isTestMode) {
  //                 checkTextAnswer(question.question_id, question.options?.correct_answer);
  //               }
  //             }}
  //           />
  //         </>
  //       ) : parseInt(question.question_type) === 2 ? (
  //               // MCQ
  //       <View>
  //           {["option1", "option2", "option3", "option4"].map((optKey, idx) => {
  //           const option = question.options?.[optKey];
  //           if (!option) return null;

  //           const isSelected = userAnswers?.[question.question_id] === optKey;
  //           const isCorrect = answerFeedback?.[question.question_id] === "correct";
  //           const baseStyle = styles(isDarkMode).quizOption;

  //           const selectedStyle = isTestMode
  //               ? { borderColor: "#007BFF", borderWidth: 2 }
  //               : isSelected
  //               ? isCorrect
  //                   ? styles(isDarkMode).correctAnswer
  //                   : styles(isDarkMode).wrongAnswer
  //               : {};

  //           return (
  //                 <TouchableOpacity
  //                   key={idx}
  //                   style={[baseStyle, isSelected && selectedStyle]}
  //                   onPress={() =>
  //                     handleMCQSelection(
  //                       question.question_id,
  //                       optKey,
  //                       idx,
  //                       `${question.options?.correct_answer}`
  //                     )
  //                   }
  //                 >
  //                   {/* Small label to keep your "Option X:" prefix */}
  //                   <Text style={styles(isDarkMode).optionText}>
  //                     {t("Option")} {idx + 1}:
  //                   </Text>

  //                   {/* Segments renderer for the option body */}
  //                   {Array.isArray(option?.segments) ? (
  //                     <SegmentsRendererRN
  //                       segments={option.segments}
  //                       isDarkMode={isDarkMode}
  //                       baseFontSize={16}
  //                     />
  //                   ) : (
  //                     <>
  //                       {!!option?.text && (
  //                         <Text style={styles(isDarkMode).optionText}>{option.text}</Text>
  //                       )}
  //                       {option?.images?.length > 0 &&
  //                         option.images.map((img, imgIdx) => (
  //                           <Image
  //                             key={imgIdx}
  //                             source={{ uri: img.base64 }}
  //                             style={{
  //                               width:
  //                                 img.width && img.width < 150
  //                                   ? img.width
  //                                   : img.orientation === "horizontal"
  //                                   ? "100%"
  //                                   : "50%",
  //                               height:
  //                                 img.height && img.height < 150
  //                                   ? img.height
  //                                   : img.orientation === "vertical"
  //                                   ? 300
  //                                   : 250,
  //                               resizeMode: "contain",
  //                               marginVertical: 5,
  //                             }}
  //                           />
  //                         ))}
  //                     </>
  //                   )}
  //                 </TouchableOpacity>

  //           );
  //           })}
  //       </View>
  //       ) : parseInt(question.question_type) === 4 ? (
  //       // True/False
  //       <View>
  //           {["True", "False"].map((option, idx) => {
  //           const isSelected = userAnswers?.[question.question_id] === option;
  //           const isCorrect = answerFeedback?.[question.question_id] === "correct";
  //           const baseStyle = styles(isDarkMode).quizOption;

  //           const selectedStyle = isTestMode
  //               ? { borderColor: "#007BFF", borderWidth: 2 }
  //               : isSelected
  //               ? option === question.options?.correct_answer
  //                   ? styles(isDarkMode).correctAnswer
  //                   : styles(isDarkMode).wrongAnswer
  //               : {};

  //           return (
  //               <TouchableOpacity
  //               key={idx}
  //               style={[baseStyle, isSelected && selectedStyle]}
  //               onPress={() =>
  //                   handleMCQSelection(
  //                   question.question_id,
  //                   option,
  //                   question.options?.correct_answer
  //                   )
  //               }
  //               >
  //               <Text>{t("option")}</Text>
  //               </TouchableOpacity>
  //           );
  //           })}
  //       </View>
  //       ) : parseInt(question.question_type) === 9 ? (
  //         // Word Association
  //         <View>
  //           {question.options?.pairs?.map((pair, idx) => {
  //             const selectedRight = userAnswers?.[question.question_id]?.[idx] ?? "";
  //             const allRightOptions = question.options.pairs.map(p => p.right?.text);

  //             return (
  //               <View key={idx} style={{ marginVertical: 10 }}>
  //                 <Text style={styles(isDarkMode).quizQuestion}>
  //                   {t("Match")}: {pair.left?.text}
  //                 </Text>

  //                 <Picker
  //                   selectedValue={selectedRight}
  //                   onValueChange={(value) => {
  //                   const existingAnswers = userAnswers?.[question.question_id] || [];
  //                   const updatedAnswers = [...existingAnswers];
  //                   updatedAnswers[idx] = value;
  //                     handleAnswerChange(question.question_id, updatedAnswers);
  //                   }}
  //                   style={{
  //                     backgroundColor: isDarkMode ? "#333" : "#eee",
  //                     color: isDarkMode ? "#fff" : "#000",
  //                   }}
  //                 >
  //                   <Picker.Item label={t("Select an option")} value="" />
  //                   {allRightOptions.map((opt, optIdx) => (
  //                     <Picker.Item key={optIdx} label={opt} value={opt} />
  //                   ))}
  //                 </Picker>
  //               </View>
  //             );
  //           })}
  //         </View>

  //         ) : parseInt(question.question_type) === 10 ? (
  //                 // 📝 Short Essay (3–5 sentences)
  //                 <View>
  //                   <TextInput
  //                     multiline
  //                     numberOfLines={5}
  //                     placeholder={t("Write a short response (3–5 sentences)...")}
  //                     value={userAnswers?.[question.question_id] || ""}
  //                     onChangeText={(text) => handleAnswerChange(question.question_id, text)}
  //                     style={[
  //                       styles(isDarkMode).inputField,
  //                       { textAlignVertical: "top", minHeight: 100 }
  //                     ]}
  //                   />
  //                 </View>
  //               ) : parseInt(question.question_type) === 11 ? (
  //                 // 🧾 Long Essay (150–200 words)
  //                 <View>
  //                   <TextInput
  //                     multiline
  //                     numberOfLines={10}
  //                     placeholder={t("Write a detailed response (150–200 words)...")}
  //                     value={userAnswers?.[question.question_id] || ""}
  //                     onChangeText={(text) => handleAnswerChange(question.question_id, text)}
  //                     style={[
  //                       styles(isDarkMode).inputField,
  //                       { textAlignVertical: "top", minHeight: 180 }
  //                     ]}
  //                   />
  //                 </View>
  //      ) : null}


  //       {/* 💡 Hints */}
  //       {(question.hints?.hint1?.text || question.hints?.hint2?.text || question.hints?.hint1?.images?.length || question.hints?.hint2?.images?.length) && (
  //         <TouchableOpacity onPress={() => toggleHint(question.question_id)} style={styles(isDarkMode).hintButton}>
  //           <Text style={styles(isDarkMode).hintText}>
  //             <MaterialCommunityIcons name="lightbulb-outline" size={18} color="#FFF" /> {t("Show Hint")}
  //           </Text>
  //         </TouchableOpacity>
  //       )}

  //       {showHints?.[question.question_id] && (
  //         <View style={{ marginTop: 8 }}>
  //           {Array.isArray(question?.hints?.hint1?.segments) ? (
  //             <SegmentsRendererRN
  //               segments={question.hints.hint1.segments}
  //               isDarkMode={isDarkMode}
  //             />
  //           ) : (
  //             <>
  //               {!!question?.hints?.hint1?.text && (
  //                 <Text style={styles(isDarkMode).hintText}>{question.hints.hint1.text}</Text>
  //               )}
  //               {question?.hints?.hint1?.images?.map((image, imgIndex) => (
  //                 <Image
  //                   key={`h1-${imgIndex}`}
  //                   source={{ uri: image.base64 }}
  //                   style={{
  //                     width:
  //                       image.width && image.width < 150
  //                         ? image.width
  //                         : image.orientation === "horizontal"
  //                         ? "100%"
  //                         : "50%",
  //                     height:
  //                       image.height && image.height < 150
  //                         ? image.height
  //                         : image.orientation === "vertical"
  //                         ? 300
  //                         : 250,
  //                     resizeMode: "contain",
  //                     marginVertical: 5,
  //                   }}
  //                 />
  //               ))}
  //             </>
  //           )}

  //           {Array.isArray(question?.hints?.hint2?.segments) ? (
  //             <SegmentsRendererRN
  //               segments={question.hints.hint2.segments}
  //               isDarkMode={isDarkMode}
  //             />
  //           ) : (
  //             <>
  //               {!!question?.hints?.hint2?.text && (
  //                 <Text style={styles(isDarkMode).hintText}>{question.hints.hint2.text}</Text>
  //               )}
  //               {question?.hints?.hint2?.images?.map((image, imgIndex) => (
  //                 <Image
  //                   key={`h2-${imgIndex}`}
  //                   source={{ uri: image.base64 }}
  //                   style={{
  //                     width:
  //                       image.width && image.width < 150
  //                         ? image.width
  //                         : image.orientation === "horizontal"
  //                         ? "100%"
  //                         : "50%",
  //                     height:
  //                       image.height && image.height < 150
  //                         ? image.height
  //                         : image.orientation === "vertical"
  //                         ? 300
  //                         : 250,
  //                     resizeMode: "contain",
  //                     marginVertical: 5,
  //                   }}
  //                 />
  //               ))}
  //             </>
  //           )}
  //         </View>
  //       )}

  //       {/* ✅ Solution Button */}
  //       {!isTestMode && (
  //       <TouchableOpacity onPress={() => toggleSolution(question.question_id)} style={styles(isDarkMode).solutionButton}>
  //         <Text style={styles(isDarkMode).solutionButtonText}>
  //           <MaterialCommunityIcons name="lightbulb-on-outline" size={18} color="#FFF" /> {t("Show Solution")}
  //         </Text>
  //       </TouchableOpacity>
  //       )}

  //       {/* ✅ Solution Content */}

  //       {!isTestMode && showSolutions?.[question.question_id] && (
  //         <View style={{ marginTop: 8 }}>
  //           {Array.isArray(question?.solution?.segments) ? (
  //             <SegmentsRendererRN
  //               segments={question.solution.segments}
  //               isDarkMode={isDarkMode}
  //               baseFontSize={16}
  //             />
  //           ) : (
  //             <>
  //               <Text style={styles(isDarkMode).solutionText}>
  //                 {question.solution?.text || t("No solution available")}
  //               </Text>
  //               {question.solution?.images?.length > 0 &&
  //                 question.solution.images.map((image, imgIndex) => (
  //                   <Image
  //                     key={imgIndex}
  //                     source={{ uri: image.base64 }}
  //                     style={{
  //                       width:
  //                         image.width && image.width < 150
  //                           ? image.width
  //                           : image.orientation === "horizontal"
  //                           ? "100%"
  //                           : "50%",
  //                       height:
  //                         image.height && image.height < 150
  //                           ? image.height
  //                           : image.orientation === "vertical"
  //                           ? 300
  //                           : 250,
  //                       resizeMode: "contain",
  //                       marginTop: 5,
  //                     }}
  //                   />
  //                 ))}
  //             </>
  //           )}
  //         </View>
  //       )}

  //     </View>
  //   ));
  // };
  // BDD 10/7/2025 - new renderQuizSection as previous was not recognizing clicks consistently
  // why did I have to do it should be understood - I do not like changes like these
  //   const renderQuizSection = ({
  //   quizData,
  //   userAnswers,
  //   answerFeedback,
  //   showHints,
  //   showSolutions,
  //   toggleHint,
  //   toggleSolution,
  //   handleAnswerChange,
  //   handleMCQSelection,
  //   isDarkMode,
  //   styles,
  // }) => {
  //   if (!quizData || !Array.isArray(quizData) || quizData.length === 0) {
  //     return <Text>{t("No questions available for this topic.")}</Text>;
  //   }

  //   const isTestMode = quizMode === "test";
  //   const isPastTestView = quizMode === "pastTestView";

  //   // ── helper to find the nearest element that carries our data-* marker
  //   const __findOptionEl = (e) => {
  //     const nat = e && e.nativeEvent;
  //     const path = (nat && typeof nat.composedPath === "function" && nat.composedPath()) || [];
  //     for (const el of path) {
  //       if (el && el.dataset && (el.dataset.optkey || el.dataset.opttf)) return el;
  //     }
  //     let el = e.target;
  //     while (el && el !== e.currentTarget) {
  //       if (el.dataset && (el.dataset.optkey || el.dataset.opttf)) return el;
  //       el = el.parentElement;
  //     }
  //     return null;
  //   };

  //   return quizData.map((question, index) => (
  //     <View
  //       key={index}
  //       // 🔒 rock-solid selection: handle pointer-up in capture on the card container
  //       onPointerUpCapture={(e) => {
  //         const el = __findOptionEl(e);
  //         if (!el) return; // not an option click
  //         const ds = el.dataset || {};
  //         // Ensure the event belongs to this question card (avoid cross-card bubbling)
  //         if (String(ds.qid || "") !== String(question.question_id || "")) return;

  //         // prevent text selection/ghost drags from interfering
  //         if (e && typeof e.preventDefault === "function") e.preventDefault();

  //         // MCQ path: your original signature is
  //         // handleMCQSelection(question_id, optKey, idx, correct_answerString)
  //         if (ds.optkey) {
  //           const idx = Number(ds.optindex || 0);
  //           handleMCQSelection(
  //             question.question_id,
  //             ds.optkey,
  //             isNaN(idx) ? 0 : idx,
  //             String(ds.correct || "")
  //           );
  //           return;
  //         }

  //         // True/False path: your original signature is
  //         // handleMCQSelection(question_id, option, correct_answer)
  //         if (ds.opttf) {
  //           handleMCQSelection(
  //             question.question_id,
  //             ds.opttf,
  //             String(ds.correcttf || ds.correct || "")
  //           );
  //           return;
  //         }
  //       }}
  //       style={[
  //         styles(isDarkMode).quizCardContainer,
  //         // prevent selection/gesture delays that can kill click synthesis
  //         { userSelect: "none", touchAction: "manipulation" },
  //       ]}
  //     >
  //       {/* 🧠 Question Content (segments-aware) */}
  //       {Array.isArray(question?.question?.segments) ? (
  //         <SegmentsRendererRN
  //           segments={question.question.segments}
  //           isDarkMode={isDarkMode}
  //           baseFontSize={16}
  //         />
  //       ) : (
  //         <>
  //           <Text style={styles(isDarkMode).quizQuestion}>
  //             {question.question?.text || t("No question available")}
  //           </Text>

  //           {/* fallback images (legacy shape) */}
  //           {question.question?.images?.length > 0 &&
  //             question.question.images.map((image, imgIndex) => (
  //               <Image
  //                 key={imgIndex}
  //                 source={{ uri: image.base64 }}
  //                 style={{
  //                   width:
  //                     image.width && image.width < 150
  //                       ? image.width
  //                       : image.orientation === "horizontal"
  //                       ? "100%"
  //                       : "50%",
  //                   height:
  //                     image.height && image.height < 150
  //                       ? image.height
  //                       : image.orientation === "vertical"
  //                       ? 300
  //                       : 250,
  //                   resizeMode: "contain",
  //                   marginVertical: 5,
  //                 }}
  //               />
  //             ))}
  //         </>
  //       )}

  //       {/* 🎯 Question Types */}
  //       {parseInt(question.question_type) === 1 ? (
  //         <>
  //           {/* 🔧 Parse options if string (FITB only) */}
  //           {typeof question.options === "string" &&
  //             (() => {
  //               try {
  //                 question.options = JSON.parse(question.options);
  //               } catch (e) {
  //                 console.warn("⚠️ Could not parse question.options:", e);
  //               }
  //             })()}

  //           {question.options?.word_bank?.length > 0 && (
  //             <View style={{ flexDirection: "row", flexWrap: "wrap", marginBottom: 10 }}>
  //               <Text style={{ fontWeight: "bold", marginRight: 5 }}>🧩 Word Bank:</Text>
  //               {question.options.word_bank.map((word, idx) => (
  //                 <Text
  //                   key={idx}
  //                   style={{
  //                     backgroundColor: "#eee",
  //                     paddingHorizontal: 8,
  //                     paddingVertical: 4,
  //                     borderRadius: 4,
  //                     marginRight: 8,
  //                     marginBottom: 6,
  //                   }}
  //                 >
  //                   {word}
  //                 </Text>
  //               ))}
  //             </View>
  //           )}

  //           <TextInput
  //             style={styles(isDarkMode).inputField}
  //             placeholder={t("Type your answer...")}
  //             value={userAnswers?.[question.question_id] || ""}
  //             onChangeText={(text) => handleAnswerChange(question.question_id, text)}
  //             onBlur={() => {
  //               if (!isTestMode) {
  //                 checkTextAnswer(question.question_id, question.options?.correct_answer);
  //               }
  //             }}
  //           />
  //         </>
  //       ) : parseInt(question.question_type) === 2 ? (
  //         // MCQ

  //         // MCQ try 2
  //         <View>
  //           {["option1", "option2", "option3", "option4"].map((optKey, idx) => {
  //             const option = question.options?.[optKey];
  //             if (!option) return null;

  //             const isSelected = userAnswers?.[question.question_id] === optKey;
  //             const isCorrect = answerFeedback?.[question.question_id] === "correct";
  //             const baseStyle = styles(isDarkMode).quizOption;

  //             const selectedStyle = isTestMode
  //               ? { borderColor: "#007BFF", borderWidth: 2 }
  //               : isSelected
  //               ? (isCorrect ? styles(isDarkMode).correctAnswer : styles(isDarkMode).wrongAnswer)
  //               : {};

  //             // 🔒 de-dupe bursty multi-events on web
  //             const firedRef = React.useRef(false);
  //             const fire = React.useCallback((from) => {
  //               if (firedRef.current) return;
  //               firedRef.current = true;
  //               setTimeout(() => { firedRef.current = false; }, 200);

  //               // Your original selection call
  //               handleMCQSelection(
  //                 question.question_id,
  //                 optKey,
  //                 idx,
  //                 String(question.options?.correct_answer ?? "")
  //               );
  //             }, [question.question_id, optKey, idx, question.options]);

  //             return (
  //               <TouchableOpacity
  //                 key={idx}
  //                 activeOpacity={0.85}
  //                 onPress={() => fire("onPress")}
  //                 {...(Platform.OS === "web"
  //                   ? {
  //                       onClick: (e) => { e.preventDefault?.(); fire("onClick"); },
  //                       onMouseUp: () => fire("onMouseUp"),
  //                       onTouchEnd: () => fire("onTouchEnd"),
  //                       onKeyDown: (e) => {
  //                         if (e.key === "Enter" || e.key === " ") { e.preventDefault?.(); fire("onKeyDown"); }
  //                       },
  //                     }
  //                   : {})}
  //                 style={[
  //                   baseStyle,
  //                   isSelected && selectedStyle,
  //                   // web niceties that reduce missed clicks
  //                   Platform.OS === "web" ? { userSelect: "none", cursor: "pointer", touchAction: "manipulation" } : null,
  //                 ]}
  //               >
  //                 <Text style={styles(isDarkMode).optionText}>
  //                   {t("Option")} {idx + 1}:
  //                 </Text>

  //                 {Array.isArray(option?.segments) ? (
  //                   <SegmentsRendererRN
  //                     segments={option.segments}
  //                     isDarkMode={isDarkMode}
  //                     baseFontSize={16}
  //                   />
  //                 ) : (
  //                   <>
  //                     {!!option?.text && (
  //                       <Text style={styles(isDarkMode).optionText}>{option.text}</Text>
  //                     )}
  //                     {option?.images?.length > 0 &&
  //                       option.images.map((img, imgIdx) => (
  //                         <Image
  //                           key={imgIdx}
  //                           source={{ uri: img.base64 }}
  //                           style={{
  //                             width:
  //                               img.width && img.width < 150
  //                                 ? img.width
  //                                 : img.orientation === "horizontal"
  //                                 ? "100%"
  //                                 : "50%",
  //                             height:
  //                               img.height && img.height < 150
  //                                 ? img.height
  //                                 : img.orientation === "vertical"
  //                                 ? 300
  //                                 : 250,
  //                             resizeMode: "contain",
  //                             marginVertical: 5,
  //                           }}
  //                         />
  //                       ))}
  //                   </>
  //                 )}
  //               </TouchableOpacity>
  //             );
  //           })}
  //         </View>


  //       ) : parseInt(question.question_type) === 4 ? (
  //         // True/False
  //         // True/False - try2
  //         <View>
  //           {["True", "False"].map((option, idx) => {
  //             const isSelected = userAnswers?.[question.question_id] === option;
  //             const isCorrect = answerFeedback?.[question.question_id] === "correct";
  //             const baseStyle = styles(isDarkMode).quizOption;

  //             const selectedStyle = isTestMode
  //               ? { borderColor: "#007BFF", borderWidth: 2 }
  //               : isSelected
  //               ? (option === question.options?.correct_answer
  //                   ? styles(isDarkMode).correctAnswer
  //                   : styles(isDarkMode).wrongAnswer)
  //               : {};

  //             const firedRef = React.useRef(false);
  //             const fire = React.useCallback((from) => {
  //               if (firedRef.current) return;
  //               firedRef.current = true;
  //               setTimeout(() => { firedRef.current = false; }, 200);

  //               // Your original TF signature: (qid, option, correctAnswer)
  //               handleMCQSelection(
  //                 question.question_id,
  //                 option,
  //                 String(question.options?.correct_answer ?? "")
  //               );
  //             }, [question.question_id, option, question.options]);

  //             return (
  //               <TouchableOpacity
  //                 key={idx}
  //                 activeOpacity={0.85}
  //                 onPress={() => fire("onPress")}
  //                 {...(Platform.OS === "web"
  //                   ? {
  //                       onClick: (e) => { e.preventDefault?.(); fire("onClick"); },
  //                       onMouseUp: () => fire("onMouseUp"),
  //                       onTouchEnd: () => fire("onTouchEnd"),
  //                       onKeyDown: (e) => {
  //                         if (e.key === "Enter" || e.key === " ") { e.preventDefault?.(); fire("onKeyDown"); }
  //                       },
  //                     }
  //                   : {})}
  //                 style={[
  //                   baseStyle,
  //                   isSelected && selectedStyle,
  //                   Platform.OS === "web" ? { userSelect: "none", cursor: "pointer", touchAction: "manipulation" } : null,
  //                 ]}
  //               >
  //                 <Text>{t("option")}</Text>
  //               </TouchableOpacity>
  //             );
  //           })}
  //         </View>

  //       ) : parseInt(question.question_type) === 9 ? (
  //         // Word Association
  //         <View>
  //           {question.options?.pairs?.map((pair, idx) => {
  //             const selectedRight = userAnswers?.[question.question_id]?.[idx] ?? "";
  //             const allRightOptions = question.options.pairs.map((p) => p.right?.text);

  //             return (
  //               <View key={idx} style={{ marginVertical: 10 }}>
  //                 <Text style={styles(isDarkMode).quizQuestion}>
  //                   {t("Match")}: {pair.left?.text}
  //                 </Text>

  //                 <Picker
  //                   selectedValue={selectedRight}
  //                   onValueChange={(value) => {
  //                     const existingAnswers = userAnswers?.[question.question_id] || [];
  //                     const updatedAnswers = [...existingAnswers];
  //                     updatedAnswers[idx] = value;
  //                     handleAnswerChange(question.question_id, updatedAnswers);
  //                   }}
  //                   style={{
  //                     backgroundColor: isDarkMode ? "#333" : "#eee",
  //                     color: isDarkMode ? "#fff" : "#000",
  //                   }}
  //                 >
  //                   <Picker.Item label={t("Select an option")} value="" />
  //                   {allRightOptions.map((opt, optIdx) => (
  //                     <Picker.Item key={optIdx} label={opt} value={opt} />
  //                   ))}
  //                 </Picker>
  //               </View>
  //             );
  //           })}
  //         </View>
  //       ) : parseInt(question.question_type) === 10 ? (
  //         // 📝 Short Essay (3–5 sentences)
  //         <View>
  //           <TextInput
  //             multiline
  //             numberOfLines={5}
  //             placeholder={t("Write a short response (3–5 sentences)...")}
  //             value={userAnswers?.[question.question_id] || ""}
  //             onChangeText={(text) => handleAnswerChange(question.question_id, text)}
  //             style={[
  //               styles(isDarkMode).inputField,
  //               { textAlignVertical: "top", minHeight: 100 },
  //             ]}
  //           />
  //         </View>
  //       ) : parseInt(question.question_type) === 11 ? (
  //         // 🧾 Long Essay (150–200 words)
  //         <View>
  //           <TextInput
  //             multiline
  //             numberOfLines={10}
  //             placeholder={t("Write a detailed response (150–200 words)...")}
  //             value={userAnswers?.[question.question_id] || ""}
  //             onChangeText={(text) => handleAnswerChange(question.question_id, text)}
  //             style={[
  //               styles(isDarkMode).inputField,
  //               { textAlignVertical: "top", minHeight: 180 },
  //             ]}
  //           />
  //         </View>
  //       ) : null}

  //       {/* 💡 Hints */}
  //       {(question.hints?.hint1?.text ||
  //         question.hints?.hint2?.text ||
  //         question.hints?.hint1?.images?.length ||
  //         question.hints?.hint2?.images?.length) && (
  //         <TouchableOpacity
  //           onPress={() => toggleHint(question.question_id)}
  //           style={styles(isDarkMode).hintButton}
  //         >
  //           <Text style={styles(isDarkMode).hintText}>
  //             <MaterialCommunityIcons name="lightbulb-outline" size={18} color="#FFF" />{" "}
  //             {t("Show Hint")}
  //           </Text>
  //         </TouchableOpacity>
  //       )}

  //       {showHints?.[question.question_id] && (
  //         <View style={{ marginTop: 8 }}>
  //           {Array.isArray(question?.hints?.hint1?.segments) ? (
  //             <SegmentsRendererRN segments={question.hints.hint1.segments} isDarkMode={isDarkMode} />
  //           ) : (
  //             <>
  //               {!!question?.hints?.hint1?.text && (
  //                 <Text style={styles(isDarkMode).hintText}>{question.hints.hint1.text}</Text>
  //               )}
  //               {question?.hints?.hint1?.images?.map((image, imgIndex) => (
  //                 <Image
  //                   key={`h1-${imgIndex}`}
  //                   source={{ uri: image.base64 }}
  //                   style={{
  //                     width:
  //                       image.width && image.width < 150
  //                         ? image.width
  //                         : image.orientation === "horizontal"
  //                         ? "100%"
  //                         : "50%",
  //                     height:
  //                       image.height && image.height < 150
  //                         ? image.height
  //                         : image.orientation === "vertical"
  //                         ? 300
  //                         : 250,
  //                     resizeMode: "contain",
  //                     marginVertical: 5,
  //                   }}
  //                 />
  //               ))}
  //             </>
  //           )}

  //           {Array.isArray(question?.hints?.hint2?.segments) ? (
  //             <SegmentsRendererRN segments={question.hints.hint2.segments} isDarkMode={isDarkMode} />
  //           ) : (
  //             <>
  //               {!!question?.hints?.hint2?.text && (
  //                 <Text style={styles(isDarkMode).hintText}>{question.hints.hint2.text}</Text>
  //               )}
  //               {question?.hints?.hint2?.images?.map((image, imgIndex) => (
  //                 <Image
  //                   key={`h2-${imgIndex}`}
  //                   source={{ uri: image.base64 }}
  //                   style={{
  //                     width:
  //                       image.width && image.width < 150
  //                         ? image.width
  //                         : image.orientation === "horizontal"
  //                         ? "100%"
  //                         : "50%",
  //                     height:
  //                       image.height && image.height < 150
  //                         ? image.height
  //                         : image.orientation === "vertical"
  //                         ? 300
  //                         : 250,
  //                     resizeMode: "contain",
  //                     marginVertical: 5,
  //                   }}
  //                 />
  //               ))}
  //             </>
  //           )}
  //         </View>
  //       )}

  //       {/* ✅ Solution Button */}
  //       {!isTestMode && (
  //         <TouchableOpacity
  //           onPress={() => toggleSolution(question.question_id)}
  //           style={styles(isDarkMode).solutionButton}
  //         >
  //           <Text style={styles(isDarkMode).solutionButtonText}>
  //             <MaterialCommunityIcons name="lightbulb-on-outline" size={18} color="#FFF" />{" "}
  //             {t("Show Solution")}
  //           </Text>
  //         </TouchableOpacity>
  //       )}

  //       {/* ✅ Solution Content */}
  //       {!isTestMode && showSolutions?.[question.question_id] && (
  //         <View style={{ marginTop: 8 }}>
  //           {Array.isArray(question?.solution?.segments) ? (
  //             <SegmentsRendererRN
  //               segments={question.solution.segments}
  //               isDarkMode={isDarkMode}
  //               baseFontSize={16}
  //             />
  //           ) : (
  //             <>
  //               <Text style={styles(isDarkMode).solutionText}>
  //                 {question.solution?.text || t("No solution available")}
  //               </Text>
  //               {question.solution?.images?.length > 0 &&
  //                 question.solution.images.map((image, imgIndex) => (
  //                   <Image
  //                     key={imgIndex}
  //                     source={{ uri: image.base64 }}
  //                     style={{
  //                       width:
  //                         image.width && image.width < 150
  //                           ? image.width
  //                           : image.orientation === "horizontal"
  //                           ? "100%"
  //                           : "50%",
  //                       height:
  //                         image.height && image.height < 150
  //                           ? image.height
  //                           : image.orientation === "vertical"
  //                           ? 300
  //                           : 250,
  //                       resizeMode: "contain",
  //                       marginTop: 5,
  //                     }}
  //                   />
  //                 ))}
  //             </>
  //           )}
  //         </View>
  //       )}
  //     </View>
  //   ));
  // };

  // BDD 10/7/2025 - try#3 - new renderQuizSection as previous was not recognizing clicks consistently
  // why did I have to do it should be understood - I do not like changes like these
  // const renderQuizSection = ({
  //   quizData,
  //   userAnswers,
  //   answerFeedback,
  //   showHints,
  //   showSolutions,
  //   toggleHint,
  //   toggleSolution,
  //   handleAnswerChange,
  //   handleMCQSelection,
  //   isDarkMode,
  //   styles,
  // }) => {
  //   if (!quizData || !Array.isArray(quizData) || quizData.length === 0) {
  //     return <Text>{t("No questions available for this topic.")}</Text>;
  //   }

  //   const isTestMode = quizMode === "test";
  //   const isPastTestView = quizMode === "pastTestView";

  //   // ---------- tiny child components so hooks don't live in loops ----------

  //   const MCQOption = React.memo(function MCQOption({
  //     question,
  //     optKey,
  //     idx,
  //     option,
  //     isSelected,
  //     isCorrect,
  //   }) {
  //     const firedRef = React.useRef(false);
  //     const fire = React.useCallback(
  //       (from) => {
  //         if (firedRef.current) return;
  //         firedRef.current = true;
  //         setTimeout(() => {
  //           firedRef.current = false;
  //         }, 200);

  //         // original signature: (qid, optKey, idx, correctAnsString)
  //         handleMCQSelection(
  //           question.question_id,
  //           optKey,
  //           idx,
  //           String(question?.options?.correct_answer ?? "")
  //         );
  //       },
  //       [question, optKey, idx]
  //     );

  //     const baseStyle = styles(isDarkMode).quizOption;
  //     const selectedStyle = isTestMode
  //       ? { borderColor: "#007BFF", borderWidth: 2 }
  //       : isSelected
  //       ? isCorrect
  //         ? styles(isDarkMode).correctAnswer
  //         : styles(isDarkMode).wrongAnswer
  //       : {};

  //     return (
  //       <TouchableOpacity
  //         activeOpacity={0.85}
  //         onPress={() => fire("onPress")}
  //         {...(Platform.OS === "web"
  //           ? {
  //               onClick: (e) => {
  //                 e.preventDefault?.();
  //                 fire("onClick");
  //               },
  //               onMouseUp: () => fire("onMouseUp"),
  //               onTouchEnd: () => fire("onTouchEnd"),
  //               onKeyDown: (e) => {
  //                 if (e.key === "Enter" || e.key === " ") {
  //                   e.preventDefault?.();
  //                   fire("onKeyDown");
  //                 }
  //               },
  //             }
  //           : {})}
  //         style={[
  //           baseStyle,
  //           isSelected && selectedStyle,
  //           Platform.OS === "web"
  //             ? {
  //                 userSelect: "none",
  //                 cursor: "pointer",
  //                 touchAction: "manipulation",
  //               }
  //             : null,
  //         ]}
  //       >
  //         <Text style={styles(isDarkMode).optionText}>
  //           {t("Option")} {idx + 1}:
  //         </Text>

  //         {Array.isArray(option?.segments) ? (
  //           <SegmentsRendererRN
  //             segments={option.segments}
  //             isDarkMode={isDarkMode}
  //             baseFontSize={16}
  //           />
  //         ) : (
  //           <>
  //             {!!option?.text && (
  //               <Text style={styles(isDarkMode).optionText}>{option.text}</Text>
  //             )}
  //             {option?.images?.length > 0 &&
  //               option.images.map((img, imgIdx) => (
  //                 <Image
  //                   key={imgIdx}
  //                   source={{ uri: img.base64 }}
  //                   style={{
  //                     width:
  //                       img.width && img.width < 150
  //                         ? img.width
  //                         : img.orientation === "horizontal"
  //                         ? "100%"
  //                         : "50%",
  //                     height:
  //                       img.height && img.height < 150
  //                         ? img.height
  //                         : img.orientation === "vertical"
  //                         ? 300
  //                         : 250,
  //                     resizeMode: "contain",
  //                     marginVertical: 5,
  //                   }}
  //                 />
  //               ))}
  //           </>
  //         )}
  //       </TouchableOpacity>
  //     );
  //   });

  //   const TFOption = React.memo(function TFOption({
  //     question,
  //     optionLabel, // "True" | "False"
  //     isSelected,
  //     isCorrect,
  //   }) {
  //     const firedRef = React.useRef(false);
  //     const fire = React.useCallback(
  //       (from) => {
  //         if (firedRef.current) return;
  //         firedRef.current = true;
  //         setTimeout(() => {
  //           firedRef.current = false;
  //         }, 200);

  //         // original TF signature: (qid, option, correct_answer)
  //         handleMCQSelection(
  //           question.question_id,
  //           optionLabel,
  //           String(question?.options?.correct_answer ?? "")
  //         );
  //       },
  //       [question, optionLabel]
  //     );

  //     const baseStyle = styles(isDarkMode).quizOption;
  //     const selectedStyle = isTestMode
  //       ? { borderColor: "#007BFF", borderWidth: 2 }
  //       : isSelected
  //       ? optionLabel === question.options?.correct_answer
  //         ? styles(isDarkMode).correctAnswer
  //         : styles(isDarkMode).wrongAnswer
  //       : {};

  //     return (
  //       <TouchableOpacity
  //         activeOpacity={0.85}
  //         onPress={() => fire("onPress")}
  //         {...(Platform.OS === "web"
  //           ? {
  //               onClick: (e) => {
  //                 e.preventDefault?.();
  //                 fire("onClick");
  //               },
  //               onMouseUp: () => fire("onMouseUp"),
  //               onTouchEnd: () => fire("onTouchEnd"),
  //               onKeyDown: (e) => {
  //                 if (e.key === "Enter" || e.key === " ") {
  //                   e.preventDefault?.();
  //                   fire("onKeyDown");
  //                 }
  //               },
  //             }
  //           : {})}
  //         style={[
  //           baseStyle,
  //           isSelected && selectedStyle,
  //           Platform.OS === "web"
  //             ? {
  //                 userSelect: "none",
  //                 cursor: "pointer",
  //                 touchAction: "manipulation",
  //               }
  //             : null,
  //         ]}
  //       >
  //         <Text>{t("option")}</Text>
  //       </TouchableOpacity>
  //     );
  //   });

  //   // ---------- main render ----------

  //   return quizData.map((question, index) => (
  //     <View key={index} style={styles(isDarkMode).quizCardContainer}>
  //       {/* 🧠 Question Content (segments-aware) */}
  //       {Array.isArray(question?.question?.segments) ? (
  //         <SegmentsRendererRN
  //           segments={question.question.segments}
  //           isDarkMode={isDarkMode}
  //           baseFontSize={16}
  //         />
  //       ) : (
  //         <>
  //           <Text style={styles(isDarkMode).quizQuestion}>
  //             {question.question?.text || t("No question available")}
  //           </Text>

  //           {/* fallback images (legacy shape) */}
  //           {question.question?.images?.length > 0 &&
  //             question.question.images.map((image, imgIndex) => (
  //               <Image
  //                 key={imgIndex}
  //                 source={{ uri: image.base64 }}
  //                 style={{
  //                   width:
  //                     image.width && image.width < 150
  //                       ? image.width
  //                       : image.orientation === "horizontal"
  //                       ? "100%"
  //                       : "50%",
  //                   height:
  //                     image.height && image.height < 150
  //                       ? image.height
  //                       : image.orientation === "vertical"
  //                       ? 300
  //                       : 250,
  //                   resizeMode: "contain",
  //                   marginVertical: 5,
  //                 }}
  //               />
  //             ))}
  //         </>
  //       )}

  //       {/* 🎯 Question Types */}
  //       {parseInt(question.question_type) === 1 ? (
  //         <>
  //           {/* 🔧 FITB parse if string */}
  //           {typeof question.options === "string" &&
  //             (() => {
  //               try {
  //                 question.options = JSON.parse(question.options);
  //               } catch (e) {
  //                 console.warn("⚠️ Could not parse question.options:", e);
  //               }
  //             })()}

  //           {question.options?.word_bank?.length > 0 && (
  //             <View style={{ flexDirection: "row", flexWrap: "wrap", marginBottom: 10 }}>
  //               <Text style={{ fontWeight: "bold", marginRight: 5 }}>🧩 Word Bank:</Text>
  //               {question.options.word_bank.map((word, idx) => (
  //                 <Text
  //                   key={idx}
  //                   style={{
  //                     backgroundColor: "#eee",
  //                     paddingHorizontal: 8,
  //                     paddingVertical: 4,
  //                     borderRadius: 4,
  //                     marginRight: 8,
  //                     marginBottom: 6,
  //                   }}
  //                 >
  //                   {word}
  //                 </Text>
  //               ))}
  //             </View>
  //           )}

  //           <TextInput
  //             style={styles(isDarkMode).inputField}
  //             placeholder={t("Type your answer...")}
  //             value={userAnswers?.[question.question_id] || ""}
  //             onChangeText={(text) => handleAnswerChange(question.question_id, text)}
  //             onBlur={() => {
  //               if (!isTestMode) {
  //                 checkTextAnswer(
  //                   question.question_id,
  //                   question.options?.correct_answer
  //                 );
  //               }
  //             }}
  //           />
  //         </>
  //       ) : parseInt(question.question_type) === 2 ? (
  //         // MCQ -------------- (replaced)
  //         <View>
  //           {["option1", "option2", "option3", "option4"].map((optKey, idx) => {
  //             const option = question.options?.[optKey];
  //             if (!option) return null;

  //             const isSelected = userAnswers?.[question.question_id] === optKey;
  //             const isCorrect = answerFeedback?.[question.question_id] === "correct";

  //             return (
  //               <MCQOption
  //                 key={`${question.question_id}:${optKey}`}
  //                 question={question}
  //                 optKey={optKey}
  //                 idx={idx}
  //                 option={option}
  //                 isSelected={!!isSelected}
  //                 isCorrect={!!isCorrect}
  //               />
  //             );
  //           })}
  //         </View>
  //       ) : parseInt(question.question_type) === 4 ? (
  //         // True/False -------- (replaced)
  //         <View>
  //           {["True", "False"].map((optionLabel, idx) => {
  //             const isSelected = userAnswers?.[question.question_id] === optionLabel;
  //             const isCorrect = answerFeedback?.[question.question_id] === "correct";
  //             return (
  //               <TFOption
  //                 key={`${question.question_id}:tf:${idx}`}
  //                 question={question}
  //                 optionLabel={optionLabel}
  //                 isSelected={!!isSelected}
  //                 isCorrect={!!isCorrect}
  //               />
  //             );
  //           })}
  //         </View>
  //       ) : parseInt(question.question_type) === 9 ? (
  //         // Word Association
  //         <View>
  //           {question.options?.pairs?.map((pair, idx) => {
  //             const selectedRight = userAnswers?.[question.question_id]?.[idx] ?? "";
  //             const allRightOptions = question.options.pairs.map((p) => p.right?.text);

  //             return (
  //               <View key={idx} style={{ marginVertical: 10 }}>
  //                 <Text style={styles(isDarkMode).quizQuestion}>
  //                   {t("Match")}: {pair.left?.text}
  //                 </Text>

  //                 <Picker
  //                   selectedValue={selectedRight}
  //                   onValueChange={(value) => {
  //                     const existingAnswers = userAnswers?.[question.question_id] || [];
  //                     const updatedAnswers = [...existingAnswers];
  //                     updatedAnswers[idx] = value;
  //                     handleAnswerChange(question.question_id, updatedAnswers);
  //                   }}
  //                   style={{
  //                     backgroundColor: isDarkMode ? "#333" : "#eee",
  //                     color: isDarkMode ? "#fff" : "#000",
  //                   }}
  //                 >
  //                   <Picker.Item label={t("Select an option")} value="" />
  //                   {allRightOptions.map((opt, optIdx) => (
  //                     <Picker.Item key={optIdx} label={opt} value={opt} />
  //                   ))}
  //                 </Picker>
  //               </View>
  //             );
  //           })}
  //         </View>
  //       ) : parseInt(question.question_type) === 10 ? (
  //         // 📝 Short Essay
  //         <View>
  //           <TextInput
  //             multiline
  //             numberOfLines={5}
  //             placeholder={t("Write a short response (3–5 sentences)...")}
  //             value={userAnswers?.[question.question_id] || ""}
  //             onChangeText={(text) => handleAnswerChange(question.question_id, text)}
  //             style={[
  //               styles(isDarkMode).inputField,
  //               { textAlignVertical: "top", minHeight: 100 },
  //             ]}
  //           />
  //         </View>
  //       ) : parseInt(question.question_type) === 11 ? (
  //         // 🧾 Long Essay
  //         <View>
  //           <TextInput
  //             multiline
  //             numberOfLines={10}
  //             placeholder={t("Write a detailed response (150–200 words)...")}
  //             value={userAnswers?.[question.question_id] || ""}
  //             onChangeText={(text) => handleAnswerChange(question.question_id, text)}
  //             style={[
  //               styles(isDarkMode).inputField,
  //               { textAlignVertical: "top", minHeight: 180 },
  //             ]}
  //           />
  //         </View>
  //       ) : null}

  //       {/* 💡 Hints */}
  //       {(question.hints?.hint1?.text ||
  //         question.hints?.hint2?.text ||
  //         question.hints?.hint1?.images?.length ||
  //         question.hints?.hint2?.images?.length) && (
  //         <TouchableOpacity
  //           onPress={() => toggleHint(question.question_id)}
  //           style={styles(isDarkMode).hintButton}
  //         >
  //           <Text style={styles(isDarkMode).hintText}>
  //             <MaterialCommunityIcons name="lightbulb-outline" size={18} color="#FFF" />{" "}
  //             {t("Show Hint")}
  //           </Text>
  //         </TouchableOpacity>
  //       )}

  //       {showHints?.[question.question_id] && (
  //         <View style={{ marginTop: 8 }}>
  //           {Array.isArray(question?.hints?.hint1?.segments) ? (
  //             <SegmentsRendererRN
  //               segments={question.hints.hint1.segments}
  //               isDarkMode={isDarkMode}
  //             />
  //           ) : (
  //             <>
  //               {!!question?.hints?.hint1?.text && (
  //                 <Text style={styles(isDarkMode).hintText}>
  //                   {question.hints.hint1.text}
  //                 </Text>
  //               )}
  //               {question?.hints?.hint1?.images?.map((image, imgIndex) => (
  //                 <Image
  //                   key={`h1-${imgIndex}`}
  //                   source={{ uri: image.base64 }}
  //                   style={{
  //                     width:
  //                       image.width && image.width < 150
  //                         ? image.width
  //                         : image.orientation === "horizontal"
  //                         ? "100%"
  //                         : "50%",
  //                     height:
  //                       image.height && image.height < 150
  //                         ? image.height
  //                         : image.orientation === "vertical"
  //                         ? 300
  //                         : 250,
  //                     resizeMode: "contain",
  //                     marginVertical: 5,
  //                   }}
  //                 />
  //               ))}
  //             </>
  //           )}

  //           {Array.isArray(question?.hints?.hint2?.segments) ? (
  //             <SegmentsRendererRN
  //               segments={question.hints.hint2.segments}
  //               isDarkMode={isDarkMode}
  //             />
  //           ) : (
  //             <>
  //               {!!question?.hints?.hint2?.text && (
  //                 <Text style={styles(isDarkMode).hintText}>
  //                   {question.hints.hint2.text}
  //                 </Text>
  //               )}
  //               {question?.hints?.hint2?.images?.map((image, imgIndex) => (
  //                 <Image
  //                   key={`h2-${imgIndex}`}
  //                   source={{ uri: image.base64 }}
  //                   style={{
  //                     width:
  //                       image.width && image.width < 150
  //                         ? image.width
  //                         : image.orientation === "horizontal"
  //                         ? "100%"
  //                         : "50%",
  //                     height:
  //                       image.height && image.height < 150
  //                         ? image.height
  //                         : image.orientation === "vertical"
  //                         ? 300
  //                         : 250,
  //                     resizeMode: "contain",
  //                     marginVertical: 5,
  //                   }}
  //                 />
  //               ))}
  //             </>
  //           )}
  //         </View>
  //       )}

  //       {/* ✅ Solution Button */}
  //       {!isTestMode && (
  //         <TouchableOpacity
  //           onPress={() => toggleSolution(question.question_id)}
  //           style={styles(isDarkMode).solutionButton}
  //         >
  //           <Text style={styles(isDarkMode).solutionButtonText}>
  //             <MaterialCommunityIcons name="lightbulb-on-outline" size={18} color="#FFF" />{" "}
  //             {t("Show Solution")}
  //           </Text>
  //         </TouchableOpacity>
  //       )}

  //       {/* ✅ Solution Content */}
  //       {!isTestMode && showSolutions?.[question.question_id] && (
  //         <View style={{ marginTop: 8 }}>
  //           {Array.isArray(question?.solution?.segments) ? (
  //             <SegmentsRendererRN
  //               segments={question.solution.segments}
  //               isDarkMode={isDarkMode}
  //               baseFontSize={16}
  //             />
  //           ) : (
  //             <>
  //               <Text style={styles(isDarkMode).solutionText}>
  //                 {question.solution?.text || t("No solution available")}
  //               </Text>
  //               {question.solution?.images?.length > 0 &&
  //                 question.solution.images.map((image, imgIndex) => (
  //                   <Image
  //                     key={imgIndex}
  //                     source={{ uri: image.base64 }}
  //                     style={{
  //                       width:
  //                         image.width && image.width < 150
  //                           ? image.width
  //                           : image.orientation === "horizontal"
  //                           ? "100%"
  //                           : "50%",
  //                       height:
  //                         image.height && image.height < 150
  //                           ? image.height
  //                           : image.orientation === "vertical"
  //                           ? 300
  //                           : 250,
  //                       resizeMode: "contain",
  //                       marginTop: 5,
  //                     }}
  //                   />
  //                 ))}
  //             </>
  //           )}
  //         </View>
  //       )}
  //     </View>
  //   ));
  // };
  // BDD 10/27/2025 - moving detailed logic of renderQuizSection to a common area
  // frontend/app/QuestionDisplay.js
  // BDD 10/27/2025 - removing renderQuizSection completely
  // const renderQuizSection = ({
  //   quizData,
  //   userAnswers,
  //   answerFeedback,
  //   showHints,
  //   showSolutions,
  //   toggleHint,
  //   toggleSolution,
  //   handleAnswerChange,
  //   handleMCQSelection,
  //   checkTextAnswer,
  //   isDarkMode,
  //   styles,
  //   SegmentsRendererRN, // 👈 NEW: pass through
  // }) => {
  //   if (!quizData || !Array.isArray(quizData) || quizData.length === 0) {
  //     return <Text>{t("No questions available for this topic.")}</Text>;
  //   }

  //   // map your quizMode -> QuestionDisplay.mode
  //   // quizMode is still from outer scope in AITutorApp.js
  //   let displayMode = "quizPractice";
  //   if (quizMode === "test") {
  //     displayMode = "testTaking";
  //   } else if (quizMode === "pastTestView") {
  //     displayMode = "pastTestView";
  //   } else {
  //     displayMode = "quizPractice";
  //   }

  //   return quizData.map((question, index) => (
  //     <QuestionDisplay
  //       key={question.question_id ?? index}
  //       question={question}
  //       index={index}
  //       mode={displayMode}
  //       isDarkMode={isDarkMode}
  //       styles={styles}
  //       userAnswers={userAnswers}
  //       answerFeedback={answerFeedback}
  //       showHints={showHints}
  //       showSolutions={showSolutions}
  //       toggleHint={toggleHint}
  //       toggleSolution={toggleSolution}
  //       handleAnswerChange={handleAnswerChange}
  //       handleMCQSelection={handleMCQSelection}
  //       checkTextAnswer={checkTextAnswer}
  //       SegmentsRendererRN={SegmentsRendererRN} // 👈 pass it down so QuestionDisplay can render rich text
  //     />
  //   ));
  // };

  // BDD 10/13/2025
  // When in regular "quiz" mode (not "test"), celebrate as soon as all are correct.
  // AIT-249: Gated on immediateFeedbackEnabled. In the new deferred-feedback
  // path, answerFeedback is empty during answering, so this effect would never
  // fire correctly anyway. Confetti is now triggered by submitQuiz() (and by
  // the review screen entry) so all-correct quizzes still celebrate on submit.
  useEffect(() => {
    if (!immediateFeedbackEnabled) return;
    if (quizMode === "test" || !showQuiz) return;
    if (!Array.isArray(quizData) || quizData.length === 0) return;

    const ids = quizData.map(q => q.question_id);
    const allCorrect = ids.every((id) => answerFeedback?.[id] === "correct");

    if (allCorrect && !confettiFiredRef.current) {
      confettiFiredRef.current = true;
      setConfettiVisible(true);
    }
  }, [answerFeedback, quizData, showQuiz, quizMode, immediateFeedbackEnabled]);

  // Reset confetti guard when quiz changes (enter/leave/new set of questions)
  useEffect(() => {
    confettiFiredRef.current = false;
    setConfettiVisible(false);
  }, [assessmentId, showQuiz, quizMode, quizData?.length]);

  useEffect(() => {
    if (Platform?.OS === "web" && showVideo) {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      } catch {
        window.scrollTo(0, 0);
      }
    }
  }, [showVideo]);

  useEffect(() => {
    if (shelvesLayout) setSidebarVisible(false);
  }, [shelvesLayout]);

  // BDD 10/13/2025 Allow closing with ESC (web)
  useEffect(() => {
    if (!shelvesLayout || Platform.OS !== "web") return;
    const onKey = (e) => {
      if (e.key === "Escape") {
        setHistoryOpen(false);
        setInsightsOpen(false);
        setLauncherOpen(false);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [shelvesLayout]);

  const prevColIdRef = useRef(null);

  // Ensure sidebar is always hidden in investor mode
  useEffect(() => {
    if (shelvesLayout) setSidebarVisible(false);
  }, [shelvesLayout]);

  // ESC closes shelves (web)
  useEffect(() => {
    if (!shelvesLayout || Platform.OS !== "web") return;
    const onKey = (e) => {
      if (e.key === "Escape") {
        setHistoryOpen(false);
        setInsightsOpen(false);
        setLauncherOpen(false);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [shelvesLayout]);

  // BDD 11/3/2025
  // // Track the last-seen collection id whenever launcher opens/closes
  // useEffect(() => {
  //   if (!shelvesLayout ) return;
  //   if (!launcherOpen) {
  //     prevColIdRef.current = activeStudyCollection?.id ?? null;
  //   }
  // }, [shelvesLayout , launcherOpen, activeStudyCollection?.id]);

  // BDD 11/3/2025
  // === PATCH 2025-11-03: avoid redundant view flips ===
  // Close launcher ONLY when collection CHANGES while the launcher is open
  useEffect(() => {
    if (!shelvesLayout || !launcherOpen) return;

    const curr = activeStudyCollection?.id ?? null;

    // First time we see a value while open → just remember it, don't close
    if (prevColIdRef.current === null) {
      prevColIdRef.current = curr;
      return;
    }

    // If user picked a different collection while the shelf is open → switch view & close
    if (curr && curr !== prevColIdRef.current) {
      prevColIdRef.current = curr;
      if (viewMode !== "collections") {    // 👈 guard to prevent flicker
        setViewMode("collections");
      }
      setActiveModule("learning");
      setLauncherOpen(false);
    }
  }, [shelvesLayout, launcherOpen, activeStudyCollection?.id, viewMode]); // 👈 include viewMode

  // Close launcher ONLY when collection CHANGES while the launcher is open
  useEffect(() => {
    if (!shelvesLayout || !launcherOpen) return;

    const curr = activeStudyCollection?.id ?? null;

    // First time we see a value while open → just remember it, don't close
    if (prevColIdRef.current === null) {
      prevColIdRef.current = curr;
      return;
    }

    // If user picked a different collection while the shelf is open → switch view & close
    if (curr && curr !== prevColIdRef.current) {
      prevColIdRef.current = curr;
      setViewMode("collections"); // BDD 10/17/2025
      setActiveModule("learning");
      setLauncherOpen(false);
    }
  }, [shelvesLayout, launcherOpen, activeStudyCollection?.id]);

  // BDD 10/15/2025
  // === Drag-resize support (RN Web + touch) ===
  // const [isResizing, setIsResizing] = useState(false);
  const resizeStartRef = useRef({ x: 0, wPx: 0 });  // x = start cursor X, wPx = sidebar width in px at start
  const [contentWidth, setContentWidth] = useState(0);

  // Force iframe repaint after zoom/resize to prevent grey/black screen
  // Browser may pause iframe rendering after transform changes, body zoom, or losing focus
  useEffect(() => {
    if (pwoIframeRef.current && (showPwo || pwoKeepAlive)) {
      const iframe = pwoIframeRef.current;
      // Small delay to let the zoom/resize settle, then force repaint
      const timer = setTimeout(() => {
        if (!iframe) return;
        // Force reflow
        void iframe.offsetHeight;
        // Toggle visibility to force browser to re-render iframe content
        iframe.style.visibility = 'hidden';
        requestAnimationFrame(() => {
          iframe.style.visibility = 'visible';
          // Also dispatch resize event to iframe window - WebGL listens for this
          try {
            iframe.contentWindow?.dispatchEvent(new Event('resize'));
          } catch (e) {
            // Cross-origin may block this, that's ok
          }
        });
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [pwoScale, zoomLevel, stageMaximized, width, height, contentWidth, showPwo, pwoKeepAlive]);

  // BDD 01/23/2026 - Responsive auto-scale for non-fullscreen PWO
  // Calculates a base scale so the native 1280x720 PWO fits within available width
  const pwoResponsiveScale = useMemo(() => {
    if (stageMaximized || !contentWidth || contentWidth <= 0) return 1;
    // Calculate scale needed to fit PWO_NATIVE_WIDTH into contentWidth
    // Use the smaller of width-based or height-based scale to maintain aspect ratio
    const availableWidth = contentWidth - 40;  // Account for padding
    const scaleToFitWidth = availableWidth / PWO_NATIVE_WIDTH;
    // Cap at 1 so we never scale up beyond native size
    return Math.min(1, scaleToFitWidth);
  }, [stageMaximized, contentWidth]);

  // Helper: clamp
  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  // Convert current sidebarWidth (could be "25%" or a number) to px based on contentWidth
  const getSidebarWidthPx = () => {
    if (!contentWidth) return 0;
    if (typeof sidebarWidth === "string" && sidebarWidth.endsWith("%")) {
      const p = parseFloat(sidebarWidth);
      return (contentWidth * (isNaN(p) ? 0 : p)) / 100;
    }
    const n = Number(sidebarWidth);
    return isNaN(n) ? 0 : n;
  };

  // WEB: global mouse move while dragging
  useEffect(() => {
    if (Platform.OS !== "web") return;
    const onMove = (e) => {
      if (!isResizing || !contentWidth) return;
      e.preventDefault?.();
      const dx = e.clientX - resizeStartRef.current.x;
      const newPx = clamp(
        resizeStartRef.current.wPx + dx,
        180,                     // MIN sidebar px
        contentWidth * 0.6       // MAX 60% of wrapper
      );
      const pct = Math.round((newPx / contentWidth) * 100);
      setSidebarWidth(`${pct}%`);
    };
    const onUp = () => setIsResizing(false);

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };
  }, [isResizing, contentWidth, setSidebarWidth]);

  // Start drag (web)
  const onResizeStartWeb = (e) => {
    if (Platform.OS !== "web") return;
    e.preventDefault?.();
    resizeStartRef.current = {
      x: e.clientX,
      wPx: getSidebarWidthPx(),
    };
    setIsResizing(true);
  };

  // Start drag (touch/responder)
  const onResizeGrantTouch = (e) => {
    const startX = e?.nativeEvent?.pageX ?? 0;
    resizeStartRef.current = {
      x: startX,
      wPx: getSidebarWidthPx(),
    };
    setIsResizing(true);
  };

  // Move during drag (touch/responder)
  const onResizeMoveTouch = (e) => {
    if (!isResizing || !contentWidth) return;
    const x = e?.nativeEvent?.pageX ?? 0;
    const dx = x - resizeStartRef.current.x;
    const newPx = clamp(
      resizeStartRef.current.wPx + dx,
      180,
      contentWidth * 0.6
    );
    const pct = Math.round((newPx / contentWidth) * 100);
    setSidebarWidth(`${pct}%`);
  };

  // End drag (touch/responder)
  const onResizeEndTouch = () => setIsResizing(false);

  // ========== RIGHT SIDEBAR RESIZE (SuggestionRail) ==========
  // Get right sidebar width in px
  const getRightSidebarWidthPx = () => {
    if (!contentWidth) return responsiveRailWidth;
    if (rightSidebarWidth === null) return responsiveRailWidth;
    if (typeof rightSidebarWidth === "number") return rightSidebarWidth;
    return responsiveRailWidth;
  };

  // WEB: global mouse move while dragging right sidebar
  useEffect(() => {
    if (Platform.OS !== "web") return;
    const onMove = (e) => {
      if (!isResizingRight || !contentWidth) return;
      e.preventDefault?.();
      // For right sidebar, dragging left (negative dx) makes it wider
      const dx = e.clientX - resizeStartRightRef.current.x;
      const newPx = clamp(
        resizeStartRightRef.current.wPx - dx, // Note: subtract dx (opposite of left sidebar)
        120,                    // MIN right sidebar px
        contentWidth * 0.55     // MAX 55% of wrapper
      );
      setRightSidebarWidth(newPx);
    };
    const onUp = () => setIsResizingRight(false);

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };
  }, [isResizingRight, contentWidth]);

  // Start drag right sidebar (web)
  const onResizeStartRightWeb = (e) => {
    if (Platform.OS !== "web") return;
    e.preventDefault?.();
    resizeStartRightRef.current = {
      x: e.clientX,
      wPx: getRightSidebarWidthPx(),
    };
    setIsResizingRight(true);
  };

  // Start drag right sidebar (touch/responder)
  const onResizeGrantRightTouch = (e) => {
    const startX = e?.nativeEvent?.pageX ?? 0;
    resizeStartRightRef.current = {
      x: startX,
      wPx: getRightSidebarWidthPx(),
    };
    setIsResizingRight(true);
  };

  // Move during drag right sidebar (touch/responder)
  const onResizeMoveRightTouch = (e) => {
    if (!isResizingRight || !contentWidth) return;
    const x = e?.nativeEvent?.pageX ?? 0;
    const dx = x - resizeStartRightRef.current.x;
    const newPx = clamp(
      resizeStartRightRef.current.wPx - dx, // Note: subtract dx
      120,
      contentWidth * 0.55
    );
    setRightSidebarWidth(newPx);
  };

  // End drag right sidebar (touch/responder)
  const onResizeEndRightTouch = () => setIsResizingRight(false);
  // ========== END RIGHT SIDEBAR RESIZE ==========

  // BDD 10/13/2025 - end
  // Calculate dynamic styles based on state
  const getDynamicStyles = () => {
    // Responsive breakpoints for browser zoom support
    const isMobile = width < 768;
    const isTablet = width >= 768 && width < 1024;
    const isNarrow = width < 1100;  // Auto-collapse at 150% zoom (increased threshold)

    // Use user-controlled sidebarWidth on desktop, overlay mode on mobile/tablet/narrow
    let calculatedWidth = sidebarWidth; // Keep user-controlled width for drag-to-resize
    if (isMobile || isNarrow) {
      calculatedWidth = "85%"; // Overlay mode for narrow viewports
    } else if (isTablet) {
      calculatedWidth = "85%"; // Tablet mode
    }

    return {
      sidebar: {
        // On mobile/tablet/narrow: absolute positioning to overlay content
        // On desktop: normal flow (pushes content)
        ...(isMobile || isTablet || isNarrow ? { position: "absolute", left: 0, top: 0, zIndex: 100 } : {}),
        width: sidebarVisible ? calculatedWidth : "0%",
        height: "100%",
        backgroundColor: isDarkMode ? "#181818" : "#ffffff",
        borderRightWidth: 1,
        borderRightColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#e2e8f0",
        padding: sidebarVisible ? responsiveContentPadding : 0, // Responsive padding
        overflow: (isMobile || isTablet || isNarrow) ? 'visible' : 'hidden',
        display: sidebarVisible ? "flex" : "none",

        // Shadow on mobile/tablet/narrow to show it's floating
        ...(isMobile || isTablet || isNarrow ? {
          shadowColor: "#000",
          shadowOpacity: 0.3,
          shadowRadius: 10,
          shadowOffset: { width: 2, height: 0 },
        } : {}),
      },
      sidebarToggleButton: {
        position: "absolute",
        top: 10,
        left: (isMobile || isTablet || isNarrow) ? (sidebarVisible ? "85%" : 0) : (sidebarVisible ? sidebarWidth : 0), // Use user-controlled width

        backgroundColor: "rgba(0,0,0,0.6)",
        borderRadius: 20,
        padding: 6, // Smaller padding
        zIndex: 101,  // Above sidebar
        alignItems: "center",

      },
      sidebarToggleIcon: {
        color: '#fff',
        fontSize: rem(16) + 'rem',
        fontWeight: 'bold',
      },
    };
  };

  // Get the dynamic styles
  const dynamicStyles = getDynamicStyles();
  // BDD 10/1/12025 speed up typing response time
  const s = styles(isDarkMode); // cached sheet, cheap to call
  const placeholder = useMemo(() => {
    if (activeModule === "video") return t("Ask a question about this video...");
    if (activeModule === "pwo") return t("Ask a question about this Interactive Play With Object...");
    if (activeModule === "whiteboard") return t("Ask a question about what is drawn on this Whiteboard...");
    if (activeModule === "uploaded") return t("Ask a question about this image/pdf...");
    return t("Ask a question...");
  }, [activeModule, t]);

  // BDD 10/15/2025

  // Clear selection if leaving curriculum view
  useEffect(() => {
    if (!curriculumView) setSelectedChapter(null);
  }, [curriculumView]);

  // BDD 10/15/2025
  const parseGradeNum = (g) => {
    const n = Number(String(g ?? "").replace(/[^\d]/g, ""));
    return Number.isFinite(n) && n > 0 ? n : 1e9; // push unknowns to bottom
  };

  // BDD 10/15/2025

  // Expand the tree for a chosen chapter (uses your shapes)
  const ensureExpandedForChapter = React.useCallback((levelId, subjectId, chapterId) => {
    setExpandedGrades(prev => ({
      ...prev,
      [levelId]: true,
    }));
    setExpandedSubjects(prev => ({
      ...prev,
      [levelId]: { ...(prev[levelId] || {}), [subjectId]: true },
    }));
    setExpandedChapters(prev => ({
      ...prev,
      [subjectId]: { ...(prev[subjectId] || {}), [chapterId]: true },
    }));
    // Scroll to the chapter after a delay to allow expansion animation and DOM update
    setTimeout(() => {
      scrollToChapter(chapterId);
    }, 500);
  }, []);

  // Scroll to a specific chapter in the sidebar (with retry for web)
  const scrollToChapter = useCallback((chapterId, retryCount = 0) => {
    const maxRetries = 10;
    const retryDelay = 200;

    if (Platform.OS === 'web') {
      try {
        const selector = `[data-chapterid="${chapterId}"]`;
        const element = document.querySelector(selector);

        if (element) {
          // Find the scrollable sidebar container
          const scrollContainer = document.querySelector('[data-sidebarscroll="true"]');

          if (scrollContainer) {
            // React Native Web ScrollView: find the actual scrollable element
            // It's usually the outer div itself or its first child with overflow
            let scrollableEl = scrollContainer;

            // Check if the container itself is scrollable
            const style = window.getComputedStyle(scrollContainer);
            if (style.overflow !== 'auto' && style.overflow !== 'scroll' &&
              style.overflowY !== 'auto' && style.overflowY !== 'scroll') {
              // Try first child
              if (scrollContainer.firstElementChild) {
                scrollableEl = scrollContainer.firstElementChild;
              }
            }

            const elementRect = element.getBoundingClientRect();
            const containerRect = scrollableEl.getBoundingClientRect();
            const currentScroll = scrollableEl.scrollTop;
            const targetY = elementRect.top - containerRect.top + currentScroll - 100;

            // Try React Native ref first
            if (sidebarScrollRef.current?.scrollTo) {
              sidebarScrollRef.current.scrollTo({ y: Math.max(0, targetY), animated: true });
            }

            // Also try direct DOM scroll as backup
            scrollableEl.scrollTop = Math.max(0, targetY);
          } else {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        } else if (retryCount < maxRetries) {
          // Element not found yet, retry after delay
          setTimeout(() => scrollToChapter(chapterId, retryCount + 1), retryDelay);
        }
      } catch (e) {
        // Scroll error - silently ignore
      }
    } else {
      // Native: use measureLayout
      const chapterRef = chapterRefsMap.current[chapterId];
      if (chapterRef?.measureLayout && sidebarScrollRef.current) {
        chapterRef.measureLayout(
          sidebarScrollRef.current,
          (x, y) => {
            sidebarScrollRef.current.scrollTo({ y: Math.max(0, y - 100), animated: true });
          },
          () => { }
        );
      }
    }
  }, []);

  // Expand and scroll to selected chapter when switching back to Chapters tab
  useEffect(() => {
    if (activeSidebarTab === 'collections' && selectedChapter?.chapterId && selectedChapter?.levelId && selectedChapter?.subjectId) {
      // Ensure the chapter's parents are expanded and scroll to it
      ensureExpandedForChapter(selectedChapter.levelId, selectedChapter.subjectId, selectedChapter.chapterId);
    }
  }, [activeSidebarTab, selectedChapter, ensureExpandedForChapter]);
  // BDD 10/15/2025

  // sorted curriculum (grade asc)
  const sortedCurriculum = useMemo(() => {
    const arr = Array.isArray(curriculum) ? [...curriculum] : [];
    arr.sort((a, b) => parseGradeNum(a?.grade) - parseGradeNum(b?.grade));
    // console.log("[BDD Curriculum DEBUG] curriculum", curriculum);
    return arr;
  }, [curriculum]);

  const hasMultipleGrades = useMemo(() => {
    const set = new Set((sortedCurriculum || []).map(l => String(l?.grade ?? "").trim()).filter(Boolean));
    return set.size > 1;
  }, [sortedCurriculum]);
  // BDD 10/15/2025
  // BDD 02/20/2026 - PWO QA - Grade scope test/healthCheckpwo - start
  // BDD 02/20/2026 - test/healthCheckpwo
  function exportPwoQaJsonlNamed(filenameBase, rows) {
    const jsonl = (rows || []).map((r) => JSON.stringify(r)).join("\n");
    const ts = new Date().toISOString().replace(/[:.]/g, "-");
    downloadTextFile(`${filenameBase}_${ts}.jsonl`, jsonl + "\n");
  }

  // BDD 02/20/2026 - test/healthCheckpwo
  async function runPwoQaForSelectedGrade() {
    const gid = String(pwoQaGradeId || "").trim();
    if (!gid) {
      alert("Select a grade first.");
      return;
    }

    const levels = Array.isArray(sortedCurriculum) ? sortedCurriculum : [];
    const level = levels.find((l) => String(l?.id ?? l?.levelId ?? l?.gradeId ?? "") === gid);

    if (!level) {
      alert("Could not find that grade in sortedCurriculum.");
      return;
    }

    const subjectsInGrade = level?.subjects || [];
    if (!subjectsInGrade.length) {
      alert("No subjects found under this grade.");
      return;
    }

    setPwoQaGradeRunning(true);

    const gradeLabel =
      (level?.grade ?? level?.display_name ?? level?.displayName ?? level?.name ?? gid).toString().trim() || gid;

    const allRows = [];

    try {
      for (let sIdx = 0; sIdx < subjectsInGrade.length; sIdx++) {
        if (pwoQaAbortRef.current) break;

        const subj = subjectsInGrade[sIdx];
        const sid = String(subj?.id ?? subj?.subjectId ?? subj?.subject_id ?? "").trim();
        if (!sid) continue;

        const subjLabel = (labelForCurriculumNode?.(subj) || subj?.display_name || subj?.displayName || subj?.name || sid).toString().trim();

        // Build list for this subject (does NOT rely on setSelectedChapter)
        const items = await buildPwoQaListForSubjectId(sid);

        if (!items?.length) {
          allRows.push({
            status: "NO_ITEMS",
            gradeId: gid,
            gradeLabel,
            subjectId: sid,
            subjectLabel: subjLabel,
            ts: Date.now(),
          });
          continue;
        }

        // Run using override to avoid any setState timing weirdness
        setPwoQaIndex(0);
        setPwoQaResults([]);

        const results = await startPwoQaRun(items);

        // tag each row with grade+subject so you can filter later
        for (const r of results) {
          allRows.push({
            gradeId: gid,
            gradeLabel,
            subjectId: sid,
            subjectLabel: subjLabel,
            ...r,
          });
        }

        // small breather between subjects
        await sleep(250);
      }

      // Single download at end (avoids browser blocking multiple downloads)
      exportPwoQaJsonlNamed(`pwo_healthcheck_grade_${gradeLabel}`.replace(/[^a-z0-9_-]+/gi, "_"), allRows);
    } finally {
      setPwoQaGradeRunning(false);
    }
  }
  // BDD 02/20/2026 - PWO QA - Grade scope test/healthCheckpwo - end
  // BDD 02/20/2026 - PWO QA - Grade scope test/healthCheckpwo - start
  useEffect(() => {
    try {
      const levels = Array.isArray(sortedCurriculum) ? sortedCurriculum : [];

      const opts = levels
        .map((lvl) => {
          const id = lvl?.id ?? lvl?.levelId ?? lvl?.gradeId ?? lvl?.grade_id ?? null;
          if (!id) return null;

          const raw =
            (lvl?.grade ?? lvl?.display_name ?? lvl?.displayName ?? lvl?.name ?? "").toString().trim();

          const label = raw ? raw : `Level ${id}`;
          return { id: String(id), label };
        })
        .filter(Boolean);

      // If you have parseGradeNum in this file already, keep this sort. Otherwise you can remove sorting.
      try {
        opts.sort((a, b) => (parseGradeNum(a.label) - parseGradeNum(b.label)) || String(a.label).localeCompare(String(b.label)));
      } catch {
        opts.sort((a, b) => String(a.label).localeCompare(String(b.label)));
      }

      setPwoQaGradeOptions(opts);

      if (!pwoQaGradeId && opts.length) {
        setPwoQaGradeId(opts[0].id);
      }
    } catch (e) {
      console.warn("[PWO QA] Failed to build grade options from sortedCurriculum", e);
      setPwoQaGradeOptions([]);
      setPwoQaGradeId("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortedCurriculum]);
  // BDD 02/20/2026 - PWO QA - Grade scope test/healthCheckpwo - end

      // BDD 02/15/2026 - test/healthCheckpwo
    useEffect(() => {
      try {
        const subjects = extractSubjectNodes(sortedCurriculum);
        const opts = (subjects || [])
          .map((s) => {
            const id = getNodeId(s);
            const label = getNodeLabel(s);
            if (!id || !label) return null;
            return { id: String(id), label };
          })
          .filter(Boolean);

        setPwoQaSubjectOptions(opts);

        // Default selection (first) if none chosen yet
        if (!pwoQaSubjectId && opts.length) {
          setPwoQaSubjectId(opts[0].id);
        }
      } catch (e) {
        console.warn("[PWO QA] Failed to build subject options from sortedCurriculum", e);
        setPwoQaSubjectOptions([]);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sortedCurriculum]);

  // Find level/subject/chapter — validate saved selection
  const findChapterPath = React.useCallback((finder) => {
    for (const level of sortedCurriculum || []) {
      for (const subject of level.subjects || []) {
        for (const chap of subject.chapters || []) {
          if (finder({ level, subject, chap })) return { level, subject, chap };
        }
      }
    }
    return null;
  }, [sortedCurriculum]);


    // BDD 02/20/2026 - PWO QA - Grade scope test/healthCheckpwo - start
    // BDD 02/20/2026 - test/healthCheckpwo
    const buildPwoQaListForSubjectId = async (sidRaw) => {
      const sid = String(sidRaw || "").trim();
      if (!sid) {
        alert("Select a subject first.");
        return [];
      }

      console.log("[PWO QA] Build List (Subject) clicked", { subjectId: sid });

      const subjects = extractSubjectNodes(sortedCurriculum);
      const subjectNode = (subjects || []).find((s) => String(getNodeId(s)) === sid);

      if (!subjectNode) {
        alert("Could not find that subject in sortedCurriculum.");
        return [];
      }

      const chapters = extractChaptersFromSubject(subjectNode) || [];
      if (!chapters.length) {
        alert("No chapters found under this subject.");
        return [];
      }

      const items = [];
      for (let c = 0; c < chapters.length; c++) {
        const chap = chapters[c];
        const chapterId = chap?.chapterId ?? chap?.chapter_id ?? chap?.id ?? null;

        const topics = extractTopicsFromChapter(chap) || [];
        for (let tIdx = 0; tIdx < topics.length; tIdx++) {
          const topic = topics[tIdx];
          const topicId = topic?.topicId ?? topic?.topic_id ?? topic?.id ?? null;
          if (!topicId) continue;

          const pwos = await fetchPwosForTopic(topicId, selectedSecondaryLang);

          for (let i = 0; i < (pwos || []).length; i++) {
            const p = pwos[i];
            const pwoID = p?.pwo_source_id;
            const sceneName = p?.scene_name;
            if (!pwoID || !sceneName) continue;

            items.push({
              pwoID,
              sceneName,
              topicId,
              chapterId,
              subjectId: sid,
              title:
                (p?.name && p?.display_name)
                  ? (p.name.toLowerCase().includes(String(p.display_name).toLowerCase()) ? p.name : `${p.name} - ${p.display_name}`)
                  : (p?.name || p?.display_name || `${pwoID} - ${sceneName}`),
            });

            if (pwoQaMaxItems && items.length >= pwoQaMaxItems) break;
          }

          if (pwoQaMaxItems && items.length >= pwoQaMaxItems) break;
        }

        if (pwoQaMaxItems && items.length >= pwoQaMaxItems) break;
      }

      console.log("[PWO QA] Build List (Subject) done", { items: items.length, subjectId: sid });
      setPwoQaItems(items);
      setPwoQaIndex(0);
      setPwoQaResults([]);
      return items;
    };

  const hasMultipleGradesForQa = React.useMemo(() => {
    return Array.isArray(sortedCurriculum) && sortedCurriculum.length > 1;
  }, [sortedCurriculum]);

  // BDD 02/20/2026 smoketest - Smoke Test Runner
  // BDD 02/20/2026 - Smoke Test Runner
  async function runOneSmokeStep(step, idx, plan) {
    const startedAt = Date.now();
    const base = {
      idx,
      kind: step?.kind || "unknown",
      name: step?.name || null,
      startedAtIso: new Date(startedAt).toISOString(),
      ok: false,
      status: "fail",
      ms: 0,
      details: {},
      error: null,
    };

    try {
      if (smokeAbortRef.current) throw new Error("SMOKE_ABORTED");

      if (step.kind === "pwo") {
        // Reuse the existing proven PWO healthcheck runner
        const item = {
          pwoID: step.pwoID,
          sceneName: step.sceneName,
          topicId: step.topicId ?? null,
          chapterId: step.chapterId ?? null,
          subjectId: step.subjectId ?? null,
          title: step.title || step.name || `${step.pwoID} - ${step.sceneName}`,
        };

        const res = await runOnePwoHealthcheck(item);
        setSmokeTopicScopeFromStep(step);  // <-- add this
        base.ok = !!res && !(res?.error || res?.fatal || res?.hasError);
        base.status = base.ok ? "pass" : "fail";
        base.details = { pwo: item, res };
      }

      else if (step.kind === "video") {
        const playMs =
          Number(step.playMs) ||
          Number(plan?.default_timeouts?.video_play_ms) ||
          12000;

        const videoID = step.videoID;
        const tagID = step.tagID;
        if (!videoID || tagID == null) throw new Error("Video step missing videoID/tagID");

        // Launch video (reuses your handler)
        await handleVideoClick(
          videoID,
          tagID,
          authToken,
          step.chapterId ?? null,
          step.topicId ?? null,
          true // isAuto
        );

        // Wait for HLS.js to fully attach and video to have frames before timing playback
        // readyState >= 3 (HAVE_FUTURE_DATA) means the browser has enough data to render video
        const VIDEO_READY_TIMEOUT = 15000;
        const videoReadyStart = Date.now();
        while (
          (!videoRef?.current || (videoRef.current.readyState || 0) < 3) &&
          (Date.now() - videoReadyStart) < VIDEO_READY_TIMEOUT
        ) {
          await sleep(250);
        }
        if (!videoRef?.current || (videoRef.current.readyState || 0) < 3) {
          console.warn("[SMOKE] video readyState never reached HAVE_FUTURE_DATA within timeout — proceeding anyway");
        }

        // Let it play a bit
        let t0 = null, t1 = null, played = null;
        try {
          const v = videoRef?.current;
          if (v) t0 = Number(v.currentTime || 0);
          await sleep(playMs);
          if (v) t1 = Number(v.currentTime || 0);
          played = (t0 != null && t1 != null) ? ((t1 - t0) > 0.5) : null;
        } catch {}

        // AIT-255: run was aborted while we waited - pause and close before returning.
        if (smokeAbortRef.current) {
          smokeCleanupRef.current?.({ closeModule: true });
          throw new Error("SMOKE_ABORTED");
        }

        // Close module cleanly
        try { await handleCloseModule(false); } catch {}

        // For smoke: consider “pass” if handler didn’t throw.
        // played==null is acceptable (some environments block autoplay), so we don’t fail on that.
        base.ok = true;
        base.status = "pass";
        base.details = { videoID, tagID, playMs, played, t0, t1 };
      }

      else if (step.kind === "ask") {
        const question = String(step.question || "").trim();
        if (!question) throw new Error("Ask step missing question");

        const askTimeout =
          Number(step.timeoutMs) ||
          Number(plan?.default_timeouts?.ask_timeout_ms) ||
          60000;

        // ✅ baseline for “new result”
        const prevHist = historyRef.current || [];
        const prevLen = prevHist.length;
        const prevTop = prevHist[0] || null;
        const prevTopId = prevTop?.student_message_id ?? prevTop?.assistant_turn_id ?? null;

        // ✅ optional: clear ref arrays so we don't accidentally read stale globals
        try { setPwos([]); } catch {}
        try { setVideos([]); } catch {}
        try { setDocuments([]); } catch {}

        const scopeNow = getSmokeTopicScope(step, plan);

        await handleAsk(question, {
          forceNewDialog: step.forceNewDialog !== false,
          skipReferences: !!step.skipReferences,
          debugPromptMode: !!step.debugPromptMode,

          // ✅ THIS is the fix
          topicScope: scopeNow,
        });

        // AIT-255: Stop pressed while the answer was in flight - do not start/keep media.
        if (smokeAbortRef.current) {
          smokeCleanupRef.current?.({ closeModule: true });
          throw new Error("SMOKE_ABORTED");
        }


        // ✅ wait for a new history entry (best source of truth for answer+refs)
        const gotHist = await waitForNewHistoryEntry(prevLen, prevTopId, askTimeout);

        // AIT-255: aborted while waiting for the answer - stop media and bail out.
        if (smokeAbortRef.current) {
          smokeCleanupRef.current?.({ closeModule: true });
          throw new Error("SMOKE_ABORTED");
        }

        const entry = (historyRef.current && historyRef.current[0]) ? historyRef.current[0] : null;

        // BDD 04/13/2026 - AI smoke metrics for current ask
        const askMetrics = getAiAskMetricsSnapshot();

        const ans = String(entry?.answer || answerRef.current || "").trim();
        const pwosLocal = entry?.pwos ?? pwosRef.current ?? [];
        const vidsLocal = entry?.videos ?? videosRef.current ?? [];

        const expect = Array.isArray(step.expect) ? step.expect : ["answer"];
        const minAnswerLen = Number(step.minAnswerLen ?? 80);

        const badHit = SMOKE_BAD_ANSWER_PATTERNS.find((re) => re.test(ans));
        const mustContainAny = step.mustContainAny || null;

        const gotAnswer = ans.length >= 1;
        const okAnswerLen = ans.length >= minAnswerLen;
        const okMustContain = smokeIncludesAny(ans, mustContainAny);

        const pwoCount = Array.isArray(pwosLocal) ? pwosLocal.length : 0;
        const vidCount = Array.isArray(vidsLocal) ? vidsLocal.length : 0;

        let ok = gotHist && gotAnswer && okAnswerLen && !badHit && okMustContain;

        if (expect.includes("pwo") && pwoCount < Number(step.minPwos ?? 1)) ok = false;
        if (expect.includes("video") && vidCount < Number(step.minVideos ?? 1)) ok = false;

        // BDD 04/13/2026 - AI smoke metrics for current ask
        if (askMetrics.hadError) ok = false;
        if (!askMetrics.doneMs) ok = false;
        if (!askMetrics.ttftMs) ok = false;

        base.ok = ok;
        base.status = ok ? "pass" : "fail";
        base.details = {
          expect,
          gotHist,
          answerLen: ans.length,
          answerPreview: smokePreviewText(ans, Number(step.previewLen ?? 280)),
          badPattern: badHit ? String(badHit) : null,
          mustContainAny,
          okMustContain,
          pwos: pwoCount,
          videos: vidCount,
          pwosPreview: summarizePwosForSmoke(pwosLocal, 3),
          videosPreview: summarizeVideosForSmoke(vidsLocal, 3),

          // BDD 04/13/2026 - AI smoke metrics for current ask
          mode: askMetrics.mode,
          ttftMs: askMetrics.ttftMs,
          textDoneMs: askMetrics.textDoneMs,
          doneMs: askMetrics.doneMs,
          firstAudioMs: askMetrics.firstAudioMs,
          hadAudio: askMetrics.hadAudio,
          hadError: askMetrics.hadError,
          errorMessages: askMetrics.errorMessages,
          metrics: askMetrics,

          // handy debugging anchors if present
          conversation_id: entry?.conversation_id ?? null,
          assistant_turn_id: entry?.assistant_turn_id ?? null,
          student_message_id: entry?.student_message_id ?? null,
          content_db: entry?.content_db ?? null,
        };

        // OPTIONAL (only if you explicitly want full answer in JSONL)
        if (step.storeFullAnswer === true) {
          base.details.answerFull = ans;
        }
      }

      else if (step.kind === "ask_suggested") {
        const si = Number(step.index || 0);
        const q = String(suggestedQuestionsRef.current?.[si] || "").trim();
        if (!q) throw new Error(`No suggested question at index ${si}`);

        const askTimeout =
          Number(step.timeoutMs) ||
          Number(plan?.default_timeouts?.ask_timeout_ms) ||
          60000;

        const prevHist = historyRef.current || [];
        const prevLen = prevHist.length;
        const prevTop = prevHist[0] || null;
        const prevTopId = prevTop?.student_message_id ?? prevTop?.assistant_turn_id ?? null;

        try { setPwos([]); } catch {}
        try { setVideos([]); } catch {}
        try { setDocuments([]); } catch {}

        const scopeNow = getSmokeTopicScope(step, plan);

        await handleAsk(q, {
          forceNewDialog: !!step.forceNewDialog,
          skipReferences: !!step.skipReferences,

          // ✅ keep suggested asks anchored too
          topicScope: scopeNow,
        });

        const gotHist = await waitForNewHistoryEntry(prevLen, prevTopId, askTimeout);

        // AIT-255: aborted while waiting for the answer - stop media and bail out.
        if (smokeAbortRef.current) {
          smokeCleanupRef.current?.({ closeModule: true });
          throw new Error("SMOKE_ABORTED");
        }
        const entry = (historyRef.current && historyRef.current[0]) ? historyRef.current[0] : null;

        // BDD 04/13/2026 - AI smoke metrics for current ask
        const askMetrics = getAiAskMetricsSnapshot();

        const ans = String(entry?.answer || answerRef.current || "").trim();
        const minAnswerLen = Number(step.minAnswerLen ?? 60);

        const badHit = SMOKE_BAD_ANSWER_PATTERNS.find((re) => re.test(ans));
        const mustContainAny = step.mustContainAny || null;
        const okMustContain = smokeIncludesAny(ans, mustContainAny);

        const ok = gotHist && ans.length >= minAnswerLen && !badHit && okMustContain;
        // BDD 04/13/2026 - AI smoke metrics for current ask
        if (askMetrics.hadError) ok = false;
        if (!askMetrics.doneMs) ok = false;
        if (!askMetrics.ttftMs) ok = false;

        base.ok = ok;
        base.status = ok ? "pass" : "fail";
        base.details = {
          suggestedIndex: si,
          question: q,
          gotHist,
          answerLen: ans.length,
          answerPreview: smokePreviewText(ans, Number(step.previewLen ?? 280)),
          badPattern: badHit ? String(badHit) : null,
          mustContainAny,
          okMustContain,

          // BDD 04/13/2026 - AI smoke metrics for current ask
          mode: askMetrics.mode,
          ttftMs: askMetrics.ttftMs,
          textDoneMs: askMetrics.textDoneMs,
          doneMs: askMetrics.doneMs,
          firstAudioMs: askMetrics.firstAudioMs,
          hadAudio: askMetrics.hadAudio,
          hadError: askMetrics.hadError,
          errorMessages: askMetrics.errorMessages,
          metrics: askMetrics,

          conversation_id: entry?.conversation_id ?? null,
          assistant_turn_id: entry?.assistant_turn_id ?? null,
          student_message_id: entry?.student_message_id ?? null,
          content_db: entry?.content_db ?? null,
        };

        if (step.storeFullAnswer === true) {
          base.details.answerFull = ans;
        }
      }

      else {
        base.status = "skipped";
        base.ok = true;
        base.details = { note: `Unknown kind '${step.kind}', skipped.` };
      }

    } catch (e) {
      const msg = String(e?.message || e);
      if (msg === "SMOKE_ABORTED") {
        base.status = "aborted";
        base.ok = false;
      } else {
        base.status = "error";
        base.ok = false;
        base.error = msg;
      }
    } finally {
      base.ms = Date.now() - startedAt;
    }

    return base;
  }

  // ✅ Keep latest history available synchronously
  const historyRef = useRef([]);
  useEffect(() => {
    historyRef.current = Array.isArray(history) ? history : [];
  }, [history]);

  // Smoke runner topic context (persists across steps)
const smokeTopicScopeRef = useRef(null);

function setSmokeTopicScopeFromStep(step) {
  // Prefer explicit scope if provided in JSON
  const explicit = step?.topicScope || step?.topic_scope || null;
  if (explicit) {
    smokeTopicScopeRef.current = explicit;
    // Keep your existing AI scope pointer aligned too
    try { activeTopicForAIRef.current = explicit; } catch {}
    return explicit;
  }

  // Otherwise derive from common fields (works with your existing step structure)
  const scope = {
    board_topic_id: step?.topicId ?? step?.board_topic_id ?? null,
    source_topic_id: step?.source_topic_id ?? step?.sourceTopicId ?? null,
    topic_name: step?.topicName ?? step?.topic_name ?? null,
    chapter_id: step?.chapterId ?? step?.chapter_id ?? null,
    chapter_name: step?.chapterName ?? step?.chapter_name ?? null,
  };

  // Only save if we have at least a topic id of some sort
  if (scope.board_topic_id || scope.source_topic_id || scope.topic_name) {
    smokeTopicScopeRef.current = scope;
    try { activeTopicForAIRef.current = scope; } catch {}
    return scope;
  }

  return smokeTopicScopeRef.current;
}

function getSmokeTopicScope(step, plan) {
  return (
    step?.topicScope ||
    step?.topic_scope ||
    plan?.defaults?.topicScope ||
    plan?.defaults?.topic_scope ||
    smokeTopicScopeRef.current ||
    null
  );
}

  async function startSmokeRun() {
  smokeAbortRef.current = false; // ✅ reset abort each run
  setSmokeRunning(true);
  setSmokeLastError(null);

  const plan = SMOKE_TEST_PLAN_V1;
  const out = [];
  setSmokeResults([]);
  smokeResultsRef.current = [];

  try {
    for (let i = 0; i < (plan?.steps || []).length; i++) {
      if (smokeAbortRef.current) break;
      setSmokeStepIndex(i);

      const step = plan.steps[i];
      console.log("[SMOKE] step start", i, step?.kind, step?.name);

      // ✅ pass idx + plan (your runOneSmokeStep signature expects them)
      const res = await runOneSmokeStep(step, i, plan);

      out.push(res);
      smokeResultsRef.current = out;
      setSmokeResults([...out]);

      console.log("[SMOKE] step done", i, res?.status, "total=", out.length);
    }
  } catch (e) {
    console.error("[SMOKE] runner crashed", e);
    setSmokeLastError(String(e?.message || e));
  } finally {
    // AIT-255: never leave media playing once the run ends, errors, or is stopped.
    smokeCleanupRef.current?.({ closeModule: true });
    setSmokeRunning(false);
    if (plan?.auto_download_jsonl) {
      exportSmokeJsonl(plan?.name || "smoke", out);
    }
  }
}

  // AIT-255: stop video + spoken-answer audio, and optionally close the open module.
  function cleanupSmokeMedia({ closeModule = false, retry = true } = {}) {
    stopSmokeMedia({
      getVideo: () => videoRef.current,
      stopAudio: () => stopAudio(),
      speech: typeof window !== "undefined" ? window.speechSynthesis : null,
    });
    // AIT-255: never auto-close while a test is open (closing triggers window.confirm).
    if (closeModule && (showVideo || showPwo) && !(showQuiz && quizMode === "test")) {
      Promise.resolve(handleCloseModule(false))
        .then((closed) => {
          // handleCloseModule returns false when a close is already running / debounced.
          // AIT-255: retry once via the LATEST render's cleanup (re-checks current state; no-op once closed).
          if (closed === false && retry) {
            setTimeout(() => {
              smokeCleanupRef.current?.({ closeModule: true, retry: false });
            }, 100);
          }
        })
        .catch((e) => console.warn("[SMOKE] close on cleanup failed", e));
    }
  }

  smokeCleanupRef.current = cleanupSmokeMedia; // AIT-255: latest render's state/handlers for the async runner

  function stopSmokeRun() {
    smokeAbortRef.current = true;
    // AIT-255: abort an in-flight AI stream so a late answer does not start media.
    if (streamAbortControllerRef.current) {
      try { streamAbortControllerRef.current.abort(); } catch {}
      streamAbortControllerRef.current = null;
    }
    setSmokeRunning(false);
    cleanupSmokeMedia({ closeModule: true });
  }

  // AIT-255: while a smoke run is active, pause the video if the tab is hidden.
  useEffect(() => {
    if (!smokeRunning) return undefined;
    // AIT-255: hidden tab stops video + spoken audio only (never aborts or closes).
    return attachSmokeVisibilityPause({
      getVideo: () => videoRef.current,
      stopAudio: () => stopAudio(),
      speech: typeof window !== "undefined" ? window.speechSynthesis : null,
    });
  }, [smokeRunning]);

  // BDD 02/20/2026 - PWO QA - Grade scope test/healthCheckpwo - start

  // BDD 02/20/2026 smoketest - Smoke Test Runner
  // Mirror important state into refs so async runner can read latest values

  const loadingRef = useRef(false);
  useEffect(() => { loadingRef.current = !!loading; }, [loading]);

  const answerRef = useRef("");
  useEffect(() => { answerRef.current = answer || ""; }, [answer]);

  const pwosRef = useRef([]);
  useEffect(() => { pwosRef.current = Array.isArray(pwos) ? pwos : []; }, [pwos]);

  const videosRef = useRef([]);
  useEffect(() => { videosRef.current = Array.isArray(videos) ? videos : []; }, [videos]);

  const suggestedQuestionsRef = useRef([]);
  useEffect(() => { suggestedQuestionsRef.current = Array.isArray(suggestedQuestions) ? suggestedQuestions : []; }, [suggestedQuestions]);

  // BDD 12/08/2025
  // First chapter (grade asc, then subject/chapter label asc)
  const findFirstChapter = React.useCallback(() => {
    const rows = [];
    for (const level of sortedCurriculum || []) {
      for (const subject of level.subjects || []) {
        for (const chap of subject.chapters || []) {
          rows.push({
            levelId: level.id,
            grade: level.grade,
            subjectId: subject.id,
            subjectName: labelForCurriculumNode(subject),
            chapterId: chap.id,
            chapterName: labelForCurriculumNode(chap),
          });
        }
      }
    }
    rows.sort((a, b) =>
      parseGradeNum(a.grade) - parseGradeNum(b.grade) ||
      String(a.subjectName).localeCompare(String(b.subjectName)) ||
      String(a.chapterName).localeCompare(String(b.chapterName))
    );
    return rows[0] || null;
  }, [sortedCurriculum]);

  useEffect(() => {
    if (!curriculumView || !sortedCurriculum?.length) return;

    // Skip restore if an explicit navigation (e.g. resume from dashboard) recently set selectedChapter
    if (Date.now() < skipChapterRestoreUntilRef.current) {
      return;
    }

    (async () => {
      // 1) selection: restore if valid, else choose first chapter
      const saved = await storage.get(LAST_CHAPTER_KEY);
      let candidate = null;

      // BDD 12/08/2025
      if (saved?.subjectId && saved?.chapterId) {
        const hit = findChapterPath(({ subject, chap }) =>
          subject.id === saved.subjectId && chap.id === saved.chapterId
        );
        if (hit) {
          candidate = {
            levelId: hit.level.id,
            subjectId: hit.subject.id,
            subjectName: labelForCurriculumNode(hit.subject),
            chapterId: hit.chap.id,
            chapterName: labelForCurriculumNode(hit.chap),
          };
        }
      }

      if (!candidate) candidate = findFirstChapter();
      if (candidate) {
        setSelectedChapter(candidate);
        // Only switch to learning if user is already on a learning-related module
        // (preserve home, testQuestions, teacherDashboard, collections, manageStudents on refresh)
        const nonLearningModules = ["home", "testQuestions", "teacherDashboard", "collections", "manageStudents"];
        if (!nonLearningModules.includes(activeModuleRef.current)) {
          setActiveModule("learning");
        }
        ensureExpandedForChapter(candidate.levelId, candidate.subjectId, candidate.chapterId);
      }

      // 2) scroll: restore
      const y = await storage.get(SIDEBAR_SCROLL_KEY);
      if (y != null && sidebarScrollRef.current?.scrollTo) {
        requestAnimationFrame(() => {
          sidebarScrollRef.current.scrollTo({ y, animated: false });
          sidebarScrollYRef.current = y;
        });
      }
    })();
  }, [curriculumView, sortedCurriculum, currentCurriculum, ensureExpandedForChapter, findFirstChapter, findChapterPath]);
  // BDD 03/18/2026 - DEBUG
  const DEBUG_VIDEO_CHAPTER = false;
  const DEBUG_CHAPTER_ID = 341;

  const isDebugChapterSelected =
    DEBUG_VIDEO_CHAPTER &&
    selectedChapter?.chapterId != null &&
    String(selectedChapter.chapterId) === String(DEBUG_CHAPTER_ID);

  const summarizeVideoRaw = (raw) => {
    if (!raw) return "null";
    if (Array.isArray(raw)) return `array(len=${raw.length})`;

    const keys = Object.keys(raw || {});
    const segs = Array.isArray(raw?.segments) ? raw.segments.length : "n/a";
    const items = Array.isArray(raw?.items) ? raw.items.length : "n/a";

    return `object(keys=${keys.join(",")}, segments=${segs}, items=${items})`;
  };
  
  // BDD 10/17/2025 - try 2
  // Normalize the variety of shapes we may get back from the store
  const countFrom = (raw, kind /* "video" | "pwo" */) => {
    if (!raw) return 0;
    if (Array.isArray(raw)) return raw.length;
    if (kind === "video") {
      if (Array.isArray(raw.segments)) return raw.segments.length;
      if (Array.isArray(raw.items)) return raw.items.length;
    } else {
      if (Array.isArray(raw.scenes)) return raw.scenes.length;
      if (Array.isArray(raw.items)) return raw.items.length;
    }
    return 0;
  };

  const lookupCountsForTopic = (boardId, sourceId) => {
    const key = `${String(boardId)}|${String(sourceId)}`;
    const vRaw = videoTopicMap?.[key];
    const pRaw = pwoTopicMap?.[key];
    return {
      videoCount: countFrom(vRaw, "video"),
      pwoCount: countFrom(pRaw, "pwo"),
    };
  };

  // BDD 12/08/2025
  const topicsFlatForChapter = useMemo(() => {
    if (!curriculumView || !selectedChapter) return [];

    // 🔹 Helper: prefer localized display_name, then fallback to name
    const labelOf = (node) =>
      (node?.display_name || node?.displayName || node?.name || "").trim();

    // Find the concrete nodes for the chosen chapter
    const level = (curriculum || []).find(l => l.id === selectedChapter.levelId);
    const subject = level?.subjects?.find(s => s.id === selectedChapter.subjectId);
    const chapter = subject?.chapters?.find(c => c.id === selectedChapter.chapterId);

    if (!chapter?.topics?.length) return [];

    console.log('[DEBUG] chapter opened:', chapter.name || chapter.display_name, 'topics:', chapter.topics.length,
      chapter.topics.map(t => ({ id: t.id, source_id: t.source_id, name: t.name || t.display_name }))
    );

    const out = [];
    for (const topic of chapter.topics) {
      const boardId = topic.id;        // curriculum tree gives real board topic id here
      const sourceId = topic.source_id; // source_topic_id in your DB

      const { videoCount, pwoCount } = lookupCountsForTopic(boardId, sourceId);
      const quizCount = quizCountMap?.[String(sourceId)] ?? 0;

      out.push({
        topicId: boardId,                   // what your pickers typically take for curriculum
        boardTopicId: boardId,
        sourceTopicId: sourceId,

        // 🔻 CHANGED: use localized labels from curriculum tree
        topicName: labelOf(topic),
        subjectName: labelOf(subject),
        chapterName: labelOf(chapter),

        topicImagePath: topic.topic_image_path || null,
        subjectId: selectedChapter.subjectId,
        chapterId: selectedChapter.chapterId,
        videoCount,
        pwoCount,
        quizCount,
      });
    }
    return out;
    // IMPORTANT: depend on the maps so we recompute when they load
  }, [
    curriculumView,
    selectedChapter?.levelId,
    selectedChapter?.subjectId,
    selectedChapter?.chapterId,
    curriculum,
    videoTopicMap,
    pwoTopicMap,
    quizCountMap
  ]);

  // BDD 12/08/2025
  const topicsFlatForChapterWithCounts = React.useMemo(() => {
    const qc = quizCountMap || {};

    return (Array.isArray(topicsFlatForChapter) ? topicsFlatForChapter : []).map((it) => {
      // 🔹 Prefer localized label if present
      const label = (
        it.display_name ||      // from backend/localize_curriculum_tree
        it.displayName ||       // if something upstream already used camelCase
        it.topicName ||         // old field
        it.name ||              // extra fallback
        ""
      ).trim();

      return {
        ...it,
        // ensure TopicCard sees the localized label
        topicName: label,
        displayName: label,

        // keep your counts logic as-is
        videoCount: chapterCounts[it.topicId]?.video ?? it.videoCount ?? 0,
        pwoCount: chapterCounts[it.topicId]?.pwo ?? it.pwoCount ?? 0,
        quizCount: qc[it.sourceTopicId] ?? it.quizCount ?? 0,
      };
    });
  }, [topicsFlatForChapter, chapterCounts, quizCountMap]);

  // BDD 10/04/2026 - Chapter Learning Path prototype.
  // Flag OFF or no authored path => the existing Topic tile UI remains untouched.
  const activeChapterLearningPath = React.useMemo(() => {
    if (!flags?.chapter_learning_path || !selectedChapter) return null;
    return resolveChapterLearningPath({
      contentDb,
      subjectName: selectedChapter?.subjectName,
      chapterName: selectedChapter?.chapterName || selectedChapter?.name,
    });
  }, [
    flags?.chapter_learning_path,
    contentDb,
    selectedChapter?.subjectName,
    selectedChapter?.chapterName,
    selectedChapter?.name,
  ]);

  // BDD 03/16/2026 - DEBUG
  // useEffect(() => {
  //   if (!isDebugChapterSelected) return;

  //   const rows = (Array.isArray(topicsFlatForChapterWithCounts) ? topicsFlatForChapterWithCounts : []).map((it) => {
  //     const key = `${String(it.boardTopicId)}|${String(it.sourceTopicId)}`;
  //     const vRaw = videoTopicMap?.[key];

  //     return {
  //       topicName: it.topicName,
  //       boardTopicId: it.boardTopicId,
  //       sourceTopicId: it.sourceTopicId,
  //       key,
  //       hasVideoKey: !!vRaw,
  //       videoShape: summarizeVideoRaw(vRaw),
  //       videoCount_lookup: countFrom(vRaw, "video"),
  //       videoCount_final: it.videoCount ?? 0,
  //       pwoCount_final: it.pwoCount ?? 0,
  //       quizCount_final: it.quizCount ?? 0,
  //     };
  //   });

  //   // BDD 03/18/2026 - Debug Video PKL Reference Search
  //   // console.log("====================================================");
  //   // console.log("[UI DEBUG] Selected chapter 341");
  //   // console.log({
  //   //   selectedChapter,
  //   //   topicCount: rows.length,
  //   // });
  //   // console.table(rows);

  //   // const zeroVideoRows = rows.filter(r => Number(r.videoCount_final || 0) === 0);
  //   // if (zeroVideoRows.length) {
  //   //   console.log("[UI DEBUG] Topics in chapter 341 with zero final videoCount:");
  //   //   console.table(zeroVideoRows);
  //   // }

  //   // console.log("====================================================");
  // }, [
  //   isDebugChapterSelected,
  //   selectedChapter,
  //   topicsFlatForChapterWithCounts,
  //   videoTopicMap
  // ]);

  // BDD 10/13/2025
  const SideModal = ({
    visible,
    onRequestClose,
    side = "right",            // "right" | "left"
    isDarkMode,
    widthFraction = 0.44,      // ~44% of viewport, clamped below
    children,
  }) => {
    const { width } = useWindowDimensions();

    // Mobile/Tablet friendly: use full width on narrow screens
    const isMobile = width < 768;  // Tablet breakpoint
    const isTablet = width >= 768 && width < 1024;  // Tablet range

    // Responsive width calculation:
    // - Mobile: 100% width (full overlay)
    // - Tablet: 85% width
    // - Desktop: 44% width (max 95% for high zoom)
    const sheetWidth = isMobile
      ? width  // Full width on mobile
      : isTablet
        ? Math.floor(width * 0.85)  // 85% on tablet
        : Math.min(
          Math.floor(width * 0.95),  // Max 95% of viewport for high zoom
          Math.max(320, Math.floor(width * widthFraction))  // Desktop: 44%
        );

    const offscreen = side === "right" ? sheetWidth : -sheetWidth;

    const slide = React.useRef(new Animated.Value(offscreen)).current;

    React.useEffect(() => {
      Animated.timing(slide, {
        toValue: visible ? 0 : offscreen,
        duration: 220,
        easing: Easing.out(Easing.cubic),
        useNativeDriver: Platform.OS !== "web",
      }).start();
    }, [visible, offscreen, slide]);

    // Esc to close (web)
    React.useEffect(() => {
      if (!visible || Platform.OS !== "web") return;
      const onKey = (e) => { if (e.key === "Escape") onRequestClose?.(); };
      window.addEventListener("keydown", onKey);
      return () => window.removeEventListener("keydown", onKey);
    }, [visible, onRequestClose]);

    // Darker backdrop on mobile/tablet to make it obvious you can tap to dismiss
    const backdropOpacity = isMobile ? 0.5 : isTablet ? 0.45 : 0.35;

    return (
      <Modal
        visible={!!visible}
        transparent
        animationType="fade"
        onRequestClose={onRequestClose}
        statusBarTranslucent
      >
        {/* Backdrop catches outside taps - darker on mobile/tablet */}
        <TouchableWithoutFeedback onPress={onRequestClose}>
          <View style={[StyleSheet.absoluteFillObject, { zIndex: 2147483600, backgroundColor: `rgba(0,0,0,${backdropOpacity})` }]}>
            {/* Prevent backdrop closing when tapping inside the panel */}
            <TouchableWithoutFeedback>
              <Animated.View
                onStartShouldSetResponderCapture={() => true}
                onMoveShouldSetResponderCapture={() => true}
                style={{
                  position: "absolute",
                  top: 0, bottom: 0,
                  [side]: 0,
                  width: sheetWidth,
                  transform: [{ translateX: slide }],
                  backgroundColor: isDarkMode ? "#0c1220" : "#fff",
                  borderLeftWidth: side === "right" ? StyleSheet.hairlineWidth : 0,
                  borderRightWidth: side === "left" ? StyleSheet.hairlineWidth : 0,
                  borderColor: isDarkMode ? "#2b395a" : "#e5eaf4",
                  shadowColor: "#000",
                  shadowOpacity: 0.22,
                  shadowRadius: 16,
                  shadowOffset: { width: 0, height: 4 },
                  // zIndex: 2,
                  zIndex: 2147483602,                         // ← above everything
                  ...(Platform.OS === "web" ? { outlineStyle: "none" } : null),
                }}
              >
                {children}
              </Animated.View>
            </TouchableWithoutFeedback>
          </View>
        </TouchableWithoutFeedback>
      </Modal>
    );
  };
  // BDD 10/13/2025
  const HistoryModal = ({
    open, onClose, isDarkMode, items, activeCollectionName,
    renderHistorySection, handleVideoClick, handlePWOClick, authToken, styles, t
  }) => (
    <SideModal visible={open} onRequestClose={onClose} side="right" isDarkMode={isDarkMode}>
      <View style={{ padding: 14, borderBottomWidth: StyleSheet.hairlineWidth, borderColor: isDarkMode ? "#203055" : "#e3e8f2" }}>
        <Text style={{ fontWeight: "700", fontSize: rem(16) + 'rem', color: isDarkMode ? "#dbe6ff" : "#122b53" }}>
          🕓 {t ? t("History") : "History"} — {activeCollectionName || (t ? t("No module selected") : "No module selected")}
        </Text>
        <TouchableOpacity onPress={onClose} style={{ position: "absolute", top: 10, right: 10, padding: 6 }}>
          <MaterialCommunityIcons name="close" size={20} color={isDarkMode ? "#cfe0ff" : "#334155"} />
        </TouchableOpacity>
      </View>

      <ScrollView
        contentContainerStyle={{ padding: 12 }}
        keyboardShouldPersistTaps="handled"
        nestedScrollEnabled
        showsVerticalScrollIndicator
      >
        {(items && items.length > 0)
          ? renderHistorySection(
            items,
            isDarkMode,
            // auto-close when launching items:
            (...args) => { onClose?.(); handleVideoClick(...args); },
            (...args) => { onClose?.(); handlePWOClick(...args); },
            authToken,
            styles
          )
          : <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>
            {(t ? t("No history for this module yet.") : "No history for this module yet.")}
          </Text>
        }
      </ScrollView>
    </SideModal>
  );
  // BDD 10/13/2025
  const InsightsModal = ({
    open, onClose, isDarkMode,
    assessments, adaptiveRecommendation,
    engagementLogs, leaderboard, badges,
    styles, t, formatLocalDate, user_id, user_name, userRank, user_score
  }) => (
    <SideModal visible={open} onRequestClose={onClose} side="right" isDarkMode={isDarkMode}>
      <View style={{ padding: 14, borderBottomWidth: StyleSheet.hairlineWidth, borderColor: isDarkMode ? "#203055" : "#e3e8f2" }}>
        <Text style={{ fontWeight: "700", fontSize: rem(16) + 'rem', color: isDarkMode ? "#dbe6ff" : "#122b53" }}>📊 {t("Insights")}</Text>
        <TouchableOpacity {...makeWebTap(onClose)} style={{ position: "absolute", top: 10, right: 10, padding: 6 }}>
          <MaterialCommunityIcons name="close" size={20} color={isDarkMode ? "#cfe0ff" : "#334155"} />
        </TouchableOpacity>
      </View>

      <ScrollView
        contentContainerStyle={{ padding: 12, gap: 12 }}
        keyboardShouldPersistTaps="handled"
        nestedScrollEnabled
        showsVerticalScrollIndicator
      >
        {/* Performance Analytics */}
        <View style={{
          padding: 12, borderRadius: 12,
          backgroundColor: isDarkMode ? "rgba(16,27,50,0.9)" : "#f8fbff",
          borderWidth: StyleSheet.hairlineWidth,
          borderColor: isDarkMode ? "#223252" : "#dfe8f7"
        }}>
          <Text style={{ fontWeight: "700", marginBottom: 8, color: isDarkMode ? "#dbe6ff" : "#102a52" }}>
            {t("Performance Analytics")}
          </Text>
          {assessments?.length ? assessments.map((a, i) => (
            <View key={i} style={{ marginBottom: 10, padding: 10, borderRadius: 10, backgroundColor: isDarkMode ? "#0b1324" : "#ffffff", borderWidth: StyleSheet.hairlineWidth, borderColor: isDarkMode ? "#24314f" : "#e6eefb" }}>
              <Text style={{ fontWeight: "600", color: isDarkMode ? "#d8e3ff" : "#1b325c" }}>
                {a.subject} — {a.chapter} — {a.topic}
              </Text>
              <Text style={{ marginTop: 4, color: isDarkMode ? "#b8c7ea" : "#314a7a" }}>
                🎯 {t("Score")}: {a.score}/{a.total_score} ({a.accuracy}%)
              </Text>
              <Text style={{ marginTop: 2, color: isDarkMode ? "#9db0d8" : "#4b5e84" }}>
                📅 {t("Taken On")}: {a.completed_at ? formatLocalDate(a.completed_at) : "N/A"}
              </Text>
            </View>
          )) : (
            <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>{t("No assessment data available.")}</Text>
          )}
          {!!adaptiveRecommendation && (
            <Text style={{ marginTop: 8, color: isDarkMode ? "#cfe0ff" : "#1a2f58" }}>{adaptiveRecommendation}</Text>
          )}
        </View>

        {/* Engagement & Leaderboard */}
        <View style={{
          padding: 12, borderRadius: 12,
          backgroundColor: isDarkMode ? "rgba(16,27,50,0.9)" : "#f8fbff",
          borderWidth: StyleSheet.hairlineWidth,
          borderColor: isDarkMode ? "#223252" : "#dfe8f7"
        }}>
          <Text style={{ fontWeight: "700", marginBottom: 8, color: isDarkMode ? "#dbe6ff" : "#102a52" }}>
            {t("Engagement & Leaderboard")}
          </Text>

          {engagementLogs?.length ? engagementLogs.slice().sort((a, b) => new Date(b.last_active) - new Date(a.last_active)).map((log, i) => (
            <View key={i} style={{ marginBottom: 8 }}>
              <Text style={{ color: isDarkMode ? "#cfe0ff" : "#1b325c" }}>
                📅 {t("Last Active")}: {formatLocalDate(log.last_active)}
              </Text>
              <Text style={{ color: isDarkMode ? "#b8c7ea" : "#314a7a" }}>👆 {t("Touch Points")}: {log.clicks}</Text>
              <Text style={{ color: isDarkMode ? "#b8c7ea" : "#314a7a" }}>📝 {t("Quiz Attempts")}: {log.quiz_attempts}</Text>
              <Text style={{ color: isDarkMode ? "#b8c7ea" : "#314a7a" }}>🎯 {t("Accuracy")}: {log.accuracy ? `${log.accuracy.toFixed(2)}%` : "N/A"}</Text>
            </View>
          )) : <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>{t("No engagement data available.")}</Text>}

          <View style={{ marginTop: 10 }}>
            <Text style={{ fontWeight: "700", color: isDarkMode ? "#dbe6ff" : "#102a52" }}>🏆 {t("Leaderboard")}</Text>
            {leaderboard?.length ? leaderboard.slice(0, 10).map((entry, idx) => (
              <View key={idx} style={{ flexDirection: "row", justifyContent: "space-between", paddingVertical: 6 }}>
                <Text style={{ color: isDarkMode ? "#cfe0ff" : "#1b325c" }}>#{idx + 1}</Text>
                <Text style={{ color: isDarkMode ? "#cfe0ff" : "#1b325c" }}>{entry.email === user_id ? entry.name : ""}</Text>
                <Text style={{ color: isDarkMode ? "#b8c7ea" : "#314a7a" }}>{entry.total_score.toFixed(2)} pts</Text>
              </View>
            )) : <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>{t("No leaderboard data available.")}</Text>}
            {leaderboard?.length > 10 && (
              <View style={{ flexDirection: "row", justifyContent: "space-between", paddingVertical: 6 }}>
                <Text style={{ color: isDarkMode ? "#cfe0ff" : "#1b325c" }}>#{userRank}</Text>
                <Text style={{ color: isDarkMode ? "#cfe0ff" : "#1b325c" }}>{user_name}</Text>
                <Text style={{ color: isDarkMode ? "#b8c7ea" : "#314a7a" }}>{user_score?.toFixed(2)} pts</Text>
              </View>
            )}
          </View>

          {/* Badges */}
          <View style={{ marginTop: 10 }}>
            <Text style={{ fontWeight: "700", color: isDarkMode ? "#dbe6ff" : "#102a52" }}>🎖️ {t("Earned Badges")}</Text>
            {badges?.length ? badges.filter(b => b?.name).map((badge, i) => (
              <View key={i} style={{ marginTop: 6, backgroundColor: isDarkMode ? "#0b1324" : "#fff", borderRadius: 10, padding: 8, borderWidth: StyleSheet.hairlineWidth, borderColor: isDarkMode ? "#24314f" : "#e6eefb" }}>
                <Text style={{ color: isDarkMode ? "#cfe0ff" : "#1b325c" }}>{badgeDisplayName(badge, t)}</Text>
              </View>
            )) : <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>{t("No badges earned yet.")}</Text>}
          </View>
        </View>
      </ScrollView>
    </SideModal>
  );
  // BDD 10/13/2025
  const LauncherModal = ({
    open, onClose, isDarkMode,
    activeTab, setActiveTab,
    availableCollections, openStudentCollection, clearStudentCollection, activeStudyCollection,
    availableTests, startStudentTest, myTestResults, handleSelectPastTestResult,
    t, formatLocalDate, PDF_BASE_URL, Platform, Linking,
    setCurriculumView, setActiveModule,
  }) => (
    <SideModal visible={open} onRequestClose={onClose} side="left" isDarkMode={isDarkMode}>
      <View style={{ padding: 14, borderBottomWidth: StyleSheet.hairlineWidth, borderColor: isDarkMode ? "#203055" : "#e3e8f2" }}>
        <Text style={{ fontWeight: "700", fontSize: rem(16) + 'rem', color: isDarkMode ? "#dbe6ff" : "#122b53" }}>🚀 {t("Launcher")}</Text>
        <TouchableOpacity onPress={onClose} style={{ position: "absolute", top: 10, right: 10, padding: 6 }}>
          <MaterialCommunityIcons name="close" size={20} color={isDarkMode ? "#cfe0ff" : "#334155"} />
        </TouchableOpacity>

        <View style={{ flexDirection: "row", marginTop: 10, gap: 8 }}>
          <TouchableOpacity
            onPress={() => setActiveTab("modules")}
            style={{
              paddingVertical: 6, paddingHorizontal: 12, borderRadius: 999,
              backgroundColor: activeTab === "modules" ? (isDarkMode ? "#1a2a4e" : "#e8f1ff") : "transparent",
              borderWidth: StyleSheet.hairlineWidth,
              borderColor: isDarkMode ? "#2a3b63" : "#cfe0ff",
            }}
          >
            <Text style={{ fontWeight: "600", color: isDarkMode ? "#dbe6ff" : "#1b345e" }}>{t("Modules")}</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => setActiveTab("tests")}
            style={{
              paddingVertical: 6, paddingHorizontal: 12, borderRadius: 999,
              backgroundColor: activeTab === "tests" ? (isDarkMode ? "#1a2a4e" : "#e8f1ff") : "transparent",
              borderWidth: StyleSheet.hairlineWidth,
              borderColor: isDarkMode ? "#2a3b63" : "#cfe0ff",
            }}
          >
            <Text style={{ fontWeight: "600", color: isDarkMode ? "#dbe6ff" : "#1b345e" }}>{t("Tests")}</Text>
          </TouchableOpacity>
        </View>
      </View>

      {activeTab === "modules" ? (
        <ScrollView
          contentContainerStyle={{ padding: 12 }}
          keyboardShouldPersistTaps="handled"
          nestedScrollEnabled
          showsVerticalScrollIndicator
        >
          <Text style={{ fontWeight: "700", marginBottom: 8, color: isDarkMode ? "#dbe6ff" : "#102a52" }}>
            📦 {t("Available Learning Modules")}
          </Text>

          {(availableCollections || []).length ? (
            <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 10 }}>
              {availableCollections.map((col) => {
                const isSelected = activeStudyCollection && String(activeStudyCollection.id) === String(col.id);
                return (
                <TouchableOpacity
                  key={col.id}
                  {...makeWebTap(() => {
                    if (isSelected) {
                      clearStudentCollection();
                    } else {
                      openStudentCollection(col);
                      userHasSavedPreferenceRef.current = true;
                      setViewMode("collections");
                      setActiveModule("learning");
                    }
                    onClose?.();
                  })}
                  accessibilityRole="button"
                  accessibilityLabel={col.name}
                  style={{
                    width: "100%",
                    backgroundColor: isSelected
                      ? (isDarkMode ? "#1a2a4e" : "#e8f1ff")
                      : (isDarkMode ? "#0b1324" : "#fff"),
                    borderRadius: 12, padding: 10,
                    borderWidth: isSelected ? 2 : StyleSheet.hairlineWidth,
                    borderColor: isSelected
                      ? (isDarkMode ? "#60a5fa" : "#3B82F6")
                      : (isDarkMode ? "#24314f" : "#e6eefb")
                  }}
                >
                  <Text style={{ fontWeight: "700", color: isDarkMode ? "#d8e3ff" : "#1b325c" }}>{col.name}</Text>
                  <View style={{ flexDirection: "row", alignItems: "center", marginTop: 4, gap: 8 }}>
                    <Text style={{ color: isDarkMode ? "#9db0d8" : "#4b5e84" }}>{col.base_board?.toUpperCase()}</Text>
                  </View>
                </TouchableOpacity>
                );
              })}
            </View>
          ) : (
            <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>{t("No Learning Modules available right now.")}</Text>
          )}
        </ScrollView>
      ) : (
        <ScrollView
          contentContainerStyle={{ padding: 12 }}
          keyboardShouldPersistTaps="handled"
          nestedScrollEnabled
          showsVerticalScrollIndicator
        >
          <Text style={{ fontWeight: "700", marginBottom: 8, color: isDarkMode ? "#dbe6ff" : "#102a52" }}>
            🧪 {t("Available Tests")}
          </Text>

          {availableTests?.length ? availableTests.map((test) => (
            <TouchableOpacity
              key={test.id}
              {...makeWebTap(() => { startStudentTest(test.id); onClose?.(); })}
              accessibilityRole="button"
              accessibilityLabel={test.title}
              style={{
                backgroundColor: isDarkMode ? "#0b1324" : "#fff",
                borderRadius: 12, padding: 10,
                borderWidth: StyleSheet.hairlineWidth, borderColor: isDarkMode ? "#24314f" : "#e6eefb",
                marginBottom: 8
              }}
            >
              <Text style={{ fontWeight: "700", color: isDarkMode ? "#d8e3ff" : "#1b325c" }}>{test.title}</Text>
              <Text style={{ marginTop: 4, color: isDarkMode ? "#9db0d8" : "#4b5e84" }}>
                {test.start_time ? formatLocalDate(test.start_time) : "N/A"}
              </Text>
            </TouchableOpacity>
          )) : <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>{t("No available tests at this time.")}</Text>}


          <View style={{ marginTop: 16 }}>
            <Text style={{ fontWeight: "700", marginBottom: 8, color: isDarkMode ? "#dbe6ff" : "#102a52" }}>
              📊 {t("My Test Results")}
            </Text>
            {myTestResults?.length ? myTestResults.map((result) => (
              <TouchableOpacity
                key={result.id}
                {...makeWebTap(() => { handleSelectPastTestResult(result); onClose?.(); })}
                accessibilityRole="button"
                accessibilityLabel={result.test_title}
                style={{
                  backgroundColor: isDarkMode ? "#0b1324" : "#fff",
                  borderRadius: 12, padding: 10,
                  borderWidth: StyleSheet.hairlineWidth, borderColor: isDarkMode ? "#24314f" : "#e6eefb",
                  marginBottom: 8
                }}
              >
                <Text style={{ color: isDarkMode ? "#d8e3ff" : "#1b325c" }}>{t("Test:")} {result.test_title}</Text>
                <Text style={{ color: isDarkMode ? "#b8c7ea" : "#314a7a" }}>{t("Score:")} {result.score} / {result.total_score}</Text>
                <Text style={{ color: isDarkMode ? "#9db0d8" : "#4b5e84" }}>
                  {t("Submitted on:")} {result.completed_at ? formatLocalDate(result.completed_at) : "N/A"}
                </Text>

                {result.pdf_path && (
                  <TouchableOpacity
                    onPress={() => {
                      const url = `${PDF_BASE_URL}/${result.pdf_path}`;
                      if (Platform.OS === "web") window.open(url, "_blank");
                      else Linking.openURL(url);
                    }}
                    style={{ marginTop: 6 }}
                  >
                    <Text style={{ color: "#007BFF" }}>📄 {t("View Submitted PDF")}</Text>
                  </TouchableOpacity>
                )}

                {result.graded_pdf_path && (
                  <TouchableOpacity
                    onPress={() => {
                      const url = `${PDF_BASE_URL}/${result.graded_pdf_path}`;
                      if (Platform.OS === "web") window.open(url, "_blank");
                      else Linking.openURL(url);
                    }}
                    style={{ marginTop: 6 }}
                  >
                    <Text style={{ color: "#28a745" }}>📄 {t("View Graded PDF")}</Text>
                  </TouchableOpacity>
                )}
              </TouchableOpacity>
            )) : <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>{t("No test results available.")}</Text>}
          </View>


          {/* BDD 02/03/2026 student-practice-test-phase1 */}
          <Text style={{ fontWeight: "bold", marginTop: 10 }}>🧩 My Practice Tests</Text>
          {(myPracticeTests || []).length === 0 ? (
            <Text style={{ opacity: 0.7 }}>No practice tests yet.</Text>
          ) : (
            (myPracticeTests || []).map((t) => (
              <TouchableOpacity
                key={t.id}
                onPress={() => {
                  setActiveTest(t);
                  setQuizMode("test");
                  setShowQuiz(false); // AIT-253: pre-start view, not a running test
                  setTestReadyToStart(true);
                }}
                style={{ padding: 10, borderWidth: 1, borderColor: "#eee", borderRadius: 10, marginTop: 8, backgroundColor: "#fff" }}
              >
                <Text style={{ fontWeight: "700" }}>{t.title}</Text>
                <Text style={{ fontSize: 12, opacity: 0.7 }}>
                  {t.duration_minutes ? `${t.duration_minutes} min` : "Untimed"} • Created {t.created_at ? formatLocalDate(t.created_at) : ""}
                </Text>
              </TouchableOpacity>
            ))
          )}

          {/* BDD 02/03/2026 student-practice-test-phase1 */}
          {/* BDD 02/03/2026 student-practice-test-phase1 - try4 */}
          <View style={{ padding: 12, borderWidth: 1, borderColor: "#e5e7eb", borderRadius: 12, marginBottom: 12 }}>
            <Text style={{ fontWeight: "700", marginBottom: 8 }}>⚡ Quick Practice</Text>

            <Picker
              selectedValue={practiceSubjectKey}
              onValueChange={(val) => {
                setPracticeSubjectKey(val);

                const match = (practiceSubjects || []).find((x) => String(x.key) === String(val));
                setPracticeSubjectId(match?.id || "");
                setPracticeSubjectName(match?.name || "");

                // chapters for UX only (backend still resolves topics)
                setPracticeChapters(Array.isArray(match?.chapters) ? match.chapters : []);
                setPracticeChapterMode("all");
                setPracticeSelectedChapterIds([]);
              }}
            >
              <Picker.Item label={t("Select a subject")} value="" />
              {(practiceSubjects || []).map((s) => (
                <Picker.Item key={String(s.key)} label={s.label} value={String(s.key)} />
              ))}
            </Picker>

            <Text style={{ fontSize: 12, marginTop: 8, marginBottom: 4 }}># Questions</Text>
            <Picker selectedValue={practiceTotal} onValueChange={setPracticeTotal} style={{ backgroundColor: "#fff" }}>
              {[10, 15, 20, 25].map(n => <Picker.Item key={n} label={`${n}`} value={n} />)}
            </Picker>

            <Text style={{ fontSize: 12, marginTop: 8, marginBottom: 4 }}>Difficulty</Text>
            <Picker selectedValue={practiceMix} onValueChange={setPracticeMix} style={{ backgroundColor: "#fff" }}>
              <Picker.Item label="Balanced" value="balanced" />
              <Picker.Item label="Easy-heavy" value="easy_heavy" />
              <Picker.Item label="Hard-heavy" value="hard_heavy" />
            </Picker>

            <Text style={{ marginTop: 10, fontSize: 12, color: isDarkMode ? "#94a3b8" : "#64748b" }}>
              {t("Test Name (optional)")}
            </Text>

            <View style={{
              marginTop: 6,
              borderRadius: 10,
              borderWidth: 1,
              borderColor: isDarkMode ? "rgba(148,163,184,0.22)" : "rgba(148,163,184,0.35)",
              backgroundColor: isDarkMode ? "rgba(2,6,23,0.35)" : "#fff",
              paddingHorizontal: 10,
            }}>
              <TextInput
                value={practiceTitle}
                onChangeText={setPracticeTitle}
                placeholder={t("e.g., Biology – Chapter 3 Practice")}
                placeholderTextColor={isDarkMode ? "rgba(148,163,184,0.8)" : "rgba(100,116,139,0.8)"}
                style={{ height: 44, color: isDarkMode ? "#e2e8f0" : "#0f172a" }}
              />
            </View>

            {!!practiceChapters?.length && (
              <>
                <Text style={{ marginTop: 10, fontSize: 12, color: isDarkMode ? "#94a3b8" : "#64748b" }}>
                  {t("Chapters")}
                </Text>

                <View style={{ flexDirection: "row", gap: 8, marginTop: 6 }}>
                  <TouchableOpacity
                    onPress={() => { setPracticeChapterMode("all"); setPracticeSelectedChapterIds([]); }}
                    style={{
                      flex: 1,
                      paddingVertical: 8,
                      borderRadius: 10,
                      alignItems: "center",
                      borderWidth: 1,
                      borderColor: isDarkMode ? "rgba(148,163,184,0.22)" : "rgba(148,163,184,0.35)",
                      backgroundColor: practiceChapterMode === "all"
                        ? (isDarkMode ? "rgba(99,102,241,0.25)" : "rgba(99,102,241,0.18)")
                        : "transparent",
                    }}
                  >
                    <Text style={{ fontWeight: "700", color: isDarkMode ? "#e2e8f0" : "#0f172a" }}>
                      {t("All")}
                    </Text>
                  </TouchableOpacity>

                  <TouchableOpacity
                    onPress={() => setPracticeChapterMode("custom")}
                    style={{
                      flex: 1,
                      paddingVertical: 8,
                      borderRadius: 10,
                      alignItems: "center",
                      borderWidth: 1,
                      borderColor: isDarkMode ? "rgba(148,163,184,0.22)" : "rgba(148,163,184,0.35)",
                      backgroundColor: practiceChapterMode === "custom"
                        ? (isDarkMode ? "rgba(99,102,241,0.25)" : "rgba(99,102,241,0.18)")
                        : "transparent",
                    }}
                  >
                    <Text style={{ fontWeight: "700", color: isDarkMode ? "#e2e8f0" : "#0f172a" }}>
                      {t("Select")}
                    </Text>
                  </TouchableOpacity>
                </View>

                {practiceChapterMode === "custom" && (
                  <View style={{ marginTop: 8, maxHeight: 160 }}>
                    <ScrollView>
                      {(practiceChapters || []).map((ch) => {
                        const cid = Number(ch.chapter_id);
                        const checked = practiceSelectedChapterIds.includes(cid);
                        return (
                          <TouchableOpacity
                            key={String(cid)}
                            onPress={() => {
                              setPracticeSelectedChapterIds((prev) => {
                                if (prev.includes(cid)) return prev.filter((x) => x !== cid);
                                return [...prev, cid];
                              });
                            }}
                            style={{
                              paddingVertical: 8,
                              paddingHorizontal: 10,
                              borderRadius: 10,
                              marginBottom: 6,
                              borderWidth: 1,
                              borderColor: isDarkMode ? "rgba(148,163,184,0.16)" : "rgba(148,163,184,0.25)",
                              backgroundColor: checked
                                ? (isDarkMode ? "rgba(34,197,94,0.12)" : "rgba(34,197,94,0.10)")
                                : (isDarkMode ? "rgba(2,6,23,0.18)" : "rgba(255,255,255,0.7)"),
                            }}
                          >
                            <Text style={{ color: isDarkMode ? "#e2e8f0" : "#0f172a", fontWeight: checked ? "800" : "600" }}>
                              {checked ? "✓ " : ""}{ch.chapter_name}
                            </Text>
                          </TouchableOpacity>
                        );
                      })}
                    </ScrollView>
                  </View>
                )}
              </>
            )}

            <Button
              mode="contained"
              onPress={async () => {
                try {
                  const chapter_ids =
                    practiceChapterMode === "custom"
                      ? practiceSelectedChapterIds
                      : null;

                  const payload = {
                    student_email: user_id,
                    subject_id: Number(practiceSubjectId),
                    subject_name: practiceSubjectName,
                    title: practiceTitle?.trim() || null,     // ✅ optional
                    chapter_ids: (chapter_ids && chapter_ids.length) ? chapter_ids : null, // ✅ optional
                    total_questions: practiceTotal,
                    difficulty_mix: practiceMix,
                    language_id: 1,
                    timed: false,
                  };

                  const res = await axios.post(`${FASTAPI_BASE_URL}/practice_tests/quick_create`, payload);
                  const newTest = res.data.test;

                  setActiveTest(newTest);
                  setQuizMode("test");
                  setShowQuiz(false); // AIT-253: pre-start view, not a running test
                  setTestReadyToStart(true);
                } catch (e) {
                  console.error("Quick practice failed", e);
                }
              }}
              style={{ marginTop: 12 }}
              disabled={!practiceSubjectId}
            >
              Create Practice Test
            </Button>
          </View>

        </ScrollView>
      )}
    </SideModal>
  );


  const ShelfContainer = ({ side = "right", open, onClose, widthPx = 420, isDarkMode, children }) => {
    const { width } = useWindowDimensions();
    const shelfWidth = Math.min(480, Math.max(340, Math.floor(width * 0.4)));
    const translateX = open ? 0 : (side === "right" ? shelfWidth : -shelfWidth);

    return (
      <View
        pointerEvents={open ? "auto" : "none"}
        style={{
          position: "absolute",
          top: 0, left: 0, right: 0, bottom: 0,
          zIndex: 10000, // ⬅️ above everything
          ...(Platform.OS === "web" ? { overscrollBehavior: "none" } : null),
        }}
      >
        {/* Backdrop (z:1) */}
        <TouchableOpacity
          activeOpacity={1}
          onPress={onClose}
          style={{
            position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: open ? "rgba(0,0,0,0.35)" : "transparent",
            zIndex: 1,
          }}
        />

        {/* Shelf (z:2) */}
        <View
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            [side]: 0,
            width: shelfWidth,
            backgroundColor: isDarkMode ? "#0c1220" : "#fff",
            borderLeftWidth: side === "right" ? StyleSheet.hairlineWidth : 0,
            borderRightWidth: side === "left" ? StyleSheet.hairlineWidth : 0,
            borderColor: isDarkMode ? "#2b395a" : "#e5eaf4",
            transform: [{ translateX }],
            zIndex: 2,
            ...(Platform.OS === "web" ? { transition: "transform 220ms ease" } : null),
            shadowColor: "#000",
            shadowOpacity: 0.22,
            shadowRadius: 16,
            shadowOffset: { width: 0, height: 4 },
          }}
        >
          {children}
        </View>
      </View>
    );
  };

  const HistoryShelf = ({
    open, onClose, isDarkMode, items, activeCollectionName,
    renderHistorySection, handleVideoClick, handlePWOClick, authToken, styles
  }) => (
    <ShelfContainer side="right" open={open} onClose={onClose} isDarkMode={isDarkMode}>
      <View style={{ padding: 14, borderBottomWidth: StyleSheet.hairlineWidth, borderColor: isDarkMode ? "#203055" : "#e3e8f2" }}>
        <Text style={{ fontWeight: "700", fontSize: rem(16) + 'rem', color: isDarkMode ? "#dbe6ff" : "#122b53" }}>
          🕓 History — {activeCollectionName || "No module selected"}
        </Text>

        {/* Close (X) */}
        <TouchableOpacity {...makeWebTap(onClose)} style={{ position: "absolute", top: 10, right: 10, padding: 6 }}>
          <MaterialCommunityIcons name="close" size={20} color={isDarkMode ? "#cfe0ff" : "#334155"} />
        </TouchableOpacity>

        <Text style={{ marginTop: 4, color: isDarkMode ? "#9db0d8" : "#4b5e84", fontSize: rem(12) + 'rem' }}>
          Per-collection, persisted server-side.
        </Text>
      </View>
      <ScrollView contentContainerStyle={{ padding: 12 }}>
        {(items && items.length > 0)
          ? renderHistorySection(items, isDarkMode, handleVideoClick, handlePWOClick, authToken, styles)
          : <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>No history for this module yet.</Text>}
      </ScrollView>
    </ShelfContainer>
  );

  const InsightsShelf = ({
    open, onClose, isDarkMode, assessments, adaptiveRecommendation,
    engagementLogs, leaderboard, badges, styles, t, formatLocalDate, user_id, user_name, userRank, user_score
  }) => (
    <ShelfContainer side="right" open={open} onClose={onClose} isDarkMode={isDarkMode}>
      <View style={{ padding: 14, borderBottomWidth: StyleSheet.hairlineWidth, borderColor: isDarkMode ? "#203055" : "#e3e8f2" }}>
        <Text style={{ fontWeight: "700", fontSize: rem(16) + 'rem', color: isDarkMode ? "#dbe6ff" : "#122b53" }}>
          📊 Insights
        </Text>
        {/* Close (X) */}
        <TouchableOpacity
          onPress={onClose}
          style={{ position: "absolute", top: 10, right: 10, padding: 6 }}
        >
          <MaterialCommunityIcons name="close" size={20} color={isDarkMode ? "#cfe0ff" : "#334155"} />
        </TouchableOpacity>

        <Text style={{ marginTop: 4, color: isDarkMode ? "#9db0d8" : "#4b5e84", fontSize: rem(12) + 'rem' }}>
          Analytics & Engagement in modern cards
        </Text>
      </View>

      <ScrollView contentContainerStyle={{ padding: 12, gap: 12 }}>
        {/* Performance Analytics */}
        <View style={{
          padding: 12, borderRadius: 12,
          backgroundColor: isDarkMode ? "rgba(16,27,50,0.9)" : "#f8fbff",
          borderWidth: StyleSheet.hairlineWidth,
          borderColor: isDarkMode ? "#223252" : "#dfe8f7"
        }}>
          <Text style={{ fontWeight: "700", marginBottom: 8, color: isDarkMode ? "#dbe6ff" : "#102a52" }}>
            {t("Performance Analytics")}
          </Text>
          {assessments?.length ? assessments.map((a, i) => (
            <View key={i} style={{ marginBottom: 10, padding: 10, borderRadius: 10, backgroundColor: isDarkMode ? "#0b1324" : "#ffffff", borderWidth: StyleSheet.hairlineWidth, borderColor: isDarkMode ? "#24314f" : "#e6eefb" }}>
              <Text style={{ fontWeight: "600", color: isDarkMode ? "#d8e3ff" : "#1b325c" }}>
                {a.subject} — {a.chapter} — {a.topic}
              </Text>
              <Text style={{ marginTop: 4, color: isDarkMode ? "#b8c7ea" : "#314a7a" }}>
                🎯 {t("Score")}: {a.score}/{a.total_score} ({a.accuracy}%)
              </Text>
              <Text style={{ marginTop: 2, color: isDarkMode ? "#9db0d8" : "#4b5e84" }}>
                📅 {t("Taken On")}: {a.completed_at ? formatLocalDate(a.completed_at) : "N/A"}
              </Text>
            </View>
          )) : (
            <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>{t("No assessment data available.")}</Text>
          )}
          {!!adaptiveRecommendation && (
            <Text style={{ marginTop: 8, color: isDarkMode ? "#cfe0ff" : "#1a2f58" }}>{adaptiveRecommendation}</Text>
          )}
        </View>

        {/* Engagement */}
        <View style={{
          padding: 12, borderRadius: 12,
          backgroundColor: isDarkMode ? "rgba(16,27,50,0.9)" : "#f8fbff",
          borderWidth: StyleSheet.hairlineWidth,
          borderColor: isDarkMode ? "#223252" : "#dfe8f7"
        }}>
          <Text style={{ fontWeight: "700", marginBottom: 8, color: isDarkMode ? "#dbe6ff" : "#102a52" }}>
            {t("Engagement & Leaderboard")}
          </Text>

          {/* Last active / touches */}
          {engagementLogs?.length ? engagementLogs
            .slice().sort((a, b) => new Date(b.last_active) - new Date(a.last_active))
            .map((log, i) => (
              <View key={i} style={{ marginBottom: 8 }}>
                <Text style={{ color: isDarkMode ? "#cfe0ff" : "#1b325c" }}>
                  📅 {t("Last Active")}: {formatLocalDate(log.last_active)}
                </Text>
                <Text style={{ color: isDarkMode ? "#b8c7ea" : "#314a7a" }}>👆 {t("Touch Points")}: {log.clicks}</Text>
                <Text style={{ color: isDarkMode ? "#b8c7ea" : "#314a7a" }}>📝 {t("Quiz Attempts")}: {log.quiz_attempts}</Text>
                <Text style={{ color: isDarkMode ? "#b8c7ea" : "#314a7a" }}>🎯 {t("Accuracy")}: {log.accuracy ? `${log.accuracy.toFixed(2)}%` : "N/A"}</Text>
              </View>
            )) : <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>{t("No engagement data available.")}</Text>
          }

          {/* Leaderboard */}
          <View style={{ marginTop: 10 }}>
            <Text style={{ fontWeight: "700", color: isDarkMode ? "#dbe6ff" : "#102a52" }}>🏆 {t("Leaderboard")}</Text>
            {leaderboard?.length ? leaderboard.slice(0, 10).map((entry, idx) => (
              <View key={idx} style={{ flexDirection: "row", justifyContent: "space-between", paddingVertical: 6 }}>
                <Text style={{ color: isDarkMode ? "#cfe0ff" : "#1b325c" }}>#{idx + 1}</Text>
                <Text style={{ color: isDarkMode ? "#cfe0ff" : "#1b325c" }}>{entry.email === user_id ? entry.name : ""}</Text>
                <Text style={{ color: isDarkMode ? "#b8c7ea" : "#314a7a" }}>{entry.total_score.toFixed(2)} pts</Text>
              </View>
            )) : <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>{t("No leaderboard data available.")}</Text>}
            {leaderboard?.length > 10 && (
              <View style={{ flexDirection: "row", justifyContent: "space-between", paddingVertical: 6 }}>
                <Text style={{ color: isDarkMode ? "#cfe0ff" : "#1b325c" }}>#{userRank}</Text>
                <Text style={{ color: isDarkMode ? "#cfe0ff" : "#1b325c" }}>{user_name}</Text>
                <Text style={{ color: isDarkMode ? "#b8c7ea" : "#314a7a" }}>{user_score?.toFixed(2)} pts</Text>
              </View>
            )}
          </View>

          {/* Badges */}
          <View style={{ marginTop: 10 }}>
            <Text style={{ fontWeight: "700", color: isDarkMode ? "#dbe6ff" : "#102a52" }}>🎖️ {t("Earned Badges")}</Text>
            {badges?.length ? badges.filter(b => b?.name).map((badge, i) => (
              <View key={i} style={{ marginTop: 6, backgroundColor: isDarkMode ? "#0b1324" : "#fff", borderRadius: 10, padding: 8, borderWidth: StyleSheet.hairlineWidth, borderColor: isDarkMode ? "#24314f" : "#e6eefb" }}>
                <Text style={{ color: isDarkMode ? "#cfe0ff" : "#1b325c" }}>{badgeDisplayName(badge, t)}</Text>
              </View>
            )) : <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>{t("No badges earned yet.")}</Text>}
          </View>
        </View>
      </ScrollView>
    </ShelfContainer>
  );

  const LauncherShelf = ({
    open, onClose, isDarkMode,
    activeTab, setActiveTab,
    availableCollections, openStudentCollection, clearStudentCollection, activeStudyCollection,
    availableTests, startStudentTest, myTestResults, handleSelectPastTestResult,
    t, formatLocalDate, PDF_BASE_URL, Platform, Linking
  }) => (
    <ShelfContainer side="left" open={open} onClose={onClose} isDarkMode={isDarkMode}>
      <View style={{ padding: 14, borderBottomWidth: StyleSheet.hairlineWidth, borderColor: isDarkMode ? "#203055" : "#e3e8f2" }}>
        <Text style={{ fontWeight: "700", fontSize: rem(16) + 'rem', color: isDarkMode ? "#dbe6ff" : "#122b53" }}>
          🚀 Launcher
        </Text>
        {/* Close (X) */}
        <TouchableOpacity {...makeWebTap(onClose)} style={{ position: "absolute", top: 10, right: 10, padding: 6 }}>
          <MaterialCommunityIcons name="close" size={20} color={isDarkMode ? "#cfe0ff" : "#334155"} />
        </TouchableOpacity>

        <View style={{ flexDirection: "row", marginTop: 10, gap: 8 }}>
          <TouchableOpacity
            onPress={() => setActiveTab("modules")}
            style={{
              paddingVertical: 6, paddingHorizontal: 12, borderRadius: 999,
              backgroundColor: activeTab === "modules" ? (isDarkMode ? "#1a2a4e" : "#e8f1ff") : "transparent",
              borderWidth: StyleSheet.hairlineWidth,
              borderColor: isDarkMode ? "#2a3b63" : "#cfe0ff",
            }}
          >
            <Text style={{ fontWeight: "600", color: isDarkMode ? "#dbe6ff" : "#1b345e" }}>{t("Modules")}</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => setActiveTab("tests")}
            style={{
              paddingVertical: 6, paddingHorizontal: 12, borderRadius: 999,
              backgroundColor: activeTab === "tests" ? (isDarkMode ? "#1a2a4e" : "#e8f1ff") : "transparent",
              borderWidth: StyleSheet.hairlineWidth,
              borderColor: isDarkMode ? "#2a3b63" : "#cfe0ff",
            }}
          >
            <Text style={{ fontWeight: "600", color: isDarkMode ? "#dbe6ff" : "#1b345e" }}>{t("Tests")}</Text>
          </TouchableOpacity>
        </View>
      </View>

      {/* CONTENT */}
      {activeTab === "modules" ? (
        <ScrollView contentContainerStyle={{ padding: 12 }}>
          <Text style={{ fontWeight: "700", marginBottom: 8, color: isDarkMode ? "#dbe6ff" : "#102a52" }}>
            📦 {t("Available Learning Modules")}
          </Text>
          {(availableCollections || []).length ? (
            <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 10 }}>
              {availableCollections.map((col) => {
                const isSelected = activeStudyCollection && String(activeStudyCollection.id) === String(col.id);
                return (
                <TouchableOpacity key={col.id} onPress={() => {
                  if (isSelected) {
                    clearStudentCollection();
                  } else {
                    openStudentCollection(col);
                    console.log("[USER_ACTION] User opened collection from narrow shelf");
                    userHasSavedPreferenceRef.current = true;
                    setViewMode("collections");
                    setActiveModule("learning");
                  }
                  onClose?.();
                }}
                  style={{
                    width: "100%",
                    backgroundColor: isSelected
                      ? (isDarkMode ? "#1a2a4e" : "#e8f1ff")
                      : (isDarkMode ? "#0b1324" : "#fff"),
                    borderRadius: 12, padding: 10,
                    borderWidth: isSelected ? 2 : StyleSheet.hairlineWidth,
                    borderColor: isSelected
                      ? (isDarkMode ? "#60a5fa" : "#3B82F6")
                      : (isDarkMode ? "#24314f" : "#e6eefb")
                  }}>
                  <Text style={{ fontWeight: "700", color: isDarkMode ? "#d8e3ff" : "#1b325c" }}>{col.name}</Text>
                  <View style={{ flexDirection: "row", alignItems: "center", marginTop: 4, gap: 8 }}>
                    <Text style={{ color: isDarkMode ? "#9db0d8" : "#4b5e84" }}>{col.base_board?.toUpperCase()}</Text>
                  </View>
                </TouchableOpacity>
                );
              })}
            </View>
          ) : <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>{t("No Learning Modules available right now.")}</Text>}
        </ScrollView>
      ) : (
        <ScrollView contentContainerStyle={{ padding: 12 }}>
          {/* Available tests */}
          <Text style={{ fontWeight: "700", marginBottom: 8, color: isDarkMode ? "#dbe6ff" : "#102a52" }}>
            🧪 {t("Available Tests")}
          </Text>
          {availableTests?.length ? availableTests.map((test) => (
            <TouchableOpacity key={test.id} onPress={() => { startStudentTest(test.id); onClose?.(); }} style={{
              backgroundColor: isDarkMode ? "#0b1324" : "#fff",
              borderRadius: 12, padding: 10,
              borderWidth: StyleSheet.hairlineWidth, borderColor: isDarkMode ? "#24314f" : "#e6eefb",
              marginBottom: 8
            }}>
              <Text style={{ fontWeight: "700", color: isDarkMode ? "#d8e3ff" : "#1b325c" }}>{test.title}</Text>
              <Text style={{ marginTop: 4, color: isDarkMode ? "#9db0d8" : "#4b5e84" }}>
                {test.start_time ? formatLocalDate(test.start_time) : "N/A"}
              </Text>
            </TouchableOpacity>
          )) : <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>{t("No available tests at this time.")}</Text>}

          {/* My results */}
          <View style={{ marginTop: 16 }}>
            <Text style={{ fontWeight: "700", marginBottom: 8, color: isDarkMode ? "#dbe6ff" : "#102a52" }}>
              📊 {t("My Test Results")}
            </Text>
            {myTestResults?.length ? myTestResults.map((result) => (
              <TouchableOpacity
                key={result.id}
                onPress={() => { handleSelectPastTestResult(result); onClose?.(); }}
                style={{
                  backgroundColor: isDarkMode ? "#0b1324" : "#fff",
                  borderRadius: 12, padding: 10,
                  borderWidth: StyleSheet.hairlineWidth, borderColor: isDarkMode ? "#24314f" : "#e6eefb",
                  marginBottom: 8
                }}
              >
                <Text style={{ color: isDarkMode ? "#d8e3ff" : "#1b325c" }}>{t("Test:")} {result.test_title}</Text>
                <Text style={{ color: isDarkMode ? "#b8c7ea" : "#314a7a" }}>{t("Score:")} {result.score} / {result.total_score}</Text>
                <Text style={{ color: isDarkMode ? "#9db0d8" : "#4b5e84" }}>
                  {t("Submitted on:")} {result.completed_at ? formatLocalDate(result.completed_at) : "N/A"}
                </Text>

                {result.pdf_path && (
                  <TouchableOpacity
                    onPress={() => {
                      const url = `${PDF_BASE_URL}/${result.pdf_path}`;
                      if (Platform.OS === "web") window.open(url, "_blank");
                      else Linking.openURL(url);
                    }}
                    style={{ marginTop: 6 }}
                  >
                    <Text style={{ color: "#007BFF" }}>📄 {t("View Submitted PDF")}</Text>
                  </TouchableOpacity>
                )}

                {result.graded_pdf_path && (
                  <TouchableOpacity
                    onPress={() => {
                      const url = `${PDF_BASE_URL}/${result.graded_pdf_path}`;
                      if (Platform.OS === "web") window.open(url, "_blank");
                      else Linking.openURL(url);
                    }}
                    style={{ marginTop: 6 }}
                  >
                    <Text style={{ color: "#28a745" }}>📄 {t("View Graded PDF")}</Text>
                  </TouchableOpacity>
                )}
              </TouchableOpacity>
            )) : <Text style={{ color: isDarkMode ? "#9fb0d5" : "#5b6b88" }}>{t("No test results available.")}</Text>}
          </View>

          {/* BDD 02/03/2026 student-practice-test-phase1 */}
          <Text style={{ fontWeight: "bold", marginTop: 10 }}>🧩 My Practice Tests</Text>
          {(myPracticeTests || []).length === 0 ? (
            <Text style={{ opacity: 0.7 }}>No practice tests yet.</Text>
          ) : (
            (myPracticeTests || []).map((t) => (
              <TouchableOpacity
                key={t.id}
                onPress={() => {
                  setActiveTest(t);
                  setQuizMode("test");
                  setShowQuiz(false); // AIT-253: pre-start view, not a running test
                  setTestReadyToStart(true);
                }}
                style={{ padding: 10, borderWidth: 1, borderColor: "#eee", borderRadius: 10, marginTop: 8, backgroundColor: "#fff" }}
              >
                <Text style={{ fontWeight: "700" }}>{t.title}</Text>
                <Text style={{ fontSize: 12, opacity: 0.7 }}>
                  {t.duration_minutes ? `${t.duration_minutes} min` : "Untimed"} • Created {t.created_at ? formatLocalDate(t.created_at) : ""}
                </Text>
              </TouchableOpacity>
            ))
          )}

          {/* BDD 02/03/2026 student-practice-test-phase1 */}
          <View style={{ padding: 12, borderWidth: 1, borderColor: "#e5e7eb", borderRadius: 12, marginBottom: 12 }}>
            <Text style={{ fontWeight: "700", marginBottom: 8 }}>⚡ Quick Practice</Text>

            <Text style={{ fontSize: 12, marginBottom: 4 }}>Subject</Text>
            <Picker
              selectedValue={practiceSubjectId}
              onValueChange={(val) => {
                setPracticeSubjectId(val);
                const match = practiceSubjects.find(x => x.id === val);
                setPracticeSubjectName(match?.name || "");
              }}
              style={{ backgroundColor: "#fff" }}
            >
              {practiceSubjects.map(s => (
                <Picker.Item key={s.id} label={`${s.name}`} value={s.id} />
              ))}
            </Picker>

            <Text style={{ fontSize: 12, marginTop: 8, marginBottom: 4 }}># Questions</Text>
            <Picker selectedValue={practiceTotal} onValueChange={setPracticeTotal} style={{ backgroundColor: "#fff" }}>
              {[10, 15, 20, 25].map(n => <Picker.Item key={n} label={`${n}`} value={n} />)}
            </Picker>

            <Text style={{ fontSize: 12, marginTop: 8, marginBottom: 4 }}>Difficulty</Text>
            <Picker selectedValue={practiceMix} onValueChange={setPracticeMix} style={{ backgroundColor: "#fff" }}>
              <Picker.Item label="Balanced" value="balanced" />
              <Picker.Item label="Easy-heavy" value="easy_heavy" />
              <Picker.Item label="Hard-heavy" value="hard_heavy" />
            </Picker>

            <Button
              mode="contained"
              onPress={async () => {
                try {
                  const payload = {
                    student_email: user.email,
                    subject_id: practiceSubjectId,
                    subject_name: practiceSubjectName,
                    total_questions: practiceTotal,
                    difficulty_mix: practiceMix,
                    language_id: 1,
                    timed: false
                  };

                  const res = await axios.post(`${FASTAPI_BASE_URL}/practice_tests/quick_create`, payload);
                  const newTest = res.data.test;

                  setActiveTest(newTest);
                  setQuizMode("test");
                  setShowQuiz(false); // AIT-253: pre-start view, not a running test
                  setTestReadyToStart(true);
                } catch (e) {
                  console.error("Quick practice failed", e);
                }
              }}
              style={{ marginTop: 12 }}
              disabled={!practiceSubjectId}
            >
              Create Practice Test
            </Button>
          </View>

        </ScrollView>
      )}
    </ShelfContainer>
  );

  // BDD 19/15/2025
  // When switching boards, also reset (you already reload on web, this protects native)
  useEffect(() => {
    setSelectedChapter(null);
  }, [currentCurriculum]);

  const handleCurriculumClick = () => {
    // Use the same clickable pattern as other header icons
    setCurriculumMenuOpen(v => !v);
  };

  const applyCurriculumChange = async (newName) => {
    try {
      setIsChangingCurriculum(true);

      // 1) Persist to backend
      await axios.post(`${FASTAPI_BASE_URL}/set_content_db`, {
        user_id: user_id,
        content_db: newName,
      });

      // BDD 10/15/2025 — ensure board-scoped stores/collections remap cleanly
      if (Platform.OS === "web") {
        try { setCurriculumModalVisible?.(false); } catch { }
        // Close any open shelves to avoid flicker
        try { setHistoryOpen?.(false); setInsightsOpen?.(false); setLauncherOpen?.(false); } catch { }
        window.location.reload();   // ← identical to what you did manually
        return;                     // stop further local refetch to avoid double work
      }

      // // 2) Re-fetch curriculum (copying your existing fetch logic inline to avoid refactors)
      // const response = await axios.get(`${FASTAPI_BASE_URL}/curriculum_with_images`, {
      //   params: { user_id: user_id },
      // });
      // BDD 12/08/2025
      // 2) Re-fetch curriculum (copying your existing fetch logic inline to avoid refactors)
      const curriculumLang = resolveCurriculumLang(selectedSecondaryLang);

      const response = await axios.get(`${FASTAPI_BASE_URL}/curriculum_with_images`, {
        params: {
          user_id: user_id,
          lang: curriculumLang,  // 👈 NEW
        },
      });

      setCurriculum(response.data.curriculum);
      setPwoTopicMap(response.data.pwo_topic_map);
      setVideoTopicMap(response.data.video_topic_map);
      setQuizCountMap(response.data.quiz_count_map || {}); // ⬅️ add this line
      // setCurrentCurriculum(response.data.curriculum_name || newName);
      setCurrentCurriculum((response.data.curriculum_name || newName || "").toLowerCase()); // BDD 10/23

    } catch (e) {
      console.error("Failed to change curriculum:", e);
      if (typeof window !== "undefined" && window.alert) {
        window.alert("Failed to change curriculum. Please try again.");
      }
    } finally {
      setIsChangingCurriculum(false);
      setCurriculumMenuOpen(false);
    }
  };

  const handleSelectCurriculum = async (newName) => {
    if (newName === currentCurriculum) {
      setCurriculumMenuOpen(false);
      return;
    }
    // Confirm (web-safe). No new modal introduced.
    let ok = true;
    if (typeof window !== "undefined" && window.confirm) {
        ok = window.confirm(`Are you sure you want to switch to "${getBoardLabel(newName)}"?`);
    }
    if (!ok) return;

    await applyCurriculumChange(newName);
  };

  // BDD 10/17/2025 - TEMP delete it - not for production - for DEBUG only
  // // ===== DEV PROBES (read-only; safe to remove later) =========================
  // if (typeof window !== "undefined") {
  //   const asNum = (v) => (v != null && !Number.isNaN(+v) && String(+v) === String(v)) ? +v : v;

  //   const getBoardId = (x) =>
  //     x?.boardTopicId ?? x?.board_topic_id ?? x?.topicId ?? x?.topic_id ?? x?.id ?? null;
  //   const getSourceId = (x) =>
  //     x?.sourceTopicId ?? x?.source_topic_id ?? x?.source_id ?? null;

  //   const countFrom = (raw, kind) => {
  //     if (!raw) return 0;
  //     if (Array.isArray(raw)) return raw.length;
  //     if (kind === "video") {
  //       if (Array.isArray(raw.segments)) return raw.segments.length;
  //       if (Array.isArray(raw.items))    return raw.items.length;
  //     } else {
  //       if (Array.isArray(raw.scenes))   return raw.scenes.length;
  //       if (Array.isArray(raw.items))    return raw.items.length;
  //     }
  //     return 0;
  //   };

  //   // 1) Quick look at shapes of IDs in each grid
  //   window.__sampleIDShapes = (n = 8) => {
  //     const pick = (arr) => (arr || []).slice(0, n).map(x => ({
  //       topicName: x.topicName || x.name,
  //       id: x.id, topicId: x.topicId, topic_id: x.topic_id,
  //       boardTopicId: getBoardId(x), sourceTopicId: getSourceId(x),
  //       typeof_id: typeof x?.id,
  //       typeof_topicId: typeof x?.topicId,
  //       typeof_boardTopicId: typeof getBoardId(x),
  //       typeof_sourceTopicId: typeof getSourceId(x),
  //     }));
  //     console.table({collections: pick(topicsFlat), curriculum: pick(topicsFlatForChapter)});
  //     return {collections: pick(topicsFlat), curriculum: pick(topicsFlatForChapter)};
  //   };

  //   // 2) What patterns do your map keys follow?
  //   window.__scanMapKeys = (limit = 20) => {
  //     const unpack = (obj) => {
  //       const ks = Object.keys(obj || {}).slice(0, limit);
  //       return ks.map(k => {
  //         const [L, R] = k.split("|");
  //         return { key: k, left: L, right: R, typeof_left: typeof L, typeof_right: typeof R };
  //       });
  //     };
  //     const out = {
  //       video: unpack(videoTopicMap),
  //       pwo:   unpack(pwoTopicMap),
  //     };
  //     console.table(out.video);
  //     console.table(out.pwo);
  //     return out;
  //   };

  //   // 3) For the current chapter, compare tile counts vs map-derived counts (both orders)
  //   window.__compareChapterCounts = () => {
  //     const rows = (topicsFlatForChapter || []).map(x => {
  //       const b = asNum(getBoardId(x));
  //       const s = asNum(getSourceId(x));
  //       const k1 = `${b}|${s}`;
  //       const k2 = `${s}|${b}`;
  //       return {
  //         topicName: x.topicName || x.name,
  //         boardTopicId: b, sourceTopicId: s,
  //         tile_video: x.videoCount ?? 0,
  //         tile_pwo:   x.pwoCount   ?? 0,
  //         map_k1_video: countFrom(videoTopicMap?.[k1], "video"),
  //         map_k2_video: countFrom(videoTopicMap?.[k2], "video"),
  //         map_k1_pwo:   countFrom(pwoTopicMap?.[k1],   "pwo"),
  //         map_k2_pwo:   countFrom(pwoTopicMap?.[k2],   "pwo"),
  //         has_k1_v: !!videoTopicMap?.[k1], has_k2_v: !!videoTopicMap?.[k2],
  //         has_k1_p: !!pwoTopicMap?.[k1],   has_k2_p: !!pwoTopicMap?.[k2],
  //       };
  //     });
  //     console.table(rows);
  //     return rows;
  //   };

  //   // 4) Deep inspect a single topic (IDs can be numbers or strings)
  //   window.__inspectTopic = (boardId, sourceId) => {
  //     const b = asNum(boardId), s = asNum(sourceId);
  //     const k1 = `${b}|${s}`, k2 = `${s}|${b}`;
  //     const inColl = (topicsFlat || []).find(t => getBoardId(t) === b || getSourceId(t) === s);
  //     const inChap = (topicsFlatForChapter || []).find(t => getBoardId(t) === b || getSourceId(t) === s);

  //     const pack = (x, label) => x ? {
  //       where: label,
  //       topicName: x.topicName || x.name,
  //       boardTopicId: getBoardId(x),
  //       sourceTopicId: getSourceId(x),
  //       tile_video: x.videoCount ?? 0,
  //       tile_pwo:   x.pwoCount   ?? 0,
  //     } : { where: label, missing: true };

  //     console.table([pack(inColl, "collections"), pack(inChap, "curriculum")]);
  //     console.log("[map hits]", {
  //       k1, k2,
  //       has_k1_video: !!videoTopicMap?.[k1],
  //       has_k2_video: !!videoTopicMap?.[k2],
  //       has_k1_pwo:   !!pwoTopicMap?.[k1],
  //       has_k2_pwo:   !!pwoTopicMap?.[k2],
  //       map_k1_video: countFrom(videoTopicMap?.[k1], "video"),
  //       map_k2_video: countFrom(videoTopicMap?.[k2], "video"),
  //       map_k1_pwo:   countFrom(pwoTopicMap?.[k1],   "pwo"),
  //       map_k2_pwo:   countFrom(pwoTopicMap?.[k2],   "pwo"),
  //     });
  //     return { inColl, inChap };
  //   };

  //   // 5) Quick meta
  //   window.__devMapsMeta = () => ({
  //     videoKeys: Object.keys(videoTopicMap || {}).length,
  //     pwoKeys:   Object.keys(pwoTopicMap   || {}).length,
  //     quizKeys:  Object.keys(quizCountMap  || {}).length,
  //     selectedChapter,
  //   });
  // }

  // BDD 10/17/2025
  // ==== DEV LOGGING (no behavior changes) ====

  // Helper to fetch the same payload your tree uses and print rows
  const __probeTopicContent = React.useCallback(async (tid, topicName) => {
    const url = `${FASTAPI_BASE_URL}/content/${tid}`;
    try {
      // BDD 12/09/2025
      const curriculumLang = resolveCurriculumLang(selectedSecondaryLang);
      const { data } = await axios.get(url, { params: { language_id: languageID, user_id, lang: curriculumLang } });
      const videos = Array.isArray(data?.videos) ? data.videos : [];
      const pwos = Array.isArray(data?.pwos) ? data.pwos : [];
      console.groupCollapsed(
        `[DEV] /content/${tid} → ${topicName || ""}  (videos: ${videos.length}, pwos: ${pwos.length})`
      );
      console.log("URL:", url);
      console.table(videos.map(v => ({
        name: v.name,
        source_id: v.source_id,
        tag_id: v.tag_id,
        key: `${v.source_id}|${v.tag_id}`,
      })));
      console.table(pwos.map(p => ({
        name: p.name,
        pwo_source_id: p.pwo_source_id,
        scene_name: p.scene_name,
        key: `${p.pwo_source_id}|${p.scene_name}`,
      })));
      console.groupEnd();
      return { videos, pwos };
    } catch (e) {
      console.warn("[DEV] content fetch failed", { tid, url, err: e?.message || String(e) });
      return { videos: [], pwos: [] };
    }
  }, [FASTAPI_BASE_URL, languageID, user_id, selectedSecondaryLang]);

  // Resolve the id we actually pass to /content/{id} (uses your resolver if present)
  const __resolveTid = React.useCallback((it) => {
    // try boardTopicId on the item, then your resolver, then raw topicId
    return it.boardTopicId
      ?? (typeof resolveBoardTopicId === "function" ? resolveBoardTopicId(it.topicId) : null)
      ?? it.topicId;
  }, []);

  // // BDD 04/27/2026 - DEBUG I UNCOMMENTED THIS OUT
  // // Probe CURRENT CHAPTER tiles (what’s broken) and print content rows
  // useEffect(() => {
  //   if (!DEBUG_TILE_CONTENT) return;
  //   if (!curriculumView || !selectedChapter) return;

  //   const list = Array.isArray(topicsFlatForChapter) ? topicsFlatForChapter : [];
  //   if (!list.length) return;

  //   console.log("[DEV] Probing chapter tiles:", {
  //     chapter: selectedChapter?.chapterName,
  //     subject: selectedChapter?.subjectName,
  //     count: list.length
  //   });

  //   let cancelled = false;

  //   (async () => {
  //     // keep noise down: first 8 topics is usually plenty to see the pattern
  //     const sample = list.slice(0, 8);

  //     for (const it of sample) {
  //       const tid = __resolveTid(it);
  //       console.log("[DEV] chapter tile id mapping", {
  //         topicName: it.topicName, rawTopicId: it.topicId, boardTopicId: it.boardTopicId, resolvedTid: tid
  //       });
  //       if (tid != null && !cancelled) {
  //         await __probeTopicContent(tid, it.topicName);
  //       }
  //     }
  //   })();

  //   return () => { cancelled = true; };
  // }, [DEBUG_TILE_CONTENT, curriculumView, selectedChapter, topicsFlatForChapter, __resolveTid, __probeTopicContent]);

  // Probe CURRENT COLLECTION tiles (what works) for side-by-side comparison
  // useEffect(() => {
  //   if (!DEBUG_TILE_CONTENT) return;
  //   if (!activeStudyCollection) return;

  //   const list = Array.isArray(topicsFlat) ? topicsFlat : [];
  //   if (!list.length) return;

  //   console.log("[DEV] Probing collection tiles:", {
  //     collection: activeStudyCollection?.name,
  //     count: list.length
  //   });

  //   let cancelled = false;

  //   (async () => {
  //     const sample = list.slice(0, 6);
  //     for (const it of sample) {
  //       const tid = __resolveTid(it);
  //       console.log("[DEV] collection tile id mapping", {
  //         topicName: it.topicName, rawTopicId: it.topicId, boardTopicId: it.boardTopicId, resolvedTid: tid
  //       });
  //       if (tid != null && !cancelled) {
  //         await __probeTopicContent(tid, it.topicName);
  //       }
  //     }
  //   })();

  //   return () => { cancelled = true; };
  // }, [DEBUG_TILE_CONTENT, activeStudyCollection, topicsFlat, __resolveTid, __probeTopicContent]);
  // BDD 10/17/2025
  // Progressive update: merge each topic's counts into state as soon as its
  // /content API call returns, so buttons appear incrementally instead of
  // waiting for every topic to finish.
  useEffect(() => {
    if (!curriculumView || !selectedChapter) { setChapterCounts({}); return; }

    const list = Array.isArray(topicsFlatForChapter) ? topicsFlatForChapter : [];
    if (!list.length) { setChapterCounts({}); return; }

    let cancelled = false;
    const MAX_PAR = 5;
    let i = 0;

    const worker = async () => {
      while (i < list.length && !cancelled) {
        const idx = i++;
        const it = list[idx];
        const tid = __resolveTid(it);
        if (tid == null) {
          if (!cancelled) setChapterCounts(prev => ({ ...prev, [it.topicId]: { video: 0, pwo: 0 } }));
          continue;
        }

        try {
          // BDD 12/09/2025
          const curriculumLang = resolveCurriculumLang(langRef.current || selectedSecondaryLang);
          const { data } = await axios.get(`${FASTAPI_BASE_URL}/content/${tid}`, {
            params: { language_id: languageID, user_id, lang: curriculumLang }
          });
          const videos = Array.isArray(data?.videos) ? data.videos : [];
          const pwos = Array.isArray(data?.pwos) ? data.pwos : [];
          if (!cancelled) setChapterCounts(prev => ({ ...prev, [it.topicId]: { video: videos.length, pwo: pwos.length } }));
        } catch (e) {
          // non-fatal — treat as zero
          if (!cancelled) setChapterCounts(prev => ({ ...prev, [it.topicId]: { video: 0, pwo: 0 } }));
        }
      }
    };

    // Reset before starting new chapter's fetches
    setChapterCounts({});
    Promise.all([...Array(Math.min(MAX_PAR, list.length))].map(worker));

    return () => { cancelled = true; };
  }, [
    curriculumView,
    selectedChapter,
    topicsFlatForChapter,
    __resolveTid,
    FASTAPI_BASE_URL,
    languageID,
    user_id
  ]);

  // BDD 10/17/2025



  // Show curriculum tiles when user asked for them OR when there are no collections.
  const showTiles = Boolean(curriculumTileView && (curriculumView || !hasCollections));

  // Sidebar should show curriculum tree when curriculum view is on,
  // OR when we are forcing tiles due to no collections.
  // const sidebarShowsCurriculum = Boolean(curriculumView || (!hasCollections && curriculumTileView));
  // === PATCH 2025-11-03: sidebar source of truth ===
  // BDD 01/07/2026 Collection vs Curriculum Display Bug
  const sidebarShowsCurriculum = useMemo(() => {
    if (noCollectionsForSure) return true;           // no modules → always show Curriculum tree
    return viewMode === "curriculum";         // else follow the user’s mode
  }, [noCollectionsForSure, viewMode]);

  // maps the old quizMode from AITutorApp state
  // into the `mode` prop that QuestionDisplay understands
  function mapQuizModeToDisplayMode(qm) {
    // qm is like "test", "pastTestView", "quiz", "quizReview" etc.
    if (qm === "test") {
      return "testTaking";       // live student test (no solutions, timer, etc.)
    }
    if (qm === "pastTestView") {
      return "pastTestView";     // student looking back at results, can see correctness
    }
    // AIT-249: just-submitted practice quiz review — render like pastTestView
    // so QuestionDisplay applies green/red + reveals solutions.
    if (qm === "quizReview") {
      return "pastTestView";
    }
    // default is just practice quiz mode
    return "quizPractice";
  }
  // BDD 01/12/2026 X-bug
  // {/*// ✅ Stage visibility guards (do NOT depend on viewMode) BDD 01/12/2026 X-bug*/}
  const isVideoStageVisible = !!showVideo;                // video is actually on screen
  // Keepalive keeps Unity mounted in the background; it should NOT count as "visible"
  // or it will steal focus/layout from the learning modules.
  const isPwoStageVisible = !!showPwo;                    // Unity OR local Three.js PWO visible

  // Professor Swan self-guided mode uses the same clean viewport takeover as
  // Journey Present, but it remains student-owned work and follows the saved
  // Journey step rather than the presenter's ephemeral step index.
  const journeySelfGuidedFocus = Boolean(
    showJourney &&
    journeyRuntime &&
    journeyMode === "self_guided"
  );

  // Caption source is a short-lived, locally created Blob URL obtained with
  // the same Bearer token used for the video. Never publish SME transcripts to
  // the unauthenticated /static directory. Missing captions are harmless.
  useEffect(() => {
    // Wait for the actual HLS video to be ready before attaching a track.
    // Otherwise its initial media/source setup can leave an empty loaded track.
    if (!journeySelfGuidedFocus || !showVideo || !videoReady || !currentVideoId || !authToken) {
      setWonderLabsCaptionTracks([]);
      return undefined;
    }
    let disposed = false;
    let objectUrl = null;
    const controller = typeof AbortController !== "undefined" ? new AbortController() : null;
    setWonderLabsCaptionTracks([]);
    const sourceLang = Number(languageIDVideo) === 2 ? "gu"
      : Number(languageIDVideo) === 5 ? "en-US" : "en";
    const url = `${FASTAPI_BASE_URL}/wonderlabs/video-captions/${encodeURIComponent(currentVideoId)}` +
      `?language_id=${encodeURIComponent(languageIDVideo || 1)}`;
    fetch(url, { signal: controller?.signal, headers: { Authorization: `Bearer ${authToken}` } })
      .then(async (response) => {
        if (response.status === 204) {
          console.info("[WonderLabs CC] No captions for source video/language", currentVideoId, languageIDVideo);
          return null;
        }
        if (!response.ok) throw new Error(`Caption request failed: ${response.status}`);
        return response.text();
      })
      .then((vtt) => {
        if (disposed || !vtt || !vtt.startsWith("WEBVTT")) return;
        objectUrl = URL.createObjectURL(new Blob([vtt], { type: "text/vtt" }));
        setWonderLabsCaptionTracks([{
          url: objectUrl, srclang: sourceLang,
          label: sourceLang === "gu" ? "Gujarati" : "English",
          language_id: languageIDVideo, default: true,
        }]);
      })
      .catch((error) => {
        if (!disposed && error?.name !== "AbortError") {
          console.warn("[WonderLabs CC] Caption retrieval failed", currentVideoId, error);
          setWonderLabsCaptionTracks([]);
        }
      });
    return () => {
      disposed = true;
      controller?.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [authToken, currentVideoId, journeySelfGuidedFocus, languageIDVideo, showVideo, videoReady]);

  // Chromium sometimes reports a track as loaded with zero cues the first
  // time HLS video opens; reopening fixes it. Watch the *actual* native track
  // instead of relying on the HTML `default` attribute. Retry only the track,
  // not the video or Journey state. A finite retry limit prevents a loop on a
  // genuinely empty/invalid subtitle file.
  useEffect(() => {
    if (Platform.OS !== "web" || !journeySelfGuidedFocus || !showVideo ||
        !videoReady || wonderLabsCaptionTracks.length === 0) return;
    const video = videoRef.current;
    if (!video) return;
    let checks = 0;
    const timer = setInterval(() => {
      const element = video.querySelector('track[kind="captions"]');
      if (!element) return;
      const active = element.track;
      if (active && active.mode !== "showing") active.mode = "showing";
      if (active?.cues?.length > 0) {
        placeWonderLabsCaptionCues(active);
        clearInterval(timer);
        return;
      }
      checks += 1;
      if (checks < 8) return;
      clearInterval(timer);
      const current = wonderLabsCaptionTracks[0];
      const attempt = current?.retry || 0;
      if (attempt < 2 && (element.readyState === 2 || element.readyState === 3)) {
        console.warn("[WonderLabs CC] Empty/failed text track on first open; retrying track", {
          videoId: currentVideoId, state: element.readyState, attempt: attempt + 1,
        });
        setWonderLabsCaptionTracks((previous) => previous.map((item) => ({
          ...item, retry: (item.retry || 0) + 1,
        })));
      } else if (element.readyState === 2 && !active?.cues?.length) {
        console.warn("[WonderLabs CC] Track loaded but contains zero cues", currentVideoId);
      }
    }, 250);
    return () => clearInterval(timer);
  }, [currentVideoId, journeySelfGuidedFocus, showVideo, videoReady, wonderLabsCaptionTracks]);

  // BDD 07/29/2026 - Journey
  const journeyAssetMode = Boolean(
    showJourney &&
    journeyRuntime &&
    journeyActiveAsset &&
    (isVideoStageVisible || isPwoStageVisible)
  );

  const journeyAssetTocVisible =
    journeyAssetMode &&
    !journeyPresentMode &&
    !journeySelfGuidedFocus &&
    !stageMaximized &&
    width >= 1180;

  // The same existing asset + Ask AI companion now supports Professor Swan
  // self-guided mode. Teacher Present remains a projector-only surface.
  const journeyAssetCompanionVisible =
    journeyAssetMode &&
    !journeyPresentMode &&
    !stageMaximized &&
    width >= 1050;

  const journeyAssetTocWidth = Math.min(
    270,
    Math.max(225, Math.round(width * 0.18))
  );

  const journeyAssetCompanionWidth = Math.min(
    390,
    Math.max(330, Math.round(width * 0.27))
  );
  const JourneyMediaCompanionContainer = journeySelfGuidedFocus
    ? JourneySwanMediaShell
    : JourneyAssetCompanion;


  // Lesson in a Box 2026-08-13 — keep the lesson docked beside its own asset.
  const lessonAssetMode = Boolean(
    showLessonPlan &&
    lessonPlanRuntime &&
    lessonPlanAssetLaunchRef.current &&
    // A 3D scene renders inline inside the step; only video still takes over
    // its own module and needs the lesson docked beside it.
    isVideoStageVisible
  );

  const lessonAssetCompanionVisible =
    lessonAssetMode && !stageMaximized && width >= 1050;

  const lessonAssetCompanionWidth = Math.min(
    400,
    Math.max(330, Math.round(width * 0.27))
  );

  // The companion is an absolute overlay and the stage reserves its width by
  // hand, so exactly one value decides whether it is drawn. Present mode hides
  // it; the reservation used to miss that and left a companion-shaped hole on
  // the projector.
  const lessonAssetCompanionShown =
    lessonAssetCompanionVisible && !lessonPresentMode;

  // ── Saras rail geometry ───────────────────────────────────────────────────
  // The rail is an absolute overlay *inside* mainContent (zIndex 30), so the
  // content underneath has to reserve its width by hand or the rail sits on
  // top of it. Both the rail and that reservation are derived from
  // `railOverlayWidth` and nothing else — 0 when no rail is drawn, the rail's
  // current width when one is — so the two cannot drift apart again.
  //
  // They had drifted twice: the rail also renders under `challengeLockdown`,
  // and it renders with no sparks and no suggested questions (SuggestionRail
  // deliberately does not bail out when empty). Neither case reserved
  // anything, so the rail covered the stage — including the curriculum
  // chapter tabs in FolderNavigation.
  const suggestionRailVisible =
    ((bottomUiKind === "club" && flags.club_mode) || challengeLockdown) &&
    !journeyAssetMode &&
    !lessonAssetMode &&
    !journeyPresentMode &&
    !journeySelfGuidedFocus &&
    !stageMaximized &&
    showSuggestionRail;

  const railOverlayWidth = suggestionRailVisible
    ? (rightSidebarWidth !== null ? rightSidebarWidth : responsiveRailWidth)
    : 0;

  const isQuizStageVisible = !!showQuiz && quizMode !== "test";
  // BDD 01/12/2026 X-bug
  // {/*// ✅ Top-right controls should show whenever any stage is active/visible */}
  const showStageControls = isVideoStageVisible || isPwoStageVisible || isQuizStageVisible
    || (activeModule === "video") || (activeModule === "pwo"); // extra safety
  // BDD 01/12/2026 X-bug
  const effectiveActiveModule =
    (showPwo ? "pwo" : activeModule);

  // BDD 07/29/2026 - Journey
  const journeyStepsForWorkspace = Array.isArray(
    journeyRuntime?.steps
  )
    ? journeyRuntime.steps
    : Array.isArray(journeyRuntime?.runtime?.steps)
      ? journeyRuntime.runtime.steps
      : [];

  const journeyActiveStepForWorkspace =
    journeyStepsForWorkspace[journeyStepIndex] || null;

  const journeySlugForWorkspace = String(
    journeyRuntime?.slug || journeyRuntime?.runtime?.slug || ""
  )
    .trim()
    .toLowerCase();

  const journeyPhaseLabelsForWorkspace =
    STEM_MISSION_SLUGS.has(journeySlugForWorkspace) &&
    journeyStepsForWorkspace.length === STEM_MISSION_PHASE_LABELS.length
      ? STEM_MISSION_PHASE_LABELS
      : null;

  // ── Helper: navigate to a curriculum chapter without calling handleChapterClick ──
  // (handleChapterClick calls cleanupModule which interferes with subsequent video/PWO opens)
  const navigateToCurriculumChapter = (chapterId) => {
    setLearningSubModule("modules");
    setActiveModule("learning");
    setViewMode("curriculum");
    setActiveStudyCollection(null);
    const path = findChapterPath(({ chap }) => {
      const cid = chap?.chapterId ?? chap?.id ?? chap?.chapter_id;
      return String(cid) === String(chapterId);
    });
    if (path) {
      const candidate = {
        levelId: path.level?.id ?? path.level?.levelId,
        subjectId: path.subject?.id ?? path.subject?.subjectId,
        subjectName: labelForCurriculumNode(path.subject),
        chapterId: path.chap?.id ?? path.chap?.chapterId ?? chapterId,
        chapterName: labelForCurriculumNode(path.chap),
      };
      skipChapterRestoreUntilRef.current = Date.now() + 3000;
      setSelectedChapter(candidate);
      ensureExpandedForChapter(candidate.levelId, candidate.subjectId, candidate.chapterId);
      storage.set(LAST_CHAPTER_KEY, candidate);
    }
  };

  // ── Extracted StudentHomeScreen callbacks (shared by home + teacher dashboard preview) ──
  const studentHomeOnContinueLearning = async () => {
    console.log("[ContinueLearning] clicked, learningResumeState:", learningResumeState);
    if (!learningResumeState) {
      console.log("[ContinueLearning] No learningResumeState, returning");
      return;
    }
    const safeUpper = (s) => (typeof s === "string" ? s.trim().toUpperCase() : "");
    const safeNum = (v) => { const n = Number(v); return Number.isFinite(n) ? n : null; };

    const assetType = safeUpper(learningResumeState.asset_type);
    const assetId = safeNum(learningResumeState.asset_source_id);
    const stateJson = learningResumeState.state_json || {};
    console.log("[ContinueLearning] assetType:", assetType, "assetId:", assetId, "stateJson:", stateJson);

    // Small helper: let React process chapter/collection navigation before opening asset
    const waitForRender = () => new Promise((r) => setTimeout(r, 150));

    if (assetType === "VIDEO" && assetId != null) {
      const tagId = safeNum(stateJson?.tag_id);
      const boardTopicId = safeNum(stateJson?.board_topic_id);
      const chapterId = safeNum(stateJson?.chapter_id);
      console.log("[ContinueLearning] VIDEO - tagId:", tagId, "boardTopicId:", boardTopicId, "chapterId:", chapterId);
      if (tagId) {
        // Navigate to chapter/collection first (same pattern as recent activity)
        if (stateJson?.collection_id) {
          await handleCollectionClick({ collection_id: stateJson.collection_id, base_board: stateJson.content_db || contentDb });
        } else if (chapterId) {
          navigateToCurriculumChapter(chapterId);
          await waitForRender();
        }
        await handleVideoClick(assetId, tagId, authToken, chapterId || null, boardTopicId, false);
      } else {
        console.log("[ContinueLearning] No tagId, going to learning module");
        setActiveModule("learning");
        setLearningSubModule("modules");
      }
      return;
    }

    if (assetType === "PWO" && assetId != null) {
      const sceneName = (stateJson?.pwo_scene_name || stateJson?.pwo_scene || "").trim();
      const chapterId = safeNum(stateJson?.chapter_id);
      if (sceneName) {
        // Navigate to chapter/collection first
        if (stateJson?.collection_id) {
          await handleCollectionClick({ collection_id: stateJson.collection_id, base_board: stateJson.content_db || contentDb });
        } else if (chapterId) {
          navigateToCurriculumChapter(chapterId);
          await waitForRender();
        }
        await handlePWOClick(assetId, sceneName, authToken, selectedSecondaryLang, chapterId || null, safeNum(stateJson?.board_topic_id) || null, false);
      } else {
        setActiveModule("learning");
        setLearningSubModule("modules");
      }
      return;
    }

    setActiveModule("learning");
    setLearningSubModule("modules");
  };

  const studentHomeOnContinueCuriosityAI = React.useMemo(
    () =>
      makeContinueChatHandler({
        getCuriosityResumeState: () => curiosityResumeState,
        fetchChatSessionsDirect,
        openChatSession,
        setActiveModule,
        setLearningSubModule,
        setActiveSidebarTab,
        alert: (title, message) => Alert.alert(title, message),
        t,
      }),
    [curiosityResumeState, t],
  );

  // BDD 07/28/2026 - Journey
  const handleJourneyAsk = (
      question,
      contextOverride = null,
      extraOptions = {}
    ) => {
      const text = String(question || "").trim();
      if (!text) return;

      const sourceContext = contextOverride || journeyAiContext;
      const mediaAsset = journeyActiveAsset && (showVideo || showPwo)
        ? journeyActiveAsset
        : null;
      // The visible media takes precedence over a stale question context,
      // but saved phase work remains from the existing Journey renderer.
      const effectiveJourneyContext = sourceContext && mediaAsset
        ? {
            ...sourceContext,
            ...(getWonderLabsScienceGuardrail(sourceContext?.step_id)
              ? { scientific_constraints: getWonderLabsScienceGuardrail(sourceContext?.step_id) }
              : {}),
            active_activity: {
              type: mediaAsset.type,
              activity_id: mediaAsset.activityId || null,
              source_video_id: mediaAsset.videoId || null,
              tag_id: mediaAsset.tagId || null,
              source_pwo_id: mediaAsset.pwoId || null,
              scene_name: mediaAsset.sceneName || null,
              label: mediaAsset.label || null,
              mission: mediaAsset.mission || null,
              // Do not assert undocumented PWO controls. The native scene
              // screenshot/metadata remains the authority for affordances.
            },
          }
        : sourceContext;

      if (!effectiveJourneyContext) {
        console.warn(
          "[JOURNEY ASK] No Journey context is available yet."
        );
        return;
      }

      // Freeze the exact video frame/timestamp before the existing Ask handler
      // captures it. Do not auto-resume: the child controls when to play again.
      if (journeySelfGuidedFocus && mediaAsset?.type === "video") {
        journeyVideoInterruptedSpeechRef.current = false;
        try { videoRef.current?.pause?.(); } catch (_error) { /* media may have closed */ }
      }

      const shouldStartNewDialog = !journeyConversationStarted;

      setJourneyConversationStarted(true);
      setInputValue("");

      // Media observations need stricter teaching discipline than a generic
      // AI Tutor request. Retain the child's natural question for history/UX,
      // but supply a scoped instruction to the existing backend. This applies
      // to videos and 3D models in EVERY flagged WonderLabs journey.
      const earlierMediaHints = journeySelfGuidedFocus && mediaAsset
        ? (Array.isArray(history) ? history : []).filter((entry) =>
            entry?._swanMediaAsk &&
            entry?._swanMediaAssetKey ===
              `${mediaAsset.type}:${mediaAsset.videoId || mediaAsset.pwoId || mediaAsset.activityId || ""}` &&
            String(entry?._swanMediaStepId || "") === String(effectiveJourneyContext?.step_id || "") &&
            isMediaHint(entry?.question)
          ).length
        : 0;
      const mediaTeachingInstructions = journeySelfGuidedFocus && mediaAsset
        ? buildWonderLabsMediaTeachingInstructions({
            question: text,
            stepId: effectiveJourneyContext?.step_id,
            assetType: mediaAsset.type,
            activityTitle: mediaAsset.label,
            activityMission: mediaAsset.mission,
            sceneName: mediaAsset.sceneName,
            previousHintRequests: earlierMediaHints,
          })
        : null;
      handleAskButtonPress(text, {
        ...extraOptions,
        ...(mediaTeachingInstructions ? {
          customInstructions: [
            typeof extraOptions.customInstructions === "string"
              ? extraOptions.customInstructions
              : extraOptions.customInstructions
                ? JSON.stringify(extraOptions.customInstructions) : null,
            mediaTeachingInstructions,
          ].filter(Boolean).join("\n"),
        } : {}),
        journeyContext: effectiveJourneyContext,
        skipReferences: true,
        answer_length: journeySelfGuidedFocus && mediaAsset ? "short" : undefined,
        swanMediaAsk: Boolean(journeySelfGuidedFocus && mediaAsset),
        swanMediaGuardBlockId: effectiveJourneyContext?.activity_progress?.inquiry_guard?.block_id || null,
        swanMediaAssetKey: mediaAsset
          ? `${mediaAsset.type}:${mediaAsset.videoId || mediaAsset.pwoId || mediaAsset.activityId || ""}`
          : null,
        forceNewDialog:
          extraOptions.forceNewDialog ?? shouldStartNewDialog,
      });
    };

  // BDD 07/29/2026 - Journey
  const updateJourneyContextForAsset = (asset) => {
    const step = journeyActiveStepForWorkspace;

    setJourneyAiContext((current) => ({
      ...(current || {}),

      journey_id:
        current?.journey_id ??
        journeyRuntime?.journey_id ??
        journeyRuntime?.id ??
        null,

      journey_slug:
        current?.journey_slug ??
        journeyRuntime?.slug ??
        journeyRuntime?.manifest?.slug ??
        null,

      step_id:
        current?.step_id ??
        step?.step_id ??
        step?.id ??
        null,

      step_title:
        current?.step_title ??
        step?.title ??
        step?.name ??
        null,

      learning_goal:
        current?.learning_goal ??
        step?.learning_goal ??
        step?.objective ??
        step?.description ??
        null,

      student_work:
        current?.student_work || {
          observations: (
            journeySessionState?.observations || []
          ).filter((value) => String(value || "").trim()),

          different_artwork_id:
            journeySessionState?.differentArtworkId || null,

          difference_reason:
            journeySessionState?.differenceReason || null,

          initial_theory:
            journeySessionState?.theory || null,
        },

      active_activity: {
        type: asset.type,
        activity_id: asset.activityId || null,
        source_video_id: asset.videoId || null,
        tag_id: asset.tagId || null,
        source_pwo_id: asset.pwoId || null,
        scene_name: asset.sceneName || null,
        label: asset.label || null,
      },
    }));
  };

  const openJourneyVideo = async (
    videoID,
    tagID,
    videoAuthToken,
    chapterID = null,
    topicID = null,
    isAuto = false,
    walkthroughStepOverride = null,
    walkthroughRefsOverride = null,
    displayLabel = null
  ) => {
    if (journeyMediaLaunchRef.current) return;
    journeyMediaLaunchRef.current = true;
    setJourneyMediaLaunchPending(true);
    const asset = {
      type: "video",
      videoId: videoID,
      tagId: tagID,
      label: displayLabel || t("Journey Video"),
    };

    stopTtsStream();
    setJourneyActiveAsset(asset);
    setJourneyRightTab("journey");
    updateJourneyContextForAsset(asset);

    try {
      return await handleVideoClick(
        videoID,
        tagID,
        videoAuthToken,
        chapterID,
        topicID,
        isAuto,
        walkthroughStepOverride,
        walkthroughRefsOverride,
        displayLabel,
        0 // Journey collection videos do not have the legacy 11-second preamble  // BDD 08/03/2026 - jouney notebook llm video starting at 11 seconds temp fix
      );
    } catch (error) {
      setJourneyActiveAsset(null);
      throw error;
    } finally {
      journeyMediaLaunchRef.current = false;
      setJourneyMediaLaunchPending(false);
    }
  };

  const openJourneyPwo = async (
    pwoID,
    sceneName,
    pwoAuthToken,
    pwoLang,
    chapterID = null,
    topicID = null,
    isAuto = false,
    walkthroughStepOverride = null,
    walkthroughRefsOverride = null,
    activityInfo = null
  ) => {
    if (journeyMediaLaunchRef.current) return;
    journeyMediaLaunchRef.current = true;
    setJourneyMediaLaunchPending(true);
    const asset = {
      type: "pwo",
      pwoId: pwoID,
      sceneName,
      activityId: activityInfo?.activityId || null,
      mission: activityInfo?.mission || null,
      label: activityInfo?.title || sceneName || t("Journey 3D Exploration"),
    };

    stopTtsStream();
    setJourneyActiveAsset(asset);
    setJourneyRightTab("journey");
    updateJourneyContextForAsset(asset);

    // The only new provider is an explicit stable ID; native numeric PWOs
    // continue through the original Unity backend/UUID/asset-bundle path.
    if (isThreeJsPwo(pwoID)) {
      try {
        if (Platform.OS !== "web" || typeof window === "undefined") {
          throw new Error("Three.js assembly pilot currently supports web only");
        }
        const url = buildThreeJsPwoUrl(pwoID, sceneName, window.location.origin);
        // Honor the same close gate used by the native media launch path.
        const canClose = await handleCloseModule(true);
        if (canClose === false) return;
        setThreePwoUrl(url);
        setThreePwoActive(true);
        setShowVideo(false);
        setShowPwo(true);
        setActiveModule("pwo");
        setCurrentPwoId(pwoID);
        setCurrentPwoScene(sceneName);
        setIsPwoOpen(true);
        setLoading(false);
        return;
      } catch (error) {
        console.error("[WonderLabs Three.js] Failed to open", error);
        setJourneyActiveAsset(null);
        throw error;
      } finally {
        journeyMediaLaunchRef.current = false;
        setJourneyMediaLaunchPending(false);
      }
    }

    try {
      return await handlePWOClick(
        pwoID,
        sceneName,
        pwoAuthToken,
        pwoLang,
        chapterID,
        topicID,
        isAuto,
        walkthroughStepOverride,
        walkthroughRefsOverride
      );
    } catch (error) {
      setJourneyActiveAsset(null);
      throw error;
    } finally {
      journeyMediaLaunchRef.current = false;
      setJourneyMediaLaunchPending(false);
    }
  };

  // Only accept scene notifications from our selected Three.js frame/origin.
  // Captures use a separate one-shot request_id listener below.
  useEffect(() => {
    if (!threePwoActive || !threePwoUrl || typeof window === "undefined") return;
    const expectedOrigin = new URL(threePwoUrl).origin;
    const onScene = (event) => {
      if (event.source !== threePwoFrameRef.current?.contentWindow ||
          event.origin !== expectedOrigin) return;
      const m = event.data || {};
      const activePwoId = new URL(threePwoUrl).searchParams.get("pwo_id");
      if (m.pwo_id !== activePwoId) return;
      if (m.type === "wonderlabs:pwo:close") {
        handleJourneyStageClose();
        return;
      }
      if (m.type !== "wonderlabs:pwo:scene-changed" ||
          !isKnownThreeJsPwoScene(activePwoId, m.scene_name)) return;
      setCurrentPwoScene(m.scene_name);
      currentPwoSceneRef.current = m.scene_name;
      setJourneyActiveAsset((old) => old?.pwoId === activePwoId
        ? { ...old, sceneName: m.scene_name } : old);
    };
    window.addEventListener("message", onScene);
    return () => window.removeEventListener("message", onScene);
  }, [threePwoActive, threePwoUrl]);

  // One exit for a tile-launched WonderLabs mission. Flush the current
  // learner's last edits before unmounting (closeJourney cancels the existing
  // debounce). A failed save keeps the Journey open so work is not discarded.
  // Start Mission must survive a refresh even if the learner has not yet
  // submitted any Phase 1 evidence. Store this one fact INSIDE the existing
  // server-owned Journey session, not in localStorage or a new endpoint.
  // Do not mark any authored block complete or advance the phase index.
  const beginWonderLabsMission = async () => {
    if (wonderLabsStarting) return;
    if (hasMeaningfulJourneyState({
      session_state: journeySessionState,
      step_index: journeyStepIndex,
      visited_through_index: journeyVisitedThroughIndex,
    })) {
      // Returning child: revisiting Mission Home must not write new state.
      setWonderLabsWelcomeOpen(false);
      return;
    }
    setWonderLabsStarting(true);
    try {
      const journeyId = journeyRuntime?.journey_id ?? journeyRuntime?.id;
      const nextSession = normalizeJourneySessionState({
        ...journeySessionState, wonderlabs_started: true,
      });
      const payload = {
        session_state: nextSession,
        step_index: journeyStepIndex,
        visited_through_index: journeyVisitedThroughIndex,
      };
      if (journeyId != null && activeJourneyStudentId &&
          activeJourneyStudentId !== "Guest" && !isPreviewingStudentJourney) {
        const runtimeSteps = Array.isArray(journeyRuntime?.steps)
          ? journeyRuntime.steps : Array.isArray(journeyRuntime?.runtime?.steps)
            ? journeyRuntime.runtime.steps : [];
        const activeStep = runtimeSteps[journeyStepIndex];
        await queueWonderLabsR2Save(journeyId, activeJourneyStudentId, payload,
          activeStep?.step_id || activeStep?.id || null);
      }
      setJourneySessionState(nextSession);
      setWonderLabsWelcomeOpen(false);
    } catch (error) {
      console.error("[WONDERLABS] Could not start mission:", error);
      if (Platform.OS === "web" && typeof window !== "undefined" && typeof window.alert === "function") {
        window.alert("Could not save your place. Check your connection and try Start Mission again.");
      } else {
        Alert.alert("Could not start mission", "Check your connection and try again.");
      }
    } finally {
      setWonderLabsStarting(false);
    }
  };

  const exitWonderLabsAdventure = async () => {
    if (wonderLabsExitInFlightRef.current) return;
    wonderLabsExitInFlightRef.current = true;
    try {
      if (journeySaveTimeoutRef.current) {
        clearTimeout(journeySaveTimeoutRef.current);
        journeySaveTimeoutRef.current = null;
      }
      const journeyId = journeyRuntime?.journey_id ?? journeyRuntime?.id;
      if (journeyId != null && activeJourneyStudentId && activeJourneyStudentId !== "Guest" &&
          !isPreviewingStudentJourney && journeyStateHydratedRef.current) {
        const runtimeSteps = Array.isArray(journeyRuntime?.steps)
          ? journeyRuntime.steps
          : Array.isArray(journeyRuntime?.runtime?.steps)
            ? journeyRuntime.runtime.steps
            : [];
        const savedStepIndex = wonderLabsDirectLaunchRef.current && isWonderLabsLearningBeatsEnabled()
          ? wonderLabsCheckpointStepRef.current : journeyStepIndex;
        const payload = {
          session_state: normalizeJourneySessionState(journeySessionState),
          step_index: savedStepIndex,
          visited_through_index: journeyVisitedThroughIndex,
        };
        const serialized = JSON.stringify(payload);
        if (wonderLabsDirectLaunchRef.current && isWonderLabsLearningBeatsEnabled()) {
          const currentStep = runtimeSteps[savedStepIndex];
          // Wait for earlier automatic saves, then commit the newest snapshot.
          // Never exit to the adventure tiles before that save succeeds.
          await queueWonderLabsR2Save(journeyId, activeJourneyStudentId, payload,
            currentStep?.step_id || currentStep?.id || null);
        } else if (serialized !== lastSavedJourneyStateRef.current) {
          const currentStep = runtimeSteps[journeyStepIndex];
          await axios.put(
            `${FASTAPI_BASE_URL}/student/${encodeURIComponent(activeJourneyStudentId)}/journeys/${journeyId}/state`,
            {
              state_json: payload,
              last_active_step_id: currentStep?.step_id || currentStep?.id || null,
            },
            authToken ? {
              headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
              },
            } : undefined
          );
          lastSavedJourneyStateRef.current = serialized;
        }
      }
      closeJourney();
      setShowRegularHomeWithSwanFlag(false);
      setActiveModule("home");
    } catch (error) {
      console.error("[WONDERLABS] Could not save before leaving:", error);
      if (Platform.OS === "web" && typeof window !== "undefined" && typeof window.alert === "function") {
        window.alert("Could not save your progress. Please check your connection and try again.");
      } else {
        Alert.alert("Could not save your progress", "Please check your connection and try again.");
      }
    } finally {
      wonderLabsExitInFlightRef.current = false;
    }
  };

   // BDD 07/28/2026 - Journey
  const renderJourneyWorkspace = () => {
    // Classroom presentation owns the whole Journey viewport: no TOC or normal
    // Saras rail. Step navigation is local to the presenter. The loaded content
    // keeps its existing ownership policy: teacher-owned state is editable and
    // saved; a selected student's state is projected read-only.
    if (journeyPresentMode || journeySelfGuidedFocus) {
      const isSelfGuidedFocus = journeySelfGuidedFocus && !journeyPresentMode;
      const selectedMission = WONDERLABS_MISSIONS.find((mission) =>
        mission.slug === wonderLabsWelcomeSlug
      );
      // The same loaded Journey remains mounted in AITutorApp while its
      // activity workspace is replaced by the welcome view. Saved answers,
      // current phase and media-return activity cursor stay in memory.
      if (isSelfGuidedFocus && wonderLabsWelcomeOpen && selectedMission) {
        return (
          <WonderLabsMissionWelcome
            mission={selectedMission}
            isDarkMode={isDarkMode}
            isReturning={hasMeaningfulJourneyState({
              session_state: journeySessionState,
              step_index: journeyStepIndex,
              visited_through_index: journeyVisitedThroughIndex,
            })}
            phaseIndex={wonderLabsCheckpointStepRef.current}
            phaseCount={Array.isArray(journeyRuntime?.steps)
              ? journeyRuntime.steps.length : Array.isArray(journeyRuntime?.runtime?.steps)
                ? journeyRuntime.runtime.steps.length : 9}
            starting={wonderLabsStarting}
            onStart={beginWonderLabsMission}
            onBack={exitWonderLabsAdventure}
          />
        );
      }

      return (
        <JourneyPresentMode
          journey={journeyRuntime}
          displayTitle={isSelfGuidedFocus ? selectedMission?.title : null}
          stepIndex={isSelfGuidedFocus ? journeyStepIndex : journeyPresentStepIndex}
          visitedThroughIndex={isSelfGuidedFocus ? journeyVisitedThroughIndex : journeyPresentStepIndex}
          onStepChange={
            isSelfGuidedFocus
              ? (nextIndex, details) => {
                  if (wonderLabsDirectLaunchRef.current && isWonderLabsLearningBeatsEnabled()) {
                    const plan = planStepMove({
                      currentIndex: journeyStepIndex,
                      nextIndex,
                      checkpointIndex: wonderLabsCheckpointStepRef.current,
                      reviewing: wonderLabsReviewingRef.current,
                      explicitSelection: ["manual", "evidence-recovery"].includes(details?.intent),
                    });
                    wonderLabsReviewingRef.current = plan.reviewing;
                    wonderLabsCheckpointStepRef.current = plan.checkpointIndex;
                    if (!plan.reviewing) {
                      // Save the new Step's Part 1 cursor on a real forward
                      // transition, including when no answer is entered there.
                      setJourneySessionState((previous) => ({
                        ...previous,
                        wonderlabs_activity_cursors: copyActivityCursors(
                          wonderLabsActivityCursorRef.current),
                      }));
                    }
                  }
                  setJourneyStepIndex(nextIndex);
                  setJourneyVisitedThroughIndex((current) =>
                    Math.max(current, nextIndex)
                  );
                }
              : setJourneyPresentStepIndex
          }
          authToken={authToken}
          userId={user?.email}
          localLanguage={getLocalLanguage(
            langRef.current && langRef.current !== "auto"
              ? langRef.current
              : (lang || "en")
          )}
          lang={lang}
          isDarkMode={isDarkMode}
          handleVideoClick={openJourneyVideo}
          handlePWOClick={openJourneyPwo}
          sessionState={journeySessionState}
          activityCursorRef={wonderLabsActivityCursorRef}
          onActivityCursorChange={isSelfGuidedFocus && isWonderLabsLearningBeatsEnabled()
            ? recordWonderLabsR2ActivityCursor : undefined}
          onSessionStateChange={
            isPreviewingStudentJourney ? undefined : setJourneySessionState
          }
          readOnly={isPreviewingStudentJourney}
          presentationLabel={
            isSelfGuidedFocus
              ? t("Professor Swan is guiding your mission")
              : isPreviewingStudentJourney
                ? `${t("Presenting")}: ${
                    journeyPreviewStudent?.name ||
                    journeyPreviewStudent?.email ||
                    t("Student")
                  } · ${t("Read only")}`
                : `${t("Presenting")}: ${t("My work")}`
          }
          experienceMode={isSelfGuidedFocus ? "self_guided_focus" : "teacher_present"}
          swanPanelPreference={isSelfGuidedFocus ? journeySwanPanelPreference : undefined}
          onSwanPanelPreferenceChange={isSelfGuidedFocus ? setJourneySwanPanelPreference : undefined}
          swanReadAloudPreference={isSelfGuidedFocus ? journeySwanReadAloudEnabled : undefined}
          onSwanReadAloudPreferenceChange={isSelfGuidedFocus ? updateJourneySwanReadAloud : undefined}
          onContextChange={isSelfGuidedFocus ? setJourneyAiContext : undefined}
          onMissionHome={isSelfGuidedFocus && selectedMission
            ? () => setWonderLabsWelcomeOpen(true) : undefined}
          exitLabel={isSelfGuidedFocus && wonderLabsPreviewEnabled && wonderLabsDirectLaunchRef.current
            ? "Back to adventures"
            : undefined}
          onExit={
            isSelfGuidedFocus
              ? (wonderLabsPreviewEnabled && wonderLabsDirectLaunchRef.current
                ? exitWonderLabsAdventure
                : () => setJourneyMode("teacher_led"))
              : exitJourneyPresentMode
          }
          t={t}
        />
      );
    }

    const journeyTocVisible = width >= 1180;

    const journeyTocWidth = Math.min(
      280,
      Math.max(230, Math.round(width * 0.18))
    );
    const journeyRailVisible = width >= 1100;

    const journeyRailWidth = Math.min(
      430,
      Math.max(340, Math.round(width * 0.3))
    );

    const journeySuggestions =
      journeyAiContext?.suggested_questions || [];

    return (
      <View
        style={{
          flex: 1,
          width: "100%",
          minHeight: 0,
          padding: 12,
          backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc",
        }}
      >
        {journeyPreviewStudent && (
          <View
            style={{
              marginBottom: 12,
              paddingHorizontal: 16,
              paddingVertical: 12,
              borderRadius: 16,
              borderWidth: 1,
              borderColor: isDarkMode ? "rgba(56,189,248,0.35)" : "#bae6fd",
              backgroundColor: isDarkMode ? "rgba(14,165,233,0.14)" : "#eff6ff",
            }}
          >
            <Text
              style={{
                color: isDarkMode ? "#e0f2fe" : "#075985",
                fontSize: 12,
                fontWeight: "800",
                letterSpacing: 0.6,
                textTransform: "uppercase",
                marginBottom: 4,
              }}
            >
              {t("Student Journey Preview")}
            </Text>
            <Text
              style={{
                color: isDarkMode ? "#f8fafc" : "#0f172a",
                fontSize: 16,
                fontWeight: "700",
              }}
            >
              {t("Viewing journey for")} {journeyPreviewStudent?.name || journeyPreviewStudent?.email}
            </Text>
            <Text
              style={{
                color: isDarkMode ? "#cbd5e1" : "#475569",
                fontSize: 13,
                marginTop: 4,
              }}
            >
              {t("This preview uses the student's saved journey state and does not overwrite it.")}
            </Text>
          </View>
        )}

        <View
          style={{
            flex: 1,
            minHeight: 0,
            flexDirection: "row",
            gap: 12,
          }}
        >

        {/* Persistent Journey table of contents */}
        {journeyTocVisible && (
          <View
            style={{
              width: journeyTocWidth,
              minWidth: journeyTocWidth,
              flexShrink: 0,
              minHeight: 0,
              overflow: "hidden",
              borderRadius: 16,
            }}
          >
            <JourneyTableOfContents
              journey={journeyRuntime}
              activeStepIndex={journeyStepIndex}
              visitedThroughIndex={journeyVisitedThroughIndex}
              onStepChange={(nextIndex) => {
                setJourneyStepIndex(nextIndex);
                setJourneyVisitedThroughIndex((current) =>
                  Math.max(current, nextIndex)
                );
              }}
              isDarkMode={isDarkMode}
              phaseLabels={journeyPhaseLabelsForWorkspace}
              lang={lang}
              t={t}
            />
          </View>
        )}

        {/* Journey lesson area */}
        <View
          style={{
            flex: 1,
            minWidth: 0,
            minHeight: 0,
          }}
        >
          <JourneyPanel
            journey={journeyRuntime}
            authToken={authToken}
            lang={lang}
            isDarkMode={isDarkMode}
            activeStepIndex={journeyStepIndex}
            onStepChange={(nextIndex) => {
              setJourneyStepIndex(nextIndex);
              setJourneyVisitedThroughIndex((current) =>
                Math.max(current, nextIndex)
              );
            }}
            handleVideoClick={openJourneyVideo}
            handlePWOClick={openJourneyPwo}
            onAsk={(question, journeyContext) =>
              handleJourneyAsk(question, journeyContext)
            }
            onContextChange={setJourneyAiContext}

            // BDD 07/29/2026
            sessionState={journeySessionState}
            onSessionStateChange={setJourneySessionState}
            readOnly={isPreviewingStudentJourney}

            journeyMode={journeyMode}
            onJourneyModeChange={isPreviewingStudentJourney ? undefined : setJourneyMode}
            onPresent={isTeacher ? enterJourneyPresentMode : undefined}
            onClose={closeJourney}
            t={t}
          />
        </View>

        {/* Existing Saras AI rail */}
        {journeyRailVisible && (
          <View
            style={{
              width: journeyRailWidth,
              minWidth: journeyRailWidth,
              flexShrink: 0,
              minHeight: 0,
              overflow: "hidden",
              borderRadius: 16,
            }}
          >
            <SuggestionRail
              key={`journey-saras-${
                journeyRuntime?.journey_id ||
                journeyRuntime?.id ||
                "active"
              }`}
              t={t}
              isDarkMode={isDarkMode}
              idleSubtitle={
                journeyMode === "self_guided"
                  ? "Professor Swan · your STEM guide"
                  : "Journey investigation"
              }

              sparksMapped={[]}
              suggestedQuestions={journeySuggestions}
              suggestedQuestionsHeader={[
                journeyMode === "self_guided"
                  ? t("Ask Professor Swan")
                  : t("Investigate with Saras"),
              ]}

              onAsk={(question, extraOptions = {}) =>
                handleJourneyAsk(
                  question,
                  journeyAiContext,
                  extraOptions
                )
              }

              viewMode="journey"
              userId={user_id}
              activeCollectionId={null}
              suggestedQuestionsMeta={null}
              customWidth={journeyRailWidth}

              answerStyle={answerStyle}
              setAnswerStyle={setAnswerStyle}

              inputValue={inputValue}
              setInputValue={setInputValue}

              onInputSubmit={(text) =>
                handleJourneyAsk(text, journeyAiContext)
              }

              placeholder={t(
                journeyMode === "self_guided"
                  ? "Ask Professor Swan for a hint..."
                  : "Ask Saras about this investigation..."
              )}

              loading={loading}

              chatSessions={chatSessions}
              sessionsLoading={sessionsLoading}
              selectedConversationId={selectedConversationId}
              openChatSession={openChatSession}
              closeChatSession={closeChatSession}
              sessionTurnsLoading={sessionTurnsLoading}
              formatLocalDate={formatLocalDate}

              history={
                journeyConversationStarted ? history : []
              }

              renderHistorySection={renderHistorySection}
              authToken={authToken}

              handleVideoClick={openJourneyVideo}
              handlePWOClick={openJourneyPwo}
              handleChapterClick={handleChapterClick}
              handleCollectionClick={handleCollectionClick}

              onVoiceInput={handleVoiceInput}
              isListening={isListening}
              styles={styles}

              isMuted={isMuted}
              isPlaying={isPlaying}
              audioUrl={audioUrl}
              onToggleMute={handleToggleMute}
              onPlayAnswer={handlePlayAnswer}
              onStopAudio={stopAudio}
            />
          </View>
        )}
        </View>
      </View>
    );
  };

  // Lesson in a Box 2026-08-13 — the Lessons module landing page.
  // Same launcher component as the dashboard, given the whole content area.
  // The Learning module's PWO stage, unchanged. Lessons deliberately do NOT
  // use this — see components/lessonPlans/LessonPwoPlayer.js for why.
  const renderPwoStage = () => {
    if (!(showPwo || pwoKeepAlive)) return null;
    if (threePwoActive) {
      return (
        <View style={{ position: "relative", width: "100%", minHeight: 570,
                       flex: stageMaximized ? 1 : undefined,
                       height: stageMaximized ? "100%" : undefined }}>
          <iframe ref={threePwoFrameRef} title={threePwoUrl.includes("food-delivery-robot") ? "Food Delivery Robot 3D assembly guide" : "Doodle Robot 3D assembly guide"}
            src={threePwoUrl} loading="eager" allow="fullscreen"
            style={{ border: 0, width: "100%", height: stageMaximized ? "100%" : 660,
                     background: "#e6f0f5", borderRadius: 12 }} />
          <TouchableOpacity onPress={handleJourneyStageClose}
            accessibilityRole="button"
            accessibilityLabel="Close 3D assembly guide and return to activity"
            style={{
              position: "absolute",
              top: 2,
              right: 35,
              zIndex: 100,
              width: 36,
              height: 36,
              borderRadius: 18,
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              backdropFilter: "blur(12px)",
              WebkitBackdropFilter: "blur(12px)",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            activeOpacity={0.8}>
            <MaterialCommunityIcons name="close" size={20} color="#fff" />
          </TouchableOpacity>
        </View>
      );
    }

    return (
                  <View style={{
                    // When keepalive is on but PWO isn't visible, keep the iframe mounted
                    // without affecting layout (so Unity stays warm).
                    ...(pwoKeepAlive && !showPwo ? {
                      position: "fixed",
                      left: 0,
                      top: 0,
                      width: 1,
                      height: 1,
                      overflow: "hidden",
                      pointerEvents: "none",
                      opacity: 0,
                    } : {
                      position: "relative",
                      flex: stageMaximized ? undefined : 1,
                      overflow: 'auto',  // Show scrollbars when iframe overflows
                      maxWidth: '100%',
                      backgroundColor: stageMaximized ? '#000' : undefined,
                    }),
                    // In fullscreen: fill available space and center content
                    ...(stageMaximized ? {
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      overflow: 'hidden',  // No scrollbars in fullscreen
                    } : {
                      // Non-fullscreen: allow scrolling
                      width: '100%',
                    }),

                    // SBS 3D Phase 1: current Unity already outputs packed SBS,
                    // so it takes over the entire physical browser framebuffer.
                    ...(sbs3dPwoTakeover ? {
                      position: "fixed",
                      left: 0,
                      top: 0,
                      width: "100vw",
                      height: "100vh",
                      maxWidth: "none",
                      zIndex: 2147483600,
                      backgroundColor: "#000",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "hidden",
                    } : {}),
                  }}>
                    {/* PWO iframe - fixed native size, will overflow and create scrollbars */}
                    <iframe
                      id="pwoIframe"
                      ref={pwoIframeRef}
                      src="about:blank"
                      allow="cross-origin"
                      scrolling="no"
                      style={{
                        border: "none",
                        display: "block",
                        // Fixed native dimensions - will overflow container when smaller
                        ...(pwoKeepAlive && !showPwo ? {
                          width: 1,
                          height: 1,
                          minWidth: 1,
                          minHeight: 1,
                          pointerEvents: "none",
                          opacity: 0,
                        } : {
                          width: PWO_NATIVE_WIDTH,
                          height: PWO_NATIVE_HEIGHT,
                          minWidth: PWO_NATIVE_WIDTH,
                          minHeight: PWO_NATIVE_HEIGHT,
                        }),
                        backgroundColor: '#000',
                        // Apply uniform zoom scale to maintain 16:9 aspect ratio
                        transform: sbs3dPwoTakeover
                          ? `scale(${sbs3dPwoScale})`
                          : (stageMaximized
                            ? `scale(${fullscreenAutoScale * pwoScale})`
                            : `scale(${pwoScale})`),
                        transformOrigin: (sbs3dPwoTakeover || stageMaximized) ? "center center" : "top left",
                        // Prevent black screen on zoom by keeping layer GPU-composited
                        willChange: "transform",
                        backfaceVisibility: "hidden",
                      }}
                    />

                    {/* SBS 3D Phase 1D: AITutor-owned eye-safe handoff cover.
                        Unity boots and receives CamMode=3D_0 underneath this cover.
                        Each eye gets the same logical 1920-wide scene compressed into
                        its physical half, so the projector reconstructs one flat image. */}
                    {sbs3dPwoTakeover && sbs3dPwoCoverVisible && (
                      <View
                        pointerEvents="none"
                        style={{
                          position: "fixed",
                          left: 0,
                          top: 0,
                          width: "100vw",
                          height: "100vh",
                          zIndex: 2147483645,
                          backgroundColor: "#05070b",
                          overflow: "hidden",
                        }}
                      >
                        {[0, 1].map((eyeIndex) => (
                          <View
                            key={`sbs3d-pwo-cover-eye-${eyeIndex}`}
                            style={{
                              position: "absolute",
                              left: eyeIndex === 0 ? 0 : "50%",
                              top: 0,
                              width: "50%",
                              height: "100%",
                              overflow: "hidden",
                              backgroundColor: "#05070b",
                            }}
                          >
                            <View
                              style={{
                                width: "100vw",
                                height: "100vh",
                                transform: "scaleX(0.5)",
                                transformOrigin: "0 0",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#05070b",
                              }}
                            >
                              <View style={{ alignItems: "center", justifyContent: "center", padding: 28 }}>
                                <MaterialCommunityIcons name="cube-scan" size={72} color="#ffffff" />
                                <Text
                                  style={{
                                    marginTop: 18,
                                    color: "#ffffff",
                                    fontSize: 28,
                                    fontWeight: "700",
                                    textAlign: "center",
                                  }}
                                >
                                  {t("Loading 3D experience…")}
                                </Text>
                                <Text
                                  style={{
                                    marginTop: 8,
                                    marginBottom: 22,
                                    color: "rgba(255,255,255,0.72)",
                                    fontSize: 16,
                                    textAlign: "center",
                                  }}
                                >
                                  {t("Preparing stereoscopic view")}
                                </Text>
                                <ActivityIndicator size="large" color="#ffffff" />
                              </View>
                            </View>
                          </View>
                        ))}
                      </View>
                    )}

                    {/* PWO Controls - Close at top-right, Zoom dock at bottom-left */}
                    {!sbs3dProjectorMode && showStageControls && (showPwo || activeModule === "pwo") && (
                      <>
                        {/* Close button - Top right corner - BDD 07/29/2026 Journey - changed onPress*/}
                        <TouchableOpacity
                          onPress={handleJourneyStageClose}
                          style={{
                            position: "absolute",
                            top: 2,
                            right: 35,
                            zIndex: 70,
                            width: 36,
                            height: 36,
                            borderRadius: 18,
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "rgba(0, 0, 0, 0.6)",
                            backdropFilter: "blur(12px)",
                            WebkitBackdropFilter: "blur(12px)",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                            border: "1px solid rgba(255, 255, 255, 0.1)",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                          }}
                          activeOpacity={0.8}
                        >
                          <MaterialCommunityIcons name="close" size={20} color="#fff" />
                        </TouchableOpacity>

                        {/* Keep zoom out of the caption/native playback-control zone
                            in the child-facing Journey. Normal AI Tutor is unchanged. */}
                        {isWebGLReady && (
                          <View
                            style={{
                              position: "absolute",
                              bottom: journeySelfGuidedFocus ? undefined : 24,
                              top: journeySelfGuidedFocus ? 48 : undefined,
                              left: journeySelfGuidedFocus ? 12 : '45%',
                              right: journeySelfGuidedFocus ? undefined : 0,
                              alignItems: "center",
                              justifyContent: "center",
                              zIndex: 2147483500,
                              width:184
                            }}
                          >
                            <View
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                backgroundColor: "rgba(0, 0, 0, 0.6)",
                                backdropFilter: "blur(12px)",
                                WebkitBackdropFilter: "blur(12px)",
                                borderRadius: 22,
                                paddingHorizontal: 4,
                                paddingVertical: 4,
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                                border: "1px solid rgba(255, 255, 255, 0.1)",
                                gap: 2,
                              }}
                            >
                              {/* Zoom out */}
                              <TouchableOpacity
                                onPress={() => zoomPwo(-PWO_ZOOM_STEP)}
                                disabled={pwoScale <= MIN_PWO_ZOOM + 1e-6}
                                style={{
                                  width: 36,
                                  height: 36,
                                  borderRadius: 18,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: pwoScale <= MIN_PWO_ZOOM + 1e-6 ? "not-allowed" : "pointer",
                                  transition: "all 0.15s ease",
                                }}
                                activeOpacity={0.7}
                              >
                                <MaterialCommunityIcons
                                  name="minus"
                                  size={20}
                                  color={pwoScale <= MIN_PWO_ZOOM + 1e-6 ? "rgba(255,255,255,0.3)" : "#fff"}
                                />
                              </TouchableOpacity>

                              {/* Zoom percentage - shows effective scale */}
                              <View style={{
                                paddingHorizontal: 8,
                                height: 36,
                                minWidth: 50,
                                alignItems: "center",
                                justifyContent: "center",
                              }}>
                                <Text style={{
                                  color: "#fff",
                                  fontSize: rem(13) + 'rem',
                                  fontWeight: "600",
                                  fontFamily: "monospace",
                                  textAlign: "center",
                                  letterSpacing: 0.5,
                                  userSelect: "none",
                                }}>
                                  {Math.round(pwoScale * 100)}%
                                </Text>
                              </View>

                              {/* Zoom in */}
                              <TouchableOpacity
                                onPress={() => zoomPwo(+PWO_ZOOM_STEP)}
                                disabled={pwoScale >= MAX_PWO_ZOOM - 1e-6}
                                style={{
                                  width: 36,
                                  height: 36,
                                  borderRadius: 18,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: pwoScale >= MAX_PWO_ZOOM - 1e-6 ? "not-allowed" : "pointer",
                                  transition: "all 0.15s ease",
                                }}
                                activeOpacity={0.7}
                              >
                                <MaterialCommunityIcons
                                  name="plus"
                                  size={20}
                                  color={pwoScale >= MAX_PWO_ZOOM - 1e-6 ? "rgba(255,255,255,0.3)" : "#fff"}
                                />
                              </TouchableOpacity>

                              {/* Divider */}
                              <View style={{
                                width: 1,
                                height: 20,
                                backgroundColor: "rgba(255, 255, 255, 0.2)",
                                marginHorizontal: 4,
                              }} />

                              {/* Fullscreen toggle */}
                              <TouchableOpacity
                                onPress={() => setStageMaximized((prev) => !prev)}
                                style={{
                                  width: 36,
                                  height: 36,
                                  borderRadius: 18,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  transition: "all 0.15s ease",
                                }}
                                activeOpacity={0.7}
                              >
                                <MaterialCommunityIcons
                                  name={stageMaximized ? "fullscreen-exit" : "fullscreen"}
                                  size={20}
                                  color="#fff"
                                />
                              </TouchableOpacity>
                            </View>
                          </View>
                        )}
                      </>
                    )}

                    {/* While Unity owns its blue-ball cursor / pointer lock, a browser
                        overlay cannot provide a truthful clickable X because the OS pointer
                        is not free to move to it. Show the same eye-safe instruction in both
                        physical halves; Esc releases Unity control and opens real browser
                        Resume / Exit controls. */}
                    {sbs3dPwoTakeover && !sbs3dPwoRecoveryVisible && (
                      <View
                        pointerEvents="none"
                        style={{
                          position: "fixed",
                          left: 0,
                          top: 0,
                          width: "100vw",
                          height: "100vh",
                          zIndex: 2147483646,
                        }}
                      >
                        {[0, 1].map((eyeIndex) => (
                          <View
                            key={`sbs3d-pwo-esc-hint-${eyeIndex}`}
                            style={{
                              position: "absolute",
                              top: 0,
                              left: eyeIndex === 0 ? 0 : "50%",
                              width: "50%",
                              height: "100%",
                            }}
                          >
                            <View
                              style={{
                                position: "absolute",
                                top: 8,
                                right: 12,
                                paddingHorizontal: 12,
                                paddingVertical: 7,
                                borderRadius: 12,
                                backgroundColor: "rgba(0,0,0,0.68)",
                                borderWidth: 1,
                                borderColor: "rgba(255,255,255,0.25)",
                              }}
                            >
                              <Text
                                style={{
                                  color: "#fff",
                                  fontSize: 12,
                                  fontWeight: "700",
                                }}
                              >
                                {t(sbs3dKioskMode ? "Esc • Return to AITutor" : "Esc • PWO controls")}
                              </Text>
                            </View>
                          </View>
                        ))}
                      </View>
                    )}
                  </View>
    );
  };

  // Capped and centred like the Class Insights page. `flexGrow` on the content
  // container plus `flex` on the frame is what puts the footer on the floor of a
  // short page instead of leaving one grid row adrift in empty space.
  const renderLessonPlanIndex = () => {
    const lessonColors = getLessonColors(isDarkMode);
    const lessonIndexWide = width >= 1200;
    const lessonIndexNarrow = width < 720;

    return (
      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={{ flexGrow: 1, alignItems: "center", paddingBottom: 0 }}
        showsVerticalScrollIndicator={false}
      >
        <View
          style={{
            width: "100%",
            maxWidth: LESSON_INDEX_MAX_WIDTH,
            // `flexGrow` without `flex`, deliberately. The page is one centred
            // composition, so it has to fill a tall viewport to sit in the
            // middle of it — but `flex: 1` also brings flexShrink, which on a
            // short laptop viewport would squeeze the composition instead of
            // letting the ScrollView scroll it.
            flexGrow: 1,
            justifyContent: "center",
            paddingHorizontal: lessonIndexNarrow ? 14 : lessonIndexWide ? 24 : 20,
            paddingVertical: lessonIndexNarrow ? 16 : 24,
          }}
        >
          <LessonPlanLauncher
            lessons={lessonPlanList}
            progressByLesson={lessonPlanProgress}
            loading={lessonPlanListLoading}
            error={lessonPlanListError}
            onOpenLesson={openLessonPlan}
            // Turns on the finder's fallback: a description whose words appear
            // in no lesson gets handed to Saras rather than answering "nothing
            // found". Without these two the finder is local ranking only —
            // which works, and would hide the fact that the fallback is dead.
            fetchWithAuth={fetchWithAuth}
            board={contentDb}
            // Offers the handler; it does not decide who gets it. Whether a
            // given lesson shows Edit is `can_edit` on that lesson, computed
            // server-side — a teacher may edit what they created and not the
            // shared library, and this boolean cannot tell those apart.
            onEditLesson={isTeacher ? (lesson) => setLessonWizardTarget(lesson.id) : undefined}
            isDarkMode={isDarkMode}
            // The index is the composition: one question, one box, one quiet
            // way to author. No title, no subtitle, no progress meter — there
            // is nothing else on this page for them to distinguish it from.
            layout="page"
            onCreateLesson={isTeacher ? () => setLessonWizardTarget("new") : undefined}
            // An uploaded lesson JSON becomes a draft; open it in the wizard.
            onLessonImported={
              isTeacher
                ? (lesson) => setLessonWizardTarget(lesson?.lesson_plan_id ?? lesson?.id ?? null)
                : undefined
            }
            // "Make my copy" on a lesson this teacher did not write. Teacher-only,
            // same as onEditLesson/onCreateLesson above — a student has nothing
            // to author or copy.
            onForkLesson={isTeacher ? onForkLesson : undefined}
            forkingLessonId={forkingLessonId}
            t={t}
          />

          {!lessonPlanListLoading && !lessonPlanListError && lessonPlanList.length === 0 && (
            <View
              style={{
                alignItems: "center",
                paddingVertical: 48,
                paddingHorizontal: 24,
              }}
            >
              <MaterialCommunityIcons
                name="clipboard-text-outline"
                size={40}
                color={isDarkMode ? "#475569" : "#cbd5e1"}
              />
              <Text
                style={{
                  marginTop: 12,
                  fontSize: 16,
                  fontWeight: "700",
                  color: lessonColors.textPrimary,
                }}
              >
                {t("No lesson plans yet")}
              </Text>
              <Text
                style={{
                  marginTop: 6,
                  fontSize: 13,
                  textAlign: "center",
                  color: lessonColors.textSecondary,
                }}
              >
                {t("No lesson plans have been published for this curriculum.")}
              </Text>
            </View>
          )}

        </View>
      </ScrollView>
    );
  };

  // Lesson in a Box 2026-08-13
  // Renders inside contentWrapper like any other module, so the top bar stays
  // put and the Saras rail stays available. Not an absolute overlay.
  const renderLessonPlanWorkspace = () => {
    // Present mode 2026-08-27 — the lesson IS the screen. No Saras rail, no
    // padding, no gap: the framing this function normally applies is exactly
    // what a projector must not show. App chrome hides separately, below.
    //
    // No sessionState and no answer callbacks reach the surface on purpose:
    // the room has no devices, so there is no individual student work to
    // record and nothing here may write any.
    if (lessonPresentMode) {
      return (
        <View
          style={{
            flex: 1,
            width: "100%",
            minHeight: 0,
            backgroundColor: isDarkMode ? "#0f172a" : "#ffffff",
          }}
        >
          <LessonPresentMode
            lesson={lessonPlanRuntime}
            stepIndex={lessonPlanStepIndex}
            onStepChange={setLessonPlanStepIndex}
            onExit={exitLessonPresentMode}
            isDarkMode={isDarkMode}
            // The scene and the video play on the slide itself here — the
            // workspace that normally owns those players is not mounted in
            // present mode. Same three values it passes them, and without the
            // token the PWO argument call comes back 422.
            authToken={authToken}
            languageId={Number(selectedSecondaryLang) || 1}
            localLanguage={getLocalLanguage(
              langRef.current && langRef.current !== "auto"
                ? langRef.current
                : (lang || "en")
            )}
            userId={user?.email}
            t={t}
          />
        </View>
      );
    }

    const lessonRailVisible = width >= 1280;
    const lessonRailWidth = Math.min(
      430,
      Math.max(340, Math.round(width * 0.28))
    );

    const activeLessonStep =
      lessonPlanStepIndex >= 0
        ? (lessonPlanRuntime?.steps || [])[lessonPlanStepIndex] || null
        : null;

    // Suggested questions come from the current step's authored ai_prompt
    // blocks, so the rail follows the lesson rather than showing generic prompts.
    const stepQuestions = (activeLessonStep?.blocks || [])
      .filter((block) => block?.type === "ai_prompt")
      .flatMap((block) => (Array.isArray(block.questions) ? block.questions : []));

    const lessonSuggestions = stepQuestions.length
      ? stepQuestions
      : [
          t("Explain this lesson's main idea in simple terms."),
          t("What is the most common misconception here?"),
          t("Give me another example of this."),
        ];

    return (
      <View
        style={{
          flex: 1,
          width: "100%",
          minHeight: 0,
          flexDirection: "row",
          gap: 12,
          padding: 12,
          backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc",
        }}
      >
        <View style={{ flex: 1, minWidth: 0, minHeight: 0 }}>
          <LessonPlanWorkspace
            lesson={lessonPlanRuntime}
            isDarkMode={isDarkMode}
            mode={lessonPlanMode}
            activeIndex={lessonPlanStepIndex}
            onActiveIndexChange={setLessonPlanStepIndex}
            sessionState={lessonPlanSessionState}
            onSessionStateChange={setLessonPlanSessionState}
            launchingBlockId={lessonPlanLaunchingBlockId}
            onLaunchBlock={handleLessonPlanLaunch}
            onAsk={handleLessonPlanAsk}
            // Without this the asset cards draw no summary control at all, and
            // the 179 authored PWO and video descriptions are unreachable
            // outside present mode. That was the bug.
            onShowSummary={showLessonPlanSummary}
            openAssetBlockId={lessonPlanActiveBlockId}
            onCloseAsset={() => setLessonPlanActiveBlockId(null)}
            authToken={authToken}
            languageId={Number(selectedSecondaryLang) || 1}
            localLanguage={getLocalLanguage(
              langRef.current && langRef.current !== "auto"
                ? langRef.current
                : (lang || "en")
            )}
            onOpenInsights={isTeacher ? openLessonInsights : undefined}
            fetchWithAuth={isTeacher ? fetchWithAuth : undefined}
            onPresent={resolveLessonPresentHandler({
              enabled: LESSON_PRESENT_MODE_ENABLED,
              isTeacher,
              enter: enterLessonPresentMode,
            })}
            onClose={closeLessonPlanFromJourney}
            onFinish={finishLessonPlanFromJourney}
            mastery={lessonPlanMastery}
            onAiEvaluate={handleLessonAiEvaluate}
            onExplorationEvent={handleLessonExplorationEvent}
            t={t}
          />
        </View>

        {/* The rail gives up its column while a summary is showing, and is
            UNMOUNTED rather than covered. Its composer is the only thing on
            this screen that could send a follow-up to a conversation that has
            never contained the author's words, so the guarantee that it cannot
            is that it is not in the tree.

            S4 — LessonSarasPanel wraps SuggestionRail here (lesson workspace
            only) to add the collapse control the SME review asked for. It
            owns the column width itself: expanded, it reports lessonRailWidth
            back via its own container; collapsed, 44px, and this flex row
            gives that reclaimed space to LessonPlanWorkspace on the left. */}
        {lessonRailVisible && !lessonPlanSummary && (
          <LessonSarasPanel
            key={`lesson-saras-${lessonPlanRuntime?.lesson_plan_id || "active"}`}
            railWidth={lessonRailWidth}
            isDarkMode={isDarkMode}
            t={t}
            railProps={{
              idleSubtitle: "Lesson investigation",

              sparksMapped: [],
              suggestedQuestions: lessonSuggestions,
              suggestedQuestionsHeader: [t("Investigate with Saras")],

              onAsk: (question) => handleLessonPlanAsk(question),

              viewMode: "lesson",
              userId: user_id,
              activeCollectionId: null,
              suggestedQuestionsMeta: null,

              answerStyle,
              setAnswerStyle,

              inputValue,
              setInputValue,
              onInputSubmit: (text) => handleLessonPlanAsk(text),
              placeholder: t("Ask Saras about this lesson..."),
              loading,

              chatSessions,
              sessionsLoading,
              selectedConversationId,
              openChatSession,
              closeChatSession,
              sessionTurnsLoading,
              formatLocalDate,

              history,
              renderHistorySection,
              authToken,

              handleVideoClick,
              handlePWOClick,
              handleChapterClick,
              handleCollectionClick,

              onVoiceInput: handleVoiceInput,
              isListening,
              styles,

              isMuted,
              isPlaying,
              audioUrl,
              onToggleMute: handleToggleMute,
              onPlayAnswer: handlePlayAnswer,
              onStopAudio: stopAudio,
            }}
          />
        )}

        {/* The author's words, in the rail's column where there is one and over
            the lesson where there is not — the control stays live below 1280px
            rather than opening a rail the viewport does not have. It takes no
            ask callback of any kind: see LessonSummarySurface. */}
        <LessonSummarySurface
          summary={lessonPlanSummary}
          isDarkMode={isDarkMode}
          railVisible={lessonRailVisible}
          railWidth={lessonRailWidth}
          onDismiss={dismissLessonPlanSummary}
          t={t}
        />
      </View>
    );
  };

  // AIT-250: studentHomeOnAskAI / studentHomeOnStats removed — Quick Actions
  // widget was replaced by RecentQuizzes / ProgressSummary / RecommendedNextSteps.
  // studentHomeOnBrowseTopics is retained — still used by ResumeCard fallback.

  const studentHomeOnBrowseTopics = () => {
    setLearningSubModule("modules");
    setActiveSidebarTab("collections");
    setActiveModule("learning");
  };

  const studentHomeOnActivityPress = async (activity) => {
    if (!activity) return;
    const waitForRender = () => new Promise((r) => setTimeout(r, 150));
    switch (activity.type) {
      case "video":
        if (activity.video_id && activity.tag_id) {
          if (activity.collection_id) {
            await handleCollectionClick({ collection_id: activity.collection_id, base_board: contentDb });
          } else if (activity.chapter_id) {
            navigateToCurriculumChapter(activity.chapter_id);
            await waitForRender();
          }
          await handleVideoClick(activity.video_id, activity.tag_id, authToken, activity.chapter_id || null, activity.board_topic_id || null);
        } else {
          setActiveModule("learning");
          setLearningSubModule("modules");
        }
        break;
      case "pwo":
        if (activity.pwo_id && (activity.pwo_scene_name || activity.title)) {
          if (activity.collection_id) {
            await handleCollectionClick({ collection_id: activity.collection_id, base_board: contentDb });
          } else if (activity.chapter_id) {
            navigateToCurriculumChapter(activity.chapter_id);
            await waitForRender();
          }
          await handlePWOClick(activity.pwo_id, activity.pwo_scene_name || activity.title, authToken, null, activity.chapter_id || null, activity.board_topic_id || null);
        } else {
          setActiveModule("learning");
          setLearningSubModule("modules");
        }
        break;
      case "chat":
        if (activity?.conversation_id != null) {
          await studentHomeOnContinueCuriosityAI(activity.conversation_id);
        } else {
          setActiveModule("learning");
          setLearningSubModule("chat");
          setActiveSidebarTab("history");
        }
        break;
      default:
        setActiveModule("learning");
        setLearningSubModule("chat");
        setActiveSidebarTab("history");
    }
  };

  const studentHomeOnTestPress = (test, options = {}) => {
    if (test?.id) {
      setLearningSubModule("modules");
      startStudentTest(test.id, options?.returnTo);
      setActiveModule("learning");
    }
  };

  const studentHomeOnViewAllTests = () => {
    setLearningSubModule("tests");
    setActiveModule("learning");
  };

  const studentHomeOnPracticeTestPress = (test) => {
    if (test?.id) {
      startStudentTest(test.id);
      setActiveModule("learning");
    }
  };

  const studentHomeOnQuickPractice = () => {
    setLearningSubModule("tests");
    setActiveSidebarTab("tests");
    setActiveModule("learning");
  };

  // AIT-250: dispatch recommendation card taps to existing navigation handlers.
  const studentHomeOnRecommendationPress = async (rec) => {
    if (!rec) return;
    const payload = rec.action_payload || {};
    switch (rec.action) {
      case "resume":
        // Reuse the existing "Continue Learning" handler — same data shape.
        studentHomeOnContinueLearning();
        break;
      case "take_test":
        if (payload.test_id) {
          setLearningSubModule("modules");
          startStudentTest(payload.test_id);
          setActiveModule("learning");
        } else {
          studentHomeOnQuickPractice();
        }
        break;
      case "practice":
      case "review":
        setActiveModule("learning");
        setLearningSubModule("modules");
        if (payload.collection_id) {
          await handleCollectionClick({
            collection_id: payload.collection_id,
            base_board: contentDb,
          });
        }
        if (payload.source_topic_id) {
          // Launch the topic's quiz directly. Strip the "Practice "/"Review "
          // prefix from the rec title so it shows just the topic name in the
          // quiz modal/header.
          const topicName = (rec.title || "")
            .replace(/^(Practice|Review)\s+/i, "")
            .trim();
          launchQuiz({
            source_topic_id: payload.source_topic_id,
            topicName,
          });
        }
        break;
      default:
        setActiveModule("learning");
        setLearningSubModule("modules");
        break;
    }
  };

  // Home redesign (2026-09-16, WP7) — teacher home attention-list / to-review
  // action handlers. v1 routes into the existing modules; there is no
  // dedicated grading or messaging UI yet (see spec §11 WP7 addenda).
  const teacherHomeGoToTestQuestions = () => setActiveModule("testQuestions");

  const teacherHomeOnOpenMastery = () => setActiveModule("knowledgeMastery");

  const teacherHomeOnOpenDashboard = () => setActiveModule("teacherDashboard");

  // Reuses the same topic-quiz navigation as the "review" recommendation case
  // in studentHomeOnRecommendationPress above, minus the collection_id step
  // (onOpenTopic only ever receives a bare source_topic_id).
  const teacherHomeOnOpenTopic = (sourceTopicId) => {
    if (!sourceTopicId) return;
    setActiveModule("learning");
    setLearningSubModule("modules");
    launchQuiz({ source_topic_id: sourceTopicId, topicName: "" });
  };

  // WP6: "Message" on a Needs-attention row opens the reminder-email modal.
  const [messageStudentTarget, setMessageStudentTarget] = useState(null);
  const teacherHomeOnMessageStudent = (email, ctx) => {
    if (!email) return;
    setMessageStudentTarget({ email, name: ctx?.name, classId: ctx?.classId });
  };

  const teacherHomeOnViewStudentHome = () => setTeacherDashboardView("student");

  const teacherHomeOnBackToTeacherHome = () => setTeacherDashboardView("teacher");

  // Header redesign 2026-09-15: single source of truth for whether a test is
  // active/about-to-start, reused by the nav disable state and the Test in
  // Progress pill (previously duplicated in both places).
  // AIT-253: only a STARTED test locks the nav, not the pre-start details screen.
  const testInProgress = isTestNavLocked({ showQuiz, quizMode, testReadyToStart });

  // Contextual Learning sub-tab row: only while inside Learning/Video/PWO,
  // never during a test, and never during a Da Vinci lockdown or a presented
  // lesson (the header itself is hidden in both of those cases).
  const showLearningSubTabs =
    ["learning", "video", "pwo"].includes(activeModule) &&
    !testInProgress &&
    // The student-owned Journey and its media stage must not expose the
    // ordinary AI Tutor learning navigation (the primary header is hidden too).
    !(challengeLockdown || lessonPresentMode || journeyPresentMode ||
      journeySelfGuidedFocus);

  const learningSubTabItems = useMemo(() => ([
    { key: "analytics", label: t("Analytics") },
    { key: "engagement", label: t("Engagement") },
    { key: "tests", label: t("My Tests") },
    { key: "homework", label: t("Homework Help") },
    ...(SHOW_AP_EXAM_PREP ? [{ key: "ap-exam-prep", label: t("AP Exam Prep") }] : []),
    {
      key: "modules",
      label: viewMode === "curriculum" ? t("Chapters") : t("Modules"),
    },
  ]), [t, viewMode]);

  // Right cluster: below this width the wide-cluster items (help menu,
  // curriculum chip, upgrade pill) fold into the avatar menu instead.
  const compactRight = width < effectiveCollapseWidthRight;

  // Alerts bell dot: subscription ending within 30 days. Lifted out of the
  // inline IIFE it used to be so it isn't recomputed on every render.
  const alertDot = useMemo(() => {
    if (!user?.access_end_date) return false;
    try {
      const end = new Date(String(user.access_end_date).slice(0, 10));
      const today = new Date();
      const daysLeft = Math.ceil((end - today) / (1000 * 60 * 60 * 24));
      return daysLeft <= 30;
    } catch {
      return false;
    }
  }, [user?.access_end_date]);

  // Keep the separate WonderLabs preview surface visually free of AI Tutor chrome.
  // The legacy header remains available via the small internal regular-home link.
  const showWonderLabsAdventureHome = wonderLabsPreviewEnabled &&
    activeModule === "home" && !showOnboarding && !showJourney && !showRegularHomeWithSwanFlag;

  // A child-facing route cannot silently fall through into unrelated AI Tutor UI.
  // This is the existing STEM-program gate, not yet a per-kit entitlement check.
  if (wonderLabsEntry.isWonderLabs && !canAccessStemMissions) {
    return (
      <View style={{ flex: 1, alignItems: "center", justifyContent: "center",
        padding: 24, backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc" }}>
        <Text style={{ fontSize: 22, fontWeight: "800", color: isDarkMode ? "#fff" : "#0f172a" }}>
          WonderLabs access isn't enabled for this account yet.
        </Text>
        <Text style={{ fontSize: 15, color: isDarkMode ? "#cbd5e1" : "#475569", marginTop: 12 }}>
          Ask a parent or the WonderLabs team to activate your science adventures.
        </Text>
      </View>
    );
  }

  return (

    <View nativeID={SBS3D_ROOT_ID} style={styles(isDarkMode).container}>
      {journeySelfGuidedFocus && journeyMediaLaunchPending && !showVideo && !showPwo ? (
        <View style={{ position: "fixed", left: 0, top: 0, width: "100vw", height: "100vh",
          zIndex: 2147483500, alignItems: "center", justifyContent: "center",
          backgroundColor: isDarkMode ? "#0f172a" : "#f8fbff" }}>
          <ActivityIndicator size="large" color="#0759a9" />
          <Text style={{ color: isDarkMode ? "#fff" : "#16324f", fontSize: 18,
            marginTop: 16, fontWeight: "700" }}>{t("Opening your investigation…")}</Text>
        </View>
      ) : null}
      {/* BDD 10/01/2026 - SBS 3D projector mode filter definition.
          Normal AITutor is rendered ONCE. The SVG filter creates a second
          raster copy one logical-screen-width to the right; body scaleX(.5)
          compresses the two copies into the physical SBS halves. */}
      {sbs3dProjectorMode && Platform.OS === "web" && (
        <svg
          aria-hidden="true"
          width="0"
          height="0"
          style={{ position: "fixed", width: 0, height: 0, pointerEvents: "none" }}
        >
          <defs>
            <filter
              id={SBS3D_FILTER_ID}
              x={0}
              y={0}
              width={Math.max(1, width * 2)}
              height={Math.max(1, height)}
              filterUnits="userSpaceOnUse"
              primitiveUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feOffset in="SourceGraphic" dx={0} dy={0} result="sbs3dLeftEye" />
              <feOffset in="SourceGraphic" dx={width} dy={0} result="sbs3dRightEye" />
              <feMerge>
                <feMergeNode in="sbs3dLeftEye" />
                <feMergeNode in="sbs3dRightEye" />
              </feMerge>
            </filter>
          </defs>
        </svg>
      )}

      {/* SBS 3D customer setup. Because the body duplication filter is already
          active, this ONE setup card appears once in each physical SBS half. */}
      {sbs3dProjectorMode && !sbs3dSetupComplete && !sbs3dPwoTakeover && (
        <View
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 2147483640,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#07111f",
            paddingHorizontal: 80,
          }}
        >
          <View
            style={{
              width: 760,
              maxWidth: "82%",
              backgroundColor: "#0f1d31",
              borderWidth: 1,
              borderColor: "rgba(255,255,255,0.18)",
              borderRadius: 24,
              paddingHorizontal: 42,
              paddingVertical: 36,
              alignItems: "center",
              boxShadow: "0 24px 70px rgba(0,0,0,0.45)",
            }}
          >
            <Image
              source={Logo}
              style={{ width: 92, height: 70, resizeMode: "contain", marginBottom: 8 }}
            />
            <Text
              style={{
                color: "#ffffff",
                fontSize: 34,
                lineHeight: 42,
                fontWeight: "800",
                textAlign: "center",
              }}
            >
              {t("Saras-3D Projector Mode")}
            </Text>

            {!sbs3dSetupStarted ? (
              <>
                <Text
                  style={{
                    color: "#cbd5e1",
                    fontSize: 20,
                    lineHeight: 30,
                    textAlign: "center",
                    marginTop: 16,
                  }}
                >
                  {t(sbs3dKioskMode ? "AITutor is running in full-screen Side-by-Side 3D kiosk mode." : "AITutor will enter full-screen Side-by-Side 3D mode.")}
                </Text>
                <Text
                  style={{
                    color: "#94a3b8",
                    fontSize: 17,
                    lineHeight: 26,
                    textAlign: "center",
                    marginTop: 10,
                  }}
                >
                  {t("You may see two compressed copies until the projector is switched to SBS 3D.")}
                </Text>
                <TouchableOpacity
                  onPress={beginSbs3dSetup}
                  style={{
                    marginTop: 30,
                    minWidth: 340,
                    paddingVertical: 15,
                    paddingHorizontal: 28,
                    borderRadius: 14,
                    backgroundColor: "#2563eb",
                    alignItems: "center",
                  }}
                  activeOpacity={0.8}
                >
                  <Text style={{ color: "#fff", fontSize: 18, fontWeight: "800" }}>
                    {t("Start 3D Projector Mode")}
                  </Text>
                </TouchableOpacity>
                <Text style={{ color: "#64748b", fontSize: 14, marginTop: 16, textAlign: "center" }}>
                  {t("You can also press Enter.")}
                </Text>
              </>
            ) : (
              <>
                <View
                  style={{
                    width: "100%",
                    marginTop: 22,
                    padding: 22,
                    borderRadius: 16,
                    backgroundColor: "rgba(37,99,235,0.12)",
                    borderWidth: 1,
                    borderColor: "rgba(96,165,250,0.30)",
                  }}
                >
                  <Text style={{ color: "#fff", fontSize: 20, fontWeight: "800", marginBottom: 14 }}>
                    {t("On the projector:")}
                  </Text>
                  <Text style={{ color: "#dbeafe", fontSize: 19, lineHeight: 32 }}>
                    {t("1. Open the projector 3D settings.")}
                  </Text>
                  <Text style={{ color: "#dbeafe", fontSize: 19, lineHeight: 32 }}>
                    {t("2. Select Side-by-Side (SBS) 3D.")}
                  </Text>
                  <Text style={{ color: "#dbeafe", fontSize: 19, lineHeight: 32 }}>
                    {t("3. Put on the 3D glasses.")}
                  </Text>
                  <Text style={{ color: "#dbeafe", fontSize: 19, lineHeight: 32 }}>
                    {t("4. Confirm that these two copies now appear as one normal flat screen.")}
                  </Text>
                </View>

                <TouchableOpacity
                  onPress={continueSbs3dSetup}
                  style={{
                    marginTop: 26,
                    minWidth: 360,
                    paddingVertical: 15,
                    paddingHorizontal: 28,
                    borderRadius: 14,
                    backgroundColor: "#16a34a",
                    alignItems: "center",
                  }}
                  activeOpacity={0.8}
                >
                  <Text style={{ color: "#fff", fontSize: 18, fontWeight: "800" }}>
                    {t("Projector is in SBS — Continue")}
                  </Text>
                </TouchableOpacity>
                <Text style={{ color: "#64748b", fontSize: 14, marginTop: 16, textAlign: "center" }}>
                  {t("Press Enter if the mouse pointer is difficult to see while setting up 3D.")}
                </Text>
              </>
            )}
          </View>
        </View>
      )}

      {/* Phase 2B kiosk teacher escape hatch. This button is part of the
          logical AITutor surface, so the SBS compositor duplicates it into both
          eyes. Releasing Pointer Lock frees the real Windows pointer without
          leaving Edge kiosk or breaking the projector's SBS framebuffer. */}
      {sbs3dKioskMode &&
        sbs3dSetupComplete &&
        sbs3dPointerLocked &&
        !sbs3dPwoTakeover && (
          <TouchableOpacity
            onPress={releaseSbs3dPointer}
            accessibilityLabel={t("Release mouse")}
            title={t("Release mouse")}
            style={{
              position: "fixed",
              right: 18,
              bottom: 18,
              zIndex: 2147483637,
              flexDirection: "row",
              alignItems: "center",
              gap: 7,
              paddingVertical: 9,
              paddingHorizontal: 13,
              borderRadius: 13,
              backgroundColor: "rgba(15,23,42,0.90)",
              borderWidth: 1,
              borderColor: "rgba(255,255,255,0.22)",
              cursor: "pointer",
            }}
            activeOpacity={0.82}
          >
            <MaterialCommunityIcons name="mouse-off" size={18} color="#ffffff" />
            <Text style={{ color: "#fff", fontSize: 13, fontWeight: "700" }}>
              {t("Release Mouse")}
            </Text>
            <Text style={{ color: "#94a3b8", fontSize: 11, fontWeight: "600" }}>
              Ctrl+Alt+M
            </Text>
          </TouchableOpacity>
        )}

      {/* AITutor software cursor. Body SBS duplication automatically creates
          the matching right-eye cursor at zero disparity. */}
      {sbs3dProjectorMode &&
        sbs3dSetupComplete &&
        sbs3dPointerLocked &&
        !sbs3dPwoTakeover && (
          <div
            ref={sbs3dCursorElRef}
            aria-hidden="true"
            style={{
              position: "fixed",
              left: 0,
              top: 0,
              width: 34,
              height: 46,
              zIndex: 2147483638,
              pointerEvents: "none",
              transform: `translate(${sbs3dCursorPosRef.current.x}px, ${sbs3dCursorPosRef.current.y}px)`,
              filter: "drop-shadow(0 2px 3px rgba(0,0,0,0.75))",
            }}
          >
            <svg width="34" height="46" viewBox="0 0 36 48">
              <path
                d="M3 2 L3 38 L12 30 L18 45 L25 42 L19 28 L31 28 Z"
                fill="white"
                stroke="black"
                strokeWidth="2.3"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        )}

      {/* PWO fullscreen recovery. Unity owns the normal PWO cursor, so after
          Esc we intentionally switch to browser-owned controls and expose the
          native pointer. Both eye halves contain real controls at matching
          positions so either physical half is clickable before SBS fusion. */}
      {sbs3dProjectorMode &&
        sbs3dSetupComplete &&
        sbs3dPwoTakeover &&
        sbs3dPwoRecoveryVisible && (
          <View
            style={{
              position: "fixed",
              left: 0,
              top: 0,
              width: "100vw",
              height: "100vh",
              zIndex: 2147483647,
              backgroundColor: "rgba(2,6,23,0.76)",
              overflow: "hidden",
              cursor: "default",
            }}
          >
            {[0, 1].map((eyeIndex) => (
              <View
                key={`sbs3d-pwo-recovery-eye-${eyeIndex}`}
                style={{
                  position: "absolute",
                  left: eyeIndex === 0 ? 0 : "50%",
                  top: 0,
                  width: "50%",
                  height: "100%",
                  overflow: "hidden",
                }}
              >
                <View
                  style={{
                    width: "100vw",
                    height: "100vh",
                    transform: "scaleX(0.5)",
                    transformOrigin: "0 0",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <View
                    style={{
                      width: 700,
                      maxWidth: "78%",
                      paddingHorizontal: 42,
                      paddingVertical: 34,
                      borderRadius: 22,
                      alignItems: "center",
                      backgroundColor: "rgba(15,23,42,0.97)",
                      borderWidth: 1,
                      borderColor: "rgba(255,255,255,0.24)",
                      boxShadow: "0 22px 60px rgba(0,0,0,0.48)",
                    }}
                  >
                    <MaterialCommunityIcons name="cube-outline" size={58} color="#ffffff" />
                    <Text
                      style={{
                        marginTop: 14,
                        color: "#ffffff",
                        fontSize: 30,
                        fontWeight: "800",
                        textAlign: "center",
                      }}
                    >
                      {t("3D PWO paused")}
                    </Text>
                    <Text
                      style={{
                        marginTop: 9,
                        color: "#cbd5e1",
                        fontSize: 18,
                        lineHeight: 27,
                        textAlign: "center",
                      }}
                    >
                      {t("Browser full-screen was exited. Resume the 3D experience or return to AITutor.")}
                    </Text>

                    <TouchableOpacity
                      onPress={resumeSbs3dPwo}
                      style={{
                        marginTop: 26,
                        minWidth: 380,
                        paddingVertical: 15,
                        paddingHorizontal: 28,
                        borderRadius: 14,
                        alignItems: "center",
                        backgroundColor: "#2563eb",
                        cursor: "pointer",
                      }}
                      activeOpacity={0.80}
                    >
                      <Text style={{ color: "#fff", fontSize: 18, fontWeight: "800" }}>
                        {t("Resume 3D PWO")}
                      </Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                      onPressIn={() => {
                        setSbs3dPwoRecoveryVisible(false);
                        handleJourneyStageClose();
                      }}
                      style={{
                        marginTop: 12,
                        minWidth: 380,
                        paddingVertical: 13,
                        paddingHorizontal: 28,
                        borderRadius: 14,
                        alignItems: "center",
                        backgroundColor: "rgba(255,255,255,0.10)",
                        borderWidth: 1,
                        borderColor: "rgba(255,255,255,0.20)",
                        cursor: "pointer",
                      }}
                      activeOpacity={0.80}
                    >
                      <Text style={{ color: "#fff", fontSize: 17, fontWeight: "700" }}>
                        {t("Exit PWO")}
                      </Text>
                    </TouchableOpacity>

                    <Text
                      style={{
                        marginTop: 16,
                        color: "#94a3b8",
                        fontSize: 14,
                        textAlign: "center",
                      }}
                    >
                      {t("Enter resumes • Esc again exits")}
                    </Text>
                  </View>
                </View>
              </View>
            ))}
          </View>
        )}

      {/* Escape or a PWO close releases Pointer Lock. A new user gesture is
          required by the browser before AITutor can capture relative motion again. */}
      {sbs3dProjectorMode &&
        sbs3dSetupComplete &&
        !sbs3dPwoTakeover &&
        !sbs3dPointerLocked && (
          <View
            style={{
              position: "fixed",
              left: 0,
              top: 0,
              width: "100vw",
              height: "100vh",
              zIndex: 2147483639,
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(0,0,0,0.30)",
            }}
            pointerEvents="box-none"
          >
            <TouchableOpacity
              onPress={resumeSbs3dPointer}
              style={{
                paddingVertical: sbs3dKioskMode ? 20 : 15,
                paddingHorizontal: 28,
                borderRadius: 14,
                backgroundColor: "rgba(15,23,42,0.94)",
                borderWidth: 1,
                borderColor: "rgba(255,255,255,0.22)",
                minWidth: sbs3dKioskMode ? 520 : undefined,
                alignItems: "center",
              }}
              activeOpacity={0.82}
            >
              {sbs3dKioskMode && (
                <MaterialCommunityIcons name="mouse-off" size={28} color="#ffffff" />
              )}
              <Text
                style={{
                  color: "#fff",
                  fontSize: 17,
                  fontWeight: "800",
                  textAlign: "center",
                  marginTop: sbs3dKioskMode ? 8 : 0,
                }}
              >
                {t(
                  sbs3dKioskMode
                    ? "Mouse released — click or press Enter to resume 3D navigation"
                    : "Click or press Enter to resume 3D navigation"
                )}
              </Text>
              {sbs3dKioskMode && (
                <Text
                  style={{
                    color: "#cbd5e1",
                    fontSize: 13,
                    lineHeight: 20,
                    marginTop: 9,
                    textAlign: "center",
                  }}
                >
                  {t("You can move the Windows pointer to another monitor while Saras-3D remains safely in SBS kiosk mode.")}
                </Text>
              )}
              {sbs3dKioskMode && (
                <Text
                  style={{
                    color: "#94a3b8",
                    fontSize: 12,
                    marginTop: 8,
                    textAlign: "center",
                  }}
                >
                  {t("Alt+Tab switches apps • Alt+F4 ends the kiosk session")}
                </Text>
              )}
            </TouchableOpacity>
          </View>
        )}
      {/* BDD 2026-06-18 — Da Vinci "Science Exploration Trail" hub. Shown on entry
          and again once all collections are done (so the QR-code button is
          reachable). Tiles open collections; the gold button mints the cert. */}
      {challengeLockdown && !challengeHubClosed && (!challengeIntroDismissed || challengeState?.all_done) && (
        <DavinciChallengeIntro
          challengeState={challengeState}
          language={selectedSecondaryLang}
          isDarkMode={isDarkMode}
          onSelectCollection={(cid) => {
            setChallengeIntroDismissed(true);
            if (cid != null && typeof handleCollectionClick === "function") {
              handleCollectionClick(cid);
            }
          }}
          onClose={
            challengeState?.all_done
              ? undefined
              : () => {
                  setChallengeIntroDismissed(true);
                  setChallengeHubClosed(true);
                }
          }
          onGetCertificate={() => {
            setChallengeModal({
              allDone: true,
              day: challengeState?.days?.length || 0,
              cert: null,
            });
          }}
        />
      )}
      {/* Logout stays reachable during lockdown (the header is hidden). Sits
          above the intro overlay (zIndex 10000) so staff can reset anytime. */}
      {challengeLockdown && !sbs3dPwoTakeover && (
        <TouchableOpacity
          onPress={handleLogout}
          accessibilityLabel="Log out"
          title={t("Logout")}
          style={{
            position: "absolute",
            top: 16,
            right: 18,
            zIndex: 10000,
            flexDirection: "row",
            alignItems: "center",
            gap: 6,
            paddingVertical: 8,
            paddingHorizontal: 14,
            borderRadius: 999,
            backgroundColor: "rgba(8,18,46,0.72)",
            borderWidth: 1,
            borderColor: "rgba(231,196,106,0.4)",
          }}
        >
          <MaterialCommunityIcons name="logout" size={18} color="#e7c46a" />
          <Text style={{ color: "#e7c46a", fontWeight: "700", fontSize: 14 }}>{t("Logout")}</Text>
        </TouchableOpacity>
      )}
      {/* Challenge progress now lives inside the COLLECTION PROGRESS bar
          (badge + goal marker) — see <CollectionProgressBar/> below. */}
      {/* ===== HEADER (unchanged) ===== BDD 10/5/2025 - header UI UX */}
      {/* HEADER — hidden during Da Vinci challenge lockdown, and while a
          lesson is being presented to a class */}
      <View nativeID="here" style={[h.header, { paddingHorizontal: responsiveContentPadding }, (challengeLockdown || lessonPresentMode || journeyPresentMode || journeySelfGuidedFocus || sbs3dPwoTakeover || showWonderLabsAdventureHome) && { display: "none" }]}>
        {/* Left: Home button + teacher/admin tools - responsive hamburger for narrow screens */}
        <View nativeID="here2" style={[h.leftRow, !showTeacherNavLabels && { gap: 4 }]}>
          {/* Brand — logo + wordmark, moved to the far left of the bar so full
              nav labels survive down to HEADER_HIDE_LABELS_WIDTH (see the
              header redesign decision log, 2026-09-15). */}
          <View style={h.brand}>
            <Image source={Logo} style={h.logo} />
            {width >= 1024 && <Text style={h.title}>{t("3D AI Tutor")}</Text>}
          </View>

          {/* Student navigation buttons (Home + Curriculum + Collections + Programs ▾) - visible to all */}
          <StudentNavButtons
            activeModule={activeModule}
            setActiveModule={setActiveModule}
            onCurriculumPress={() => { setActiveModule("learning"); handleLearningSubModuleChange("modules"); setViewMode("curriculum"); setActiveSidebarTab("collections"); userHasSavedPreferenceRef.current = true; }}
            onCollectionsPress={() => { setActiveModule("learning"); handleLearningSubModuleChange("modules"); setViewMode("collections"); setActiveSidebarTab("collections"); userHasSavedPreferenceRef.current = true; }}
            showCurriculum={!isCollectionsOnly}
            collectionsDisabled={noCollectionsForSure}
            viewMode={effectiveViewMode}
            programItems={programItems}
            programsActive={programsActive}
            showLabels={showTeacherNavLabels && width >= effectiveCollapseWidthLeft}
            styles={h}
            isDarkMode={isDarkMode}
            disabled={testInProgress}
            t={t}
          />

          {/* Test in Progress indicator - shown when test is active or ready to start */}
          {testInProgress && (
            <View style={{
              flexDirection: "row",
              alignItems: "center",
              backgroundColor: "rgba(239, 68, 68, 0.2)",
              paddingHorizontal: 12,
              paddingVertical: 6,
              borderRadius: 16,
              marginLeft: 8,
              gap: 6,
            }}>
              <MaterialCommunityIcons name="lock" size={16} color="#f87171" />
              <Text style={{ color: "#f87171", fontSize: 13, fontWeight: "600" }}>
                {t("Test in Progress")}
              </Text>
            </View>
          )}

          {(user?.can_use_teacher_tools ?? canUseTeacherTools(user?.role)) && (
            <>
              {/* Hamburger menu button - shown on narrow screens */}
              {width < effectiveCollapseWidthLeft && (
                <TouchableOpacity
                  onPress={() => setHamburgerMenuOpen(!hamburgerMenuOpen)}
                  style={h.hamburgerBtn}
                  title={t("Teacher tools menu")}
                >
                  <MaterialCommunityIcons
                    name={hamburgerMenuOpen ? "close" : "menu"}
                    size={26}
                    color="#fff"
                  />
                </TouchableOpacity>
              )}

              {/* Gap between student nav and teacher nav (was a divider bar;
                  the redesigned pills use the same hairline separator as the
                  right cluster, see the header redesign decision log,
                  2026-09-15 and WP6 item 6). */}
              {width >= effectiveCollapseWidthLeft && <View style={h.clusterGap} />}

              {/* Teacher navigation buttons - shown on wide screens */}
              {width >= effectiveCollapseWidthLeft && (
                <TeacherNavButtons
                  activeModule={activeModule}
                  setActiveModule={setActiveModule}
                  handleTeacherDashboard={handleTeacherDashboard}
                  currentCurriculum={currentCurriculum}
                  showLabels={showTeacherNavLabels}
                  styles={h}
                  isDarkMode={isDarkMode}
                  disabled={testInProgress}
                  showLessonPlans={lessonPlanEnabled}
                  onOpenLessonPlans={() => setActiveModule("lessonPlans")}
                  t={t}
                />
              )}

              {/* Hamburger dropdown menu */}
              {width < effectiveCollapseWidthLeft && hamburgerMenuOpen && (
                <View style={h.hamburgerDropdown}>
                  <TeacherHamburgerMenuItems
                    activeModule={activeModule}
                    setActiveModule={setActiveModule}
                    handleTeacherDashboard={handleTeacherDashboard}
                    currentCurriculum={currentCurriculum}
                    setHamburgerMenuOpen={setHamburgerMenuOpen}
                    styles={h}
                    isDarkMode={isDarkMode}
                    disabled={testInProgress}
                    showLessonPlans={lessonPlanEnabled}
                    onOpenLessonPlans={() => setActiveModule("lessonPlans")}
                    t={t}
                  />
                </View>
              )}
            </>
          )}

          {/* BDD 01/25/2026 studen resum states */}
          {/* Hide class badge at narrow screens - it moves under the logo at < effectiveClassBadgeMoveWidth */}
          {(myClasses.length > 0 || showContinueButton) && width >= effectiveClassBadgeMoveWidth && (
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              {/* Class badge (only if student + classes exist) */}
              {!(user?.can_use_teacher_tools ?? canUseTeacherTools(user?.role)) && myClasses.length > 0 && (
                <View style={h.classBadge}>
                  <MaterialCommunityIcons
                    name="account-group"
                    size={16}
                    color="#bfdbfe"
                    style={{ marginRight: 4 }}
                  />
                  <Text style={h.classBadgeText}>
                    {myClasses.length === 1
                      ? t("You're in {className}", { className: myClasses[0].class_name })
                      : t("Your classes: {classes}", { classes: myClasses.map((c) => c.class_name).join(", ") })}
                  </Text>
                </View>
              )}

              {/* Continue button removed BDD 02/10/2026 */}
            </View>
          )}

          {/* Compact class badge — narrow screens where the full badge above
              is hidden but there's still room for a short one (the "under the
              logo" narrow variant, now inline since the brand moved to the
              far left; see the header redesign decision log, 2026-09-15). */}
          {width >= effectiveClassBadgeHideWidth && width < effectiveClassBadgeMoveWidth && !(user?.can_use_teacher_tools ?? canUseTeacherTools(user?.role)) && myClasses.length > 0 && (
            <View style={[h.classBadge, { pointerEvents: "auto" }]}>
              <MaterialCommunityIcons
                name="account-group"
                size={14}
                color="#bfdbfe"
                style={{ marginRight: 4 }}
              />
              <Text style={[h.classBadgeText, { fontSize: 11 }]}>
                {myClasses.length === 1
                  ? t("You're in {className}", { className: myClasses[0].class_name })
                  : t("{count} classes", { count: myClasses.length })}
              </Text>
            </View>
          )}

          {ENABLE_COVERAGE_EXPORT && currentCurriculum ? (
            <View style={styles(isDarkMode).exportRow}>
              <TouchableOpacity
                onPress={() => handleExportCoverage(currentCurriculum)}
                style={styles(isDarkMode).exportButton}
              >
                <Text style={styles(isDarkMode).exportButtonText}>{t("Export Coverage")}</Text>
              </TouchableOpacity>
            </View>
          ) : null}
        </View>

        {/* Right: alerts, help, curriculum, upgrade, avatar menu - responsive
            collapse into the avatar menu below effectiveCollapseWidthRight */}
        <View style={[h.rightRow, !showTeacherNavLabels && { gap: 6 }]}>
          {/* ⬇️ ADD THIS BLOCK (only in investor mode) BDD 10/13/2025*/}
          {shelvesLayout && !stageMaximized && ( // BDD 10/21/2025
            <>
              {/* Launcher (Modules/Tests) – opens LEFT shelf */}
              <TouchableOpacity onPress={() => { setActiveLauncherTab("modules"); setLauncherOpen(true); }} style={h.iconBtnLabeled} title={t("Modules")}>
                <MaterialCommunityIcons name="view-grid" size={22} color="#fff" />
                <Text style={h.iconBtnLabel}>{t("Modules")}</Text>
              </TouchableOpacity>

              {/* Per-collection History – opens RIGHT shelf */}
              <TouchableOpacity onPress={() => setHistoryOpen(true)} style={h.iconBtnLabeled} title={t("History")}>
                <MaterialCommunityIcons name="history" size={22} color="#fff" />
                <Text style={h.iconBtnLabel}>{t("History")}</Text>
              </TouchableOpacity>

              {/* Insights (Analytics + Engagement) – opens RIGHT shelf */}
              <TouchableOpacity onPress={() => setInsightsOpen(true)} style={h.iconBtnLabeled} title={t("Insights")}>
                <MaterialCommunityIcons name="chart-box-outline" size={22} color="#fff" />
                <Text style={h.iconBtnLabel}>{t("Insights")}</Text>
              </TouchableOpacity>
            </>
          )}

          {/* Notifications BDD 01/21/2026 - 01/22/2026 - add_subscription_notifications_and_support */}
          {canSeeAdminNotifications && (
            <HeaderIconButton
              icon="bell-outline"
              label={t("Alerts")}
              dot={alertDot}
              onPress={() => setNotificationsModalVisible(true)}
              testID="header-alerts"
            />
          )}

          {/* Help "?" menu (App guide, Support) — wide cluster only; folds
              into the avatar menu's Help section when compact. */}
          {!compactRight && (
            <HeaderHelpMenu
              isDarkMode={isDarkMode}
              t={t}
              onAppGuide={() => setKnowledgeModalVisible(true)}
              onSupport={() => setSupportModalVisible(true)}
            />
          )}

          {!compactRight && <View style={h.clusterGap} />}

          {/* Curriculum switcher chip = BDD 10/15/2025, redesigned 2026-09-15 */}
          {!compactRight && (
            <TouchableOpacity
              onPress={() => setCurriculumModalVisible(true)}
              style={h.currChip}
              title={t("Switch curriculum")}
              accessibilityLabel={t("Switch curriculum")}
            >
              <MaterialCommunityIcons name="school-outline" size={18} color={HEADER.onBrand} />
              <Text style={h.currChipText}>{currentCurriculum ? currentCurriculum.toUpperCase() : t("Curriculum")}</Text>
              <MaterialCommunityIcons name="chevron-down" size={16} color={HEADER.onBrand} />
            </TouchableOpacity>
          )}

          {!compactRight && isRetailUser && (
            <TouchableOpacity
              onPress={() => navigation.navigate("UpgradePlan")}
              style={h.upgradePill}
              title={t("Upgrade Plan")}
              accessibilityLabel={t("Upgrade Plan")}
            >
              <MaterialCommunityIcons name="lightning-bolt" size={16} color={HEADER.amberInk} />
              <Text style={h.upgradePillText}>{t("Upgrade")}</Text>
            </TouchableOpacity>
          )}

          {/* Avatar menu — header redesign 2026-09-15. Replaces the old
              language/profile buttons and the "dots" hamburger; when
              compact it also carries Upgrade, App guide and Support. */}
          <HeaderProfileMenu
            user={{ name: user?.name, email: user?.email, roleLabel: isTeacher ? t("Teacher") : t("Student") }}
            isDarkMode={isDarkMode}
            compact={compactRight}
            t={t}
            language={{ label: selectedSecondaryLang ? selectedSecondaryLang.toUpperCase() : t("Auto") }}
            onLanguage={() => setLanguageModal(true)}
            curriculum={{ label: currentCurriculum ? currentCurriculum.toUpperCase() : t("Curriculum") }}
            onCurriculum={() => setCurriculumModalVisible(true)}
            theme={{ isDark: isDarkMode, onToggle: toggleTheme }}
            zoom={
              Platform.OS === "web"
                ? {
                    // Displayed as a percentage by HeaderProfileMenu ("{level}%"),
                    // so level/min/max are scaled from the raw 0.5–2.0 zoomLevel
                    // multiplier; onIn/onOut/onReset operate on that raw state
                    // directly and ignore any argument, so no scaling needed there.
                    level: Math.round(zoomLevel * 100),
                    min: Math.round(MIN_ZOOM * 100),
                    max: Math.round(MAX_ZOOM * 100),
                    onIn: handleZoomIn,
                    onOut: handleZoomOut,
                    onReset: handleZoomReset,
                  }
                : null
            }
            showUpgrade={isRetailUser}
            onUpgrade={() => navigation.navigate("UpgradePlan")}
            showAdmin={
              user?.is_internal_admin ||
              user?.role == "partneradmin" ||
              (user?.can_use_admin_tools ?? canUseAdminTools(user?.role))
            }
            onAdmin={() => navigation.navigate("InternalAdmin")}
            showScanner={canUseDavinciScanner(user)}
            onScanner={() => navigation.navigate("DavinciScanner")}
            showHelpItems
            onAppGuide={() => setKnowledgeModalVisible(true)}
            onSupport={() => setSupportModalVisible(true)}
            onProfile={() => { setProfileModalVisible(true); }}
            onLogout={handleLogout}
          />
        </View>
      </View>

      {/* Contextual Learning sub-tab row — see the header redesign decision
          log, 2026-09-15. */}
      {!sbs3dPwoTakeover && showLearningSubTabs && (
        <LearningSubTabs
          t={t}
          testID="learning-subtabs"
          activeKey={learningSubModule}
          onSelect={handleLearningSubModuleChange}
          items={learningSubTabItems}
          paddingHorizontal={responsiveContentPadding}
        />
      )}

      {/* Billing nags do not belong on a projector in front of a class. */}
      {shouldShowExpiryNotice && !lessonPresentMode && !journeyPresentMode && !journeySelfGuidedFocus && !sbs3dPwoTakeover && (
        <View style={styles(isDarkMode).expiryBanner}>
          <Text style={styles(isDarkMode).expiryBannerText}>
            {t("Your subscription is about to end in {days} days. Consider upgrading your plan. You can use the Upgrade button in the top bar or in the menu.", { days: expiryDaysLeft })}
          </Text>
          <View style={styles(isDarkMode).expiryBannerActions}>
            <TouchableOpacity
              onPress={() => navigation.navigate("UpgradePlan")}
              style={styles(isDarkMode).expiryBannerBtn}
            >
              <Text style={styles(isDarkMode).expiryBannerBtnText}>{t("Upgrade Now")}</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => setDismissExpiryNotice(true)}
              style={styles(isDarkMode).expiryBannerDismiss}
            >
              <Text style={styles(isDarkMode).expiryBannerDismissText}>{t("Dismiss")}</Text>
            </TouchableOpacity>
          </View>
        </View>
      )}

      {/* BDD 10/15/2025 - BDD 07/29/2026 - Journey - changing this style*/}
      <View
        style={[
          styles(isDarkMode).contentWrapper,
          (journeyAssetMode || lessonAssetMode) && {
            position: "relative",
          },
          sbs3dPwoTakeover && {
            position: "fixed",
            left: 0,
            top: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 2147483590,
            backgroundColor: "#000",
          },
        ]}
        onLayout={(e) => setContentWidth(e.nativeEvent.layout.width)}
      >

        {/* Walkthrough Controller - manages guided tour */}
        <WalkthroughController
          isReady={!showOnboarding && activeModule === "home"}
        />

        {/* BDD 07/29/2026 - Journey Map beside an active video/PWO */}
        {journeyAssetTocVisible && (
          <View
            style={{
              position: "absolute",
              top: 12,
              bottom: 12,
              left: 12,
              width: journeyAssetTocWidth,
              zIndex: 45,
            }}
          >
            <JourneyTableOfContents
              journey={journeyRuntime}
              activeStepIndex={journeyStepIndex}
              visitedThroughIndex={journeyVisitedThroughIndex}
              onStepChange={async (nextIndex) => {
                const closed = await handleJourneyStageClose();
                if (closed === false) return;

                setJourneyStepIndex(nextIndex);
                setJourneyVisitedThroughIndex((current) =>
                  Math.max(current, nextIndex)
                );
              }}
              isDarkMode={isDarkMode}
              phaseLabels={journeyPhaseLabelsForWorkspace}
              lang={lang}
              t={t}
            />
          </View>
        )}

        {/* Lesson in a Box 2026-08-13 — the lesson step, docked beside its own
            3D scene or video. The Unity iframe stays where it is in the tree;
            moving it would force a ~1 minute cold reload. */}
        {lessonAssetCompanionShown && (
          <View
            style={{
              position: "absolute",
              top: 12,
              bottom: 12,
              right: 12,
              width: lessonAssetCompanionWidth,
              zIndex: 46,
            }}
          >
            <LessonAssetCompanion
              lesson={lessonPlanRuntime}
              step={(lessonPlanRuntime?.steps || [])[lessonPlanStepIndex] || null}
              stepIndex={lessonPlanStepIndex}
              totalSteps={(lessonPlanRuntime?.steps || []).length}
              activeBlockId={lessonPlanActiveBlockId}
              sessionState={lessonPlanSessionState}
              onSessionStateChange={setLessonPlanSessionState}
              launchingBlockId={lessonPlanLaunchingBlockId}
              onLaunchBlock={handleLessonPlanLaunch}
              onAsk={handleLessonPlanAsk}
              onStepChange={setLessonPlanStepIndex}
              onBack={async () => {
                const canClose = await handleCloseModule(false);
                if (canClose === false) return;
                lessonPlanAssetLaunchRef.current = false;
                lessonPlanLastModuleRef.current = "lessonPlans";
                setLessonPlanActiveBlockId(null);
                setActiveModule("lessonPlans");
              }}
              isDarkMode={isDarkMode}
              mode={lessonPlanMode}
              t={t}
            />
          </View>
        )}

        {/* BDD 07/29/2026 - Journey/Saras companion beside an active video/PWO */}
        {journeyAssetCompanionVisible && (
          <View
            style={{
              position: "absolute",
              top: 12,
              bottom: 12,
              right: 12,
              width: journeyAssetCompanionWidth,
              zIndex: 45,
            }}
          >
            <JourneyMediaCompanionContainer
              step={journeyActiveStepForWorkspace}
              asset={journeyActiveAsset}
              stepId={journeyAiContext?.step_id || null}
              inquiryGuard={journeySelfGuidedFocus
                ? journeyAiContext?.activity_progress?.inquiry_guard || null
                : null}
              activeTab={journeyRightTab}
              onTabChange={setJourneyRightTab}
              onReturnToJourney={handleJourneyStageClose}
              isDarkMode={isDarkMode}
              t={t}
              history={history}
              loading={loading}
              onAsk={(question) => handleJourneyAsk(question, journeyAiContext)}
              language={lang || "en"}
              userId={user_id}
              readAloudEnabled={journeySwanReadAloudEnabled}
              videoPlaying={journeyVideoPlaying}
              externalSpeaking={ttsStreamSpeaking && journeySwanReadAloudEnabled}
              onReadAloudEnabledChange={updateJourneySwanReadAloud}
            >
              {!journeySelfGuidedFocus && (
              <SuggestionRail
                key={`journey-asset-saras-${
                  journeyActiveAsset?.type || "asset"
                }`}
                t={t}
                isDarkMode={isDarkMode}
                idleSubtitle={journeySelfGuidedFocus
                  ? "Professor Swan · science guide"
                  : "Journey investigation"}

                sparksMapped={[]}
                suggestedQuestions={journeySelfGuidedFocus
                  ? [
                      journeyActiveAsset?.type === "video"
                        ? "What should I notice in this video?"
                        : "What should I explore in this 3D model?",
                      "Give me a hint.",
                    ]
                  : (journeyAiContext?.suggested_questions || [])}
                suggestedQuestionsHeader={[
                  journeySelfGuidedFocus
                    ? t("Ask Professor Swan")
                    : t("Investigate with Saras"),
                ]}

                onAsk={(question, extraOptions = {}) =>
                  handleJourneyAsk(
                    question,
                    journeyAiContext,
                    extraOptions
                  )
                }

                viewMode="journey"
                userId={user_id}
                activeCollectionId={null}
                suggestedQuestionsMeta={null}
                customWidth={journeyAssetCompanionWidth}

                answerStyle={answerStyle}
                setAnswerStyle={setAnswerStyle}

                inputValue={inputValue}
                setInputValue={setInputValue}
                onInputSubmit={(text) =>
                  handleJourneyAsk(text, journeyAiContext)
                }

                placeholder={t(journeySelfGuidedFocus
                  ? "Ask Professor Swan about what you see..."
                  : "Ask Saras about this Journey activity...")}

                loading={loading}

                chatSessions={chatSessions}
                sessionsLoading={sessionsLoading}
                selectedConversationId={selectedConversationId}
                openChatSession={openChatSession}
                closeChatSession={closeChatSession}
                sessionTurnsLoading={sessionTurnsLoading}
                formatLocalDate={formatLocalDate}

                history={
                  journeyConversationStarted ? history : []
                }

                renderHistorySection={renderHistorySection}
                authToken={authToken}

                handleVideoClick={openJourneyVideo}
                handlePWOClick={openJourneyPwo}
                handleChapterClick={handleChapterClick}
                handleCollectionClick={handleCollectionClick}

                onVoiceInput={handleVoiceInput}
                isListening={isListening}
                styles={styles}

                isMuted={isMuted}
                isPlaying={isPlaying}
                audioUrl={audioUrl}
                onToggleMute={handleToggleMute}
                onPlayAnswer={handlePlayAnswer}
                onStopAudio={stopAudio}
              />
              )}
            </JourneyMediaCompanionContainer>
          </View>
        )}

        {activeModule === "home" && showOnboarding ? (
          <OnboardingScreen
            userName={user?.name}
            isTeacher={user?.can_use_teacher_tools ?? canUseTeacherTools(user?.role)}
            onComplete={handleOnboardingComplete}
            onCreateTest={() => {
              setShowOnboarding(false);
              setActiveModule("testQuestions");
            }}
          />
        ) : activeModule === "home" ? (
          <View style={{ flex: 1, width: "100%", backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc" }}>
            {showWonderLabsAdventureHome ? (
              <WonderLabsMissionHome
                catalog={wonderLabsEntry.catalog || "all"}
                journeysBySlug={programJourneysBySlug}
                loading={programJourneysLoading}
                opening={journeyLoading}
                isDarkMode={isDarkMode}
                onOpenMission={(journeyId, missionSlug) => openJourney(journeyId, null, { startWithSwan: true, missionSlug })}
                onOpenRegularHome={wonderLabsEntry.isWonderLabs ? undefined : () => setShowRegularHomeWithSwanFlag(true)}
              />
            ) : (
            <>
            {wonderLabsPreviewEnabled && !showJourney && showRegularHomeWithSwanFlag ? (
              <TouchableOpacity
                onPress={() => setShowRegularHomeWithSwanFlag(false)}
                accessibilityRole="button"
                style={{ padding: 10, alignItems: "center", backgroundColor: isDarkMode ? "#163149" : "#e0f2fe" }}
              >
                <Text style={{ fontSize: 14, fontWeight: "800", color: isDarkMode ? "#7dd3fc" : "#075985" }}>
                  ← Back to WonderLabs adventures
                </Text>
              </TouchableOpacity>
            ) : null}
            {(user?.can_use_teacher_tools ?? canUseTeacherTools(user?.role)) ? (
              teacherDashboardView === "student" ? (
                <>
                  {/* Home redesign (2026-09-16): the pill toggle is gone —
                      "student" view is reached only via TeacherHomeScreen's
                      "See the student home" link (onViewStudentHome), and
                      this slim bar is the only way back. */}
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 6,
                      paddingVertical: 8,
                      backgroundColor: isDarkMode ? "#1e293b" : "#e2e8f0",
                    }}
                  >
                    <Text style={{ fontSize: 12, color: isDarkMode ? "#94a3b8" : "#64748b" }}>
                      {t("Viewing the student home")} ·
                    </Text>
                    <TouchableOpacity onPress={teacherHomeOnBackToTeacherHome}>
                      <Text style={{ fontSize: 12, fontWeight: "600", color: "#0ea5e9" }}>
                        {t("Back to Teacher Home")}
                      </Text>
                    </TouchableOpacity>
                  </View>

                  {showJourney && journeyRuntime ? (
                    renderJourneyWorkspace()
                  ) : (
                    <StudentHomeScreen
                      userName={user?.name || t("Student")}
                      userEmail={user?.email}
                      authToken={authToken}
                      learningResumeState={learningResumeState}
                      curiosityResumeState={curiosityResumeState}
                      availableTests={availableTests}
                      upcomingTests={upcomingTests}
                      myTestResults={myTestResults}
                      onContinueLearning={studentHomeOnContinueLearning}
                      onContinueCuriosityAI={studentHomeOnContinueCuriosityAI}
                      onBrowseTopics={studentHomeOnBrowseTopics}
                      onActivityPress={studentHomeOnActivityPress}
                      onTestPress={studentHomeOnTestPress}
                      onViewAllTests={studentHomeOnViewAllTests}
                      onRecommendationPress={studentHomeOnRecommendationPress}
                      myPracticeTests={myPracticeTests}
                      onPracticeTestPress={studentHomeOnPracticeTestPress}
                      onOpenJourney={(journeyId, previewStudent) => openJourney(journeyId, previewStudent)}
                      showJourneyLauncher={canAccessSummerCampJourneys}
                      showStemMissionLauncher={canAccessStemMissions}
                      lessonPlans={lessonPlanList}
                      lessonPlansProgress={lessonPlanProgress}
                      lessonPlansLoading={lessonPlanListLoading}
                      lessonPlansError={lessonPlanListError}
                      onOpenLessonPlan={lessonPlanEnabled ? openLessonPlan : undefined}
                      isDarkMode={isDarkMode}
                      t={t}
                      lang={lang}
                    />
                  )}
                </>
              ) : showJourney && journeyRuntime ? (
                renderJourneyWorkspace()
              ) : (
                <>
                <TeacherHomeScreen
                  userName={user?.name || t("Teacher")}
                  userEmail={user?.email}
                  authToken={authToken}
                  classes={myClasses}
                  onCreateTest={() => setActiveModule("testQuestions")}
                  onAddStudent={() => setActiveModule("manageStudents")}
                  onViewKnowledgeInsights={() => setActiveModule("knowledgeMastery")}
                  onOpenJourney={(journeyId, previewStudent) => openJourney(journeyId, previewStudent)}
                  showJourneyLauncher={canAccessSummerCampJourneys}
                  showStemMissionLauncher={canAccessStemMissions}
                  onOpenTest={teacherHomeGoToTestQuestions}
                  onGradeTest={teacherHomeGoToTestQuestions}
                  onEditTest={teacherHomeGoToTestQuestions}
                  onOpenMastery={teacherHomeOnOpenMastery}
                  onOpenTopic={teacherHomeOnOpenTopic}
                  onMessageStudent={teacherHomeOnMessageStudent}
                  onOpenDashboard={teacherHomeOnOpenDashboard}
                  onViewStudentHome={teacherHomeOnViewStudentHome}
                  lessonPlans={lessonPlanList}
                  lessonPlansProgress={lessonPlanProgress}
                  lessonPlansLoading={lessonPlanListLoading}
                  lessonPlansError={lessonPlanListError}
                  onOpenLessonPlan={lessonPlanEnabled ? openLessonPlan : undefined}
                  onOpenLessonPlans={lessonPlanEnabled ? () => setActiveModule("lessonPlans") : undefined}
                  selectedJourneyStudentEmail={selectedJourneyStudentEmail}
                  onSelectedJourneyStudentEmailChange={setSelectedJourneyStudentEmail}
                  isDarkMode={isDarkMode}
                  t={t}
                  lang={lang}
                />
                <MessageStudentModal
                  visible={!!messageStudentTarget}
                  student={messageStudentTarget}
                  classId={messageStudentTarget?.classId}
                  fetchWithAuth={fetchWithAuth}
                  onClose={() => setMessageStudentTarget(null)}
                  isDarkMode={isDarkMode}
                  t={t}
                />
                </>
              )
            ) : showJourney && journeyRuntime ? (
              renderJourneyWorkspace()
            ) : (
              <StudentHomeScreen
                userName={user?.name || t("Student")}
                userEmail={user?.email}
                authToken={authToken}
                learningResumeState={learningResumeState}
                curiosityResumeState={curiosityResumeState}
                availableTests={availableTests}
                upcomingTests={upcomingTests}
                myTestResults={myTestResults}
                onContinueLearning={studentHomeOnContinueLearning}
                onContinueCuriosityAI={studentHomeOnContinueCuriosityAI}
                onBrowseTopics={studentHomeOnBrowseTopics}
                onActivityPress={studentHomeOnActivityPress}
                onTestPress={studentHomeOnTestPress}
                onViewAllTests={studentHomeOnViewAllTests}
                onRecommendationPress={studentHomeOnRecommendationPress}
                myPracticeTests={myPracticeTests}
                onPracticeTestPress={studentHomeOnPracticeTestPress}
                onOpenJourney={(journeyId, previewStudent) => openJourney(journeyId, previewStudent)}
                showJourneyLauncher={canAccessSummerCampJourneys}
                showStemMissionLauncher={canAccessStemMissions}
                lessonPlans={lessonPlanList}
                lessonPlansProgress={lessonPlanProgress}
                lessonPlansLoading={lessonPlanListLoading}
                lessonPlansError={lessonPlanListError}
                onOpenLessonPlan={lessonPlanEnabled ? openLessonPlan : undefined}
                isDarkMode={isDarkMode}
                t={t}
                lang={lang}
              />
            )}
            </>
            )}
          </View>
        ) : activeModule === "lessonPlans" ? (
          /* Lesson in a Box 2026-08-13 — the open lesson, or the lesson index.
             An asset launch minimizes and switches module, so the PWO/video
             gets the stage and the floating pill brings the lesson back. */
          <View style={{ flex: 1, width: "100%", backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc" }}>
            {lessonWizardTarget ? (
              <LessonWizard
                isDarkMode={isDarkMode}
                board={contentDb}
                curriculum={curriculum}
                ownerEmail={user?.email}
                fetchWithAuth={fetchWithAuth}
                editLessonPlanId={
                  lessonWizardTarget === "new" ? null : lessonWizardTarget
                }
                onSaved={() => refreshLessonPlanList()}
                onClose={() => {
                  setLessonWizardTarget(null);
                  refreshLessonPlanList();
                }}
                t={t}
              />
            ) : lessonInsightsOpen ? (
              <ScrollView contentContainerStyle={{ padding: 0 }}>
                <LessonInsightsPanel
                  insights={lessonInsights}
                  loading={lessonInsightsLoading}
                  error={lessonInsightsError}
                  isDarkMode={isDarkMode}
                  onClose={() => setLessonInsightsOpen(false)}
                  t={t}
                />
              </ScrollView>
            ) : showLessonPlan && lessonPlanRuntime ? (
              renderLessonPlanWorkspace()
            ) : (
              renderLessonPlanIndex()
            )}
          </View>
        ) : activeModule === "discoveryJourneys" ? (
          /* Saras Learning Loop 2026-08-24 - the journey map, or the index of
             journeys for this board. Opening a loop hands off to the lesson
             runtime above; this arm never renders a lesson itself. */
          <View style={{ flex: 1, width: "100%", backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc" }}>
            <ScrollView contentContainerStyle={{ padding: 0 }}>
              {discoveryJourney ? (
                <>
                  <TouchableOpacity
                    onPress={closeDiscoveryJourney}
                    accessibilityLabel="Back to all journeys"
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 6,
                      alignSelf: "flex-start",
                      paddingVertical: 8,
                      paddingHorizontal: 12,
                      marginBottom: 4,
                    }}
                  >
                    <MaterialCommunityIcons
                      name="chevron-left"
                      size={20}
                      color={getLessonColors(isDarkMode).textSecondary}
                    />
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: "600",
                        color: getLessonColors(isDarkMode).textSecondary,
                      }}
                    >
                      {t("All journeys")}
                    </Text>
                  </TouchableOpacity>
                  <DiscoveryJourneyMap
                    // The runtime payload is flat: the journey's own fields sit
                    // at the top level beside `loops`, so the payload IS the
                    // journey.
                    journey={discoveryJourney}
                    loops={discoveryJourney?.loops || []}
                    onOpenLoop={openJourneyLoop}
                    loading={discoveryJourneyLoading}
                    error={discoveryJourneyError}
                    isDarkMode={isDarkMode}
                    footer={
                      <JourneyMasteryMap
                        concepts={discoveryJourneyMastery}
                        mode={isTeacher ? "teacher" : "student"}
                        isDarkMode={isDarkMode}
                        t={t}
                      />
                    }
                    t={t}
                  />
                </>
              ) : (
                <DiscoveryJourneyLauncher
                  fetchWithAuth={fetchWithAuth}
                  board={contentDb}
                  includeDrafts={isTeacher}
                  studentEmail={lessonPlanStudentEmail}
                  onOpenJourney={openDiscoveryJourney}
                  loading={discoveryJourneyLoading}
                  error={discoveryJourneyError}
                  isDarkMode={isDarkMode}
                  t={t}
                />
              )}
            </ScrollView>
          </View>
        ) : activeModule === "testQuestions" ? (
          <View style={{ flex: 1, width: "100%", backgroundColor: isDarkMode ? "#0f172a" : "#f1f5f9" }}>
            <TeacherTestsPage isDarkMode={isDarkMode} />
          </View>
        ) : activeModule === "collections" ? (
          <View style={{ flex: 1, width: "100%", backgroundColor: isDarkMode ? "#0f172a" : "#f1f5f9" }}>
            <CollectionBuilderScreen
              board={contentDb}
              ownerEmail={user_id}
              teacherEmail={user_id}
              languageId={languageID}
              curriculum={sortedCurriculum}
              isDarkMode={isDarkMode}
            />
          </View>
        ) : activeModule === "manageStudents" ? (
          <View style={{ flex: 1, width: "100%", backgroundColor: isDarkMode ? "#0f172a" : "#f1f5f9" }}>
            <ManageStudentsScreen
              isDarkMode={isDarkMode}
              schools={schools}
              canViewAllClasses={!!user?.can_view_all_classes}
              userSchool={user?.school || null}
              userSchoolId={user?.school_id ?? null}
              onFetchSchools={fetchSchools}
            />
          </View>
        ) : activeModule === "teacherDashboard" ? (
          <View style={{ flex: 1, width: "100%", backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc" }}>
            <TeacherDashboard setActiveModule={setActiveModule} isDarkMode={isDarkMode} />
          </View>
        ) : activeModule === "knowledgeMastery" ? (
          <View style={{ flex: 1, width: "100%", backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc" }}>
            <KtMasteryDashboard
              classId={null}
              isDarkMode={isDarkMode}
              apiBaseUrl={FASTAPI_BASE_URL}
              authToken={authToken}
            />
          </View>
        ) : activeModule === "learning" && learningSubModule === "chat" && !showSuggestionRail ? (
          /* Full-bleed Saras chat for narrow viewports where SuggestionRail is hidden */
          <View style={{ flex: 1, width: "100%", backgroundColor: isDarkMode ? "#0f172a" : "#ffffff" }}>
            <ChatPanel
              t={t}
              isDarkMode={isDarkMode}
              isCompact={true}
              dynamicStyles={{
                paddingTop: 6,
                paddingLeft: 6,
                paddingRight: 6,
                paddingBottom: 12,
                headerMarginBottom: 8,
                headerPaddingBottom: 6,
                headerFontSize: 13,
                headerLetterSpacing: 0.4,
                cardGap: 6,
                cardPaddingVertical: 10,
                cardPaddingHorizontal: 12,
                questionFontSize: 14,
                questionLineHeight: 18,
                sectionMarginBottom: 16,
              }}
              history={history}
              loading={loading}
              allSuggestionItems={[]}
              handlePillPress={() => {}}
              authToken={authToken}
              handleVideoClick={handleVideoClick}
              handlePWOClick={handlePWOClick}
              handleChapterClick={handleChapterClick}
              handleCollectionClick={handleCollectionClick}
              isMuted={isMuted}
              isPlaying={isPlaying}
              audioUrl={audioUrl}
              onToggleMute={handleToggleMute}
              onPlayAnswer={handlePlayAnswer}
              onStopAudio={stopAudio}
            />
          </View>
        ) : activeModule === "learning" && learningSubModule === "analytics" ? (
          /* Full-page Analytics view (no sidebar) */
          <View style={{ flex: 1, width: "100%", backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc" }}>
            <StudentAnalyticsPage
              assessments={assessments}
              adaptiveRecommendation={adaptiveRecommendation}
              formatLocalDate={formatLocalDate}
              isDarkMode={isDarkMode}
              t={t}
            />
          </View>
        ) : activeModule === "learning" && learningSubModule === "engagement" ? (
          /* Full-page Engagement view (no sidebar) */
          <View style={{ flex: 1, width: "100%", backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc" }}>
            <StudentEngagementPage
              engagementLogs={engagementLogs}
              engagementViewType={engagementViewType}
              onEngagementViewTypeChange={handleEngagementViewTypeChange}
              engagementHasMore={engagementHasMore}
              onLoadMoreEngagement={loadMoreEngagement}
              formatLocalDateShort={formatLocalDateShort}
              formatLocalWeekShort={formatLocalWeekShort}
              leaderboard={leaderboard}
              user_id={user_id}
              user_name={user_name}
              user_score={user_score}
              userRank={userRank}
              badges={badges}
              isDarkMode={isDarkMode}
              t={t}
            />
          </View>
        ) : (testReadyToStart && activeTest && quizMode === "test") || (showQuiz && (quizMode === "test" || quizMode === "pastTestView")) ? (
          /* Full-page Test-taking / completed-test review view */
          <View
            style={{
              flex: 1,
              width: "100%",
              minHeight: 0,
              flexDirection: quizMode === "pastTestView" ? "row" : "column",
              backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc",
            }}
          >
            {/* BDD 08/30/2026 - keep the live timed test full-width; only completed review shares space with Saras AI. */}
            <View style={{ flex: 1, minWidth: 0, minHeight: 0 }}>
              <StudentTestTakingPage
                activeTest={activeTest}
                testReadyToStart={testReadyToStart}
                testTimeLeft={testTimeLeft}
                showQuiz={showQuiz}
                quizMode={quizMode}
                quizData={quizData}
                userAnswers={userAnswers}
                answerFeedback={answerFeedback}
                showHints={showHints}
                showSolutions={showSolutions}
                handleStartTest={handleStartTest}
                handleSubmitTest={handleSubmitTest}
                onClose={() => {
                  // Close and go back to tests page
                  setTestReadyToStart(false);
                  setActiveTest(null);
                  setTestTimerActive(false);
                  setShowQuiz(false);
                  setQuizMode(null);
                  setQuizNav(null);
                  setQuiz([]);
                  setUserAnswers({});
                  setAnswerFeedback({});
                  setLearningSubModule("tests");
                }}
                toggleHint={toggleHint}
                toggleSolution={toggleSolution}
                handleAnswerChange={handleAnswerChange}
                handleMCQSelection={handleMCQSelection}
                handleMultiSelect={handleMultiSelect}
                checkTextAnswer={checkTextAnswer}
                mapQuizModeToDisplayMode={mapQuizModeToDisplayMode}
                formatLocalDate={formatLocalDate}
                isDarkMode={isDarkMode}
                t={t}
                // AIT-249: forward teacher-controlled toggle
                immediateFeedback={immediateFeedbackEnabled}
                onAskAI={handleExamReviewAskAI}
              />
            </View>

            {/* BDD 08/30/2026 - completed-test Ask AI uses the existing Saras rail.
                Never mount this rail during the live timed test. */}
            {quizMode === "pastTestView" && (
              <View
                style={{
                  width: Math.max(
                    320,
                    Math.min(
                      520,
                      rightSidebarWidth !== null
                        ? rightSidebarWidth
                        : responsiveRailWidth
                    )
                  ),
                  minWidth: 320,
                  maxWidth: 520,
                  minHeight: 0,
                  flexShrink: 0,
                  paddingTop: 8,
                  paddingRight: 4,
                  borderLeftWidth: 1,
                  borderLeftColor: isDarkMode
                    ? "rgba(255,255,255,0.10)"
                    : "rgba(15,23,42,0.10)",
                  backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc",
                  flexDirection: "row",
                }}
              >
                {/* Reuse the normal resizable Saras rail handle. */}
                <View
                  onStartShouldSetResponder={() => true}
                  onResponderGrant={onResizeGrantRightTouch}
                  onResponderMove={onResizeMoveRightTouch}
                  onResponderRelease={onResizeEndRightTouch}
                  onResponderTerminate={onResizeEndRightTouch}
                  {...(Platform.OS === "web"
                    ? { onMouseDown: onResizeStartRightWeb }
                    : {})}
                  pointerEvents="auto"
                  style={{
                    width: 12,
                    alignSelf: "stretch",
                    backgroundColor: isDarkMode
                      ? "rgba(255,255,255,0.06)"
                      : "rgba(0,0,0,0.04)",
                    borderRightWidth: 1,
                    borderRightColor: isDarkMode
                      ? "rgba(255,255,255,0.1)"
                      : "rgba(0,0,0,0.08)",
                    justifyContent: "center",
                    alignItems: "center",
                    ...(Platform.OS === "web"
                      ? { cursor: "ew-resize", userSelect: "none", touchAction: "none" }
                      : null),
                    zIndex: 20,
                  }}
                >
                  <View
                    style={{
                      width: 4,
                      height: 32,
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {[0, 1, 2, 3, 4, 5].map((i) => (
                      <View
                        key={i}
                        style={{
                          width: 3,
                          height: 3,
                          borderRadius: 1.5,
                          backgroundColor: isDarkMode
                            ? "rgba(255,255,255,0.3)"
                            : "rgba(0,0,0,0.2)",
                        }}
                      />
                    ))}
                  </View>
                </View>

                <SuggestionRail
                  t={t}
                  isDarkMode={isDarkMode}
                  idleSubtitle="Completed exam review"
                  sparksMapped={sparksMapped}
                  suggestedQuestions={suggestedQuestions}
                  suggestedQuestionsHeader={suggestedQuestionsHeader}
                  onAsk={askFromAnywhere}
                  viewMode={viewMode}
                  userId={user_id}
                  activeCollectionId={activeStudyCollection?.id}
                  suggestedQuestionsMeta={suggestedQuestionsMeta}
                  customWidth={
                    Math.max(
                      320,
                      Math.min(
                        520,
                        rightSidebarWidth !== null
                          ? rightSidebarWidth
                          : responsiveRailWidth
                      )
                    ) - 12
                  }
                  answerStyle={answerStyle}
                  setAnswerStyle={setAnswerStyle}
                  inputValue={inputValue}
                  setInputValue={setInputValue}
                  onInputSubmit={(txt) => handleAskButtonPress(txt)}
                  placeholder={placeholder}
                  loading={loading}
                  chatSessions={chatSessions}
                  sessionsLoading={sessionsLoading}
                  selectedConversationId={selectedConversationId}
                  openChatSession={openChatSession}
                  closeChatSession={closeChatSession}
                  sessionTurnsLoading={sessionTurnsLoading}
                  formatLocalDate={formatLocalDate}
                  history={history}
                  renderHistorySection={renderHistorySection}
                  authToken={authToken}
                  handleVideoClick={handleVideoClick}
                  handlePWOClick={handlePWOClick}
                  handleChapterClick={handleChapterClick}
                  handleCollectionClick={handleCollectionClick}
                  onVoiceInput={handleVoiceInput}
                  isListening={isListening}
                  styles={styles}
                  isMuted={isMuted}
                  isPlaying={isPlaying}
                  audioUrl={audioUrl}
                  onToggleMute={handleToggleMute}
                  onPlayAnswer={handlePlayAnswer}
                  onStopAudio={stopAudio}
                />
              </View>
            )}
          </View>
        ) : activeModule === "learning" && learningSubModule === "tests" ? (
          /* Full-page Tests view (no sidebar) */
          <View style={{ flex: 1, width: "100%", backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc" }}>
            <StudentTestsPage
              availableTests={availableTests}
              myTestResults={myTestResults}
              startStudentTest={startStudentTest}
              handleSelectPastTestResult={handleSelectPastTestResult}
              formatLocalDate={formatLocalDate}
              PDF_BASE_URL={PDF_BASE_URL}
              isDarkMode={isDarkMode}
              t={t}
              // Practice Tests props
              userEmail={user?.email}
              myPracticeTests={myPracticeTests}
              practiceSubjects={practiceSubjects}
              practiceSubjectKey={practiceSubjectKey}
              setPracticeSubjectKey={setPracticeSubjectKey}
              practiceSubjectId={practiceSubjectId}
              setPracticeSubjectId={setPracticeSubjectId}
              practiceSubjectName={practiceSubjectName}
              setPracticeSubjectName={setPracticeSubjectName}
              practiceChapters={practiceChapters}
              setPracticeChapters={setPracticeChapters}
              practiceChapterMode={practiceChapterMode}
              setPracticeChapterMode={setPracticeChapterMode}
              practiceSelectedChapterIds={practiceSelectedChapterIds}
              setPracticeSelectedChapterIds={setPracticeSelectedChapterIds}
              practiceTitle={practiceTitle}
              setPracticeTitle={setPracticeTitle}
              practiceTotal={practiceTotal}
              setPracticeTotal={setPracticeTotal}
              practiceMix={practiceMix}
              quickCreatePracticeTest={quickCreatePracticeTest}
              deletePracticeTest={deletePracticeTest}
              refreshMyPracticeTests={refreshMyPracticeTests}
            />
          </View>
        ) : (
          <>
            {/* <View style={styles(isDarkMode).mainContent}> BDD 12/21/2025*/}
            <View
              style={[
                styles(isDarkMode).mainContent,

                // Base padding + computed margin for dock
                {
                  padding: responsiveContentPadding
                },

                // Keep clear of the Saras rail. Same value the rail is sized
                // from, so the reservation is non-zero exactly when a rail is
                // drawn — see `railOverlayWidth`.
                railOverlayWidth > 0 && {
                  paddingRight: railOverlayWidth + responsiveContentPadding,
                },

                // Lesson in a Box 2026-08-13 — the lesson panel replaces the
                // Saras rail, so the stage reserves that width instead.
                lessonAssetMode &&
                !stageMaximized && {
                  paddingLeft: responsiveContentPadding,
                  paddingRight: lessonAssetCompanionShown
                    ? lessonAssetCompanionWidth + 24
                    : responsiveContentPadding,
                },
                // BDD 07/29/2026 - Journey
                journeyAssetMode &&
                !stageMaximized && {
                  paddingLeft: journeyAssetTocVisible
                    ? journeyAssetTocWidth + 24
                    : responsiveContentPadding,

                  paddingRight: journeyAssetCompanionVisible
                    ? journeyAssetCompanionWidth + 24
                    : responsiveContentPadding,
                },

                // ✅ FINAL OVERRIDE (last one wins)
                stageMaximized && { marginBottom: 0 },
              ]}
            >

              {/* 🎉 Confetti overlay (absolute; non-blocking) BDD 10/13/2025*/}
              {confettiVisible && (
                <View
                  pointerEvents="none"
                  style={{
                    position: "absolute",  // ⬅️ was "fixed"
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    zIndex: 999999,
                  }}
                >
                  <ConfettiOverlay
                    show
                    pieces={500}
                    gravity={0.3}
                    wind={0.015}
                    durationMs={6000}
                    colors={["#1a73e8", "#34a853", "#fbbc05", "#ea4335", "#a142f4"]}
                    onComplete={() => setConfettiVisible(false)}
                  />
                </View>
              )}


              {picker.visible && (
                <View style={sheet.overlay} pointerEvents="box-none">
                  {/* Backdrop */}
                  <TouchableOpacity style={sheet.backdrop} activeOpacity={1} onPress={dismissPicker} />

                  {/* Centered floating modal */}
                  <View style={sheet.modalContainer}>
                    <View
                      style={[
                        sheet.modal,
                        isDarkMode && sheet.modalDark,
                        {
                          maxHeight: height * 0.7,
                        },
                      ]}
                    >
                      {/* Close button (top right) */}
                      <TouchableOpacity
                        style={[sheet.closeBtn, isDarkMode && sheet.closeBtnDark]}
                        onPress={dismissPicker}
                        activeOpacity={0.7}
                      >
                        <MaterialCommunityIcons
                          name="close"
                          size={20}
                          color={isDarkMode ? "#94a3b8" : "#64748b"}
                        />
                      </TouchableOpacity>

                      {/* Header section */}
                      <View style={sheet.header}>
                        <View style={[sheet.headerIcon, isDarkMode && sheet.headerIconDark]}>
                          <MaterialCommunityIcons
                            name={picker.icon || "cube-outline"}
                            size={24}
                            color={isDarkMode ? "#60a5fa" : "#0077b6"}
                          />
                        </View>
                        <Text style={[sheet.title, isDarkMode && sheet.titleDark]} numberOfLines={2}>
                          {picker.title}
                        </Text>
                        <View style={[sheet.badge, isDarkMode && sheet.badgeDark]}>
                          <Text style={[sheet.badgeText, isDarkMode && sheet.badgeTextDark]}>
                            {(() => {
                              const watchedCount = picker.rows.filter(r => r.watched).length;
                              if (watchedCount > 0) return `${watchedCount}/${picker.rows.length} ${t("studied")}`;
                              return `${picker.rows.length} ${picker.rows.length === 1 ? t("item") : t("items")}`;
                            })()}
                          </Text>
                        </View>
                      </View>

                      {/* Items list */}
                      <ScrollView
                        style={sheet.listContainer}
                        contentContainerStyle={sheet.listContent}
                        showsVerticalScrollIndicator={true}
                        persistentScrollbar={true}
                      >
                        {picker.rows.map((r, index) => (
                          <TouchableOpacity
                            key={r.key}
                            style={[
                              sheet.item,
                              isDarkMode && sheet.itemDark,
                              r.watched && sheet.itemWatched,
                              r.watched && isDarkMode && sheet.itemWatchedDark,
                            ]}
                            onPress={r.onPress}
                            activeOpacity={0.7}
                          >
                            <View style={[
                              sheet.itemIconContainer,
                              isDarkMode && sheet.itemIconContainerDark,
                              r.watched && sheet.itemIconContainerWatched,
                              r.watched && isDarkMode && sheet.itemIconContainerWatchedDark,
                            ]}>
                              <MaterialCommunityIcons
                                name={r.icon || "play-circle-outline"}
                                size={20}
                                color={isDarkMode ? "#60a5fa" : "#0077b6"}
                              />
                            </View>
                            <View style={sheet.itemTextWrap}>
                              <Text style={[sheet.itemLabel, isDarkMode && sheet.itemLabelDark]} numberOfLines={2}>
                                {r.label}
                              </Text>
                              {r.watched ? (
                                <View style={{ flexDirection: "row", alignItems: "center", marginTop: 2 }}>
                                  <MaterialCommunityIcons
                                    name="check-circle"
                                    size={13}
                                    color={isDarkMode ? "#34d399" : "#10B981"}
                                    style={{ marginRight: 4 }}
                                  />
                                  <Text style={[sheet.itemSubWatched, isDarkMode && sheet.itemSubWatchedDark]} numberOfLines={1}>
                                    {t("Studied")} {r.watchCount}x
                                  </Text>
                                </View>
                              ) : r.countLoading ? (
                                <Text style={[sheet.itemSub, isDarkMode && sheet.itemSubDark]} numberOfLines={1}>
                                  ...
                                </Text>
                              ) : !!r.subtitle ? (
                                <Text style={[sheet.itemSub, isDarkMode && sheet.itemSubDark]} numberOfLines={1}>
                                  {r.subtitle}
                                </Text>
                              ) : null}
                            </View>
                            <View style={[sheet.itemChevron, isDarkMode && sheet.itemChevronDark]}>
                              <MaterialCommunityIcons
                                name="chevron-right"
                                size={18}
                                color={isDarkMode ? "#64748b" : "#94a3b8"}
                              />
                            </View>
                          </TouchableOpacity>
                        ))}
                      </ScrollView>

                      {/* Cancel button */}
                      <View style={[sheet.footerContainer, isDarkMode && sheet.footerContainerDark]}>
                        <TouchableOpacity
                          onPress={dismissPicker}
                          style={[sheet.cancelBtn, isDarkMode && sheet.cancelBtnDark]}
                          activeOpacity={0.8}
                        >
                          <Text style={[sheet.cancelText, isDarkMode && sheet.cancelTextDark]}>
                            {t("Cancel")}
                          </Text>
                        </TouchableOpacity>
                      </View>
                    </View>
                  </View>
                </View>
              )}

              {/* Quiz Info Modal */}


              {/*** PERSISTENT PWO LAYER (keeps Unity alive) ***/}
              {renderPwoStage()}
              {/*** ⬆️ END NEW PERSISTENT LAYER ***/}

              {/* Status Message — now handled by typing indicator in SuggestionRail chat panel */}
              { /*** BDD 10/14/2025 ***/}
              {isAsking && showTriviaWhenWaiting && triviaItem ? (
                <TriviaOverlayCard
                  item={triviaItem}
                  onNext={() => {
                    const module = activeModuleRef.current;
                    const topicId =
                      (module && (module.source_topic_id || module.topic?.source_topic_id)) || null;
                    setTriviaItem(pickNextTrivia(topicId));
                  }}
                />
              ) : null}

              {testReadyToStart && activeTest && quizMode === "test" ? (
                <View
                  style={{
                    marginBottom: 20,
                    padding: 10,
                    backgroundColor: isDarkMode ? "#222" : "#F5F5F5",
                    borderRadius: 10,
                    position: "relative",
                  }}
                >
                  {/* Close button for test ready view (before starting) */}
                  {/* BDD 02/03/2026 student-practice-test-phase1 below */}
                  <TouchableOpacity
                    onPress={() => {
                      setTestReadyToStart(false);
                      setActiveTest(null);
                      setTestTimerActive(false);
                    }}
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      zIndex: 70,
                      width: 36,
                      height: 36,
                      borderRadius: 18,
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "rgba(0, 0, 0, 0.6)",
                      backdropFilter: "blur(12px)",
                      WebkitBackdropFilter: "blur(12px)",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                    activeOpacity={0.8}
                  >
                    <MaterialCommunityIcons name="close" size={20} color="#fff" />
                  </TouchableOpacity>
                  <Text style={styles(isDarkMode).sectionTitle}>🧪 {activeTest.title}</Text>

                  {!isPractice ? (
                    <Text style={styles(isDarkMode).descriptionText}>
                      🧑‍🏫 {t("Teacher:")} {activeTest.teacher_email || t("Unknown")}
                    </Text>
                  ) : (
                    <Text style={styles(isDarkMode).descriptionText}>
                      🧑‍🎓 {t("Practice Test")}
                    </Text>
                  )}

                  <Text style={styles(isDarkMode).descriptionText}>
                    📝 {activeTest.description || t("No description provided")}
                  </Text>

                  <Text style={styles(isDarkMode).descriptionText}>
                    🕒 {t("Duration:")}{" "}
                    {activeTest.duration_minutes ? `${activeTest.duration_minutes} ${t("minutes")}` : t("Untimed")}
                  </Text>

                  {!isPractice && (
                    <Text style={styles(isDarkMode).descriptionText}>
                      📅 {t("Available:")}{" "}
                      {activeTest.start_time ? formatLocalDate(activeTest.start_time) : "N/A"} –{" "}
                      {activeTest.end_time ? formatLocalDate(activeTest.end_time) : "N/A"}
                    </Text>
                  )}

                  {activeTest.chapters?.length > 0 && (
                    <View style={{ marginTop: 5 }}>
                      <Text style={styles(isDarkMode).descriptionText}>📚 {t("Chapters:")}</Text>

                      {activeTest.chapters.map((ch, idx) => {
                        const cname =
                          (ch?.chapter_name || ch?.name || "").trim();

                        return (
                          <Text key={idx} style={{ marginLeft: 10 }}>
                            • {cname ? cname : `Chapter ID: ${ch?.chapter_id}`}
                            {ch?.topic_id ? ` → Topic ID: ${ch.topic_id}` : ""}
                          </Text>
                        );
                      })}
                    </View>
                  )}
                  <Button onPress={handleStartTest} mode="contained" style={{ marginTop: 20 }}>
                    🚀 {t("Start Test")}
                  </Button>
                </View>
              ) : showQuiz && learningSubModule !== "homework" ? (
                <View style={{ flex: 1, position: "relative" }}>
                  {/* Close button for QUIZ only (NOT for live test mode) */}
                  {quizMode !== "test" && (
                    <TouchableOpacity
                      onPress={() => {
                        // Close quiz using the same unified module close
                        setStageMaximized(false);
                        handleCloseModule();
                      }}
                      style={{
                        position: "absolute",
                        top: 2,
                        right: 12,
                        zIndex: 70,
                        width: 36,
                        height: 36,
                        borderRadius: 18,
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(0, 0, 0, 0.6)",
                        backdropFilter: "blur(12px)",
                        WebkitBackdropFilter: "blur(12px)",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }}
                      activeOpacity={0.8}
                    >
                      <MaterialCommunityIcons name="close" size={20} color="#fff" />
                    </TouchableOpacity>
                  )}

                  <>
                    <ScrollView style={{ flex: 1, padding: 10 }}>
                      <Text style={styles(isDarkMode).sectionTitle}>
                        <MaterialCommunityIcons
                          name={
                            quizMode === "test"
                              ? "clipboard-list"
                              : quizMode === "pastTestView"
                                ? "clipboard-check-outline"
                                : quizMode === "quizReview"
                                  ? "clipboard-check-outline"
                                  : "clipboard-text-outline"
                          }
                          size={18}
                          color="#007BFF"
                        />{" "}
                        {quizMode === "test"
                          ? `🧪 ${t("Test")}`
                          : quizMode === "pastTestView"
                            ? `📊 ${t("Test Results")}`
                            : quizMode === "quizReview"
                              ? `📊 ${t("Review your answers")}`
                              : `📝 ${t("Quiz")}`}
                      </Text>

                      <QuestionDisplay
                        mode={mapQuizModeToDisplayMode(quizMode)} // <-- new helper below
                        quiz={quizData} // 👈 array of questions
                        isDarkMode={false} // Force light mode – KaTeX equations render with black text
                        userAnswers={userAnswers}
                        answerFeedback={answerFeedback}
                        showHints={showHints}
                        showSolutions={showSolutions}
                        toggleHint={toggleHint}
                        toggleSolution={toggleSolution}
                        handleAnswerChange={handleAnswerChange}
                        handleMCQSelection={handleMCQSelection}
                        handleMultiSelect={handleMultiSelect}
                        checkTextAnswer={checkTextAnswer}
                        onNavStateChange={quizMode === "quiz" ? setQuizNav : null}
                        // AIT-249: gate live "selection coloring" and surface the review summary
                        immediateFeedback={immediateFeedbackEnabled}
                        isReviewMode={quizMode === "quizReview" || quizMode === "pastTestView"}
                        reviewSummary={quizMode === "quizReview" ? reviewSummary : null}
                      />
                    </ScrollView>

                    {/* Fixed footer for quiz mode: nav buttons + submit */}
                    {quizMode === "quiz" && Array.isArray(quizData) && quizData.length > 0 && (
                      <View style={{
                        paddingVertical: 12,
                        paddingHorizontal: 20,
                        borderTopWidth: 1,
                        borderTopColor: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)",
                        backgroundColor: isDarkMode ? "#1e293b" : "#f8fafc",
                        alignItems: "center",
                      }}>
                        {/* Prev / Next nav row */}
                        {quizNav && quizNav.total > 1 && (
                          <View style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: 10,
                            gap: 16,
                          }}>
                            <TouchableOpacity
                              onPress={quizNav.onPrev}
                              disabled={quizNav.currentIndex === 0}
                              activeOpacity={0.7}
                              style={{
                                paddingVertical: 8,
                                paddingHorizontal: 18,
                                borderRadius: 8,
                                backgroundColor: quizNav.currentIndex === 0
                                  ? (isDarkMode ? "#334155" : "#e2e8f0")
                                  : (isDarkMode ? "#475569" : "#cbd5e1"),
                              }}
                            >
                              <Text style={{
                                fontSize: 14,
                                fontWeight: "600",
                                color: quizNav.currentIndex === 0
                                  ? (isDarkMode ? "#64748b" : "#94a3b8")
                                  : (isDarkMode ? "#f1f5f9" : "#1e293b"),
                              }}>
                                ← {t("Previous")}
                              </Text>
                            </TouchableOpacity>

                            <Text style={{
                              fontSize: 13,
                              fontWeight: "600",
                              color: isDarkMode ? "#94a3b8" : "#64748b",
                            }}>
                              {quizNav.currentIndex + 1} / {quizNav.total}
                            </Text>

                            <TouchableOpacity
                              onPress={quizNav.onNext}
                              disabled={quizNav.currentIndex === quizNav.total - 1}
                              activeOpacity={0.7}
                              style={{
                                paddingVertical: 8,
                                paddingHorizontal: 18,
                                borderRadius: 8,
                                backgroundColor: quizNav.currentIndex === quizNav.total - 1
                                  ? (isDarkMode ? "#334155" : "#e2e8f0")
                                  : (isDarkMode ? "#475569" : "#cbd5e1"),
                              }}
                            >
                              <Text style={{
                                fontSize: 14,
                                fontWeight: "600",
                                color: quizNav.currentIndex === quizNav.total - 1
                                  ? (isDarkMode ? "#64748b" : "#94a3b8")
                                  : (isDarkMode ? "#f1f5f9" : "#1e293b"),
                              }}>
                                {t("Next")} →
                              </Text>
                            </TouchableOpacity>
                          </View>
                        )}

                        {/* Submit button - green to match Submit Test */}
                        {/* AIT-249: Submit transitions to "quizReview" instead of
                            immediately closing the stage. The review screen then
                            shows a "Done" button to perform the legacy close. */}
                        <TouchableOpacity
                          onPress={async () => {
                            await submitQuiz();
                            setQuizMode("quizReview");
                            setQuizNav(null);
                          }}
                          activeOpacity={0.8}
                          style={{
                            paddingVertical: 14,
                            paddingHorizontal: 32,
                            borderRadius: 12,
                            backgroundColor: isDarkMode ? "#34d399" : "#10B981",
                            alignItems: "center",
                            width: "100%",
                            maxWidth: 400,
                          }}
                        >
                          <Text style={{ color: "#fff", fontSize: 15, fontWeight: "700" }}>
                            {t("Submit Quiz")}
                          </Text>
                        </TouchableOpacity>
                      </View>
                    )}

                    {/* AIT-249: review footer with "Done" — appears after submit
                        in the deferred-feedback practice quiz flow. */}
                    {quizMode === "quizReview" && (
                      <View style={{
                        paddingVertical: 12,
                        paddingHorizontal: 20,
                        borderTopWidth: 1,
                        borderTopColor: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)",
                        backgroundColor: isDarkMode ? "#1e293b" : "#f8fafc",
                        alignItems: "center",
                      }}>
                        <TouchableOpacity
                          onPress={() => {
                            setStageMaximized(false);
                            setShowQuiz(false);
                            setQuizMode(null);
                            setQuizNav(null);
                            setQuiz([]);
                            setUserAnswers({});
                            setAnswerFeedback({});
                            setQuizResponses({});
                            setReviewSummary(null);
                            // This is the normal finish path and it bypasses
                            // handleCloseModule entirely, so it has to ask the
                            // same question cleanupModule does.
                            setActiveModule(resolveModuleAfterClose({ consume: true }));
                          }}
                          activeOpacity={0.8}
                          style={{
                            paddingVertical: 14,
                            paddingHorizontal: 32,
                            borderRadius: 12,
                            backgroundColor: isDarkMode ? "#34d399" : "#10B981",
                            alignItems: "center",
                            width: "100%",
                            maxWidth: 400,
                          }}
                        >
                          <Text style={{ color: "#fff", fontSize: 15, fontWeight: "700" }}>
                            {t("Done")}
                          </Text>
                        </TouchableOpacity>
                      </View>
                    )}

                    {/* ⏱️ Timer + Submit for live "test" mode */}
                    {quizMode === "test" && (
                      <View style={{ marginVertical: 20, alignItems: "center" }}>
                        <Text style={styles(isDarkMode).sectionTitle}>
                          🕒 Time Remaining: {Math.floor(testTimeLeft / 60)}:
                          {String(testTimeLeft % 60).padStart(2, "0")}
                        </Text>
                        <Button onPress={handleSubmitTest} mode="contained">
                          {t("Submit Test")}
                        </Button>
                      </View>
                    )}
                  </>
                </View>
              ) : showVideo ? (
                <View
                  style={{
                    // No "flex: 1" here. Keep it top-aligned and sized to content. BDD 10/13/2025
                    flexShrink: 0,
                    paddingBottom: stageMaximized ? 0 : (bottomInset || 0) + 80,  // keep clear of askDock (not in fullscreen)
                    alignItems: "stretch",
                    // In fullscreen: use viewport units to always fill screen regardless of app zoom
                    ...(stageMaximized ? {
                      height: '100%',
                      overflow: 'hidden',
                    } : {}),
                  }}
                >
                  {/* 16:9 responsive container BDD 10/29/2025*/}
                  <View
                    style={{
                      position: "relative",
                      width: "100%",
                      aspectRatio: stageMaximized ? undefined : 16 / 9,  // Remove aspect ratio in fullscreen
                      height: stageMaximized ? '100%' : undefined,
                      alignSelf: "stretch",
                      backgroundColor: "#000",
                      maxHeight: stageMaximized ? 'unset' : 670,
                      // overflow removed from parent to prevent clipping controls
                      // borderRadius: 10,              // NEW: soften edges
                      // borderWidth: 1,                // NEW: subtle frame
                      // borderColor: "rgba(255,255,255,0.18)", // NEW: faint line
                      // // optional, gives a gentle glow
                      // shadowColor: "#000",
                      // shadowOpacity: 0.45,
                      // shadowOffset: { width: 0, height: 4 },
                      // shadowRadius: 10,
                      // elevation: 4,
                    }}
                  >
                    {/* Video wrapper with overflow hidden */}
                    <View
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        overflow: "hidden",  // Crop video when zoomed
                        maxHeight: stageMaximized ? '100%' : responsiveVideoMaxHeight,
                      }}
                    >
                      <video
                        ref={videoRef}
                        src={nativeVideoUrl || ""}
                        playsInline
                        preload="metadata"
                        className={journeySelfGuidedFocus ? "wonderlabs-caption-video" : undefined}
                        controls={!sbs3dProjectorMode}
                        onClick={sbs3dProjectorMode ? toggleSbs3dVideoPlayback : undefined}
                        onEnded={() => {
                          if (journeySelfGuidedFocus) setJourneyVideoPlaying(false);
                          handleVideoEnded?.();
                        }}
                        onPlay={() => {
                          if (journeySelfGuidedFocus && journeyActiveAsset?.type === "video") {
                            journeyVideoInterruptedSpeechRef.current = true;
                            stopTtsStream();
                            setJourneyVideoPlaying(true);
                          }
                        }}
                        onPause={() => {
                          if (journeySelfGuidedFocus) setJourneyVideoPlaying(false);
                        }}
                        style={{
                          position: "absolute",
                          top: 0, left: 0, right: 0, bottom: 0,
                          width: "100%",
                          height: "100%",
                          display: "block",
                          // objectFit: "contain",
                          transform: `scale(${videoScale})`,       // <-- zoom
                          transformOrigin: "center center",
                          willChange: "transform",
                          /* NEW: draw the border on the zooming surface itself */
                          border: "1px solid rgba(255,255,255,0.25)",
                          boxSizing: "border-box",
                          borderRadius: 8, // optional; tweak to taste or remove

                        }}
                      >
                        {journeySelfGuidedFocus && wonderLabsCaptionTracks.map((track) => (
                          <track
                            key={`${currentVideoId}-${track.language_id}-${track.retry || 0}`}
                            kind="captions"
                            src={track.url}
                            srcLang={track.srclang || "en"}
                            label={track.label || "Captions"}
                            default={track.default === true}
                            onLoad={(event) => {
                              // Some engines attach textTracks after the
                              // containing video's effect has already run.
                              const loadedTrack = event?.currentTarget?.track;
                              if (loadedTrack) {
                                loadedTrack.mode = "showing";
                                placeWonderLabsCaptionCues(loadedTrack);
                              }
                            }}
                            onError={() => {
                              console.warn("[WonderLabs CC] Browser could not parse/load a VTT track", currentVideoId);
                            }}
                          />
                        ))}
                      </video>
                    </View>

                    {/* SBS 3D video controls. Browser-native media controls live in shadow DOM
                        and cannot be addressed reliably by our Pointer-Lock software cursor.
                        This explicit DOM bar is duplicated by the global SBS compositor and
                        supports play/pause plus click-to-seek. */}
                    {sbs3dProjectorMode && (
                      <View
                        style={{
                          position: "absolute",
                          left: "15%",
                          right: "15%",
                          bottom: 18,
                          height: 54,
                          zIndex: 2147483550,
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 12,
                          paddingHorizontal: 14,
                          borderRadius: 14,
                          backgroundColor: "rgba(0,0,0,0.72)",
                          borderWidth: 1,
                          borderColor: "rgba(255,255,255,0.25)",
                        }}
                      >
                        <TouchableOpacity
                          onPress={toggleSbs3dVideoPlayback}
                          accessibilityLabel={sbs3dVideoPlaying ? t("Pause video") : t("Play video")}
                          style={{
                            width: 38,
                            height: 38,
                            borderRadius: 19,
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "rgba(255,255,255,0.14)",
                          }}
                          activeOpacity={0.75}
                        >
                          <MaterialCommunityIcons
                            name={sbs3dVideoPlaying ? "pause" : "play"}
                            size={22}
                            color="#fff"
                          />
                        </TouchableOpacity>

                        <div
                          data-sbs3d-video-seek="1"
                          role="slider"
                          aria-label="Video seek"
                          style={{
                            position: "relative",
                            flex: 1,
                            height: 18,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              left: 0,
                              right: 0,
                              height: 6,
                              borderRadius: 999,
                              background: "rgba(255,255,255,0.30)",
                              pointerEvents: "none",
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              left: 0,
                              width: `${sbs3dVideoDuration > 0
                                ? Math.max(0, Math.min(100, (sbs3dVideoTime / sbs3dVideoDuration) * 100))
                                : 0}%`,
                              height: 6,
                              borderRadius: 999,
                              background: "#60a5fa",
                              pointerEvents: "none",
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              left: `${sbs3dVideoDuration > 0
                                ? Math.max(0, Math.min(100, (sbs3dVideoTime / sbs3dVideoDuration) * 100))
                                : 0}%`,
                              width: 14,
                              height: 14,
                              borderRadius: "50%",
                              background: "#fff",
                              transform: "translateX(-7px)",
                              pointerEvents: "none",
                            }}
                          />
                        </div>

                        <Text
                          style={{
                            color: "#fff",
                            fontSize: rem(12) + 'rem',
                            fontWeight: "600",
                            fontFamily: "monospace",
                            minWidth: 92,
                            textAlign: "right",
                          }}
                        >
                          {formatSbs3dVideoTime(sbs3dVideoTime)} / {formatSbs3dVideoTime(sbs3dVideoDuration)}
                        </Text>
                      </View>
                    )}

                    {/* Video Controls - Split design: Close at top-left, Zoom dock at bottom-left */}
                    {showStageControls && isVideoStageVisible && (
                      <>
                        {/* Close button - Top right corner BDD 07/29/2026 - Journey - changed onPress */}
                        <TouchableOpacity
                          onPress={handleJourneyStageClose}
                          style={{
                            position: "absolute",
                            top: 2,
                            right: 12,
                            zIndex: 70,
                            width: 36,
                            height: 36,
                            borderRadius: 18,
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "rgba(0, 0, 0, 0.6)",
                            backdropFilter: "blur(12px)",
                            WebkitBackdropFilter: "blur(12px)",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                            border: "1px solid rgba(255, 255, 255, 0.1)",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                          }}
                          activeOpacity={0.8}
                        >
                          <MaterialCommunityIcons name="close" size={20} color="#fff" />
                        </TouchableOpacity>

                        {/* Zoom & Fullscreen dock - Bottom center, draggable */}
                        {videoReady && (
                          <View
                            style={{
                              position: "absolute",
                              bottom: 24,
                              left: '45%',
                              right: 0,
                              alignItems: "center",
                              justifyContent: "center",
                              zIndex: 2147483500,
                              width:184
                            }}
                          >
                            <View
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                backgroundColor: "rgba(0, 0, 0, 0.6)",
                                backdropFilter: "blur(12px)",
                                WebkitBackdropFilter: "blur(12px)",
                                borderRadius: 22,
                                paddingHorizontal: 4,
                                paddingVertical: 4,
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                                border: "1px solid rgba(255, 255, 255, 0.1)",
                                gap: 2,
                              }}
                            >
                              {/* Zoom out */}
                              <TouchableOpacity
                                onPress={() => zoomVideo(-VIDEO_ZOOM_STEP)}
                                disabled={videoScale <= MIN_VIDEO_ZOOM + 1e-6}
                                style={{
                                  width: 36,
                                  height: 36,
                                  borderRadius: 18,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: videoScale <= MIN_VIDEO_ZOOM + 1e-6 ? "not-allowed" : "pointer",
                                  transition: "all 0.15s ease",
                                }}
                                activeOpacity={0.7}
                              >
                                <MaterialCommunityIcons
                                  name="minus"
                                  size={20}
                                  color={videoScale <= MIN_VIDEO_ZOOM + 1e-6 ? "rgba(255,255,255,0.3)" : "#fff"}
                                />
                              </TouchableOpacity>

                              {/* Zoom percentage */}
                              <View style={{
                                paddingHorizontal: 8,
                                height: 36,
                                minWidth: 50,
                                alignItems: "center",
                                justifyContent: "center",
                              }}>
                                <Text style={{
                                  color: "#fff",
                                  fontSize: rem(13) + 'rem',
                                  fontWeight: "600",
                                  fontFamily: "monospace",
                                  textAlign: "center",
                                  letterSpacing: 0.5,
                                  userSelect: "none",
                                }}>
                                  {Math.round(videoScale * 100)}%
                                </Text>
                              </View>

                              {/* Zoom in */}
                              <TouchableOpacity
                                onPress={() => zoomVideo(+VIDEO_ZOOM_STEP)}
                                disabled={videoScale >= MAX_VIDEO_ZOOM - 1e-6}
                                style={{
                                  width: 36,
                                  height: 36,
                                  borderRadius: 18,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: videoScale >= MAX_VIDEO_ZOOM - 1e-6 ? "not-allowed" : "pointer",
                                  transition: "all 0.15s ease",
                                }}
                                activeOpacity={0.7}
                              >
                                <MaterialCommunityIcons
                                  name="plus"
                                  size={20}
                                  color={videoScale >= MAX_VIDEO_ZOOM - 1e-6 ? "rgba(255,255,255,0.3)" : "#fff"}
                                />
                              </TouchableOpacity>

                              {/* Divider */}
                              <View style={{
                                width: 1,
                                height: 20,
                                backgroundColor: "rgba(255, 255, 255, 0.2)",
                                marginHorizontal: 4,
                              }} />

                              {/* Fullscreen toggle */}
                              <TouchableOpacity
                                onPress={() => setStageMaximized((prev) => !prev)}
                                style={{
                                  width: 36,
                                  height: 36,
                                  borderRadius: 18,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  transition: "all 0.15s ease",
                                }}
                                activeOpacity={0.7}
                              >
                                <MaterialCommunityIcons
                                  name={stageMaximized ? "fullscreen-exit" : "fullscreen"}
                                  size={20}
                                  color="#fff"
                                />
                              </TouchableOpacity>
                            </View>
                          </View>
                        )}
                      </>
                    )}
                  </View>

                </View>
              ) : effectiveActiveModule === "pwo" ? ( // ⬅️ Unity iframe lives in persistent layer // BDD 01/12/2026 X-bug
                null
              ) : activeModule === "learning" && learningSubModule === "homework" ? (
                // ===== HOMEWORK HELP (inside mainContent so SuggestionRail stays visible) =====
                <ScrollView style={{ flex: 1, backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc" }}>
                  <View style={{ padding: 12, paddingBottom: 140 }}>
                    <HomeworkHelpPanel
                      apiBaseUrl={HOMEWORK_API_BASE_URL}
                      userId={user_id}
                      contentDb={contentDb || "cbse"}
                      homeworkModeOn={homeworkHelpEnabled}
                      onEnableHomeworkMode={() => {
                        setHomeworkHelpEnabled(true);
                        homeworkHelpNewDialogOnNextAskRef.current = true;
                      }}
                      onAskProblem={askHomeworkProblem}
                      t={t}
                      isDarkMode={isDarkMode}
                      MarkdownRenderer={MarkdownRenderer}
                    />
                  </View>
                </ScrollView>
              ) : SHOW_AP_EXAM_PREP && activeModule === "learning" && learningSubModule === "ap-exam-prep" ? (
                // ===== AP EXAM PREP (scaffold — placeholder content) =====
                <APExamPrepScreen isDarkMode={isDarkMode} t={t} />
              ) : showTiles ? ( // BDD 10/17/2025 – tiles if user asked for them OR no collections
                // ===== CURRICULUM MAIN with FolderNavigation =====
                <View style={{ flex: 1, backgroundColor: isDarkMode ? "#0f172a" : "#f1f5f9" }}>
                  {/* Folder drill-down navigation (replaces left sidebar) */}
                  <FolderNavigation
                    isDarkMode={isDarkMode}
                    sortedCurriculum={sortedCurriculum}
                    hasMultipleGrades={hasMultipleGrades}
                    selectedChapter={selectedChapter}
                    onChapterSelect={(payload) => {
                      setSelectedChapter(payload);
                      setActiveModule("learning");
                      ensureExpandedForChapter(payload.levelId, payload.subjectId, payload.chapterId);
                      storage.set(LAST_CHAPTER_KEY, payload);
                    }}
                    onDepthChange={setFolderNavDepth}
                    labelForCurriculumNode={labelForCurriculumNode}
                    t={t}
                    contentDb={contentDb}
                  />

                  {/* Chapter body: feature-gated authored learning path, otherwise current Topic tiles. */}
                  {folderNavDepth >= 3 && selectedChapter && (
                    activeChapterLearningPath ? (
                      <ChapterLearningWorkspace
                        path={activeChapterLearningPath}
                        chapter={selectedChapter}
                        fetchWithAuth={fetchWithAuth}
                        userId={user_id}
                        authToken={authToken}
                        languageId={languageIDquiz}
                        localLanguage={langCode}
                        isDarkMode={isDarkMode}
                        t={t}
                        onAsk={({ path: learningPath, topic, section }) => {
                          const topicRef = topic?.topicRef || {};
                          const question = `${t("Help me understand")} ${section?.title || ""} ${t("in")} ${topic?.title || learningPath?.title || ""}.`;
                          askFromUI(question, {
                            customInstructions: {
                              intent: "chapter_learning_section",
                              subject: selectedChapter?.subjectName || learningPath?.subject || null,
                              chapter: selectedChapter?.chapterName || learningPath?.chapter || null,
                              topic: topic?.title || topicRef?.name || null,
                              learning_section: section?.title || null,
                              board_topic_id: topicRef?.topicId ?? null,
                              source_topic_id: topicRef?.sourceTopicId ?? null,
                            },
                            topicScope: {
                              chapterId: selectedChapter?.chapterId ?? null,
                              topicId: topicRef?.topicId ?? null,
                              board_topic_id: topicRef?.topicId ?? null,
                              source_topic_id: topicRef?.sourceTopicId ?? null,
                              topic_name: topic?.title || topicRef?.name || null,
                              chapter_name: selectedChapter?.chapterName || null,
                            },
                            forceNewDialog: true,
                          });
                        }}
                      />
                    ) : topicsFlatForChapter.length > 0 ? (
                  <ScrollView style={{ flex: 1 }}>
                    <View style={{ paddingBottom: 120 }}>
                      {/* Chapter Header Card */}
                      <View style={{ paddingHorizontal: 28, paddingTop: 12 }}>
                        <View style={{
                          backgroundColor: isDarkMode ? "#1e293b" : "#fff",
                          borderRadius: 16,
                          padding: 20,
                          paddingHorizontal: 24,
                          borderWidth: 1,
                          borderColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#e2e8f0",
                          ...(Platform.OS === "web" ? { boxShadow: "0 1px 4px rgba(0,0,0,0.04)" } : { shadowColor: "#000", shadowOpacity: 0.04, shadowRadius: 4, shadowOffset: { width: 0, height: 1 }, elevation: 1 }),
                          marginBottom: 20,
                        }}>
                          {/* Top row: icon + title + buttons */}
                          <View style={{ flexDirection: "row", alignItems: "center", gap: 16 }}>
                            {/* Subject icon */}
                            <View style={{
                              width: 44, height: 44, borderRadius: 12, flexShrink: 0,
                              background: isDarkMode
                                ? "linear-gradient(135deg, #1e3a5f, #0f172a)"
                                : "linear-gradient(135deg, #dbeafe, #eff6ff)",
                              borderWidth: 1,
                              borderColor: isDarkMode ? "#334155" : "#bfdbfe",
                              alignItems: "center", justifyContent: "center",
                            }}>
                              <Text style={{ fontSize: 22 }}>🧪</Text>
                            </View>

                            {/* Title area */}
                            <View style={{ flex: 1 }}>
                              <Text style={{
                                fontSize: 11, fontWeight: "600", textTransform: "uppercase",
                                letterSpacing: 0.6,
                                color: isDarkMode ? "#60a5fa" : "#60a5fa",
                                marginBottom: 2,
                              }}>
                                {selectedChapter?.subjectName || t("Chapter")}
                              </Text>
                              <Text style={{
                                fontSize: 19, fontWeight: "700",
                                color: isDarkMode ? "#f1f5f9" : "#0f172a",
                              }}>
                                {selectedChapter?.chapterName || selectedChapter?.name || t("Current Chapter")}
                              </Text>
                            </View>

                            {/* Guide Me button */}
                            <View style={{ flexDirection: "row", gap: 8, flexShrink: 0 }}>
                              <TouchableOpacity
                                onPress={() => {
                                  const chapterId =
                                    selectedChapter?.chapterId ??
                                    selectedChapter?.id ??
                                    selectedChapter?.chapter_id;
                                  const chapterTitle =
                                    selectedChapter?.chapterName ||
                                    selectedChapter?.name ||
                                    selectedChapter?.chapter_title ||
                                    t("Current Chapter");
                                  if (!chapterId) {
                                    console.warn("Guide Me: no chapterId on selectedChapter", selectedChapter);
                                    return;
                                  }
                                  handleGuideMeChapterClick(chapterId, chapterTitle);
                                }}
                                style={{
                                  paddingVertical: 8, paddingHorizontal: 18, borderRadius: 8,
                                  backgroundColor: "#2563eb",
                                  flexDirection: "row", alignItems: "center", gap: 6,
                                  ...(Platform.OS === "web" ? { transition: "background 0.15s" } : {}),
                                }}
                              >
                                <Text style={{ fontSize: 13 }}>⭐</Text>
                                <Text style={{ fontSize: 13, fontWeight: "600", color: "#fff" }}>
                                  {guideMeLoading ? t("Thinking…") : t("Guide Me")}
                                </Text>
                              </TouchableOpacity>
                            </View>
                          </View>

                          {/* Progress section */}
                          <View style={{
                            marginTop: 16, paddingTop: 16,
                            borderTopWidth: 1,
                            borderTopColor: isDarkMode ? "rgba(148,163,184,0.1)" : "#f1f5f9",
                          }}>
                            <View style={{ flexDirection: "row", justifyContent: "space-between", marginBottom: 6 }}>
                              <Text style={{ fontSize: 12, fontWeight: "500", color: isDarkMode ? "#64748b" : "#94a3b8" }}>
                                {t("Chapter Progress")}
                              </Text>
                              <Text style={{ fontSize: 12, fontWeight: "700", color: isDarkMode ? "#60a5fa" : "#2563eb" }}>
                                {chapterProgressPercentage ?? 0}%
                              </Text>
                            </View>
                            <View style={{
                              height: 5, borderRadius: 5, overflow: "hidden",
                              backgroundColor: isDarkMode ? "rgba(148,163,184,0.1)" : "#f1f5f9",
                            }}>
                              <View style={{
                                width: `${chapterProgressPercentage ?? 0}%`,
                                height: "100%", borderRadius: 5,
                                background: "linear-gradient(90deg, #60a5fa, #2563eb)",
                              }} />
                            </View>
                          </View>
                        </View>
                      </View>

                      {/* Topic cards grid */}
                      <View
                        style={{
                          paddingHorizontal: 28,
                          paddingTop: 0,
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 12,
                        }}
                      >
                        {(showAllTopics
                          ? topicsFlatForChapterWithCounts
                          : topicsFlatForChapterWithCounts.slice(0, INITIAL_CARDS_TO_SHOW)
                        ).map((it) => (
                          <View key={it.topicId} style={tileWrapperWidthStyle}>
                            <TopicCardRedesigned
                              item={it}
                              imgUrl={resolveTopicImgUrl(it.topicImagePath)}
                              swanSrc={SARAS_3D_SWAN_SRC}
                              isDarkMode={isDarkMode}
                              t={t}
                              onStart={onStartTopic}
                              onOpenPwo={onOpenPwo}
                              onOpenVideo={onOpenVideo}
                              onOpenQuiz={onOpenQuiz}
                            />
                          </View>
                        ))}
                      </View>

                      {/* View All Topics button when there are hidden cards */}
                      {!showAllTopics && topicsFlatForChapterWithCounts.length > INITIAL_CARDS_TO_SHOW && (
                        <TouchableOpacity
                          onPress={() => setShowAllTopics(true)}
                          style={{
                            marginHorizontal: 16,
                            marginTop: 16,
                            paddingVertical: 14,
                            paddingHorizontal: 20,
                            backgroundColor: isDarkMode ? "rgba(99, 102, 241, 0.1)" : "rgba(99, 102, 241, 0.08)",
                            borderRadius: 12,
                            borderWidth: 1,
                            borderColor: isDarkMode ? "rgba(99, 102, 241, 0.3)" : "rgba(99, 102, 241, 0.2)",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 8,
                          }}
                        >
                          <MaterialCommunityIcons
                            name="view-grid-plus"
                            size={18}
                            color={isDarkMode ? "#818cf8" : "#6366f1"}
                          />
                          <Text
                            style={{
                              color: isDarkMode ? "#818cf8" : "#6366f1",
                              fontSize: rem(14) + 'rem',
                              fontWeight: "600",
                            }}
                          >
                            {t("View All")} {topicsFlatForChapterWithCounts.length} {t("Topics")}
                          </Text>
                        </TouchableOpacity>
                      )}

                      {SHOW_DISCOVERY && (
                        <>
                          <View style={{ marginTop: 10 }}>
                            <ChipRow
                              title={t("Today’s Picks")}
                              items={picks}
                              isDarkMode={isDarkMode}
                            />
                          </View>
                          <View
                            style={{
                              paddingHorizontal: 16,
                              paddingTop: 10,
                              position: "relative",
                              zIndex: 0,
                            }}
                            pointerEvents="box-none"
                          >
                            <ChipRow
                              title={t("Curiosity Sparks")}
                              items={sparksMapped}
                              wrap
                              isDarkMode={isDarkMode}
                            />
                          </View>
                        </>
                      )}
                    </View>
                  </ScrollView>
                    ) : null
                  )}
                </View>
              ) : activeModule === "learning" ? (
                <>
                  {flags.club_mode ? (
                    activeStudyCollection ? (
                      // ✅ In club_mode AND a collection is selected:
                      //    - show tiles when ready
                      //    - otherwise show loading placeholder
                      (collectionResolved && (topicsFlat?.length || 0) > 0) ? (
                        // ===== CLUB MODE COLLECTION VIEW (tiles + Guide Me) =====
                        <ScrollView style={{ backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc" }}>
                          <View style={{ paddingBottom: 120 }}>
                            {/* Back to collections list */}
                            {availableCollections.length > 1 && (
                              <TouchableOpacity
                                onPress={() => clearStudentCollection()}
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: 6,
                                  paddingHorizontal: 20,
                                  paddingTop: 14,
                                  paddingBottom: 4,
                                }}
                              >
                                <MaterialCommunityIcons name="arrow-left" size={16} color={isDarkMode ? "#60a5fa" : "#2563eb"} />
                                <Text style={{ fontSize: 13, fontWeight: "600", color: isDarkMode ? "#60a5fa" : "#2563eb" }}>
                                  {t("All Collections")}
                                </Text>
                              </TouchableOpacity>
                            )}

                            {/* Collection header + Guide Me button */}
                            <View style={{ paddingHorizontal: 16, paddingTop: availableCollections.length > 1 ? 8 : 16 }}>
                              <SectionHeader
                                title={
                                  activeStudyCollection?.title ||
                                  activeStudyCollection?.name ||
                                  (viewMode === "curriculum" ? t("Chapters") : t("Current Collection"))
                                }
                                subtitle={viewMode === "curriculum" ? t("Curriculum") : t("Learning Module")}
                                icon={viewMode === "curriculum" ? "book-open-variant" : "folder-star"}
                                isDarkMode={isDarkMode}
                                rightAction={guideMeLoading ? t("Thinking\u2026") : t("Guide Me")}
                                rightActionIcon="compass"
                                onRightActionPress={handleGuideMeClick}
                              />
                            </View>

                            <CollectionProgressBar
                              progress={collectionProgressPercentage}
                              isDarkMode={isDarkMode}
                              goalPercent={
                                challengeLockdown && challengeState?.current
                                  ? (challengeState.current.advance_threshold_pct ?? null)
                                  : null
                              }
                              badge={
                                challengeLockdown && challengeState?.current
                                  ? `${t("Challenge")} ${challengeState.current.day}/${challengeState?.days?.length || 1}`
                                  : null
                              }
                            />

                            {/* Topic tiles grid */}
                            <View
                              style={{
                                paddingHorizontal: 16,
                                paddingTop: 8,
                                flexDirection: "row",
                                flexWrap: "wrap",
                                gap: 12,
                              }}
                            >
                              {(showAllTopics ? topicsFlat : topicsFlat.slice(0, INITIAL_CARDS_TO_SHOW)).map((it) => (
                                <View key={it.topicId} style={tileWrapperWidthStyle}>
                                  <TopicCardRedesigned
                                    item={it}
                                    imgUrl={resolveTopicImgUrl(it.topicImagePath)}
                                    swanSrc={SARAS_3D_SWAN_SRC}
                                    isDarkMode={isDarkMode}
                                    t={t}
                                    onStart={onStartTopic}
                                    onOpenPwo={onOpenPwo}
                                    onOpenVideo={onOpenVideo}
                                    onOpenQuiz={onOpenQuiz}
                                  />
                                </View>
                              ))}
                            </View>

                            {/* View All Topics button */}
                            {!showAllTopics && topicsFlat.length > INITIAL_CARDS_TO_SHOW && (
                              <TouchableOpacity
                                onPress={() => setShowAllTopics(true)}
                                style={{
                                  marginHorizontal: 16,
                                  marginTop: 16,
                                  paddingVertical: 14,
                                  paddingHorizontal: 20,
                                  backgroundColor: isDarkMode
                                    ? "rgba(99, 102, 241, 0.1)"
                                    : "rgba(99, 102, 241, 0.08)",
                                  borderRadius: 12,
                                  borderWidth: 1,
                                  borderColor: isDarkMode
                                    ? "rgba(99, 102, 241, 0.3)"
                                    : "rgba(99, 102, 241, 0.2)",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: 8,
                                }}
                              >
                                <MaterialCommunityIcons
                                  name="view-grid-plus"
                                  size={18}
                                  color={isDarkMode ? "#818cf8" : "#6366f1"}
                                />
                                <Text
                                  style={{
                                    color: isDarkMode ? "#818cf8" : "#6366f1",
                                    fontSize: rem(14) + 'rem',
                                    fontWeight: "600",
                                  }}
                                >
                                  {t("View All")} {topicsFlat.length} {t("Topics")}
                                </Text>
                              </TouchableOpacity>
                            )}

                            {SHOW_DISCOVERY && (
                              <>
                                <View style={{ paddingHorizontal: 16, paddingTop: 10 }}>
                                  <ChipRow
                                    title={t("Curiosity Sparks")}
                                    items={sparksMapped}
                                    wrap
                                    isDarkMode={isDarkMode}
                                  />
                                </View>
                                <View style={{ marginTop: 10 }}>
                                  <ChipRow
                                    title={t("Today's Picks")}
                                    items={picks}
                                    isDarkMode={isDarkMode}
                                  />
                                </View>
                              </>
                            )}
                          </View>
                        </ScrollView>
                      ) : collectionsDetailLoading ? (
                        // ✅ Collection selected and still loading
                        <ScrollView style={{ backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc" }}>
                          <EmptyState
                            icon="folder-star"
                            title={t("Loading collection\u2026")}
                            message={t("Preparing topics for this module.")}
                            isDarkMode={isDarkMode}
                          />
                        </ScrollView>
                      ) : (
                        // ✅ Collection loaded but has no topics
                        <ScrollView style={{ backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc" }}>
                          <EmptyState
                            icon="folder-open-outline"
                            title={t("No topics in this collection")}
                            message={t("This learning module doesn't have any topics yet. Try selecting a different collection from the sidebar.")}
                            isDarkMode={isDarkMode}
                          />
                        </ScrollView>
                      )
                    ) : (
                      // ✅ club_mode but no collection selected — show collection list
                      <ScrollView style={{ backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc" }}>
                        <View style={{ paddingBottom: 60 }}>
                          <View style={{ paddingHorizontal: 28, paddingTop: 24, paddingBottom: 16 }}>
                            <Text style={{ fontSize: 20, fontWeight: "700", color: isDarkMode ? "#f1f5f9" : "#0f172a" }}>
                              {t("Collections")}
                            </Text>
                            <Text style={{ fontSize: 13, color: isDarkMode ? "#94a3b8" : "#64748b", marginTop: 4 }}>
                              {t("Select a collection to explore its topics")}
                            </Text>
                          </View>
                          <View style={{ paddingHorizontal: 20, gap: 10 }}>
                            {availableCollections.length > 0 ? availableCollections.map((col) => (
                              <TouchableOpacity
                                key={col.id}
                                onPress={() => openStudentCollection(col, "user-tap")}
                                activeOpacity={0.7}
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  paddingVertical: 18,
                                  paddingHorizontal: 20,
                                  borderRadius: 14,
                                  borderWidth: 1,
                                  borderColor: isDarkMode ? "rgba(148,163,184,0.15)" : "#e2e8f0",
                                  backgroundColor: isDarkMode ? "#1e293b" : "#fff",
                                  ...(Platform.OS === "web" ? {
                                    cursor: "pointer",
                                    transition: "transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease",
                                  } : {}),
                                }}
                              >
                                <View style={{
                                  width: 44, height: 44, borderRadius: 12, flexShrink: 0,
                                  backgroundColor: isDarkMode ? "rgba(99,102,241,0.15)" : "rgba(99,102,241,0.1)",
                                  alignItems: "center", justifyContent: "center",
                                  marginRight: 14,
                                }}>
                                  <MaterialCommunityIcons name="folder-star" size={22} color={isDarkMode ? "#818cf8" : "#6366f1"} />
                                </View>
                                <View style={{ flex: 1, minWidth: 0, marginRight: 8 }}>
                                  <Text numberOfLines={1} style={{
                                    fontSize: 15, fontWeight: "600",
                                    color: isDarkMode ? "#f1f5f9" : "#0f172a",
                                  }}>
                                    {col.name}
                                  </Text>
                                  {col.item_count != null && (
                                    <Text style={{ fontSize: 12, color: isDarkMode ? "#64748b" : "#94a3b8", marginTop: 2 }}>
                                      {col.item_count} {col.item_count === 1 ? t("topic") : t("topics")}
                                    </Text>
                                  )}
                                </View>
                                <MaterialCommunityIcons name="chevron-right" size={20} color={isDarkMode ? "#475569" : "#cbd5e1"} />
                              </TouchableOpacity>
                            )) : (
                              <EmptyState
                                icon="folder-open-outline"
                                title={t("No collections available")}
                                message={t("No learning modules have been assigned yet.")}
                                isDarkMode={isDarkMode}
                              />
                            )}
                          </View>
                        </View>
                      </ScrollView>
                    )
                  ) : (
                    // ✅ Not club_mode: keep it simple (no curriculum tree fallback in mainContent)
                    <ScrollView style={{ backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc" }}>
                      <EmptyState
                        icon="book-open-page-variant"
                        title={t("Select a Chapter or Collection")}
                        message={t("Pick from the left sidebar to explore topics.")}
                        isDarkMode={isDarkMode}
                      />
                    </ScrollView>
                  )}
                </>
              ) : activeModule === "whiteboard" ? (

                <View style={{ flex: 1, backgroundColor: "white" }}>
                  <ReactSketchCanvas
                    ref={whiteboardRef}
                    style={{ width: "100%", height: "100%", backgroundColor: "white" }}
                    strokeWidth={4}
                    strokeColor="black"
                  />
                  {/* Clear and Submit Buttons */}
                  <View
                    style={{ flexDirection: "row", justifyContent: "space-around", padding: 10 }}
                  >
                    <Button onPress={() => whiteboardRef.current.clearCanvas()} mode="outlined">
                      Clear
                    </Button>
                    <Button onPress={handleSaveWhiteboard} mode="contained">
                      Submit
                    </Button>
                  </View>
                </View>
              ) : (
                <ScrollView>
                  {/* Show Uploaded File Name */}
                  {uploadedFile && (
                    <View style={{ marginTop: 10 }}>
                      <Text style={styles(isDarkMode).answerText}>
                        📎 Uploaded File: {uploadedFile.name}
                      </Text>

                      {/* Show Extracted Text for PDFs */}
                      {uploadedFile.content && (
                        <ScrollView
                          style={{
                            maxHeight: 200,
                            padding: 10,
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          <Text style={styles(isDarkMode).answerText}>
                            {typeof uploadedFile.content === "string"
                              ? uploadedFile.content.substring(0, 1000) + "..."
                              : "Unable to preview file"}
                          </Text>
                        </ScrollView>
                      )}

                      {/* Show Image Preview if the file is an image */}
                      {uploadedFile.content &&
                        typeof uploadedFile.content === "string" &&
                        uploadedFile.content.startsWith("data:image") && (
                          <Image
                            source={{ uri: uploadedFile.content }}
                            style={{
                              width: "100%",
                              height: 200,
                              resizeMode: "contain",
                              marginTop: 10,
                            }}
                          />
                        )}
                    </View>
                  )}                
                  </ScrollView>
              )}
              {/* BDD 11/16/2025 – SuggestionRail temporarily disabled for Da Vinci pilot.
                  Backend + DB (collection_prompts) are live; UI will be re-enabled later. */}
              {/* RIGHT: show in club mode or challenge lockdown, but not while Journey owns the asset panel.
                  Drawn on exactly the value the stage reserves above — see `railOverlayWidth`. */}
              {railOverlayWidth > 0 && (
                  <View
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      bottom: 0,
                      width: railOverlayWidth,
                      paddingTop: 8,
                      paddingRight: 4,
                      zIndex: 30,
                      flexDirection: "row",
                    }}
                  >
                    {/* Drag handle for right sidebar */}
                    <View
                      onStartShouldSetResponder={() => true}
                      onResponderGrant={onResizeGrantRightTouch}
                      onResponderMove={onResizeMoveRightTouch}
                      onResponderRelease={onResizeEndRightTouch}
                      onResponderTerminate={onResizeEndRightTouch}
                      {...(Platform.OS === "web"
                        ? { onMouseDown: onResizeStartRightWeb }
                        : {})}
                      pointerEvents="auto"
                      style={{
                        width: 12,
                        alignSelf: "stretch",
                        backgroundColor: isDarkMode ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
                        borderRightWidth: 1,
                        borderRightColor: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)",
                        justifyContent: "center",
                        alignItems: "center",
                        ...(Platform.OS === "web"
                          ? { cursor: "ew-resize", userSelect: "none", touchAction: "none" }
                          : null),
                        zIndex: 20,
                      }}
                    >
                      {/* Grip indicator dots */}
                      <View style={{
                        width: 4,
                        height: 32,
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}>
                        {[0, 1, 2, 3, 4, 5].map((i) => (
                          <View
                            key={i}
                            style={{
                              width: 3,
                              height: 3,
                              borderRadius: 1.5,
                              backgroundColor: isDarkMode ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.2)",
                            }}
                          />
                        ))}
                      </View>
                    </View>
                    <SuggestionRail
                      t={t}
                      isDarkMode={isDarkMode}
                      sparksMapped={sparksMapped}
                      suggestedQuestions={suggestedQuestions}
                      suggestedQuestionsHeader={suggestedQuestionsHeader}
                      onAsk={askFromAnywhere}
                      viewMode={viewMode}
                      userId={user_id}
                      activeCollectionId={activeStudyCollection?.id}
                      suggestedQuestionsMeta={suggestedQuestionsMeta}
                      customWidth={rightSidebarWidth !== null ? rightSidebarWidth - 12 : null}
                      answerStyle={answerStyle}
                      setAnswerStyle={setAnswerStyle}
                      inputValue={inputValue}
                      setInputValue={setInputValue}
                      onInputSubmit={(txt) => handleAskButtonPress(txt)}
                      placeholder={placeholder}
                      loading={loading}
                      chatSessions={chatSessions}
                      sessionsLoading={sessionsLoading}
                      selectedConversationId={selectedConversationId}
                      openChatSession={openChatSession}
                      closeChatSession={closeChatSession}
                      sessionTurnsLoading={sessionTurnsLoading}
                      formatLocalDate={formatLocalDate}
                      history={history}
                      renderHistorySection={renderHistorySection}
                      authToken={authToken}
                      handleVideoClick={handleVideoClick}
                      handlePWOClick={handlePWOClick}
                      handleChapterClick={handleChapterClick}
                      handleCollectionClick={handleCollectionClick}
                      onVoiceInput={handleVoiceInput}
                      isListening={isListening}
                      styles={styles}
                      isMuted={isMuted}
                      isPlaying={isPlaying}
                      audioUrl={audioUrl}
                      onToggleMute={handleToggleMute}
                      onPlayAnswer={handlePlayAnswer}
                      onStopAudio={stopAudio}
                    />
                  </View>
                )}
              {/* BDD 02/10/2026 - suggested questions improvement */}
              {!flags.club_mode && suggestedQuestions.length > 0 && isPwoOpen && !showQuiz && quizMode !== "test" && (
                <View
                  pointerEvents="box-none"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    // This legacy popup is an absolute child, so mainContent's
                    // paddingRight does not move it. It only coincides with a
                    // rail under challenge lockdown (club_mode off), and
                    // railOverlayWidth is 0 in every other case.
                    right: railOverlayWidth,
                    bottom: 0,
                    zIndex: 5,
                  }}
                >
                  <View
                    pointerEvents="auto"
                    style={{
                      position: "absolute",
                      bottom: 10,
                      left: 10,
                      right: 10,
                      backgroundColor: "#fff",
                      padding: 10,
                      borderRadius: 8,
                      elevation: 5,
                    }}
                  >
                    <Text style={{ fontWeight: "bold", marginBottom: 6 }}>
                      {`🤖 ${
                        (Array.isArray(suggestedQuestionsHeader) && suggestedQuestionsHeader.length > 0)
                          ? suggestedQuestionsHeader[0]
                          : t("Deepen your understanding:")
                      }`}
                    </Text>

                    {/* ✅ Step-1 clarity line */}
                    <Text style={{ marginTop: 2, marginBottom: 8, fontSize: 12, color: "#666" }}>
                      {t("Tap a question to ask the AI")}
                    </Text>

                    <View
                      style={{
                        flexDirection: "row",
                        flexWrap: "wrap",
                        justifyContent: "flex-start",
                        gap: 8,
                      }}
                    >
                      {suggestedQuestions.map((question, index) => (
                        <TouchableOpacity
                          key={index}
                          onPress={() => {
                            console.log("[Suggested tapped]", index, question);

                            const opts =
                              suggestedQuestionsMeta?.kind === "topic" && suggestedQuestionsMeta?.topicScope
                                ? { topicScope: suggestedQuestionsMeta.topicScope, forceNewDialog: true }
                                : null;

                            if (opts) askFromAnywhere(question, opts);
                            else askFromAnywhere(question);
                          }}
                          style={{
                            backgroundColor: activeSuggestedQuestion === question ? "#CDE8FF" : "#EEE",
                            paddingVertical: 6,
                            paddingHorizontal: 10,
                            borderRadius: 6,
                            borderColor: activeSuggestedQuestion === question ? "#007BFF" : "#CCC",
                            borderWidth: 1,
                            marginBottom: 6,
                            maxWidth: "100%",
                          }}
                        >
                          {/* ✅ Step-1 "Ask AI →" affordance */}
                          <View style={{ flexDirection: "row", alignItems: "center" }}>
                            <Text style={{ color: "#333", flexShrink: 1, flexWrap: "wrap" }}>
                              {question}
                            </Text>
                            <Text style={{ color: "#007BFF", fontWeight: "600", marginLeft: 8, fontSize: 12 }}>
                              {t("Ask AI")} →
                            </Text>
                          </View>
                        </TouchableOpacity>
                      ))}
                    </View>
                  </View>
                </View>
              )}

            </View>
          </>
        )}
        {/* end full-width teacher tool screens conditional */}

      </View>

      {/* ===== Modern Shelves (investor mode only) BDD 10/13/2025 ===== */}
      {
        shelvesLayout && !lessonPresentMode && !journeyPresentMode && !journeySelfGuidedFocus && (
          <>
            <HistoryShelf
              open={historyOpen}
              onClose={() => setHistoryOpen(false)}
              isDarkMode={isDarkMode}
              items={collectionHistory}
              activeCollectionName={activeStudyCollection?.name}
              // Wrap to auto-close on click
              renderHistorySection={renderHistorySection}
              handleVideoClick={(...args) => { setHistoryOpen(false); handleVideoClick(...args); }}
              handlePWOClick={(...args) => { setHistoryOpen(false); handlePWOClick(...args); }}
              authToken={authToken}
              styles={styles}
            />

            <InsightsShelf
              open={insightsOpen}
              onClose={() => setInsightsOpen(false)}
              isDarkMode={isDarkMode}
              assessments={assessments}
              adaptiveRecommendation={adaptiveRecommendation}
              engagementLogs={engagementLogs}
              leaderboard={leaderboard}
              badges={badges}
              styles={styles}
              t={t}
              formatLocalDate={formatLocalDate}
              user_id={user_id}
              user_name={user_name}
              userRank={userRank}
              user_score={user_score}
            />

            <LauncherShelf
              open={launcherOpen}
              onClose={() => setLauncherOpen(false)}
              isDarkMode={isDarkMode}
              activeTab={activeLauncherTab}
              setActiveTab={setActiveLauncherTab}
              availableCollections={availableCollections}
              openStudentCollection={openStudentCollection}
              clearStudentCollection={clearStudentCollection}
              activeStudyCollection={activeStudyCollection}
              availableTests={availableTests}
              startStudentTest={startStudentTest}
              myTestResults={myTestResults}
              handleSelectPastTestResult={handleSelectPastTestResult}
              t={t}
              formatLocalDate={formatLocalDate}
              PDF_BASE_URL={PDF_BASE_URL}
              Platform={Platform}
              Linking={Linking}
            />
          </>
        )
      }

      {/* View-mode toggle - MOVED TO FOOTER BDD 12/13/2025 */}
      {/* Answer length toggle - MOVED TO FOOTER BDD 12/13/2025 */}

      {/* The version strip is the last thing left on the container floor; it
          would sit under the lesson as a grey band on the projector. */}
      {!lessonPresentMode && !journeyPresentMode && !journeySelfGuidedFocus && (
        <View style={{ width: "100%", alignItems: "center" }}>
          {/* Status stripe (only when loading) BDD 10/5/2025 */}

          {/* "Working on your query" overlay removed — typing indicator now lives in SuggestionRail chat panel */}

          {/* Bottom dock removed — chat input lives in right AI panel (SuggestionRail) */}
          <VersionBadge isDarkMode={isDarkMode} />
        </View>
      )}

      {/* ===== HISTORY MODAL ===== BDD 10/13/2025 */}
      {
        shelvesLayout && (
          <HistoryModal
            open={historyOpen}
            onClose={() => setHistoryOpen(false)}
            isDarkMode={isDarkMode}
            items={collectionHistory}
            activeCollectionName={activeStudyCollection?.name}
            renderHistorySection={renderHistorySection}
            handleVideoClick={handleVideoClick}
            handlePWOClick={handlePWOClick}
            authToken={authToken}
            styles={styles}
            t={t}
          />
        )
      }

      {/* ===== INSIGHTS MODAL ===== BDD 10/13/2025*/}
      {
        shelvesLayout && (
          <InsightsModal
            open={insightsOpen}
            onClose={() => setInsightsOpen(false)}
            isDarkMode={isDarkMode}
            assessments={assessments}
            adaptiveRecommendation={adaptiveRecommendation}
            engagementLogs={engagementLogs}
            leaderboard={leaderboard}
            badges={badges}
            styles={styles}
            t={t}
            formatLocalDate={formatLocalDate}
            user_id={user_id}
            user_name={user_name}
            userRank={userRank}
            user_score={user_score}
          />
        )
      }

      {/* ===== LAUNCHER MODAL ===== BDD 10/13/2025 */}
      {
        shelvesLayout && (
          <LauncherModal
            open={launcherOpen}
            onClose={() => setLauncherOpen(false)}
            isDarkMode={isDarkMode}
            activeTab={activeLauncherTab}
            setActiveTab={setActiveLauncherTab}
            availableCollections={availableCollections}
            openStudentCollection={openStudentCollection}
            clearStudentCollection={clearStudentCollection}
            activeStudyCollection={activeStudyCollection}
            availableTests={availableTests}
            startStudentTest={startStudentTest}
            myTestResults={myTestResults}
            handleSelectPastTestResult={handleSelectPastTestResult}
            t={t}
            formatLocalDate={formatLocalDate}
            PDF_BASE_URL={PDF_BASE_URL}
            Platform={Platform}
            Linking={Linking}
            setCurriculumView={setCurriculumView}
            setActiveModule={setActiveModule}
          />
        )
      }

      {/* ===== CURRICULUM MODAL (same wrapper & styles as Language) BDD 10/15/2025 ===== */}
      <Modal
        visible={curriculumModalVisible}
        transparent
        animationType="fade"
        onRequestClose={() => setCurriculumModalVisible(false)}
      >
        <TouchableWithoutFeedback onPress={() => setCurriculumModalVisible(false)}>
          <View style={styles(isDarkMode).modalBackground}>
            <TouchableWithoutFeedback>
              <View style={styles(isDarkMode).modalBox}>
                <Text style={styles(isDarkMode).modalTitle}>🎓 {t("Select Curriculum / Board")}</Text>

                <FlatList
                  data={CURRICULA}
                  keyExtractor={(item) => item}
                  style={{ maxHeight: 260 }}
                  showsVerticalScrollIndicator
                  renderItem={({ item }) => (
                    <TouchableOpacity
                      disabled={isChangingCurriculum}
                      onPress={async () => {
                        await handleSelectCurriculum(item); // includes the "Are you sure?" confirm
                        setCurriculumModalVisible(false);
                      }}
                    >
                      <Text
                        style={[
                          styles(isDarkMode).languageItem,
                          item === currentCurriculum ? styles(isDarkMode).selectedLanguage : null,
                        ]}
                      >
                      {getBoardLabel(item)} {item === currentCurriculum ? "✅" : ""}
                      </Text>
                    </TouchableOpacity>
                  )}
                />

                <TouchableOpacity onPress={() => setCurriculumModalVisible(false)} style={styles(isDarkMode).modalClose}>
                  <Text>❌ {t("Close")}</Text>
                </TouchableOpacity>
              </View>
            </TouchableWithoutFeedback>
          </View>
        </TouchableWithoutFeedback>
      </Modal>

      {/* ===== LANGUAGE MODAL (same content, reliable wrapper) ===== */}
      <Modal
        visible={languageModal}
        transparent
        animationType="fade"
        onRequestClose={() => setLanguageModal(false)}
      >
        <TouchableWithoutFeedback onPress={() => setLanguageModal(false)}>
          <View style={styles(isDarkMode).modalBackground}>
            <TouchableWithoutFeedback /* prevent closing when tapping inside card */>
              <View style={styles(isDarkMode).modalBox}>
                <Text style={styles(isDarkMode).modalTitle}>
                  🌍 {t("Select Language for AI Tutor Interaction")}
                </Text>

                <FlatList
                  data={languages}
                  keyExtractor={(item) => item.id}
                  style={{ maxHeight: 200 }}
                  showsVerticalScrollIndicator
                  renderItem={({ item }) => (
                    <TouchableOpacity
                      onPress={() => {
                        handleLanguageSelect(item.id, "secondary");
                        setLanguageModal(false);
                      }}
                    >
                      <Text
                        style={[
                          styles(isDarkMode).languageItem,
                          selectedSecondaryLang === item.id ? styles(isDarkMode).selectedLanguage : {},
                        ]}
                      >
                        {item.name} {selectedSecondaryLang === item.id ? "✅" : ""}
                      </Text>
                    </TouchableOpacity>
                  )}
                />

                <TouchableOpacity onPress={() => setLanguageModal(false)} style={styles(isDarkMode).modalClose}>
                  <Text>❌ {t("Close")}</Text>
                </TouchableOpacity>
              </View>
            </TouchableWithoutFeedback>
          </View>
        </TouchableWithoutFeedback>
      </Modal>

      {/* ===== Notifications - BDD 01/21/2026 - 01/22/2026 - add_subscription_notifications_and_support ===== */}
      {
        canSeeAdminNotifications && (
          <NotificationsModal
            visible={notificationsModalVisible}
            onClose={() => setNotificationsModalVisible(false)}
            user={user}
            isDarkMode={isDarkMode}
            t={t}
            onOpenSupport={() => {
              setNotificationsModalVisible(false);
              setSupportModalVisible(true);
            }}
          />
        )
      }

      {/* ===== SUPPORT CRM MODAL - BDD 01/21/2026 - 01/22/2026 - add_subscription_notifications_and_support ===== */}
      <SupportCenterModal
        visible={supportModalVisible}
        onClose={() => setSupportModalVisible(false)}
        user={user}
        isDarkMode={isDarkMode}
        t={t}
        activeModule={activeModule}
        currentCurriculum={currentCurriculum}
        contentDb={contentDb}
      />

      {/* ===== KNOWLEDGE CENTER MODAL — guides users through each functionality ===== */}
      <KnowledgeCenterModal
        visible={knowledgeModalVisible}
        onClose={() => setKnowledgeModalVisible(false)}
        isDarkMode={isDarkMode}
        t={t}
      />

      {/* ===== PROFILE MODAL (unchanged form fields) ===== */}
      <Modal
        visible={profileModalVisible}
        transparent
        animationType="slide"
        onRequestClose={() => setProfileModalVisible(false)}
      >
        <TouchableWithoutFeedback onPress={() => setProfileModalVisible(false)}>
          <View style={styles(isDarkMode).modalBackground}>
            <TouchableWithoutFeedback>
              <View style={styles(isDarkMode).modalBox}>
                <Text style={styles(isDarkMode).modalTitle}>👤 {t("Edit Profile")}</Text>

                <ScrollView>
                  {/* 🔹 Grade */}
                  <View style={styles(isDarkMode).inputContainer}>
                    <Text style={styles(isDarkMode).label}>📚 {t("Grade:")}</Text>
                    <TextInput
                      style={styles(isDarkMode).input}
                      value={profileData.grade}
                      onChangeText={(text) => setProfileData({ ...profileData, grade: text })}
                    />
                  </View>

                  {/* 🔹 Age */}
                  <View style={styles(isDarkMode).inputContainer}>
                    <Text style={styles(isDarkMode).label}>🎂 {t("Age:")}</Text>
                    <TextInput
                      style={styles(isDarkMode).input}
                      keyboardType="numeric"
                      value={profileData.age ? profileData.age.toString() : ""}
                      onChangeText={(text) => {
                        if (text === "" || isNaN(text)) {
                          setProfileData({ ...profileData, age: null });
                        } else {
                          setProfileData({ ...profileData, age: parseInt(text, 10) });
                        }
                      }}
                    />
                  </View>

                  {/* 🔹 Passion */}
                  <View style={styles(isDarkMode).inputContainer}>
                    <Text style={styles(isDarkMode).label}>🔥 {t("Passion:")}</Text>
                    <TextInput
                      style={styles(isDarkMode).input}
                      value={profileData.passion}
                      onChangeText={(text) => setProfileData({ ...profileData, passion: text })}
                    />
                  </View>

                  {/* 🔹 Favorite STEM Subject */}
                  <View style={styles(isDarkMode).inputContainer}>
                    <Text style={styles(isDarkMode).label}>🧪 {t("Favorite STEM Subject:")}</Text>
                    <TextInput
                      style={styles(isDarkMode).input}
                      value={profileData.favorite_stem_subject}
                      onChangeText={(text) =>
                        setProfileData({ ...profileData, favorite_stem_subject: text })
                      }
                    />
                  </View>

                  {/* 🔹 Extracurricular Activity */}
                  <View style={styles(isDarkMode).inputContainer}>
                    <Text style={styles(isDarkMode).label}>⚽ {t("Extracurricular Activity:")}</Text>
                    <TextInput
                      style={styles(isDarkMode).input}
                      value={profileData.extracurricular_activity}
                      onChangeText={(text) =>
                        setProfileData({ ...profileData, extracurricular_activity: text })
                      }
                    />
                  </View>

                  {/* 🔹 Preferred Learning Style */}
                  <View style={styles(isDarkMode).inputContainer}>
                    <Text style={styles(isDarkMode).label}>🧠 {t("Learning Style:")}</Text>
                    <TextInput
                      style={styles(isDarkMode).input}
                      value={profileData.preferred_learning_style}
                      onChangeText={(text) =>
                        setProfileData({ ...profileData, preferred_learning_style: text })
                      }
                    />
                  </View>

                  {/* 
            <View style={styles(isDarkMode).inputContainer}>
              <Text style={styles(isDarkMode).label}>🔖 {t("Always include references")}</Text>
              <Switch value={autoFetchReferences} onValueChange={setAutoFetchReferences} />
            </View>

            
            <View style={styles(isDarkMode).inputContainer}>
              <Text style={styles(isDarkMode).label}>📚 {t("Restrict to RAG-only answers")}</Text>
              <Switch value={restrictToRAGOnly} onValueChange={setRestrictToRAGOnly} />
            </View>
            BDD 11/12/2025 */}

                  {/* 🔹 Auto-open video after refs */}
                  <View style={styles(isDarkMode).inputContainer}>
                    <Text style={styles(isDarkMode).label}>🎥 {t("Auto‑open video after references")}</Text>
                    <Switch value={autoPlayVideo} onValueChange={setAutoPlayVideo} />
                  </View>

                  {/* 🔹 Auto-open PWO after refs */}
                  <View style={styles(isDarkMode).inputContainer}>
                    <Text style={styles(isDarkMode).label}>🎮 {t("Auto‑open PWO after references")}</Text>
                    <Switch value={autoOpenPWO} onValueChange={setAutoOpenPWO} />
                  </View>

                  {/* 🔹 Knowledge Check Popups toggle */}
                  <View style={styles(isDarkMode).inputContainer}>
                    <View style={{ flex: 1 }}>
                      <Text style={styles(isDarkMode).label}>{t("Knowledge Check Popups")}</Text>
                      <Text style={{
                        fontSize: 11,
                        color: isDarkMode ? '#64748b' : '#94a3b8',
                        marginTop: 2,
                      }}>
                        {ktPopupDisabled
                          ? t("Paused — toggle on to resume quick checks")
                          : t("Short quizzes appear while you study")}
                      </Text>
                    </View>
                    <Switch
                      value={!ktPopupDisabled}
                      onValueChange={(val) => handleKtPopupToggle(!val)}
                    />
                  </View>
                </ScrollView>

                {/* Buttons */}
                <View style={styles(isDarkMode).modalButtons}>
                  <TouchableOpacity
                    onPress={() => setProfileModalVisible(false)}
                    style={styles(isDarkMode).modalButton}
                  >
                    <Text style={styles(isDarkMode).modalButtonText}>❌ {t("Cancel")}</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => {
                      handleSaveProfile();
                      setProfileModalVisible(false);
                    }}
                    style={styles(isDarkMode).modalButton}
                  >
                    <Text style={styles(isDarkMode).modalButtonText}>✅ {t("Save")}</Text>
                  </TouchableOpacity>
                </View>
              </View>
            </TouchableWithoutFeedback>
          </View>
        </TouchableWithoutFeedback>
      </Modal>

      {/* ===== Da Vinci 3-Day Challenge celebration modal ===== */}
      <Modal
        visible={!!challengeModal}
        transparent
        animationType="fade"
        onRequestClose={() => setChallengeModal(null)}
      >
        <View
          style={{
            flex: 1,
            backgroundColor: "rgba(0,0,0,0.55)",
            justifyContent: "center",
            alignItems: "center",
            padding: 24,
          }}
        >
          <View
            style={{
              width: "100%",
              maxWidth: 420,
              borderRadius: 18,
              padding: 26,
              backgroundColor: isDarkMode ? "#1e293b" : "#ffffff",
              borderWidth: 1,
              borderColor: isDarkMode ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.06)",
              shadowColor: "#000",
              shadowOpacity: 0.25,
              shadowRadius: 18,
              shadowOffset: { width: 0, height: 8 },
              alignItems: "center",
            }}
          >
            <Text
              style={{
                fontSize: 40,
                marginBottom: 10,
              }}
            >
              {challengeModal?.allDone ? "🎉" : "✅"}
            </Text>
            <Text
              style={{
                fontSize: 20,
                fontWeight: "700",
                textAlign: "center",
                marginBottom: 10,
                color: isDarkMode ? "#f1f5f9" : "#111827",
              }}
            >
              {challengeModal?.allDone
                ? t("You finished the Challenge!")
                : `${t("Challenge")} ${challengeModal?.day} ${t("complete!")}`}
            </Text>
            {!challengeModal?.allDone && challengeState?.current != null && (
              <Text
                style={{
                  fontSize: 13,
                  fontWeight: "600",
                  textAlign: "center",
                  marginBottom: 8,
                  color: isDarkMode ? "#818cf8" : "#4f46e5",
                }}
              >
                {`${t("Day")} ${challengeState.current.day} ${t("of")} ${challengeState?.days?.length || 3} · ${challengeState.current.percent}%`}
              </Text>
            )}
            <Text
              style={{
                fontSize: 15,
                lineHeight: 22,
                textAlign: "center",
                marginBottom: 22,
                color: isDarkMode ? "#94a3b8" : "#5f6b7a",
              }}
            >
              {challengeModal?.allDone
                ? t(
                    "Enter the name to print on your certificate, then we'll email it to you."
                  )
                : `${t("Great work — ready for Challenge")} ${
                    challengeModal?.nextDay ?? (challengeModal?.day ?? 0) + 1
                  }?`}
            </Text>

            {challengeModal?.allDone ? (
              certSubmit.status === "sent" ? (
                <>
                  <Text
                    style={{
                      color: isDarkMode ? "#34d399" : "#059669",
                      fontSize: 14,
                      fontWeight: "600",
                      textAlign: "center",
                      marginBottom: 14,
                    }}
                  >
                    {`✓ ${certSubmit.message}`}
                  </Text>
                  <TouchableOpacity
                    onPress={() => setChallengeModal(null)}
                    style={{
                      width: "100%",
                      paddingVertical: 13,
                      borderRadius: 12,
                      alignItems: "center",
                      backgroundColor: isDarkMode ? "#818cf8" : "#4f46e5",
                    }}
                  >
                    <Text style={{ color: "#ffffff", fontSize: 16, fontWeight: "700" }}>
                      {t("Done")}
                    </Text>
                  </TouchableOpacity>
                </>
              ) : (
                <>
                  <TextInput
                    value={certName}
                    onChangeText={setCertName}
                    placeholder={t("Your full name")}
                    placeholderTextColor={isDarkMode ? "#64748b" : "#9ca3af"}
                    editable={certSubmit.status !== "sending"}
                    autoCapitalize="words"
                    onSubmitEditing={submitChallengeCertificate}
                    style={{
                      width: "100%",
                      borderWidth: 1,
                      borderColor: isDarkMode ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.15)",
                      borderRadius: 12,
                      paddingVertical: 12,
                      paddingHorizontal: 14,
                      fontSize: 16,
                      color: isDarkMode ? "#f1f5f9" : "#111827",
                      backgroundColor: isDarkMode ? "rgba(255,255,255,0.04)" : "#f8fafc",
                      marginBottom: 12,
                      textAlign: "center",
                    }}
                  />
                  {certSubmit.status === "error" ? (
                    <Text
                      style={{ color: "#ef4444", fontSize: 13, textAlign: "center", marginBottom: 10 }}
                    >
                      {certSubmit.message}
                    </Text>
                  ) : null}
                  <TouchableOpacity
                    onPress={submitChallengeCertificate}
                    disabled={certSubmit.status === "sending" || !certName.trim()}
                    style={{
                      width: "100%",
                      paddingVertical: 13,
                      borderRadius: 12,
                      alignItems: "center",
                      opacity: certSubmit.status === "sending" || !certName.trim() ? 0.6 : 1,
                      backgroundColor: isDarkMode ? "#818cf8" : "#4f46e5",
                    }}
                  >
                    <Text style={{ color: "#ffffff", fontSize: 16, fontWeight: "700" }}>
                      {certSubmit.status === "sending" ? t("Sending…") : t("Email my certificate")}
                    </Text>
                  </TouchableOpacity>
                </>
              )
            ) : (
              <TouchableOpacity
                onPress={() => {
                  const nextId = challengeModal?.nextCollectionId;
                  setChallengeModal(null);
                  if (nextId != null) {
                    handleCollectionClick(nextId);
                  }
                }}
                style={{
                  width: "100%",
                  paddingVertical: 13,
                  borderRadius: 12,
                  alignItems: "center",
                  backgroundColor: isDarkMode ? "#818cf8" : "#4f46e5",
                }}
              >
                <Text
                  style={{ color: "#ffffff", fontSize: 16, fontWeight: "700" }}
                >
                  {`${t("Start Challenge")} ${
                    challengeModal?.nextDay ?? (challengeModal?.day ?? 0) + 1
                  }`}
                </Text>
              </TouchableOpacity>
            )}
          </View>
        </View>
      </Modal>

      {/* PWO Healthcheck panel + debug build label */}
      <PwoHealthcheckPanel
        isDarkMode={isDarkMode}
        debugBuildLabel={debugBuildLabel}
        user={user}
        isHealthcheckEnabled={isHealthcheckEnabled}
        pwoQaVisible={pwoQaVisible}
        setPwoQaVisible={setPwoQaVisible}
        pwoQaItems={pwoQaItems}
        pwoQaResults={pwoQaResults}
        pwoQaIndex={pwoQaIndex}
        pwoQaRunning={pwoQaRunning}
        pwoQaPaused={pwoQaPaused}
        setPwoQaPaused={setPwoQaPaused}
        pwoQaGradeId={pwoQaGradeId}
        setPwoQaGradeId={setPwoQaGradeId}
        pwoQaGradeOptions={pwoQaGradeOptions}
        pwoQaGradeRunning={pwoQaGradeRunning}
        hasMultipleGradesForQa={hasMultipleGradesForQa}
        pwoQaSubjectId={pwoQaSubjectId}
        setPwoQaSubjectId={setPwoQaSubjectId}
        pwoQaSubjectOptions={pwoQaSubjectOptions}
        smokeRunning={smokeRunning}
        smokeStepIndex={smokeStepIndex}
        smokeResults={smokeResults}
        smokeLastError={smokeLastError}
        SMOKE_TEST_PLAN_V1={SMOKE_TEST_PLAN_V1}
        closePwoQaPanel={closePwoQaPanel}
        buildPwoQaListForVisibleTopics={buildPwoQaListForVisibleTopics}
        buildPwoQaListForSelectedSubject={buildPwoQaListForSelectedSubject}
        startPwoQaRun={startPwoQaRun}
        stopPwoQaRun={stopPwoQaRun}
        exportPwoQaJsonl={exportPwoQaJsonl}
        resetPwoQa={resetPwoQa}
        runPwoQaForSelectedGrade={runPwoQaForSelectedGrade}
        startSmokeRun={startSmokeRun}
        stopSmokeRun={stopSmokeRun}
        exportSmokeJsonl={exportSmokeJsonl}
      />

      {/* ===== Lesson in a Box (2026-08-13) ===== */}
      {/* The workspace itself renders inside contentWrapper, below. This pill is
          all that remains on top: it restores the lesson after an asset launch. */}
      {showLessonPlan &&
        lessonPlanRuntime &&
        activeModule !== "lessonPlans" &&
        !lessonAssetCompanionVisible && (
        <TouchableOpacity
          onPress={async () => {
            // handleCloseModule tears the asset down and, because the lesson
            // owns it, routes back to the lessonPlans module itself.
            const canClose = await handleCloseModule(false);
            if (canClose === false) return;
            lessonPlanAssetLaunchRef.current = false;
            lessonPlanLastModuleRef.current = "lessonPlans";
            setActiveModule("lessonPlans");
          }}
          accessibilityRole="button"
          accessibilityLabel={t("Back to lesson")}
          style={{
            position: "absolute",
            right: 20,
            bottom: 24,
            zIndex: 900,
            flexDirection: "row",
            alignItems: "center",
            gap: 8,
            paddingHorizontal: 16,
            paddingVertical: 12,
            borderRadius: 999,
            borderWidth: 1,
            borderColor: isDarkMode ? "rgba(129,140,248,0.5)" : "#c7d2fe",
            backgroundColor: isDarkMode ? "#1e293b" : "#ffffff",
            shadowColor: "#000",
            shadowOpacity: 0.18,
            shadowRadius: 12,
            shadowOffset: { width: 0, height: 4 },
            elevation: 6,
          }}
        >
          <MaterialCommunityIcons
            name="clipboard-text-outline"
            size={18}
            color={isDarkMode ? "#818cf8" : "#6366f1"}
          />
          <Text
            style={{
              marginLeft: 8,
              fontSize: 13,
              fontWeight: "700",
              color: isDarkMode ? "#f1f5f9" : "#0f172a",
            }}
          >
            {t("Back to lesson")}
          </Text>
        </TouchableOpacity>
        )}

      {/* Top level, deliberately. This modal used to live inside the
          `activeModule` fall-through arm, which is not rendered while a
          lesson plan is open — so opening a topic quiz from inside a lesson
          set visible:true and painted nothing at all. A modal has no reason
          to be scoped to one module. */}
      {quizInfoModal.visible && (
        <View style={sheet.overlay} pointerEvents="box-none">
          <TouchableOpacity
            style={sheet.backdrop}
            activeOpacity={1}
            onPress={() => setQuizInfoModal((p) => ({ ...p, visible: false }))}
          />
          <View style={sheet.modalContainer}>
            <View
              style={[
                sheet.modal,
                isDarkMode && sheet.modalDark,
                { maxHeight: height * 0.7 },
              ]}
            >
              {/* Close button */}
              <TouchableOpacity
                style={[sheet.closeBtn, isDarkMode && sheet.closeBtnDark]}
                onPress={() => setQuizInfoModal((p) => ({ ...p, visible: false }))}
                activeOpacity={0.7}
              >
                <MaterialCommunityIcons
                  name="close"
                  size={20}
                  color={isDarkMode ? "#94a3b8" : "#64748b"}
                />
              </TouchableOpacity>

              {/* Header */}
              <View style={sheet.header}>
                <View style={[sheet.headerIcon, isDarkMode && sheet.headerIconDark, { backgroundColor: isDarkMode ? "rgba(139, 92, 246, 0.15)" : "rgba(139, 92, 246, 0.1)" }]}>
                  <MaterialCommunityIcons
                    name="help-circle-outline"
                    size={24}
                    color={isDarkMode ? "#a78bfa" : "#8b5cf6"}
                  />
                </View>
                <Text style={[sheet.title, isDarkMode && sheet.titleDark]} numberOfLines={2}>
                  {quizInfoModal.topicLabel}
                </Text>
              </View>

              {/* Stats & Attempt History */}
              <View style={{ paddingHorizontal: 20, paddingBottom: 16 }}>
                {quizInfoModal.loading ? (
                  <Text style={{ color: isDarkMode ? "#64748b" : "#94a3b8", textAlign: "center", fontSize: 14 }}>
                    ...
                  </Text>
                ) : quizInfoModal.count > 0 ? (
                  <View style={{ gap: 10 }}>
                    {/* Best score banner */}
                    {quizInfoModal.bestCorrect != null && quizInfoModal.bestTotal != null && (
                      <View style={{
                        flexDirection: "row",
                        alignItems: "center",
                        padding: 12,
                        borderRadius: 12,
                        backgroundColor: isDarkMode ? "rgba(52, 211, 153, 0.08)" : "rgba(16, 185, 129, 0.05)",
                        borderWidth: 1,
                        borderColor: isDarkMode ? "rgba(52, 211, 153, 0.2)" : "rgba(16, 185, 129, 0.12)",
                      }}>
                        <MaterialCommunityIcons
                          name="trophy-outline"
                          size={18}
                          color={isDarkMode ? "#34d399" : "#10B981"}
                          style={{ marginRight: 10 }}
                        />
                        <Text style={{ color: isDarkMode ? "#f1f5f9" : "#1e293b", fontSize: 14, fontWeight: "600" }}>
                          {t("Best")}: {quizInfoModal.bestCorrect}/{quizInfoModal.bestTotal}
                          {quizInfoModal.bestTotal > 0 && (
                            <Text style={{ color: isDarkMode ? "#94a3b8" : "#64748b", fontWeight: "400" }}>
                              {" "}({Math.round((quizInfoModal.bestCorrect / quizInfoModal.bestTotal) * 100)}%)
                            </Text>
                          )}
                        </Text>
                      </View>
                    )}

                    {/* Attempt history header */}
                    <Text style={{ color: isDarkMode ? "#94a3b8" : "#64748b", fontSize: 12, fontWeight: "600", textTransform: "uppercase", letterSpacing: 0.5, marginTop: 4 }}>
                      {quizInfoModal.count} {quizInfoModal.count === 1 ? t("attempt") : t("attempts")}
                    </Text>

                    {/* Attempt list */}
                    <ScrollView style={{ maxHeight: 180 }} showsVerticalScrollIndicator persistentScrollbar>
                      {quizInfoModal.attempts.map((a, i) => {
                        const hasScore = a.correct_answers != null && a.total_questions != null && a.total_questions > 0;
                        const pct = hasScore ? Math.round((a.correct_answers / a.total_questions) * 100) : null;
                        const date = a.created_at ? new Date(a.created_at) : null;
                        const isBest = hasScore && quizInfoModal.bestCorrect != null &&
                          a.correct_answers === quizInfoModal.bestCorrect && a.total_questions === quizInfoModal.bestTotal;
                        return (
                          <View
                            key={a.id}
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              padding: 10,
                              marginBottom: 6,
                              borderRadius: 10,
                              backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc",
                              borderWidth: 1,
                              borderColor: isBest
                                ? (isDarkMode ? "rgba(52, 211, 153, 0.3)" : "rgba(16, 185, 129, 0.2)")
                                : (isDarkMode ? "#334155" : "#e2e8f0"),
                            }}
                          >
                            {/* Attempt number */}
                            <View style={{
                              width: 28, height: 28, borderRadius: 14,
                              backgroundColor: isDarkMode ? "#334155" : "#e2e8f0",
                              alignItems: "center", justifyContent: "center", marginRight: 10,
                            }}>
                              <Text style={{ color: isDarkMode ? "#94a3b8" : "#64748b", fontSize: 12, fontWeight: "700" }}>
                                {quizInfoModal.attempts.length - i}
                              </Text>
                            </View>

                            {/* Date + score */}
                            <View style={{ flex: 1 }}>
                              {date && (
                                <Text style={{ color: isDarkMode ? "#64748b" : "#94a3b8", fontSize: 11 }}>
                                  {date.toLocaleDateString(undefined, { month: "short", day: "numeric" })}
                                  {" "}
                                  {date.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })}
                                </Text>
                              )}
                              {hasScore ? (
                                <Text style={{ color: isDarkMode ? "#f1f5f9" : "#1e293b", fontSize: 13, fontWeight: "600", marginTop: 1 }}>
                                  {a.correct_answers}/{a.total_questions} ({pct}%)
                                </Text>
                              ) : (
                                <Text style={{ color: isDarkMode ? "#64748b" : "#94a3b8", fontSize: 13, fontStyle: "italic", marginTop: 1 }}>
                                  {a.completed_at ? t("No score") : t("Not submitted")}
                                </Text>
                              )}
                            </View>

                            {/* Best badge */}
                            {isBest && (
                              <View style={{
                                paddingHorizontal: 8, paddingVertical: 3, borderRadius: 8,
                                backgroundColor: isDarkMode ? "rgba(52, 211, 153, 0.12)" : "rgba(16, 185, 129, 0.08)",
                              }}>
                                <Text style={{ color: isDarkMode ? "#34d399" : "#10B981", fontSize: 10, fontWeight: "700" }}>
                                  {t("BEST")}
                                </Text>
                              </View>
                            )}
                          </View>
                        );
                      })}
                    </ScrollView>
                  </View>
                ) : (
                  <View style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 12,
                    borderRadius: 12,
                    backgroundColor: isDarkMode ? "rgba(100, 116, 139, 0.1)" : "rgba(148, 163, 184, 0.1)",
                  }}>
                    <MaterialCommunityIcons
                      name="information-outline"
                      size={16}
                      color={isDarkMode ? "#64748b" : "#94a3b8"}
                      style={{ marginRight: 8 }}
                    />
                    <Text style={{ color: isDarkMode ? "#64748b" : "#94a3b8", fontSize: 13 }}>
                      {t("No previous attempts")}
                    </Text>
                  </View>
                )}
              </View>

              {/* Start Quiz button */}
              <View style={{ paddingHorizontal: 20, paddingBottom: 4 }}>
                <TouchableOpacity
                  onPress={() => launchQuiz(quizInfoModal.item)}
                  activeOpacity={0.8}
                  style={{
                    paddingVertical: 14,
                    borderRadius: 12,
                    backgroundColor: isDarkMode ? "#8b5cf6" : "#7c3aed",
                    alignItems: "center",
                  }}
                >
                  <Text style={{ color: "#fff", fontSize: 15, fontWeight: "700" }}>
                    {quizInfoModal.count > 0 ? t("Try Again") : t("Start Quiz")}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      )}

      {/* ===== Knowledge Tracing Popup ===== */}
      <KtPopup
        question={ktPopupQuestion}
        visible={ktPopupVisible}
        isDarkMode={isDarkMode}
        onAnswer={handleKtAnswer}
        onSkip={handleKtSkip}
        onDismiss={handleKtDismiss}
        onDisablePopups={() => handleKtPopupToggle(true)}
      />

    </View >
  )
};

// BDD 10/5/2025
const h = {
  header: {
    minHeight: HEADER.barHeight,  // Header redesign 2026-09-15: 60 -> 52
    width: "100%",
    backgroundColor: "#0077b6",
    position: "relative",
    overflow: "visible",            // ✅ BDD 10/15/2025 allow the dropdown to extend below the header
    zIndex: 2147483000,             // ✅ BDD 10/15/2025 keep header above shelves/scrims/confetti
  },
  leftRow: {
    position: "absolute", left: 10, top: 0, bottom: 0,
    flexDirection: "row", alignItems: "center", gap: 4,
  },
  classBadge: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 999,
    backgroundColor: "rgba(15,23,42,0.7)", // slate-900-ish
  },
  classBadgeText: {
    color: "#bfdbfe", // light blue
    fontSize: rem(12) + 'rem',
  },

  rightRow: {
    position: "absolute", right: 10, top: 0, bottom: 0,
    flexDirection: "row", alignItems: "center", gap: 6,
    zIndex: 2147483600,             // BDD 10/15/2025 ✅ ensure right controls sit atop everything else in the bar
    pointerEvents: "auto",
  },
  // Brand — logo + wordmark, moved to the far left of leftRow (header
  // redesign 2026-09-15; see the decision log for why).
  brand: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginRight: 10,
  },
  logo: { width: 34, height: 26 },
  title: { color: "#fff", fontSize: rem(18) + 'rem', fontWeight: "700" },
  iconBtn: { padding: 8 },
  // Teacher tool button with label
  iconBtnLabeled: {
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 8,
    minWidth: 60,
  },
  iconBtnLabel: {
    color: "#fff",
    fontSize: rem(10) + 'rem',
    marginTop: 2,
    fontWeight: "500",
  },
  // Nav pills (StudentNavButtons / TeacherNavButtons) — header redesign 2026-09-15
  navTab: {
    flexDirection: "row",
    alignItems: "center",
    gap: 7,
    height: HEADER.tabHeight,
    paddingHorizontal: 12,
    borderRadius: 8,
  },
  navTabCompact: {
    paddingHorizontal: 8,
  },
  navTabActive: {
    backgroundColor: HEADER.onBrand,
  },
  navTabLabel: {
    color: HEADER.onBrandInactive,
    fontSize: rem(14) + 'rem',
    fontWeight: "500",
  },
  navTabLabelActive: {
    color: HEADER.brandDeep,
    fontWeight: "600",
  },
  // Right-cluster curriculum chip / upgrade pill — header redesign 2026-09-15
  currChip: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    height: 32,
    paddingLeft: 9,
    paddingRight: 10,
    borderRadius: 999,
    borderWidth: 1,
    borderColor: HEADER.brandLine,
  },
  currChipText: {
    color: HEADER.onBrand,
    fontSize: rem(13) + 'rem',
    fontWeight: "600",
  },
  upgradePill: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    height: 32,
    paddingHorizontal: 12,
    borderRadius: 999,
    backgroundColor: HEADER.amber,
  },
  upgradePillText: {
    color: HEADER.amberInk,
    fontSize: rem(13) + 'rem',
    fontWeight: "700",
  },
  clusterGap: {
    width: 1,
    height: 22,
    backgroundColor: HEADER.brandLine,
    marginHorizontal: 6,
  },
  // BDD 01/23/2026 - Hamburger menu styles for responsive header
  hamburgerBtn: {
    padding: 8,
    borderRadius: 6,
    backgroundColor: "rgba(255,255,255,0.15)",
  },
  hamburgerDropdown: {
    position: "absolute",
    top: 48,
    left: 0,
    backgroundColor: "#0077b6",
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 4,
    minWidth: 160,
    shadowColor: "#000",
    shadowOpacity: 0.3,
    shadowOffset: { width: 0, height: 4 },
    shadowRadius: 8,
    elevation: 10,
    zIndex: 2147483647,
  },
  hamburgerMenuItem: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRadius: 6,
    gap: 10,
  },
  hamburgerMenuItemActive: {
    backgroundColor: "rgba(255,255,255,0.25)",
  },
  hamburgerMenuText: {
    color: "#fff",
    fontSize: rem(14) + 'rem',
    fontWeight: "500",
  },
};

// BDD 10/5/2025 - try2 - Redesigned 12/30/2025 - Centered Modal
const sheet = StyleSheet.create({
  // Export row styles
  exportRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginBottom: 8,
  },
  exportButton: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 12,
    backgroundColor: "#2563eb",
  },
  exportButtonText: {
    color: "#ffffff",
    fontWeight: "600",
  },

  // Overlay
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2147483600,
    elevation: 10000,
  },
  backdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(15, 23, 42, 0.65)",
  },

  // Centered modal container
  modalContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
  },

  // Main modal
  modal: {
    backgroundColor: "#ffffff",
    borderRadius: 20,
    paddingTop: 24,
    paddingBottom: 20,
    paddingHorizontal: 20,
    shadowColor: "#0f172a",
    shadowOpacity: 0.3,
    shadowRadius: 30,
    shadowOffset: { width: 0, height: 12 },
    elevation: 24,
  },
  modalDark: {
    backgroundColor: "#1e293b",
    shadowColor: "#000",
  },

  // Close button (top right X)
  closeBtn: {
    position: "absolute",
    top: 12,
    right: 12,
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: "#f1f5f9",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
  },
  closeBtnDark: {
    backgroundColor: "#334155",
  },

  // Header section
  header: {
    alignItems: "center",
    paddingBottom: 16,
    paddingHorizontal: 24,
  },
  headerIcon: {
    width: 56,
    height: 56,
    borderRadius: 16,
    backgroundColor: "rgba(0, 119, 182, 0.1)",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 14,
  },
  headerIconDark: {
    backgroundColor: "rgba(96, 165, 250, 0.15)",
  },
  title: {
    fontSize: rem(18) + 'rem',
    fontWeight: "700",
    color: "#0f172a",
    textAlign: "center",
    letterSpacing: -0.3,
    marginBottom: 8,
  },
  titleDark: {
    color: "#f1f5f9",
  },
  badge: {
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 12,
    backgroundColor: "#f1f5f9",
  },
  badgeDark: {
    backgroundColor: "#334155",
  },
  badgeText: {
    fontSize: rem(12) + 'rem',
    color: "#64748b",
    fontWeight: "600",
  },
  badgeTextDark: {
    color: "#94a3b8",
  },

  // List container
  listContainer: {
    maxHeight: 280,
  },
  listContent: {
    paddingVertical: 4,
  },

  // Item card
  item: {
    flexDirection: "row",
    alignItems: "center",
    padding: 12,
    marginVertical: 4,
    backgroundColor: "#f8fafc",
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "#e2e8f0",
  },
  itemDark: {
    backgroundColor: "#0f172a",
    borderColor: "#334155",
  },
  itemWatched: {
    backgroundColor: "rgba(16, 185, 129, 0.06)",
    borderColor: "#10B981",
  },
  itemWatchedDark: {
    backgroundColor: "rgba(52, 211, 153, 0.08)",
    borderColor: "#34d399",
  },

  // Item icon
  itemIconContainer: {
    width: 36,
    height: 36,
    borderRadius: 10,
    backgroundColor: "rgba(0, 119, 182, 0.08)",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
  },
  itemIconContainerDark: {
    backgroundColor: "rgba(96, 165, 250, 0.15)",
  },
  itemIconContainerWatched: {
    backgroundColor: "rgba(16, 185, 129, 0.12)",
  },
  itemIconContainerWatchedDark: {
    backgroundColor: "rgba(52, 211, 153, 0.18)",
  },

  // Item text
  itemTextWrap: {
    flex: 1,
    paddingRight: 8,
  },
  itemLabel: {
    fontSize: rem(14) + 'rem',
    fontWeight: "600",
    color: "#1e293b",
    lineHeight: 18,
  },
  itemLabelDark: {
    color: "#f1f5f9",
  },
  itemSub: {
    fontSize: rem(12) + 'rem',
    color: "#64748b",
    marginTop: 2,
    fontWeight: "400",
  },
  itemSubDark: {
    color: "#94a3b8",
  },
  itemSubWatched: {
    fontSize: rem(12) + 'rem',
    color: "#94a3b8",
    fontWeight: "400",
  },
  itemSubWatchedDark: {
    color: "#64748b",
  },

  // Item chevron
  itemChevron: {
    width: 26,
    height: 26,
    borderRadius: 8,
    backgroundColor: "#f1f5f9",
    alignItems: "center",
    justifyContent: "center",
  },
  itemChevronDark: {
    backgroundColor: "#334155",
  },

  // Footer
  footerContainer: {
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: "#e2e8f0",
    marginTop: 8,
  },
  footerContainerDark: {
    borderTopColor: "#334155",
  },
  cancelBtn: {
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 12,
    backgroundColor: "#f1f5f9",
    alignItems: "center",
  },
  cancelBtnDark: {
    backgroundColor: "#0f172a",
  },
  cancelText: {
    color: "#64748b",
    fontSize: rem(15) + 'rem',
    fontWeight: "600",
  },
  cancelTextDark: {
    color: "#94a3b8",
  },
});

// Add banner styles
// BDD the following should be kept in alphabetical order for ease of maintainance
// const styles = (isDarkMode) => StyleSheet.create({
// 1) Rename your existing function to a "raw" builder (paste your WHOLE object unchanged)
const _stylesRaw = (isDarkMode) => StyleSheet.create({


  // ✅ Add these two small entries so we can remove inline objects in BottomBar
  micContainer: { alignItems: "center", marginHorizontal: 8 },
  micError: { color: "red", fontSize: rem(10) + 'rem', marginTop: 4, maxWidth: 100, textAlign: "center" },

  activeItem: {
    color: "#AB274F",  // Amaranth Purple
    // fontWeight: "bold",
    // textDecorationLine: "underline"
  },
  // answerText: {
  //     color: isDarkMode ? "#dddddd" : "#333",
  //     paddingTop: 4
  // },
  // activeItem: {
  //     color: "#AB274F",  // Amaranth Purple
  //     // fontWeight: "bold",
  //     // textDecorationLine: "underline"
  // },

  // BDD 11/21/2025 – AI history card styles (modernized to match SuggestionRail)
  answerContainer: {
    marginTop: 4,
    paddingLeft: 8,
  },
  answerText: {
    color: isDarkMode ? "#e2e8f0" : "#374151",
    paddingTop: 4,
    fontSize: rem(13) + 'rem',
    lineHeight: 18,
  },
  chatCard: {
    marginTop: 8,
    marginBottom: 8,
    padding: 10,
    borderRadius: 10,
    backgroundColor: isDarkMode ? "#020617" : "#f9fafb",
    borderWidth: 1,
    borderColor: isDarkMode ? "#1e293b" : "#e5e7eb",
  },
  questionLabelRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 6,
  },
  questionLabel: {
    fontSize: rem(11) + 'rem',
    fontWeight: "600",
    letterSpacing: 0.5,
    textTransform: "uppercase",
    color: isDarkMode ? "#818cf8" : "#6366f1",
    backgroundColor: isDarkMode ? "rgba(99, 102, 241, 0.15)" : "rgba(99, 102, 241, 0.1)",
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 4,
  },
  questionText: {
    fontSize: rem(14) + 'rem',
    lineHeight: 20,
    fontWeight: "500",
    marginBottom: 10,
    paddingLeft: 0,
    color: isDarkMode ? "#f1f5f9" : "#0f172a",
  },
  answerDivider: {
    height: 1,
    backgroundColor: isDarkMode ? "rgba(148, 163, 184, 0.15)" : "rgba(148, 163, 184, 0.2)",
    marginBottom: 10,
  },
  historyHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: isDarkMode ? "rgba(148, 163, 184, 0.1)" : "rgba(148, 163, 184, 0.15)",
  },
  historyHeaderText: {
    fontSize: rem(13) + 'rem',
    fontWeight: "600",
    letterSpacing: 0.5,
    textTransform: "uppercase",
    color: isDarkMode ? "#94a3b8" : "#64748b",
  },

  assessmentCard: {
    marginBottom: 10,
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderRadius: 12,
    backgroundColor: isDarkMode ? "#0f172a" : "#ffffff",
    borderWidth: 1,
    borderColor: isDarkMode ? "rgba(148, 163, 184, 0.1)" : "rgba(148, 163, 184, 0.2)",
    shadowColor: isDarkMode ? "#000" : "#64748b",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: isDarkMode ? 0.3 : 0.08,
    shadowRadius: 8,
    elevation: 2,
    borderLeftWidth: 3,
    borderLeftColor: isDarkMode ? "#6366f1" : "#818cf8",
  },
  assessmentTitle: {
    fontSize: rem(13) + 'rem',
    fontWeight: "500",
    color: isDarkMode ? "#f1f5f9" : "#0f172a",
    marginBottom: 2
  },
  assessmentScore: {
    fontSize: rem(13) + 'rem',
    fontWeight: "600",
    color: isDarkMode ? "#818cf8" : "#6366f1",
    marginBottom: 4,
    marginTop: 8,
  },
  assessmentMeta: {
    fontSize: rem(11) + 'rem',
    color: isDarkMode ? "#64748b" : "#94a3b8",
    marginTop: 6
  },
  adaptiveLearningText: {
    marginTop: 16,
    padding: 14,
    fontSize: rem(13) + 'rem',
    lineHeight: 19,
    fontWeight: "400",
    color: isDarkMode ? "#e2e8f0" : "#1e293b",
    backgroundColor: isDarkMode ? "rgba(251, 191, 36, 0.1)" : "rgba(251, 191, 36, 0.08)",
    borderRadius: 12,
    borderLeftWidth: 3,
    borderLeftColor: isDarkMode ? "#f59e0b" : "#d97706",
  },
  badgeItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 8,
    marginRight: 8,
    marginBottom: 8,
    backgroundColor: isDarkMode ? "rgba(251, 191, 36, 0.15)" : "rgba(251, 191, 36, 0.1)",
    borderRadius: 20,
    borderWidth: 1,
    borderColor: isDarkMode ? "rgba(251, 191, 36, 0.3)" : "rgba(251, 191, 36, 0.4)",
  },
  badgeText: {
    fontSize: rem(12) + 'rem',
    fontWeight: '500',
    color: isDarkMode ? "#fbbf24" : "#d97706",
  },
  banner: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    // backgroundColor: '#f8d7da',
    // color: '#721c24',
    backgroundColor: '#f0f2f5',
    color: '#121212',
    padding: '10px',
    textAlign: 'center',
    fontSize: '16px',
    zIndex: 9999,
    pointerEvents: 'none',   // BDD 10/15/2025 ✅ never intercept clicks (header is below)
    borderWidth: 1, borderColor: "magenta" // BDD 10/15/2025
  },
  bannerText: {
    // color: '#721c24',
    color: '#000',
    fontSize: rem(16) + 'rem',
  },
  bottomBar: {
    flexDirection: "row",
    alignItems: "center",
    padding: 10,
    backgroundColor: isDarkMode ? "#1e1e1e" : "#fff",
    width: "100%",
    minHeight: 60,  // Responsive: was fixed height, now allows growth at high zoom
    gap: 8,  // Add spacing between controls
  },
  button: {
    padding: 10,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 10,  // Space before the mic button
  },
  chatCard: {
    backgroundColor: isDarkMode ? "#0f172a" : "#ffffff",
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderRadius: 12,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: isDarkMode ? "rgba(148, 163, 184, 0.1)" : "rgba(148, 163, 184, 0.2)",
    shadowColor: isDarkMode ? "#000" : "#64748b",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: isDarkMode ? 0.3 : 0.08,
    shadowRadius: 8,
    elevation: 2,
    position: "relative",
    overflow: "hidden",
  },
  chatCardAccentBar: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: 3,
    backgroundColor: isDarkMode ? "#6366f1" : "#818cf8",
    opacity: 0.6,
  },
  chapterContainer: {
    marginLeft: 8,
    marginVertical: 2,
  },
  chapterItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 7,
    paddingHorizontal: 12,
    paddingLeft: 16,
    borderRadius: 6,
    marginVertical: 1,
    position: "relative",
    ...(Platform.OS === "web" ? { transition: "background 0.12s, color 0.12s" } : {}),
  },
  chapterItemActive: {
    backgroundColor: isDarkMode ? 'rgba(37, 99, 235, 0.15)' : '#eff6ff',
    borderLeftWidth: 3,
    borderLeftColor: isDarkMode ? '#60a5fa' : '#2563eb',
  },
  chapterDot: {
    width: 5,
    height: 5,
    borderRadius: 2.5,
    backgroundColor: isDarkMode ? '#64748b' : '#94a3b8',
    marginRight: 8,
  },
  chapterDotActive: {
    backgroundColor: isDarkMode ? '#60a5fa' : '#2563eb',
    width: 6,
    height: 6,
    borderRadius: 3,
  },
  chapterTitle: {
    fontSize: rem(12.5) + 'rem',
    fontWeight: '500',
    lineHeight: 17,
    color: isDarkMode ? '#94a3b8' : '#64748b',
    flex: 1,
  },
  chapterTitleActive: {
    color: isDarkMode ? '#60a5fa' : '#2563eb',
    fontWeight: '600',
  },
  topicContainer: {
    marginLeft: 12,        // Reduced from 18
    marginVertical: 2,     // Reduced from 4
  },
  topicTitleItem: {
    fontSize: rem(10) + 'rem',  // Reduced from 12
    paddingVertical: 2,    // Reduced from 3
    paddingLeft: 10,       // Reduced from 15
    color: isDarkMode ? '#8cc' : '#16a',
  },
  topicTitle: {
    fontSize: rem(11) + 'rem',  // Reduced from 13
    fontWeight: '500',
    paddingVertical: 1,    // Reduced from 2
    color: isDarkMode ? '#ccc' : '#444',
  },
  container: {
    flex: 1,
    backgroundColor: isDarkMode ? "#121212" : "#f0f2f5",
    overflow: 'hidden',
  },
  contentItem: {
    fontSize: rem(12) + 'rem',
    paddingVertical: 3,
    paddingLeft: 15,
    color: isDarkMode ? '#8cc' : '#16a',
    textDecorationLine: 'underline',
  },
  contentSection: {
    marginLeft: 8,
    marginTop: 4,
    marginBottom: 8,
  },
  contentWrapper: {
    flex: 1,
    flexDirection: "row",
    width: "100%"
  },
  correctAnswer: {
    backgroundColor: "#D4EDDA",  // Γ£à Light green for correct
    borderColor: "#28A745",
  },

  header: {
    minHeight: 56,  // Responsive: was fixed height: 60, now allows growth at high zoom
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12, // Will be overridden inline with responsive value
    paddingVertical: 8,  // Add vertical padding for better spacing
    backgroundColor: isDarkMode ? "#1e1e1e" : "#0077b6",
  },
  expiryBanner: {
    width: "100%",
    backgroundColor: isDarkMode ? "rgba(245, 158, 11, 0.15)" : "#fff7ed",
    borderBottomWidth: 1,
    borderBottomColor: isDarkMode ? "rgba(245, 158, 11, 0.35)" : "#fed7aa",
    paddingHorizontal: 16,
    paddingVertical: 10,
  },
  expiryBannerText: {
    fontSize: 13,
    color: isDarkMode ? "#fde68a" : "#7c2d12",
    fontWeight: "600",
  },
  expiryBannerActions: {
    marginTop: 8,
    flexDirection: "row",
    gap: 10,
    alignItems: "center",
    flexWrap: "wrap",
  },
  expiryBannerBtn: {
    backgroundColor: isDarkMode ? "#f59e0b" : "#ea580c",
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 6,
  },
  expiryBannerBtnText: {
    color: "#fff",
    fontWeight: "700",
    fontSize: 12,
  },
  expiryBannerDismiss: {
    paddingHorizontal: 8,
    paddingVertical: 6,
  },
  expiryBannerDismissText: {
    color: isDarkMode ? "#fcd34d" : "#9a3412",
    fontWeight: "600",
    fontSize: 12,
  },

  // left / center / right columns
  headerLeft: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    gap: 12, // RN Web supports gap; RN mobile ignores safely
  },
  headerCenter: {
    flex: 2,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  },
  headerRight: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 12,
  },
  headerSide: {
    flex: 1  // Takes up space on the left to push the center content
  },
  languageButton: {
    paddingHorizontal: 10,
    paddingVertical: 6,
    backgroundColor: "rgba(255,255,255,0.18)",
    borderRadius: 6,
  },
  languageText: {
    color: "#fff",
    fontSize: rem(13) + 'rem',
    fontWeight: "600",
  },
  username: {
    color: "#fff",
    fontSize: rem(14) + 'rem',
    fontWeight: "700",
  },
  logoutButton: {
    padding: 6,
    marginLeft: 6,
  },

  inputBox: {
    flex: 1,
    padding: 8,
    backgroundColor: "#fff",
    borderRadius: 5
  },
  leaderboardCard: {
    marginBottom: 8,
    paddingVertical: 10,
    paddingHorizontal: 14,
    borderRadius: 12,
    backgroundColor: isDarkMode ? "#0f172a" : "#ffffff",
    borderWidth: 1,
    borderColor: isDarkMode ? "rgba(148, 163, 184, 0.1)" : "rgba(148, 163, 184, 0.2)",
    shadowColor: isDarkMode ? "#000" : "#64748b",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: isDarkMode ? 0.3 : 0.08,
    shadowRadius: 8,
    elevation: 2,
    borderLeftWidth: 3,
    borderLeftColor: isDarkMode ? "#6366f1" : "#818cf8",
  },
  leaderboardItem: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 10,
    paddingHorizontal: 12,
    marginBottom: 6,
    backgroundColor: isDarkMode ? "#0f172a" : "#ffffff",
    borderRadius: 10,
    borderWidth: 1,
    borderColor: isDarkMode ? "rgba(148, 163, 184, 0.08)" : "rgba(148, 163, 184, 0.15)",
  },
  leaderboardName: {
    fontSize: rem(13) + 'rem',
    flex: 1,
    textAlign: 'left',
    marginLeft: 12,
    color: isDarkMode ? "#e2e8f0" : "#1e293b",
  },
  leaderboardRank: {
    fontSize: rem(12) + 'rem',
    fontWeight: '600',
    width: 28,
    height: 28,
    lineHeight: 28,
    textAlign: 'center',
    borderRadius: 14,
    backgroundColor: isDarkMode ? "rgba(148, 163, 184, 0.15)" : "rgba(148, 163, 184, 0.2)",
    color: isDarkMode ? "#94a3b8" : "#64748b",
    overflow: 'hidden',
  },
  leaderboardScore: {
    fontSize: rem(13) + 'rem',
    fontWeight: '600',
    color: isDarkMode ? "#818cf8" : "#6366f1",
  },
  learningPathTitle: {
    fontSize: rem(13) + 'rem',
    fontWeight: "600",
    letterSpacing: 0.5,
    textTransform: "uppercase",
    marginTop: 16,
    marginBottom: 12,
    paddingHorizontal: 8,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: isDarkMode ? "rgba(148, 163, 184, 0.1)" : "rgba(148, 163, 184, 0.15)",
    color: isDarkMode ? "#94a3b8" : "#64748b",
  },
  levelContainer: {
    marginBottom: 8,
    paddingHorizontal: 8,
  },
  levelTitle: {
    fontSize: rem(13) + 'rem',
    fontWeight: '700',
    color: isDarkMode ? '#60a5fa' : '#1e40af',
    flex: 1,
  },
  gradeHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 8,
    paddingHorizontal: 12,
    marginBottom: 8,
    backgroundColor: isDarkMode ? 'rgba(37, 99, 235, 0.15)' : '#eff6ff',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: isDarkMode ? 'rgba(37, 99, 235, 0.3)' : '#dbeafe',
  },
  gradeHeaderExpanded: {
    backgroundColor: isDarkMode ? 'rgba(37, 99, 235, 0.2)' : '#eff6ff',
  },
  subjectHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 8,
    paddingHorizontal: 12,
    marginVertical: 2,
    borderRadius: 8,
    ...(Platform.OS === "web" ? { transition: "background 0.12s", cursor: "pointer", userSelect: "none" } : {}),
  },
  subjectHeaderExpanded: {
    backgroundColor: isDarkMode ? 'rgba(99, 102, 241, 0.08)' : 'rgba(226, 232, 240, 0.5)',
  },
  expandIcon: {
    marginRight: 10,
  },
  expandIconRotated: {
    transform: [{ rotate: '90deg' }],
  },
  linkText: {
    color: isDarkMode ? "#818cf8" : "#6366f1",
    marginVertical: 4,
    fontSize: rem(13) + 'rem',
    lineHeight: 18,
    paddingLeft: 8,
  },
  referenceHeader: {
    fontSize: rem(12) + 'rem',
    fontWeight: "500",
    color: isDarkMode ? "#94a3b8" : "#64748b",
    marginTop: 10,
    marginBottom: 4,
    paddingLeft: 8,
  },
  loadingText: {
    fontSize: rem(18) + 'rem',
    fontWeight: "bold",
    color: "#0077b6", // A modern blue color
    textAlign: "center",
    fontFamily: "monospace",
  },
  logo: {
    width: 38,
    height: 28,
    resizeMode: "contain",
    marginRight: 6,
  },

  mainContent: {
    flex: 1,
    padding: 10, // Will be overridden inline with responsive value
    position: "relative", // ✅ Required so "absolute" children like suggestions position correctly
    paddingBottom: 60,    // ✅ Internal padding for content
    minHeight: 0,
    overflow: "visible",     // ✅ Important
    width: "100%",           // ✅ Ensures scroll can happen
    // Updated to match sidebar aesthetic
    backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc",
  },
  optionText: {
    fontSize: rem(16) + 'rem',
    fontWeight: "500",
    color: isDarkMode ? "#FFF" : "#222",
  },

  profileIcon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: "#fff",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 15,
  },
  profileText: {
    fontSize: rem(16) + 'rem',
    fontWeight: "bold",
    color: "#007BFF",
  },
  modalBackground: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay
  },

  modalBox: {
    width: "90%",  // Responsive: was 33%, now 90% for better usability at high zoom
    maxWidth: 600,  // Cap at reasonable size for large screens
    minWidth: 320,  // Ensure usability on small screens
    backgroundColor: "#fff",
    padding: 20,
    borderRadius: 10,
    maxHeight: "90vh",
    overflow: "auto",
    webkitOverflowScrolling: "touch"  // smoother scroll on mobile Safari
  },

  inputContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },

  modalTitle: {
    fontSize: rem(18) + 'rem',
    fontWeight: "bold",
    marginBottom: 10,
  },
  input: {
    width: "60%", // Make input box wider
    borderWidth: 1,
    borderColor: "#ccc",
    padding: 10,
    borderRadius: 5,
  },
  label: {
    width: "40%",  // Ensure labels are aligned properly
    fontSize: rem(16) + 'rem',
    fontWeight: "500",
  },
  modalButtons: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 15,
  },

  modalButton: {
    flex: 1,
    backgroundColor: "#4CAF50",
    padding: 12,
    borderRadius: 5,
    alignItems: "center",
    marginHorizontal: 5, // Ensure equal spacing
  },

  modalButtonText: {
    color: "#fff",
    fontSize: rem(16) + 'rem',
    fontWeight: "bold",
  },
  modalBackgroundSL: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // ✅ Dark transparent background
  },
  modalBoxSL: {
    width: "90%",  // Responsive: was 80%, now 90% for better usability
    maxWidth: 500,  // Cap at reasonable size
    minWidth: 320,  // Ensure usability on small screens
    backgroundColor: "#FFF",
    padding: 20,
    borderRadius: 10,
    alignItems: "center",
  },
  modalTitleSL: {
    fontSize: rem(18) + 'rem',
    fontWeight: "bold",
    marginBottom: 10,
  },
  languageItemSL: {
    fontSize: rem(16) + 'rem',
    padding: 10,
    textAlign: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
  },
  modalCloseSL: {
    marginTop: 20,
    backgroundColor: "#ff4444",
    padding: 10,
    borderRadius: 5,
  },
  languageList: {
    width: "100%",
    maxHeight: 300, // Allows scrolling if too many languages
  },

  listContent: {
    alignItems: "center",
  },

  languageItem: {
    fontSize: rem(16) + 'rem',
    padding: 10,
    textAlign: "center",
    width: "100%",
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
  },

  modalClose: {
    marginTop: 15,
    padding: 10,
    backgroundColor: "#d9534f",
    borderRadius: 5,
  },
  modalSave: {
    backgroundColor: "#4CAF50",
    padding: 10,
    borderRadius: 5,
  },
  closeText: {
    color: "white",
    fontSize: rem(16) + 'rem',
    fontWeight: "bold",
  },
  quizCardContainer: {
    marginVertical: 15, // Add spacing between questions
    padding: 20,
    borderRadius: 12,
    backgroundColor: isDarkMode ? "#252525" : "#FFF",
    shadowColor: "#000",
    shadowOpacity: 0.08,
    shadowRadius: 6,
    elevation: 4,
  },
  quizOption: {
    padding: 12,
    marginVertical: 6,
    borderRadius: 8,
    backgroundColor: isDarkMode ? "#333" : "#F8F9FA",
    borderWidth: 1,
    borderColor: isDarkMode ? "#555" : "#ddd",
  },
  quizQuestion: {
    fontSize: rem(18) + 'rem',
    fontWeight: "bold",
    marginBottom: 10,
    color: isDarkMode ? "#FFF" : "#222",
  },
  sectionTitle: {
    fontSize: rem(15) + 'rem',
    fontWeight: "600",
    color: isDarkMode ? "#fff" : "#333",
    marginBottom: 4,
  },

  sidebar: {
    width: "25%",
    height: "100%",
    backgroundColor: isDarkMode ? "#181818" : "#fff",
    padding: 10
  },

  resizeHandle: {
    position: 'absolute',
    right: 0,
    top: 0,
    width: 10,
    height: '100%',
    backgroundColor: 'transparent',
    cursor: 'ew-resize', // CSS cursor for web
    zIndex: 5,
  },
  solutionButton: {
    marginTop: 10,
    padding: 10,
    borderRadius: 8,
    backgroundColor: "#007BFF",
    alignItems: "center",
  },
  solutionButtonText: {
    color: "white",
    fontWeight: "bold",
    fontSize: rem(16) + 'rem',
  },
  solutionText: {
    marginTop: 10,
    padding: 10,
    borderRadius: 8,
    backgroundColor: "#FFF3CD",
    borderColor: "#FFC107",
    borderWidth: 1,
    fontSize: rem(16) + 'rem',
  },
  statusContainer: {
    height: 40,  // Ensures space for status text at all times
    justifyContent: "center",  // Aligns vertically in the frame
    marginBottom: 10, // Space below the status message
    paddingLeft: 10,  // Γ£à Adds padding for left alignment
    alignItems: "flex-start",  // Γ£à Left-aligns the text
    width: "100%",  // Ensures it spans the entire width
  },
  subjectContainer: {
    marginLeft: 0,
    marginBottom: 4,
    paddingLeft: 0,
  },
  subjectTitle: {
    fontSize: rem(13) + 'rem',
    fontWeight: '600',
    color: isDarkMode ? '#e2e8f0' : '#334155',
    flex: 1,
  },
  tab: {
    flex: 1,
    paddingVertical: 4,    // Reduced from 8
    paddingHorizontal: 1,  // Reduced from 2
    alignItems: 'center',
    borderRadius: 6,       // Reduced from 8
    marginHorizontal: 1,   // Reduced from 2
  },
  activeTab: {
    backgroundColor: isDarkMode ? "rgba(99, 102, 241, 0.15)" : "rgba(99, 102, 241, 0.1)",
  },
  tabContainer: {
    flexDirection: 'row',
    paddingHorizontal: 2,  // Reduced from 4
    paddingVertical: 4,    // Reduced from 8
    borderBottomWidth: 1,
    borderBottomColor: isDarkMode ? "rgba(148, 163, 184, 0.1)" : "rgba(148, 163, 184, 0.15)",
    backgroundColor: isDarkMode ? "#0f172a" : "#ffffff",
  },
  tabText: {
    fontSize: rem(8) + 'rem',  // Reduced from 9
    marginTop: 2,          // Reduced from 4
    color: isDarkMode ? "#94a3b8" : "#64748b",
    fontWeight: '500',
  },
  activeTabText: {
    color: isDarkMode ? "#818cf8" : "#6366f1",
    fontWeight: "600",
  },
  // Test card styles
  testCard: {
    marginBottom: 10,
    borderRadius: 12,
    backgroundColor: isDarkMode ? "#0f172a" : "#ffffff",
    borderWidth: 1,
    borderColor: isDarkMode ? "rgba(148, 163, 184, 0.1)" : "rgba(148, 163, 184, 0.2)",
    shadowColor: isDarkMode ? "#000" : "#64748b",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: isDarkMode ? 0.3 : 0.08,
    shadowRadius: 8,
    elevation: 2,
    position: "relative",
    overflow: "hidden",
    flexDirection: "row",
    alignItems: "stretch",
  },
  testCardAccent: {
    width: 3,
    backgroundColor: isDarkMode ? "#22c55e" : "#16a34a",
  },
  testResultAccent: {
    width: 3,
    backgroundColor: isDarkMode ? "#6366f1" : "#818cf8",
  },
  testCardContent: {
    flex: 1,
    padding: 14,
  },
  testCardTitle: {
    fontSize: rem(14) + 'rem',
    fontWeight: "500",
    color: isDarkMode ? "#f1f5f9" : "#0f172a",
    marginBottom: 4,
  },
  testCardMeta: {
    fontSize: rem(11) + 'rem',
    color: isDarkMode ? "#64748b" : "#94a3b8",
    marginTop: 4,
  },
  testScoreBadge: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: isDarkMode ? "rgba(99, 102, 241, 0.15)" : "rgba(99, 102, 241, 0.1)",
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 6,
    alignSelf: "flex-start",
    marginTop: 8,
    gap: 6,
  },
  testScoreValue: {
    fontSize: rem(14) + 'rem',
    fontWeight: "600",
    color: isDarkMode ? "#818cf8" : "#6366f1",
  },
  testScoreLabel: {
    fontSize: rem(10) + 'rem',
    color: isDarkMode ? "#64748b" : "#94a3b8",
  },
  pdfLinksRow: {
    flexDirection: "row",
    gap: 12,
    marginTop: 10,
  },
  pdfLink: {
    flexDirection: "row",
    alignItems: "center",
  },
  pdfLinkText: {
    fontSize: rem(12) + 'rem',
    color: isDarkMode ? "#818cf8" : "#6366f1",
    fontWeight: "500",
  },
  pdfLinkTextGreen: {
    fontSize: rem(12) + 'rem',
    color: "#22c55e",
    fontWeight: "500",
  },
  emptyStateText: {
    fontSize: rem(13) + 'rem',
    color: isDarkMode ? "#64748b" : "#94a3b8",
    textAlign: "center",
    paddingVertical: 20,
  },
  // Engagement stats styles
  engagementStatsRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 6,
  },
  engagementStatItem: {
    alignItems: "center",
    flex: 1,
  },
  engagementStatValue: {
    fontSize: rem(15) + 'rem',
    fontWeight: "600",
    color: isDarkMode ? "#e2e8f0" : "#1e293b",
  },
  engagementStatLabel: {
    fontSize: rem(9) + 'rem',
    color: isDarkMode ? "#64748b" : "#94a3b8",
    marginTop: 1,
  },
  accentColor: {
    color: isDarkMode ? "#818cf8" : "#6366f1",
  },
  currentUserHighlight: {
    borderColor: isDarkMode ? "#6366f1" : "#818cf8",
    borderWidth: 1.5,
  },
  badgesContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  // title: {
  //     fontSize: 20,
  //     fontWeight: "bold",
  //     color: "#fff"
  // },
  title: {
    color: "#fff",
    fontSize: rem(18) + 'rem',
    fontWeight: "700",
    letterSpacing: 0.3,
  },

  userSection: {
    flexDirection: "row",
    alignItems: "right",
    gap: 10
  },

  // username: {
  //     color: "white",
  //     fontSize: 16
  // },

  wrongAnswer: {
    backgroundColor: "#F8D7DA",  // Γ¥î Light red for incorrect
    borderColor: "#DC3545",
  },

  container_TD: {
    flex: 1,
    backgroundColor: "#f8f8f8",
    padding: 10,
  },
  scrollContainer_TD: {
    paddingBottom: 20,
  },
  header_TD: {
    fontSize: rem(22) + 'rem',
    fontWeight: "bold",
    marginBottom: 10,
    textAlign: "center",
    color: "#333",
  },
  backButton_TD: {
    backgroundColor: "#007BFF",
    padding: 10,
    borderRadius: 5,
    marginBottom: 10,
    alignItems: "center",
  },
  backButtonText_TD: {
    color: "#fff",
    fontSize: rem(16) + 'rem',
    fontWeight: "bold",
  },

  sectionSubToggle: {
    fontSize: rem(12) + 'rem',
    color: "#888",
    paddingTop: 2,
  },

});

// 2) New cached wrapper with the SAME API as before
const styles = (() => {
  const cache = new Map(); // 0 -> light, 1 -> dark
  return (isDarkMode) => {
    const key = isDarkMode ? 1 : 0;
    if (!cache.has(key)) {
      cache.set(key, _stylesRaw(isDarkMode));  // builds ONCE per mode
    }
    return cache.get(key);
  };
})();

// Inner component that uses OnboardingContext
const AITutorAppWithOnboarding = () => {
  const auth = useAuth();
  const userEmail = auth?.user?.email;
  const authToken = auth?.authToken;
  const userData = auth?.user;
  const refetchProfile = auth?.refetchProfile;
  const contentDb = auth?.contentDb;

  return (
    <OnboardingProvider userEmail={userEmail} authToken={authToken} userData={userData} refetchProfile={refetchProfile} currentContentDb={contentDb}>
      <WalkthroughProvider>
        <AITutorApp />
      </WalkthroughProvider>
    </OnboardingProvider>
  );
};

// Wrap AITutorApp with NotificationProvider and CopilotProvider
const AITutorAppWithNotifications = () => (
  <CopilotProvider
    stepNumberComponent={() => null}
    tooltipComponent={WalkthroughTooltip}
    tooltipStyle={{ backgroundColor: 'transparent', padding: 0 }}
    arrowColor="#6366f1"
    backdropColor="rgba(0, 0, 0, 0.7)"
    animationDuration={300}
  >
    <NotificationProvider>
      <RewardProvider>
        <AITutorAppWithOnboarding />
      </RewardProvider>
    </NotificationProvider>
  </CopilotProvider>
);

export default AITutorAppWithNotifications;










